/*!
 * modernizr.min.js
 */
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms-csstransforms3d-flexbox-placeholder-svg-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
!function(e, t, n) {
    function r(e, t) {
        return typeof e === t
    }
    function s() {
        var e, t, n, s, o, i, a;
        for (var f in w)
            if (w.hasOwnProperty(f)) {
                if (e = [],
                t = w[f],
                t.name && (e.push(t.name.toLowerCase()),
                t.options && t.options.aliases && t.options.aliases.length))
                    for (n = 0; n < t.options.aliases.length; n++)
                        e.push(t.options.aliases[n].toLowerCase());
                for (s = r(t.fn, "function") ? t.fn() : t.fn,
                o = 0; o < e.length; o++)
                    i = e[o],
                    a = i.split("."),
                    1 === a.length ? Modernizr[a[0]] = s : (!Modernizr[a[0]] || Modernizr[a[0]]instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])),
                    Modernizr[a[0]][a[1]] = s),
                    y.push((s ? "" : "no-") + a.join("-"))
            }
    }
    function o(e) {
        var t = S.className
          , n = Modernizr._config.classPrefix || "";
        if (_ && (t = t.baseVal),
        Modernizr._config.enableJSClass) {
            var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(r, "$1" + n + "js$2")
        }
        Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n),
        _ ? S.className.baseVal = t : S.className = t)
    }
    function i() {
        return "function" != typeof t.createElement ? t.createElement(arguments[0]) : _ ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
    }
    function a(e, t) {
        return !!~("" + e).indexOf(t)
    }
    function f(e) {
        return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
            return t + n.toUpperCase()
        }).replace(/^-/, "")
    }
    function l() {
        var e = t.body;
        return e || (e = i(_ ? "svg" : "body"),
        e.fake = !0),
        e
    }
    function u(e, n, r, s) {
        var o, a, f, u, d = "modernizr", p = i("div"), c = l();
        if (parseInt(r, 10))
            for (; r--; )
                f = i("div"),
                f.id = s ? s[r] : d + (r + 1),
                p.appendChild(f);
        return o = i("style"),
        o.type = "text/css",
        o.id = "s" + d,
        (c.fake ? c : p).appendChild(o),
        c.appendChild(p),
        o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)),
        p.id = d,
        c.fake && (c.style.background = "",
        c.style.overflow = "hidden",
        u = S.style.overflow,
        S.style.overflow = "hidden",
        S.appendChild(c)),
        a = n(p, e),
        c.fake ? (c.parentNode.removeChild(c),
        S.style.overflow = u,
        S.offsetHeight) : p.parentNode.removeChild(p),
        !!a
    }
    function d(e, t) {
        return function() {
            return e.apply(t, arguments)
        }
    }
    function p(e, t, n) {
        var s;
        for (var o in e)
            if (e[o]in t)
                return n === !1 ? e[o] : (s = t[e[o]],
                r(s, "function") ? d(s, n || t) : s);
        return !1
    }
    function c(e) {
        return e.replace(/([A-Z])/g, function(e, t) {
            return "-" + t.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }
    function m(t, r) {
        var s = t.length;
        if ("CSS"in e && "supports"in e.CSS) {
            for (; s--; )
                if (e.CSS.supports(c(t[s]), r))
                    return !0;
            return !1
        }
        if ("CSSSupportsRule"in e) {
            for (var o = []; s--; )
                o.push("(" + c(t[s]) + ":" + r + ")");
            return o = o.join(" or "),
            u("@supports (" + o + ") { #modernizr { position: absolute; } }", function(e) {
                return "absolute" == getComputedStyle(e, null).position
            })
        }
        return n
    }
    function h(e, t, s, o) {
        function l() {
            d && (delete k.style,
            delete k.modElem)
        }
        if (o = r(o, "undefined") ? !1 : o,
        !r(s, "undefined")) {
            var u = m(e, s);
            if (!r(u, "undefined"))
                return u
        }
        for (var d, p, c, h, v, g = ["modernizr", "tspan", "samp"]; !k.style && g.length; )
            d = !0,
            k.modElem = i(g.shift()),
            k.style = k.modElem.style;
        for (c = e.length,
        p = 0; c > p; p++)
            if (h = e[p],
            v = k.style[h],
            a(h, "-") && (h = f(h)),
            k.style[h] !== n) {
                if (o || r(s, "undefined"))
                    return l(),
                    "pfx" == t ? h : !0;
                try {
                    k.style[h] = s
                } catch (y) {}
                if (k.style[h] != v)
                    return l(),
                    "pfx" == t ? h : !0
            }
        return l(),
        !1
    }
    function v(e, t, n, s, o) {
        var i = e.charAt(0).toUpperCase() + e.slice(1)
          , a = (e + " " + E.join(i + " ") + i).split(" ");
        return r(t, "string") || r(t, "undefined") ? h(a, t, s, o) : (a = (e + " " + T.join(i + " ") + i).split(" "),
        p(a, t, n))
    }
    function g(e, t, r) {
        return v(e, n, n, t, r)
    }
    var y = []
      , w = []
      , x = {
        _version: "3.3.1",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(e, t) {
            var n = this;
            setTimeout(function() {
                t(n[e])
            }, 0)
        },
        addTest: function(e, t, n) {
            w.push({
                name: e,
                fn: t,
                options: n
            })
        },
        addAsyncTest: function(e) {
            w.push({
                name: null,
                fn: e
            })
        }
    }
      , Modernizr = function() {};
    Modernizr.prototype = x,
    Modernizr = new Modernizr,
    Modernizr.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var C = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    x._prefixes = C;
    var S = t.documentElement
      , _ = "svg" === S.nodeName.toLowerCase()
      , b = "Moz O ms Webkit"
      , T = x._config.usePrefixes ? b.toLowerCase().split(" ") : [];
    x._domPrefixes = T;
    var z = "CSS"in e && "supports"in e.CSS
      , P = "supportsCSS"in e;
    Modernizr.addTest("supports", z || P),
    Modernizr.addTest("placeholder", "placeholder"in i("input") && "placeholder"in i("textarea"));
    var E = x._config.usePrefixes ? b.split(" ") : [];
    x._cssomPrefixes = E;
    var N = x.testStyles = u;
    Modernizr.addTest("touchevents", function() {
        var n;
        if ("ontouchstart"in e || e.DocumentTouch && t instanceof DocumentTouch)
            n = !0;
        else {
            var r = ["@media (", C.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            N(r, function(e) {
                n = 9 === e.offsetTop
            })
        }
        return n
    });
    var j = {
        elem: i("modernizr")
    };
    Modernizr._q.push(function() {
        delete j.elem
    });
    var k = {
        style: j.elem.style
    };
    Modernizr._q.unshift(function() {
        delete k.style
    });
    x.testProp = function(e, t, r) {
        return h([e], n, t, r)
    }
    ;
    x.testAllProps = v,
    x.testAllProps = g,
    Modernizr.addTest("csstransforms", function() {
        return -1 === navigator.userAgent.indexOf("Android 2.") && g("transform", "scale(1)", !0)
    }),
    Modernizr.addTest("csstransforms3d", function() {
        var e = !!g("perspective", "1px", !0)
          , t = Modernizr._config.usePrefixes;
        if (e && (!t || "webkitPerspective"in S.style)) {
            var n, r = "#modernizr{width:0;height:0}";
            Modernizr.supports ? n = "@supports (perspective: 1px)" : (n = "@media (transform-3d)",
            t && (n += ",(-webkit-transform-3d)")),
            n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",
            N(r + n, function(t) {
                e = 7 === t.offsetWidth && 18 === t.offsetHeight
            })
        }
        return e
    }),
    Modernizr.addTest("flexbox", g("flexBasis", "1px", !0)),
    s(),
    o(y),
    delete x.addTest,
    delete x.addAsyncTest;
    for (var A = 0; A < Modernizr._q.length; A++)
        Modernizr._q[A]();
    e.Modernizr = Modernizr
}(window, document);

/*!
 * jquery-3.3.1.min.js
 */
/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document)
            throw new Error("jQuery requires a window with a document");
        return t(e)
    }
    : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    "use strict";
    var n = []
      , r = e.document
      , i = Object.getPrototypeOf
      , o = n.slice
      , a = n.concat
      , s = n.push
      , u = n.indexOf
      , l = {}
      , c = l.toString
      , f = l.hasOwnProperty
      , p = f.toString
      , d = p.call(Object)
      , h = {}
      , g = function e(t) {
        return "function" == typeof t && "number" != typeof t.nodeType
    }
      , y = function e(t) {
        return null != t && t === t.window
    }
      , v = {
        type: !0,
        src: !0,
        noModule: !0
    };
    function m(e, t, n) {
        var i, o = (t = t || r).createElement("script");
        if (o.text = e,
        n)
            for (i in v)
                n[i] && (o[i] = n[i]);
        t.head.appendChild(o).parentNode.removeChild(o)
    }
    function x(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? l[c.call(e)] || "object" : typeof e
    }
    var b = "3.3.1"
      , w = function(e, t) {
        return new w.fn.init(e,t)
    }
      , T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    w.fn = w.prototype = {
        jquery: "3.3.1",
        constructor: w,
        length: 0,
        toArray: function() {
            return o.call(this)
        },
        get: function(e) {
            return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = w.merge(this.constructor(), e);
            return t.prevObject = this,
            t
        },
        each: function(e) {
            return w.each(this, e)
        },
        map: function(e) {
            return this.pushStack(w.map(this, function(t, n) {
                return e.call(t, n, t)
            }))
        },
        slice: function() {
            return this.pushStack(o.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length
              , n = +e + (e < 0 ? t : 0);
            return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: s,
        sort: n.sort,
        splice: n.splice
    },
    w.extend = w.fn.extend = function() {
        var e, t, n, r, i, o, a = arguments[0] || {}, s = 1, u = arguments.length, l = !1;
        for ("boolean" == typeof a && (l = a,
        a = arguments[s] || {},
        s++),
        "object" == typeof a || g(a) || (a = {}),
        s === u && (a = this,
        s--); s < u; s++)
            if (null != (e = arguments[s]))
                for (t in e)
                    n = a[t],
                    a !== (r = e[t]) && (l && r && (w.isPlainObject(r) || (i = Array.isArray(r))) ? (i ? (i = !1,
                    o = n && Array.isArray(n) ? n : []) : o = n && w.isPlainObject(n) ? n : {},
                    a[t] = w.extend(l, o, r)) : void 0 !== r && (a[t] = r));
        return a
    }
    ,
    w.extend({
        expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, n;
            return !(!e || "[object Object]" !== c.call(e)) && (!(t = i(e)) || "function" == typeof (n = f.call(t, "constructor") && t.constructor) && p.call(n) === d)
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e)
                return !1;
            return !0
        },
        globalEval: function(e) {
            m(e)
        },
        each: function(e, t) {
            var n, r = 0;
            if (C(e)) {
                for (n = e.length; r < n; r++)
                    if (!1 === t.call(e[r], r, e[r]))
                        break
            } else
                for (r in e)
                    if (!1 === t.call(e[r], r, e[r]))
                        break;
            return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(T, "")
        },
        makeArray: function(e, t) {
            var n = t || [];
            return null != e && (C(Object(e)) ? w.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)),
            n
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : u.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, r = 0, i = e.length; r < n; r++)
                e[i++] = t[r];
            return e.length = i,
            e
        },
        grep: function(e, t, n) {
            for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++)
                (r = !t(e[o], o)) !== s && i.push(e[o]);
            return i
        },
        map: function(e, t, n) {
            var r, i, o = 0, s = [];
            if (C(e))
                for (r = e.length; o < r; o++)
                    null != (i = t(e[o], o, n)) && s.push(i);
            else
                for (o in e)
                    null != (i = t(e[o], o, n)) && s.push(i);
            return a.apply([], s)
        },
        guid: 1,
        support: h
    }),
    "function" == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]),
    w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        l["[object " + t + "]"] = t.toLowerCase()
    });
    function C(e) {
        var t = !!e && "length"in e && e.length
          , n = x(e);
        return !g(e) && !y(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
    }
    var E = function(e) {
        var t, n, r, i, o, a, s, u, l, c, f, p, d, h, g, y, v, m, x, b = "sizzle" + 1 * new Date, w = e.document, T = 0, C = 0, E = ae(), k = ae(), S = ae(), D = function(e, t) {
            return e === t && (f = !0),
            0
        }, N = {}.hasOwnProperty, A = [], j = A.pop, q = A.push, L = A.push, H = A.slice, O = function(e, t) {
            for (var n = 0, r = e.length; n < r; n++)
                if (e[n] === t)
                    return n;
            return -1
        }, P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", M = "[\\x20\\t\\r\\n\\f]", R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", I = "\\[" + M + "*(" + R + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + M + "*\\]", W = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + I + ")*)|.*)\\)|)", $ = new RegExp(M + "+","g"), B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$","g"), F = new RegExp("^" + M + "*," + M + "*"), _ = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"), z = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]","g"), X = new RegExp(W), U = new RegExp("^" + R + "$"), V = {
            ID: new RegExp("^#(" + R + ")"),
            CLASS: new RegExp("^\\.(" + R + ")"),
            TAG: new RegExp("^(" + R + "|[*])"),
            ATTR: new RegExp("^" + I),
            PSEUDO: new RegExp("^" + W),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)","i"),
            bool: new RegExp("^(?:" + P + ")$","i"),
            needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)","i")
        }, G = /^(?:input|select|textarea|button)$/i, Y = /^h\d$/i, Q = /^[^{]+\{\s*\[native \w/, J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, K = /[+~]/, Z = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)","ig"), ee = function(e, t, n) {
            var r = "0x" + t - 65536;
            return r !== r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320)
        }, te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, ne = function(e, t) {
            return t ? "\0" === e ? "\ufffd" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
        }, re = function() {
            p()
        }, ie = me(function(e) {
            return !0 === e.disabled && ("form"in e || "label"in e)
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            L.apply(A = H.call(w.childNodes), w.childNodes),
            A[w.childNodes.length].nodeType
        } catch (e) {
            L = {
                apply: A.length ? function(e, t) {
                    q.apply(e, H.call(t))
                }
                : function(e, t) {
                    var n = e.length
                      , r = 0;
                    while (e[n++] = t[r++])
                        ;
                    e.length = n - 1
                }
            }
        }
        function oe(e, t, r, i) {
            var o, s, l, c, f, h, v, m = t && t.ownerDocument, T = t ? t.nodeType : 9;
            if (r = r || [],
            "string" != typeof e || !e || 1 !== T && 9 !== T && 11 !== T)
                return r;
            if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t),
            t = t || d,
            g)) {
                if (11 !== T && (f = J.exec(e)))
                    if (o = f[1]) {
                        if (9 === T) {
                            if (!(l = t.getElementById(o)))
                                return r;
                            if (l.id === o)
                                return r.push(l),
                                r
                        } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o)
                            return r.push(l),
                            r
                    } else {
                        if (f[2])
                            return L.apply(r, t.getElementsByTagName(e)),
                            r;
                        if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName)
                            return L.apply(r, t.getElementsByClassName(o)),
                            r
                    }
                if (n.qsa && !S[e + " "] && (!y || !y.test(e))) {
                    if (1 !== T)
                        m = t,
                        v = e;
                    else if ("object" !== t.nodeName.toLowerCase()) {
                        (c = t.getAttribute("id")) ? c = c.replace(te, ne) : t.setAttribute("id", c = b),
                        s = (h = a(e)).length;
                        while (s--)
                            h[s] = "#" + c + " " + ve(h[s]);
                        v = h.join(","),
                        m = K.test(e) && ge(t.parentNode) || t
                    }
                    if (v)
                        try {
                            return L.apply(r, m.querySelectorAll(v)),
                            r
                        } catch (e) {} finally {
                            c === b && t.removeAttribute("id")
                        }
                }
            }
            return u(e.replace(B, "$1"), t, r, i)
        }
        function ae() {
            var e = [];
            function t(n, i) {
                return e.push(n + " ") > r.cacheLength && delete t[e.shift()],
                t[n + " "] = i
            }
            return t
        }
        function se(e) {
            return e[b] = !0,
            e
        }
        function ue(e) {
            var t = d.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t),
                t = null
            }
        }
        function le(e, t) {
            var n = e.split("|")
              , i = n.length;
            while (i--)
                r.attrHandle[n[i]] = t
        }
        function ce(e, t) {
            var n = t && e
              , r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (r)
                return r;
            if (n)
                while (n = n.nextSibling)
                    if (n === t)
                        return -1;
            return e ? 1 : -1
        }
        function fe(e) {
            return function(t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }
        function pe(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }
        function de(e) {
            return function(t) {
                return "form"in t ? t.parentNode && !1 === t.disabled ? "label"in t ? "label"in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ie(t) === e : t.disabled === e : "label"in t && t.disabled === e
            }
        }
        function he(e) {
            return se(function(t) {
                return t = +t,
                se(function(n, r) {
                    var i, o = e([], n.length, t), a = o.length;
                    while (a--)
                        n[i = o[a]] && (n[i] = !(r[i] = n[i]))
                })
            })
        }
        function ge(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e
        }
        n = oe.support = {},
        o = oe.isXML = function(e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName
        }
        ,
        p = oe.setDocument = function(e) {
            var t, i, a = e ? e.ownerDocument || e : w;
            return a !== d && 9 === a.nodeType && a.documentElement ? (d = a,
            h = d.documentElement,
            g = !o(d),
            w !== d && (i = d.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", re, !1) : i.attachEvent && i.attachEvent("onunload", re)),
            n.attributes = ue(function(e) {
                return e.className = "i",
                !e.getAttribute("className")
            }),
            n.getElementsByTagName = ue(function(e) {
                return e.appendChild(d.createComment("")),
                !e.getElementsByTagName("*").length
            }),
            n.getElementsByClassName = Q.test(d.getElementsByClassName),
            n.getById = ue(function(e) {
                return h.appendChild(e).id = b,
                !d.getElementsByName || !d.getElementsByName(b).length
            }),
            n.getById ? (r.filter.ID = function(e) {
                var t = e.replace(Z, ee);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }
            ,
            r.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && g) {
                    var n = t.getElementById(e);
                    return n ? [n] : []
                }
            }
            ) : (r.filter.ID = function(e) {
                var t = e.replace(Z, ee);
                return function(e) {
                    var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t
                }
            }
            ,
            r.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && g) {
                    var n, r, i, o = t.getElementById(e);
                    if (o) {
                        if ((n = o.getAttributeNode("id")) && n.value === e)
                            return [o];
                        i = t.getElementsByName(e),
                        r = 0;
                        while (o = i[r++])
                            if ((n = o.getAttributeNode("id")) && n.value === e)
                                return [o]
                    }
                    return []
                }
            }
            ),
            r.find.TAG = n.getElementsByTagName ? function(e, t) {
                return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0
            }
            : function(e, t) {
                var n, r = [], i = 0, o = t.getElementsByTagName(e);
                if ("*" === e) {
                    while (n = o[i++])
                        1 === n.nodeType && r.push(n);
                    return r
                }
                return o
            }
            ,
            r.find.CLASS = n.getElementsByClassName && function(e, t) {
                if ("undefined" != typeof t.getElementsByClassName && g)
                    return t.getElementsByClassName(e)
            }
            ,
            v = [],
            y = [],
            (n.qsa = Q.test(d.querySelectorAll)) && (ue(function(e) {
                h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + M + "*(?:''|\"\")"),
                e.querySelectorAll("[selected]").length || y.push("\\[" + M + "*(?:value|" + P + ")"),
                e.querySelectorAll("[id~=" + b + "-]").length || y.push("~="),
                e.querySelectorAll(":checked").length || y.push(":checked"),
                e.querySelectorAll("a#" + b + "+*").length || y.push(".#.+[+~]")
            }),
            ue(function(e) {
                e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = d.createElement("input");
                t.setAttribute("type", "hidden"),
                e.appendChild(t).setAttribute("name", "D"),
                e.querySelectorAll("[name=d]").length && y.push("name" + M + "*[*^$|!~]?="),
                2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"),
                h.appendChild(e).disabled = !0,
                2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"),
                e.querySelectorAll("*,:x"),
                y.push(",.*:")
            })),
            (n.matchesSelector = Q.test(m = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && ue(function(e) {
                n.disconnectedMatch = m.call(e, "*"),
                m.call(e, "[s!='']:x"),
                v.push("!=", W)
            }),
            y = y.length && new RegExp(y.join("|")),
            v = v.length && new RegExp(v.join("|")),
            t = Q.test(h.compareDocumentPosition),
            x = t || Q.test(h.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e
                  , r = t && t.parentNode;
                return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)))
            }
            : function(e, t) {
                if (t)
                    while (t = t.parentNode)
                        if (t === e)
                            return !0;
                return !1
            }
            ,
            D = t ? function(e, t) {
                if (e === t)
                    return f = !0,
                    0;
                var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === d || e.ownerDocument === w && x(w, e) ? -1 : t === d || t.ownerDocument === w && x(w, t) ? 1 : c ? O(c, e) - O(c, t) : 0 : 4 & r ? -1 : 1)
            }
            : function(e, t) {
                if (e === t)
                    return f = !0,
                    0;
                var n, r = 0, i = e.parentNode, o = t.parentNode, a = [e], s = [t];
                if (!i || !o)
                    return e === d ? -1 : t === d ? 1 : i ? -1 : o ? 1 : c ? O(c, e) - O(c, t) : 0;
                if (i === o)
                    return ce(e, t);
                n = e;
                while (n = n.parentNode)
                    a.unshift(n);
                n = t;
                while (n = n.parentNode)
                    s.unshift(n);
                while (a[r] === s[r])
                    r++;
                return r ? ce(a[r], s[r]) : a[r] === w ? -1 : s[r] === w ? 1 : 0
            }
            ,
            d) : d
        }
        ,
        oe.matches = function(e, t) {
            return oe(e, null, null, t)
        }
        ,
        oe.matchesSelector = function(e, t) {
            if ((e.ownerDocument || e) !== d && p(e),
            t = t.replace(z, "='$1']"),
            n.matchesSelector && g && !S[t + " "] && (!v || !v.test(t)) && (!y || !y.test(t)))
                try {
                    var r = m.call(e, t);
                    if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                        return r
                } catch (e) {}
            return oe(t, d, null, [e]).length > 0
        }
        ,
        oe.contains = function(e, t) {
            return (e.ownerDocument || e) !== d && p(e),
            x(e, t)
        }
        ,
        oe.attr = function(e, t) {
            (e.ownerDocument || e) !== d && p(e);
            var i = r.attrHandle[t.toLowerCase()]
              , o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
            return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null
        }
        ,
        oe.escape = function(e) {
            return (e + "").replace(te, ne)
        }
        ,
        oe.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }
        ,
        oe.uniqueSort = function(e) {
            var t, r = [], i = 0, o = 0;
            if (f = !n.detectDuplicates,
            c = !n.sortStable && e.slice(0),
            e.sort(D),
            f) {
                while (t = e[o++])
                    t === e[o] && (i = r.push(o));
                while (i--)
                    e.splice(r[i], 1)
            }
            return c = null,
            e
        }
        ,
        i = oe.getText = function(e) {
            var t, n = "", r = 0, o = e.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof e.textContent)
                        return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling)
                        n += i(e)
                } else if (3 === o || 4 === o)
                    return e.nodeValue
            } else
                while (t = e[r++])
                    n += i(t);
            return n
        }
        ,
        (r = oe.selectors = {
            cacheLength: 50,
            createPseudo: se,
            match: V,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(Z, ee),
                    e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(),
                    "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]),
                    e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                    e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]),
                    e
                },
                PSEUDO: function(e) {
                    var t, n = !e[6] && e[2];
                    return V.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t),
                    e[2] = n.slice(0, t)),
                    e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(Z, ee).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    }
                    : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = E[e + " "];
                    return t || (t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) && E(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(e, t, n) {
                    return function(r) {
                        var i = oe.attr(r, e);
                        return null == i ? "!=" === t : !t || (i += "",
                        "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace($, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"))
                    }
                },
                CHILD: function(e, t, n, r, i) {
                    var o = "nth" !== e.slice(0, 3)
                      , a = "last" !== e.slice(-4)
                      , s = "of-type" === t;
                    return 1 === r && 0 === i ? function(e) {
                        return !!e.parentNode
                    }
                    : function(t, n, u) {
                        var l, c, f, p, d, h, g = o !== a ? "nextSibling" : "previousSibling", y = t.parentNode, v = s && t.nodeName.toLowerCase(), m = !u && !s, x = !1;
                        if (y) {
                            if (o) {
                                while (g) {
                                    p = t;
                                    while (p = p[g])
                                        if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType)
                                            return !1;
                                    h = g = "only" === e && !h && "nextSibling"
                                }
                                return !0
                            }
                            if (h = [a ? y.firstChild : y.lastChild],
                            a && m) {
                                x = (d = (l = (c = (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2],
                                p = d && y.childNodes[d];
                                while (p = ++d && p && p[g] || (x = d = 0) || h.pop())
                                    if (1 === p.nodeType && ++x && p === t) {
                                        c[e] = [T, d, x];
                                        break
                                    }
                            } else if (m && (x = d = (l = (c = (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]),
                            !1 === x)
                                while (p = ++d && p && p[g] || (x = d = 0) || h.pop())
                                    if ((s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) && ++x && (m && ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] = [T, x]),
                                    p === t))
                                        break;
                            return (x -= i) === r || x % r == 0 && x / r >= 0
                        }
                    }
                },
                PSEUDO: function(e, t) {
                    var n, i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);
                    return i[b] ? i(t) : i.length > 1 ? (n = [e, e, "", t],
                    r.setFilters.hasOwnProperty(e.toLowerCase()) ? se(function(e, n) {
                        var r, o = i(e, t), a = o.length;
                        while (a--)
                            e[r = O(e, o[a])] = !(n[r] = o[a])
                    }) : function(e) {
                        return i(e, 0, n)
                    }
                    ) : i
                }
            },
            pseudos: {
                not: se(function(e) {
                    var t = []
                      , n = []
                      , r = s(e.replace(B, "$1"));
                    return r[b] ? se(function(e, t, n, i) {
                        var o, a = r(e, null, i, []), s = e.length;
                        while (s--)
                            (o = a[s]) && (e[s] = !(t[s] = o))
                    }) : function(e, i, o) {
                        return t[0] = e,
                        r(t, null, o, n),
                        t[0] = null,
                        !n.pop()
                    }
                }),
                has: se(function(e) {
                    return function(t) {
                        return oe(e, t).length > 0
                    }
                }),
                contains: se(function(e) {
                    return e = e.replace(Z, ee),
                    function(t) {
                        return (t.textContent || t.innerText || i(t)).indexOf(e) > -1
                    }
                }),
                lang: se(function(e) {
                    return U.test(e || "") || oe.error("unsupported lang: " + e),
                    e = e.replace(Z, ee).toLowerCase(),
                    function(t) {
                        var n;
                        do {
                            if (n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                                return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1
                    }
                }),
                target: function(t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id
                },
                root: function(e) {
                    return e === h
                },
                focus: function(e) {
                    return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                },
                enabled: de(!1),
                disabled: de(!0),
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex,
                    !0 === e.selected
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(e) {
                    return !r.pseudos.empty(e)
                },
                header: function(e) {
                    return Y.test(e.nodeName)
                },
                input: function(e) {
                    return G.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                },
                first: he(function() {
                    return [0]
                }),
                last: he(function(e, t) {
                    return [t - 1]
                }),
                eq: he(function(e, t, n) {
                    return [n < 0 ? n + t : n]
                }),
                even: he(function(e, t) {
                    for (var n = 0; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                odd: he(function(e, t) {
                    for (var n = 1; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                lt: he(function(e, t, n) {
                    for (var r = n < 0 ? n + t : n; --r >= 0; )
                        e.push(r);
                    return e
                }),
                gt: he(function(e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t; )
                        e.push(r);
                    return e
                })
            }
        }).pseudos.nth = r.pseudos.eq;
        for (t in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            r.pseudos[t] = fe(t);
        for (t in {
            submit: !0,
            reset: !0
        })
            r.pseudos[t] = pe(t);
        function ye() {}
        ye.prototype = r.filters = r.pseudos,
        r.setFilters = new ye,
        a = oe.tokenize = function(e, t) {
            var n, i, o, a, s, u, l, c = k[e + " "];
            if (c)
                return t ? 0 : c.slice(0);
            s = e,
            u = [],
            l = r.preFilter;
            while (s) {
                n && !(i = F.exec(s)) || (i && (s = s.slice(i[0].length) || s),
                u.push(o = [])),
                n = !1,
                (i = _.exec(s)) && (n = i.shift(),
                o.push({
                    value: n,
                    type: i[0].replace(B, " ")
                }),
                s = s.slice(n.length));
                for (a in r.filter)
                    !(i = V[a].exec(s)) || l[a] && !(i = l[a](i)) || (n = i.shift(),
                    o.push({
                        value: n,
                        type: a,
                        matches: i
                    }),
                    s = s.slice(n.length));
                if (!n)
                    break
            }
            return t ? s.length : s ? oe.error(e) : k(e, u).slice(0)
        }
        ;
        function ve(e) {
            for (var t = 0, n = e.length, r = ""; t < n; t++)
                r += e[t].value;
            return r
        }
        function me(e, t, n) {
            var r = t.dir
              , i = t.next
              , o = i || r
              , a = n && "parentNode" === o
              , s = C++;
            return t.first ? function(t, n, i) {
                while (t = t[r])
                    if (1 === t.nodeType || a)
                        return e(t, n, i);
                return !1
            }
            : function(t, n, u) {
                var l, c, f, p = [T, s];
                if (u) {
                    while (t = t[r])
                        if ((1 === t.nodeType || a) && e(t, n, u))
                            return !0
                } else
                    while (t = t[r])
                        if (1 === t.nodeType || a)
                            if (f = t[b] || (t[b] = {}),
                            c = f[t.uniqueID] || (f[t.uniqueID] = {}),
                            i && i === t.nodeName.toLowerCase())
                                t = t[r] || t;
                            else {
                                if ((l = c[o]) && l[0] === T && l[1] === s)
                                    return p[2] = l[2];
                                if (c[o] = p,
                                p[2] = e(t, n, u))
                                    return !0
                            }
                return !1
            }
        }
        function xe(e) {
            return e.length > 1 ? function(t, n, r) {
                var i = e.length;
                while (i--)
                    if (!e[i](t, n, r))
                        return !1;
                return !0
            }
            : e[0]
        }
        function be(e, t, n) {
            for (var r = 0, i = t.length; r < i; r++)
                oe(e, t[r], n);
            return n
        }
        function we(e, t, n, r, i) {
            for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
                (o = e[s]) && (n && !n(o, r, i) || (a.push(o),
                l && t.push(s)));
            return a
        }
        function Te(e, t, n, r, i, o) {
            return r && !r[b] && (r = Te(r)),
            i && !i[b] && (i = Te(i, o)),
            se(function(o, a, s, u) {
                var l, c, f, p = [], d = [], h = a.length, g = o || be(t || "*", s.nodeType ? [s] : s, []), y = !e || !o && t ? g : we(g, p, e, s, u), v = n ? i || (o ? e : h || r) ? [] : a : y;
                if (n && n(y, v, s, u),
                r) {
                    l = we(v, d),
                    r(l, [], s, u),
                    c = l.length;
                    while (c--)
                        (f = l[c]) && (v[d[c]] = !(y[d[c]] = f))
                }
                if (o) {
                    if (i || e) {
                        if (i) {
                            l = [],
                            c = v.length;
                            while (c--)
                                (f = v[c]) && l.push(y[c] = f);
                            i(null, v = [], l, u)
                        }
                        c = v.length;
                        while (c--)
                            (f = v[c]) && (l = i ? O(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f))
                    }
                } else
                    v = we(v === a ? v.splice(h, v.length) : v),
                    i ? i(null, a, v, u) : L.apply(a, v)
            })
        }
        function Ce(e) {
            for (var t, n, i, o = e.length, a = r.relative[e[0].type], s = a || r.relative[" "], u = a ? 1 : 0, c = me(function(e) {
                return e === t
            }, s, !0), f = me(function(e) {
                return O(t, e) > -1
            }, s, !0), p = [function(e, n, r) {
                var i = !a && (r || n !== l) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
                return t = null,
                i
            }
            ]; u < o; u++)
                if (n = r.relative[e[u].type])
                    p = [me(xe(p), n)];
                else {
                    if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
                        for (i = ++u; i < o; i++)
                            if (r.relative[e[i].type])
                                break;
                        return Te(u > 1 && xe(p), u > 1 && ve(e.slice(0, u - 1).concat({
                            value: " " === e[u - 2].type ? "*" : ""
                        })).replace(B, "$1"), n, u < i && Ce(e.slice(u, i)), i < o && Ce(e = e.slice(i)), i < o && ve(e))
                    }
                    p.push(n)
                }
            return xe(p)
        }
        function Ee(e, t) {
            var n = t.length > 0
              , i = e.length > 0
              , o = function(o, a, s, u, c) {
                var f, h, y, v = 0, m = "0", x = o && [], b = [], w = l, C = o || i && r.find.TAG("*", c), E = T += null == w ? 1 : Math.random() || .1, k = C.length;
                for (c && (l = a === d || a || c); m !== k && null != (f = C[m]); m++) {
                    if (i && f) {
                        h = 0,
                        a || f.ownerDocument === d || (p(f),
                        s = !g);
                        while (y = e[h++])
                            if (y(f, a || d, s)) {
                                u.push(f);
                                break
                            }
                        c && (T = E)
                    }
                    n && ((f = !y && f) && v--,
                    o && x.push(f))
                }
                if (v += m,
                n && m !== v) {
                    h = 0;
                    while (y = t[h++])
                        y(x, b, a, s);
                    if (o) {
                        if (v > 0)
                            while (m--)
                                x[m] || b[m] || (b[m] = j.call(u));
                        b = we(b)
                    }
                    L.apply(u, b),
                    c && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u)
                }
                return c && (T = E,
                l = w),
                x
            };
            return n ? se(o) : o
        }
        return s = oe.compile = function(e, t) {
            var n, r = [], i = [], o = S[e + " "];
            if (!o) {
                t || (t = a(e)),
                n = t.length;
                while (n--)
                    (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
                (o = S(e, Ee(i, r))).selector = e
            }
            return o
        }
        ,
        u = oe.select = function(e, t, n, i) {
            var o, u, l, c, f, p = "function" == typeof e && e, d = !i && a(e = p.selector || e);
            if (n = n || [],
            1 === d.length) {
                if ((u = d[0] = d[0].slice(0)).length > 2 && "ID" === (l = u[0]).type && 9 === t.nodeType && g && r.relative[u[1].type]) {
                    if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0]))
                        return n;
                    p && (t = t.parentNode),
                    e = e.slice(u.shift().value.length)
                }
                o = V.needsContext.test(e) ? 0 : u.length;
                while (o--) {
                    if (l = u[o],
                    r.relative[c = l.type])
                        break;
                    if ((f = r.find[c]) && (i = f(l.matches[0].replace(Z, ee), K.test(u[0].type) && ge(t.parentNode) || t))) {
                        if (u.splice(o, 1),
                        !(e = i.length && ve(u)))
                            return L.apply(n, i),
                            n;
                        break
                    }
                }
            }
            return (p || s(e, d))(i, t, !g, n, !t || K.test(e) && ge(t.parentNode) || t),
            n
        }
        ,
        n.sortStable = b.split("").sort(D).join("") === b,
        n.detectDuplicates = !!f,
        p(),
        n.sortDetached = ue(function(e) {
            return 1 & e.compareDocumentPosition(d.createElement("fieldset"))
        }),
        ue(function(e) {
            return e.innerHTML = "<a href='#'></a>",
            "#" === e.firstChild.getAttribute("href")
        }) || le("type|href|height|width", function(e, t, n) {
            if (!n)
                return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }),
        n.attributes && ue(function(e) {
            return e.innerHTML = "<input/>",
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
        }) || le("value", function(e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase())
                return e.defaultValue
        }),
        ue(function(e) {
            return null == e.getAttribute("disabled")
        }) || le(P, function(e, t, n) {
            var r;
            if (!n)
                return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
        }),
        oe
    }(e);
    w.find = E,
    w.expr = E.selectors,
    w.expr[":"] = w.expr.pseudos,
    w.uniqueSort = w.unique = E.uniqueSort,
    w.text = E.getText,
    w.isXMLDoc = E.isXML,
    w.contains = E.contains,
    w.escapeSelector = E.escape;
    var k = function(e, t, n) {
        var r = []
          , i = void 0 !== n;
        while ((e = e[t]) && 9 !== e.nodeType)
            if (1 === e.nodeType) {
                if (i && w(e).is(n))
                    break;
                r.push(e)
            }
        return r
    }
      , S = function(e, t) {
        for (var n = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && n.push(e);
        return n
    }
      , D = w.expr.match.needsContext;
    function N(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function j(e, t, n) {
        return g(t) ? w.grep(e, function(e, r) {
            return !!t.call(e, r, e) !== n
        }) : t.nodeType ? w.grep(e, function(e) {
            return e === t !== n
        }) : "string" != typeof t ? w.grep(e, function(e) {
            return u.call(t, e) > -1 !== n
        }) : w.filter(t, e, n)
    }
    w.filter = function(e, t, n) {
        var r = t[0];
        return n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === r.nodeType ? w.find.matchesSelector(r, e) ? [r] : [] : w.find.matches(e, w.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }
    ,
    w.fn.extend({
        find: function(e) {
            var t, n, r = this.length, i = this;
            if ("string" != typeof e)
                return this.pushStack(w(e).filter(function() {
                    for (t = 0; t < r; t++)
                        if (w.contains(i[t], this))
                            return !0
                }));
            for (n = this.pushStack([]),
            t = 0; t < r; t++)
                w.find(e, i[t], n);
            return r > 1 ? w.uniqueSort(n) : n
        },
        filter: function(e) {
            return this.pushStack(j(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(j(this, e || [], !0))
        },
        is: function(e) {
            return !!j(this, "string" == typeof e && D.test(e) ? w(e) : e || [], !1).length
        }
    });
    var q, L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (w.fn.init = function(e, t, n) {
        var i, o;
        if (!e)
            return this;
        if (n = n || q,
        "string" == typeof e) {
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : L.exec(e)) || !i[1] && t)
                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (t = t instanceof w ? t[0] : t,
                w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)),
                A.test(i[1]) && w.isPlainObject(t))
                    for (i in t)
                        g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this
            }
            return (o = r.getElementById(i[2])) && (this[0] = o,
            this.length = 1),
            this
        }
        return e.nodeType ? (this[0] = e,
        this.length = 1,
        this) : g(e) ? void 0 !== n.ready ? n.ready(e) : e(w) : w.makeArray(e, this)
    }
    ).prototype = w.fn,
    q = w(r);
    var H = /^(?:parents|prev(?:Until|All))/
      , O = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    w.fn.extend({
        has: function(e) {
            var t = w(e, this)
              , n = t.length;
            return this.filter(function() {
                for (var e = 0; e < n; e++)
                    if (w.contains(this, t[e]))
                        return !0
            })
        },
        closest: function(e, t) {
            var n, r = 0, i = this.length, o = [], a = "string" != typeof e && w(e);
            if (!D.test(e))
                for (; r < i; r++)
                    for (n = this[r]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))) {
                            o.push(n);
                            break
                        }
            return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? u.call(w(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    });
    function P(e, t) {
        while ((e = e[t]) && 1 !== e.nodeType)
            ;
        return e
    }
    w.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return k(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return k(e, "parentNode", n)
        },
        next: function(e) {
            return P(e, "nextSibling")
        },
        prev: function(e) {
            return P(e, "previousSibling")
        },
        nextAll: function(e) {
            return k(e, "nextSibling")
        },
        prevAll: function(e) {
            return k(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return k(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return k(e, "previousSibling", n)
        },
        siblings: function(e) {
            return S((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return S(e.firstChild)
        },
        contents: function(e) {
            return N(e, "iframe") ? e.contentDocument : (N(e, "template") && (e = e.content || e),
            w.merge([], e.childNodes))
        }
    }, function(e, t) {
        w.fn[e] = function(n, r) {
            var i = w.map(this, t, n);
            return "Until" !== e.slice(-5) && (r = n),
            r && "string" == typeof r && (i = w.filter(r, i)),
            this.length > 1 && (O[e] || w.uniqueSort(i),
            H.test(e) && i.reverse()),
            this.pushStack(i)
        }
    });
    var M = /[^\x20\t\r\n\f]+/g;
    function R(e) {
        var t = {};
        return w.each(e.match(M) || [], function(e, n) {
            t[n] = !0
        }),
        t
    }
    w.Callbacks = function(e) {
        e = "string" == typeof e ? R(e) : w.extend({}, e);
        var t, n, r, i, o = [], a = [], s = -1, u = function() {
            for (i = i || e.once,
            r = t = !0; a.length; s = -1) {
                n = a.shift();
                while (++s < o.length)
                    !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length,
                    n = !1)
            }
            e.memory || (n = !1),
            t = !1,
            i && (o = n ? [] : "")
        }, l = {
            add: function() {
                return o && (n && !t && (s = o.length - 1,
                a.push(n)),
                function t(n) {
                    w.each(n, function(n, r) {
                        g(r) ? e.unique && l.has(r) || o.push(r) : r && r.length && "string" !== x(r) && t(r)
                    })
                }(arguments),
                n && !t && u()),
                this
            },
            remove: function() {
                return w.each(arguments, function(e, t) {
                    var n;
                    while ((n = w.inArray(t, o, n)) > -1)
                        o.splice(n, 1),
                        n <= s && s--
                }),
                this
            },
            has: function(e) {
                return e ? w.inArray(e, o) > -1 : o.length > 0
            },
            empty: function() {
                return o && (o = []),
                this
            },
            disable: function() {
                return i = a = [],
                o = n = "",
                this
            },
            disabled: function() {
                return !o
            },
            lock: function() {
                return i = a = [],
                n || t || (o = n = ""),
                this
            },
            locked: function() {
                return !!i
            },
            fireWith: function(e, n) {
                return i || (n = [e, (n = n || []).slice ? n.slice() : n],
                a.push(n),
                t || u()),
                this
            },
            fire: function() {
                return l.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!r
            }
        };
        return l
    }
    ;
    function I(e) {
        return e
    }
    function W(e) {
        throw e
    }
    function $(e, t, n, r) {
        var i;
        try {
            e && g(i = e.promise) ? i.call(e).done(t).fail(n) : e && g(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r))
        } catch (e) {
            n.apply(void 0, [e])
        }
    }
    w.extend({
        Deferred: function(t) {
            var n = [["notify", "progress", w.Callbacks("memory"), w.Callbacks("memory"), 2], ["resolve", "done", w.Callbacks("once memory"), w.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", w.Callbacks("once memory"), w.Callbacks("once memory"), 1, "rejected"]]
              , r = "pending"
              , i = {
                state: function() {
                    return r
                },
                always: function() {
                    return o.done(arguments).fail(arguments),
                    this
                },
                "catch": function(e) {
                    return i.then(null, e)
                },
                pipe: function() {
                    var e = arguments;
                    return w.Deferred(function(t) {
                        w.each(n, function(n, r) {
                            var i = g(e[r[4]]) && e[r[4]];
                            o[r[1]](function() {
                                var e = i && i.apply(this, arguments);
                                e && g(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[r[0] + "With"](this, i ? [e] : arguments)
                            })
                        }),
                        e = null
                    }).promise()
                },
                then: function(t, r, i) {
                    var o = 0;
                    function a(t, n, r, i) {
                        return function() {
                            var s = this
                              , u = arguments
                              , l = function() {
                                var e, l;
                                if (!(t < o)) {
                                    if ((e = r.apply(s, u)) === n.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    l = e && ("object" == typeof e || "function" == typeof e) && e.then,
                                    g(l) ? i ? l.call(e, a(o, n, I, i), a(o, n, W, i)) : (o++,
                                    l.call(e, a(o, n, I, i), a(o, n, W, i), a(o, n, I, n.notifyWith))) : (r !== I && (s = void 0,
                                    u = [e]),
                                    (i || n.resolveWith)(s, u))
                                }
                            }
                              , c = i ? l : function() {
                                try {
                                    l()
                                } catch (e) {
                                    w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace),
                                    t + 1 >= o && (r !== W && (s = void 0,
                                    u = [e]),
                                    n.rejectWith(s, u))
                                }
                            }
                            ;
                            t ? c() : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()),
                            e.setTimeout(c))
                        }
                    }
                    return w.Deferred(function(e) {
                        n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)),
                        n[1][3].add(a(0, e, g(t) ? t : I)),
                        n[2][3].add(a(0, e, g(r) ? r : W))
                    }).promise()
                },
                promise: function(e) {
                    return null != e ? w.extend(e, i) : i
                }
            }
              , o = {};
            return w.each(n, function(e, t) {
                var a = t[2]
                  , s = t[5];
                i[t[1]] = a.add,
                s && a.add(function() {
                    r = s
                }, n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock),
                a.add(t[3].fire),
                o[t[0]] = function() {
                    return o[t[0] + "With"](this === o ? void 0 : this, arguments),
                    this
                }
                ,
                o[t[0] + "With"] = a.fireWith
            }),
            i.promise(o),
            t && t.call(o, o),
            o
        },
        when: function(e) {
            var t = arguments.length
              , n = t
              , r = Array(n)
              , i = o.call(arguments)
              , a = w.Deferred()
              , s = function(e) {
                return function(n) {
                    r[e] = this,
                    i[e] = arguments.length > 1 ? o.call(arguments) : n,
                    --t || a.resolveWith(r, i)
                }
            };
            if (t <= 1 && ($(e, a.done(s(n)).resolve, a.reject, !t),
            "pending" === a.state() || g(i[n] && i[n].then)))
                return a.then();
            while (n--)
                $(i[n], s(n), a.reject);
            return a.promise()
        }
    });
    var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    w.Deferred.exceptionHook = function(t, n) {
        e.console && e.console.warn && t && B.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n)
    }
    ,
    w.readyException = function(t) {
        e.setTimeout(function() {
            throw t
        })
    }
    ;
    var F = w.Deferred();
    w.fn.ready = function(e) {
        return F.then(e)["catch"](function(e) {
            w.readyException(e)
        }),
        this
    }
    ,
    w.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --w.readyWait : w.isReady) || (w.isReady = !0,
            !0 !== e && --w.readyWait > 0 || F.resolveWith(r, [w]))
        }
    }),
    w.ready.then = F.then;
    function _() {
        r.removeEventListener("DOMContentLoaded", _),
        e.removeEventListener("load", _),
        w.ready()
    }
    "complete" === r.readyState || "loading" !== r.readyState && !r.documentElement.doScroll ? e.setTimeout(w.ready) : (r.addEventListener("DOMContentLoaded", _),
    e.addEventListener("load", _));
    var z = function(e, t, n, r, i, o, a) {
        var s = 0
          , u = e.length
          , l = null == n;
        if ("object" === x(n)) {
            i = !0;
            for (s in n)
                z(e, t, s, n[s], !0, o, a)
        } else if (void 0 !== r && (i = !0,
        g(r) || (a = !0),
        l && (a ? (t.call(e, r),
        t = null) : (l = t,
        t = function(e, t, n) {
            return l.call(w(e), n)
        }
        )),
        t))
            for (; s < u; s++)
                t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
        return i ? e : l ? t.call(e) : u ? t(e[0], n) : o
    }
      , X = /^-ms-/
      , U = /-([a-z])/g;
    function V(e, t) {
        return t.toUpperCase()
    }
    function G(e) {
        return e.replace(X, "ms-").replace(U, V)
    }
    var Y = function(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    };
    function Q() {
        this.expando = w.expando + Q.uid++
    }
    Q.uid = 1,
    Q.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {},
            Y(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))),
            t
        },
        set: function(e, t, n) {
            var r, i = this.cache(e);
            if ("string" == typeof t)
                i[G(t)] = n;
            else
                for (r in t)
                    i[G(r)] = t[r];
            return i
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)]
        },
        access: function(e, t, n) {
            return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n),
            void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, r = e[this.expando];
            if (void 0 !== r) {
                if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(G) : (t = G(t))in r ? [t] : t.match(M) || []).length;
                    while (n--)
                        delete r[t[n]]
                }
                (void 0 === t || w.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !w.isEmptyObject(t)
        }
    };
    var J = new Q
      , K = new Q
      , Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , ee = /[A-Z]/g;
    function te(e) {
        return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : Z.test(e) ? JSON.parse(e) : e)
    }
    function ne(e, t, n) {
        var r;
        if (void 0 === n && 1 === e.nodeType)
            if (r = "data-" + t.replace(ee, "-$&").toLowerCase(),
            "string" == typeof (n = e.getAttribute(r))) {
                try {
                    n = te(n)
                } catch (e) {}
                K.set(e, t, n)
            } else
                n = void 0;
        return n
    }
    w.extend({
        hasData: function(e) {
            return K.hasData(e) || J.hasData(e)
        },
        data: function(e, t, n) {
            return K.access(e, t, n)
        },
        removeData: function(e, t) {
            K.remove(e, t)
        },
        _data: function(e, t, n) {
            return J.access(e, t, n)
        },
        _removeData: function(e, t) {
            J.remove(e, t)
        }
    }),
    w.fn.extend({
        data: function(e, t) {
            var n, r, i, o = this[0], a = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (i = K.get(o),
                1 === o.nodeType && !J.get(o, "hasDataAttrs"))) {
                    n = a.length;
                    while (n--)
                        a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = G(r.slice(5)),
                        ne(o, r, i[r]));
                    J.set(o, "hasDataAttrs", !0)
                }
                return i
            }
            return "object" == typeof e ? this.each(function() {
                K.set(this, e)
            }) : z(this, function(t) {
                var n;
                if (o && void 0 === t) {
                    if (void 0 !== (n = K.get(o, e)))
                        return n;
                    if (void 0 !== (n = ne(o, e)))
                        return n
                } else
                    this.each(function() {
                        K.set(this, e, t)
                    })
            }, null, t, arguments.length > 1, null, !0)
        },
        removeData: function(e) {
            return this.each(function() {
                K.remove(this, e)
            })
        }
    }),
    w.extend({
        queue: function(e, t, n) {
            var r;
            if (e)
                return t = (t || "fx") + "queue",
                r = J.get(e, t),
                n && (!r || Array.isArray(n) ? r = J.access(e, t, w.makeArray(n)) : r.push(n)),
                r || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = w.queue(e, t)
              , r = n.length
              , i = n.shift()
              , o = w._queueHooks(e, t)
              , a = function() {
                w.dequeue(e, t)
            };
            "inprogress" === i && (i = n.shift(),
            r--),
            i && ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            i.call(e, a, o)),
            !r && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return J.get(e, n) || J.access(e, n, {
                empty: w.Callbacks("once memory").add(function() {
                    J.remove(e, [t + "queue", n])
                })
            })
        }
    }),
    w.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e,
            e = "fx",
            n--),
            arguments.length < n ? w.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var n = w.queue(this, e, t);
                w._queueHooks(this, e),
                "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                w.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var n, r = 1, i = w.Deferred(), o = this, a = this.length, s = function() {
                --r || i.resolveWith(o, [o])
            };
            "string" != typeof e && (t = e,
            e = void 0),
            e = e || "fx";
            while (a--)
                (n = J.get(o[a], e + "queueHooks")) && n.empty && (r++,
                n.empty.add(s));
            return s(),
            i.promise(t)
        }
    });
    var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$","i")
      , oe = ["Top", "Right", "Bottom", "Left"]
      , ae = function(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && w.contains(e.ownerDocument, e) && "none" === w.css(e, "display")
    }
      , se = function(e, t, n, r) {
        var i, o, a = {};
        for (o in t)
            a[o] = e.style[o],
            e.style[o] = t[o];
        i = n.apply(e, r || []);
        for (o in t)
            e.style[o] = a[o];
        return i
    };
    function ue(e, t, n, r) {
        var i, o, a = 20, s = r ? function() {
            return r.cur()
        }
        : function() {
            return w.css(e, t, "")
        }
        , u = s(), l = n && n[3] || (w.cssNumber[t] ? "" : "px"), c = (w.cssNumber[t] || "px" !== l && +u) && ie.exec(w.css(e, t));
        if (c && c[3] !== l) {
            u /= 2,
            l = l || c[3],
            c = +u || 1;
            while (a--)
                w.style(e, t, c + l),
                (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0),
                c /= o;
            c *= 2,
            w.style(e, t, c + l),
            n = n || []
        }
        return n && (c = +c || +u || 0,
        i = n[1] ? c + (n[1] + 1) * n[2] : +n[2],
        r && (r.unit = l,
        r.start = c,
        r.end = i)),
        i
    }
    var le = {};
    function ce(e) {
        var t, n = e.ownerDocument, r = e.nodeName, i = le[r];
        return i || (t = n.body.appendChild(n.createElement(r)),
        i = w.css(t, "display"),
        t.parentNode.removeChild(t),
        "none" === i && (i = "block"),
        le[r] = i,
        i)
    }
    function fe(e, t) {
        for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
            (r = e[o]).style && (n = r.style.display,
            t ? ("none" === n && (i[o] = J.get(r, "display") || null,
            i[o] || (r.style.display = "")),
            "" === r.style.display && ae(r) && (i[o] = ce(r))) : "none" !== n && (i[o] = "none",
            J.set(r, "display", n)));
        for (o = 0; o < a; o++)
            null != i[o] && (e[o].style.display = i[o]);
        return e
    }
    w.fn.extend({
        show: function() {
            return fe(this, !0)
        },
        hide: function() {
            return fe(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                ae(this) ? w(this).show() : w(this).hide()
            })
        }
    });
    var pe = /^(?:checkbox|radio)$/i
      , de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i
      , he = /^$|^module$|\/(?:java|ecma)script/i
      , ge = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    ge.optgroup = ge.option,
    ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead,
    ge.th = ge.td;
    function ye(e, t) {
        var n;
        return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [],
        void 0 === t || t && N(e, t) ? w.merge([e], n) : n
    }
    function ve(e, t) {
        for (var n = 0, r = e.length; n < r; n++)
            J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"))
    }
    var me = /<|&#?\w+;/;
    function xe(e, t, n, r, i) {
        for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++)
            if ((o = e[d]) || 0 === o)
                if ("object" === x(o))
                    w.merge(p, o.nodeType ? [o] : o);
                else if (me.test(o)) {
                    a = a || f.appendChild(t.createElement("div")),
                    s = (de.exec(o) || ["", ""])[1].toLowerCase(),
                    u = ge[s] || ge._default,
                    a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2],
                    c = u[0];
                    while (c--)
                        a = a.lastChild;
                    w.merge(p, a.childNodes),
                    (a = f.firstChild).textContent = ""
                } else
                    p.push(t.createTextNode(o));
        f.textContent = "",
        d = 0;
        while (o = p[d++])
            if (r && w.inArray(o, r) > -1)
                i && i.push(o);
            else if (l = w.contains(o.ownerDocument, o),
            a = ye(f.appendChild(o), "script"),
            l && ve(a),
            n) {
                c = 0;
                while (o = a[c++])
                    he.test(o.type || "") && n.push(o)
            }
        return f
    }
    !function() {
        var e = r.createDocumentFragment().appendChild(r.createElement("div"))
          , t = r.createElement("input");
        t.setAttribute("type", "radio"),
        t.setAttribute("checked", "checked"),
        t.setAttribute("name", "t"),
        e.appendChild(t),
        h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked,
        e.innerHTML = "<textarea>x</textarea>",
        h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
    }();
    var be = r.documentElement
      , we = /^key/
      , Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , Ce = /^([^.]*)(?:\.(.+)|)/;
    function Ee() {
        return !0
    }
    function ke() {
        return !1
    }
    function Se() {
        try {
            return r.activeElement
        } catch (e) {}
    }
    function De(e, t, n, r, i, o) {
        var a, s;
        if ("object" == typeof t) {
            "string" != typeof n && (r = r || n,
            n = void 0);
            for (s in t)
                De(e, s, n, r, t[s], o);
            return e
        }
        if (null == r && null == i ? (i = n,
        r = n = void 0) : null == i && ("string" == typeof n ? (i = r,
        r = void 0) : (i = r,
        r = n,
        n = void 0)),
        !1 === i)
            i = ke;
        else if (!i)
            return e;
        return 1 === o && (a = i,
        (i = function(e) {
            return w().off(e),
            a.apply(this, arguments)
        }
        ).guid = a.guid || (a.guid = w.guid++)),
        e.each(function() {
            w.event.add(this, t, i, r, n)
        })
    }
    w.event = {
        global: {},
        add: function(e, t, n, r, i) {
            var o, a, s, u, l, c, f, p, d, h, g, y = J.get(e);
            if (y) {
                n.handler && (n = (o = n).handler,
                i = o.selector),
                i && w.find.matchesSelector(be, i),
                n.guid || (n.guid = w.guid++),
                (u = y.events) || (u = y.events = {}),
                (a = y.handle) || (a = y.handle = function(t) {
                    return "undefined" != typeof w && w.event.triggered !== t.type ? w.event.dispatch.apply(e, arguments) : void 0
                }
                ),
                l = (t = (t || "").match(M) || [""]).length;
                while (l--)
                    d = g = (s = Ce.exec(t[l]) || [])[1],
                    h = (s[2] || "").split(".").sort(),
                    d && (f = w.event.special[d] || {},
                    d = (i ? f.delegateType : f.bindType) || d,
                    f = w.event.special[d] || {},
                    c = w.extend({
                        type: d,
                        origType: g,
                        data: r,
                        handler: n,
                        guid: n.guid,
                        selector: i,
                        needsContext: i && w.expr.match.needsContext.test(i),
                        namespace: h.join(".")
                    }, o),
                    (p = u[d]) || ((p = u[d] = []).delegateCount = 0,
                    f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(d, a)),
                    f.add && (f.add.call(e, c),
                    c.handler.guid || (c.handler.guid = n.guid)),
                    i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                    w.event.global[d] = !0)
            }
        },
        remove: function(e, t, n, r, i) {
            var o, a, s, u, l, c, f, p, d, h, g, y = J.hasData(e) && J.get(e);
            if (y && (u = y.events)) {
                l = (t = (t || "").match(M) || [""]).length;
                while (l--)
                    if (s = Ce.exec(t[l]) || [],
                    d = g = s[1],
                    h = (s[2] || "").split(".").sort(),
                    d) {
                        f = w.event.special[d] || {},
                        p = u[d = (r ? f.delegateType : f.bindType) || d] || [],
                        s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        a = o = p.length;
                        while (o--)
                            c = p[o],
                            !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1),
                            c.selector && p.delegateCount--,
                            f.remove && f.remove.call(e, c));
                        a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, y.handle) || w.removeEvent(e, d, y.handle),
                        delete u[d])
                    } else
                        for (d in u)
                            w.event.remove(e, d + t[l], n, r, !0);
                w.isEmptyObject(u) && J.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t = w.event.fix(e), n, r, i, o, a, s, u = new Array(arguments.length), l = (J.get(this, "events") || {})[t.type] || [], c = w.event.special[t.type] || {};
            for (u[0] = t,
            n = 1; n < arguments.length; n++)
                u[n] = arguments[n];
            if (t.delegateTarget = this,
            !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
                s = w.event.handlers.call(this, t, l),
                n = 0;
                while ((o = s[n++]) && !t.isPropagationStopped()) {
                    t.currentTarget = o.elem,
                    r = 0;
                    while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped())
                        t.rnamespace && !t.rnamespace.test(a.namespace) || (t.handleObj = a,
                        t.data = a.data,
                        void 0 !== (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) && !1 === (t.result = i) && (t.preventDefault(),
                        t.stopPropagation()))
                }
                return c.postDispatch && c.postDispatch.call(this, t),
                t.result
            }
        },
        handlers: function(e, t) {
            var n, r, i, o, a, s = [], u = t.delegateCount, l = e.target;
            if (u && l.nodeType && !("click" === e.type && e.button >= 1))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                        for (o = [],
                        a = {},
                        n = 0; n < u; n++)
                            void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? w(i, this).index(l) > -1 : w.find(i, this, null, [l]).length),
                            a[i] && o.push(r);
                        o.length && s.push({
                            elem: l,
                            handlers: o
                        })
                    }
            return l = this,
            u < t.length && s.push({
                elem: l,
                handlers: t.slice(u)
            }),
            s
        },
        addProp: function(e, t) {
            Object.defineProperty(w.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: g(t) ? function() {
                    if (this.originalEvent)
                        return t(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[e]
                }
                ,
                set: function(t) {
                    Object.defineProperty(this, e, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: t
                    })
                }
            })
        },
        fix: function(e) {
            return e[w.expando] ? e : new w.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== Se() && this.focus)
                        return this.focus(),
                        !1
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === Se() && this.blur)
                        return this.blur(),
                        !1
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if ("checkbox" === this.type && this.click && N(this, "input"))
                        return this.click(),
                        !1
                },
                _default: function(e) {
                    return N(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    },
    w.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }
    ,
    w.Event = function(e, t) {
        if (!(this instanceof w.Event))
            return new w.Event(e,t);
        e && e.type ? (this.originalEvent = e,
        this.type = e.type,
        this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ee : ke,
        this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target,
        this.currentTarget = e.currentTarget,
        this.relatedTarget = e.relatedTarget) : this.type = e,
        t && w.extend(this, t),
        this.timeStamp = e && e.timeStamp || Date.now(),
        this[w.expando] = !0
    }
    ,
    w.Event.prototype = {
        constructor: w.Event,
        isDefaultPrevented: ke,
        isPropagationStopped: ke,
        isImmediatePropagationStopped: ke,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = Ee,
            e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = Ee,
            e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = Ee,
            e && !this.isSimulated && e.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    w.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        "char": !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
            var t = e.button;
            return null == e.which && we.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Te.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
        }
    }, w.event.addProp),
    w.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        w.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, r = this, i = e.relatedTarget, o = e.handleObj;
                return i && (i === r || w.contains(r, i)) || (e.type = o.origType,
                n = o.handler.apply(this, arguments),
                e.type = t),
                n
            }
        }
    }),
    w.fn.extend({
        on: function(e, t, n, r) {
            return De(this, e, t, n, r)
        },
        one: function(e, t, n, r) {
            return De(this, e, t, n, r, 1)
        },
        off: function(e, t, n) {
            var r, i;
            if (e && e.preventDefault && e.handleObj)
                return r = e.handleObj,
                w(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler),
                this;
            if ("object" == typeof e) {
                for (i in e)
                    this.off(i, t, e[i]);
                return this
            }
            return !1 !== t && "function" != typeof t || (n = t,
            t = void 0),
            !1 === n && (n = ke),
            this.each(function() {
                w.event.remove(this, e, n, t)
            })
        }
    });
    var Ne = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi
      , Ae = /<script|<style|<link/i
      , je = /checked\s*(?:[^=]|=\s*.checked.)/i
      , qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function Le(e, t) {
        return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr") ? w(e).children("tbody")[0] || e : e
    }
    function He(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
        e
    }
    function Oe(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"),
        e
    }
    function Pe(e, t) {
        var n, r, i, o, a, s, u, l;
        if (1 === t.nodeType) {
            if (J.hasData(e) && (o = J.access(e),
            a = J.set(t, o),
            l = o.events)) {
                delete a.handle,
                a.events = {};
                for (i in l)
                    for (n = 0,
                    r = l[i].length; n < r; n++)
                        w.event.add(t, i, l[i][n])
            }
            K.hasData(e) && (s = K.access(e),
            u = w.extend({}, s),
            K.set(t, u))
        }
    }
    function Me(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && pe.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
    }
    function Re(e, t, n, r) {
        t = a.apply([], t);
        var i, o, s, u, l, c, f = 0, p = e.length, d = p - 1, y = t[0], v = g(y);
        if (v || p > 1 && "string" == typeof y && !h.checkClone && je.test(y))
            return e.each(function(i) {
                var o = e.eq(i);
                v && (t[0] = y.call(this, i, o.html())),
                Re(o, t, n, r)
            });
        if (p && (i = xe(t, e[0].ownerDocument, !1, e, r),
        o = i.firstChild,
        1 === i.childNodes.length && (i = o),
        o || r)) {
            for (u = (s = w.map(ye(i, "script"), He)).length; f < p; f++)
                l = i,
                f !== d && (l = w.clone(l, !0, !0),
                u && w.merge(s, ye(l, "script"))),
                n.call(e[f], l, f);
            if (u)
                for (c = s[s.length - 1].ownerDocument,
                w.map(s, Oe),
                f = 0; f < u; f++)
                    l = s[f],
                    he.test(l.type || "") && !J.access(l, "globalEval") && w.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? w._evalUrl && w._evalUrl(l.src) : m(l.textContent.replace(qe, ""), c, l))
        }
        return e
    }
    function Ie(e, t, n) {
        for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
            n || 1 !== r.nodeType || w.cleanData(ye(r)),
            r.parentNode && (n && w.contains(r.ownerDocument, r) && ve(ye(r, "script")),
            r.parentNode.removeChild(r));
        return e
    }
    w.extend({
        htmlPrefilter: function(e) {
            return e.replace(Ne, "<$1></$2>")
        },
        clone: function(e, t, n) {
            var r, i, o, a, s = e.cloneNode(!0), u = w.contains(e.ownerDocument, e);
            if (!(h.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || w.isXMLDoc(e)))
                for (a = ye(s),
                r = 0,
                i = (o = ye(e)).length; r < i; r++)
                    Me(o[r], a[r]);
            if (t)
                if (n)
                    for (o = o || ye(e),
                    a = a || ye(s),
                    r = 0,
                    i = o.length; r < i; r++)
                        Pe(o[r], a[r]);
                else
                    Pe(e, s);
            return (a = ye(s, "script")).length > 0 && ve(a, !u && ye(e, "script")),
            s
        },
        cleanData: function(e) {
            for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (Y(n)) {
                    if (t = n[J.expando]) {
                        if (t.events)
                            for (r in t.events)
                                i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
                        n[J.expando] = void 0
                    }
                    n[K.expando] && (n[K.expando] = void 0)
                }
        }
    }),
    w.fn.extend({
        detach: function(e) {
            return Ie(this, e, !0)
        },
        remove: function(e) {
            return Ie(this, e)
        },
        text: function(e) {
            return z(this, function(e) {
                return void 0 === e ? w.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return Re(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Le(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return Re(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = Le(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return Re(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return Re(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++)
                1 === e.nodeType && (w.cleanData(ye(e, !1)),
                e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e,
            t = null == t ? e : t,
            this.map(function() {
                return w.clone(this, e, t)
            })
        },
        html: function(e) {
            return z(this, function(e) {
                var t = this[0] || {}
                  , n = 0
                  , r = this.length;
                if (void 0 === e && 1 === t.nodeType)
                    return t.innerHTML;
                if ("string" == typeof e && !Ae.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = w.htmlPrefilter(e);
                    try {
                        for (; n < r; n++)
                            1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)),
                            t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = [];
            return Re(this, arguments, function(t) {
                var n = this.parentNode;
                w.inArray(this, e) < 0 && (w.cleanData(ye(this)),
                n && n.replaceChild(t, this))
            }, e)
        }
    }),
    w.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        w.fn[e] = function(e) {
            for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)
                n = a === o ? this : this.clone(!0),
                w(i[a])[t](n),
                s.apply(r, n.get());
            return this.pushStack(r)
        }
    });
    var We = new RegExp("^(" + re + ")(?!px)[a-z%]+$","i")
      , $e = function(t) {
        var n = t.ownerDocument.defaultView;
        return n && n.opener || (n = e),
        n.getComputedStyle(t)
    }
      , Be = new RegExp(oe.join("|"),"i");
    !function() {
        function t() {
            if (c) {
                l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                be.appendChild(l).appendChild(c);
                var t = e.getComputedStyle(c);
                i = "1%" !== t.top,
                u = 12 === n(t.marginLeft),
                c.style.right = "60%",
                s = 36 === n(t.right),
                o = 36 === n(t.width),
                c.style.position = "absolute",
                a = 36 === c.offsetWidth || "absolute",
                be.removeChild(l),
                c = null
            }
        }
        function n(e) {
            return Math.round(parseFloat(e))
        }
        var i, o, a, s, u, l = r.createElement("div"), c = r.createElement("div");
        c.style && (c.style.backgroundClip = "content-box",
        c.cloneNode(!0).style.backgroundClip = "",
        h.clearCloneStyle = "content-box" === c.style.backgroundClip,
        w.extend(h, {
            boxSizingReliable: function() {
                return t(),
                o
            },
            pixelBoxStyles: function() {
                return t(),
                s
            },
            pixelPosition: function() {
                return t(),
                i
            },
            reliableMarginLeft: function() {
                return t(),
                u
            },
            scrollboxSize: function() {
                return t(),
                a
            }
        }))
    }();
    function Fe(e, t, n) {
        var r, i, o, a, s = e.style;
        return (n = n || $e(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || w.contains(e.ownerDocument, e) || (a = w.style(e, t)),
        !h.pixelBoxStyles() && We.test(a) && Be.test(t) && (r = s.width,
        i = s.minWidth,
        o = s.maxWidth,
        s.minWidth = s.maxWidth = s.width = a,
        a = n.width,
        s.width = r,
        s.minWidth = i,
        s.maxWidth = o)),
        void 0 !== a ? a + "" : a
    }
    function _e(e, t) {
        return {
            get: function() {
                if (!e())
                    return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }
    var ze = /^(none|table(?!-c[ea]).+)/
      , Xe = /^--/
      , Ue = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , Ve = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , Ge = ["Webkit", "Moz", "ms"]
      , Ye = r.createElement("div").style;
    function Qe(e) {
        if (e in Ye)
            return e;
        var t = e[0].toUpperCase() + e.slice(1)
          , n = Ge.length;
        while (n--)
            if ((e = Ge[n] + t)in Ye)
                return e
    }
    function Je(e) {
        var t = w.cssProps[e];
        return t || (t = w.cssProps[e] = Qe(e) || e),
        t
    }
    function Ke(e, t, n) {
        var r = ie.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t
    }
    function Ze(e, t, n, r, i, o) {
        var a = "width" === t ? 1 : 0
          , s = 0
          , u = 0;
        if (n === (r ? "border" : "content"))
            return 0;
        for (; a < 4; a += 2)
            "margin" === n && (u += w.css(e, n + oe[a], !0, i)),
            r ? ("content" === n && (u -= w.css(e, "padding" + oe[a], !0, i)),
            "margin" !== n && (u -= w.css(e, "border" + oe[a] + "Width", !0, i))) : (u += w.css(e, "padding" + oe[a], !0, i),
            "padding" !== n ? u += w.css(e, "border" + oe[a] + "Width", !0, i) : s += w.css(e, "border" + oe[a] + "Width", !0, i));
        return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5))),
        u
    }
    function et(e, t, n) {
        var r = $e(e)
          , i = Fe(e, t, r)
          , o = "border-box" === w.css(e, "boxSizing", !1, r)
          , a = o;
        if (We.test(i)) {
            if (!n)
                return i;
            i = "auto"
        }
        return a = a && (h.boxSizingReliable() || i === e.style[t]),
        ("auto" === i || !parseFloat(i) && "inline" === w.css(e, "display", !1, r)) && (i = e["offset" + t[0].toUpperCase() + t.slice(1)],
        a = !0),
        (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? "border" : "content"), a, r, i) + "px"
    }
    w.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = Fe(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i, o, a, s = G(t), u = Xe.test(t), l = e.style;
                if (u || (t = Je(s)),
                a = w.cssHooks[t] || w.cssHooks[s],
                void 0 === n)
                    return a && "get"in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
                "string" == (o = typeof n) && (i = ie.exec(n)) && i[1] && (n = ue(e, t, i),
                o = "number"),
                null != n && n === n && ("number" === o && (n += i && i[3] || (w.cssNumber[s] ? "" : "px")),
                h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                a && "set"in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n))
            }
        },
        css: function(e, t, n, r) {
            var i, o, a, s = G(t);
            return Xe.test(t) || (t = Je(s)),
            (a = w.cssHooks[t] || w.cssHooks[s]) && "get"in a && (i = a.get(e, !0, n)),
            void 0 === i && (i = Fe(e, t, r)),
            "normal" === i && t in Ve && (i = Ve[t]),
            "" === n || n ? (o = parseFloat(i),
            !0 === n || isFinite(o) ? o || 0 : i) : i
        }
    }),
    w.each(["height", "width"], function(e, t) {
        w.cssHooks[t] = {
            get: function(e, n, r) {
                if (n)
                    return !ze.test(w.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? et(e, t, r) : se(e, Ue, function() {
                        return et(e, t, r)
                    })
            },
            set: function(e, n, r) {
                var i, o = $e(e), a = "border-box" === w.css(e, "boxSizing", !1, o), s = r && Ze(e, t, r, a, o);
                return a && h.scrollboxSize() === o.position && (s -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Ze(e, t, "border", !1, o) - .5)),
                s && (i = ie.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n,
                n = w.css(e, t)),
                Ke(e, n, s)
            }
        }
    }),
    w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function(e, t) {
        if (t)
            return (parseFloat(Fe(e, "marginLeft")) || e.getBoundingClientRect().left - se(e, {
                marginLeft: 0
            }, function() {
                return e.getBoundingClientRect().left
            })) + "px"
    }),
    w.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        w.cssHooks[e + t] = {
            expand: function(n) {
                for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++)
                    i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
                return i
            }
        },
        "margin" !== e && (w.cssHooks[e + t].set = Ke)
    }),
    w.fn.extend({
        css: function(e, t) {
            return z(this, function(e, t, n) {
                var r, i, o = {}, a = 0;
                if (Array.isArray(t)) {
                    for (r = $e(e),
                    i = t.length; a < i; a++)
                        o[t[a]] = w.css(e, t[a], !1, r);
                    return o
                }
                return void 0 !== n ? w.style(e, t, n) : w.css(e, t)
            }, e, t, arguments.length > 1)
        }
    });
    function tt(e, t, n, r, i) {
        return new tt.prototype.init(e,t,n,r,i)
    }
    w.Tween = tt,
    tt.prototype = {
        constructor: tt,
        init: function(e, t, n, r, i, o) {
            this.elem = e,
            this.prop = n,
            this.easing = i || w.easing._default,
            this.options = t,
            this.start = this.now = this.cur(),
            this.end = r,
            this.unit = o || (w.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = tt.propHooks[this.prop];
            return e && e.get ? e.get(this) : tt.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = tt.propHooks[this.prop];
            return this.options.duration ? this.pos = t = w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
            this.now = (this.end - this.start) * t + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : tt.propHooks._default.set(this),
            this
        }
    },
    tt.prototype.init.prototype = tt.prototype,
    tt.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = w.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                w.fx.step[e.prop] ? w.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop] ? e.elem[e.prop] = e.now : w.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    },
    tt.propHooks.scrollTop = tt.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    },
    w.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    },
    w.fx = tt.prototype.init,
    w.fx.step = {};
    var nt, rt, it = /^(?:toggle|show|hide)$/, ot = /queueHooks$/;
    function at() {
        rt && (!1 === r.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(at) : e.setTimeout(at, w.fx.interval),
        w.fx.tick())
    }
    function st() {
        return e.setTimeout(function() {
            nt = void 0
        }),
        nt = Date.now()
    }
    function ut(e, t) {
        var n, r = 0, i = {
            height: e
        };
        for (t = t ? 1 : 0; r < 4; r += 2 - t)
            i["margin" + (n = oe[r])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e),
        i
    }
    function lt(e, t, n) {
        for (var r, i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]), o = 0, a = i.length; o < a; o++)
            if (r = i[o].call(n, t, e))
                return r
    }
    function ct(e, t, n) {
        var r, i, o, a, s, u, l, c, f = "width"in t || "height"in t, p = this, d = {}, h = e.style, g = e.nodeType && ae(e), y = J.get(e, "fxshow");
        n.queue || (null == (a = w._queueHooks(e, "fx")).unqueued && (a.unqueued = 0,
        s = a.empty.fire,
        a.empty.fire = function() {
            a.unqueued || s()
        }
        ),
        a.unqueued++,
        p.always(function() {
            p.always(function() {
                a.unqueued--,
                w.queue(e, "fx").length || a.empty.fire()
            })
        }));
        for (r in t)
            if (i = t[r],
            it.test(i)) {
                if (delete t[r],
                o = o || "toggle" === i,
                i === (g ? "hide" : "show")) {
                    if ("show" !== i || !y || void 0 === y[r])
                        continue;
                    g = !0
                }
                d[r] = y && y[r] || w.style(e, r)
            }
        if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
            f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY],
            null == (l = y && y.display) && (l = J.get(e, "display")),
            "none" === (c = w.css(e, "display")) && (l ? c = l : (fe([e], !0),
            l = e.style.display || l,
            c = w.css(e, "display"),
            fe([e]))),
            ("inline" === c || "inline-block" === c && null != l) && "none" === w.css(e, "float") && (u || (p.done(function() {
                h.display = l
            }),
            null == l && (c = h.display,
            l = "none" === c ? "" : c)),
            h.display = "inline-block")),
            n.overflow && (h.overflow = "hidden",
            p.always(function() {
                h.overflow = n.overflow[0],
                h.overflowX = n.overflow[1],
                h.overflowY = n.overflow[2]
            })),
            u = !1;
            for (r in d)
                u || (y ? "hidden"in y && (g = y.hidden) : y = J.access(e, "fxshow", {
                    display: l
                }),
                o && (y.hidden = !g),
                g && fe([e], !0),
                p.done(function() {
                    g || fe([e]),
                    J.remove(e, "fxshow");
                    for (r in d)
                        w.style(e, r, d[r])
                })),
                u = lt(g ? y[r] : 0, r, p),
                r in y || (y[r] = u.start,
                g && (u.end = u.start,
                u.start = 0))
        }
    }
    function ft(e, t) {
        var n, r, i, o, a;
        for (n in e)
            if (r = G(n),
            i = t[r],
            o = e[n],
            Array.isArray(o) && (i = o[1],
            o = e[n] = o[0]),
            n !== r && (e[r] = o,
            delete e[n]),
            (a = w.cssHooks[r]) && "expand"in a) {
                o = a.expand(o),
                delete e[r];
                for (n in o)
                    n in e || (e[n] = o[n],
                    t[n] = i)
            } else
                t[r] = i
    }
    function pt(e, t, n) {
        var r, i, o = 0, a = pt.prefilters.length, s = w.Deferred().always(function() {
            delete u.elem
        }), u = function() {
            if (i)
                return !1;
            for (var t = nt || st(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, a = l.tweens.length; o < a; o++)
                l.tweens[o].run(r);
            return s.notifyWith(e, [l, r, n]),
            r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]),
            s.resolveWith(e, [l]),
            !1)
        }, l = s.promise({
            elem: e,
            props: w.extend({}, t),
            opts: w.extend(!0, {
                specialEasing: {},
                easing: w.easing._default
            }, n),
            originalProperties: t,
            originalOptions: n,
            startTime: nt || st(),
            duration: n.duration,
            tweens: [],
            createTween: function(t, n) {
                var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
                return l.tweens.push(r),
                r
            },
            stop: function(t) {
                var n = 0
                  , r = t ? l.tweens.length : 0;
                if (i)
                    return this;
                for (i = !0; n < r; n++)
                    l.tweens[n].run(1);
                return t ? (s.notifyWith(e, [l, 1, 0]),
                s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]),
                this
            }
        }), c = l.props;
        for (ft(c, l.opts.specialEasing); o < a; o++)
            if (r = pt.prefilters[o].call(l, e, c, l.opts))
                return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)),
                r;
        return w.map(c, lt, l),
        g(l.opts.start) && l.opts.start.call(e, l),
        l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
        w.fx.timer(w.extend(u, {
            elem: e,
            anim: l,
            queue: l.opts.queue
        })),
        l
    }
    w.Animation = w.extend(pt, {
        tweeners: {
            "*": [function(e, t) {
                var n = this.createTween(e, t);
                return ue(n.elem, e, ie.exec(t), n),
                n
            }
            ]
        },
        tweener: function(e, t) {
            g(e) ? (t = e,
            e = ["*"]) : e = e.match(M);
            for (var n, r = 0, i = e.length; r < i; r++)
                n = e[r],
                pt.tweeners[n] = pt.tweeners[n] || [],
                pt.tweeners[n].unshift(t)
        },
        prefilters: [ct],
        prefilter: function(e, t) {
            t ? pt.prefilters.unshift(e) : pt.prefilters.push(e)
        }
    }),
    w.speed = function(e, t, n) {
        var r = e && "object" == typeof e ? w.extend({}, e) : {
            complete: n || !n && t || g(e) && e,
            duration: e,
            easing: n && t || t && !g(t) && t
        };
        return w.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in w.fx.speeds ? r.duration = w.fx.speeds[r.duration] : r.duration = w.fx.speeds._default),
        null != r.queue && !0 !== r.queue || (r.queue = "fx"),
        r.old = r.complete,
        r.complete = function() {
            g(r.old) && r.old.call(this),
            r.queue && w.dequeue(this, r.queue)
        }
        ,
        r
    }
    ,
    w.fn.extend({
        fadeTo: function(e, t, n, r) {
            return this.filter(ae).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, r)
        },
        animate: function(e, t, n, r) {
            var i = w.isEmptyObject(e)
              , o = w.speed(t, n, r)
              , a = function() {
                var t = pt(this, w.extend({}, e), o);
                (i || J.get(this, "finish")) && t.stop(!0)
            };
            return a.finish = a,
            i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        },
        stop: function(e, t, n) {
            var r = function(e) {
                var t = e.stop;
                delete e.stop,
                t(n)
            };
            return "string" != typeof e && (n = t,
            t = e,
            e = void 0),
            t && !1 !== e && this.queue(e || "fx", []),
            this.each(function() {
                var t = !0
                  , i = null != e && e + "queueHooks"
                  , o = w.timers
                  , a = J.get(this);
                if (i)
                    a[i] && a[i].stop && r(a[i]);
                else
                    for (i in a)
                        a[i] && a[i].stop && ot.test(i) && r(a[i]);
                for (i = o.length; i--; )
                    o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n),
                    t = !1,
                    o.splice(i, 1));
                !t && n || w.dequeue(this, e)
            })
        },
        finish: function(e) {
            return !1 !== e && (e = e || "fx"),
            this.each(function() {
                var t, n = J.get(this), r = n[e + "queue"], i = n[e + "queueHooks"], o = w.timers, a = r ? r.length : 0;
                for (n.finish = !0,
                w.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length; t--; )
                    o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0),
                    o.splice(t, 1));
                for (t = 0; t < a; t++)
                    r[t] && r[t].finish && r[t].finish.call(this);
                delete n.finish
            })
        }
    }),
    w.each(["toggle", "show", "hide"], function(e, t) {
        var n = w.fn[t];
        w.fn[t] = function(e, r, i) {
            return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ut(t, !0), e, r, i)
        }
    }),
    w.each({
        slideDown: ut("show"),
        slideUp: ut("hide"),
        slideToggle: ut("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, t) {
        w.fn[e] = function(e, n, r) {
            return this.animate(t, e, n, r)
        }
    }),
    w.timers = [],
    w.fx.tick = function() {
        var e, t = 0, n = w.timers;
        for (nt = Date.now(); t < n.length; t++)
            (e = n[t])() || n[t] !== e || n.splice(t--, 1);
        n.length || w.fx.stop(),
        nt = void 0
    }
    ,
    w.fx.timer = function(e) {
        w.timers.push(e),
        w.fx.start()
    }
    ,
    w.fx.interval = 13,
    w.fx.start = function() {
        rt || (rt = !0,
        at())
    }
    ,
    w.fx.stop = function() {
        rt = null
    }
    ,
    w.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    w.fn.delay = function(t, n) {
        return t = w.fx ? w.fx.speeds[t] || t : t,
        n = n || "fx",
        this.queue(n, function(n, r) {
            var i = e.setTimeout(n, t);
            r.stop = function() {
                e.clearTimeout(i)
            }
        })
    }
    ,
    function() {
        var e = r.createElement("input")
          , t = r.createElement("select").appendChild(r.createElement("option"));
        e.type = "checkbox",
        h.checkOn = "" !== e.value,
        h.optSelected = t.selected,
        (e = r.createElement("input")).value = "t",
        e.type = "radio",
        h.radioValue = "t" === e.value
    }();
    var dt, ht = w.expr.attrHandle;
    w.fn.extend({
        attr: function(e, t) {
            return z(this, w.attr, e, t, arguments.length > 1)
        },
        removeAttr: function(e) {
            return this.each(function() {
                w.removeAttr(this, e)
            })
        }
    }),
    w.extend({
        attr: function(e, t, n) {
            var r, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return "undefined" == typeof e.getAttribute ? w.prop(e, t, n) : (1 === o && w.isXMLDoc(e) || (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? dt : void 0)),
                void 0 !== n ? null === n ? void w.removeAttr(e, t) : i && "set"in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""),
                n) : i && "get"in i && null !== (r = i.get(e, t)) ? r : null == (r = w.find.attr(e, t)) ? void 0 : r)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!h.radioValue && "radio" === t && N(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t),
                        n && (e.value = n),
                        t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, r = 0, i = t && t.match(M);
            if (i && 1 === e.nodeType)
                while (n = i[r++])
                    e.removeAttribute(n)
        }
    }),
    dt = {
        set: function(e, t, n) {
            return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n),
            n
        }
    },
    w.each(w.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var n = ht[t] || w.find.attr;
        ht[t] = function(e, t, r) {
            var i, o, a = t.toLowerCase();
            return r || (o = ht[a],
            ht[a] = i,
            i = null != n(e, t, r) ? a : null,
            ht[a] = o),
            i
        }
    });
    var gt = /^(?:input|select|textarea|button)$/i
      , yt = /^(?:a|area)$/i;
    w.fn.extend({
        prop: function(e, t) {
            return z(this, w.prop, e, t, arguments.length > 1)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[w.propFix[e] || e]
            })
        }
    }),
    w.extend({
        prop: function(e, t, n) {
            var r, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && w.isXMLDoc(e) || (t = w.propFix[t] || t,
                i = w.propHooks[t]),
                void 0 !== n ? i && "set"in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get"in i && null !== (r = i.get(e, t)) ? r : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = w.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : gt.test(e.nodeName) || yt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    }),
    h.optSelected || (w.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex,
            null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex,
            t.parentNode && t.parentNode.selectedIndex)
        }
    }),
    w.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        w.propFix[this.toLowerCase()] = this
    });
    function vt(e) {
        return (e.match(M) || []).join(" ")
    }
    function mt(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }
    function xt(e) {
        return Array.isArray(e) ? e : "string" == typeof e ? e.match(M) || [] : []
    }
    w.fn.extend({
        addClass: function(e) {
            var t, n, r, i, o, a, s, u = 0;
            if (g(e))
                return this.each(function(t) {
                    w(this).addClass(e.call(this, t, mt(this)))
                });
            if ((t = xt(e)).length)
                while (n = this[u++])
                    if (i = mt(n),
                    r = 1 === n.nodeType && " " + vt(i) + " ") {
                        a = 0;
                        while (o = t[a++])
                            r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                        i !== (s = vt(r)) && n.setAttribute("class", s)
                    }
            return this
        },
        removeClass: function(e) {
            var t, n, r, i, o, a, s, u = 0;
            if (g(e))
                return this.each(function(t) {
                    w(this).removeClass(e.call(this, t, mt(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((t = xt(e)).length)
                while (n = this[u++])
                    if (i = mt(n),
                    r = 1 === n.nodeType && " " + vt(i) + " ") {
                        a = 0;
                        while (o = t[a++])
                            while (r.indexOf(" " + o + " ") > -1)
                                r = r.replace(" " + o + " ", " ");
                        i !== (s = vt(r)) && n.setAttribute("class", s)
                    }
            return this
        },
        toggleClass: function(e, t) {
            var n = typeof e
              , r = "string" === n || Array.isArray(e);
            return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : g(e) ? this.each(function(n) {
                w(this).toggleClass(e.call(this, n, mt(this), t), t)
            }) : this.each(function() {
                var t, i, o, a;
                if (r) {
                    i = 0,
                    o = w(this),
                    a = xt(e);
                    while (t = a[i++])
                        o.hasClass(t) ? o.removeClass(t) : o.addClass(t)
                } else
                    void 0 !== e && "boolean" !== n || ((t = mt(this)) && J.set(this, "__className__", t),
                    this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, n, r = 0;
            t = " " + e + " ";
            while (n = this[r++])
                if (1 === n.nodeType && (" " + vt(mt(n)) + " ").indexOf(t) > -1)
                    return !0;
            return !1
        }
    });
    var bt = /\r/g;
    w.fn.extend({
        val: function(e) {
            var t, n, r, i = this[0];
            {
                if (arguments.length)
                    return r = g(e),
                    this.each(function(n) {
                        var i;
                        1 === this.nodeType && (null == (i = r ? e.call(this, n, w(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = w.map(i, function(e) {
                            return null == e ? "" : e + ""
                        })),
                        (t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set"in t && void 0 !== t.set(this, i, "value") || (this.value = i))
                    });
                if (i)
                    return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) && "get"in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(bt, "") : null == n ? "" : n
            }
        }
    }),
    w.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = w.find.attr(e, "value");
                    return null != t ? t : vt(w.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, n, r, i = e.options, o = e.selectedIndex, a = "select-one" === e.type, s = a ? null : [], u = a ? o + 1 : i.length;
                    for (r = o < 0 ? u : a ? o : 0; r < u; r++)
                        if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))) {
                            if (t = w(n).val(),
                            a)
                                return t;
                            s.push(t)
                        }
                    return s
                },
                set: function(e, t) {
                    var n, r, i = e.options, o = w.makeArray(t), a = i.length;
                    while (a--)
                        ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    w.each(["radio", "checkbox"], function() {
        w.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t))
                    return e.checked = w.inArray(w(e).val(), t) > -1
            }
        },
        h.checkOn || (w.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        }
        )
    }),
    h.focusin = "onfocusin"in e;
    var wt = /^(?:focusinfocus|focusoutblur)$/
      , Tt = function(e) {
        e.stopPropagation()
    };
    w.extend(w.event, {
        trigger: function(t, n, i, o) {
            var a, s, u, l, c, p, d, h, v = [i || r], m = f.call(t, "type") ? t.type : t, x = f.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = h = u = i = i || r,
            3 !== i.nodeType && 8 !== i.nodeType && !wt.test(m + w.event.triggered) && (m.indexOf(".") > -1 && (m = (x = m.split(".")).shift(),
            x.sort()),
            c = m.indexOf(":") < 0 && "on" + m,
            t = t[w.expando] ? t : new w.Event(m,"object" == typeof t && t),
            t.isTrigger = o ? 2 : 3,
            t.namespace = x.join("."),
            t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            t.result = void 0,
            t.target || (t.target = i),
            n = null == n ? [t] : w.makeArray(n, [t]),
            d = w.event.special[m] || {},
            o || !d.trigger || !1 !== d.trigger.apply(i, n))) {
                if (!o && !d.noBubble && !y(i)) {
                    for (l = d.delegateType || m,
                    wt.test(l + m) || (s = s.parentNode); s; s = s.parentNode)
                        v.push(s),
                        u = s;
                    u === (i.ownerDocument || r) && v.push(u.defaultView || u.parentWindow || e)
                }
                a = 0;
                while ((s = v[a++]) && !t.isPropagationStopped())
                    h = s,
                    t.type = a > 1 ? l : d.bindType || m,
                    (p = (J.get(s, "events") || {})[t.type] && J.get(s, "handle")) && p.apply(s, n),
                    (p = c && s[c]) && p.apply && Y(s) && (t.result = p.apply(s, n),
                    !1 === t.result && t.preventDefault());
                return t.type = m,
                o || t.isDefaultPrevented() || d._default && !1 !== d._default.apply(v.pop(), n) || !Y(i) || c && g(i[m]) && !y(i) && ((u = i[c]) && (i[c] = null),
                w.event.triggered = m,
                t.isPropagationStopped() && h.addEventListener(m, Tt),
                i[m](),
                t.isPropagationStopped() && h.removeEventListener(m, Tt),
                w.event.triggered = void 0,
                u && (i[c] = u)),
                t.result
            }
        },
        simulate: function(e, t, n) {
            var r = w.extend(new w.Event, n, {
                type: e,
                isSimulated: !0
            });
            w.event.trigger(r, null, t)
        }
    }),
    w.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                w.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            if (n)
                return w.event.trigger(e, t, n, !0)
        }
    }),
    h.focusin || w.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var n = function(e) {
            w.event.simulate(t, e.target, w.event.fix(e))
        };
        w.event.special[t] = {
            setup: function() {
                var r = this.ownerDocument || this
                  , i = J.access(r, t);
                i || r.addEventListener(e, n, !0),
                J.access(r, t, (i || 0) + 1)
            },
            teardown: function() {
                var r = this.ownerDocument || this
                  , i = J.access(r, t) - 1;
                i ? J.access(r, t, i) : (r.removeEventListener(e, n, !0),
                J.remove(r, t))
            }
        }
    });
    var Ct = e.location
      , Et = Date.now()
      , kt = /\?/;
    w.parseXML = function(t) {
        var n;
        if (!t || "string" != typeof t)
            return null;
        try {
            n = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (e) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || w.error("Invalid XML: " + t),
        n
    }
    ;
    var St = /\[\]$/
      , Dt = /\r?\n/g
      , Nt = /^(?:submit|button|image|reset|file)$/i
      , At = /^(?:input|select|textarea|keygen)/i;
    function jt(e, t, n, r) {
        var i;
        if (Array.isArray(t))
            w.each(t, function(t, i) {
                n || St.test(e) ? r(e, i) : jt(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r)
            });
        else if (n || "object" !== x(t))
            r(e, t);
        else
            for (i in t)
                jt(e + "[" + i + "]", t[i], n, r)
    }
    w.param = function(e, t) {
        var n, r = [], i = function(e, t) {
            var n = g(t) ? t() : t;
            r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
        };
        if (Array.isArray(e) || e.jquery && !w.isPlainObject(e))
            w.each(e, function() {
                i(this.name, this.value)
            });
        else
            for (n in e)
                jt(n, e[n], t, i);
        return r.join("&")
    }
    ,
    w.fn.extend({
        serialize: function() {
            return w.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = w.prop(this, "elements");
                return e ? w.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !w(this).is(":disabled") && At.test(this.nodeName) && !Nt.test(e) && (this.checked || !pe.test(e))
            }).map(function(e, t) {
                var n = w(this).val();
                return null == n ? null : Array.isArray(n) ? w.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Dt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(Dt, "\r\n")
                }
            }).get()
        }
    });
    var qt = /%20/g
      , Lt = /#.*$/
      , Ht = /([?&])_=[^&]*/
      , Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
      , Mt = /^(?:GET|HEAD)$/
      , Rt = /^\/\//
      , It = {}
      , Wt = {}
      , $t = "*/".concat("*")
      , Bt = r.createElement("a");
    Bt.href = Ct.href;
    function Ft(e) {
        return function(t, n) {
            "string" != typeof t && (n = t,
            t = "*");
            var r, i = 0, o = t.toLowerCase().match(M) || [];
            if (g(n))
                while (r = o[i++])
                    "+" === r[0] ? (r = r.slice(1) || "*",
                    (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
        }
    }
    function _t(e, t, n, r) {
        var i = {}
          , o = e === Wt;
        function a(s) {
            var u;
            return i[s] = !0,
            w.each(e[s] || [], function(e, s) {
                var l = s(t, n, r);
                return "string" != typeof l || o || i[l] ? o ? !(u = l) : void 0 : (t.dataTypes.unshift(l),
                a(l),
                !1)
            }),
            u
        }
        return a(t.dataTypes[0]) || !i["*"] && a("*")
    }
    function zt(e, t) {
        var n, r, i = w.ajaxSettings.flatOptions || {};
        for (n in t)
            void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        return r && w.extend(!0, e, r),
        e
    }
    function Xt(e, t, n) {
        var r, i, o, a, s = e.contents, u = e.dataTypes;
        while ("*" === u[0])
            u.shift(),
            void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
        if (r)
            for (i in s)
                if (s[i] && s[i].test(r)) {
                    u.unshift(i);
                    break
                }
        if (u[0]in n)
            o = u[0];
        else {
            for (i in n) {
                if (!u[0] || e.converters[i + " " + u[0]]) {
                    o = i;
                    break
                }
                a || (a = i)
            }
            o = o || a
        }
        if (o)
            return o !== u[0] && u.unshift(o),
            n[o]
    }
    function Ut(e, t, n, r) {
        var i, o, a, s, u, l = {}, c = e.dataTypes.slice();
        if (c[1])
            for (a in e.converters)
                l[a.toLowerCase()] = e.converters[a];
        o = c.shift();
        while (o)
            if (e.responseFields[o] && (n[e.responseFields[o]] = t),
            !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
            u = o,
            o = c.shift())
                if ("*" === o)
                    o = u;
                else if ("*" !== u && u !== o) {
                    if (!(a = l[u + " " + o] || l["* " + o]))
                        for (i in l)
                            if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                                !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0],
                                c.unshift(s[1]));
                                break
                            }
                    if (!0 !== a)
                        if (a && e["throws"])
                            t = a(t);
                        else
                            try {
                                t = a(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: a ? e : "No conversion from " + u + " to " + o
                                }
                            }
                }
        return {
            state: "success",
            data: t
        }
    }
    w.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Ct.href,
            type: "GET",
            isLocal: Pt.test(Ct.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": $t,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": w.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e)
        },
        ajaxPrefilter: Ft(It),
        ajaxTransport: Ft(Wt),
        ajax: function(t, n) {
            "object" == typeof t && (n = t,
            t = void 0),
            n = n || {};
            var i, o, a, s, u, l, c, f, p, d, h = w.ajaxSetup({}, n), g = h.context || h, y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event, v = w.Deferred(), m = w.Callbacks("once memory"), x = h.statusCode || {}, b = {}, T = {}, C = "canceled", E = {
                readyState: 0,
                getResponseHeader: function(e) {
                    var t;
                    if (c) {
                        if (!s) {
                            s = {};
                            while (t = Ot.exec(a))
                                s[t[1].toLowerCase()] = t[2]
                        }
                        t = s[e.toLowerCase()]
                    }
                    return null == t ? null : t
                },
                getAllResponseHeaders: function() {
                    return c ? a : null
                },
                setRequestHeader: function(e, t) {
                    return null == c && (e = T[e.toLowerCase()] = T[e.toLowerCase()] || e,
                    b[e] = t),
                    this
                },
                overrideMimeType: function(e) {
                    return null == c && (h.mimeType = e),
                    this
                },
                statusCode: function(e) {
                    var t;
                    if (e)
                        if (c)
                            E.always(e[E.status]);
                        else
                            for (t in e)
                                x[t] = [x[t], e[t]];
                    return this
                },
                abort: function(e) {
                    var t = e || C;
                    return i && i.abort(t),
                    k(0, t),
                    this
                }
            };
            if (v.promise(E),
            h.url = ((t || h.url || Ct.href) + "").replace(Rt, Ct.protocol + "//"),
            h.type = n.method || n.type || h.method || h.type,
            h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""],
            null == h.crossDomain) {
                l = r.createElement("a");
                try {
                    l.href = h.url,
                    l.href = l.href,
                    h.crossDomain = Bt.protocol + "//" + Bt.host != l.protocol + "//" + l.host
                } catch (e) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = w.param(h.data, h.traditional)),
            _t(It, h, n, E),
            c)
                return E;
            (f = w.event && h.global) && 0 == w.active++ && w.event.trigger("ajaxStart"),
            h.type = h.type.toUpperCase(),
            h.hasContent = !Mt.test(h.type),
            o = h.url.replace(Lt, ""),
            h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(qt, "+")) : (d = h.url.slice(o.length),
            h.data && (h.processData || "string" == typeof h.data) && (o += (kt.test(o) ? "&" : "?") + h.data,
            delete h.data),
            !1 === h.cache && (o = o.replace(Ht, "$1"),
            d = (kt.test(o) ? "&" : "?") + "_=" + Et++ + d),
            h.url = o + d),
            h.ifModified && (w.lastModified[o] && E.setRequestHeader("If-Modified-Since", w.lastModified[o]),
            w.etag[o] && E.setRequestHeader("If-None-Match", w.etag[o])),
            (h.data && h.hasContent && !1 !== h.contentType || n.contentType) && E.setRequestHeader("Content-Type", h.contentType),
            E.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + $t + "; q=0.01" : "") : h.accepts["*"]);
            for (p in h.headers)
                E.setRequestHeader(p, h.headers[p]);
            if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c))
                return E.abort();
            if (C = "abort",
            m.add(h.complete),
            E.done(h.success),
            E.fail(h.error),
            i = _t(Wt, h, n, E)) {
                if (E.readyState = 1,
                f && y.trigger("ajaxSend", [E, h]),
                c)
                    return E;
                h.async && h.timeout > 0 && (u = e.setTimeout(function() {
                    E.abort("timeout")
                }, h.timeout));
                try {
                    c = !1,
                    i.send(b, k)
                } catch (e) {
                    if (c)
                        throw e;
                    k(-1, e)
                }
            } else
                k(-1, "No Transport");
            function k(t, n, r, s) {
                var l, p, d, b, T, C = n;
                c || (c = !0,
                u && e.clearTimeout(u),
                i = void 0,
                a = s || "",
                E.readyState = t > 0 ? 4 : 0,
                l = t >= 200 && t < 300 || 304 === t,
                r && (b = Xt(h, E, r)),
                b = Ut(h, b, E, l),
                l ? (h.ifModified && ((T = E.getResponseHeader("Last-Modified")) && (w.lastModified[o] = T),
                (T = E.getResponseHeader("etag")) && (w.etag[o] = T)),
                204 === t || "HEAD" === h.type ? C = "nocontent" : 304 === t ? C = "notmodified" : (C = b.state,
                p = b.data,
                l = !(d = b.error))) : (d = C,
                !t && C || (C = "error",
                t < 0 && (t = 0))),
                E.status = t,
                E.statusText = (n || C) + "",
                l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]),
                E.statusCode(x),
                x = void 0,
                f && y.trigger(l ? "ajaxSuccess" : "ajaxError", [E, h, l ? p : d]),
                m.fireWith(g, [E, C]),
                f && (y.trigger("ajaxComplete", [E, h]),
                --w.active || w.event.trigger("ajaxStop")))
            }
            return E
        },
        getJSON: function(e, t, n) {
            return w.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return w.get(e, void 0, t, "script")
        }
    }),
    w.each(["get", "post"], function(e, t) {
        w[t] = function(e, n, r, i) {
            return g(n) && (i = i || r,
            r = n,
            n = void 0),
            w.ajax(w.extend({
                url: e,
                type: t,
                dataType: i,
                data: n,
                success: r
            }, w.isPlainObject(e) && e))
        }
    }),
    w._evalUrl = function(e) {
        return w.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            "throws": !0
        })
    }
    ,
    w.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (g(e) && (e = e.call(this[0])),
            t = w(e, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && t.insertBefore(this[0]),
            t.map(function() {
                var e = this;
                while (e.firstElementChild)
                    e = e.firstElementChild;
                return e
            }).append(this)),
            this
        },
        wrapInner: function(e) {
            return g(e) ? this.each(function(t) {
                w(this).wrapInner(e.call(this, t))
            }) : this.each(function() {
                var t = w(this)
                  , n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = g(e);
            return this.each(function(n) {
                w(this).wrapAll(t ? e.call(this, n) : e)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                w(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    w.expr.pseudos.hidden = function(e) {
        return !w.expr.pseudos.visible(e)
    }
    ,
    w.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }
    ,
    w.ajaxSettings.xhr = function() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    }
    ;
    var Vt = {
        0: 200,
        1223: 204
    }
      , Gt = w.ajaxSettings.xhr();
    h.cors = !!Gt && "withCredentials"in Gt,
    h.ajax = Gt = !!Gt,
    w.ajaxTransport(function(t) {
        var n, r;
        if (h.cors || Gt && !t.crossDomain)
            return {
                send: function(i, o) {
                    var a, s = t.xhr();
                    if (s.open(t.type, t.url, t.async, t.username, t.password),
                    t.xhrFields)
                        for (a in t.xhrFields)
                            s[a] = t.xhrFields[a];
                    t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
                    t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");
                    for (a in i)
                        s.setRequestHeader(a, i[a]);
                    n = function(e) {
                        return function() {
                            n && (n = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null,
                            "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Vt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                                binary: s.response
                            } : {
                                text: s.responseText
                            }, s.getAllResponseHeaders()))
                        }
                    }
                    ,
                    s.onload = n(),
                    r = s.onerror = s.ontimeout = n("error"),
                    void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function() {
                        4 === s.readyState && e.setTimeout(function() {
                            n && r()
                        })
                    }
                    ,
                    n = n("abort");
                    try {
                        s.send(t.hasContent && t.data || null)
                    } catch (e) {
                        if (n)
                            throw e
                    }
                },
                abort: function() {
                    n && n()
                }
            }
    }),
    w.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }),
    w.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return w.globalEval(e),
                e
            }
        }
    }),
    w.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1),
        e.crossDomain && (e.type = "GET")
    }),
    w.ajaxTransport("script", function(e) {
        if (e.crossDomain) {
            var t, n;
            return {
                send: function(i, o) {
                    t = w("<script>").prop({
                        charset: e.scriptCharset,
                        src: e.url
                    }).on("load error", n = function(e) {
                        t.remove(),
                        n = null,
                        e && o("error" === e.type ? 404 : 200, e.type)
                    }
                    ),
                    r.head.appendChild(t[0])
                },
                abort: function() {
                    n && n()
                }
            }
        }
    });
    var Yt = []
      , Qt = /(=)\?(?=&|$)|\?\?/;
    w.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Yt.pop() || w.expando + "_" + Et++;
            return this[e] = !0,
            e
        }
    }),
    w.ajaxPrefilter("json jsonp", function(t, n, r) {
        var i, o, a, s = !1 !== t.jsonp && (Qt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Qt.test(t.data) && "data");
        if (s || "jsonp" === t.dataTypes[0])
            return i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback,
            s ? t[s] = t[s].replace(Qt, "$1" + i) : !1 !== t.jsonp && (t.url += (kt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i),
            t.converters["script json"] = function() {
                return a || w.error(i + " was not called"),
                a[0]
            }
            ,
            t.dataTypes[0] = "json",
            o = e[i],
            e[i] = function() {
                a = arguments
            }
            ,
            r.always(function() {
                void 0 === o ? w(e).removeProp(i) : e[i] = o,
                t[i] && (t.jsonpCallback = n.jsonpCallback,
                Yt.push(i)),
                a && g(o) && o(a[0]),
                a = o = void 0
            }),
            "script"
    }),
    h.createHTMLDocument = function() {
        var e = r.implementation.createHTMLDocument("").body;
        return e.innerHTML = "<form></form><form></form>",
        2 === e.childNodes.length
    }(),
    w.parseHTML = function(e, t, n) {
        if ("string" != typeof e)
            return [];
        "boolean" == typeof t && (n = t,
        t = !1);
        var i, o, a;
        return t || (h.createHTMLDocument ? ((i = (t = r.implementation.createHTMLDocument("")).createElement("base")).href = r.location.href,
        t.head.appendChild(i)) : t = r),
        o = A.exec(e),
        a = !n && [],
        o ? [t.createElement(o[1])] : (o = xe([e], t, a),
        a && a.length && w(a).remove(),
        w.merge([], o.childNodes))
    }
    ,
    w.fn.load = function(e, t, n) {
        var r, i, o, a = this, s = e.indexOf(" ");
        return s > -1 && (r = vt(e.slice(s)),
        e = e.slice(0, s)),
        g(t) ? (n = t,
        t = void 0) : t && "object" == typeof t && (i = "POST"),
        a.length > 0 && w.ajax({
            url: e,
            type: i || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            o = arguments,
            a.html(r ? w("<div>").append(w.parseHTML(e)).find(r) : e)
        }).always(n && function(e, t) {
            a.each(function() {
                n.apply(this, o || [e.responseText, t, e])
            })
        }
        ),
        this
    }
    ,
    w.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        w.fn[t] = function(e) {
            return this.on(t, e)
        }
    }),
    w.expr.pseudos.animated = function(e) {
        return w.grep(w.timers, function(t) {
            return e === t.elem
        }).length
    }
    ,
    w.offset = {
        setOffset: function(e, t, n) {
            var r, i, o, a, s, u, l, c = w.css(e, "position"), f = w(e), p = {};
            "static" === c && (e.style.position = "relative"),
            s = f.offset(),
            o = w.css(e, "top"),
            u = w.css(e, "left"),
            (l = ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1) ? (a = (r = f.position()).top,
            i = r.left) : (a = parseFloat(o) || 0,
            i = parseFloat(u) || 0),
            g(t) && (t = t.call(e, n, w.extend({}, s))),
            null != t.top && (p.top = t.top - s.top + a),
            null != t.left && (p.left = t.left - s.left + i),
            "using"in t ? t.using.call(e, p) : f.css(p)
        }
    },
    w.fn.extend({
        offset: function(e) {
            if (arguments.length)
                return void 0 === e ? this : this.each(function(t) {
                    w.offset.setOffset(this, e, t)
                });
            var t, n, r = this[0];
            if (r)
                return r.getClientRects().length ? (t = r.getBoundingClientRect(),
                n = r.ownerDocument.defaultView,
                {
                    top: t.top + n.pageYOffset,
                    left: t.left + n.pageXOffset
                }) : {
                    top: 0,
                    left: 0
                }
        },
        position: function() {
            if (this[0]) {
                var e, t, n, r = this[0], i = {
                    top: 0,
                    left: 0
                };
                if ("fixed" === w.css(r, "position"))
                    t = r.getBoundingClientRect();
                else {
                    t = this.offset(),
                    n = r.ownerDocument,
                    e = r.offsetParent || n.documentElement;
                    while (e && (e === n.body || e === n.documentElement) && "static" === w.css(e, "position"))
                        e = e.parentNode;
                    e && e !== r && 1 === e.nodeType && ((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0),
                    i.left += w.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - i.top - w.css(r, "marginTop", !0),
                    left: t.left - i.left - w.css(r, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                var e = this.offsetParent;
                while (e && "static" === w.css(e, "position"))
                    e = e.offsetParent;
                return e || be
            })
        }
    }),
    w.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var n = "pageYOffset" === t;
        w.fn[e] = function(r) {
            return z(this, function(e, r, i) {
                var o;
                if (y(e) ? o = e : 9 === e.nodeType && (o = e.defaultView),
                void 0 === i)
                    return o ? o[t] : e[r];
                o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i
            }, e, r, arguments.length)
        }
    }),
    w.each(["top", "left"], function(e, t) {
        w.cssHooks[t] = _e(h.pixelPosition, function(e, n) {
            if (n)
                return n = Fe(e, t),
                We.test(n) ? w(e).position()[t] + "px" : n
        })
    }),
    w.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        w.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(n, r) {
            w.fn[r] = function(i, o) {
                var a = arguments.length && (n || "boolean" != typeof i)
                  , s = n || (!0 === i || !0 === o ? "margin" : "border");
                return z(this, function(t, n, i) {
                    var o;
                    return y(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement,
                    Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? w.css(t, n, s) : w.style(t, n, i, s)
                }, t, a ? i : void 0, a)
            }
        })
    }),
    w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
        w.fn[t] = function(e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
    }),
    w.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }),
    w.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, r) {
            return this.on(t, e, n, r)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        }
    }),
    w.proxy = function(e, t) {
        var n, r, i;
        if ("string" == typeof t && (n = e[t],
        t = e,
        e = n),
        g(e))
            return r = o.call(arguments, 2),
            i = function() {
                return e.apply(t || this, r.concat(o.call(arguments)))
            }
            ,
            i.guid = e.guid = e.guid || w.guid++,
            i
    }
    ,
    w.holdReady = function(e) {
        e ? w.readyWait++ : w.ready(!0)
    }
    ,
    w.isArray = Array.isArray,
    w.parseJSON = JSON.parse,
    w.nodeName = N,
    w.isFunction = g,
    w.isWindow = y,
    w.camelCase = G,
    w.type = x,
    w.now = Date.now,
    w.isNumeric = function(e) {
        var t = w.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }
    ,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return w
    });
    var Jt = e.jQuery
      , Kt = e.$;
    return w.noConflict = function(t) {
        return e.$ === w && (e.$ = Kt),
        t && e.jQuery === w && (e.jQuery = Jt),
        w
    }
    ,
    t || (e.jQuery = e.$ = w),
    w
});
/*
 * Responsive Layout helper
 */
window.ResponsiveHelper = (function($) {
    // init variables
    var handlers = [], prevWinWidth, win = $(window), nativeMatchMedia = false;

    // detect match media support
    if (window.matchMedia) {
        if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
            nativeMatchMedia = true;
        } else if (window.matchMedia.toString().indexOf('native') > -1) {
            nativeMatchMedia = true;
        }
    }

    // prepare resize handler
    function resizeHandler() {
        var winWidth = win.width();
        if (winWidth !== prevWinWidth) {
            prevWinWidth = winWidth;

            // loop through range groups
            $.each(handlers, function(index, rangeObject) {
                // disable current active area if needed
                $.each(rangeObject.data, function(property, item) {
                    if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
                        item.currentActive = false;
                        if (typeof item.disableCallback === 'function') {
                            item.disableCallback();
                        }
                    }
                });

                // enable areas that match current width
                $.each(rangeObject.data, function(property, item) {
                    if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
                        // make callback
                        item.currentActive = true;
                        if (typeof item.enableCallback === 'function') {
                            item.enableCallback();
                        }
                    }
                });
            });
        }
    }
    win.bind('load resize orientationchange', resizeHandler);

    // test range
    function matchRange(r1, r2) {
        var mediaQueryString = '';
        if (r1 > 0) {
            mediaQueryString += '(min-width: ' + r1 + 'px)';
        }
        if (r2 < Infinity) {
            mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
        }
        return matchQuery(mediaQueryString, r1, r2);
    }

    // media query function
    function matchQuery(query, r1, r2) {
        if (window.matchMedia && nativeMatchMedia) {
            return matchMedia(query).matches;
        } else if (window.styleMedia) {
            return styleMedia.matchMedium(query);
        } else if (window.media) {
            return media.matchMedium(query);
        } else {
            return prevWinWidth >= r1 && prevWinWidth <= r2;
        }
    }

    // range parser
    function parseRange(rangeStr) {
        var rangeData = rangeStr.split('..');
        var x1 = parseInt(rangeData[0], 10) || -Infinity;
        var x2 = parseInt(rangeData[1], 10) || Infinity;
        return [x1, x2].sort(function(a, b) {
            return a - b;
        });
    }

    // export public functions
    return {
        addRange: function(ranges) {
            // parse data and add items to collection
            var result = {
                data: {}
            };
            $.each(ranges, function(property, data) {
                result.data[property] = {
                    range: parseRange(property),
                    enableCallback: data.on,
                    disableCallback: data.off
                };
            });
            handlers.push(result);

            // call resizeHandler to recalculate all events
            prevWinWidth = null;
            resizeHandler();
        }
    };
}(jQuery));

jQuery(function() {
    initVideo();
});

function initVideo() {
    jQuery('[data-video]').bgVideo();
}

/* video plugin */
;(function($) {
    'use strict';

    function BgVideo(options) {
        this.options = $.extend({
            containerClass: 'js-video',
            btnPlay: '.btn-play',
            btnPause: '.btn-pause',
            popupBtnClose: '<a href="#" class="close"></a>',
            loadedClass: 'video-loaded',
            playingClass: 'playing',
            pausedClass: 'paused',
            popupClass: 'js-video-popup',
            activePopupClass: 'active-popup',
            activePageClass: 'active-video-popup',
            fluidVideoClass: 'fluid-video',
            autoplayVideoClass: 'bg-video',
            vimeoAPI: '//player.vimeo.com/api/player.js',
            wistiaAPI: '//fast.wistia.com/assets/external/E-v1.js',
            youtubeAPI: '//www.youtube.com/iframe_api'
        }, options);

        this.init();
    }

    BgVideo.prototype = {
        init: function() {
            if (this.options.holder) {
                this.findElements();
                this.attachEvents();
                this.makeCallback('onInit', this);
            }
        },
        findElements: function() {
            this.win = $(window);
            this.page = $('body');
            this.holder = $(this.options.holder);
            this.videoContainer = null;
            this.player = null;
            this.videoData = this.holder.data('video');
            this.btnPlay = this.holder.find(this.options.btnPlay);
            this.btnPause = this.holder.find(this.options.btnPause);
            this.autoplay = this.videoData.autoplay === undefined ? true : this.videoData.autoplay;
            this.fluidWidth = this.videoData.fluidWidth === undefined ? false : this.videoData.fluidWidth;
            this.isPopup = this.holder.is('a');
            this.resizeTimer = null;

            if (this.isPopup) {
                this.popup = $('<div class="' + this.options.popupClass + '"/>').append($(this.options.popupBtnClose)).appendTo(this.page);
                this.holder = this.popup;
                this.btnOpen = $(this.options.holder);
                this.btnClose = this.popup.find('> a');
                this.autoplay = false;
            } else {
                if (this.autoplay) {
                    this.holder.addClass(this.options.autoplayVideoClass);
                }

                if (this.fluidWidth) {
                    this.holder.addClass(this.options.fluidVideoClass);
                }

                this.initPlayer();
            }
        },
        initPlayer: function() {
            switch (this.videoData.type) {
            case 'youtube':
                this.initYoutube();
                break;
            case 'vimeo':
                this.initVimeo();
                break;
            case 'wistia':
                this.initWistia();
                break;
            case 'html5':
                this.initHTML5();
                break;
            default:
                return false;
            }
        },
        attachEvents: function() {
            var self = this;

            this.playClickHandler = function(e) {
                e.preventDefault();
                self.playVideo();
            }
            ;

            this.pauseClickHandler = function(e) {
                e.preventDefault();
                self.pauseVideo();
            }
            ;

            this.openClickHandler = function(e) {
                e.preventDefault();
                self.showPopup();
            }
            ;

            this.closeClickHandler = function(e) {
                e.preventDefault();
                self.hidePopup();
            }
            ;

            this.resizeHandler = function() {
                if (self.videoContainer !== null && !self.fluidWidth) {
                    clearTimeout(self.resizeTimer);

                    self.resizeTimer = setTimeout(function() {
                        self.resizeVideo();
                    }, 200);
                }
            }
            ;

            this.holder.on('loaded.video', function() {
                self.resizeHandler();
                self.holder.addClass(self.options.loadedClass);
            }).on('playing.video', function() {
                self.pauseAllVideos();
                self.holder.addClass(self.options.playingClass).removeClass(self.options.pausedClass).trigger('playingVideo');
                self.makeCallback('playingVideo', self);
            }).on('paused.video', function() {
                self.holder.addClass(self.options.pausedClass).trigger('pauseVideo');
                self.makeCallback('pauseVideo', self);
            }).on('ended.video', function() {
                self.holder.removeClass(self.options.playingClass + ' ' + self.options.pausedClass).trigger('endedVideo');
                self.makeCallback('endedVideo', self);
            });

            if (this.isPopup) {
                this.btnOpen.on('click', this.openClickHandler);
                this.btnClose.on('click', this.closeClickHandler);
            }

            this.btnPlay.on('click', this.playClickHandler);
            this.btnPause.on('click', this.pauseClickHandler);
            this.resizeHandler();
            this.win.on('load resize orientationchange', this.resizeHandler);
        },
        initYoutube: function() {
            var self = this;
            var container = $('<div />').addClass(this.options.containerClass).appendTo(this.holder);

            var opt = {
                playlist: this.autoplay ? this.videoData.video : null,
                autoplay: this.autoplay || this.isPopup ? 1 : 0,
                loop: this.autoplay ? 1 : 0,
                controls: this.autoplay ? 0 : 1,
                showinfo: 0,
                modestbranding: 1,
                disablekb: 1,
                fs: this.autoplay ? 0 : 1,
                cc_load_policy: 0,
                iv_load_policy: 3
            };

            var loadPlayer = function() {
                var player = new YT.Player(container[0],{
                    videoId: self.videoData.video,
                    playerVars: opt,
                    events: {
                        onReady: function() {
                            if (self.autoplay) {
                                player.mute();
                            }

                            self.videoContainer = self.holder.find('iframe');
                            self.holder.trigger('loaded.video');

                            self.player = {
                                play: function() {
                                    player.playVideo();
                                },
                                pause: function() {
                                    player.pauseVideo();
                                }
                            };
                        },
                        onStateChange: function(state) {
                            switch (state.data) {
                            case 0:
                                self.holder.trigger('ended.video');
                                break;
                            case 1:
                                self.holder.trigger('playing.video');
                                break;
                            case 2:
                                self.holder.trigger('paused.video');
                                break;
                            default:
                                break;
                            }
                        }
                    }
                });
            };

            if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
                var youtubeReady = window.onYouTubeIframeAPIReady;

                window.onYouTubeIframeAPIReady = function() {
                    if (youtubeReady)
                        youtubeReady();
                    loadPlayer();
                }
                ;

                $.getScript(this.options.youtubeAPI);
            } else {
                loadPlayer();
            }
        },
        initVimeo: function() {
            var self = this;
            var blockId = this.getRandomId();

            var opt = {
                id: this.videoData.video,
                autoplay: this.autoplay || this.isPopup,
                autopause: this.autoplay ? false : true,
                muted: this.autoplay ? true : false,
                loop: this.autoplay ? true : false,
                controls: this.autoplay ? false : true,
                byline: this.autoplay ? false : true,
                title: this.autoplay ? false : true
            };

            var loadPlayer = function() {
                self.holder.attr('id', blockId);

                var player = new Vimeo.Player(blockId,opt);

                player.ready().then(function() {
                    self.videoContainer = self.holder.find('iframe').addClass(self.options.containerClass);

                    self.holder.trigger('loaded.video');

                    player.on('play', function() {
                        self.holder.trigger('playing.video');
                    });

                    player.on('pause', function() {
                        self.holder.trigger('paused.video');
                    });

                    player.on('ended', function() {
                        self.holder.trigger('ended.video');
                    });

                    self.player = {
                        play: function() {
                            player.play();
                        },
                        pause: function() {
                            player.pause();
                        }
                    };
                });
            };

            if (typeof Vimeo === 'undefined' || typeof Vimeo.Player === 'undefined') {
                $.getScript(this.options.vimeoAPI, loadPlayer);
            } else {
                loadPlayer();
            }
        },
        initWistia: function() {
            var self = this;
            var blockId = this.getRandomId();

            var opt = {
                autoplay: this.isPopup ? true : this.autoplay,
                loop: this.autoplay ? 'loop' : false,
                volume: this.autoplay ? 0 : 1,
                controls: this.autoplay ? false : true
            };

            var loadPlayer = function() {
                var src = '//fast.wistia.net/embed/iframe/' + self.videoData.video + '?controlsVisibleOnLoad=false&playbar=' + opt.controls + '&playButton=' + opt.controls + '&autoPlay=' + opt.autoplay + '&endVideoBehavior=' + opt.loop + '&fullscreenButton=' + opt.controls + '&smallPlayButton=false&volume=' + opt.volume + '&volumeControl=' + opt.controls;

                self.videoContainer = $('<iframe allowtransparency="true" id="' + blockId + '" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" />').addClass(self.options.containerClass).appendTo(self.holder).attr('src', src);

                window._wq = window._wq || [];

                _wq.push({
                    id: blockId,
                    onReady: function(video) {
                        self.holder.trigger('loaded.video');

                        self.player = {
                            play: function() {
                                video.play();
                            },
                            pause: function() {
                                video.pause();
                            },
                            mute: function() {
                                video.mute();
                                video.volume(0);
                            },
                            unmute: function() {
                                video.unmute();
                                video.volume(100);
                            }
                        };

                        video.bind('play', function() {
                            self.holder.trigger('playing.video');
                        }).bind('pause', function() {
                            self.holder.trigger('paused.video');
                        }).bind('end', function() {
                            self.holder.trigger('ended.video');
                        });
                    }
                });
            };

            if (typeof Wistia === 'undefined') {
                $.getScript(this.options.wistiaAPI, loadPlayer);
            } else {
                loadPlayer();
            }
        },
        initHTML5: function() {
            var self = this;

            var opt = {
                controls: this.autoplay ? '' : 'controls',
                autoplay: this.isPopup ? 'autoplay playsinline' : this.autoplay ? 'autoplay playsinline loop muted' : ''
            };

            this.videoContainer = $('<video ' + opt.controls + ' ' + opt.autoplay + ' />').addClass(this.options.containerClass).appendTo(this.holder);

            this.videoContainer[0].addEventListener('loadeddata', function() {
                self.holder.trigger('loaded.video');
            }, false);

            this.videoContainer[0].addEventListener('progress', function() {
                self.holder.trigger('loaded.video');
            }, false);

            this.videoContainer.prop('src', this.videoData.video);

            this.videoContainer.on('play', function() {
                self.holder.trigger('playing.video');
            }).on('pause', function() {
                self.holder.trigger('paused.video');
            }).on('ended', function() {
                self.holder.trigger('ended.video');
            });

            self.player = {
                play: function() {
                    self.videoContainer[0].play();
                },
                pause: function() {
                    self.videoContainer[0].pause();
                }
            };
        },
        pauseAllVideos: function() {
            if (this.autoplay && this.videoData.type === 'html5') {
                return;
            }

            $('[data-video].' + this.options.playingClass).not(this.holder).not('.' + this.options.autoplayVideoClass).each(function() {
                var holder = $(this);

                holder.data('BgVideo').player.pause();
            });
        },
        getDimensions: function(data) {
            var ratio = data.videoRatio || (data.videoWidth / data.videoHeight);
            var slideWidth = data.maskWidth;
            var slideHeight = slideWidth / ratio;

            if (slideHeight < data.maskHeight) {
                slideHeight = data.maskHeight;
                slideWidth = slideHeight * ratio;
            }

            return {
                width: slideWidth,
                height: slideHeight,
                top: (data.maskHeight - slideHeight) / 2,
                left: (data.maskWidth - slideWidth) / 2
            };
        },
        getRatio: function() {
            if (this.videoContainer.attr('width') && this.videoContainer.attr('height')) {
                return this.videoContainer.attr('width') / this.videoContainer.attr('height');
            } else {
                return 16 / 9;
            }
        },
        resizeVideo: function() {
            var styles = this.getDimensions({
                videoRatio: this.getRatio(this.videoContainer),
                maskWidth: this.holder.width(),
                maskHeight: this.holder.height()
            });

            this.videoContainer.css({
                width: styles.width,
                height: styles.height,
                marginTop: styles.top,
                marginLeft: styles.left
            });
        },
        playVideo: function() {
            if (!this.holder.hasClass(this.options.loadedClass))
                return;

            if (!this.holder.hasClass(this.options.playingClass) || this.holder.hasClass(this.options.pausedClass)) {
                this.player.play();
                this.holder.blur();
            } else {
                if (!this.btnPause.length) {
                    this.player.pause();
                }
            }
        },
        pauseVideo: function() {
            this.player.pause();
        },
        showPopup: function() {
            var self = this;

            if (this.holder.hasClass(this.options.loadedClass)) {
                setTimeout(function() {
                    self.player.play();
                }, 500);
            } else {
                this.initPlayer();
            }

            this.page.addClass(this.options.activePageClass);
            this.popup.addClass(this.options.activePopupClass);
        },
        hidePopup: function() {
            this.player.pause();
            this.page.removeClass(this.options.activePageClass);
            this.popup.removeClass(this.options.activePopupClass);
        },
        getRandomId: function() {
            var s4 = function() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };

            return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4());
        },
        makeCallback: function(name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);

                args.shift();
                this.options[name].apply(this, args);
            }
        },
        destroy: function() {
            this.videoContainer.remove();
            this.btnPlay.off('click', this.playClickHandler);
            this.btnPause.off('click', this.pauseClickHandler);
            this.win.off('load resize orientationchange', this.resizeHandler);

            if (this.isPopup) {
                this.popup.remove();
                this.btnOpen.off('click', this.openClickHandler);
                this.btnClose.off('click', this.closeClickHandler);
            }

            this.holder.removeClass(this.options.loadedClass + ' ' + this.options.playingClass).off('.video').removeData('BgVideo');
        }
    };

    $.fn.bgVideo = function(opt) {
        return this.each(function() {
            $(this).data('BgVideo', new BgVideo($.extend(opt, {
                holder: this
            })));
        });
    }
    ;
}
)(jQuery);

/*
 * jQuery video background plugin
*/
;(function($, $win) {
    var BgVideoController = (function() {
        var videos = [];

        return {
            init: function() {
                $win.on('load.bgVideo resize.bgVideo orientationchange.bgVideo', this.resizeHandler.bind(this));
            },

            resizeHandler: function() {
                if (this.isInit) {
                    $.each(videos, this.resizeVideo.bind(this));
                }
            },

            buildPoster: function($video, $holder) {
                $holder.css({
                    'background-image': 'url(' + $video.attr('poster') + ')',
                    'background-repeat': 'no-repeat',
                    'background-size': 'cover'
                });
            },

            resizeVideo: function(i) {
                var item = videos[i];
                var styles = this.getDimensions({
                    videoRatio: item.ratio,
                    maskWidth: item.$holder.outerWidth(),
                    maskHeight: item.$holder.outerHeight()
                });

                item.$video.css({
                    width: styles.width,
                    height: styles.height,
                    marginTop: styles.top,
                    marginLeft: styles.left
                });
            },

            getRatio: function($video) {
                return $video[0].videoWidth / $video[0].videoHeight || $video.attr('width') / $video.attr('height') || $video.width() / $video.height();
            },

            getDimensions: function(data) {
                var ratio = data.videoRatio
                  , slideWidth = data.maskWidth
                  , slideHeight = slideWidth / ratio;

                if (slideHeight < data.maskHeight) {
                    slideHeight = data.maskHeight;
                    slideWidth = slideHeight * ratio;
                }
                return {
                    width: slideWidth,
                    height: slideHeight,
                    top: (data.maskHeight - slideHeight) / 2,
                    left: (data.maskWidth - slideWidth) / 2
                };
            },

            add: function($video, options) {
                var $holder = options.videoHolder ? $video.closest(options.videoHolder) : $video.parent();
                var item = {
                    $video: $video,
                    $holder: $holder,
                    options: options
                };

                if ($video.attr('poster')) {
                    this.buildPoster($video, $holder);
                }

                if ($video[0].readyState) {
                    this.onVideoReady(item);
                    if ($video[0].paused) {
                        $video[0].play();
                    } else {
                        $holder.addClass(options.activeClass);
                    }
                } else {
                    $video.one('loadedmetadata', function() {
                        if ($video[0].paused) {
                            $video[0].play();
                        } else {
                            $holder.addClass(options.activeClass);
                        }
                        this.onVideoReady(item);
                    }
                    .bind(this));
                }

                $video.one('play', function() {
                    $holder.addClass(options.activeClass);
                    this.makeCallback.apply($.extend(true, {}, this, item), ['onPlay']);
                }
                .bind(this));

                this.makeCallback.apply($.extend(true, {}, this, item), ['onInit']);
                return this;
            },

            onVideoReady: function(item) {
                if (!this.isInit) {
                    this.isInit = true;
                    this.init();
                }
                videos.push($.extend(item, {
                    ratio: this.getRatio(item.$video)
                }));
                this.resizeVideo(videos.length - 1);
            },

            destroy: function($video) {
                if (!$video) {
                    videos = videos.filter(this.destroySingle);
                } else {
                    videos = videos.filter(function(item) {
                        var removeFlag = item.$video.is($video);

                        removeFlag && this.destroySingle(item);

                        return !removeFlag;
                    }
                    .bind(this));
                }

                if (!videos.length) {
                    this.isInit = false;
                    $win.off('.bgVideo');
                }
            },

            destroySingle: function(item) {
                item.$video.removeAttr('style').removeData('BackgroundVideo')[0].pause();
                item.$holder.removeClass(item.options.activeClass);
            },

            makeCallback: function(name) {
                if (typeof this.options[name] === 'function') {
                    var args = Array.prototype.slice.call(arguments);
                    args.shift();
                    this.options[name].apply(this, args);
                }
            }
        };
    }());

    $.fn.backgroundVideo = function(opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];
        var options = $.extend({
            activeClass: 'video-active',
            videoHolder: null
        }, opt);

        return this.each(function() {
            var $video = jQuery(this);
            var instance = $video.data('BackgroundVideo');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $video.data('BackgroundVideo', BgVideoController.add($video, options));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    }
    ;

    window.BgVideoController = BgVideoController;

    return BgVideoController;
}(jQuery, jQuery(window)));

/* video plugin */
;(function($) {
    'use strict';

    function BgVideo(options) {
        this.options = $.extend({
            containerClass: 'js-video',
            btnPlay: '.btn-play',
            btnPause: '.btn-pause',
            popupBtnClose: '<a href="#" class="close"></a>',
            loadedClass: 'video-loaded',
            playingClass: 'playing',
            pausedClass: 'paused',
            popupClass: 'js-video-popup',
            activePopupClass: 'active-popup',
            activePageClass: 'active-video-popup',
            fluidVideoClass: 'fluid-video',
            autoplayVideoClass: 'bg-video',
            vimeoAPI: '//player.vimeo.com/api/player.js',
            wistiaAPI: '//fast.wistia.com/assets/external/E-v1.js',
            youtubeAPI: '//www.youtube.com/iframe_api'
        }, options);

        this.init();
    }

    BgVideo.prototype = {
        init: function() {
            if (this.options.holder) {
                this.findElements();
                this.attachEvents();
                this.makeCallback('onInit', this);
            }
        },
        findElements: function() {
            this.win = $(window);
            this.page = $('body');
            this.holder = $(this.options.holder);
            this.videoContainer = null;
            this.player = null;
            this.videoData = this.holder.data('video');
            this.btnPlay = this.holder.find(this.options.btnPlay);
            this.btnPause = this.holder.find(this.options.btnPause);
            this.autoplay = this.videoData.autoplay === undefined ? true : this.videoData.autoplay;
            this.fluidWidth = this.videoData.fluidWidth === undefined ? false : this.videoData.fluidWidth;
            this.isPopup = this.holder.is('a');
            this.resizeTimer = null;

            if (this.isPopup) {
                this.popup = $('<div class="' + this.options.popupClass + '"/>').append($(this.options.popupBtnClose)).appendTo(this.page);
                this.holder = this.popup;
                this.btnOpen = $(this.options.holder);
                this.btnClose = this.popup.find('> a');
                this.autoplay = false;
            } else {
                if (this.autoplay) {
                    this.holder.addClass(this.options.autoplayVideoClass);
                }

                if (this.fluidWidth) {
                    this.holder.addClass(this.options.fluidVideoClass);
                }

                this.initPlayer();
            }
        },
        initPlayer: function() {
            switch (this.videoData.type) {
            case 'youtube':
                this.initYoutube();
                break;
            case 'vimeo':
                this.initVimeo();
                break;
            case 'wistia':
                this.initWistia();
                break;
            case 'html5':
                this.initHTML5();
                break;
            default:
                return false;
            }
        },
        attachEvents: function() {
            var self = this;

            this.playClickHandler = function(e) {
                e.preventDefault();
                self.playVideo();
            }
            ;

            this.pauseClickHandler = function(e) {
                e.preventDefault();
                self.pauseVideo();
            }
            ;

            this.openClickHandler = function(e) {
                e.preventDefault();
                self.showPopup();
            }
            ;

            this.closeClickHandler = function(e) {
                e.preventDefault();
                self.hidePopup();
            }
            ;

            this.resizeHandler = function() {
                if (self.videoContainer !== null && !self.fluidWidth) {
                    clearTimeout(self.resizeTimer);

                    self.resizeTimer = setTimeout(function() {
                        self.resizeVideo();
                    }, 200);
                }
            }
            ;

            this.holder.on('loaded.video', function() {
                self.resizeHandler();
                self.holder.addClass(self.options.loadedClass);
            }).on('playing.video', function() {
                self.pauseAllVideos();
                self.holder.addClass(self.options.playingClass).removeClass(self.options.pausedClass).trigger('playingVideo');
                self.makeCallback('playingVideo', self);
            }).on('paused.video', function() {
                self.holder.addClass(self.options.pausedClass).trigger('pauseVideo');
                self.makeCallback('pauseVideo', self);
            }).on('ended.video', function() {
                self.holder.removeClass(self.options.playingClass + ' ' + self.options.pausedClass).trigger('endedVideo');
                self.makeCallback('endedVideo', self);
            });

            if (this.isPopup) {
                this.btnOpen.on('click', this.openClickHandler);
                this.btnClose.on('click', this.closeClickHandler);
            }

            this.btnPlay.on('click', this.playClickHandler);
            this.btnPause.on('click', this.pauseClickHandler);
            this.resizeHandler();
            this.win.on('load resize orientationchange', this.resizeHandler);
        },
        initYoutube: function() {
            var self = this;
            var container = $('<div />').addClass(this.options.containerClass).appendTo(this.holder);

            var opt = {
                playlist: this.autoplay ? this.videoData.video : null,
                autoplay: this.autoplay || this.isPopup ? 1 : 0,
                loop: this.autoplay ? 1 : 0,
                controls: this.autoplay ? 0 : 1,
                showinfo: 0,
                modestbranding: 1,
                disablekb: 1,
                fs: this.autoplay ? 0 : 1,
                cc_load_policy: 0,
                iv_load_policy: 3
            };

            var loadPlayer = function() {
                var player = new YT.Player(container[0],{
                    videoId: self.videoData.video,
                    playerVars: opt,
                    events: {
                        onReady: function() {
                            if (self.autoplay) {
                                player.mute();
                            }

                            self.videoContainer = self.holder.find('iframe');
                            self.holder.trigger('loaded.video');

                            self.player = {
                                play: function() {
                                    player.playVideo();
                                },
                                pause: function() {
                                    player.pauseVideo();
                                }
                            };
                        },
                        onStateChange: function(state) {
                            switch (state.data) {
                            case 0:
                                self.holder.trigger('ended.video');
                                break;
                            case 1:
                                self.holder.trigger('playing.video');
                                break;
                            case 2:
                                self.holder.trigger('paused.video');
                                break;
                            default:
                                break;
                            }
                        }
                    }
                });
            };

            if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
                var youtubeReady = window.onYouTubeIframeAPIReady;

                window.onYouTubeIframeAPIReady = function() {
                    if (youtubeReady)
                        youtubeReady();
                    loadPlayer();
                }
                ;

                $.getScript(this.options.youtubeAPI);
            } else {
                loadPlayer();
            }
        },
        initVimeo: function() {
            var self = this;
            var blockId = this.getRandomId();

            var opt = {
                id: this.videoData.video,
                autoplay: this.autoplay || this.isPopup,
                autopause: this.autoplay ? false : true,
                muted: this.autoplay ? true : false,
                loop: this.autoplay ? true : false,
                controls: this.autoplay ? false : true,
                byline: this.autoplay ? false : true,
                title: this.autoplay ? false : true
            };

            var loadPlayer = function() {
                self.holder.attr('id', blockId);

                var player = new Vimeo.Player(blockId,opt);

                player.ready().then(function() {
                    self.videoContainer = self.holder.find('iframe').addClass(self.options.containerClass);

                    self.holder.trigger('loaded.video');

                    player.on('play', function() {
                        self.holder.trigger('playing.video');
                    });

                    player.on('pause', function() {
                        self.holder.trigger('paused.video');
                    });

                    player.on('ended', function() {
                        self.holder.trigger('ended.video');
                    });

                    self.player = {
                        play: function() {
                            player.play();
                        },
                        pause: function() {
                            player.pause();
                        }
                    };
                });
            };

            if (typeof Vimeo === 'undefined' || typeof Vimeo.Player === 'undefined') {
                $.getScript(this.options.vimeoAPI, loadPlayer);
            } else {
                loadPlayer();
            }
        },
        initWistia: function() {
            var self = this;
            var blockId = this.getRandomId();

            var opt = {
                autoplay: this.isPopup ? true : this.autoplay,
                loop: this.autoplay ? 'loop' : false,
                volume: this.autoplay ? 0 : 1,
                controls: this.autoplay ? false : true
            };

            var loadPlayer = function() {
                var src = '//fast.wistia.net/embed/iframe/' + self.videoData.video + '?controlsVisibleOnLoad=false&playbar=' + opt.controls + '&playButton=' + opt.controls + '&autoPlay=' + opt.autoplay + '&endVideoBehavior=' + opt.loop + '&fullscreenButton=' + opt.controls + '&smallPlayButton=false&volume=' + opt.volume + '&volumeControl=' + opt.controls;

                self.videoContainer = $('<iframe allowtransparency="true" id="' + blockId + '" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" />').addClass(self.options.containerClass).appendTo(self.holder).attr('src', src);

                window._wq = window._wq || [];

                _wq.push({
                    id: blockId,
                    onReady: function(video) {
                        self.holder.trigger('loaded.video');

                        self.player = {
                            play: function() {
                                video.play();
                            },
                            pause: function() {
                                video.pause();
                            },
                            mute: function() {
                                video.mute();
                                video.volume(0);
                            },
                            unmute: function() {
                                video.unmute();
                                video.volume(100);
                            }
                        };

                        video.bind('play', function() {
                            self.holder.trigger('playing.video');
                        }).bind('pause', function() {
                            self.holder.trigger('paused.video');
                        }).bind('end', function() {
                            self.holder.trigger('ended.video');
                        });
                    }
                });
            };

            if (typeof Wistia === 'undefined') {
                $.getScript(this.options.wistiaAPI, loadPlayer);
            } else {
                loadPlayer();
            }
        },
        initHTML5: function() {
            var self = this;

            var opt = {
                controls: this.autoplay ? '' : 'controls',
                autoplay: this.isPopup ? 'autoplay playsinline' : this.autoplay ? 'autoplay playsinline loop muted' : ''
            };

            this.videoContainer = $('<video ' + opt.controls + ' ' + opt.autoplay + ' />').addClass(this.options.containerClass).appendTo(this.holder);

            this.videoContainer[0].addEventListener('loadeddata', function() {
                self.holder.trigger('loaded.video');
            }, false);

            this.videoContainer[0].addEventListener('progress', function() {
                self.holder.trigger('loaded.video');
            }, false);

            this.videoContainer.prop('src', this.videoData.video);

            this.videoContainer.on('play', function() {
                self.holder.trigger('playing.video');
            }).on('pause', function() {
                self.holder.trigger('paused.video');
            }).on('ended', function() {
                self.holder.trigger('ended.video');
            });

            self.player = {
                play: function() {
                    self.videoContainer[0].play();
                },
                pause: function() {
                    self.videoContainer[0].pause();
                }
            };
        },
        pauseAllVideos: function() {
            if (this.autoplay && this.videoData.type === 'html5') {
                return;
            }

            $('[data-video].' + this.options.playingClass).not(this.holder).not('.' + this.options.autoplayVideoClass).each(function() {
                var holder = $(this);

                holder.data('BgVideo').player.pause();
            });
        },
        getDimensions: function(data) {
            var ratio = data.videoRatio || (data.videoWidth / data.videoHeight);
            var slideWidth = data.maskWidth;
            var slideHeight = slideWidth / ratio;

            if (slideHeight < data.maskHeight) {
                slideHeight = data.maskHeight;
                slideWidth = slideHeight * ratio;
            }

            return {
                width: slideWidth,
                height: slideHeight,
                top: (data.maskHeight - slideHeight) / 2,
                left: (data.maskWidth - slideWidth) / 2
            };
        },
        getRatio: function() {
            if (this.videoContainer.attr('width') && this.videoContainer.attr('height')) {
                return this.videoContainer.attr('width') / this.videoContainer.attr('height');
            } else {
                return 16 / 9;
            }
        },
        resizeVideo: function() {
            var styles = this.getDimensions({
                videoRatio: this.getRatio(this.videoContainer),
                maskWidth: this.holder.width(),
                maskHeight: this.holder.height()
            });

            this.videoContainer.css({
                width: styles.width,
                height: styles.height,
                marginTop: styles.top,
                marginLeft: styles.left
            });
        },
        playVideo: function() {
            if (!this.holder.hasClass(this.options.loadedClass))
                return;

            if (!this.holder.hasClass(this.options.playingClass) || this.holder.hasClass(this.options.pausedClass)) {
                this.player.play();
                this.holder.blur();
            } else {
                if (!this.btnPause.length) {
                    this.player.pause();
                }
            }
        },
        pauseVideo: function() {
            this.player.pause();
        },
        showPopup: function() {
            var self = this;

            if (this.holder.hasClass(this.options.loadedClass)) {
                setTimeout(function() {
                    self.player.play();
                }, 500);
            } else {
                this.initPlayer();
            }

            this.page.addClass(this.options.activePageClass);
            this.popup.addClass(this.options.activePopupClass);
        },
        hidePopup: function() {
            this.player.pause();
            this.page.removeClass(this.options.activePageClass);
            this.popup.removeClass(this.options.activePopupClass);
        },
        getRandomId: function() {
            var s4 = function() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };

            return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4());
        },
        makeCallback: function(name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);

                args.shift();
                this.options[name].apply(this, args);
            }
        },
        destroy: function() {
            this.videoContainer.remove();
            this.btnPlay.off('click', this.playClickHandler);
            this.btnPause.off('click', this.pauseClickHandler);
            this.win.off('load resize orientationchange', this.resizeHandler);

            if (this.isPopup) {
                this.popup.remove();
                this.btnOpen.off('click', this.openClickHandler);
                this.btnClose.off('click', this.closeClickHandler);
            }

            this.holder.removeClass(this.options.loadedClass + ' ' + this.options.playingClass).off('.video').removeData('BgVideo');
        }
    };

    $.fn.bgVideo = function(opt) {
        return this.each(function() {
            $(this).data('BgVideo', new BgVideo($.extend(opt, {
                holder: this
            })));
        });
    }
    ;
}
)(jQuery);

/*!
 * lazysizes.min.js
 */
/*! lazysizes - v4.1.8 */
!function(a, b) {
    var c = function(d) {
        b(a.lazySizes, d),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("src/scripts/plugins/lazysizes.min")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c, d) {
    "use strict";
    function e(a) {
        var b = getComputedStyle(a, null) || {}
          , c = b.fontFamily || ""
          , d = c.match(j) || ""
          , e = d && c.match(k) || "";
        return e && (e = e[1]),
        {
            fit: d && d[1] || "",
            position: n[e] || e || "center"
        }
    }
    function f(a, b) {
        var d, e, f = c.cfg, g = a.cloneNode(!1), h = g.style, i = function() {
            var b = a.currentSrc || a.src;
            b && e !== b && (e = b,
            h.backgroundImage = "url(" + (m.test(b) ? JSON.stringify(b) : b) + ")",
            d || (d = !0,
            c.rC(g, f.loadingClass),
            c.aC(g, f.loadedClass)))
        }, j = function() {
            c.rAF(i)
        };
        a._lazysizesParentFit = b.fit,
        a.addEventListener("lazyloaded", j, !0),
        a.addEventListener("load", j, !0),
        g.addEventListener("load", function() {
            var a = g.currentSrc || g.src;
            a && a != l && (g.src = l,
            g.srcset = "")
        }),
        c.rAF(function() {
            var d = a
              , e = a.parentNode;
            "PICTURE" == e.nodeName.toUpperCase() && (d = e,
            e = e.parentNode),
            c.rC(g, f.loadedClass),
            c.rC(g, f.lazyClass),
            c.aC(g, f.loadingClass),
            c.aC(g, f.objectFitClass || "lazysizes-display-clone"),
            g.getAttribute(f.srcsetAttr) && g.setAttribute(f.srcsetAttr, ""),
            g.getAttribute(f.srcAttr) && g.setAttribute(f.srcAttr, ""),
            g.src = l,
            g.srcset = "",
            h.backgroundRepeat = "no-repeat",
            h.backgroundPosition = b.position,
            h.backgroundSize = b.fit,
            d.style.display = "none",
            a.setAttribute("data-parent-fit", b.fit),
            a.setAttribute("data-parent-container", "prev"),
            e.insertBefore(g, d),
            a._lazysizesParentFit && delete a._lazysizesParentFit,
            a.complete && i()
        })
    }
    var g = b.createElement("a").style
      , h = "objectFit"in g
      , i = h && "objectPosition"in g
      , j = /object-fit["']*\s*:\s*["']*(contain|cover)/
      , k = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/
      , l = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      , m = /\(|\)|'/
      , n = {
        center: "center",
        "50% 50%": "center"
    };
    if (!h || !i) {
        var o = function(a) {
            if (a.detail.instance == c) {
                var b = a.target
                  , d = e(b);
                !d.fit || h && "center" == d.position || f(b, d)
            }
        };
        a.addEventListener("lazyunveilread", o, !0),
        d && d.detail && o(d)
    }
});
/*! lazysizes - v4.1.8 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("src/scripts/plugins/lazysizes.min")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    function d(b, c) {
        var d, e, f, g, h = a.getComputedStyle(b);
        e = b.parentNode,
        g = {
            isPicture: !(!e || !m.test(e.nodeName || ""))
        },
        f = function(a, c) {
            var d = b.getAttribute("data-" + a);
            if (!d) {
                var e = h.getPropertyValue("--ls-" + a);
                e && (d = e.trim())
            }
            if (d) {
                if ("true" == d)
                    d = !0;
                else if ("false" == d)
                    d = !1;
                else if (l.test(d))
                    d = parseFloat(d);
                else if ("function" == typeof j[a])
                    d = j[a](b, d);
                else if (q.test(d))
                    try {
                        d = JSON.parse(d)
                    } catch (a) {}
                g[a] = d
            } else
                a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d))
        }
        ;
        for (d in j)
            f(d);
        return c.replace(p, function(a, b) {
            b in g || f(b, !0)
        }),
        g
    }
    function e(a, b) {
        var c = []
          , d = function(a, c) {
            return k[typeof b[c]] ? b[c] : a
        };
        return c.srcset = [],
        b.absUrl && (s.setAttribute("href", a),
        a = s.href),
        a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d),
        b.widths.forEach(function(d) {
            var e = b.widthmap[d] || d
              , f = b.aspectratio || b.ratio
              , g = !b.aspectratio && j.traditionalRatio
              , h = {
                u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""),
                w: d
            };
            c.push(h),
            c.srcset.push(h.c = h.u + " " + d + "w")
        }),
        c
    }
    function f(a, c, d) {
        var f = 0
          , g = 0
          , h = d;
        if (a) {
            if ("container" === c.ratio) {
                for (f = h.scrollWidth,
                g = h.scrollHeight; !(f && g || h === b); )
                    h = h.parentNode,
                    f = h.scrollWidth,
                    g = h.scrollHeight;
                f && g && (c.ratio = g / f)
            }
            a = e(a, c),
            a.isPicture = c.isPicture,
            u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")),
            Object.defineProperty(d, "_lazyrias", {
                value: a,
                writable: !0
            })
        }
    }
    function g(a, b) {
        var e = d(a, b);
        return j.modifyOptions.call(a, {
            target: a,
            details: e,
            detail: e
        }),
        c.fire(a, "lazyriasmodifyoptions", e),
        e
    }
    function h(a) {
        return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || ""
    }
    var i, j, k = {
        string: 1,
        number: 1
    }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset"in t && !("sizes"in t), v = !!a.HTMLPictureElement && !u;
    !function() {
        var b, d = function() {}, e = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: !1,
            modifyOptions: d,
            widthmap: {},
            ratio: !1,
            traditionalRatio: !1,
            aspectratio: !1
        };
        i = c && c.cfg || a.lazySizesConfig,
        i || (i = {},
        a.lazySizesConfig = i),
        i.supportsType || (i.supportsType = function(a) {
            return !a
        }
        ),
        i.rias || (i.rias = {}),
        "widths"in (j = i.rias) || (j.widths = [],
        function(a) {
            for (var b, c = 0; !b || b < 3e3; )
                c += 5,
                c > 30 && (c += 1),
                b = 36 * c,
                a.push(b)
        }(j.widths));
        for (b in e)
            b in j || (j[b] = e[b])
    }(),
    addEventListener("lazybeforesizes", function(a) {
        if (a.detail.instance == c) {
            var b, d, e, k, l, m, o, p, q, s, t, u, x;
            if (b = a.target,
            a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) {
                if (d = h(b),
                e = g(b, d),
                t = n.test(e.prefix) || n.test(e.postfix),
                e.isPicture && (k = b.parentNode))
                    for (l = k.getElementsByTagName("source"),
                    m = 0,
                    o = l.length; m < o; m++)
                        (t || n.test(p = h(l[m]))) && (f(p, e, l[m]),
                        u = !0);
                t || n.test(d) ? (f(d, e, b),
                u = !0) : u && (x = [],
                x.srcset = [],
                x.isPicture = !0,
                Object.defineProperty(b, "_lazyrias", {
                    value: x,
                    writable: !0
                })),
                u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = {
                    width: parseInt(q, 10)
                },
                w({
                    target: b,
                    detail: s
                })))
            }
        }
    }, !0);
    var w = function() {
        var d = function(a, b) {
            return a.w - b.w
        }
          , e = function(a) {
            var b, c, d = a.length, e = a[d - 1], f = 0;
            for (f; f < d; f++)
                if (e = a[f],
                e.d = e.w / a.w,
                e.d >= a.d) {
                    !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6),
                    b.cached && (b.d += .15 * c),
                    b.d + (e.d - a.d) * c > a.d && (e = b));
                    break
                }
            return e
        }
          , f = function(a, b) {
            var d;
            return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", {
                value: d,
                writable: !0
            }),
            b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())),
            a._lazyrias
        }
          , g = function(b) {
            var d = a.devicePixelRatio || 1
              , e = c.getX && c.getX(b);
            return Math.min(e || d, 2.4, d)
        }
          , h = function(b, c) {
            var h, i, j, k, l, m;
            if (l = b._lazyrias,
            l.isPicture && a.matchMedia)
                for (i = 0,
                h = b.parentNode.getElementsByTagName("source"),
                j = h.length; i < j; i++)
                    if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) {
                        l = h[i]._lazyrias;
                        break
                    }
            return (!l.w || l.w < c) && (l.w = c,
            l.d = g(b),
            m = e(l.sort(d))),
            m
        }
          , j = function(d) {
            if (d.detail.instance == c) {
                var e, g = d.target;
                if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf))
                    return void b.removeEventListener("lazybeforesizes", j);
                ("_lazyrias"in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u,
                e.cached = !0,
                c.rAF(function() {
                    g.setAttribute(i.srcAttr, e.u),
                    g.setAttribute("src", e.u)
                }))
            }
        };
        return v ? j = function() {}
        : addEventListener("lazybeforesizes", j),
        j
    }()
});
/*! lazysizes - v4.1.8 */
!function(a, b) {
    var c = b(a, a.document);
    a.lazySizes = c,
    "object" == typeof module && module.exports && (module.exports = c)
}(window, function(a, b) {
    "use strict";
    if (b.getElementsByClassName) {
        var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function(a, b) {
            return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")),
            p[b].test(a[i]("class") || "") && p[b]
        }, s = function(a, b) {
            r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b)
        }, t = function(a, b) {
            var c;
            (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "))
        }, u = function(a, b, c) {
            var d = c ? h : "removeEventListener";
            c && u(a, b),
            o.forEach(function(c) {
                a[d](c, b)
            })
        }, v = function(a, d, e, f, g) {
            var h = b.createEvent("Event");
            return e || (e = {}),
            e.instance = c,
            h.initEvent(d, !f, !g),
            h.detail = e,
            a.dispatchEvent(h),
            h
        }, w = function(b, c) {
            var e;
            !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src),
            e({
                reevaluate: !0,
                elements: [b]
            })) : c && c.src && (b.src = c.src)
        }, x = function(a, b) {
            return (getComputedStyle(a, null) || {})[b]
        }, y = function(a, b, c) {
            for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; )
                c = b.offsetWidth,
                b = b.parentNode;
            return c
        }, z = function() {
            var a, c, d = [], e = [], f = d, g = function() {
                var b = f;
                for (f = d.length ? e : d,
                a = !0,
                c = !1; b.length; )
                    b.shift()();
                a = !1
            }, h = function(d, e) {
                a && !e ? d.apply(this, arguments) : (f.push(d),
                c || (c = !0,
                (b.hidden ? k : l)(g)))
            };
            return h._lsFlush = g,
            h
        }(), A = function(a, b) {
            return b ? function() {
                z(a)
            }
            : function() {
                var b = this
                  , c = arguments;
                z(function() {
                    a.apply(b, c)
                })
            }
        }, B = function(a) {
            var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function() {
                b = !1,
                c = f.now(),
                a()
            }, i = m && g > 49 ? function() {
                m(h, {
                    timeout: g
                }),
                g !== d.ricTimeout && (g = d.ricTimeout)
            }
            : A(function() {
                k(h)
            }, !0);
            return function(a) {
                var d;
                (a = !0 === a) && (g = 33),
                b || (b = !0,
                d = e - (f.now() - c),
                d < 0 && (d = 0),
                a || d < 9 ? i() : k(i, d))
            }
        }, C = function(a) {
            var b, c, d = 99, e = function() {
                b = null,
                a()
            }, g = function() {
                var a = f.now() - c;
                a < d ? k(g, d - a) : (m || e)(e)
            };
            return function() {
                c = f.now(),
                b || (b = k(g, d))
            }
        };
        !function() {
            var b, c = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 0,
                throttleDelay: 125
            };
            d = a.lazySizesConfig || a.lazysizesConfig || {};
            for (b in c)
                b in d || (d[b] = c[b]);
            a.lazySizesConfig = d,
            k(function() {
                d.init && F()
            })
        }();
        var D = function() {
            var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll"in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function(a) {
                P--,
                (!a || P < 0 || !a.target) && (P = 0)
            }, S = function(a) {
                return null == J && (J = "hidden" == x(b.body, "visibility")),
                J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility")
            }, T = function(a, c) {
                var d, f = a, g = S(a);
                for (F -= c,
                I += c,
                G -= c,
                H += c; g && (f = f.offsetParent) && f != b.body && f != e; )
                    (g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(),
                    g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
                return g
            }, U = function() {
                var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements;
                if ((o = d.loadMode) && P < 8 && (a = u.length)) {
                    for (f = 0,
                    Q++; f < a; f++)
                        if (u[f] && !u[f]._lazyRace)
                            if (!M || c.prematureUnveil && c.prematureUnveil(u[f]))
                                aa(u[f]);
                            else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O),
                            r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand,
                            c._defEx = r,
                            s = r * d.expFactor,
                            t = d.hFac,
                            J = null,
                            O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s,
                            Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N),
                            q !== m && (y = innerWidth + m * t,
                            D = innerHeight + m,
                            n = -1 * m,
                            q = m),
                            h = u[f].getBoundingClientRect(),
                            (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) {
                                if (aa(u[f]),
                                k = !0,
                                P > 9)
                                    break
                            } else
                                !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]);
                    j && !k && aa(j)
                }
            }, V = B(U), W = function(a) {
                var b = a.target;
                if (b._lazyCache)
                    return void delete b._lazyCache;
                R(a),
                s(b, d.loadedClass),
                t(b, d.loadingClass),
                u(b, Y),
                v(b, "lazyloaded")
            }, X = A(W), Y = function(a) {
                X({
                    target: a.target
                })
            }, Z = function(a, b) {
                try {
                    a.contentWindow.location.replace(b)
                } catch (c) {
                    a.src = b
                }
            }, $ = function(a) {
                var b, c = a[i](d.srcsetAttr);
                (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b),
                c && a.setAttribute("srcset", c)
            }, _ = A(function(a, b, c, e, f) {
                var g, h, j, l, o, p;
                (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)),
                h = a[i](d.srcsetAttr),
                g = a[i](d.srcAttr),
                f && (j = a.parentNode,
                l = j && n.test(j.nodeName || "")),
                p = b.firesLoad || "src"in a && (h || g || l),
                o = {
                    target: a
                },
                s(a, d.loadingClass),
                p && (clearTimeout(m),
                m = k(R, 2500),
                u(a, Y, !0)),
                l && q.call(j.getElementsByTagName("source"), $),
                h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g),
                f && (h || l) && w(a, {
                    src: g
                })),
                a._lazyRace && delete a._lazyRace,
                t(a, d.lazyClass),
                z(function() {
                    var b = a.complete && a.naturalWidth > 1;
                    p && !b || (b && s(a, "ls-is-cached"),
                    W(o),
                    a._lazyCache = !0,
                    k(function() {
                        "_lazyCache"in a && delete a._lazyCache
                    }, 9)),
                    "lazy" == a.loading && P--
                }, !0)
            }), aa = function(a) {
                if (!a._lazyRace) {
                    var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e;
                    (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail,
                    f && E.updateElem(a, !0, a.offsetWidth),
                    a._lazyRace = !0,
                    P++,
                    _(a, b, f, e, c))
                }
            }, ba = C(function() {
                d.loadMode = 3,
                V()
            }), ca = function() {
                3 == d.loadMode && (d.loadMode = 2),
                ba()
            }, da = function() {
                if (!l) {
                    if (f.now() - p < 999)
                        return void k(da, 999);
                    l = !0,
                    d.loadMode = 3,
                    V(),
                    j("scroll", ca, !0)
                }
            };
            return {
                _: function() {
                    p = f.now(),
                    c.elements = b.getElementsByClassName(d.lazyClass),
                    g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass),
                    j("scroll", V, !0),
                    j("resize", V, !0),
                    a.MutationObserver ? new MutationObserver(V).observe(e, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (e[h]("DOMNodeInserted", V, !0),
                    e[h]("DOMAttrModified", V, !0),
                    setInterval(V, 999)),
                    j("hashchange", V, !0),
                    ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(a) {
                        b[h](a, V, !0)
                    }),
                    /d$|^c/.test(b.readyState) ? da() : (j("load", da),
                    b[h]("DOMContentLoaded", V),
                    k(da, 2e4)),
                    c.elements.length ? (U(),
                    z._lsFlush()) : V()
                },
                checkElems: V,
                unveil: aa,
                _aLSL: ca
            }
        }()
          , E = function() {
            var a, c = A(function(a, b, c, d) {
                var e, f, g;
                if (a._lazysizesWidth = d,
                d += "px",
                a.setAttribute("sizes", d),
                n.test(b.nodeName || ""))
                    for (e = b.getElementsByTagName("source"),
                    f = 0,
                    g = e.length; f < g; f++)
                        e[f].setAttribute("sizes", d);
                c.detail.dataAttr || w(a, c.detail)
            }), e = function(a, b, d) {
                var e, f = a.parentNode;
                f && (d = y(a, f, d),
                e = v(a, "lazybeforesizes", {
                    width: d,
                    dataAttr: !!b
                }),
                e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d))
            }, f = function() {
                var b, c = a.length;
                if (c)
                    for (b = 0; b < c; b++)
                        e(a[b])
            }, g = C(f);
            return {
                _: function() {
                    a = b.getElementsByClassName(d.autosizesClass),
                    j("resize", g)
                },
                checkElems: g,
                updateElem: e
            }
        }()
          , F = function() {
            F.i || (F.i = !0,
            E._(),
            D._())
        };
        return c = {
            cfg: d,
            autoSizer: E,
            loader: D,
            init: F,
            uP: w,
            aC: s,
            rC: t,
            hC: r,
            fire: v,
            gW: y,
            rAF: z
        }
    }
});
/*! lazysizes - v4.1.8 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("src/scripts/plugins/lazysizes.min")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    if (a.addEventListener) {
        var d = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , e = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/
          , f = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/
          , g = /^picture$/i
          , h = function(a) {
            return getComputedStyle(a, null) || {}
        }
          , i = {
            getParent: function(b, c) {
                var d = b
                  , e = b.parentNode;
                return c && "prev" != c || !e || !g.test(e.nodeName || "") || (e = e.parentNode),
                "self" != c && (d = "prev" == c ? b.previousElementSibling : c && (e.closest || a.jQuery) ? (e.closest ? e.closest(c) : jQuery(e).closest(c)[0]) || e : e),
                d
            },
            getFit: function(a) {
                var b, c, d = h(a), g = d.content || d.fontFamily, j = {
                    fit: a._lazysizesParentFit || a.getAttribute("data-parent-fit")
                };
                return !j.fit && g && (b = g.match(e)) && (j.fit = b[1]),
                j.fit ? (c = a._lazysizesParentContainer || a.getAttribute("data-parent-container"),
                !c && g && (b = g.match(f)) && (c = b[1]),
                j.parent = i.getParent(a, c)) : j.fit = d.objectFit,
                j
            },
            getImageRatio: function(b) {
                var c, e, f, h, i, j, k, l = b.parentNode, m = l && g.test(l.nodeName || "") ? l.querySelectorAll("source, img") : [b];
                for (c = 0; c < m.length; c++)
                    if (b = m[c],
                    e = b.getAttribute(lazySizesConfig.srcsetAttr) || b.getAttribute("srcset") || b.getAttribute("data-pfsrcset") || b.getAttribute("data-risrcset") || "",
                    f = b._lsMedia || b.getAttribute("media"),
                    f = lazySizesConfig.customMedia[b.getAttribute("data-media") || f] || f,
                    e && (!f || (a.matchMedia && matchMedia(f) || {}).matches)) {
                        h = parseFloat(b.getAttribute("data-aspectratio")),
                        h || (i = e.match(d),
                        i ? "w" == i[2] ? (j = i[1],
                        k = i[3]) : (j = i[3],
                        k = i[1]) : (j = b.getAttribute("width"),
                        k = b.getAttribute("height")),
                        h = j / k);
                        break
                    }
                return h
            },
            calculateSize: function(a, b) {
                var c, d, e, f, g = this.getFit(a), h = g.fit, i = g.parent;
                return "width" == h || ("contain" == h || "cover" == h) && (e = this.getImageRatio(a)) ? (i ? b = i.clientWidth : i = a,
                f = b,
                "width" == h ? f = b : (d = i.clientHeight) > 40 && (c = b / d) && ("cover" == h && c < e || "contain" == h && c > e) && (f = b * (e / c)),
                f) : b
            }
        };
        c.parentFit = i,
        b.addEventListener("lazybeforesizes", function(a) {
            if (!a.defaultPrevented && a.detail.instance == c) {
                var b = a.target;
                a.detail.width = i.calculateSize(b, a.detail.width)
            }
        })
    }
});
/*! lazysizes - v4.1.8 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("src/scripts/plugins/lazysizes.min")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    var d, e = c && c.cfg, f = b.createElement("img"), g = "sizes"in f && "srcset"in f, h = /\s+\d+h/g, i = function() {
        var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , d = Array.prototype.forEach;
        return function() {
            var e = b.createElement("img")
              , f = function(b) {
                var c, d, e = b.getAttribute(lazySizesConfig.srcsetAttr);
                e && (d = e.match(a)) && (c = "w" == d[2] ? d[1] / d[3] : d[3] / d[1],
                c && b.setAttribute("data-aspectratio", c),
                b.setAttribute(lazySizesConfig.srcsetAttr, e.replace(h, "")))
            }
              , g = function(a) {
                if (a.detail.instance == c) {
                    var b = a.target.parentNode;
                    b && "PICTURE" == b.nodeName && d.call(b.getElementsByTagName("source"), f),
                    f(a.target)
                }
            }
              , i = function() {
                e.currentSrc && b.removeEventListener("lazybeforeunveil", g)
            };
            b.addEventListener("lazybeforeunveil", g),
            e.onload = i,
            e.onerror = i,
            e.srcset = "data:,a 1w 1h",
            e.complete && i()
        }
    }();
    if (e.supportsType || (e.supportsType = function(a) {
        return !a
    }
    ),
    a.HTMLPictureElement && g)
        return void (!c.hasHDescriptorFix && b.msElementsFromPoint && (c.hasHDescriptorFix = !0,
        i()));
    a.picturefill || e.pf || (e.pf = function(b) {
        var c, e;
        if (!a.picturefill)
            for (c = 0,
            e = b.elements.length; c < e; c++)
                d(b.elements[c])
    }
    ,
    d = function() {
        var f = function(a, b) {
            return a.w - b.w
        }
          , i = /^\s*\d+\.*\d*px\s*$/
          , j = function(a) {
            var b, c, d = a.length, e = a[d - 1], f = 0;
            for (f; f < d; f++)
                if (e = a[f],
                e.d = e.w / a.w,
                e.d >= a.d) {
                    !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6),
                    b.cached && (b.d += .15 * c),
                    b.d + (e.d - a.d) * c > a.d && (e = b));
                    break
                }
            return e
        }
          , k = function() {
            var a, b = /(([^,\s].[^\s]+)\s+(\d+)w)/g, c = /\s/, d = function(b, c, d, e) {
                a.push({
                    c: c,
                    u: d,
                    w: 1 * e
                })
            };
            return function(e) {
                return a = [],
                e = e.trim(),
                e.replace(h, "").replace(b, d),
                a.length || !e || c.test(e) || a.push({
                    c: e,
                    u: e,
                    w: 99
                }),
                a
            }
        }()
          , l = function() {
            l.init || (l.init = !0,
            addEventListener("resize", function() {
                var a, c = b.getElementsByClassName("lazymatchmedia"), e = function() {
                    var a, b;
                    for (a = 0,
                    b = c.length; a < b; a++)
                        d(c[a])
                };
                return function() {
                    clearTimeout(a),
                    a = setTimeout(e, 66)
                }
            }()))
        }
          , m = function(b, d) {
            var f, g = b.getAttribute("srcset") || b.getAttribute(e.srcsetAttr);
            !g && d && (g = b._lazypolyfill ? b._lazypolyfill._set : b.getAttribute(e.srcAttr) || b.getAttribute("src")),
            b._lazypolyfill && b._lazypolyfill._set == g || (f = k(g || ""),
            d && b.parentNode && (f.isPicture = "PICTURE" == b.parentNode.nodeName.toUpperCase(),
            f.isPicture && a.matchMedia && (c.aC(b, "lazymatchmedia"),
            l())),
            f._set = g,
            Object.defineProperty(b, "_lazypolyfill", {
                value: f,
                writable: !0
            }))
        }
          , n = function(b) {
            var d = a.devicePixelRatio || 1
              , e = c.getX && c.getX(b);
            return Math.min(e || d, 2.5, d)
        }
          , o = function(b) {
            return a.matchMedia ? (o = function(a) {
                return !a || (matchMedia(a) || {}).matches
            }
            )(b) : !b
        }
          , p = function(a) {
            var b, d, g, h, k, l, p;
            if (h = a,
            m(h, !0),
            k = h._lazypolyfill,
            k.isPicture)
                for (d = 0,
                b = a.parentNode.getElementsByTagName("source"),
                g = b.length; d < g; d++)
                    if (e.supportsType(b[d].getAttribute("type"), a) && o(b[d].getAttribute("media"))) {
                        h = b[d],
                        m(h),
                        k = h._lazypolyfill;
                        break
                    }
            return k.length > 1 ? (p = h.getAttribute("sizes") || "",
            p = i.test(p) && parseInt(p, 10) || c.gW(a, a.parentNode),
            k.d = n(a),
            !k.src || !k.w || k.w < p ? (k.w = p,
            l = j(k.sort(f)),
            k.src = l) : l = k.src) : l = k[0],
            l
        }
          , q = function(a) {
            if (!g || !a.parentNode || "PICTURE" == a.parentNode.nodeName.toUpperCase()) {
                var b = p(a);
                b && b.u && a._lazypolyfill.cur != b.u && (a._lazypolyfill.cur = b.u,
                b.cached = !0,
                a.setAttribute(e.srcAttr, b.u),
                a.setAttribute("src", b.u))
            }
        };
        return q.parse = k,
        q
    }(),
    e.loadedClass && e.loadingClass && function() {
        var a = [];
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(b) {
            a.push(b + e.loadedClass),
            a.push(b + e.loadingClass)
        }),
        e.pf({
            elements: b.querySelectorAll(a.join(", "))
        })
    }())
});
/*! lazysizes - v4.1.8 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("src/scripts/plugins/lazysizes.min")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    if (a.addEventListener) {
        var d = /\s+/g
          , e = /\s*\|\s+|\s+\|\s*/g
          , f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/
          , g = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/
          , h = /\(|\)|'/
          , i = {
            contain: 1,
            cover: 1
        }
          , j = function(a) {
            var b = c.gW(a, a.parentNode);
            return (!a._lazysizesWidth || b > a._lazysizesWidth) && (a._lazysizesWidth = b),
            a._lazysizesWidth
        }
          , k = function(a) {
            var b;
            return b = (getComputedStyle(a) || {
                getPropertyValue: function() {}
            }).getPropertyValue("background-size"),
            !i[b] && i[a.style.backgroundSize] && (b = a.style.backgroundSize),
            b
        }
          , l = function(a, b) {
            if (b) {
                var c = b.match(g);
                c && c[1] ? a.setAttribute("type", c[1]) : a.setAttribute("media", lazySizesConfig.customMedia[b] || b)
            }
        }
          , m = function(a, c, g) {
            var h = b.createElement("picture")
              , i = c.getAttribute(lazySizesConfig.sizesAttr)
              , j = c.getAttribute("data-ratio")
              , k = c.getAttribute("data-optimumx");
            c._lazybgset && c._lazybgset.parentNode == c && c.removeChild(c._lazybgset),
            Object.defineProperty(g, "_lazybgset", {
                value: c,
                writable: !0
            }),
            Object.defineProperty(c, "_lazybgset", {
                value: h,
                writable: !0
            }),
            a = a.replace(d, " ").split(e),
            h.style.display = "none",
            g.className = lazySizesConfig.lazyClass,
            1 != a.length || i || (i = "auto"),
            a.forEach(function(a) {
                var c, d = b.createElement("source");
                i && "auto" != i && d.setAttribute("sizes", i),
                (c = a.match(f)) ? (d.setAttribute(lazySizesConfig.srcsetAttr, c[1]),
                l(d, c[2]),
                l(d, c[3])) : d.setAttribute(lazySizesConfig.srcsetAttr, a),
                h.appendChild(d)
            }),
            i && (g.setAttribute(lazySizesConfig.sizesAttr, i),
            c.removeAttribute(lazySizesConfig.sizesAttr),
            c.removeAttribute("sizes")),
            k && g.setAttribute("data-optimumx", k),
            j && g.setAttribute("data-ratio", j),
            h.appendChild(g),
            c.appendChild(h)
        }
          , n = function(a) {
            if (a.target._lazybgset) {
                var b = a.target
                  , d = b._lazybgset
                  , e = b.currentSrc || b.src;
                if (e) {
                    var f = c.fire(d, "bgsetproxy", {
                        src: e,
                        useSrc: h.test(e) ? JSON.stringify(e) : e
                    });
                    f.defaultPrevented || (d.style.backgroundImage = "url(" + f.detail.useSrc + ")")
                }
                b._lazybgsetLoading && (c.fire(d, "_lazyloaded", {}, !1, !0),
                delete b._lazybgsetLoading)
            }
        };
        addEventListener("lazybeforeunveil", function(a) {
            var d, e, f;
            !a.defaultPrevented && (d = a.target.getAttribute("data-bgset")) && (f = a.target,
            e = b.createElement("img"),
            e.alt = "",
            e._lazybgsetLoading = !0,
            a.detail.firesLoad = !0,
            m(d, f, e),
            setTimeout(function() {
                c.loader.unveil(e),
                c.rAF(function() {
                    c.fire(e, "_lazyloaded", {}, !0, !0),
                    e.complete && n({
                        target: e
                    })
                })
            }))
        }),
        b.addEventListener("load", n, !0),
        a.addEventListener("lazybeforesizes", function(a) {
            if (a.detail.instance == c && a.target._lazybgset && a.detail.dataAttr) {
                var b = a.target._lazybgset
                  , d = k(b);
                i[d] && (a.target._lazysizesParentFit = d,
                c.rAF(function() {
                    a.target.setAttribute("data-parent-fit", d),
                    a.target._lazysizesParentFit && delete a.target._lazysizesParentFit
                }))
            }
        }, !0),
        b.documentElement.addEventListener("lazybeforesizes", function(a) {
            !a.defaultPrevented && a.target._lazybgset && a.detail.instance == c && (a.detail.width = j(a.target._lazybgset))
        })
    }
});

/*! lazysizes - v5.2.2 */
//!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,a=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,l=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],i={},G=Array.prototype.forEach,J=function(e,t){if(!i[t]){i[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return i[t].test(e[$]("class")||"")&&i[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var i;if(i=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(i," "))}},V=function(t,i,e){var a=e?P:"removeEventListener";if(e){V(t,i)}r.forEach(function(e){t[a](e,i)})},X=function(e,t,i,a,r){var n=D.createEvent("Event");if(!i){i={}}i.instance=k;n.initEvent(t,!a,!r);n.detail=i;e.dispatchEvent(n);return n},Y=function(e,t){var i;if(!a&&(i=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}i({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,i){i=i||e.offsetWidth;while(i<H.minSize&&t&&!e._lazysizesWidth){i=t.offsetWidth;t=t.parentNode}return i},ee=function(){var i,a;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;i=true;a=false;while(e.length){e.shift()()}i=false};var e=function(e,t){if(i&&!t){e.apply(this,arguments)}else{n.push(e);if(!a){a=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(i,e){return e?function(){ee(i)}:function(){var e=this;var t=arguments;ee(function(){i.apply(e,t)})}},ie=function(e){var i;var a=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){i=false;a=f.now();e()};var s=l&&n>49?function(){l(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(i){return}i=true;t=r-(f.now()-a);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ae=function(e){var t,i;var a=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-i;if(e<a){I(n,a-e)}else{(l||r)(r)}};return function(){i=f.now();if(!t){t=I(n,a)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var N=0;var M=-1;var x=function(e){N--;if(!e||N<0||!e.target){N=0}};var W=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var S=function(e,t){var i;var a=e;var r=W(e);g-=t;b+=t;p-=t;C+=t;while(r&&(a=a.offsetParent)&&a!=D.body&&a!=O){r=(Z(a,"opacity")||1)>0;if(r&&Z(a,"overflow")!="visible"){i=a.getBoundingClientRect();r=C>i.left&&p<i.right&&b>i.top-1&&g<i.bottom+1}}return r};var t=function(){var e,t,i,a,r,n,s,l,o,u,f,c;var d=k.elements;if((h=H.loadMode)&&N<8&&(e=d.length)){t=0;M++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(l=d[t][$]("data-expand"))||!(n=l*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&N<1&&M>2&&h>2&&!D.hidden){w=f;M=0}else if(h>1&&M>1&&N<6){w=u}else{w=_}}if(o!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;o=n}i=d[t].getBoundingClientRect();if((b=i.bottom)>=s&&(g=i.top)<=z&&(C=i.right)>=s*c&&(p=i.left)<=y&&(b||C||p||g)&&(H.loadHidden||W(d[t]))&&(m&&N<3&&!l&&(h<3||M<4)||S(d[t],n))){R(d[t]);r=true;if(N>9){break}}else if(!r&&m&&!a&&N<4&&M<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!l&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){a=v[0]||d[t]}}if(a&&!r){R(a)}}};var i=ie(t);var B=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}x(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,L);X(t,"lazyloaded")};var a=te(B);var L=function(e){a({target:e.target})};var T=function(t,i){try{t.contentWindow.location.replace(i)}catch(e){t.src=i}};var F=function(e){var t;var i=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(i){e.setAttribute("srcset",i)}};var s=te(function(t,e,i,a,r){var n,s,l,o,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(a){if(i){K(t,H.autosizesClass)}else{t.setAttribute("sizes",a)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){l=t.parentNode;o=l&&j.test(l.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||o);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(x,2500);V(t,L,true)}if(o){G.call(l.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!o){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||o)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,"ls-is-cached")}B(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){N--}},true)});var R=function(e){if(e._lazyRace){return}var t;var i=n.test(e.nodeName);var a=i&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=a=="auto";if((r||!m)&&i&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;N++;s(e,t,r,a,i)};var r=ae(function(){H.loadMode=3;i()});var l=function(){if(H.loadMode==3){H.loadMode=2}r()};var o=function(){if(m){return}if(f.now()-e<999){I(o,999);return}m=true;H.loadMode=3;i();q("scroll",l,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",i,true);q("resize",i,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(i).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",i,true);O[P]("DOMAttrModified",i,true);setInterval(i,999)}q("hashchange",i,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,i,true)});if(/d$|^c/.test(D.readyState)){o()}else{q("load",o);D[P]("DOMContentLoaded",i);I(o,2e4)}if(k.elements.length){t();ee._lsFlush()}else{i()}},checkElems:i,unveil:R,_aLSL:l}}(),re=function(){var i;var n=te(function(e,t,i,a){var r,n,s;e._lazysizesWidth=a;a+="px";e.setAttribute("sizes",a);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",a)}}if(!i.detail.dataAttr){Y(e,i.detail)}});var a=function(e,t,i){var a;var r=e.parentNode;if(r){i=s(e,r,i);a=X(e,"lazybeforesizes",{width:i,dataAttr:!!t});if(!a.defaultPrevented){i=a.detail.width;if(i&&i!==e._lazysizesWidth){n(e,r,a,i)}}}};var e=function(){var e;var t=i.length;if(t){e=0;for(;e<t;e++){a(i[e])}}};var t=ae(e);return{_:function(){i=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:a}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});
/*! lazysizes bgset - v5.2.2 */
//!function(e,t){var a=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",a,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],t):e.lazySizes?a():e.addEventListener("lazyunveilread",a,!0)}(window,function(e,z,g){"use strict";var c,y,b,f,i,s,n,v,m;e.addEventListener&&(c=g.cfg,y=/\s+/g,b=/\s*\|\s+|\s+\|\s*/g,f=/^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,i=/^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,s=/\(|\)|'/,n={contain:1,cover:1},v=function(e,t){var a;t&&((a=t.match(i))&&a[1]?e.setAttribute("type",a[1]):e.setAttribute("media",c.customMedia[t]||t))},m=function(e){var t,a,i,r;e.target._lazybgset&&(a=(t=e.target)._lazybgset,(i=t.currentSrc||t.src)&&((r=g.fire(a,"bgsetproxy",{src:i,useSrc:s.test(i)?JSON.stringify(i):i})).defaultPrevented||(a.style.backgroundImage="url("+r.detail.useSrc+")")),t._lazybgsetLoading&&(g.fire(a,"_lazyloaded",{},!1,!0),delete t._lazybgsetLoading))},addEventListener("lazybeforeunveil",function(e){var t,a,i,r,s,n,l,d,o,u;!e.defaultPrevented&&(t=e.target.getAttribute("data-bgset"))&&(o=e.target,(u=z.createElement("img")).alt="",u._lazybgsetLoading=!0,e.detail.firesLoad=!0,a=t,i=o,r=u,s=z.createElement("picture"),n=i.getAttribute(c.sizesAttr),l=i.getAttribute("data-ratio"),d=i.getAttribute("data-optimumx"),i._lazybgset&&i._lazybgset.parentNode==i&&i.removeChild(i._lazybgset),Object.defineProperty(r,"_lazybgset",{value:i,writable:!0}),Object.defineProperty(i,"_lazybgset",{value:s,writable:!0}),a=a.replace(y," ").split(b),s.style.display="none",r.className=c.lazyClass,1!=a.length||n||(n="auto"),a.forEach(function(e){var t,a=z.createElement("source");n&&"auto"!=n&&a.setAttribute("sizes",n),(t=e.match(f))?(a.setAttribute(c.srcsetAttr,t[1]),v(a,t[2]),v(a,t[3])):a.setAttribute(c.srcsetAttr,e),s.appendChild(a)}),n&&(r.setAttribute(c.sizesAttr,n),i.removeAttribute(c.sizesAttr),i.removeAttribute("sizes")),d&&r.setAttribute("data-optimumx",d),l&&r.setAttribute("data-ratio",l),s.appendChild(r),i.appendChild(s),setTimeout(function(){g.loader.unveil(u),g.rAF(function(){g.fire(u,"_lazyloaded",{},!0,!0),u.complete&&m({target:u})})}))}),z.addEventListener("load",m,!0),e.addEventListener("lazybeforesizes",function(e){var t,a,i,r;e.detail.instance==g&&e.target._lazybgset&&e.detail.dataAttr&&(t=e.target._lazybgset,i=t,r=(getComputedStyle(i)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!n[r]&&n[i.style.backgroundSize]&&(r=i.style.backgroundSize),n[a=r]&&(e.target._lazysizesParentFit=a,g.rAF(function(){e.target.setAttribute("data-parent-fit",a),e.target._lazysizesParentFit&&delete e.target._lazysizesParentFit})))},!0),z.documentElement.addEventListener("lazybeforesizes",function(e){var t,a;!e.defaultPrevented&&e.target._lazybgset&&e.detail.instance==g&&(e.detail.width=(t=e.target._lazybgset,a=g.gW(t,t.parentNode),(!t._lazysizesWidth||a>t._lazysizesWidth)&&(t._lazysizesWidth=a),t._lazysizesWidth))}))});
/*! lazysizes artdirect - v5.2.2 */
//!function(e,t){var i;e&&(i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)},t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],t):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0))}("undefined"!=typeof window?window:0,function(o,e,u){"use strict";var d,t,l,f,m,h,p,s;function g(e){return'source[data-tag~="'+e+'"]'}function n(e){var t,i,a,r,s,n,c=e.getAttribute("media");return{source:e,aspectRatio:(t=e,s=parseFloat(t.getAttribute("data-aspectratio")),n=t.getAttribute(d.srcsetAttr)||t.getAttribute("srcset"),s||(r=(i=n.match(f))?"w"==i[2]?(a=i[1],i[3]):(a=i[3],i[1]):(a=t.getAttribute("width"),t.getAttribute("height")),s=a/r),s),isSelected:!c||o.matchMedia(c).matches}}function c(e,t){return e.aspectRatio<t.aspectRatio}function y(e,t){e._lsMedia=t,u.rAF(function(){e._lsMedia&&delete e._lsMedia,e.setAttribute("media",t)})}function b(t){var e,i=(e=t.img).offsetWidth/e.offsetHeight,a=s.call(t.picture.getElementsByTagName("source")).map(n).sort(c),r=function(e,t){for(var i=e[0],a=1,r=e.length;a<r;a++)Math.abs(i.aspectRatio-t)>Math.abs(e[a].aspectRatio-t)&&(i=e[a]);return i}(t.selector?a.filter(function(e){return e.source.matches(t.selector)}):a,i);r.isSelected||y(r.source,"(min-width: 1px)"),a.filter(function(e){return e!=r&&e.isSelected}).forEach(function(e){y(e.source,"(x)")})}o.addEventListener&&(d=u.cfg,t=(o.Element||Node||o.HTMLElement).prototype,l=/artdirect/,f=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,m=/artdirect["']*\s*:\s*["']*(.+?)(?=($|'|"|;))/,h=/^picture$/i,p=/[\s,]+/g,s=[].slice,t.matches||(t.matches=t.matchesSelector||t.webkitMatchesSelector||t.msMatchesSelector||t.oMatchesSelector),o.addEventListener("lazybeforesizes",function(e){var t,i,a,r,s,n,c;e.detail.instance==u&&(t=e.target,r=(a=t).parentNode,s=h.test(r.nodeName||""),n=(o.getComputedStyle(a)||{}).fontFamily,c=null,s&&(d.autoArtDirect||l.test(n||""))&&(c={picture:r,img:a,tags:n.match(m)}).tags&&(c.selector=c.tags[1].split(p).map(g).join(",")),(i=c)&&b(i))},!0))});
/*! lazysizes aspectratio - v5.2.2 */
//!function(e,t){var i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],t):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(o,r,e){"use strict";var s,t,i,n,d,c,a,u,f,l,m,h,p;function g(){this.ratioElems=r.getElementsByClassName("lazyaspectratio"),this._setupEvents(),this.processImages()}o.addEventListener&&(s=Array.prototype.forEach,d=/^picture$/i,a="img["+(c="data-aspectratio")+"]",u=function(e){return o.matchMedia?(u=function(e){return!e||(matchMedia(e)||{}).matches})(e):o.Modernizr&&Modernizr.mq?!e||Modernizr.mq(e):!e},f=e.aC,l=e.rC,m=e.cfg,g.prototype={_setupEvents:function(){function t(e){e.naturalWidth<36?n.addAspectRatio(e,!0):n.removeAspectRatio(e,!0)}function e(){n.processImages()}var i,n=this;function a(){s.call(n.ratioElems,t)}r.addEventListener("load",function(e){e.target.getAttribute&&e.target.getAttribute(c)&&t(e.target)},!0),addEventListener("resize",function(){clearTimeout(i),i=setTimeout(a,99)}),r.addEventListener("DOMContentLoaded",e),addEventListener("load",e)},processImages:function(e){for(var t=("length"in(e=e||r)&&!e.nodeName?e:e.querySelectorAll(a)),i=0;i<t.length;i++)36<t[i].naturalWidth?this.removeAspectRatio(t[i]):this.addAspectRatio(t[i])},getSelectedRatio:function(e){var t,i,n,a,o,r=e.parentNode;if(r&&d.test(r.nodeName||""))for(t=0,i=(n=r.getElementsByTagName("source")).length;t<i;t++)if(a=n[t].getAttribute("data-media")||n[t].getAttribute("media"),m.customMedia[a]&&(a=m.customMedia[a]),u(a)){o=n[t].getAttribute(c);break}return o||e.getAttribute(c)||""},parseRatio:(h=/^\s*([+\d\.]+)(\s*[\/x]\s*([+\d\.]+))?\s*$/,p={},function(e){var t;return!p[e]&&(t=e.match(h))&&(t[3]?p[e]=t[1]/t[3]:p[e]=+t[1]),p[e]}),addAspectRatio:function(e,t){var i,n=e.offsetWidth,a=e.offsetHeight;t||f(e,"lazyaspectratio"),n<36&&a<=0?(n||a&&o.console)&&console.log("Define width or height of image, so we can calculate the other dimension"):(i=this.getSelectedRatio(e),(i=this.parseRatio(i))&&(n?e.style.height=n/i+"px":e.style.width=a*i+"px"))},removeAspectRatio:function(e){l(e,"lazyaspectratio"),e.style.height="",e.style.width="",e.removeAttribute(c)}},(i=function(){(n=o.jQuery||o.Zepto||o.shoestring||o.$)&&n.fn&&!n.fn.imageRatio&&n.fn.filter&&n.fn.add&&n.fn.find?n.fn.imageRatio=function(){return t.processImages(this.find(a).add(this.filter(a))),this}:n=!1})(),setTimeout(i),t=new g,o.imageRatio=t,"object"==typeof module&&module.exports?module.exports=t:"function"==typeof define&&define.amd&&define(t))});
/*! lazysizes progressive - v5.2.2 */
//!function(e,t){var n=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",n,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],t):e.lazySizes?n():e.addEventListener("lazyunveilread",n,!0)}(window,function(e,t,i){"use strict";var r,a;"srcset"in t.createElement("img")&&(r=/^img$/i,a=function(e){e.target.style.backgroundSize="",e.target.style.backgroundImage="",e.target.removeEventListener(e.type,a)},t.addEventListener("lazybeforeunveil",function(e){var t,n;e.detail.instance==i&&(t=e.target,!r.test(t.nodeName)||(n=t.getAttribute("src"))&&(t.style.backgroundSize="100% 100%",t.style.backgroundImage="url("+n+")",t.removeAttribute("src"),t.addEventListener("load",a)))},!1))});
/*! lazysizes object-fit - v5.2.2 */
//!function(e,i){var a;e&&(a=function(t){i(e.lazySizes,t),e.removeEventListener("lazyunveilread",a,!0)},i=i.bind(null,e,e.document),"object"==typeof module&&module.exports?i(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],i):e.lazySizes?a():e.addEventListener("lazyunveilread",a,!0))}("undefined"!=typeof window?window:0,function(t,u,f,e){"use strict";var y,i,a=u.createElement("a").style,r="objectFit"in a,s=/object-fit["']*\s*:\s*["']*(contain|cover)/,l=/object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,A="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",n=/\(|\)|'/,d={center:"center","50% 50%":"center"};function c(o,r){function s(){var t=o.currentSrc||o.src;t&&i!==t&&(i=t,d.backgroundImage="url("+(n.test(t)?JSON.stringify(t):t)+")",e||(e=!0,f.rC(l,c.loadingClass),f.aC(l,c.loadedClass)))}function t(){f.rAF(s)}var e,i,l,d,c=f.cfg;o._lazysizesParentFit=r.fit,o.addEventListener("lazyloaded",t,!0),o.addEventListener("load",t,!0),f.rAF(function(){var t,e,i,a=o,n=o.parentNode;"PICTURE"==n.nodeName.toUpperCase()&&(n=(a=n).parentNode),(e=(t=a).previousElementSibling)&&f.hC(e,y)&&(e.parentNode.removeChild(e),t.style.position=e.getAttribute("data-position")||"",t.style.visibility=e.getAttribute("data-visibility")||""),y||y||(i=u.createElement("style"),y=f.cfg.objectFitClass||"lazysizes-display-clone",u.querySelector("head").appendChild(i)),l=o.cloneNode(!1),d=l.style,l.addEventListener("load",function(){var t=l.currentSrc||l.src;t&&t!=A&&(l.src=A,l.srcset="")}),f.rC(l,c.loadedClass),f.rC(l,c.lazyClass),f.rC(l,c.autosizesClass),f.aC(l,c.loadingClass),f.aC(l,y),["data-parent-fit","data-parent-container","data-object-fit-polyfilled",c.srcsetAttr,c.srcAttr].forEach(function(t){l.removeAttribute(t)}),l.src=A,l.srcset="",d.backgroundRepeat="no-repeat",d.backgroundPosition=r.position,d.backgroundSize=r.fit,l.setAttribute("data-position",a.style.position),l.setAttribute("data-visibility",a.style.visibility),a.style.visibility="hidden",a.style.position="absolute",o.setAttribute("data-parent-fit",r.fit),o.setAttribute("data-parent-container","prev"),o.setAttribute("data-object-fit-polyfilled",""),o._objectFitPolyfilledDisplay=l,n.insertBefore(l,a),o._lazysizesParentFit&&delete o._lazysizesParentFit,o.complete&&s()})}r&&(r&&"objectPosition"in a)||(i=function(t){if(t.detail.instance==f){var e,i,a,n=t.target,o=(e=(getComputedStyle(n,null)||{}).fontFamily||"",i=e.match(s)||"",a=(a=i&&e.match(l)||"")&&a[1],{fit:i&&i[1]||"",position:d[a]||a||"center"});return!(!o.fit||r&&"center"==o.position)&&(c(n,o),!0)}},t.addEventListener("lazybeforesizes",function(t){var e;t.detail.instance==f&&(null==(e=t.target).getAttribute("data-object-fit-polyfilled")||e._objectFitPolyfilledDisplay||i(t)||f.rAF(function(){e.removeAttribute("data-object-fit-polyfilled")}))}),t.addEventListener("lazyunveilread",i,!0),e&&e.detail&&i(e))});

/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function(factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD (Register as an anonymous module)
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($) {

    var pluses = /\+/g;

    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }

    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }

    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }

    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            // This is a quoted cookie as according to RFC2068, unescape...
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }

        try {
            // Replace server-side written pluses with spaces.
            // If we can't decode the cookie, ignore it, it's unusable.
            // If we can't parse the cookie, ignore it, it's unusable.
            s = decodeURIComponent(s.replace(pluses, ' '));
            return config.json ? JSON.parse(s) : s;
        } catch (e) {}
    }

    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }

    var config = $.cookie = function(key, value, options) {

        // Write

        if (arguments.length > 1 && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);

            if (typeof options.expires === 'number') {
                var days = options.expires
                  , t = options.expires = new Date();
                t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
            }

            return (document.cookie = [encode(key), '=', stringifyCookieValue(value), options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
            options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join(''));
        }

        // Read

        var result = key ? undefined : {}
          , // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all. Also prevents odd result when
        // calling $.cookie().
        cookies = document.cookie ? document.cookie.split('; ') : []
          , i = 0
          , l = cookies.length;

        for (; i < l; i++) {
            var parts = cookies[i].split('=')
              , name = decode(parts.shift())
              , cookie = parts.join('=');

            if (key === name) {
                // If second argument (value) is a function it's a converter...
                result = read(cookie, value);
                break;
            }

            // Prevent storing a cookie that we couldn't decode.
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }

        return result;
    }
    ;

    config.defaults = {};

    $.removeCookie = function(key, options) {
        // Must not alter options, thus extending a fresh object...
        $.cookie(key, '', $.extend({}, options, {
            expires: -1
        }));
        return !$.cookie(key);
    }
    ;

}));

!function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.inView = e() : t.inView = e()
}(this, function() {
    return function(t) {
        function e(r) {
            if (n[r])
                return n[r].exports;
            var i = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return t[r].call(i.exports, i, i.exports, e),
            i.loaded = !0,
            i.exports
        }
        var n = {};
        return e.m = t,
        e.c = n,
        e.p = "",
        e(0)
    }([function(t, e, n) {
        "use strict";
        function r(t) {
            return t && t.__esModule ? t : {
                "default": t
            }
        }
        var i = n(2)
          , o = r(i);
        t.exports = o["default"]
    }
    , function(t, e) {
        function n(t) {
            var e = typeof t;
            return null != t && ("object" == e || "function" == e)
        }
        t.exports = n
    }
    , function(t, e, n) {
        "use strict";
        function r(t) {
            return t && t.__esModule ? t : {
                "default": t
            }
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var i = n(9)
          , o = r(i)
          , u = n(3)
          , f = r(u)
          , s = n(4)
          , c = function() {
            if ("undefined" != typeof window) {
                var t = 100
                  , e = ["scroll", "resize", "load"]
                  , n = {
                    history: []
                }
                  , r = {
                    offset: {},
                    threshold: 0,
                    test: s.inViewport
                }
                  , i = (0,
                o["default"])(function() {
                    n.history.forEach(function(t) {
                        n[t].check()
                    })
                }, t);
                e.forEach(function(t) {
                    return addEventListener(t, i)
                }),
                window.MutationObserver && addEventListener("DOMContentLoaded", function() {
                    new MutationObserver(i).observe(document.body, {
                        attributes: !0,
                        childList: !0,
                        subtree: !0
                    })
                });
                var u = function(t) {
                    if ("string" == typeof t) {
                        var e = [].slice.call(document.querySelectorAll(t));
                        return n.history.indexOf(t) > -1 ? n[t].elements = e : (n[t] = (0,
                        f["default"])(e, r),
                        n.history.push(t)),
                        n[t]
                    }
                };
                return u.offset = function(t) {
                    if (void 0 === t)
                        return r.offset;
                    var e = function(t) {
                        return "number" == typeof t
                    };
                    return ["top", "right", "bottom", "left"].forEach(e(t) ? function(e) {
                        return r.offset[e] = t
                    }
                    : function(n) {
                        return e(t[n]) ? r.offset[n] = t[n] : null
                    }
                    ),
                    r.offset
                }
                ,
                u.threshold = function(t) {
                    return "number" == typeof t && t >= 0 && t <= 1 ? r.threshold = t : r.threshold
                }
                ,
                u.test = function(t) {
                    return "function" == typeof t ? r.test = t : r.test
                }
                ,
                u.is = function(t) {
                    return r.test(t, r)
                }
                ,
                u.offset(0),
                u
            }
        };
        e["default"] = c()
    }
    , function(t, e) {
        "use strict";
        function n(t, e) {
            if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function")
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var r = function() {
            function t(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var r = e[n];
                    r.enumerable = r.enumerable || !1,
                    r.configurable = !0,
                    "value"in r && (r.writable = !0),
                    Object.defineProperty(t, r.key, r)
                }
            }
            return function(e, n, r) {
                return n && t(e.prototype, n),
                r && t(e, r),
                e
            }
        }()
          , i = function() {
            function t(e, r) {
                n(this, t),
                this.options = r,
                this.elements = e,
                this.current = [],
                this.handlers = {
                    enter: [],
                    exit: []
                },
                this.singles = {
                    enter: [],
                    exit: []
                }
            }
            return r(t, [{
                key: "check",
                value: function() {
                    var t = this;
                    return this.elements.forEach(function(e) {
                        var n = t.options.test(e, t.options)
                          , r = t.current.indexOf(e)
                          , i = r > -1
                          , o = n && !i
                          , u = !n && i;
                        o && (t.current.push(e),
                        t.emit("enter", e)),
                        u && (t.current.splice(r, 1),
                        t.emit("exit", e))
                    }),
                    this
                }
            }, {
                key: "on",
                value: function(t, e) {
                    return this.handlers[t].push(e),
                    this
                }
            }, {
                key: "once",
                value: function(t, e) {
                    return this.singles[t].unshift(e),
                    this
                }
            }, {
                key: "emit",
                value: function(t, e) {
                    for (; this.singles[t].length; )
                        this.singles[t].pop()(e);
                    for (var n = this.handlers[t].length; --n > -1; )
                        this.handlers[t][n](e);
                    return this
                }
            }]),
            t
        }();
        e["default"] = function(t, e) {
            return new i(t,e)
        }
    }
    , function(t, e) {
        "use strict";
        function n(t, e) {
            var n = t.getBoundingClientRect()
              , r = n.top
              , i = n.right
              , o = n.bottom
              , u = n.left
              , f = n.width
              , s = n.height
              , c = {
                t: o,
                r: window.innerWidth - u,
                b: window.innerHeight - r,
                l: i
            }
              , a = {
                x: e.threshold * f,
                y: e.threshold * s
            };
            return c.t > e.offset.top + a.y && c.r > e.offset.right + a.x && c.b > e.offset.bottom + a.y && c.l > e.offset.left + a.x
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        }),
        e.inViewport = n
    }
    , function(t, e) {
        (function(e) {
            var n = "object" == typeof e && e && e.Object === Object && e;
            t.exports = n
        }
        ).call(e, function() {
            return this
        }())
    }
    , function(t, e, n) {
        var r = n(5)
          , i = "object" == typeof self && self && self.Object === Object && self
          , o = r || i || Function("return this")();
        t.exports = o
    }
    , function(t, e, n) {
        function r(t, e, n) {
            function r(e) {
                var n = x
                  , r = m;
                return x = m = void 0,
                E = e,
                w = t.apply(r, n)
            }
            function a(t) {
                return E = t,
                j = setTimeout(h, e),
                M ? r(t) : w
            }
            function l(t) {
                var n = t - O
                  , r = t - E
                  , i = e - n;
                return _ ? c(i, g - r) : i
            }
            function d(t) {
                var n = t - O
                  , r = t - E;
                return void 0 === O || n >= e || n < 0 || _ && r >= g
            }
            function h() {
                var t = o();
                return d(t) ? p(t) : void (j = setTimeout(h, l(t)))
            }
            function p(t) {
                return j = void 0,
                T && x ? r(t) : (x = m = void 0,
                w)
            }
            function v() {
                void 0 !== j && clearTimeout(j),
                E = 0,
                x = O = m = j = void 0
            }
            function y() {
                return void 0 === j ? w : p(o())
            }
            function b() {
                var t = o()
                  , n = d(t);
                if (x = arguments,
                m = this,
                O = t,
                n) {
                    if (void 0 === j)
                        return a(O);
                    if (_)
                        return j = setTimeout(h, e),
                        r(O)
                }
                return void 0 === j && (j = setTimeout(h, e)),
                w
            }
            var x, m, g, w, j, O, E = 0, M = !1, _ = !1, T = !0;
            if ("function" != typeof t)
                throw new TypeError(f);
            return e = u(e) || 0,
            i(n) && (M = !!n.leading,
            _ = "maxWait"in n,
            g = _ ? s(u(n.maxWait) || 0, e) : g,
            T = "trailing"in n ? !!n.trailing : T),
            b.cancel = v,
            b.flush = y,
            b
        }
        var i = n(1)
          , o = n(8)
          , u = n(10)
          , f = "Expected a function"
          , s = Math.max
          , c = Math.min;
        t.exports = r
    }
    , function(t, e, n) {
        var r = n(6)
          , i = function() {
            return r.Date.now()
        };
        t.exports = i
    }
    , function(t, e, n) {
        function r(t, e, n) {
            var r = !0
              , f = !0;
            if ("function" != typeof t)
                throw new TypeError(u);
            return o(n) && (r = "leading"in n ? !!n.leading : r,
            f = "trailing"in n ? !!n.trailing : f),
            i(t, e, {
                leading: r,
                maxWait: e,
                trailing: f
            })
        }
        var i = n(7)
          , o = n(1)
          , u = "Expected a function";
        t.exports = r
    }
    , function(t, e) {
        function n(t) {
            return t
        }
        t.exports = n
    }
    ])
});

/**
 * Swiper 6.7.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 31, 2021
 */

!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).Swiper = t()
}(this, (function() {
    "use strict";
    function e(e, t) {
        for (var a = 0; a < t.length; a++) {
            var i = t[a];
            i.enumerable = i.enumerable || !1,
            i.configurable = !0,
            "value"in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i)
        }
    }
    function t() {
        return (t = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var a = arguments[t];
                for (var i in a)
                    Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i])
            }
            return e
        }
        ).apply(this, arguments)
    }
    function a(e) {
        return null !== e && "object" == typeof e && "constructor"in e && e.constructor === Object
    }
    function i(e, t) {
        void 0 === e && (e = {}),
        void 0 === t && (t = {}),
        Object.keys(t).forEach((function(s) {
            void 0 === e[s] ? e[s] = t[s] : a(t[s]) && a(e[s]) && Object.keys(t[s]).length > 0 && i(e[s], t[s])
        }
        ))
    }
    var s = {
        body: {},
        addEventListener: function() {},
        removeEventListener: function() {},
        activeElement: {
            blur: function() {},
            nodeName: ""
        },
        querySelector: function() {
            return null
        },
        querySelectorAll: function() {
            return []
        },
        getElementById: function() {
            return null
        },
        createEvent: function() {
            return {
                initEvent: function() {}
            }
        },
        createElement: function() {
            return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute: function() {},
                getElementsByTagName: function() {
                    return []
                }
            }
        },
        createElementNS: function() {
            return {}
        },
        importNode: function() {
            return null
        },
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        }
    };
    function r() {
        var e = "undefined" != typeof document ? document : {};
        return i(e, s),
        e
    }
    var n = {
        document: s,
        navigator: {
            userAgent: ""
        },
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        },
        history: {
            replaceState: function() {},
            pushState: function() {},
            go: function() {},
            back: function() {}
        },
        CustomEvent: function() {
            return this
        },
        addEventListener: function() {},
        removeEventListener: function() {},
        getComputedStyle: function() {
            return {
                getPropertyValue: function() {
                    return ""
                }
            }
        },
        Image: function() {},
        Date: function() {},
        screen: {},
        setTimeout: function() {},
        clearTimeout: function() {},
        matchMedia: function() {
            return {}
        },
        requestAnimationFrame: function(e) {
            return "undefined" == typeof setTimeout ? (e(),
            null) : setTimeout(e, 0)
        },
        cancelAnimationFrame: function(e) {
            "undefined" != typeof setTimeout && clearTimeout(e)
        }
    };
    function l() {
        var e = "undefined" != typeof window ? window : {};
        return i(e, n),
        e
    }
    function o(e) {
        return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        }
        )(e)
    }
    function d(e, t) {
        return (d = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t,
            e
        }
        )(e, t)
    }
    function p() {
        if ("undefined" == typeof Reflect || !Reflect.construct)
            return !1;
        if (Reflect.construct.sham)
            return !1;
        if ("function" == typeof Proxy)
            return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}
            ))),
            !0
        } catch (e) {
            return !1
        }
    }
    function u(e, t, a) {
        return (u = p() ? Reflect.construct : function(e, t, a) {
            var i = [null];
            i.push.apply(i, t);
            var s = new (Function.bind.apply(e, i));
            return a && d(s, a.prototype),
            s
        }
        ).apply(null, arguments)
    }
    function c(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return (c = function(e) {
            if (null === e || (a = e,
            -1 === Function.toString.call(a).indexOf("[native code]")))
                return e;
            var a;
            if ("function" != typeof e)
                throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e))
                    return t.get(e);
                t.set(e, i)
            }
            function i() {
                return u(e, arguments, o(this).constructor)
            }
            return i.prototype = Object.create(e.prototype, {
                constructor: {
                    value: i,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }),
            d(i, e)
        }
        )(e)
    }
    var h = function(e) {
        var t, a;
        function i(t) {
            var a, i, s;
            return a = e.call.apply(e, [this].concat(t)) || this,
            i = function(e) {
                if (void 0 === e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e
            }(a),
            s = i.__proto__,
            Object.defineProperty(i, "__proto__", {
                get: function() {
                    return s
                },
                set: function(e) {
                    s.__proto__ = e
                }
            }),
            a
        }
        return a = e,
        (t = i).prototype = Object.create(a.prototype),
        t.prototype.constructor = t,
        t.__proto__ = a,
        i
    }(c(Array));
    function v(e) {
        void 0 === e && (e = []);
        var t = [];
        return e.forEach((function(e) {
            Array.isArray(e) ? t.push.apply(t, v(e)) : t.push(e)
        }
        )),
        t
    }
    function f(e, t) {
        return Array.prototype.filter.call(e, t)
    }
    function m(e, t) {
        var a = l()
          , i = r()
          , s = [];
        if (!t && e instanceof h)
            return e;
        if (!e)
            return new h(s);
        if ("string" == typeof e) {
            var n = e.trim();
            if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
                var o = "div";
                0 === n.indexOf("<li") && (o = "ul"),
                0 === n.indexOf("<tr") && (o = "tbody"),
                0 !== n.indexOf("<td") && 0 !== n.indexOf("<th") || (o = "tr"),
                0 === n.indexOf("<tbody") && (o = "table"),
                0 === n.indexOf("<option") && (o = "select");
                var d = i.createElement(o);
                d.innerHTML = n;
                for (var p = 0; p < d.childNodes.length; p += 1)
                    s.push(d.childNodes[p])
            } else
                s = function(e, t) {
                    if ("string" != typeof e)
                        return [e];
                    for (var a = [], i = t.querySelectorAll(e), s = 0; s < i.length; s += 1)
                        a.push(i[s]);
                    return a
                }(e.trim(), t || i)
        } else if (e.nodeType || e === a || e === i)
            s.push(e);
        else if (Array.isArray(e)) {
            if (e instanceof h)
                return e;
            s = e
        }
        return new h(function(e) {
            for (var t = [], a = 0; a < e.length; a += 1)
                -1 === t.indexOf(e[a]) && t.push(e[a]);
            return t
        }(s))
    }
    m.fn = h.prototype;
    var g, b, y, w = {
        addClass: function() {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
                t[a] = arguments[a];
            var i = v(t.map((function(e) {
                return e.split(" ")
            }
            )));
            return this.forEach((function(e) {
                var t;
                (t = e.classList).add.apply(t, i)
            }
            )),
            this
        },
        removeClass: function() {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
                t[a] = arguments[a];
            var i = v(t.map((function(e) {
                return e.split(" ")
            }
            )));
            return this.forEach((function(e) {
                var t;
                (t = e.classList).remove.apply(t, i)
            }
            )),
            this
        },
        hasClass: function() {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
                t[a] = arguments[a];
            var i = v(t.map((function(e) {
                return e.split(" ")
            }
            )));
            return f(this, (function(e) {
                return i.filter((function(t) {
                    return e.classList.contains(t)
                }
                )).length > 0
            }
            )).length > 0
        },
        toggleClass: function() {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
                t[a] = arguments[a];
            var i = v(t.map((function(e) {
                return e.split(" ")
            }
            )));
            this.forEach((function(e) {
                i.forEach((function(t) {
                    e.classList.toggle(t)
                }
                ))
            }
            ))
        },
        attr: function(e, t) {
            if (1 === arguments.length && "string" == typeof e)
                return this[0] ? this[0].getAttribute(e) : void 0;
            for (var a = 0; a < this.length; a += 1)
                if (2 === arguments.length)
                    this[a].setAttribute(e, t);
                else
                    for (var i in e)
                        this[a][i] = e[i],
                        this[a].setAttribute(i, e[i]);
            return this
        },
        removeAttr: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].removeAttribute(e);
            return this
        },
        transform: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].style.transform = e;
            return this
        },
        transition: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e;
            return this
        },
        on: function() {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
                t[a] = arguments[a];
            var i = t[0]
              , s = t[1]
              , r = t[2]
              , n = t[3];
            function l(e) {
                var t = e.target;
                if (t) {
                    var a = e.target.dom7EventData || [];
                    if (a.indexOf(e) < 0 && a.unshift(e),
                    m(t).is(s))
                        r.apply(t, a);
                    else
                        for (var i = m(t).parents(), n = 0; n < i.length; n += 1)
                            m(i[n]).is(s) && r.apply(i[n], a)
                }
            }
            function o(e) {
                var t = e && e.target && e.target.dom7EventData || [];
                t.indexOf(e) < 0 && t.unshift(e),
                r.apply(this, t)
            }
            "function" == typeof t[1] && (i = t[0],
            r = t[1],
            n = t[2],
            s = void 0),
            n || (n = !1);
            for (var d, p = i.split(" "), u = 0; u < this.length; u += 1) {
                var c = this[u];
                if (s)
                    for (d = 0; d < p.length; d += 1) {
                        var h = p[d];
                        c.dom7LiveListeners || (c.dom7LiveListeners = {}),
                        c.dom7LiveListeners[h] || (c.dom7LiveListeners[h] = []),
                        c.dom7LiveListeners[h].push({
                            listener: r,
                            proxyListener: l
                        }),
                        c.addEventListener(h, l, n)
                    }
                else
                    for (d = 0; d < p.length; d += 1) {
                        var v = p[d];
                        c.dom7Listeners || (c.dom7Listeners = {}),
                        c.dom7Listeners[v] || (c.dom7Listeners[v] = []),
                        c.dom7Listeners[v].push({
                            listener: r,
                            proxyListener: o
                        }),
                        c.addEventListener(v, o, n)
                    }
            }
            return this
        },
        off: function() {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
                t[a] = arguments[a];
            var i = t[0]
              , s = t[1]
              , r = t[2]
              , n = t[3];
            "function" == typeof t[1] && (i = t[0],
            r = t[1],
            n = t[2],
            s = void 0),
            n || (n = !1);
            for (var l = i.split(" "), o = 0; o < l.length; o += 1)
                for (var d = l[o], p = 0; p < this.length; p += 1) {
                    var u = this[p]
                      , c = void 0;
                    if (!s && u.dom7Listeners ? c = u.dom7Listeners[d] : s && u.dom7LiveListeners && (c = u.dom7LiveListeners[d]),
                    c && c.length)
                        for (var h = c.length - 1; h >= 0; h -= 1) {
                            var v = c[h];
                            r && v.listener === r || r && v.listener && v.listener.dom7proxy && v.listener.dom7proxy === r ? (u.removeEventListener(d, v.proxyListener, n),
                            c.splice(h, 1)) : r || (u.removeEventListener(d, v.proxyListener, n),
                            c.splice(h, 1))
                        }
                }
            return this
        },
        trigger: function() {
            for (var e = l(), t = arguments.length, a = new Array(t), i = 0; i < t; i++)
                a[i] = arguments[i];
            for (var s = a[0].split(" "), r = a[1], n = 0; n < s.length; n += 1)
                for (var o = s[n], d = 0; d < this.length; d += 1) {
                    var p = this[d];
                    if (e.CustomEvent) {
                        var u = new e.CustomEvent(o,{
                            detail: r,
                            bubbles: !0,
                            cancelable: !0
                        });
                        p.dom7EventData = a.filter((function(e, t) {
                            return t > 0
                        }
                        )),
                        p.dispatchEvent(u),
                        p.dom7EventData = [],
                        delete p.dom7EventData
                    }
                }
            return this
        },
        transitionEnd: function(e) {
            var t = this;
            return e && t.on("transitionend", (function a(i) {
                i.target === this && (e.call(this, i),
                t.off("transitionend", a))
            }
            )),
            this
        },
        outerWidth: function(e) {
            if (this.length > 0) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"))
                }
                return this[0].offsetWidth
            }
            return null
        },
        outerHeight: function(e) {
            if (this.length > 0) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"))
                }
                return this[0].offsetHeight
            }
            return null
        },
        styles: function() {
            var e = l();
            return this[0] ? e.getComputedStyle(this[0], null) : {}
        },
        offset: function() {
            if (this.length > 0) {
                var e = l()
                  , t = r()
                  , a = this[0]
                  , i = a.getBoundingClientRect()
                  , s = t.body
                  , n = a.clientTop || s.clientTop || 0
                  , o = a.clientLeft || s.clientLeft || 0
                  , d = a === e ? e.scrollY : a.scrollTop
                  , p = a === e ? e.scrollX : a.scrollLeft;
                return {
                    top: i.top + d - n,
                    left: i.left + p - o
                }
            }
            return null
        },
        css: function(e, t) {
            var a, i = l();
            if (1 === arguments.length) {
                if ("string" != typeof e) {
                    for (a = 0; a < this.length; a += 1)
                        for (var s in e)
                            this[a].style[s] = e[s];
                    return this
                }
                if (this[0])
                    return i.getComputedStyle(this[0], null).getPropertyValue(e)
            }
            if (2 === arguments.length && "string" == typeof e) {
                for (a = 0; a < this.length; a += 1)
                    this[a].style[e] = t;
                return this
            }
            return this
        },
        each: function(e) {
            return e ? (this.forEach((function(t, a) {
                e.apply(t, [t, a])
            }
            )),
            this) : this
        },
        html: function(e) {
            if (void 0 === e)
                return this[0] ? this[0].innerHTML : null;
            for (var t = 0; t < this.length; t += 1)
                this[t].innerHTML = e;
            return this
        },
        text: function(e) {
            if (void 0 === e)
                return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1)
                this[t].textContent = e;
            return this
        },
        is: function(e) {
            var t, a, i = l(), s = r(), n = this[0];
            if (!n || void 0 === e)
                return !1;
            if ("string" == typeof e) {
                if (n.matches)
                    return n.matches(e);
                if (n.webkitMatchesSelector)
                    return n.webkitMatchesSelector(e);
                if (n.msMatchesSelector)
                    return n.msMatchesSelector(e);
                for (t = m(e),
                a = 0; a < t.length; a += 1)
                    if (t[a] === n)
                        return !0;
                return !1
            }
            if (e === s)
                return n === s;
            if (e === i)
                return n === i;
            if (e.nodeType || e instanceof h) {
                for (t = e.nodeType ? [e] : e,
                a = 0; a < t.length; a += 1)
                    if (t[a] === n)
                        return !0;
                return !1
            }
            return !1
        },
        index: function() {
            var e, t = this[0];
            if (t) {
                for (e = 0; null !== (t = t.previousSibling); )
                    1 === t.nodeType && (e += 1);
                return e
            }
        },
        eq: function(e) {
            if (void 0 === e)
                return this;
            var t = this.length;
            if (e > t - 1)
                return m([]);
            if (e < 0) {
                var a = t + e;
                return m(a < 0 ? [] : [this[a]])
            }
            return m([this[e]])
        },
        append: function() {
            for (var e, t = r(), a = 0; a < arguments.length; a += 1) {
                e = a < 0 || arguments.length <= a ? void 0 : arguments[a];
                for (var i = 0; i < this.length; i += 1)
                    if ("string" == typeof e) {
                        var s = t.createElement("div");
                        for (s.innerHTML = e; s.firstChild; )
                            this[i].appendChild(s.firstChild)
                    } else if (e instanceof h)
                        for (var n = 0; n < e.length; n += 1)
                            this[i].appendChild(e[n]);
                    else
                        this[i].appendChild(e)
            }
            return this
        },
        prepend: function(e) {
            var t, a, i = r();
            for (t = 0; t < this.length; t += 1)
                if ("string" == typeof e) {
                    var s = i.createElement("div");
                    for (s.innerHTML = e,
                    a = s.childNodes.length - 1; a >= 0; a -= 1)
                        this[t].insertBefore(s.childNodes[a], this[t].childNodes[0])
                } else if (e instanceof h)
                    for (a = 0; a < e.length; a += 1)
                        this[t].insertBefore(e[a], this[t].childNodes[0]);
                else
                    this[t].insertBefore(e, this[t].childNodes[0]);
            return this
        },
        next: function(e) {
            return this.length > 0 ? e ? this[0].nextElementSibling && m(this[0].nextElementSibling).is(e) ? m([this[0].nextElementSibling]) : m([]) : this[0].nextElementSibling ? m([this[0].nextElementSibling]) : m([]) : m([])
        },
        nextAll: function(e) {
            var t = []
              , a = this[0];
            if (!a)
                return m([]);
            for (; a.nextElementSibling; ) {
                var i = a.nextElementSibling;
                e ? m(i).is(e) && t.push(i) : t.push(i),
                a = i
            }
            return m(t)
        },
        prev: function(e) {
            if (this.length > 0) {
                var t = this[0];
                return e ? t.previousElementSibling && m(t.previousElementSibling).is(e) ? m([t.previousElementSibling]) : m([]) : t.previousElementSibling ? m([t.previousElementSibling]) : m([])
            }
            return m([])
        },
        prevAll: function(e) {
            var t = []
              , a = this[0];
            if (!a)
                return m([]);
            for (; a.previousElementSibling; ) {
                var i = a.previousElementSibling;
                e ? m(i).is(e) && t.push(i) : t.push(i),
                a = i
            }
            return m(t)
        },
        parent: function(e) {
            for (var t = [], a = 0; a < this.length; a += 1)
                null !== this[a].parentNode && (e ? m(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
            return m(t)
        },
        parents: function(e) {
            for (var t = [], a = 0; a < this.length; a += 1)
                for (var i = this[a].parentNode; i; )
                    e ? m(i).is(e) && t.push(i) : t.push(i),
                    i = i.parentNode;
            return m(t)
        },
        closest: function(e) {
            var t = this;
            return void 0 === e ? m([]) : (t.is(e) || (t = t.parents(e).eq(0)),
            t)
        },
        find: function(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                try {
                    var i = this[a].querySelectorAll(e)
                } catch (t) {
                    console.log(e)
                }
                for (var s = 0; s < i.length; s += 1)
                    t.push(i[s])
            }
            return m(t)
        },
        children: function(e) {
            for (var t = [], a = 0; a < this.length; a += 1)
                for (var i = this[a].children, s = 0; s < i.length; s += 1)
                    e && !m(i[s]).is(e) || t.push(i[s]);
            return m(t)
        },
        filter: function(e) {
            return m(f(this, e))
        },
        remove: function() {
            for (var e = 0; e < this.length; e += 1)
                this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this
        }
    };
    function E(e, t) {
        return void 0 === t && (t = 0),
        setTimeout(e, t)
    }
    function x() {
        return Date.now()
    }
    function T(e, t) {
        void 0 === t && (t = "x");
        var a, i, s, r = l(), n = function(e) {
            var t, a = l();
            return a.getComputedStyle && (t = a.getComputedStyle(e, null)),
            !t && e.currentStyle && (t = e.currentStyle),
            t || (t = e.style),
            t
        }(e);
        return r.WebKitCSSMatrix ? ((i = n.transform || n.webkitTransform).split(",").length > 6 && (i = i.split(", ").map((function(e) {
            return e.replace(",", ".")
        }
        )).join(", ")),
        s = new r.WebKitCSSMatrix("none" === i ? "" : i)) : a = (s = n.MozTransform || n.OTransform || n.MsTransform || n.msTransform || n.transform || n.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","),
        "x" === t && (i = r.WebKitCSSMatrix ? s.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])),
        "y" === t && (i = r.WebKitCSSMatrix ? s.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])),
        i || 0
    }
    function C(e) {
        return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1)
    }
    function S() {
        for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"], a = 1; a < arguments.length; a += 1) {
            var i = a < 0 || arguments.length <= a ? void 0 : arguments[a];
            if (null != i)
                for (var s = Object.keys(Object(i)).filter((function(e) {
                    return t.indexOf(e) < 0
                }
                )), r = 0, n = s.length; r < n; r += 1) {
                    var l = s[r]
                      , o = Object.getOwnPropertyDescriptor(i, l);
                    void 0 !== o && o.enumerable && (C(e[l]) && C(i[l]) ? i[l].__swiper__ ? e[l] = i[l] : S(e[l], i[l]) : !C(e[l]) && C(i[l]) ? (e[l] = {},
                    i[l].__swiper__ ? e[l] = i[l] : S(e[l], i[l])) : e[l] = i[l])
                }
        }
        return e
    }
    function M(e, t) {
        Object.keys(t).forEach((function(a) {
            C(t[a]) && Object.keys(t[a]).forEach((function(i) {
                "function" == typeof t[a][i] && (t[a][i] = t[a][i].bind(e))
            }
            )),
            e[a] = t[a]
        }
        ))
    }
    function z(e) {
        return void 0 === e && (e = ""),
        "." + e.trim().replace(/([\.:\/])/g, "\\$1").replace(/ /g, ".")
    }
    function P(e, t, a, i) {
        var s = r();
        return a && Object.keys(i).forEach((function(a) {
            if (!t[a] && !0 === t.auto) {
                var r = s.createElement("div");
                r.className = i[a],
                e.append(r),
                t[a] = r
            }
        }
        )),
        t
    }
    function k() {
        return g || (g = function() {
            var e = l()
              , t = r();
            return {
                touch: !!("ontouchstart"in e || e.DocumentTouch && t instanceof e.DocumentTouch),
                pointerEvents: !!e.PointerEvent && "maxTouchPoints"in e.navigator && e.navigator.maxTouchPoints >= 0,
                observer: "MutationObserver"in e || "WebkitMutationObserver"in e,
                passiveListener: function() {
                    var t = !1;
                    try {
                        var a = Object.defineProperty({}, "passive", {
                            get: function() {
                                t = !0
                            }
                        });
                        e.addEventListener("testPassiveListener", null, a)
                    } catch (e) {}
                    return t
                }(),
                gestures: "ongesturestart"in e
            }
        }()),
        g
    }
    function $(e) {
        return void 0 === e && (e = {}),
        b || (b = function(e) {
            var t = (void 0 === e ? {} : e).userAgent
              , a = k()
              , i = l()
              , s = i.navigator.platform
              , r = t || i.navigator.userAgent
              , n = {
                ios: !1,
                android: !1
            }
              , o = i.screen.width
              , d = i.screen.height
              , p = r.match(/(Android);?[\s\/]+([\d.]+)?/)
              , u = r.match(/(iPad).*OS\s([\d_]+)/)
              , c = r.match(/(iPod)(.*OS\s([\d_]+))?/)
              , h = !u && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/)
              , v = "Win32" === s
              , f = "MacIntel" === s;
            return !u && f && a.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(o + "x" + d) >= 0 && ((u = r.match(/(Version)\/([\d.]+)/)) || (u = [0, 1, "13_0_0"]),
            f = !1),
            p && !v && (n.os = "android",
            n.android = !0),
            (u || h || c) && (n.os = "ios",
            n.ios = !0),
            n
        }(e)),
        b
    }
    function L() {
        return y || (y = function() {
            var e, t = l();
            return {
                isEdge: !!t.navigator.userAgent.match(/Edge/g),
                isSafari: (e = t.navigator.userAgent.toLowerCase(),
                e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
            }
        }()),
        y
    }
    Object.keys(w).forEach((function(e) {
        Object.defineProperty(m.fn, e, {
            value: w[e],
            writable: !0
        })
    }
    ));
    var I = {
        name: "resize",
        create: function() {
            var e = this;
            S(e, {
                resize: {
                    observer: null,
                    createObserver: function() {
                        e && !e.destroyed && e.initialized && (e.resize.observer = new ResizeObserver((function(t) {
                            var a = e.width
                              , i = e.height
                              , s = a
                              , r = i;
                            t.forEach((function(t) {
                                var a = t.contentBoxSize
                                  , i = t.contentRect
                                  , n = t.target;
                                n && n !== e.el || (s = i ? i.width : (a[0] || a).inlineSize,
                                r = i ? i.height : (a[0] || a).blockSize)
                            }
                            )),
                            s === a && r === i || e.resize.resizeHandler()
                        }
                        )),
                        e.resize.observer.observe(e.el))
                    },
                    removeObserver: function() {
                        e.resize.observer && e.resize.observer.unobserve && e.el && (e.resize.observer.unobserve(e.el),
                        e.resize.observer = null)
                    },
                    resizeHandler: function() {
                        e && !e.destroyed && e.initialized && (e.emit("beforeResize"),
                        e.emit("resize"))
                    },
                    orientationChangeHandler: function() {
                        e && !e.destroyed && e.initialized && e.emit("orientationchange")
                    }
                }
            })
        },
        on: {
            init: function(e) {
                var t = l();
                e.params.resizeObserver && void 0 !== l().ResizeObserver ? e.resize.createObserver() : (t.addEventListener("resize", e.resize.resizeHandler),
                t.addEventListener("orientationchange", e.resize.orientationChangeHandler))
            },
            destroy: function(e) {
                var t = l();
                e.resize.removeObserver(),
                t.removeEventListener("resize", e.resize.resizeHandler),
                t.removeEventListener("orientationchange", e.resize.orientationChangeHandler)
            }
        }
    }
      , O = {
        attach: function(e, t) {
            void 0 === t && (t = {});
            var a = l()
              , i = this
              , s = new (a.MutationObserver || a.WebkitMutationObserver)((function(e) {
                if (1 !== e.length) {
                    var t = function() {
                        i.emit("observerUpdate", e[0])
                    };
                    a.requestAnimationFrame ? a.requestAnimationFrame(t) : a.setTimeout(t, 0)
                } else
                    i.emit("observerUpdate", e[0])
            }
            ));
            s.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData
            }),
            i.observer.observers.push(s)
        },
        init: function() {
            var e = this;
            if (e.support.observer && e.params.observer) {
                if (e.params.observeParents)
                    for (var t = e.$el.parents(), a = 0; a < t.length; a += 1)
                        e.observer.attach(t[a]);
                e.observer.attach(e.$el[0], {
                    childList: e.params.observeSlideChildren
                }),
                e.observer.attach(e.$wrapperEl[0], {
                    attributes: !1
                })
            }
        },
        destroy: function() {
            this.observer.observers.forEach((function(e) {
                e.disconnect()
            }
            )),
            this.observer.observers = []
        }
    }
      , A = {
        name: "observer",
        params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1
        },
        create: function() {
            M(this, {
                observer: t({}, O, {
                    observers: []
                })
            })
        },
        on: {
            init: function(e) {
                e.observer.init()
            },
            destroy: function(e) {
                e.observer.destroy()
            }
        }
    };
    function D(e) {
        var t = this
          , a = r()
          , i = l()
          , s = t.touchEventsData
          , n = t.params
          , o = t.touches;
        if (t.enabled && (!t.animating || !n.preventInteractionOnTransition)) {
            var d = e;
            d.originalEvent && (d = d.originalEvent);
            var p = m(d.target);
            if ("wrapper" !== n.touchEventsTarget || p.closest(t.wrapperEl).length)
                if (s.isTouchEvent = "touchstart" === d.type,
                s.isTouchEvent || !("which"in d) || 3 !== d.which)
                    if (!(!s.isTouchEvent && "button"in d && d.button > 0))
                        if (!s.isTouched || !s.isMoved)
                            if (!!n.noSwipingClass && "" !== n.noSwipingClass && d.target && d.target.shadowRoot && e.path && e.path[0] && (p = m(e.path[0])),
                            n.noSwiping && p.closest(n.noSwipingSelector ? n.noSwipingSelector : "." + n.noSwipingClass)[0])
                                t.allowClick = !0;
                            else if (!n.swipeHandler || p.closest(n.swipeHandler)[0]) {
                                o.currentX = "touchstart" === d.type ? d.targetTouches[0].pageX : d.pageX,
                                o.currentY = "touchstart" === d.type ? d.targetTouches[0].pageY : d.pageY;
                                var u = o.currentX
                                  , c = o.currentY
                                  , h = n.edgeSwipeDetection || n.iOSEdgeSwipeDetection
                                  , v = n.edgeSwipeThreshold || n.iOSEdgeSwipeThreshold;
                                if (h && (u <= v || u >= i.innerWidth - v)) {
                                    if ("prevent" !== h)
                                        return;
                                    e.preventDefault()
                                }
                                if (S(s, {
                                    isTouched: !0,
                                    isMoved: !1,
                                    allowTouchCallbacks: !0,
                                    isScrolling: void 0,
                                    startMoving: void 0
                                }),
                                o.startX = u,
                                o.startY = c,
                                s.touchStartTime = x(),
                                t.allowClick = !0,
                                t.updateSize(),
                                t.swipeDirection = void 0,
                                n.threshold > 0 && (s.allowThresholdMove = !1),
                                "touchstart" !== d.type) {
                                    var f = !0;
                                    p.is(s.formElements) && (f = !1),
                                    a.activeElement && m(a.activeElement).is(s.formElements) && a.activeElement !== p[0] && a.activeElement.blur();
                                    var g = f && t.allowTouchMove && n.touchStartPreventDefault;
                                    !n.touchStartForcePreventDefault && !g || p[0].isContentEditable || d.preventDefault()
                                }
                                t.emit("touchStart", d)
                            }
        }
    }
    function N(e) {
        var t = r()
          , a = this
          , i = a.touchEventsData
          , s = a.params
          , n = a.touches
          , l = a.rtlTranslate;
        if (a.enabled) {
            var o = e;
            if (o.originalEvent && (o = o.originalEvent),
            i.isTouched) {
                if (!i.isTouchEvent || "touchmove" === o.type) {
                    var d = "touchmove" === o.type && o.targetTouches && (o.targetTouches[0] || o.changedTouches[0])
                      , p = "touchmove" === o.type ? d.pageX : o.pageX
                      , u = "touchmove" === o.type ? d.pageY : o.pageY;
                    if (o.preventedByNestedSwiper)
                        return n.startX = p,
                        void (n.startY = u);
                    if (!a.allowTouchMove)
                        return a.allowClick = !1,
                        void (i.isTouched && (S(n, {
                            startX: p,
                            startY: u,
                            currentX: p,
                            currentY: u
                        }),
                        i.touchStartTime = x()));
                    if (i.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
                        if (a.isVertical()) {
                            if (u < n.startY && a.translate <= a.maxTranslate() || u > n.startY && a.translate >= a.minTranslate())
                                return i.isTouched = !1,
                                void (i.isMoved = !1)
                        } else if (p < n.startX && a.translate <= a.maxTranslate() || p > n.startX && a.translate >= a.minTranslate())
                            return;
                    if (i.isTouchEvent && t.activeElement && o.target === t.activeElement && m(o.target).is(i.formElements))
                        return i.isMoved = !0,
                        void (a.allowClick = !1);
                    if (i.allowTouchCallbacks && a.emit("touchMove", o),
                    !(o.targetTouches && o.targetTouches.length > 1)) {
                        n.currentX = p,
                        n.currentY = u;
                        var c = n.currentX - n.startX
                          , h = n.currentY - n.startY;
                        if (!(a.params.threshold && Math.sqrt(Math.pow(c, 2) + Math.pow(h, 2)) < a.params.threshold)) {
                            var v;
                            if (void 0 === i.isScrolling)
                                a.isHorizontal() && n.currentY === n.startY || a.isVertical() && n.currentX === n.startX ? i.isScrolling = !1 : c * c + h * h >= 25 && (v = 180 * Math.atan2(Math.abs(h), Math.abs(c)) / Math.PI,
                                i.isScrolling = a.isHorizontal() ? v > s.touchAngle : 90 - v > s.touchAngle);
                            if (i.isScrolling && a.emit("touchMoveOpposite", o),
                            void 0 === i.startMoving && (n.currentX === n.startX && n.currentY === n.startY || (i.startMoving = !0)),
                            i.isScrolling)
                                i.isTouched = !1;
                            else if (i.startMoving) {
                                a.allowClick = !1,
                                !s.cssMode && o.cancelable && o.preventDefault(),
                                s.touchMoveStopPropagation && !s.nested && o.stopPropagation(),
                                i.isMoved || (s.loop && a.loopFix(),
                                i.startTranslate = a.getTranslate(),
                                a.setTransition(0),
                                a.animating && a.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                                i.allowMomentumBounce = !1,
                                !s.grabCursor || !0 !== a.allowSlideNext && !0 !== a.allowSlidePrev || a.setGrabCursor(!0),
                                a.emit("sliderFirstMove", o)),
                                a.emit("sliderMove", o),
                                i.isMoved = !0;
                                var f = a.isHorizontal() ? c : h;
                                n.diff = f,
                                f *= s.touchRatio,
                                l && (f = -f),
                                a.swipeDirection = f > 0 ? "prev" : "next",
                                i.currentTranslate = f + i.startTranslate;
                                var g = !0
                                  , b = s.resistanceRatio;
                                if (s.touchReleaseOnEdges && (b = 0),
                                f > 0 && i.currentTranslate > a.minTranslate() ? (g = !1,
                                s.resistance && (i.currentTranslate = a.minTranslate() - 1 + Math.pow(-a.minTranslate() + i.startTranslate + f, b))) : f < 0 && i.currentTranslate < a.maxTranslate() && (g = !1,
                                s.resistance && (i.currentTranslate = a.maxTranslate() + 1 - Math.pow(a.maxTranslate() - i.startTranslate - f, b))),
                                g && (o.preventedByNestedSwiper = !0),
                                !a.allowSlideNext && "next" === a.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate),
                                !a.allowSlidePrev && "prev" === a.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate),
                                a.allowSlidePrev || a.allowSlideNext || (i.currentTranslate = i.startTranslate),
                                s.threshold > 0) {
                                    if (!(Math.abs(f) > s.threshold || i.allowThresholdMove))
                                        return void (i.currentTranslate = i.startTranslate);
                                    if (!i.allowThresholdMove)
                                        return i.allowThresholdMove = !0,
                                        n.startX = n.currentX,
                                        n.startY = n.currentY,
                                        i.currentTranslate = i.startTranslate,
                                        void (n.diff = a.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY)
                                }
                                s.followFinger && !s.cssMode && ((s.freeMode || s.watchSlidesProgress || s.watchSlidesVisibility) && (a.updateActiveIndex(),
                                a.updateSlidesClasses()),
                                s.freeMode && (0 === i.velocities.length && i.velocities.push({
                                    position: n[a.isHorizontal() ? "startX" : "startY"],
                                    time: i.touchStartTime
                                }),
                                i.velocities.push({
                                    position: n[a.isHorizontal() ? "currentX" : "currentY"],
                                    time: x()
                                })),
                                a.updateProgress(i.currentTranslate),
                                a.setTranslate(i.currentTranslate))
                            }
                        }
                    }
                }
            } else
                i.startMoving && i.isScrolling && a.emit("touchMoveOpposite", o)
        }
    }
    function G(e) {
        var t = this
          , a = t.touchEventsData
          , i = t.params
          , s = t.touches
          , r = t.rtlTranslate
          , n = t.$wrapperEl
          , l = t.slidesGrid
          , o = t.snapGrid;
        if (t.enabled) {
            var d = e;
            if (d.originalEvent && (d = d.originalEvent),
            a.allowTouchCallbacks && t.emit("touchEnd", d),
            a.allowTouchCallbacks = !1,
            !a.isTouched)
                return a.isMoved && i.grabCursor && t.setGrabCursor(!1),
                a.isMoved = !1,
                void (a.startMoving = !1);
            i.grabCursor && a.isMoved && a.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
            var p, u = x(), c = u - a.touchStartTime;
            if (t.allowClick && (t.updateClickedSlide(d),
            t.emit("tap click", d),
            c < 300 && u - a.lastClickTime < 300 && t.emit("doubleTap doubleClick", d)),
            a.lastClickTime = x(),
            E((function() {
                t.destroyed || (t.allowClick = !0)
            }
            )),
            !a.isTouched || !a.isMoved || !t.swipeDirection || 0 === s.diff || a.currentTranslate === a.startTranslate)
                return a.isTouched = !1,
                a.isMoved = !1,
                void (a.startMoving = !1);
            if (a.isTouched = !1,
            a.isMoved = !1,
            a.startMoving = !1,
            p = i.followFinger ? r ? t.translate : -t.translate : -a.currentTranslate,
            !i.cssMode)
                if (i.freeMode) {
                    if (p < -t.minTranslate())
                        return void t.slideTo(t.activeIndex);
                    if (p > -t.maxTranslate())
                        return void (t.slides.length < o.length ? t.slideTo(o.length - 1) : t.slideTo(t.slides.length - 1));
                    if (i.freeModeMomentum) {
                        if (a.velocities.length > 1) {
                            var h = a.velocities.pop()
                              , v = a.velocities.pop()
                              , f = h.position - v.position
                              , m = h.time - v.time;
                            t.velocity = f / m,
                            t.velocity /= 2,
                            Math.abs(t.velocity) < i.freeModeMinimumVelocity && (t.velocity = 0),
                            (m > 150 || x() - h.time > 300) && (t.velocity = 0)
                        } else
                            t.velocity = 0;
                        t.velocity *= i.freeModeMomentumVelocityRatio,
                        a.velocities.length = 0;
                        var g = 1e3 * i.freeModeMomentumRatio
                          , b = t.velocity * g
                          , y = t.translate + b;
                        r && (y = -y);
                        var w, T, C = !1, S = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
                        if (y < t.maxTranslate())
                            i.freeModeMomentumBounce ? (y + t.maxTranslate() < -S && (y = t.maxTranslate() - S),
                            w = t.maxTranslate(),
                            C = !0,
                            a.allowMomentumBounce = !0) : y = t.maxTranslate(),
                            i.loop && i.centeredSlides && (T = !0);
                        else if (y > t.minTranslate())
                            i.freeModeMomentumBounce ? (y - t.minTranslate() > S && (y = t.minTranslate() + S),
                            w = t.minTranslate(),
                            C = !0,
                            a.allowMomentumBounce = !0) : y = t.minTranslate(),
                            i.loop && i.centeredSlides && (T = !0);
                        else if (i.freeModeSticky) {
                            for (var M, z = 0; z < o.length; z += 1)
                                if (o[z] > -y) {
                                    M = z;
                                    break
                                }
                            y = -(y = Math.abs(o[M] - y) < Math.abs(o[M - 1] - y) || "next" === t.swipeDirection ? o[M] : o[M - 1])
                        }
                        if (T && t.once("transitionEnd", (function() {
                            t.loopFix()
                        }
                        )),
                        0 !== t.velocity) {
                            if (g = r ? Math.abs((-y - t.translate) / t.velocity) : Math.abs((y - t.translate) / t.velocity),
                            i.freeModeSticky) {
                                var P = Math.abs((r ? -y : y) - t.translate)
                                  , k = t.slidesSizesGrid[t.activeIndex];
                                g = P < k ? i.speed : P < 2 * k ? 1.5 * i.speed : 2.5 * i.speed
                            }
                        } else if (i.freeModeSticky)
                            return void t.slideToClosest();
                        i.freeModeMomentumBounce && C ? (t.updateProgress(w),
                        t.setTransition(g),
                        t.setTranslate(y),
                        t.transitionStart(!0, t.swipeDirection),
                        t.animating = !0,
                        n.transitionEnd((function() {
                            t && !t.destroyed && a.allowMomentumBounce && (t.emit("momentumBounce"),
                            t.setTransition(i.speed),
                            setTimeout((function() {
                                t.setTranslate(w),
                                n.transitionEnd((function() {
                                    t && !t.destroyed && t.transitionEnd()
                                }
                                ))
                            }
                            ), 0))
                        }
                        ))) : t.velocity ? (t.updateProgress(y),
                        t.setTransition(g),
                        t.setTranslate(y),
                        t.transitionStart(!0, t.swipeDirection),
                        t.animating || (t.animating = !0,
                        n.transitionEnd((function() {
                            t && !t.destroyed && t.transitionEnd()
                        }
                        )))) : (t.emit("_freeModeNoMomentumRelease"),
                        t.updateProgress(y)),
                        t.updateActiveIndex(),
                        t.updateSlidesClasses()
                    } else {
                        if (i.freeModeSticky)
                            return void t.slideToClosest();
                        i.freeMode && t.emit("_freeModeNoMomentumRelease")
                    }
                    (!i.freeModeMomentum || c >= i.longSwipesMs) && (t.updateProgress(),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses())
                } else {
                    for (var $ = 0, L = t.slidesSizesGrid[0], I = 0; I < l.length; I += I < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
                        var O = I < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                        void 0 !== l[I + O] ? p >= l[I] && p < l[I + O] && ($ = I,
                        L = l[I + O] - l[I]) : p >= l[I] && ($ = I,
                        L = l[l.length - 1] - l[l.length - 2])
                    }
                    var A = (p - l[$]) / L
                      , D = $ < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                    if (c > i.longSwipesMs) {
                        if (!i.longSwipes)
                            return void t.slideTo(t.activeIndex);
                        "next" === t.swipeDirection && (A >= i.longSwipesRatio ? t.slideTo($ + D) : t.slideTo($)),
                        "prev" === t.swipeDirection && (A > 1 - i.longSwipesRatio ? t.slideTo($ + D) : t.slideTo($))
                    } else {
                        if (!i.shortSwipes)
                            return void t.slideTo(t.activeIndex);
                        t.navigation && (d.target === t.navigation.nextEl || d.target === t.navigation.prevEl) ? d.target === t.navigation.nextEl ? t.slideTo($ + D) : t.slideTo($) : ("next" === t.swipeDirection && t.slideTo($ + D),
                        "prev" === t.swipeDirection && t.slideTo($))
                    }
                }
        }
    }
    function B() {
        var e = this
          , t = e.params
          , a = e.el;
        if (!a || 0 !== a.offsetWidth) {
            t.breakpoints && e.setBreakpoint();
            var i = e.allowSlideNext
              , s = e.allowSlidePrev
              , r = e.snapGrid;
            e.allowSlideNext = !0,
            e.allowSlidePrev = !0,
            e.updateSize(),
            e.updateSlides(),
            e.updateSlidesClasses(),
            ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0),
            e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
            e.allowSlidePrev = s,
            e.allowSlideNext = i,
            e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow()
        }
    }
    function H(e) {
        var t = this;
        t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation && t.animating && (e.stopPropagation(),
        e.stopImmediatePropagation())))
    }
    function X() {
        var e = this
          , t = e.wrapperEl
          , a = e.rtlTranslate;
        if (e.enabled) {
            e.previousTranslate = e.translate,
            e.isHorizontal() ? e.translate = a ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft : e.translate = -t.scrollTop,
            -0 === e.translate && (e.translate = 0),
            e.updateActiveIndex(),
            e.updateSlidesClasses();
            var i = e.maxTranslate() - e.minTranslate();
            (0 === i ? 0 : (e.translate - e.minTranslate()) / i) !== e.progress && e.updateProgress(a ? -e.translate : e.translate),
            e.emit("setTranslate", e.translate, !1)
        }
    }
    var Y = !1;
    function R() {}
    var W = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !1,
        nested: !1,
        createElements: !1,
        enabled: !0,
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: .02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        loopPreventsSlide: !0,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0,
        _emitClasses: !1
    }
      , V = {
        modular: {
            useParams: function(e) {
                var t = this;
                t.modules && Object.keys(t.modules).forEach((function(a) {
                    var i = t.modules[a];
                    i.params && S(e, i.params)
                }
                ))
            },
            useModules: function(e) {
                void 0 === e && (e = {});
                var t = this;
                t.modules && Object.keys(t.modules).forEach((function(a) {
                    var i = t.modules[a]
                      , s = e[a] || {};
                    i.on && t.on && Object.keys(i.on).forEach((function(e) {
                        t.on(e, i.on[e])
                    }
                    )),
                    i.create && i.create.bind(t)(s)
                }
                ))
            }
        },
        eventsEmitter: {
            on: function(e, t, a) {
                var i = this;
                if ("function" != typeof t)
                    return i;
                var s = a ? "unshift" : "push";
                return e.split(" ").forEach((function(e) {
                    i.eventsListeners[e] || (i.eventsListeners[e] = []),
                    i.eventsListeners[e][s](t)
                }
                )),
                i
            },
            once: function(e, t, a) {
                var i = this;
                if ("function" != typeof t)
                    return i;
                function s() {
                    i.off(e, s),
                    s.__emitterProxy && delete s.__emitterProxy;
                    for (var a = arguments.length, r = new Array(a), n = 0; n < a; n++)
                        r[n] = arguments[n];
                    t.apply(i, r)
                }
                return s.__emitterProxy = t,
                i.on(e, s, a)
            },
            onAny: function(e, t) {
                var a = this;
                if ("function" != typeof e)
                    return a;
                var i = t ? "unshift" : "push";
                return a.eventsAnyListeners.indexOf(e) < 0 && a.eventsAnyListeners[i](e),
                a
            },
            offAny: function(e) {
                var t = this;
                if (!t.eventsAnyListeners)
                    return t;
                var a = t.eventsAnyListeners.indexOf(e);
                return a >= 0 && t.eventsAnyListeners.splice(a, 1),
                t
            },
            off: function(e, t) {
                var a = this;
                return a.eventsListeners ? (e.split(" ").forEach((function(e) {
                    void 0 === t ? a.eventsListeners[e] = [] : a.eventsListeners[e] && a.eventsListeners[e].forEach((function(i, s) {
                        (i === t || i.__emitterProxy && i.__emitterProxy === t) && a.eventsListeners[e].splice(s, 1)
                    }
                    ))
                }
                )),
                a) : a
            },
            emit: function() {
                var e, t, a, i = this;
                if (!i.eventsListeners)
                    return i;
                for (var s = arguments.length, r = new Array(s), n = 0; n < s; n++)
                    r[n] = arguments[n];
                "string" == typeof r[0] || Array.isArray(r[0]) ? (e = r[0],
                t = r.slice(1, r.length),
                a = i) : (e = r[0].events,
                t = r[0].data,
                a = r[0].context || i),
                t.unshift(a);
                var l = Array.isArray(e) ? e : e.split(" ");
                return l.forEach((function(e) {
                    i.eventsAnyListeners && i.eventsAnyListeners.length && i.eventsAnyListeners.forEach((function(i) {
                        i.apply(a, [e].concat(t))
                    }
                    )),
                    i.eventsListeners && i.eventsListeners[e] && i.eventsListeners[e].forEach((function(e) {
                        e.apply(a, t)
                    }
                    ))
                }
                )),
                i
            }
        },
        update: {
            updateSize: function() {
                var e, t, a = this, i = a.$el;
                e = void 0 !== a.params.width && null !== a.params.width ? a.params.width : i[0].clientWidth,
                t = void 0 !== a.params.height && null !== a.params.height ? a.params.height : i[0].clientHeight,
                0 === e && a.isHorizontal() || 0 === t && a.isVertical() || (e = e - parseInt(i.css("padding-left") || 0, 10) - parseInt(i.css("padding-right") || 0, 10),
                t = t - parseInt(i.css("padding-top") || 0, 10) - parseInt(i.css("padding-bottom") || 0, 10),
                Number.isNaN(e) && (e = 0),
                Number.isNaN(t) && (t = 0),
                S(a, {
                    width: e,
                    height: t,
                    size: a.isHorizontal() ? e : t
                }))
            },
            updateSlides: function() {
                var e = this;
                function t(t) {
                    return e.isHorizontal() ? t : {
                        width: "height",
                        "margin-top": "margin-left",
                        "margin-bottom ": "margin-right",
                        "margin-left": "margin-top",
                        "margin-right": "margin-bottom",
                        "padding-left": "padding-top",
                        "padding-right": "padding-bottom",
                        marginRight: "marginBottom"
                    }[t]
                }
                function a(e, a) {
                    return parseFloat(e.getPropertyValue(t(a)) || 0)
                }
                var i = e.params
                  , s = e.$wrapperEl
                  , r = e.size
                  , n = e.rtlTranslate
                  , l = e.wrongRTL
                  , o = e.virtual && i.virtual.enabled
                  , d = o ? e.virtual.slides.length : e.slides.length
                  , p = s.children("." + e.params.slideClass)
                  , u = o ? e.virtual.slides.length : p.length
                  , c = []
                  , h = []
                  , v = []
                  , f = i.slidesOffsetBefore;
                "function" == typeof f && (f = i.slidesOffsetBefore.call(e));
                var m = i.slidesOffsetAfter;
                "function" == typeof m && (m = i.slidesOffsetAfter.call(e));
                var g = e.snapGrid.length
                  , b = e.slidesGrid.length
                  , y = i.spaceBetween
                  , w = -f
                  , E = 0
                  , x = 0;
                if (void 0 !== r) {
                    var T, C;
                    "string" == typeof y && y.indexOf("%") >= 0 && (y = parseFloat(y.replace("%", "")) / 100 * r),
                    e.virtualSize = -y,
                    n ? p.css({
                        marginLeft: "",
                        marginTop: ""
                    }) : p.css({
                        marginRight: "",
                        marginBottom: ""
                    }),
                    i.slidesPerColumn > 1 && (T = Math.floor(u / i.slidesPerColumn) === u / e.params.slidesPerColumn ? u : Math.ceil(u / i.slidesPerColumn) * i.slidesPerColumn,
                    "auto" !== i.slidesPerView && "row" === i.slidesPerColumnFill && (T = Math.max(T, i.slidesPerView * i.slidesPerColumn)));
                    for (var M, z, P, k = i.slidesPerColumn, $ = T / k, L = Math.floor(u / i.slidesPerColumn), I = 0; I < u; I += 1) {
                        C = 0;
                        var O = p.eq(I);
                        if (i.slidesPerColumn > 1) {
                            var A = void 0
                              , D = void 0
                              , N = void 0;
                            if ("row" === i.slidesPerColumnFill && i.slidesPerGroup > 1) {
                                var G = Math.floor(I / (i.slidesPerGroup * i.slidesPerColumn))
                                  , B = I - i.slidesPerColumn * i.slidesPerGroup * G
                                  , H = 0 === G ? i.slidesPerGroup : Math.min(Math.ceil((u - G * k * i.slidesPerGroup) / k), i.slidesPerGroup);
                                A = (D = B - (N = Math.floor(B / H)) * H + G * i.slidesPerGroup) + N * T / k,
                                O.css({
                                    "-webkit-box-ordinal-group": A,
                                    "-moz-box-ordinal-group": A,
                                    "-ms-flex-order": A,
                                    "-webkit-order": A,
                                    order: A
                                })
                            } else
                                "column" === i.slidesPerColumnFill ? (N = I - (D = Math.floor(I / k)) * k,
                                (D > L || D === L && N === k - 1) && (N += 1) >= k && (N = 0,
                                D += 1)) : D = I - (N = Math.floor(I / $)) * $;
                            O.css(t("margin-top"), 0 !== N && i.spaceBetween && i.spaceBetween + "px")
                        }
                        if ("none" !== O.css("display")) {
                            if ("auto" === i.slidesPerView) {
                                var X = getComputedStyle(O[0])
                                  , Y = O[0].style.transform
                                  , R = O[0].style.webkitTransform;
                                if (Y && (O[0].style.transform = "none"),
                                R && (O[0].style.webkitTransform = "none"),
                                i.roundLengths)
                                    C = e.isHorizontal() ? O.outerWidth(!0) : O.outerHeight(!0);
                                else {
                                    var W = a(X, "width")
                                      , V = a(X, "padding-left")
                                      , F = a(X, "padding-right")
                                      , _ = a(X, "margin-left")
                                      , q = a(X, "margin-right")
                                      , j = X.getPropertyValue("box-sizing");
                                    if (j && "border-box" === j)
                                        C = W + _ + q;
                                    else {
                                        var U = O[0]
                                          , K = U.clientWidth;
                                        C = W + V + F + _ + q + (U.offsetWidth - K)
                                    }
                                }
                                Y && (O[0].style.transform = Y),
                                R && (O[0].style.webkitTransform = R),
                                i.roundLengths && (C = Math.floor(C))
                            } else
                                C = (r - (i.slidesPerView - 1) * y) / i.slidesPerView,
                                i.roundLengths && (C = Math.floor(C)),
                                p[I] && (p[I].style[t("width")] = C + "px");
                            p[I] && (p[I].swiperSlideSize = C),
                            v.push(C),
                            i.centeredSlides ? (w = w + C / 2 + E / 2 + y,
                            0 === E && 0 !== I && (w = w - r / 2 - y),
                            0 === I && (w = w - r / 2 - y),
                            Math.abs(w) < .001 && (w = 0),
                            i.roundLengths && (w = Math.floor(w)),
                            x % i.slidesPerGroup == 0 && c.push(w),
                            h.push(w)) : (i.roundLengths && (w = Math.floor(w)),
                            (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 && c.push(w),
                            h.push(w),
                            w = w + C + y),
                            e.virtualSize += C + y,
                            E = C,
                            x += 1
                        }
                    }
                    if (e.virtualSize = Math.max(e.virtualSize, r) + m,
                    n && l && ("slide" === i.effect || "coverflow" === i.effect) && s.css({
                        width: e.virtualSize + i.spaceBetween + "px"
                    }),
                    i.setWrapperSize)
                        s.css(((z = {})[t("width")] = e.virtualSize + i.spaceBetween + "px",
                        z));
                    if (i.slidesPerColumn > 1)
                        if (e.virtualSize = (C + i.spaceBetween) * T,
                        e.virtualSize = Math.ceil(e.virtualSize / i.slidesPerColumn) - i.spaceBetween,
                        s.css(((P = {})[t("width")] = e.virtualSize + i.spaceBetween + "px",
                        P)),
                        i.centeredSlides) {
                            M = [];
                            for (var Z = 0; Z < c.length; Z += 1) {
                                var J = c[Z];
                                i.roundLengths && (J = Math.floor(J)),
                                c[Z] < e.virtualSize + c[0] && M.push(J)
                            }
                            c = M
                        }
                    if (!i.centeredSlides) {
                        M = [];
                        for (var Q = 0; Q < c.length; Q += 1) {
                            var ee = c[Q];
                            i.roundLengths && (ee = Math.floor(ee)),
                            c[Q] <= e.virtualSize - r && M.push(ee)
                        }
                        c = M,
                        Math.floor(e.virtualSize - r) - Math.floor(c[c.length - 1]) > 1 && c.push(e.virtualSize - r)
                    }
                    if (0 === c.length && (c = [0]),
                    0 !== i.spaceBetween) {
                        var te, ae = e.isHorizontal() && n ? "marginLeft" : t("marginRight");
                        p.filter((function(e, t) {
                            return !i.cssMode || t !== p.length - 1
                        }
                        )).css(((te = {})[ae] = y + "px",
                        te))
                    }
                    if (i.centeredSlides && i.centeredSlidesBounds) {
                        var ie = 0;
                        v.forEach((function(e) {
                            ie += e + (i.spaceBetween ? i.spaceBetween : 0)
                        }
                        ));
                        var se = (ie -= i.spaceBetween) - r;
                        c = c.map((function(e) {
                            return e < 0 ? -f : e > se ? se + m : e
                        }
                        ))
                    }
                    if (i.centerInsufficientSlides) {
                        var re = 0;
                        if (v.forEach((function(e) {
                            re += e + (i.spaceBetween ? i.spaceBetween : 0)
                        }
                        )),
                        (re -= i.spaceBetween) < r) {
                            var ne = (r - re) / 2;
                            c.forEach((function(e, t) {
                                c[t] = e - ne
                            }
                            )),
                            h.forEach((function(e, t) {
                                h[t] = e + ne
                            }
                            ))
                        }
                    }
                    S(e, {
                        slides: p,
                        snapGrid: c,
                        slidesGrid: h,
                        slidesSizesGrid: v
                    }),
                    u !== d && e.emit("slidesLengthChange"),
                    c.length !== g && (e.params.watchOverflow && e.checkOverflow(),
                    e.emit("snapGridLengthChange")),
                    h.length !== b && e.emit("slidesGridLengthChange"),
                    (i.watchSlidesProgress || i.watchSlidesVisibility) && e.updateSlidesOffset()
                }
            },
            updateAutoHeight: function(e) {
                var t, a = this, i = [], s = a.virtual && a.params.virtual.enabled, r = 0;
                "number" == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed);
                var n = function(e) {
                    return s ? a.slides.filter((function(t) {
                        return parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e
                    }
                    ))[0] : a.slides.eq(e)[0]
                };
                if ("auto" !== a.params.slidesPerView && a.params.slidesPerView > 1)
                    if (a.params.centeredSlides)
                        a.visibleSlides.each((function(e) {
                            i.push(e)
                        }
                        ));
                    else
                        for (t = 0; t < Math.ceil(a.params.slidesPerView); t += 1) {
                            var l = a.activeIndex + t;
                            if (l > a.slides.length && !s)
                                break;
                            i.push(n(l))
                        }
                else
                    i.push(n(a.activeIndex));
                for (t = 0; t < i.length; t += 1)
                    if (void 0 !== i[t]) {
                        var o = i[t].offsetHeight;
                        r = o > r ? o : r
                    }
                r && a.$wrapperEl.css("height", r + "px")
            },
            updateSlidesOffset: function() {
                for (var e = this.slides, t = 0; t < e.length; t += 1)
                    e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop
            },
            updateSlidesProgress: function(e) {
                void 0 === e && (e = this && this.translate || 0);
                var t = this
                  , a = t.params
                  , i = t.slides
                  , s = t.rtlTranslate;
                if (0 !== i.length) {
                    void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
                    var r = -e;
                    s && (r = e),
                    i.removeClass(a.slideVisibleClass),
                    t.visibleSlidesIndexes = [],
                    t.visibleSlides = [];
                    for (var n = 0; n < i.length; n += 1) {
                        var l = i[n]
                          , o = (r + (a.centeredSlides ? t.minTranslate() : 0) - l.swiperSlideOffset) / (l.swiperSlideSize + a.spaceBetween);
                        if (a.watchSlidesVisibility || a.centeredSlides && a.autoHeight) {
                            var d = -(r - l.swiperSlideOffset)
                              , p = d + t.slidesSizesGrid[n];
                            (d >= 0 && d < t.size - 1 || p > 1 && p <= t.size || d <= 0 && p >= t.size) && (t.visibleSlides.push(l),
                            t.visibleSlidesIndexes.push(n),
                            i.eq(n).addClass(a.slideVisibleClass))
                        }
                        l.progress = s ? -o : o
                    }
                    t.visibleSlides = m(t.visibleSlides)
                }
            },
            updateProgress: function(e) {
                var t = this;
                if (void 0 === e) {
                    var a = t.rtlTranslate ? -1 : 1;
                    e = t && t.translate && t.translate * a || 0
                }
                var i = t.params
                  , s = t.maxTranslate() - t.minTranslate()
                  , r = t.progress
                  , n = t.isBeginning
                  , l = t.isEnd
                  , o = n
                  , d = l;
                0 === s ? (r = 0,
                n = !0,
                l = !0) : (n = (r = (e - t.minTranslate()) / s) <= 0,
                l = r >= 1),
                S(t, {
                    progress: r,
                    isBeginning: n,
                    isEnd: l
                }),
                (i.watchSlidesProgress || i.watchSlidesVisibility || i.centeredSlides && i.autoHeight) && t.updateSlidesProgress(e),
                n && !o && t.emit("reachBeginning toEdge"),
                l && !d && t.emit("reachEnd toEdge"),
                (o && !n || d && !l) && t.emit("fromEdge"),
                t.emit("progress", r)
            },
            updateSlidesClasses: function() {
                var e, t = this, a = t.slides, i = t.params, s = t.$wrapperEl, r = t.activeIndex, n = t.realIndex, l = t.virtual && i.virtual.enabled;
                a.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass),
                (e = l ? t.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + r + '"]') : a.eq(r)).addClass(i.slideActiveClass),
                i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass));
                var o = e.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass);
                i.loop && 0 === o.length && (o = a.eq(0)).addClass(i.slideNextClass);
                var d = e.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass);
                i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass),
                i.loop && (o.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + o.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + o.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass),
                d.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass)),
                t.emitSlidesClasses()
            },
            updateActiveIndex: function(e) {
                var t, a = this, i = a.rtlTranslate ? a.translate : -a.translate, s = a.slidesGrid, r = a.snapGrid, n = a.params, l = a.activeIndex, o = a.realIndex, d = a.snapIndex, p = e;
                if (void 0 === p) {
                    for (var u = 0; u < s.length; u += 1)
                        void 0 !== s[u + 1] ? i >= s[u] && i < s[u + 1] - (s[u + 1] - s[u]) / 2 ? p = u : i >= s[u] && i < s[u + 1] && (p = u + 1) : i >= s[u] && (p = u);
                    n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0)
                }
                if (r.indexOf(i) >= 0)
                    t = r.indexOf(i);
                else {
                    var c = Math.min(n.slidesPerGroupSkip, p);
                    t = c + Math.floor((p - c) / n.slidesPerGroup)
                }
                if (t >= r.length && (t = r.length - 1),
                p !== l) {
                    var h = parseInt(a.slides.eq(p).attr("data-swiper-slide-index") || p, 10);
                    S(a, {
                        snapIndex: t,
                        realIndex: h,
                        previousIndex: l,
                        activeIndex: p
                    }),
                    a.emit("activeIndexChange"),
                    a.emit("snapIndexChange"),
                    o !== h && a.emit("realIndexChange"),
                    (a.initialized || a.params.runCallbacksOnInit) && a.emit("slideChange")
                } else
                    t !== d && (a.snapIndex = t,
                    a.emit("snapIndexChange"))
            },
            updateClickedSlide: function(e) {
                var t, a = this, i = a.params, s = m(e.target).closest("." + i.slideClass)[0], r = !1;
                if (s)
                    for (var n = 0; n < a.slides.length; n += 1)
                        if (a.slides[n] === s) {
                            r = !0,
                            t = n;
                            break
                        }
                if (!s || !r)
                    return a.clickedSlide = void 0,
                    void (a.clickedIndex = void 0);
                a.clickedSlide = s,
                a.virtual && a.params.virtual.enabled ? a.clickedIndex = parseInt(m(s).attr("data-swiper-slide-index"), 10) : a.clickedIndex = t,
                i.slideToClickedSlide && void 0 !== a.clickedIndex && a.clickedIndex !== a.activeIndex && a.slideToClickedSlide()
            }
        },
        translate: {
            getTranslate: function(e) {
                void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                var t = this
                  , a = t.params
                  , i = t.rtlTranslate
                  , s = t.translate
                  , r = t.$wrapperEl;
                if (a.virtualTranslate)
                    return i ? -s : s;
                if (a.cssMode)
                    return s;
                var n = T(r[0], e);
                return i && (n = -n),
                n || 0
            },
            setTranslate: function(e, t) {
                var a = this
                  , i = a.rtlTranslate
                  , s = a.params
                  , r = a.$wrapperEl
                  , n = a.wrapperEl
                  , l = a.progress
                  , o = 0
                  , d = 0;
                a.isHorizontal() ? o = i ? -e : e : d = e,
                s.roundLengths && (o = Math.floor(o),
                d = Math.floor(d)),
                s.cssMode ? n[a.isHorizontal() ? "scrollLeft" : "scrollTop"] = a.isHorizontal() ? -o : -d : s.virtualTranslate || r.transform("translate3d(" + o + "px, " + d + "px, 0px)"),
                a.previousTranslate = a.translate,
                a.translate = a.isHorizontal() ? o : d;
                var p = a.maxTranslate() - a.minTranslate();
                (0 === p ? 0 : (e - a.minTranslate()) / p) !== l && a.updateProgress(e),
                a.emit("setTranslate", a.translate, t)
            },
            minTranslate: function() {
                return -this.snapGrid[0]
            },
            maxTranslate: function() {
                return -this.snapGrid[this.snapGrid.length - 1]
            },
            translateTo: function(e, t, a, i, s) {
                void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === a && (a = !0),
                void 0 === i && (i = !0);
                var r = this
                  , n = r.params
                  , l = r.wrapperEl;
                if (r.animating && n.preventInteractionOnTransition)
                    return !1;
                var o, d = r.minTranslate(), p = r.maxTranslate();
                if (o = i && e > d ? d : i && e < p ? p : e,
                r.updateProgress(o),
                n.cssMode) {
                    var u, c = r.isHorizontal();
                    if (0 === t)
                        l[c ? "scrollLeft" : "scrollTop"] = -o;
                    else if (l.scrollTo)
                        l.scrollTo(((u = {})[c ? "left" : "top"] = -o,
                        u.behavior = "smooth",
                        u));
                    else
                        l[c ? "scrollLeft" : "scrollTop"] = -o;
                    return !0
                }
                return 0 === t ? (r.setTransition(0),
                r.setTranslate(o),
                a && (r.emit("beforeTransitionStart", t, s),
                r.emit("transitionEnd"))) : (r.setTransition(t),
                r.setTranslate(o),
                a && (r.emit("beforeTransitionStart", t, s),
                r.emit("transitionStart")),
                r.animating || (r.animating = !0,
                r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(e) {
                    r && !r.destroyed && e.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd),
                    r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd),
                    r.onTranslateToWrapperTransitionEnd = null,
                    delete r.onTranslateToWrapperTransitionEnd,
                    a && r.emit("transitionEnd"))
                }
                ),
                r.$wrapperEl[0].addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd),
                r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd))),
                !0
            }
        },
        transition: {
            setTransition: function(e, t) {
                var a = this;
                a.params.cssMode || a.$wrapperEl.transition(e),
                a.emit("setTransition", e, t)
            },
            transitionStart: function(e, t) {
                void 0 === e && (e = !0);
                var a = this
                  , i = a.activeIndex
                  , s = a.params
                  , r = a.previousIndex;
                if (!s.cssMode) {
                    s.autoHeight && a.updateAutoHeight();
                    var n = t;
                    if (n || (n = i > r ? "next" : i < r ? "prev" : "reset"),
                    a.emit("transitionStart"),
                    e && i !== r) {
                        if ("reset" === n)
                            return void a.emit("slideResetTransitionStart");
                        a.emit("slideChangeTransitionStart"),
                        "next" === n ? a.emit("slideNextTransitionStart") : a.emit("slidePrevTransitionStart")
                    }
                }
            },
            transitionEnd: function(e, t) {
                void 0 === e && (e = !0);
                var a = this
                  , i = a.activeIndex
                  , s = a.previousIndex
                  , r = a.params;
                if (a.animating = !1,
                !r.cssMode) {
                    a.setTransition(0);
                    var n = t;
                    if (n || (n = i > s ? "next" : i < s ? "prev" : "reset"),
                    a.emit("transitionEnd"),
                    e && i !== s) {
                        if ("reset" === n)
                            return void a.emit("slideResetTransitionEnd");
                        a.emit("slideChangeTransitionEnd"),
                        "next" === n ? a.emit("slideNextTransitionEnd") : a.emit("slidePrevTransitionEnd")
                    }
                }
            }
        },
        slide: {
            slideTo: function(e, t, a, i, s) {
                if (void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === a && (a = !0),
                "number" != typeof e && "string" != typeof e)
                    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof e + "] given.");
                if ("string" == typeof e) {
                    var r = parseInt(e, 10);
                    if (!isFinite(r))
                        throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + e + "] given.");
                    e = r
                }
                var n = this
                  , l = e;
                l < 0 && (l = 0);
                var o = n.params
                  , d = n.snapGrid
                  , p = n.slidesGrid
                  , u = n.previousIndex
                  , c = n.activeIndex
                  , h = n.rtlTranslate
                  , v = n.wrapperEl
                  , f = n.enabled;
                if (n.animating && o.preventInteractionOnTransition || !f && !i && !s)
                    return !1;
                var m = Math.min(n.params.slidesPerGroupSkip, l)
                  , g = m + Math.floor((l - m) / n.params.slidesPerGroup);
                g >= d.length && (g = d.length - 1),
                (c || o.initialSlide || 0) === (u || 0) && a && n.emit("beforeSlideChangeStart");
                var b, y = -d[g];
                if (n.updateProgress(y),
                o.normalizeSlideIndex)
                    for (var w = 0; w < p.length; w += 1) {
                        var E = -Math.floor(100 * y)
                          , x = Math.floor(100 * p[w])
                          , T = Math.floor(100 * p[w + 1]);
                        void 0 !== p[w + 1] ? E >= x && E < T - (T - x) / 2 ? l = w : E >= x && E < T && (l = w + 1) : E >= x && (l = w)
                    }
                if (n.initialized && l !== c) {
                    if (!n.allowSlideNext && y < n.translate && y < n.minTranslate())
                        return !1;
                    if (!n.allowSlidePrev && y > n.translate && y > n.maxTranslate() && (c || 0) !== l)
                        return !1
                }
                if (b = l > c ? "next" : l < c ? "prev" : "reset",
                h && -y === n.translate || !h && y === n.translate)
                    return n.updateActiveIndex(l),
                    o.autoHeight && n.updateAutoHeight(),
                    n.updateSlidesClasses(),
                    "slide" !== o.effect && n.setTranslate(y),
                    "reset" !== b && (n.transitionStart(a, b),
                    n.transitionEnd(a, b)),
                    !1;
                if (o.cssMode) {
                    var C, S = n.isHorizontal(), M = -y;
                    if (h && (M = v.scrollWidth - v.offsetWidth - M),
                    0 === t)
                        v[S ? "scrollLeft" : "scrollTop"] = M;
                    else if (v.scrollTo)
                        v.scrollTo(((C = {})[S ? "left" : "top"] = M,
                        C.behavior = "smooth",
                        C));
                    else
                        v[S ? "scrollLeft" : "scrollTop"] = M;
                    return !0
                }
                return 0 === t ? (n.setTransition(0),
                n.setTranslate(y),
                n.updateActiveIndex(l),
                n.updateSlidesClasses(),
                n.emit("beforeTransitionStart", t, i),
                n.transitionStart(a, b),
                n.transitionEnd(a, b)) : (n.setTransition(t),
                n.setTranslate(y),
                n.updateActiveIndex(l),
                n.updateSlidesClasses(),
                n.emit("beforeTransitionStart", t, i),
                n.transitionStart(a, b),
                n.animating || (n.animating = !0,
                n.onSlideToWrapperTransitionEnd || (n.onSlideToWrapperTransitionEnd = function(e) {
                    n && !n.destroyed && e.target === this && (n.$wrapperEl[0].removeEventListener("transitionend", n.onSlideToWrapperTransitionEnd),
                    n.$wrapperEl[0].removeEventListener("webkitTransitionEnd", n.onSlideToWrapperTransitionEnd),
                    n.onSlideToWrapperTransitionEnd = null,
                    delete n.onSlideToWrapperTransitionEnd,
                    n.transitionEnd(a, b))
                }
                ),
                n.$wrapperEl[0].addEventListener("transitionend", n.onSlideToWrapperTransitionEnd),
                n.$wrapperEl[0].addEventListener("webkitTransitionEnd", n.onSlideToWrapperTransitionEnd))),
                !0
            },
            slideToLoop: function(e, t, a, i) {
                void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === a && (a = !0);
                var s = this
                  , r = e;
                return s.params.loop && (r += s.loopedSlides),
                s.slideTo(r, t, a, i)
            },
            slideNext: function(e, t, a) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0);
                var i = this
                  , s = i.params
                  , r = i.animating;
                if (!i.enabled)
                    return i;
                var n = i.activeIndex < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup;
                if (s.loop) {
                    if (r && s.loopPreventsSlide)
                        return !1;
                    i.loopFix(),
                    i._clientLeft = i.$wrapperEl[0].clientLeft
                }
                return i.slideTo(i.activeIndex + n, e, t, a)
            },
            slidePrev: function(e, t, a) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0);
                var i = this
                  , s = i.params
                  , r = i.animating
                  , n = i.snapGrid
                  , l = i.slidesGrid
                  , o = i.rtlTranslate;
                if (!i.enabled)
                    return i;
                if (s.loop) {
                    if (r && s.loopPreventsSlide)
                        return !1;
                    i.loopFix(),
                    i._clientLeft = i.$wrapperEl[0].clientLeft
                }
                function d(e) {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                }
                var p = d(o ? i.translate : -i.translate)
                  , u = n.map((function(e) {
                    return d(e)
                }
                ));
                n[u.indexOf(p)];
                var c, h = n[u.indexOf(p) - 1];
                return void 0 === h && s.cssMode && n.forEach((function(e) {
                    !h && p >= e && (h = e)
                }
                )),
                void 0 !== h && (c = l.indexOf(h)) < 0 && (c = i.activeIndex - 1),
                i.slideTo(c, e, t, a)
            },
            slideReset: function(e, t, a) {
                return void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                this.slideTo(this.activeIndex, e, t, a)
            },
            slideToClosest: function(e, t, a, i) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                void 0 === i && (i = .5);
                var s = this
                  , r = s.activeIndex
                  , n = Math.min(s.params.slidesPerGroupSkip, r)
                  , l = n + Math.floor((r - n) / s.params.slidesPerGroup)
                  , o = s.rtlTranslate ? s.translate : -s.translate;
                if (o >= s.snapGrid[l]) {
                    var d = s.snapGrid[l];
                    o - d > (s.snapGrid[l + 1] - d) * i && (r += s.params.slidesPerGroup)
                } else {
                    var p = s.snapGrid[l - 1];
                    o - p <= (s.snapGrid[l] - p) * i && (r -= s.params.slidesPerGroup)
                }
                return r = Math.max(r, 0),
                r = Math.min(r, s.slidesGrid.length - 1),
                s.slideTo(r, e, t, a)
            },
            slideToClickedSlide: function() {
                var e, t = this, a = t.params, i = t.$wrapperEl, s = "auto" === a.slidesPerView ? t.slidesPerViewDynamic() : a.slidesPerView, r = t.clickedIndex;
                if (a.loop) {
                    if (t.animating)
                        return;
                    e = parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"), 10),
                    a.centeredSlides ? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2 ? (t.loopFix(),
                    r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(),
                    E((function() {
                        t.slideTo(r)
                    }
                    ))) : t.slideTo(r) : r > t.slides.length - s ? (t.loopFix(),
                    r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(),
                    E((function() {
                        t.slideTo(r)
                    }
                    ))) : t.slideTo(r)
                } else
                    t.slideTo(r)
            }
        },
        loop: {
            loopCreate: function() {
                var e = this
                  , t = r()
                  , a = e.params
                  , i = e.$wrapperEl;
                i.children("." + a.slideClass + "." + a.slideDuplicateClass).remove();
                var s = i.children("." + a.slideClass);
                if (a.loopFillGroupWithBlank) {
                    var n = a.slidesPerGroup - s.length % a.slidesPerGroup;
                    if (n !== a.slidesPerGroup) {
                        for (var l = 0; l < n; l += 1) {
                            var o = m(t.createElement("div")).addClass(a.slideClass + " " + a.slideBlankClass);
                            i.append(o)
                        }
                        s = i.children("." + a.slideClass)
                    }
                }
                "auto" !== a.slidesPerView || a.loopedSlides || (a.loopedSlides = s.length),
                e.loopedSlides = Math.ceil(parseFloat(a.loopedSlides || a.slidesPerView, 10)),
                e.loopedSlides += a.loopAdditionalSlides,
                e.loopedSlides > s.length && (e.loopedSlides = s.length);
                var d = []
                  , p = [];
                s.each((function(t, a) {
                    var i = m(t);
                    a < e.loopedSlides && p.push(t),
                    a < s.length && a >= s.length - e.loopedSlides && d.push(t),
                    i.attr("data-swiper-slide-index", a)
                }
                ));
                for (var u = 0; u < p.length; u += 1)
                    i.append(m(p[u].cloneNode(!0)).addClass(a.slideDuplicateClass));
                for (var c = d.length - 1; c >= 0; c -= 1)
                    i.prepend(m(d[c].cloneNode(!0)).addClass(a.slideDuplicateClass))
            },
            loopFix: function() {
                var e = this;
                e.emit("beforeLoopFix");
                var t, a = e.activeIndex, i = e.slides, s = e.loopedSlides, r = e.allowSlidePrev, n = e.allowSlideNext, l = e.snapGrid, o = e.rtlTranslate;
                e.allowSlidePrev = !0,
                e.allowSlideNext = !0;
                var d = -l[a] - e.getTranslate();
                if (a < s)
                    t = i.length - 3 * s + a,
                    t += s,
                    e.slideTo(t, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d);
                else if (a >= i.length - s) {
                    t = -i.length + a + s,
                    t += s,
                    e.slideTo(t, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d)
                }
                e.allowSlidePrev = r,
                e.allowSlideNext = n,
                e.emit("loopFix")
            },
            loopDestroy: function() {
                var e = this
                  , t = e.$wrapperEl
                  , a = e.params
                  , i = e.slides;
                t.children("." + a.slideClass + "." + a.slideDuplicateClass + ",." + a.slideClass + "." + a.slideBlankClass).remove(),
                i.removeAttr("data-swiper-slide-index")
            }
        },
        grabCursor: {
            setGrabCursor: function(e) {
                var t = this;
                if (!(t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)) {
                    var a = t.el;
                    a.style.cursor = "move",
                    a.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab",
                    a.style.cursor = e ? "-moz-grabbin" : "-moz-grab",
                    a.style.cursor = e ? "grabbing" : "grab"
                }
            },
            unsetGrabCursor: function() {
                var e = this;
                e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.el.style.cursor = "")
            }
        },
        manipulation: {
            appendSlide: function(e) {
                var t = this
                  , a = t.$wrapperEl
                  , i = t.params;
                if (i.loop && t.loopDestroy(),
                "object" == typeof e && "length"in e)
                    for (var s = 0; s < e.length; s += 1)
                        e[s] && a.append(e[s]);
                else
                    a.append(e);
                i.loop && t.loopCreate(),
                i.observer && t.support.observer || t.update()
            },
            prependSlide: function(e) {
                var t = this
                  , a = t.params
                  , i = t.$wrapperEl
                  , s = t.activeIndex;
                a.loop && t.loopDestroy();
                var r = s + 1;
                if ("object" == typeof e && "length"in e) {
                    for (var n = 0; n < e.length; n += 1)
                        e[n] && i.prepend(e[n]);
                    r = s + e.length
                } else
                    i.prepend(e);
                a.loop && t.loopCreate(),
                a.observer && t.support.observer || t.update(),
                t.slideTo(r, 0, !1)
            },
            addSlide: function(e, t) {
                var a = this
                  , i = a.$wrapperEl
                  , s = a.params
                  , r = a.activeIndex;
                s.loop && (r -= a.loopedSlides,
                a.loopDestroy(),
                a.slides = i.children("." + s.slideClass));
                var n = a.slides.length;
                if (e <= 0)
                    a.prependSlide(t);
                else if (e >= n)
                    a.appendSlide(t);
                else {
                    for (var l = r > e ? r + 1 : r, o = [], d = n - 1; d >= e; d -= 1) {
                        var p = a.slides.eq(d);
                        p.remove(),
                        o.unshift(p)
                    }
                    if ("object" == typeof t && "length"in t) {
                        for (var u = 0; u < t.length; u += 1)
                            t[u] && i.append(t[u]);
                        l = r > e ? r + t.length : r
                    } else
                        i.append(t);
                    for (var c = 0; c < o.length; c += 1)
                        i.append(o[c]);
                    s.loop && a.loopCreate(),
                    s.observer && a.support.observer || a.update(),
                    s.loop ? a.slideTo(l + a.loopedSlides, 0, !1) : a.slideTo(l, 0, !1)
                }
            },
            removeSlide: function(e) {
                var t = this
                  , a = t.params
                  , i = t.$wrapperEl
                  , s = t.activeIndex;
                a.loop && (s -= t.loopedSlides,
                t.loopDestroy(),
                t.slides = i.children("." + a.slideClass));
                var r, n = s;
                if ("object" == typeof e && "length"in e) {
                    for (var l = 0; l < e.length; l += 1)
                        r = e[l],
                        t.slides[r] && t.slides.eq(r).remove(),
                        r < n && (n -= 1);
                    n = Math.max(n, 0)
                } else
                    r = e,
                    t.slides[r] && t.slides.eq(r).remove(),
                    r < n && (n -= 1),
                    n = Math.max(n, 0);
                a.loop && t.loopCreate(),
                a.observer && t.support.observer || t.update(),
                a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1)
            },
            removeAllSlides: function() {
                for (var e = [], t = 0; t < this.slides.length; t += 1)
                    e.push(t);
                this.removeSlide(e)
            }
        },
        events: {
            attachEvents: function() {
                var e = this
                  , t = r()
                  , a = e.params
                  , i = e.touchEvents
                  , s = e.el
                  , n = e.wrapperEl
                  , l = e.device
                  , o = e.support;
                e.onTouchStart = D.bind(e),
                e.onTouchMove = N.bind(e),
                e.onTouchEnd = G.bind(e),
                a.cssMode && (e.onScroll = X.bind(e)),
                e.onClick = H.bind(e);
                var d = !!a.nested;
                if (!o.touch && o.pointerEvents)
                    s.addEventListener(i.start, e.onTouchStart, !1),
                    t.addEventListener(i.move, e.onTouchMove, d),
                    t.addEventListener(i.end, e.onTouchEnd, !1);
                else {
                    if (o.touch) {
                        var p = !("touchstart" !== i.start || !o.passiveListener || !a.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        s.addEventListener(i.start, e.onTouchStart, p),
                        s.addEventListener(i.move, e.onTouchMove, o.passiveListener ? {
                            passive: !1,
                            capture: d
                        } : d),
                        s.addEventListener(i.end, e.onTouchEnd, p),
                        i.cancel && s.addEventListener(i.cancel, e.onTouchEnd, p),
                        Y || (t.addEventListener("touchstart", R),
                        Y = !0)
                    }
                    (a.simulateTouch && !l.ios && !l.android || a.simulateTouch && !o.touch && l.ios) && (s.addEventListener("mousedown", e.onTouchStart, !1),
                    t.addEventListener("mousemove", e.onTouchMove, d),
                    t.addEventListener("mouseup", e.onTouchEnd, !1))
                }
                (a.preventClicks || a.preventClicksPropagation) && s.addEventListener("click", e.onClick, !0),
                a.cssMode && n.addEventListener("scroll", e.onScroll),
                a.updateOnWindowResize ? e.on(l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", B, !0) : e.on("observerUpdate", B, !0)
            },
            detachEvents: function() {
                var e = this
                  , t = r()
                  , a = e.params
                  , i = e.touchEvents
                  , s = e.el
                  , n = e.wrapperEl
                  , l = e.device
                  , o = e.support
                  , d = !!a.nested;
                if (!o.touch && o.pointerEvents)
                    s.removeEventListener(i.start, e.onTouchStart, !1),
                    t.removeEventListener(i.move, e.onTouchMove, d),
                    t.removeEventListener(i.end, e.onTouchEnd, !1);
                else {
                    if (o.touch) {
                        var p = !("onTouchStart" !== i.start || !o.passiveListener || !a.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        s.removeEventListener(i.start, e.onTouchStart, p),
                        s.removeEventListener(i.move, e.onTouchMove, d),
                        s.removeEventListener(i.end, e.onTouchEnd, p),
                        i.cancel && s.removeEventListener(i.cancel, e.onTouchEnd, p)
                    }
                    (a.simulateTouch && !l.ios && !l.android || a.simulateTouch && !o.touch && l.ios) && (s.removeEventListener("mousedown", e.onTouchStart, !1),
                    t.removeEventListener("mousemove", e.onTouchMove, d),
                    t.removeEventListener("mouseup", e.onTouchEnd, !1))
                }
                (a.preventClicks || a.preventClicksPropagation) && s.removeEventListener("click", e.onClick, !0),
                a.cssMode && n.removeEventListener("scroll", e.onScroll),
                e.off(l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", B)
            }
        },
        breakpoints: {
            setBreakpoint: function() {
                var e = this
                  , t = e.activeIndex
                  , a = e.initialized
                  , i = e.loopedSlides
                  , s = void 0 === i ? 0 : i
                  , r = e.params
                  , n = e.$el
                  , l = r.breakpoints;
                if (l && (!l || 0 !== Object.keys(l).length)) {
                    var o = e.getBreakpoint(l, e.params.breakpointsBase, e.el);
                    if (o && e.currentBreakpoint !== o) {
                        var d = o in l ? l[o] : void 0;
                        d && ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach((function(e) {
                            var t = d[e];
                            void 0 !== t && (d[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto")
                        }
                        ));
                        var p = d || e.originalParams
                          , u = r.slidesPerColumn > 1
                          , c = p.slidesPerColumn > 1
                          , h = r.enabled;
                        u && !c ? (n.removeClass(r.containerModifierClass + "multirow " + r.containerModifierClass + "multirow-column"),
                        e.emitContainerClasses()) : !u && c && (n.addClass(r.containerModifierClass + "multirow"),
                        "column" === p.slidesPerColumnFill && n.addClass(r.containerModifierClass + "multirow-column"),
                        e.emitContainerClasses());
                        var v = p.direction && p.direction !== r.direction
                          , f = r.loop && (p.slidesPerView !== r.slidesPerView || v);
                        v && a && e.changeDirection(),
                        S(e.params, p);
                        var m = e.params.enabled;
                        S(e, {
                            allowTouchMove: e.params.allowTouchMove,
                            allowSlideNext: e.params.allowSlideNext,
                            allowSlidePrev: e.params.allowSlidePrev
                        }),
                        h && !m ? e.disable() : !h && m && e.enable(),
                        e.currentBreakpoint = o,
                        e.emit("_beforeBreakpoint", p),
                        f && a && (e.loopDestroy(),
                        e.loopCreate(),
                        e.updateSlides(),
                        e.slideTo(t - s + e.loopedSlides, 0, !1)),
                        e.emit("breakpoint", p)
                    }
                }
            },
            getBreakpoint: function(e, t, a) {
                if (void 0 === t && (t = "window"),
                e && ("container" !== t || a)) {
                    var i = !1
                      , s = l()
                      , r = "window" === t ? s.innerWidth : a.clientWidth
                      , n = "window" === t ? s.innerHeight : a.clientHeight
                      , o = Object.keys(e).map((function(e) {
                        if ("string" == typeof e && 0 === e.indexOf("@")) {
                            var t = parseFloat(e.substr(1));
                            return {
                                value: n * t,
                                point: e
                            }
                        }
                        return {
                            value: e,
                            point: e
                        }
                    }
                    ));
                    o.sort((function(e, t) {
                        return parseInt(e.value, 10) - parseInt(t.value, 10)
                    }
                    ));
                    for (var d = 0; d < o.length; d += 1) {
                        var p = o[d]
                          , u = p.point;
                        p.value <= r && (i = u)
                    }
                    return i || "max"
                }
            }
        },
        checkOverflow: {
            checkOverflow: function() {
                var e = this
                  , t = e.params
                  , a = e.isLocked
                  , i = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
                t.slidesOffsetBefore && t.slidesOffsetAfter && i ? e.isLocked = i <= e.size : e.isLocked = 1 === e.snapGrid.length,
                e.allowSlideNext = !e.isLocked,
                e.allowSlidePrev = !e.isLocked,
                a !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
                a && a !== e.isLocked && (e.isEnd = !1,
                e.navigation && e.navigation.update())
            }
        },
        classes: {
            addClasses: function() {
                var e, t, a, i = this, s = i.classNames, r = i.params, n = i.rtl, l = i.$el, o = i.device, d = i.support, p = (e = ["initialized", r.direction, {
                    "pointer-events": d.pointerEvents && !d.touch
                }, {
                    "free-mode": r.freeMode
                }, {
                    autoheight: r.autoHeight
                }, {
                    rtl: n
                }, {
                    multirow: r.slidesPerColumn > 1
                }, {
                    "multirow-column": r.slidesPerColumn > 1 && "column" === r.slidesPerColumnFill
                }, {
                    android: o.android
                }, {
                    ios: o.ios
                }, {
                    "css-mode": r.cssMode
                }],
                t = r.containerModifierClass,
                a = [],
                e.forEach((function(e) {
                    "object" == typeof e ? Object.keys(e).forEach((function(i) {
                        e[i] && a.push(t + i)
                    }
                    )) : "string" == typeof e && a.push(t + e)
                }
                )),
                a);
                s.push.apply(s, p),
                l.addClass([].concat(s).join(" ")),
                i.emitContainerClasses()
            },
            removeClasses: function() {
                var e = this
                  , t = e.$el
                  , a = e.classNames;
                t.removeClass(a.join(" ")),
                e.emitContainerClasses()
            }
        },
        images: {
            loadImage: function(e, t, a, i, s, r) {
                var n, o = l();
                function d() {
                    r && r()
                }
                m(e).parent("picture")[0] || e.complete && s ? d() : t ? ((n = new o.Image).onload = d,
                n.onerror = d,
                i && (n.sizes = i),
                a && (n.srcset = a),
                t && (n.src = t)) : d()
            },
            preloadImages: function() {
                var e = this;
                function t() {
                    null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                    e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(),
                    e.emit("imagesReady")))
                }
                e.imagesToLoad = e.$el.find("img");
                for (var a = 0; a < e.imagesToLoad.length; a += 1) {
                    var i = e.imagesToLoad[a];
                    e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t)
                }
            }
        }
    }
      , F = {}
      , _ = function() {
        function t() {
            for (var e, a, i = arguments.length, s = new Array(i), r = 0; r < i; r++)
                s[r] = arguments[r];
            if (1 === s.length && s[0].constructor && "Object" === Object.prototype.toString.call(s[0]).slice(8, -1) ? a = s[0] : (e = s[0],
            a = s[1]),
            a || (a = {}),
            a = S({}, a),
            e && !a.el && (a.el = e),
            a.el && m(a.el).length > 1) {
                var n = [];
                return m(a.el).each((function(e) {
                    var i = S({}, a, {
                        el: e
                    });
                    n.push(new t(i))
                }
                )),
                n
            }
            var l = this;
            l.__swiper__ = !0,
            l.support = k(),
            l.device = $({
                userAgent: a.userAgent
            }),
            l.browser = L(),
            l.eventsListeners = {},
            l.eventsAnyListeners = [],
            void 0 === l.modules && (l.modules = {}),
            Object.keys(l.modules).forEach((function(e) {
                var t = l.modules[e];
                if (t.params) {
                    var i = Object.keys(t.params)[0]
                      , s = t.params[i];
                    if ("object" != typeof s || null === s)
                        return;
                    if (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && !0 === a[i] && (a[i] = {
                        auto: !0
                    }),
                    !(i in a) || !("enabled"in s))
                        return;
                    !0 === a[i] && (a[i] = {
                        enabled: !0
                    }),
                    "object" != typeof a[i] || "enabled"in a[i] || (a[i].enabled = !0),
                    a[i] || (a[i] = {
                        enabled: !1
                    })
                }
            }
            ));
            var o, d, p = S({}, W);
            return l.useParams(p),
            l.params = S({}, p, F, a),
            l.originalParams = S({}, l.params),
            l.passedParams = S({}, a),
            l.params && l.params.on && Object.keys(l.params.on).forEach((function(e) {
                l.on(e, l.params.on[e])
            }
            )),
            l.params && l.params.onAny && l.onAny(l.params.onAny),
            l.$ = m,
            S(l, {
                enabled: l.params.enabled,
                el: e,
                classNames: [],
                slides: m(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function() {
                    return "horizontal" === l.params.direction
                },
                isVertical: function() {
                    return "vertical" === l.params.direction
                },
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: l.params.allowSlideNext,
                allowSlidePrev: l.params.allowSlidePrev,
                touchEvents: (o = ["touchstart", "touchmove", "touchend", "touchcancel"],
                d = ["mousedown", "mousemove", "mouseup"],
                l.support.pointerEvents && (d = ["pointerdown", "pointermove", "pointerup"]),
                l.touchEventsTouch = {
                    start: o[0],
                    move: o[1],
                    end: o[2],
                    cancel: o[3]
                },
                l.touchEventsDesktop = {
                    start: d[0],
                    move: d[1],
                    end: d[2]
                },
                l.support.touch || !l.params.simulateTouch ? l.touchEventsTouch : l.touchEventsDesktop),
                touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    formElements: "input, select, option, textarea, button, video, label",
                    lastClickTime: x(),
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    isTouchEvent: void 0,
                    startMoving: void 0
                },
                allowClick: !0,
                allowTouchMove: l.params.allowTouchMove,
                touches: {
                    startX: 0,
                    startY: 0,
                    currentX: 0,
                    currentY: 0,
                    diff: 0
                },
                imagesToLoad: [],
                imagesLoaded: 0
            }),
            l.useModules(),
            l.emit("_swiper"),
            l.params.init && l.init(),
            l
        }
        var a, i, s, n = t.prototype;
        return n.enable = function() {
            var e = this;
            e.enabled || (e.enabled = !0,
            e.params.grabCursor && e.setGrabCursor(),
            e.emit("enable"))
        }
        ,
        n.disable = function() {
            var e = this;
            e.enabled && (e.enabled = !1,
            e.params.grabCursor && e.unsetGrabCursor(),
            e.emit("disable"))
        }
        ,
        n.setProgress = function(e, t) {
            var a = this;
            e = Math.min(Math.max(e, 0), 1);
            var i = a.minTranslate()
              , s = (a.maxTranslate() - i) * e + i;
            a.translateTo(s, void 0 === t ? 0 : t),
            a.updateActiveIndex(),
            a.updateSlidesClasses()
        }
        ,
        n.emitContainerClasses = function() {
            var e = this;
            if (e.params._emitClasses && e.el) {
                var t = e.el.className.split(" ").filter((function(t) {
                    return 0 === t.indexOf("swiper-container") || 0 === t.indexOf(e.params.containerModifierClass)
                }
                ));
                e.emit("_containerClasses", t.join(" "))
            }
        }
        ,
        n.getSlideClasses = function(e) {
            var t = this;
            return e.className.split(" ").filter((function(e) {
                return 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass)
            }
            )).join(" ")
        }
        ,
        n.emitSlidesClasses = function() {
            var e = this;
            if (e.params._emitClasses && e.el) {
                var t = [];
                e.slides.each((function(a) {
                    var i = e.getSlideClasses(a);
                    t.push({
                        slideEl: a,
                        classNames: i
                    }),
                    e.emit("_slideClass", a, i)
                }
                )),
                e.emit("_slideClasses", t)
            }
        }
        ,
        n.slidesPerViewDynamic = function() {
            var e = this
              , t = e.params
              , a = e.slides
              , i = e.slidesGrid
              , s = e.size
              , r = e.activeIndex
              , n = 1;
            if (t.centeredSlides) {
                for (var l, o = a[r].swiperSlideSize, d = r + 1; d < a.length; d += 1)
                    a[d] && !l && (n += 1,
                    (o += a[d].swiperSlideSize) > s && (l = !0));
                for (var p = r - 1; p >= 0; p -= 1)
                    a[p] && !l && (n += 1,
                    (o += a[p].swiperSlideSize) > s && (l = !0))
            } else
                for (var u = r + 1; u < a.length; u += 1)
                    i[u] - i[r] < s && (n += 1);
            return n
        }
        ,
        n.update = function() {
            var e = this;
            if (e && !e.destroyed) {
                var t = e.snapGrid
                  , a = e.params;
                a.breakpoints && e.setBreakpoint(),
                e.updateSize(),
                e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                e.params.freeMode ? (i(),
                e.params.autoHeight && e.updateAutoHeight()) : (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || i(),
                a.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                e.emit("update")
            }
            function i() {
                var t = e.rtlTranslate ? -1 * e.translate : e.translate
                  , a = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                e.setTranslate(a),
                e.updateActiveIndex(),
                e.updateSlidesClasses()
            }
        }
        ,
        n.changeDirection = function(e, t) {
            void 0 === t && (t = !0);
            var a = this
              , i = a.params.direction;
            return e || (e = "horizontal" === i ? "vertical" : "horizontal"),
            e === i || "horizontal" !== e && "vertical" !== e || (a.$el.removeClass("" + a.params.containerModifierClass + i).addClass("" + a.params.containerModifierClass + e),
            a.emitContainerClasses(),
            a.params.direction = e,
            a.slides.each((function(t) {
                "vertical" === e ? t.style.width = "" : t.style.height = ""
            }
            )),
            a.emit("changeDirection"),
            t && a.update()),
            a
        }
        ,
        n.mount = function(e) {
            var t = this;
            if (t.mounted)
                return !0;
            var a = m(e || t.params.el);
            if (!(e = a[0]))
                return !1;
            e.swiper = t;
            var i = function() {
                if (e && e.shadowRoot && e.shadowRoot.querySelector) {
                    var i = m(e.shadowRoot.querySelector("." + t.params.wrapperClass));
                    return i.children = function(e) {
                        return a.children(e)
                    }
                    ,
                    i
                }
                return a.children("." + t.params.wrapperClass)
            }();
            if (0 === i.length && t.params.createElements) {
                var s = r().createElement("div");
                i = m(s),
                s.className = t.params.wrapperClass,
                a.append(s),
                a.children("." + t.params.slideClass).each((function(e) {
                    i.append(e)
                }
                ))
            }
            return S(t, {
                $el: a,
                el: e,
                $wrapperEl: i,
                wrapperEl: i[0],
                mounted: !0,
                rtl: "rtl" === e.dir.toLowerCase() || "rtl" === a.css("direction"),
                rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === a.css("direction")),
                wrongRTL: "-webkit-box" === i.css("display")
            }),
            !0
        }
        ,
        n.init = function(e) {
            var t = this;
            return t.initialized || !1 === t.mount(e) || (t.emit("beforeInit"),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.params.loop && t.loopCreate(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.enabled && t.setGrabCursor(),
            t.params.preloadImages && t.preloadImages(),
            t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
            t.attachEvents(),
            t.initialized = !0,
            t.emit("init"),
            t.emit("afterInit")),
            t
        }
        ,
        n.destroy = function(e, t) {
            void 0 === e && (e = !0),
            void 0 === t && (t = !0);
            var a, i = this, s = i.params, r = i.$el, n = i.$wrapperEl, l = i.slides;
            return void 0 === i.params || i.destroyed || (i.emit("beforeDestroy"),
            i.initialized = !1,
            i.detachEvents(),
            s.loop && i.loopDestroy(),
            t && (i.removeClasses(),
            r.removeAttr("style"),
            n.removeAttr("style"),
            l && l.length && l.removeClass([s.slideVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),
            i.emit("destroy"),
            Object.keys(i.eventsListeners).forEach((function(e) {
                i.off(e)
            }
            )),
            !1 !== e && (i.$el[0].swiper = null,
            a = i,
            Object.keys(a).forEach((function(e) {
                try {
                    a[e] = null
                } catch (e) {}
                try {
                    delete a[e]
                } catch (e) {}
            }
            ))),
            i.destroyed = !0),
            null
        }
        ,
        t.extendDefaults = function(e) {
            S(F, e)
        }
        ,
        t.installModule = function(e) {
            t.prototype.modules || (t.prototype.modules = {});
            var a = e.name || Object.keys(t.prototype.modules).length + "_" + x();
            t.prototype.modules[a] = e
        }
        ,
        t.use = function(e) {
            return Array.isArray(e) ? (e.forEach((function(e) {
                return t.installModule(e)
            }
            )),
            t) : (t.installModule(e),
            t)
        }
        ,
        a = t,
        s = [{
            key: "extendedDefaults",
            get: function() {
                return F
            }
        }, {
            key: "defaults",
            get: function() {
                return W
            }
        }],
        (i = null) && e(a.prototype, i),
        s && e(a, s),
        t
    }();
    Object.keys(V).forEach((function(e) {
        Object.keys(V[e]).forEach((function(t) {
            _.prototype[t] = V[e][t]
        }
        ))
    }
    )),
    _.use([I, A]);
    var q = {
        update: function(e) {
            var t = this
              , a = t.params
              , i = a.slidesPerView
              , s = a.slidesPerGroup
              , r = a.centeredSlides
              , n = t.params.virtual
              , l = n.addSlidesBefore
              , o = n.addSlidesAfter
              , d = t.virtual
              , p = d.from
              , u = d.to
              , c = d.slides
              , h = d.slidesGrid
              , v = d.renderSlide
              , f = d.offset;
            t.updateActiveIndex();
            var m, g, b, y = t.activeIndex || 0;
            m = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top",
            r ? (g = Math.floor(i / 2) + s + o,
            b = Math.floor(i / 2) + s + l) : (g = i + (s - 1) + o,
            b = s + l);
            var w = Math.max((y || 0) - b, 0)
              , E = Math.min((y || 0) + g, c.length - 1)
              , x = (t.slidesGrid[w] || 0) - (t.slidesGrid[0] || 0);
            function T() {
                t.updateSlides(),
                t.updateProgress(),
                t.updateSlidesClasses(),
                t.lazy && t.params.lazy.enabled && t.lazy.load()
            }
            if (S(t.virtual, {
                from: w,
                to: E,
                offset: x,
                slidesGrid: t.slidesGrid
            }),
            p === w && u === E && !e)
                return t.slidesGrid !== h && x !== f && t.slides.css(m, x + "px"),
                void t.updateProgress();
            if (t.params.virtual.renderExternal)
                return t.params.virtual.renderExternal.call(t, {
                    offset: x,
                    from: w,
                    to: E,
                    slides: function() {
                        for (var e = [], t = w; t <= E; t += 1)
                            e.push(c[t]);
                        return e
                    }()
                }),
                void (t.params.virtual.renderExternalUpdate && T());
            var C = []
              , M = [];
            if (e)
                t.$wrapperEl.find("." + t.params.slideClass).remove();
            else
                for (var z = p; z <= u; z += 1)
                    (z < w || z > E) && t.$wrapperEl.find("." + t.params.slideClass + '[data-swiper-slide-index="' + z + '"]').remove();
            for (var P = 0; P < c.length; P += 1)
                P >= w && P <= E && (void 0 === u || e ? M.push(P) : (P > u && M.push(P),
                P < p && C.push(P)));
            M.forEach((function(e) {
                t.$wrapperEl.append(v(c[e], e))
            }
            )),
            C.sort((function(e, t) {
                return t - e
            }
            )).forEach((function(e) {
                t.$wrapperEl.prepend(v(c[e], e))
            }
            )),
            t.$wrapperEl.children(".swiper-slide").css(m, x + "px"),
            T()
        },
        renderSlide: function(e, t) {
            var a = this
              , i = a.params.virtual;
            if (i.cache && a.virtual.cache[t])
                return a.virtual.cache[t];
            var s = i.renderSlide ? m(i.renderSlide.call(a, e, t)) : m('<div class="' + a.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + "</div>");
            return s.attr("data-swiper-slide-index") || s.attr("data-swiper-slide-index", t),
            i.cache && (a.virtual.cache[t] = s),
            s
        },
        appendSlide: function(e) {
            var t = this;
            if ("object" == typeof e && "length"in e)
                for (var a = 0; a < e.length; a += 1)
                    e[a] && t.virtual.slides.push(e[a]);
            else
                t.virtual.slides.push(e);
            t.virtual.update(!0)
        },
        prependSlide: function(e) {
            var t = this
              , a = t.activeIndex
              , i = a + 1
              , s = 1;
            if (Array.isArray(e)) {
                for (var r = 0; r < e.length; r += 1)
                    e[r] && t.virtual.slides.unshift(e[r]);
                i = a + e.length,
                s = e.length
            } else
                t.virtual.slides.unshift(e);
            if (t.params.virtual.cache) {
                var n = t.virtual.cache
                  , l = {};
                Object.keys(n).forEach((function(e) {
                    var t = n[e]
                      , a = t.attr("data-swiper-slide-index");
                    a && t.attr("data-swiper-slide-index", parseInt(a, 10) + 1),
                    l[parseInt(e, 10) + s] = t
                }
                )),
                t.virtual.cache = l
            }
            t.virtual.update(!0),
            t.slideTo(i, 0)
        },
        removeSlide: function(e) {
            var t = this;
            if (null != e) {
                var a = t.activeIndex;
                if (Array.isArray(e))
                    for (var i = e.length - 1; i >= 0; i -= 1)
                        t.virtual.slides.splice(e[i], 1),
                        t.params.virtual.cache && delete t.virtual.cache[e[i]],
                        e[i] < a && (a -= 1),
                        a = Math.max(a, 0);
                else
                    t.virtual.slides.splice(e, 1),
                    t.params.virtual.cache && delete t.virtual.cache[e],
                    e < a && (a -= 1),
                    a = Math.max(a, 0);
                t.virtual.update(!0),
                t.slideTo(a, 0)
            }
        },
        removeAllSlides: function() {
            var e = this;
            e.virtual.slides = [],
            e.params.virtual.cache && (e.virtual.cache = {}),
            e.virtual.update(!0),
            e.slideTo(0, 0)
        }
    }
      , j = {
        name: "virtual",
        params: {
            virtual: {
                enabled: !1,
                slides: [],
                cache: !0,
                renderSlide: null,
                renderExternal: null,
                renderExternalUpdate: !0,
                addSlidesBefore: 0,
                addSlidesAfter: 0
            }
        },
        create: function() {
            M(this, {
                virtual: t({}, q, {
                    slides: this.params.virtual.slides,
                    cache: {}
                })
            })
        },
        on: {
            beforeInit: function(e) {
                if (e.params.virtual.enabled) {
                    e.classNames.push(e.params.containerModifierClass + "virtual");
                    var t = {
                        watchSlidesProgress: !0
                    };
                    S(e.params, t),
                    S(e.originalParams, t),
                    e.params.initialSlide || e.virtual.update()
                }
            },
            setTranslate: function(e) {
                e.params.virtual.enabled && e.virtual.update()
            }
        }
    }
      , U = {
        handle: function(e) {
            var t = this;
            if (t.enabled) {
                var a = l()
                  , i = r()
                  , s = t.rtlTranslate
                  , n = e;
                n.originalEvent && (n = n.originalEvent);
                var o = n.keyCode || n.charCode
                  , d = t.params.keyboard.pageUpDown
                  , p = d && 33 === o
                  , u = d && 34 === o
                  , c = 37 === o
                  , h = 39 === o
                  , v = 38 === o
                  , f = 40 === o;
                if (!t.allowSlideNext && (t.isHorizontal() && h || t.isVertical() && f || u))
                    return !1;
                if (!t.allowSlidePrev && (t.isHorizontal() && c || t.isVertical() && v || p))
                    return !1;
                if (!(n.shiftKey || n.altKey || n.ctrlKey || n.metaKey || i.activeElement && i.activeElement.nodeName && ("input" === i.activeElement.nodeName.toLowerCase() || "textarea" === i.activeElement.nodeName.toLowerCase()))) {
                    if (t.params.keyboard.onlyInViewport && (p || u || c || h || v || f)) {
                        var m = !1;
                        if (t.$el.parents("." + t.params.slideClass).length > 0 && 0 === t.$el.parents("." + t.params.slideActiveClass).length)
                            return;
                        var g = t.$el
                          , b = g[0].clientWidth
                          , y = g[0].clientHeight
                          , w = a.innerWidth
                          , E = a.innerHeight
                          , x = t.$el.offset();
                        s && (x.left -= t.$el[0].scrollLeft);
                        for (var T = [[x.left, x.top], [x.left + b, x.top], [x.left, x.top + y], [x.left + b, x.top + y]], C = 0; C < T.length; C += 1) {
                            var S = T[C];
                            if (S[0] >= 0 && S[0] <= w && S[1] >= 0 && S[1] <= E) {
                                if (0 === S[0] && 0 === S[1])
                                    continue;
                                m = !0
                            }
                        }
                        if (!m)
                            return
                    }
                    t.isHorizontal() ? ((p || u || c || h) && (n.preventDefault ? n.preventDefault() : n.returnValue = !1),
                    ((u || h) && !s || (p || c) && s) && t.slideNext(),
                    ((p || c) && !s || (u || h) && s) && t.slidePrev()) : ((p || u || v || f) && (n.preventDefault ? n.preventDefault() : n.returnValue = !1),
                    (u || f) && t.slideNext(),
                    (p || v) && t.slidePrev()),
                    t.emit("keyPress", o)
                }
            }
        },
        enable: function() {
            var e = this
              , t = r();
            e.keyboard.enabled || (m(t).on("keydown", e.keyboard.handle),
            e.keyboard.enabled = !0)
        },
        disable: function() {
            var e = this
              , t = r();
            e.keyboard.enabled && (m(t).off("keydown", e.keyboard.handle),
            e.keyboard.enabled = !1)
        }
    }
      , K = {
        name: "keyboard",
        params: {
            keyboard: {
                enabled: !1,
                onlyInViewport: !0,
                pageUpDown: !0
            }
        },
        create: function() {
            M(this, {
                keyboard: t({
                    enabled: !1
                }, U)
            })
        },
        on: {
            init: function(e) {
                e.params.keyboard.enabled && e.keyboard.enable()
            },
            destroy: function(e) {
                e.keyboard.enabled && e.keyboard.disable()
            }
        }
    };
    var Z = {
        lastScrollTime: x(),
        lastEventBeforeSnap: void 0,
        recentWheelEvents: [],
        event: function() {
            return l().navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function() {
                var e = r()
                  , t = "onwheel"
                  , a = t in e;
                if (!a) {
                    var i = e.createElement("div");
                    i.setAttribute(t, "return;"),
                    a = "function" == typeof i.onwheel
                }
                return !a && e.implementation && e.implementation.hasFeature && !0 !== e.implementation.hasFeature("", "") && (a = e.implementation.hasFeature("Events.wheel", "3.0")),
                a
            }() ? "wheel" : "mousewheel"
        },
        normalize: function(e) {
            var t = 0
              , a = 0
              , i = 0
              , s = 0;
            return "detail"in e && (a = e.detail),
            "wheelDelta"in e && (a = -e.wheelDelta / 120),
            "wheelDeltaY"in e && (a = -e.wheelDeltaY / 120),
            "wheelDeltaX"in e && (t = -e.wheelDeltaX / 120),
            "axis"in e && e.axis === e.HORIZONTAL_AXIS && (t = a,
            a = 0),
            i = 10 * t,
            s = 10 * a,
            "deltaY"in e && (s = e.deltaY),
            "deltaX"in e && (i = e.deltaX),
            e.shiftKey && !i && (i = s,
            s = 0),
            (i || s) && e.deltaMode && (1 === e.deltaMode ? (i *= 40,
            s *= 40) : (i *= 800,
            s *= 800)),
            i && !t && (t = i < 1 ? -1 : 1),
            s && !a && (a = s < 1 ? -1 : 1),
            {
                spinX: t,
                spinY: a,
                pixelX: i,
                pixelY: s
            }
        },
        handleMouseEnter: function() {
            this.enabled && (this.mouseEntered = !0)
        },
        handleMouseLeave: function() {
            this.enabled && (this.mouseEntered = !1)
        },
        handle: function(e) {
            var t = e
              , a = this;
            if (a.enabled) {
                var i = a.params.mousewheel;
                a.params.cssMode && t.preventDefault();
                var s = a.$el;
                if ("container" !== a.params.mousewheel.eventsTarget && (s = m(a.params.mousewheel.eventsTarget)),
                !a.mouseEntered && !s[0].contains(t.target) && !i.releaseOnEdges)
                    return !0;
                t.originalEvent && (t = t.originalEvent);
                var r = 0
                  , n = a.rtlTranslate ? -1 : 1
                  , l = Z.normalize(t);
                if (i.forceToAxis)
                    if (a.isHorizontal()) {
                        if (!(Math.abs(l.pixelX) > Math.abs(l.pixelY)))
                            return !0;
                        r = -l.pixelX * n
                    } else {
                        if (!(Math.abs(l.pixelY) > Math.abs(l.pixelX)))
                            return !0;
                        r = -l.pixelY
                    }
                else
                    r = Math.abs(l.pixelX) > Math.abs(l.pixelY) ? -l.pixelX * n : -l.pixelY;
                if (0 === r)
                    return !0;
                i.invert && (r = -r);
                var o = a.getTranslate() + r * i.sensitivity;
                if (o >= a.minTranslate() && (o = a.minTranslate()),
                o <= a.maxTranslate() && (o = a.maxTranslate()),
                (!!a.params.loop || !(o === a.minTranslate() || o === a.maxTranslate())) && a.params.nested && t.stopPropagation(),
                a.params.freeMode) {
                    var d = {
                        time: x(),
                        delta: Math.abs(r),
                        direction: Math.sign(r)
                    }
                      , p = a.mousewheel.lastEventBeforeSnap
                      , u = p && d.time < p.time + 500 && d.delta <= p.delta && d.direction === p.direction;
                    if (!u) {
                        a.mousewheel.lastEventBeforeSnap = void 0,
                        a.params.loop && a.loopFix();
                        var c = a.getTranslate() + r * i.sensitivity
                          , h = a.isBeginning
                          , v = a.isEnd;
                        if (c >= a.minTranslate() && (c = a.minTranslate()),
                        c <= a.maxTranslate() && (c = a.maxTranslate()),
                        a.setTransition(0),
                        a.setTranslate(c),
                        a.updateProgress(),
                        a.updateActiveIndex(),
                        a.updateSlidesClasses(),
                        (!h && a.isBeginning || !v && a.isEnd) && a.updateSlidesClasses(),
                        a.params.freeModeSticky) {
                            clearTimeout(a.mousewheel.timeout),
                            a.mousewheel.timeout = void 0;
                            var f = a.mousewheel.recentWheelEvents;
                            f.length >= 15 && f.shift();
                            var g = f.length ? f[f.length - 1] : void 0
                              , b = f[0];
                            if (f.push(d),
                            g && (d.delta > g.delta || d.direction !== g.direction))
                                f.splice(0);
                            else if (f.length >= 15 && d.time - b.time < 500 && b.delta - d.delta >= 1 && d.delta <= 6) {
                                var y = r > 0 ? .8 : .2;
                                a.mousewheel.lastEventBeforeSnap = d,
                                f.splice(0),
                                a.mousewheel.timeout = E((function() {
                                    a.slideToClosest(a.params.speed, !0, void 0, y)
                                }
                                ), 0)
                            }
                            a.mousewheel.timeout || (a.mousewheel.timeout = E((function() {
                                a.mousewheel.lastEventBeforeSnap = d,
                                f.splice(0),
                                a.slideToClosest(a.params.speed, !0, void 0, .5)
                            }
                            ), 500))
                        }
                        if (u || a.emit("scroll", t),
                        a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(),
                        c === a.minTranslate() || c === a.maxTranslate())
                            return !0
                    }
                } else {
                    var w = {
                        time: x(),
                        delta: Math.abs(r),
                        direction: Math.sign(r),
                        raw: e
                    }
                      , T = a.mousewheel.recentWheelEvents;
                    T.length >= 2 && T.shift();
                    var C = T.length ? T[T.length - 1] : void 0;
                    if (T.push(w),
                    C ? (w.direction !== C.direction || w.delta > C.delta || w.time > C.time + 150) && a.mousewheel.animateSlider(w) : a.mousewheel.animateSlider(w),
                    a.mousewheel.releaseScroll(w))
                        return !0
                }
                return t.preventDefault ? t.preventDefault() : t.returnValue = !1,
                !1
            }
        },
        animateSlider: function(e) {
            var t = this
              , a = l();
            return !(this.params.mousewheel.thresholdDelta && e.delta < this.params.mousewheel.thresholdDelta) && (!(this.params.mousewheel.thresholdTime && x() - t.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) && (e.delta >= 6 && x() - t.mousewheel.lastScrollTime < 60 || (e.direction < 0 ? t.isEnd && !t.params.loop || t.animating || (t.slideNext(),
            t.emit("scroll", e.raw)) : t.isBeginning && !t.params.loop || t.animating || (t.slidePrev(),
            t.emit("scroll", e.raw)),
            t.mousewheel.lastScrollTime = (new a.Date).getTime(),
            !1)))
        },
        releaseScroll: function(e) {
            var t = this
              , a = t.params.mousewheel;
            if (e.direction < 0) {
                if (t.isEnd && !t.params.loop && a.releaseOnEdges)
                    return !0
            } else if (t.isBeginning && !t.params.loop && a.releaseOnEdges)
                return !0;
            return !1
        },
        enable: function() {
            var e = this
              , t = Z.event();
            if (e.params.cssMode)
                return e.wrapperEl.removeEventListener(t, e.mousewheel.handle),
                !0;
            if (!t)
                return !1;
            if (e.mousewheel.enabled)
                return !1;
            var a = e.$el;
            return "container" !== e.params.mousewheel.eventsTarget && (a = m(e.params.mousewheel.eventsTarget)),
            a.on("mouseenter", e.mousewheel.handleMouseEnter),
            a.on("mouseleave", e.mousewheel.handleMouseLeave),
            a.on(t, e.mousewheel.handle),
            e.mousewheel.enabled = !0,
            !0
        },
        disable: function() {
            var e = this
              , t = Z.event();
            if (e.params.cssMode)
                return e.wrapperEl.addEventListener(t, e.mousewheel.handle),
                !0;
            if (!t)
                return !1;
            if (!e.mousewheel.enabled)
                return !1;
            var a = e.$el;
            return "container" !== e.params.mousewheel.eventsTarget && (a = m(e.params.mousewheel.eventsTarget)),
            a.off(t, e.mousewheel.handle),
            e.mousewheel.enabled = !1,
            !0
        }
    }
      , J = {
        toggleEl: function(e, t) {
            e[t ? "addClass" : "removeClass"](this.params.navigation.disabledClass),
            e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = t)
        },
        update: function() {
            var e = this
              , t = e.params.navigation
              , a = e.navigation.toggleEl;
            if (!e.params.loop) {
                var i = e.navigation
                  , s = i.$nextEl
                  , r = i.$prevEl;
                r && r.length > 0 && (e.isBeginning ? a(r, !0) : a(r, !1),
                e.params.watchOverflow && e.enabled && r[e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
                s && s.length > 0 && (e.isEnd ? a(s, !0) : a(s, !1),
                e.params.watchOverflow && e.enabled && s[e.isLocked ? "addClass" : "removeClass"](t.lockClass))
            }
        },
        onPrevClick: function(e) {
            var t = this;
            e.preventDefault(),
            t.isBeginning && !t.params.loop || t.slidePrev()
        },
        onNextClick: function(e) {
            var t = this;
            e.preventDefault(),
            t.isEnd && !t.params.loop || t.slideNext()
        },
        init: function() {
            var e, t, a = this, i = a.params.navigation;
            (a.params.navigation = P(a.$el, a.params.navigation, a.params.createElements, {
                nextEl: "swiper-button-next",
                prevEl: "swiper-button-prev"
            }),
            i.nextEl || i.prevEl) && (i.nextEl && (e = m(i.nextEl),
            a.params.uniqueNavElements && "string" == typeof i.nextEl && e.length > 1 && 1 === a.$el.find(i.nextEl).length && (e = a.$el.find(i.nextEl))),
            i.prevEl && (t = m(i.prevEl),
            a.params.uniqueNavElements && "string" == typeof i.prevEl && t.length > 1 && 1 === a.$el.find(i.prevEl).length && (t = a.$el.find(i.prevEl))),
            e && e.length > 0 && e.on("click", a.navigation.onNextClick),
            t && t.length > 0 && t.on("click", a.navigation.onPrevClick),
            S(a.navigation, {
                $nextEl: e,
                nextEl: e && e[0],
                $prevEl: t,
                prevEl: t && t[0]
            }),
            a.enabled || (e && e.addClass(i.lockClass),
            t && t.addClass(i.lockClass)))
        },
        destroy: function() {
            var e = this
              , t = e.navigation
              , a = t.$nextEl
              , i = t.$prevEl;
            a && a.length && (a.off("click", e.navigation.onNextClick),
            a.removeClass(e.params.navigation.disabledClass)),
            i && i.length && (i.off("click", e.navigation.onPrevClick),
            i.removeClass(e.params.navigation.disabledClass))
        }
    }
      , Q = {
        update: function() {
            var e = this
              , t = e.rtl
              , a = e.params.pagination;
            if (a.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var i, s = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, r = e.pagination.$el, n = e.params.loop ? Math.ceil((s - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                if (e.params.loop ? ((i = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > s - 1 - 2 * e.loopedSlides && (i -= s - 2 * e.loopedSlides),
                i > n - 1 && (i -= n),
                i < 0 && "bullets" !== e.params.paginationType && (i = n + i)) : i = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0,
                "bullets" === a.type && e.pagination.bullets && e.pagination.bullets.length > 0) {
                    var l, o, d, p = e.pagination.bullets;
                    if (a.dynamicBullets && (e.pagination.bulletSize = p.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0),
                    r.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (a.dynamicMainBullets + 4) + "px"),
                    a.dynamicMainBullets > 1 && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += i - e.previousIndex,
                    e.pagination.dynamicBulletIndex > a.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = a.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)),
                    l = i - e.pagination.dynamicBulletIndex,
                    d = ((o = l + (Math.min(p.length, a.dynamicMainBullets) - 1)) + l) / 2),
                    p.removeClass(a.bulletActiveClass + " " + a.bulletActiveClass + "-next " + a.bulletActiveClass + "-next-next " + a.bulletActiveClass + "-prev " + a.bulletActiveClass + "-prev-prev " + a.bulletActiveClass + "-main"),
                    r.length > 1)
                        p.each((function(e) {
                            var t = m(e)
                              , s = t.index();
                            s === i && t.addClass(a.bulletActiveClass),
                            a.dynamicBullets && (s >= l && s <= o && t.addClass(a.bulletActiveClass + "-main"),
                            s === l && t.prev().addClass(a.bulletActiveClass + "-prev").prev().addClass(a.bulletActiveClass + "-prev-prev"),
                            s === o && t.next().addClass(a.bulletActiveClass + "-next").next().addClass(a.bulletActiveClass + "-next-next"))
                        }
                        ));
                    else {
                        var u = p.eq(i)
                          , c = u.index();
                        if (u.addClass(a.bulletActiveClass),
                        a.dynamicBullets) {
                            for (var h = p.eq(l), v = p.eq(o), f = l; f <= o; f += 1)
                                p.eq(f).addClass(a.bulletActiveClass + "-main");
                            if (e.params.loop)
                                if (c >= p.length - a.dynamicMainBullets) {
                                    for (var g = a.dynamicMainBullets; g >= 0; g -= 1)
                                        p.eq(p.length - g).addClass(a.bulletActiveClass + "-main");
                                    p.eq(p.length - a.dynamicMainBullets - 1).addClass(a.bulletActiveClass + "-prev")
                                } else
                                    h.prev().addClass(a.bulletActiveClass + "-prev").prev().addClass(a.bulletActiveClass + "-prev-prev"),
                                    v.next().addClass(a.bulletActiveClass + "-next").next().addClass(a.bulletActiveClass + "-next-next");
                            else
                                h.prev().addClass(a.bulletActiveClass + "-prev").prev().addClass(a.bulletActiveClass + "-prev-prev"),
                                v.next().addClass(a.bulletActiveClass + "-next").next().addClass(a.bulletActiveClass + "-next-next")
                        }
                    }
                    if (a.dynamicBullets) {
                        var b = Math.min(p.length, a.dynamicMainBullets + 4)
                          , y = (e.pagination.bulletSize * b - e.pagination.bulletSize) / 2 - d * e.pagination.bulletSize
                          , w = t ? "right" : "left";
                        p.css(e.isHorizontal() ? w : "top", y + "px")
                    }
                }
                if ("fraction" === a.type && (r.find(z(a.currentClass)).text(a.formatFractionCurrent(i + 1)),
                r.find(z(a.totalClass)).text(a.formatFractionTotal(n))),
                "progressbar" === a.type) {
                    var E;
                    E = a.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
                    var x = (i + 1) / n
                      , T = 1
                      , C = 1;
                    "horizontal" === E ? T = x : C = x,
                    r.find(z(a.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + T + ") scaleY(" + C + ")").transition(e.params.speed)
                }
                "custom" === a.type && a.renderCustom ? (r.html(a.renderCustom(e, i + 1, n)),
                e.emit("paginationRender", r[0])) : e.emit("paginationUpdate", r[0]),
                e.params.watchOverflow && e.enabled && r[e.isLocked ? "addClass" : "removeClass"](a.lockClass)
            }
        },
        render: function() {
            var e = this
              , t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length
                  , i = e.pagination.$el
                  , s = "";
                if ("bullets" === t.type) {
                    var r = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                    e.params.freeMode && !e.params.loop && r > a && (r = a);
                    for (var n = 0; n < r; n += 1)
                        t.renderBullet ? s += t.renderBullet.call(e, n, t.bulletClass) : s += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
                    i.html(s),
                    e.pagination.bullets = i.find(z(t.bulletClass))
                }
                "fraction" === t.type && (s = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>',
                i.html(s)),
                "progressbar" === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>',
                i.html(s)),
                "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0])
            }
        },
        init: function() {
            var e = this;
            e.params.pagination = P(e.$el, e.params.pagination, e.params.createElements, {
                el: "swiper-pagination"
            });
            var t = e.params.pagination;
            if (t.el) {
                var a = m(t.el);
                0 !== a.length && (e.params.uniqueNavElements && "string" == typeof t.el && a.length > 1 && (a = e.$el.find(t.el)),
                "bullets" === t.type && t.clickable && a.addClass(t.clickableClass),
                a.addClass(t.modifierClass + t.type),
                "bullets" === t.type && t.dynamicBullets && (a.addClass("" + t.modifierClass + t.type + "-dynamic"),
                e.pagination.dynamicBulletIndex = 0,
                t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                "progressbar" === t.type && t.progressbarOpposite && a.addClass(t.progressbarOppositeClass),
                t.clickable && a.on("click", z(t.bulletClass), (function(t) {
                    t.preventDefault();
                    var a = m(this).index() * e.params.slidesPerGroup;
                    e.params.loop && (a += e.loopedSlides),
                    e.slideTo(a)
                }
                )),
                S(e.pagination, {
                    $el: a,
                    el: a[0]
                }),
                e.enabled || a.addClass(t.lockClass))
            }
        },
        destroy: function() {
            var e = this
              , t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.pagination.$el;
                a.removeClass(t.hiddenClass),
                a.removeClass(t.modifierClass + t.type),
                e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass),
                t.clickable && a.off("click", z(t.bulletClass))
            }
        }
    }
      , ee = {
        setTranslate: function() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar
                  , a = e.rtlTranslate
                  , i = e.progress
                  , s = t.dragSize
                  , r = t.trackSize
                  , n = t.$dragEl
                  , l = t.$el
                  , o = e.params.scrollbar
                  , d = s
                  , p = (r - s) * i;
                a ? (p = -p) > 0 ? (d = s - p,
                p = 0) : -p + s > r && (d = r + p) : p < 0 ? (d = s + p,
                p = 0) : p + s > r && (d = r - p),
                e.isHorizontal() ? (n.transform("translate3d(" + p + "px, 0, 0)"),
                n[0].style.width = d + "px") : (n.transform("translate3d(0px, " + p + "px, 0)"),
                n[0].style.height = d + "px"),
                o.hide && (clearTimeout(e.scrollbar.timeout),
                l[0].style.opacity = 1,
                e.scrollbar.timeout = setTimeout((function() {
                    l[0].style.opacity = 0,
                    l.transition(400)
                }
                ), 1e3))
            }
        },
        setTransition: function(e) {
            var t = this;
            t.params.scrollbar.el && t.scrollbar.el && t.scrollbar.$dragEl.transition(e)
        },
        updateSize: function() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar
                  , a = t.$dragEl
                  , i = t.$el;
                a[0].style.width = "",
                a[0].style.height = "";
                var s, r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight, n = e.size / e.virtualSize, l = n * (r / e.size);
                s = "auto" === e.params.scrollbar.dragSize ? r * n : parseInt(e.params.scrollbar.dragSize, 10),
                e.isHorizontal() ? a[0].style.width = s + "px" : a[0].style.height = s + "px",
                i[0].style.display = n >= 1 ? "none" : "",
                e.params.scrollbar.hide && (i[0].style.opacity = 0),
                S(t, {
                    trackSize: r,
                    divider: n,
                    moveDivider: l,
                    dragSize: s
                }),
                e.params.watchOverflow && e.enabled && t.$el[e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass)
            }
        },
        getPointerPosition: function(e) {
            return this.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientX : e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientY : e.clientY
        },
        setDragPosition: function(e) {
            var t, a = this, i = a.scrollbar, s = a.rtlTranslate, r = i.$el, n = i.dragSize, l = i.trackSize, o = i.dragStartPos;
            t = (i.getPointerPosition(e) - r.offset()[a.isHorizontal() ? "left" : "top"] - (null !== o ? o : n / 2)) / (l - n),
            t = Math.max(Math.min(t, 1), 0),
            s && (t = 1 - t);
            var d = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
            a.updateProgress(d),
            a.setTranslate(d),
            a.updateActiveIndex(),
            a.updateSlidesClasses()
        },
        onDragStart: function(e) {
            var t = this
              , a = t.params.scrollbar
              , i = t.scrollbar
              , s = t.$wrapperEl
              , r = i.$el
              , n = i.$dragEl;
            t.scrollbar.isTouched = !0,
            t.scrollbar.dragStartPos = e.target === n[0] || e.target === n ? i.getPointerPosition(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null,
            e.preventDefault(),
            e.stopPropagation(),
            s.transition(100),
            n.transition(100),
            i.setDragPosition(e),
            clearTimeout(t.scrollbar.dragTimeout),
            r.transition(0),
            a.hide && r.css("opacity", 1),
            t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
            t.emit("scrollbarDragStart", e)
        },
        onDragMove: function(e) {
            var t = this
              , a = t.scrollbar
              , i = t.$wrapperEl
              , s = a.$el
              , r = a.$dragEl;
            t.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1,
            a.setDragPosition(e),
            i.transition(0),
            s.transition(0),
            r.transition(0),
            t.emit("scrollbarDragMove", e))
        },
        onDragEnd: function(e) {
            var t = this
              , a = t.params.scrollbar
              , i = t.scrollbar
              , s = t.$wrapperEl
              , r = i.$el;
            t.scrollbar.isTouched && (t.scrollbar.isTouched = !1,
            t.params.cssMode && (t.$wrapperEl.css("scroll-snap-type", ""),
            s.transition("")),
            a.hide && (clearTimeout(t.scrollbar.dragTimeout),
            t.scrollbar.dragTimeout = E((function() {
                r.css("opacity", 0),
                r.transition(400)
            }
            ), 1e3)),
            t.emit("scrollbarDragEnd", e),
            a.snapOnRelease && t.slideToClosest())
        },
        enableDraggable: function() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = r()
                  , a = e.scrollbar
                  , i = e.touchEventsTouch
                  , s = e.touchEventsDesktop
                  , n = e.params
                  , l = e.support
                  , o = a.$el[0]
                  , d = !(!l.passiveListener || !n.passiveListeners) && {
                    passive: !1,
                    capture: !1
                }
                  , p = !(!l.passiveListener || !n.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                o && (l.touch ? (o.addEventListener(i.start, e.scrollbar.onDragStart, d),
                o.addEventListener(i.move, e.scrollbar.onDragMove, d),
                o.addEventListener(i.end, e.scrollbar.onDragEnd, p)) : (o.addEventListener(s.start, e.scrollbar.onDragStart, d),
                t.addEventListener(s.move, e.scrollbar.onDragMove, d),
                t.addEventListener(s.end, e.scrollbar.onDragEnd, p)))
            }
        },
        disableDraggable: function() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = r()
                  , a = e.scrollbar
                  , i = e.touchEventsTouch
                  , s = e.touchEventsDesktop
                  , n = e.params
                  , l = e.support
                  , o = a.$el[0]
                  , d = !(!l.passiveListener || !n.passiveListeners) && {
                    passive: !1,
                    capture: !1
                }
                  , p = !(!l.passiveListener || !n.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                o && (l.touch ? (o.removeEventListener(i.start, e.scrollbar.onDragStart, d),
                o.removeEventListener(i.move, e.scrollbar.onDragMove, d),
                o.removeEventListener(i.end, e.scrollbar.onDragEnd, p)) : (o.removeEventListener(s.start, e.scrollbar.onDragStart, d),
                t.removeEventListener(s.move, e.scrollbar.onDragMove, d),
                t.removeEventListener(s.end, e.scrollbar.onDragEnd, p)))
            }
        },
        init: function() {
            var e = this
              , t = e.scrollbar
              , a = e.$el;
            e.params.scrollbar = P(a, e.params.scrollbar, e.params.createElements, {
                el: "swiper-scrollbar"
            });
            var i = e.params.scrollbar;
            if (i.el) {
                var s = m(i.el);
                e.params.uniqueNavElements && "string" == typeof i.el && s.length > 1 && 1 === a.find(i.el).length && (s = a.find(i.el));
                var r = s.find("." + e.params.scrollbar.dragClass);
                0 === r.length && (r = m('<div class="' + e.params.scrollbar.dragClass + '"></div>'),
                s.append(r)),
                S(t, {
                    $el: s,
                    el: s[0],
                    $dragEl: r,
                    dragEl: r[0]
                }),
                i.draggable && t.enableDraggable(),
                s && s[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass)
            }
        },
        destroy: function() {
            this.scrollbar.disableDraggable()
        }
    }
      , te = {
        setTransform: function(e, t) {
            var a = this.rtl
              , i = m(e)
              , s = a ? -1 : 1
              , r = i.attr("data-swiper-parallax") || "0"
              , n = i.attr("data-swiper-parallax-x")
              , l = i.attr("data-swiper-parallax-y")
              , o = i.attr("data-swiper-parallax-scale")
              , d = i.attr("data-swiper-parallax-opacity");
            if (n || l ? (n = n || "0",
            l = l || "0") : this.isHorizontal() ? (n = r,
            l = "0") : (l = r,
            n = "0"),
            n = n.indexOf("%") >= 0 ? parseInt(n, 10) * t * s + "%" : n * t * s + "px",
            l = l.indexOf("%") >= 0 ? parseInt(l, 10) * t + "%" : l * t + "px",
            null != d) {
                var p = d - (d - 1) * (1 - Math.abs(t));
                i[0].style.opacity = p
            }
            if (null == o)
                i.transform("translate3d(" + n + ", " + l + ", 0px)");
            else {
                var u = o - (o - 1) * (1 - Math.abs(t));
                i.transform("translate3d(" + n + ", " + l + ", 0px) scale(" + u + ")")
            }
        },
        setTranslate: function() {
            var e = this
              , t = e.$el
              , a = e.slides
              , i = e.progress
              , s = e.snapGrid;
            t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t) {
                e.parallax.setTransform(t, i)
            }
            )),
            a.each((function(t, a) {
                var r = t.progress;
                e.params.slidesPerGroup > 1 && "auto" !== e.params.slidesPerView && (r += Math.ceil(a / 2) - i * (s.length - 1)),
                r = Math.min(Math.max(r, -1), 1),
                m(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t) {
                    e.parallax.setTransform(t, r)
                }
                ))
            }
            ))
        },
        setTransition: function(e) {
            void 0 === e && (e = this.params.speed);
            this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t) {
                var a = m(t)
                  , i = parseInt(a.attr("data-swiper-parallax-duration"), 10) || e;
                0 === e && (i = 0),
                a.transition(i)
            }
            ))
        }
    }
      , ae = {
        getDistanceBetweenTouches: function(e) {
            if (e.targetTouches.length < 2)
                return 1;
            var t = e.targetTouches[0].pageX
              , a = e.targetTouches[0].pageY
              , i = e.targetTouches[1].pageX
              , s = e.targetTouches[1].pageY;
            return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2))
        },
        onGestureStart: function(e) {
            var t = this
              , a = t.support
              , i = t.params.zoom
              , s = t.zoom
              , r = s.gesture;
            if (s.fakeGestureTouched = !1,
            s.fakeGestureMoved = !1,
            !a.gestures) {
                if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2)
                    return;
                s.fakeGestureTouched = !0,
                r.scaleStart = ae.getDistanceBetweenTouches(e)
            }
            r.$slideEl && r.$slideEl.length || (r.$slideEl = m(e.target).closest("." + t.params.slideClass),
            0 === r.$slideEl.length && (r.$slideEl = t.slides.eq(t.activeIndex)),
            r.$imageEl = r.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),
            r.$imageWrapEl = r.$imageEl.parent("." + i.containerClass),
            r.maxRatio = r.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio,
            0 !== r.$imageWrapEl.length) ? (r.$imageEl && r.$imageEl.transition(0),
            t.zoom.isScaling = !0) : r.$imageEl = void 0
        },
        onGestureChange: function(e) {
            var t = this
              , a = t.support
              , i = t.params.zoom
              , s = t.zoom
              , r = s.gesture;
            if (!a.gestures) {
                if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2)
                    return;
                s.fakeGestureMoved = !0,
                r.scaleMove = ae.getDistanceBetweenTouches(e)
            }
            r.$imageEl && 0 !== r.$imageEl.length ? (a.gestures ? s.scale = e.scale * s.currentScale : s.scale = r.scaleMove / r.scaleStart * s.currentScale,
            s.scale > r.maxRatio && (s.scale = r.maxRatio - 1 + Math.pow(s.scale - r.maxRatio + 1, .5)),
            s.scale < i.minRatio && (s.scale = i.minRatio + 1 - Math.pow(i.minRatio - s.scale + 1, .5)),
            r.$imageEl.transform("translate3d(0,0,0) scale(" + s.scale + ")")) : "gesturechange" === e.type && s.onGestureStart(e)
        },
        onGestureEnd: function(e) {
            var t = this
              , a = t.device
              , i = t.support
              , s = t.params.zoom
              , r = t.zoom
              , n = r.gesture;
            if (!i.gestures) {
                if (!r.fakeGestureTouched || !r.fakeGestureMoved)
                    return;
                if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !a.android)
                    return;
                r.fakeGestureTouched = !1,
                r.fakeGestureMoved = !1
            }
            n.$imageEl && 0 !== n.$imageEl.length && (r.scale = Math.max(Math.min(r.scale, n.maxRatio), s.minRatio),
            n.$imageEl.transition(t.params.speed).transform("translate3d(0,0,0) scale(" + r.scale + ")"),
            r.currentScale = r.scale,
            r.isScaling = !1,
            1 === r.scale && (n.$slideEl = void 0))
        },
        onTouchStart: function(e) {
            var t = this.device
              , a = this.zoom
              , i = a.gesture
              , s = a.image;
            i.$imageEl && 0 !== i.$imageEl.length && (s.isTouched || (t.android && e.cancelable && e.preventDefault(),
            s.isTouched = !0,
            s.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX,
            s.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY))
        },
        onTouchMove: function(e) {
            var t = this
              , a = t.zoom
              , i = a.gesture
              , s = a.image
              , r = a.velocity;
            if (i.$imageEl && 0 !== i.$imageEl.length && (t.allowClick = !1,
            s.isTouched && i.$slideEl)) {
                s.isMoved || (s.width = i.$imageEl[0].offsetWidth,
                s.height = i.$imageEl[0].offsetHeight,
                s.startX = T(i.$imageWrapEl[0], "x") || 0,
                s.startY = T(i.$imageWrapEl[0], "y") || 0,
                i.slideWidth = i.$slideEl[0].offsetWidth,
                i.slideHeight = i.$slideEl[0].offsetHeight,
                i.$imageWrapEl.transition(0),
                t.rtl && (s.startX = -s.startX,
                s.startY = -s.startY));
                var n = s.width * a.scale
                  , l = s.height * a.scale;
                if (!(n < i.slideWidth && l < i.slideHeight)) {
                    if (s.minX = Math.min(i.slideWidth / 2 - n / 2, 0),
                    s.maxX = -s.minX,
                    s.minY = Math.min(i.slideHeight / 2 - l / 2, 0),
                    s.maxY = -s.minY,
                    s.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX,
                    s.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY,
                    !s.isMoved && !a.isScaling) {
                        if (t.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x))
                            return void (s.isTouched = !1);
                        if (!t.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y))
                            return void (s.isTouched = !1)
                    }
                    e.cancelable && e.preventDefault(),
                    e.stopPropagation(),
                    s.isMoved = !0,
                    s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX,
                    s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY,
                    s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)),
                    s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)),
                    s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)),
                    s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)),
                    r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x),
                    r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y),
                    r.prevTime || (r.prevTime = Date.now()),
                    r.x = (s.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2,
                    r.y = (s.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2,
                    Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0),
                    Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0),
                    r.prevPositionX = s.touchesCurrent.x,
                    r.prevPositionY = s.touchesCurrent.y,
                    r.prevTime = Date.now(),
                    i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)")
                }
            }
        },
        onTouchEnd: function() {
            var e = this.zoom
              , t = e.gesture
              , a = e.image
              , i = e.velocity;
            if (t.$imageEl && 0 !== t.$imageEl.length) {
                if (!a.isTouched || !a.isMoved)
                    return a.isTouched = !1,
                    void (a.isMoved = !1);
                a.isTouched = !1,
                a.isMoved = !1;
                var s = 300
                  , r = 300
                  , n = i.x * s
                  , l = a.currentX + n
                  , o = i.y * r
                  , d = a.currentY + o;
                0 !== i.x && (s = Math.abs((l - a.currentX) / i.x)),
                0 !== i.y && (r = Math.abs((d - a.currentY) / i.y));
                var p = Math.max(s, r);
                a.currentX = l,
                a.currentY = d;
                var u = a.width * e.scale
                  , c = a.height * e.scale;
                a.minX = Math.min(t.slideWidth / 2 - u / 2, 0),
                a.maxX = -a.minX,
                a.minY = Math.min(t.slideHeight / 2 - c / 2, 0),
                a.maxY = -a.minY,
                a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX),
                a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY),
                t.$imageWrapEl.transition(p).transform("translate3d(" + a.currentX + "px, " + a.currentY + "px,0)")
            }
        },
        onTransitionEnd: function() {
            var e = this
              , t = e.zoom
              , a = t.gesture;
            a.$slideEl && e.previousIndex !== e.activeIndex && (a.$imageEl && a.$imageEl.transform("translate3d(0,0,0) scale(1)"),
            a.$imageWrapEl && a.$imageWrapEl.transform("translate3d(0,0,0)"),
            t.scale = 1,
            t.currentScale = 1,
            a.$slideEl = void 0,
            a.$imageEl = void 0,
            a.$imageWrapEl = void 0)
        },
        toggle: function(e) {
            var t = this.zoom;
            t.scale && 1 !== t.scale ? t.out() : t.in(e)
        },
        in: function(e) {
            var t, a, i, s, r, n, o, d, p, u, c, h, v, f, m, g, b = this, y = l(), w = b.zoom, E = b.params.zoom, x = w.gesture, T = w.image;
            (x.$slideEl || (b.params.virtual && b.params.virtual.enabled && b.virtual ? x.$slideEl = b.$wrapperEl.children("." + b.params.slideActiveClass) : x.$slideEl = b.slides.eq(b.activeIndex),
            x.$imageEl = x.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),
            x.$imageWrapEl = x.$imageEl.parent("." + E.containerClass)),
            x.$imageEl && 0 !== x.$imageEl.length && x.$imageWrapEl && 0 !== x.$imageWrapEl.length) && (x.$slideEl.addClass("" + E.zoomedSlideClass),
            void 0 === T.touchesStart.x && e ? (t = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX,
            a = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = T.touchesStart.x,
            a = T.touchesStart.y),
            w.scale = x.$imageWrapEl.attr("data-swiper-zoom") || E.maxRatio,
            w.currentScale = x.$imageWrapEl.attr("data-swiper-zoom") || E.maxRatio,
            e ? (m = x.$slideEl[0].offsetWidth,
            g = x.$slideEl[0].offsetHeight,
            i = x.$slideEl.offset().left + y.scrollX + m / 2 - t,
            s = x.$slideEl.offset().top + y.scrollY + g / 2 - a,
            o = x.$imageEl[0].offsetWidth,
            d = x.$imageEl[0].offsetHeight,
            p = o * w.scale,
            u = d * w.scale,
            v = -(c = Math.min(m / 2 - p / 2, 0)),
            f = -(h = Math.min(g / 2 - u / 2, 0)),
            (r = i * w.scale) < c && (r = c),
            r > v && (r = v),
            (n = s * w.scale) < h && (n = h),
            n > f && (n = f)) : (r = 0,
            n = 0),
            x.$imageWrapEl.transition(300).transform("translate3d(" + r + "px, " + n + "px,0)"),
            x.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + w.scale + ")"))
        },
        out: function() {
            var e = this
              , t = e.zoom
              , a = e.params.zoom
              , i = t.gesture;
            i.$slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? i.$slideEl = e.$wrapperEl.children("." + e.params.slideActiveClass) : i.$slideEl = e.slides.eq(e.activeIndex),
            i.$imageEl = i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),
            i.$imageWrapEl = i.$imageEl.parent("." + a.containerClass)),
            i.$imageEl && 0 !== i.$imageEl.length && i.$imageWrapEl && 0 !== i.$imageWrapEl.length && (t.scale = 1,
            t.currentScale = 1,
            i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
            i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
            i.$slideEl.removeClass("" + a.zoomedSlideClass),
            i.$slideEl = void 0)
        },
        toggleGestures: function(e) {
            var t = this
              , a = t.zoom
              , i = a.slideSelector
              , s = a.passiveListener;
            t.$wrapperEl[e]("gesturestart", i, a.onGestureStart, s),
            t.$wrapperEl[e]("gesturechange", i, a.onGestureChange, s),
            t.$wrapperEl[e]("gestureend", i, a.onGestureEnd, s)
        },
        enableGestures: function() {
            this.zoom.gesturesEnabled || (this.zoom.gesturesEnabled = !0,
            this.zoom.toggleGestures("on"))
        },
        disableGestures: function() {
            this.zoom.gesturesEnabled && (this.zoom.gesturesEnabled = !1,
            this.zoom.toggleGestures("off"))
        },
        enable: function() {
            var e = this
              , t = e.support
              , a = e.zoom;
            if (!a.enabled) {
                a.enabled = !0;
                var i = !("touchstart" !== e.touchEvents.start || !t.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                }
                  , s = !t.passiveListener || {
                    passive: !1,
                    capture: !0
                }
                  , r = "." + e.params.slideClass;
                e.zoom.passiveListener = i,
                e.zoom.slideSelector = r,
                t.gestures ? (e.$wrapperEl.on(e.touchEvents.start, e.zoom.enableGestures, i),
                e.$wrapperEl.on(e.touchEvents.end, e.zoom.disableGestures, i)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, r, a.onGestureStart, i),
                e.$wrapperEl.on(e.touchEvents.move, r, a.onGestureChange, s),
                e.$wrapperEl.on(e.touchEvents.end, r, a.onGestureEnd, i),
                e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, r, a.onGestureEnd, i)),
                e.$wrapperEl.on(e.touchEvents.move, "." + e.params.zoom.containerClass, a.onTouchMove, s)
            }
        },
        disable: function() {
            var e = this
              , t = e.zoom;
            if (t.enabled) {
                var a = e.support;
                e.zoom.enabled = !1;
                var i = !("touchstart" !== e.touchEvents.start || !a.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                }
                  , s = !a.passiveListener || {
                    passive: !1,
                    capture: !0
                }
                  , r = "." + e.params.slideClass;
                a.gestures ? (e.$wrapperEl.off(e.touchEvents.start, e.zoom.enableGestures, i),
                e.$wrapperEl.off(e.touchEvents.end, e.zoom.disableGestures, i)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, r, t.onGestureStart, i),
                e.$wrapperEl.off(e.touchEvents.move, r, t.onGestureChange, s),
                e.$wrapperEl.off(e.touchEvents.end, r, t.onGestureEnd, i),
                e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, r, t.onGestureEnd, i)),
                e.$wrapperEl.off(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove, s)
            }
        }
    }
      , ie = {
        loadInSlide: function(e, t) {
            void 0 === t && (t = !0);
            var a = this
              , i = a.params.lazy;
            if (void 0 !== e && 0 !== a.slides.length) {
                var s = a.virtual && a.params.virtual.enabled ? a.$wrapperEl.children("." + a.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : a.slides.eq(e)
                  , r = s.find("." + i.elementClass + ":not(." + i.loadedClass + "):not(." + i.loadingClass + ")");
                !s.hasClass(i.elementClass) || s.hasClass(i.loadedClass) || s.hasClass(i.loadingClass) || r.push(s[0]),
                0 !== r.length && r.each((function(e) {
                    var r = m(e);
                    r.addClass(i.loadingClass);
                    var n = r.attr("data-background")
                      , l = r.attr("data-src")
                      , o = r.attr("data-srcset")
                      , d = r.attr("data-sizes")
                      , p = r.parent("picture");
                    a.loadImage(r[0], l || n, o, d, !1, (function() {
                        if (null != a && a && (!a || a.params) && !a.destroyed) {
                            if (n ? (r.css("background-image", 'url("' + n + '")'),
                            r.removeAttr("data-background")) : (o && (r.attr("srcset", o),
                            r.removeAttr("data-srcset")),
                            d && (r.attr("sizes", d),
                            r.removeAttr("data-sizes")),
                            p.length && p.children("source").each((function(e) {
                                var t = m(e);
                                t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")),
                                t.removeAttr("data-srcset"))
                            }
                            )),
                            l && (r.attr("src", l),
                            r.removeAttr("data-src"))),
                            r.addClass(i.loadedClass).removeClass(i.loadingClass),
                            s.find("." + i.preloaderClass).remove(),
                            a.params.loop && t) {
                                var e = s.attr("data-swiper-slide-index");
                                if (s.hasClass(a.params.slideDuplicateClass)) {
                                    var u = a.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + a.params.slideDuplicateClass + ")");
                                    a.lazy.loadInSlide(u.index(), !1)
                                } else {
                                    var c = a.$wrapperEl.children("." + a.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');
                                    a.lazy.loadInSlide(c.index(), !1)
                                }
                            }
                            a.emit("lazyImageReady", s[0], r[0]),
                            a.params.autoHeight && a.updateAutoHeight()
                        }
                    }
                    )),
                    a.emit("lazyImageLoad", s[0], r[0])
                }
                ))
            }
        },
        load: function() {
            var e = this
              , t = e.$wrapperEl
              , a = e.params
              , i = e.slides
              , s = e.activeIndex
              , r = e.virtual && a.virtual.enabled
              , n = a.lazy
              , l = a.slidesPerView;
            function o(e) {
                if (r) {
                    if (t.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]').length)
                        return !0
                } else if (i[e])
                    return !0;
                return !1
            }
            function d(e) {
                return r ? m(e).attr("data-swiper-slide-index") : m(e).index()
            }
            if ("auto" === l && (l = 0),
            e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0),
            e.params.watchSlidesVisibility)
                t.children("." + a.slideVisibleClass).each((function(t) {
                    var a = r ? m(t).attr("data-swiper-slide-index") : m(t).index();
                    e.lazy.loadInSlide(a)
                }
                ));
            else if (l > 1)
                for (var p = s; p < s + l; p += 1)
                    o(p) && e.lazy.loadInSlide(p);
            else
                e.lazy.loadInSlide(s);
            if (n.loadPrevNext)
                if (l > 1 || n.loadPrevNextAmount && n.loadPrevNextAmount > 1) {
                    for (var u = n.loadPrevNextAmount, c = l, h = Math.min(s + c + Math.max(u, c), i.length), v = Math.max(s - Math.max(c, u), 0), f = s + l; f < h; f += 1)
                        o(f) && e.lazy.loadInSlide(f);
                    for (var g = v; g < s; g += 1)
                        o(g) && e.lazy.loadInSlide(g)
                } else {
                    var b = t.children("." + a.slideNextClass);
                    b.length > 0 && e.lazy.loadInSlide(d(b));
                    var y = t.children("." + a.slidePrevClass);
                    y.length > 0 && e.lazy.loadInSlide(d(y))
                }
        },
        checkInViewOnLoad: function() {
            var e = l()
              , t = this;
            if (t && !t.destroyed) {
                var a = t.params.lazy.scrollingElement ? m(t.params.lazy.scrollingElement) : m(e)
                  , i = a[0] === e
                  , s = i ? e.innerWidth : a[0].offsetWidth
                  , r = i ? e.innerHeight : a[0].offsetHeight
                  , n = t.$el.offset()
                  , o = !1;
                t.rtlTranslate && (n.left -= t.$el[0].scrollLeft);
                for (var d = [[n.left, n.top], [n.left + t.width, n.top], [n.left, n.top + t.height], [n.left + t.width, n.top + t.height]], p = 0; p < d.length; p += 1) {
                    var u = d[p];
                    if (u[0] >= 0 && u[0] <= s && u[1] >= 0 && u[1] <= r) {
                        if (0 === u[0] && 0 === u[1])
                            continue;
                        o = !0
                    }
                }
                var c = !("touchstart" !== t.touchEvents.start || !t.support.passiveListener || !t.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                o ? (t.lazy.load(),
                a.off("scroll", t.lazy.checkInViewOnLoad, c)) : t.lazy.scrollHandlerAttached || (t.lazy.scrollHandlerAttached = !0,
                a.on("scroll", t.lazy.checkInViewOnLoad, c))
            }
        }
    }
      , se = {
        LinearSpline: function(e, t) {
            var a, i, s, r, n, l = function(e, t) {
                for (i = -1,
                a = e.length; a - i > 1; )
                    e[s = a + i >> 1] <= t ? i = s : a = s;
                return a
            };
            return this.x = e,
            this.y = t,
            this.lastIndex = e.length - 1,
            this.interpolate = function(e) {
                return e ? (n = l(this.x, e),
                r = n - 1,
                (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0
            }
            ,
            this
        },
        getInterpolateFunction: function(e) {
            var t = this;
            t.controller.spline || (t.controller.spline = t.params.loop ? new se.LinearSpline(t.slidesGrid,e.slidesGrid) : new se.LinearSpline(t.snapGrid,e.snapGrid))
        },
        setTranslate: function(e, t) {
            var a, i, s = this, r = s.controller.control, n = s.constructor;
            function l(e) {
                var t = s.rtlTranslate ? -s.translate : s.translate;
                "slide" === s.params.controller.by && (s.controller.getInterpolateFunction(e),
                i = -s.controller.spline.interpolate(-t)),
                i && "container" !== s.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (s.maxTranslate() - s.minTranslate()),
                i = (t - s.minTranslate()) * a + e.minTranslate()),
                s.params.controller.inverse && (i = e.maxTranslate() - i),
                e.updateProgress(i),
                e.setTranslate(i, s),
                e.updateActiveIndex(),
                e.updateSlidesClasses()
            }
            if (Array.isArray(r))
                for (var o = 0; o < r.length; o += 1)
                    r[o] !== t && r[o]instanceof n && l(r[o]);
            else
                r instanceof n && t !== r && l(r)
        },
        setTransition: function(e, t) {
            var a, i = this, s = i.constructor, r = i.controller.control;
            function n(t) {
                t.setTransition(e, i),
                0 !== e && (t.transitionStart(),
                t.params.autoHeight && E((function() {
                    t.updateAutoHeight()
                }
                )),
                t.$wrapperEl.transitionEnd((function() {
                    r && (t.params.loop && "slide" === i.params.controller.by && t.loopFix(),
                    t.transitionEnd())
                }
                )))
            }
            if (Array.isArray(r))
                for (a = 0; a < r.length; a += 1)
                    r[a] !== t && r[a]instanceof s && n(r[a]);
            else
                r instanceof s && t !== r && n(r)
        }
    }
      , re = {
        getRandomNumber: function(e) {
            void 0 === e && (e = 16);
            return "x".repeat(e).replace(/x/g, (function() {
                return Math.round(16 * Math.random()).toString(16)
            }
            ))
        },
        makeElFocusable: function(e) {
            return e.attr("tabIndex", "0"),
            e
        },
        makeElNotFocusable: function(e) {
            return e.attr("tabIndex", "-1"),
            e
        },
        addElRole: function(e, t) {
            return e.attr("role", t),
            e
        },
        addElRoleDescription: function(e, t) {
            return e.attr("aria-roledescription", t),
            e
        },
        addElControls: function(e, t) {
            return e.attr("aria-controls", t),
            e
        },
        addElLabel: function(e, t) {
            return e.attr("aria-label", t),
            e
        },
        addElId: function(e, t) {
            return e.attr("id", t),
            e
        },
        addElLive: function(e, t) {
            return e.attr("aria-live", t),
            e
        },
        disableEl: function(e) {
            return e.attr("aria-disabled", !0),
            e
        },
        enableEl: function(e) {
            return e.attr("aria-disabled", !1),
            e
        },
        onEnterOrSpaceKey: function(e) {
            if (13 === e.keyCode || 32 === e.keyCode) {
                var t = this
                  , a = t.params.a11y
                  , i = m(e.target);
                t.navigation && t.navigation.$nextEl && i.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(),
                t.isEnd ? t.a11y.notify(a.lastSlideMessage) : t.a11y.notify(a.nextSlideMessage)),
                t.navigation && t.navigation.$prevEl && i.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(),
                t.isBeginning ? t.a11y.notify(a.firstSlideMessage) : t.a11y.notify(a.prevSlideMessage)),
                t.pagination && i.is(z(t.params.pagination.bulletClass)) && i[0].click()
            }
        },
        notify: function(e) {
            var t = this.a11y.liveRegion;
            0 !== t.length && (t.html(""),
            t.html(e))
        },
        updateNavigation: function() {
            var e = this;
            if (!e.params.loop && e.navigation) {
                var t = e.navigation
                  , a = t.$nextEl
                  , i = t.$prevEl;
                i && i.length > 0 && (e.isBeginning ? (e.a11y.disableEl(i),
                e.a11y.makeElNotFocusable(i)) : (e.a11y.enableEl(i),
                e.a11y.makeElFocusable(i))),
                a && a.length > 0 && (e.isEnd ? (e.a11y.disableEl(a),
                e.a11y.makeElNotFocusable(a)) : (e.a11y.enableEl(a),
                e.a11y.makeElFocusable(a)))
            }
        },
        updatePagination: function() {
            var e = this
              , t = e.params.a11y;
            e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.bullets.each((function(a) {
                var i = m(a);
                e.a11y.makeElFocusable(i),
                e.params.pagination.renderBullet || (e.a11y.addElRole(i, "button"),
                e.a11y.addElLabel(i, t.paginationBulletMessage.replace(/\{\{index\}\}/, i.index() + 1)))
            }
            ))
        },
        init: function() {
            var e = this
              , t = e.params.a11y;
            e.$el.append(e.a11y.liveRegion);
            var a = e.$el;
            t.containerRoleDescriptionMessage && e.a11y.addElRoleDescription(a, t.containerRoleDescriptionMessage),
            t.containerMessage && e.a11y.addElLabel(a, t.containerMessage);
            var i, s, r = e.$wrapperEl, n = r.attr("id") || "swiper-wrapper-" + e.a11y.getRandomNumber(16), l = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
            e.a11y.addElId(r, n),
            e.a11y.addElLive(r, l),
            t.itemRoleDescriptionMessage && e.a11y.addElRoleDescription(m(e.slides), t.itemRoleDescriptionMessage),
            e.a11y.addElRole(m(e.slides), t.slideRole),
            e.slides.each((function(a) {
                var i = m(a)
                  , s = t.slideLabelMessage.replace(/\{\{index\}\}/, i.index() + 1).replace(/\{\{slidesLength\}\}/, e.slides.length);
                e.a11y.addElLabel(i, s)
            }
            )),
            e.navigation && e.navigation.$nextEl && (i = e.navigation.$nextEl),
            e.navigation && e.navigation.$prevEl && (s = e.navigation.$prevEl),
            i && i.length && (e.a11y.makeElFocusable(i),
            "BUTTON" !== i[0].tagName && (e.a11y.addElRole(i, "button"),
            i.on("keydown", e.a11y.onEnterOrSpaceKey)),
            e.a11y.addElLabel(i, t.nextSlideMessage),
            e.a11y.addElControls(i, n)),
            s && s.length && (e.a11y.makeElFocusable(s),
            "BUTTON" !== s[0].tagName && (e.a11y.addElRole(s, "button"),
            s.on("keydown", e.a11y.onEnterOrSpaceKey)),
            e.a11y.addElLabel(s, t.prevSlideMessage),
            e.a11y.addElControls(s, n)),
            e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on("keydown", z(e.params.pagination.bulletClass), e.a11y.onEnterOrSpaceKey)
        },
        destroy: function() {
            var e, t, a = this;
            a.a11y.liveRegion && a.a11y.liveRegion.length > 0 && a.a11y.liveRegion.remove(),
            a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl),
            a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl),
            e && e.off("keydown", a.a11y.onEnterOrSpaceKey),
            t && t.off("keydown", a.a11y.onEnterOrSpaceKey),
            a.pagination && a.params.pagination.clickable && a.pagination.bullets && a.pagination.bullets.length && a.pagination.$el.off("keydown", z(a.params.pagination.bulletClass), a.a11y.onEnterOrSpaceKey)
        }
    }
      , ne = {
        init: function() {
            var e = this
              , t = l();
            if (e.params.history) {
                if (!t.history || !t.history.pushState)
                    return e.params.history.enabled = !1,
                    void (e.params.hashNavigation.enabled = !0);
                var a = e.history;
                a.initialized = !0,
                a.paths = ne.getPathValues(e.params.url),
                (a.paths.key || a.paths.value) && (a.scrollToSlide(0, a.paths.value, e.params.runCallbacksOnInit),
                e.params.history.replaceState || t.addEventListener("popstate", e.history.setHistoryPopState))
            }
        },
        destroy: function() {
            var e = l();
            this.params.history.replaceState || e.removeEventListener("popstate", this.history.setHistoryPopState)
        },
        setHistoryPopState: function() {
            var e = this;
            e.history.paths = ne.getPathValues(e.params.url),
            e.history.scrollToSlide(e.params.speed, e.history.paths.value, !1)
        },
        getPathValues: function(e) {
            var t = l()
              , a = (e ? new URL(e) : t.location).pathname.slice(1).split("/").filter((function(e) {
                return "" !== e
            }
            ))
              , i = a.length;
            return {
                key: a[i - 2],
                value: a[i - 1]
            }
        },
        setHistory: function(e, t) {
            var a = this
              , i = l();
            if (a.history.initialized && a.params.history.enabled) {
                var s;
                s = a.params.url ? new URL(a.params.url) : i.location;
                var r = a.slides.eq(t)
                  , n = ne.slugify(r.attr("data-history"));
                if (a.params.history.root.length > 0) {
                    var o = a.params.history.root;
                    "/" === o[o.length - 1] && (o = o.slice(0, o.length - 1)),
                    n = o + "/" + e + "/" + n
                } else
                    s.pathname.includes(e) || (n = e + "/" + n);
                var d = i.history.state;
                d && d.value === n || (a.params.history.replaceState ? i.history.replaceState({
                    value: n
                }, null, n) : i.history.pushState({
                    value: n
                }, null, n))
            }
        },
        slugify: function(e) {
            return e.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
        },
        scrollToSlide: function(e, t, a) {
            var i = this;
            if (t)
                for (var s = 0, r = i.slides.length; s < r; s += 1) {
                    var n = i.slides.eq(s);
                    if (ne.slugify(n.attr("data-history")) === t && !n.hasClass(i.params.slideDuplicateClass)) {
                        var l = n.index();
                        i.slideTo(l, e, a)
                    }
                }
            else
                i.slideTo(0, e, a)
        }
    }
      , le = {
        onHashCange: function() {
            var e = this
              , t = r();
            e.emit("hashChange");
            var a = t.location.hash.replace("#", "");
            if (a !== e.slides.eq(e.activeIndex).attr("data-hash")) {
                var i = e.$wrapperEl.children("." + e.params.slideClass + '[data-hash="' + a + '"]').index();
                if (void 0 === i)
                    return;
                e.slideTo(i)
            }
        },
        setHash: function() {
            var e = this
              , t = l()
              , a = r();
            if (e.hashNavigation.initialized && e.params.hashNavigation.enabled)
                if (e.params.hashNavigation.replaceState && t.history && t.history.replaceState)
                    t.history.replaceState(null, null, "#" + e.slides.eq(e.activeIndex).attr("data-hash") || ""),
                    e.emit("hashSet");
                else {
                    var i = e.slides.eq(e.activeIndex)
                      , s = i.attr("data-hash") || i.attr("data-history");
                    a.location.hash = s || "",
                    e.emit("hashSet")
                }
        },
        init: function() {
            var e = this
              , t = r()
              , a = l();
            if (!(!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)) {
                e.hashNavigation.initialized = !0;
                var i = t.location.hash.replace("#", "");
                if (i)
                    for (var s = 0, n = e.slides.length; s < n; s += 1) {
                        var o = e.slides.eq(s);
                        if ((o.attr("data-hash") || o.attr("data-history")) === i && !o.hasClass(e.params.slideDuplicateClass)) {
                            var d = o.index();
                            e.slideTo(d, 0, e.params.runCallbacksOnInit, !0)
                        }
                    }
                e.params.hashNavigation.watchState && m(a).on("hashchange", e.hashNavigation.onHashCange)
            }
        },
        destroy: function() {
            var e = l();
            this.params.hashNavigation.watchState && m(e).off("hashchange", this.hashNavigation.onHashCange)
        }
    }
      , oe = {
        run: function() {
            var e = this
              , t = e.slides.eq(e.activeIndex)
              , a = e.params.autoplay.delay;
            t.attr("data-swiper-autoplay") && (a = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
            clearTimeout(e.autoplay.timeout),
            e.autoplay.timeout = E((function() {
                var t;
                e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(),
                t = e.slidePrev(e.params.speed, !0, !0),
                e.emit("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0),
                e.emit("autoplay")) : (t = e.slidePrev(e.params.speed, !0, !0),
                e.emit("autoplay")) : e.params.loop ? (e.loopFix(),
                t = e.slideNext(e.params.speed, !0, !0),
                e.emit("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (t = e.slideTo(0, e.params.speed, !0, !0),
                e.emit("autoplay")) : (t = e.slideNext(e.params.speed, !0, !0),
                e.emit("autoplay")),
                (e.params.cssMode && e.autoplay.running || !1 === t) && e.autoplay.run()
            }
            ), a)
        },
        start: function() {
            var e = this;
            return void 0 === e.autoplay.timeout && (!e.autoplay.running && (e.autoplay.running = !0,
            e.emit("autoplayStart"),
            e.autoplay.run(),
            !0))
        },
        stop: function() {
            var e = this;
            return !!e.autoplay.running && (void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout),
            e.autoplay.timeout = void 0),
            e.autoplay.running = !1,
            e.emit("autoplayStop"),
            !0))
        },
        pause: function(e) {
            var t = this;
            t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
            t.autoplay.paused = !0,
            0 !== e && t.params.autoplay.waitForTransition ? ["transitionend", "webkitTransitionEnd"].forEach((function(e) {
                t.$wrapperEl[0].addEventListener(e, t.autoplay.onTransitionEnd)
            }
            )) : (t.autoplay.paused = !1,
            t.autoplay.run())))
        },
        onVisibilityChange: function() {
            var e = this
              , t = r();
            "hidden" === t.visibilityState && e.autoplay.running && e.autoplay.pause(),
            "visible" === t.visibilityState && e.autoplay.paused && (e.autoplay.run(),
            e.autoplay.paused = !1)
        },
        onTransitionEnd: function(e) {
            var t = this;
            t && !t.destroyed && t.$wrapperEl && e.target === t.$wrapperEl[0] && (["transitionend", "webkitTransitionEnd"].forEach((function(e) {
                t.$wrapperEl[0].removeEventListener(e, t.autoplay.onTransitionEnd)
            }
            )),
            t.autoplay.paused = !1,
            t.autoplay.running ? t.autoplay.run() : t.autoplay.stop())
        },
        onMouseEnter: function() {
            var e = this;
            e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause(),
            ["transitionend", "webkitTransitionEnd"].forEach((function(t) {
                e.$wrapperEl[0].removeEventListener(t, e.autoplay.onTransitionEnd)
            }
            ))
        },
        onMouseLeave: function() {
            var e = this;
            e.params.autoplay.disableOnInteraction || (e.autoplay.paused = !1,
            e.autoplay.run())
        },
        attachMouseEvents: function() {
            var e = this;
            e.params.autoplay.pauseOnMouseEnter && (e.$el.on("mouseenter", e.autoplay.onMouseEnter),
            e.$el.on("mouseleave", e.autoplay.onMouseLeave))
        },
        detachMouseEvents: function() {
            var e = this;
            e.$el.off("mouseenter", e.autoplay.onMouseEnter),
            e.$el.off("mouseleave", e.autoplay.onMouseLeave)
        }
    }
      , de = {
        setTranslate: function() {
            for (var e = this, t = e.slides, a = 0; a < t.length; a += 1) {
                var i = e.slides.eq(a)
                  , s = -i[0].swiperSlideOffset;
                e.params.virtualTranslate || (s -= e.translate);
                var r = 0;
                e.isHorizontal() || (r = s,
                s = 0);
                var n = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
                i.css({
                    opacity: n
                }).transform("translate3d(" + s + "px, " + r + "px, 0px)")
            }
        },
        setTransition: function(e) {
            var t = this
              , a = t.slides
              , i = t.$wrapperEl;
            if (a.transition(e),
            t.params.virtualTranslate && 0 !== e) {
                var s = !1;
                a.transitionEnd((function() {
                    if (!s && t && !t.destroyed) {
                        s = !0,
                        t.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], a = 0; a < e.length; a += 1)
                            i.trigger(e[a])
                    }
                }
                ))
            }
        }
    }
      , pe = {
        setTranslate: function() {
            var e, t = this, a = t.$el, i = t.$wrapperEl, s = t.slides, r = t.width, n = t.height, l = t.rtlTranslate, o = t.size, d = t.browser, p = t.params.cubeEffect, u = t.isHorizontal(), c = t.virtual && t.params.virtual.enabled, h = 0;
            p.shadow && (u ? (0 === (e = i.find(".swiper-cube-shadow")).length && (e = m('<div class="swiper-cube-shadow"></div>'),
            i.append(e)),
            e.css({
                height: r + "px"
            })) : 0 === (e = a.find(".swiper-cube-shadow")).length && (e = m('<div class="swiper-cube-shadow"></div>'),
            a.append(e)));
            for (var v = 0; v < s.length; v += 1) {
                var f = s.eq(v)
                  , g = v;
                c && (g = parseInt(f.attr("data-swiper-slide-index"), 10));
                var b = 90 * g
                  , y = Math.floor(b / 360);
                l && (b = -b,
                y = Math.floor(-b / 360));
                var w = Math.max(Math.min(f[0].progress, 1), -1)
                  , E = 0
                  , x = 0
                  , T = 0;
                g % 4 == 0 ? (E = 4 * -y * o,
                T = 0) : (g - 1) % 4 == 0 ? (E = 0,
                T = 4 * -y * o) : (g - 2) % 4 == 0 ? (E = o + 4 * y * o,
                T = o) : (g - 3) % 4 == 0 && (E = -o,
                T = 3 * o + 4 * o * y),
                l && (E = -E),
                u || (x = E,
                E = 0);
                var C = "rotateX(" + (u ? 0 : -b) + "deg) rotateY(" + (u ? b : 0) + "deg) translate3d(" + E + "px, " + x + "px, " + T + "px)";
                if (w <= 1 && w > -1 && (h = 90 * g + 90 * w,
                l && (h = 90 * -g - 90 * w)),
                f.transform(C),
                p.slideShadows) {
                    var S = u ? f.find(".swiper-slide-shadow-left") : f.find(".swiper-slide-shadow-top")
                      , M = u ? f.find(".swiper-slide-shadow-right") : f.find(".swiper-slide-shadow-bottom");
                    0 === S.length && (S = m('<div class="swiper-slide-shadow-' + (u ? "left" : "top") + '"></div>'),
                    f.append(S)),
                    0 === M.length && (M = m('<div class="swiper-slide-shadow-' + (u ? "right" : "bottom") + '"></div>'),
                    f.append(M)),
                    S.length && (S[0].style.opacity = Math.max(-w, 0)),
                    M.length && (M[0].style.opacity = Math.max(w, 0))
                }
            }
            if (i.css({
                "-webkit-transform-origin": "50% 50% -" + o / 2 + "px",
                "-moz-transform-origin": "50% 50% -" + o / 2 + "px",
                "-ms-transform-origin": "50% 50% -" + o / 2 + "px",
                "transform-origin": "50% 50% -" + o / 2 + "px"
            }),
            p.shadow)
                if (u)
                    e.transform("translate3d(0px, " + (r / 2 + p.shadowOffset) + "px, " + -r / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + p.shadowScale + ")");
                else {
                    var z = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90)
                      , P = 1.5 - (Math.sin(2 * z * Math.PI / 360) / 2 + Math.cos(2 * z * Math.PI / 360) / 2)
                      , k = p.shadowScale
                      , $ = p.shadowScale / P
                      , L = p.shadowOffset;
                    e.transform("scale3d(" + k + ", 1, " + $ + ") translate3d(0px, " + (n / 2 + L) + "px, " + -n / 2 / $ + "px) rotateX(-90deg)")
                }
            var I = d.isSafari || d.isWebView ? -o / 2 : 0;
            i.transform("translate3d(0px,0," + I + "px) rotateX(" + (t.isHorizontal() ? 0 : h) + "deg) rotateY(" + (t.isHorizontal() ? -h : 0) + "deg)")
        },
        setTransition: function(e) {
            var t = this
              , a = t.$el;
            t.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),
            t.params.cubeEffect.shadow && !t.isHorizontal() && a.find(".swiper-cube-shadow").transition(e)
        }
    }
      , ue = {
        setTranslate: function() {
            for (var e = this, t = e.slides, a = e.rtlTranslate, i = 0; i < t.length; i += 1) {
                var s = t.eq(i)
                  , r = s[0].progress;
                e.params.flipEffect.limitRotation && (r = Math.max(Math.min(s[0].progress, 1), -1));
                var n = -180 * r
                  , l = 0
                  , o = -s[0].swiperSlideOffset
                  , d = 0;
                if (e.isHorizontal() ? a && (n = -n) : (d = o,
                o = 0,
                l = -n,
                n = 0),
                s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length,
                e.params.flipEffect.slideShadows) {
                    var p = e.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top")
                      , u = e.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom");
                    0 === p.length && (p = m('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "left" : "top") + '"></div>'),
                    s.append(p)),
                    0 === u.length && (u = m('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "right" : "bottom") + '"></div>'),
                    s.append(u)),
                    p.length && (p[0].style.opacity = Math.max(-r, 0)),
                    u.length && (u[0].style.opacity = Math.max(r, 0))
                }
                s.transform("translate3d(" + o + "px, " + d + "px, 0px) rotateX(" + l + "deg) rotateY(" + n + "deg)")
            }
        },
        setTransition: function(e) {
            var t = this
              , a = t.slides
              , i = t.activeIndex
              , s = t.$wrapperEl;
            if (a.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),
            t.params.virtualTranslate && 0 !== e) {
                var r = !1;
                a.eq(i).transitionEnd((function() {
                    if (!r && t && !t.destroyed) {
                        r = !0,
                        t.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], a = 0; a < e.length; a += 1)
                            s.trigger(e[a])
                    }
                }
                ))
            }
        }
    }
      , ce = {
        setTranslate: function() {
            for (var e = this, t = e.width, a = e.height, i = e.slides, s = e.slidesSizesGrid, r = e.params.coverflowEffect, n = e.isHorizontal(), l = e.translate, o = n ? t / 2 - l : a / 2 - l, d = n ? r.rotate : -r.rotate, p = r.depth, u = 0, c = i.length; u < c; u += 1) {
                var h = i.eq(u)
                  , v = s[u]
                  , f = (o - h[0].swiperSlideOffset - v / 2) / v * r.modifier
                  , g = n ? d * f : 0
                  , b = n ? 0 : d * f
                  , y = -p * Math.abs(f)
                  , w = r.stretch;
                "string" == typeof w && -1 !== w.indexOf("%") && (w = parseFloat(r.stretch) / 100 * v);
                var E = n ? 0 : w * f
                  , x = n ? w * f : 0
                  , T = 1 - (1 - r.scale) * Math.abs(f);
                Math.abs(x) < .001 && (x = 0),
                Math.abs(E) < .001 && (E = 0),
                Math.abs(y) < .001 && (y = 0),
                Math.abs(g) < .001 && (g = 0),
                Math.abs(b) < .001 && (b = 0),
                Math.abs(T) < .001 && (T = 0);
                var C = "translate3d(" + x + "px," + E + "px," + y + "px)  rotateX(" + b + "deg) rotateY(" + g + "deg) scale(" + T + ")";
                if (h.transform(C),
                h[0].style.zIndex = 1 - Math.abs(Math.round(f)),
                r.slideShadows) {
                    var S = n ? h.find(".swiper-slide-shadow-left") : h.find(".swiper-slide-shadow-top")
                      , M = n ? h.find(".swiper-slide-shadow-right") : h.find(".swiper-slide-shadow-bottom");
                    0 === S.length && (S = m('<div class="swiper-slide-shadow-' + (n ? "left" : "top") + '"></div>'),
                    h.append(S)),
                    0 === M.length && (M = m('<div class="swiper-slide-shadow-' + (n ? "right" : "bottom") + '"></div>'),
                    h.append(M)),
                    S.length && (S[0].style.opacity = f > 0 ? f : 0),
                    M.length && (M[0].style.opacity = -f > 0 ? -f : 0)
                }
            }
        },
        setTransition: function(e) {
            this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)
        }
    }
      , he = {
        init: function() {
            var e = this
              , t = e.params.thumbs;
            if (e.thumbs.initialized)
                return !1;
            e.thumbs.initialized = !0;
            var a = e.constructor;
            return t.swiper instanceof a ? (e.thumbs.swiper = t.swiper,
            S(e.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            }),
            S(e.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })) : C(t.swiper) && (e.thumbs.swiper = new a(S({}, t.swiper, {
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })),
            e.thumbs.swiperCreated = !0),
            e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
            e.thumbs.swiper.on("tap", e.thumbs.onThumbClick),
            !0
        },
        onThumbClick: function() {
            var e = this
              , t = e.thumbs.swiper;
            if (t) {
                var a = t.clickedIndex
                  , i = t.clickedSlide;
                if (!(i && m(i).hasClass(e.params.thumbs.slideThumbActiveClass) || null == a)) {
                    var s;
                    if (s = t.params.loop ? parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"), 10) : a,
                    e.params.loop) {
                        var r = e.activeIndex;
                        e.slides.eq(r).hasClass(e.params.slideDuplicateClass) && (e.loopFix(),
                        e._clientLeft = e.$wrapperEl[0].clientLeft,
                        r = e.activeIndex);
                        var n = e.slides.eq(r).prevAll('[data-swiper-slide-index="' + s + '"]').eq(0).index()
                          , l = e.slides.eq(r).nextAll('[data-swiper-slide-index="' + s + '"]').eq(0).index();
                        s = void 0 === n ? l : void 0 === l ? n : l - r < r - n ? l : n
                    }
                    e.slideTo(s)
                }
            }
        },
        update: function(e) {
            var t = this
              , a = t.thumbs.swiper;
            if (a) {
                var i = "auto" === a.params.slidesPerView ? a.slidesPerViewDynamic() : a.params.slidesPerView
                  , s = t.params.thumbs.autoScrollOffset
                  , r = s && !a.params.loop;
                if (t.realIndex !== a.realIndex || r) {
                    var n, l, o = a.activeIndex;
                    if (a.params.loop) {
                        a.slides.eq(o).hasClass(a.params.slideDuplicateClass) && (a.loopFix(),
                        a._clientLeft = a.$wrapperEl[0].clientLeft,
                        o = a.activeIndex);
                        var d = a.slides.eq(o).prevAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index()
                          , p = a.slides.eq(o).nextAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index();
                        n = void 0 === d ? p : void 0 === p ? d : p - o == o - d ? a.params.slidesPerGroup > 1 ? p : o : p - o < o - d ? p : d,
                        l = t.activeIndex > t.previousIndex ? "next" : "prev"
                    } else
                        l = (n = t.realIndex) > t.previousIndex ? "next" : "prev";
                    r && (n += "next" === l ? s : -1 * s),
                    a.visibleSlidesIndexes && a.visibleSlidesIndexes.indexOf(n) < 0 && (a.params.centeredSlides ? n = n > o ? n - Math.floor(i / 2) + 1 : n + Math.floor(i / 2) - 1 : n > o && a.params.slidesPerGroup,
                    a.slideTo(n, e ? 0 : void 0))
                }
                var u = 1
                  , c = t.params.thumbs.slideThumbActiveClass;
                if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (u = t.params.slidesPerView),
                t.params.thumbs.multipleActiveThumbs || (u = 1),
                u = Math.floor(u),
                a.slides.removeClass(c),
                a.params.loop || a.params.virtual && a.params.virtual.enabled)
                    for (var h = 0; h < u; h += 1)
                        a.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + h) + '"]').addClass(c);
                else
                    for (var v = 0; v < u; v += 1)
                        a.slides.eq(t.realIndex + v).addClass(c)
            }
        }
    }
      , ve = [j, K, {
        name: "mousewheel",
        params: {
            mousewheel: {
                enabled: !1,
                releaseOnEdges: !1,
                invert: !1,
                forceToAxis: !1,
                sensitivity: 1,
                eventsTarget: "container",
                thresholdDelta: null,
                thresholdTime: null
            }
        },
        create: function() {
            M(this, {
                mousewheel: {
                    enabled: !1,
                    lastScrollTime: x(),
                    lastEventBeforeSnap: void 0,
                    recentWheelEvents: [],
                    enable: Z.enable,
                    disable: Z.disable,
                    handle: Z.handle,
                    handleMouseEnter: Z.handleMouseEnter,
                    handleMouseLeave: Z.handleMouseLeave,
                    animateSlider: Z.animateSlider,
                    releaseScroll: Z.releaseScroll
                }
            })
        },
        on: {
            init: function(e) {
                !e.params.mousewheel.enabled && e.params.cssMode && e.mousewheel.disable(),
                e.params.mousewheel.enabled && e.mousewheel.enable()
            },
            destroy: function(e) {
                e.params.cssMode && e.mousewheel.enable(),
                e.mousewheel.enabled && e.mousewheel.disable()
            }
        }
    }, {
        name: "navigation",
        params: {
            navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "swiper-button-disabled",
                hiddenClass: "swiper-button-hidden",
                lockClass: "swiper-button-lock"
            }
        },
        create: function() {
            M(this, {
                navigation: t({}, J)
            })
        },
        on: {
            init: function(e) {
                e.navigation.init(),
                e.navigation.update()
            },
            toEdge: function(e) {
                e.navigation.update()
            },
            fromEdge: function(e) {
                e.navigation.update()
            },
            destroy: function(e) {
                e.navigation.destroy()
            },
            "enable disable": function(e) {
                var t = e.navigation
                  , a = t.$nextEl
                  , i = t.$prevEl;
                a && a[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass),
                i && i[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass)
            },
            click: function(e, t) {
                var a = e.navigation
                  , i = a.$nextEl
                  , s = a.$prevEl
                  , r = t.target;
                if (e.params.navigation.hideOnClick && !m(r).is(s) && !m(r).is(i)) {
                    if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === r || e.pagination.el.contains(r)))
                        return;
                    var n;
                    i ? n = i.hasClass(e.params.navigation.hiddenClass) : s && (n = s.hasClass(e.params.navigation.hiddenClass)),
                    !0 === n ? e.emit("navigationShow") : e.emit("navigationHide"),
                    i && i.toggleClass(e.params.navigation.hiddenClass),
                    s && s.toggleClass(e.params.navigation.hiddenClass)
                }
            }
        }
    }, {
        name: "pagination",
        params: {
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: function(e) {
                    return e
                },
                formatFractionTotal: function(e) {
                    return e
                },
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                modifierClass: "swiper-pagination-",
                currentClass: "swiper-pagination-current",
                totalClass: "swiper-pagination-total",
                hiddenClass: "swiper-pagination-hidden",
                progressbarFillClass: "swiper-pagination-progressbar-fill",
                progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                clickableClass: "swiper-pagination-clickable",
                lockClass: "swiper-pagination-lock"
            }
        },
        create: function() {
            M(this, {
                pagination: t({
                    dynamicBulletIndex: 0
                }, Q)
            })
        },
        on: {
            init: function(e) {
                e.pagination.init(),
                e.pagination.render(),
                e.pagination.update()
            },
            activeIndexChange: function(e) {
                (e.params.loop || void 0 === e.snapIndex) && e.pagination.update()
            },
            snapIndexChange: function(e) {
                e.params.loop || e.pagination.update()
            },
            slidesLengthChange: function(e) {
                e.params.loop && (e.pagination.render(),
                e.pagination.update())
            },
            snapGridLengthChange: function(e) {
                e.params.loop || (e.pagination.render(),
                e.pagination.update())
            },
            destroy: function(e) {
                e.pagination.destroy()
            },
            "enable disable": function(e) {
                var t = e.pagination.$el;
                t && t[e.enabled ? "removeClass" : "addClass"](e.params.pagination.lockClass)
            },
            click: function(e, t) {
                var a = t.target;
                if (e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !m(a).hasClass(e.params.pagination.bulletClass)) {
                    if (e.navigation && (e.navigation.nextEl && a === e.navigation.nextEl || e.navigation.prevEl && a === e.navigation.prevEl))
                        return;
                    !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit("paginationShow") : e.emit("paginationHide"),
                    e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)
                }
            }
        }
    }, {
        name: "scrollbar",
        params: {
            scrollbar: {
                el: null,
                dragSize: "auto",
                hide: !1,
                draggable: !1,
                snapOnRelease: !0,
                lockClass: "swiper-scrollbar-lock",
                dragClass: "swiper-scrollbar-drag"
            }
        },
        create: function() {
            M(this, {
                scrollbar: t({
                    isTouched: !1,
                    timeout: null,
                    dragTimeout: null
                }, ee)
            })
        },
        on: {
            init: function(e) {
                e.scrollbar.init(),
                e.scrollbar.updateSize(),
                e.scrollbar.setTranslate()
            },
            update: function(e) {
                e.scrollbar.updateSize()
            },
            resize: function(e) {
                e.scrollbar.updateSize()
            },
            observerUpdate: function(e) {
                e.scrollbar.updateSize()
            },
            setTranslate: function(e) {
                e.scrollbar.setTranslate()
            },
            setTransition: function(e, t) {
                e.scrollbar.setTransition(t)
            },
            "enable disable": function(e) {
                var t = e.scrollbar.$el;
                t && t[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass)
            },
            destroy: function(e) {
                e.scrollbar.destroy()
            }
        }
    }, {
        name: "parallax",
        params: {
            parallax: {
                enabled: !1
            }
        },
        create: function() {
            M(this, {
                parallax: t({}, te)
            })
        },
        on: {
            beforeInit: function(e) {
                e.params.parallax.enabled && (e.params.watchSlidesProgress = !0,
                e.originalParams.watchSlidesProgress = !0)
            },
            init: function(e) {
                e.params.parallax.enabled && e.parallax.setTranslate()
            },
            setTranslate: function(e) {
                e.params.parallax.enabled && e.parallax.setTranslate()
            },
            setTransition: function(e, t) {
                e.params.parallax.enabled && e.parallax.setTransition(t)
            }
        }
    }, {
        name: "zoom",
        params: {
            zoom: {
                enabled: !1,
                maxRatio: 3,
                minRatio: 1,
                toggle: !0,
                containerClass: "swiper-zoom-container",
                zoomedSlideClass: "swiper-slide-zoomed"
            }
        },
        create: function() {
            var e = this;
            M(e, {
                zoom: t({
                    enabled: !1,
                    scale: 1,
                    currentScale: 1,
                    isScaling: !1,
                    gesture: {
                        $slideEl: void 0,
                        slideWidth: void 0,
                        slideHeight: void 0,
                        $imageEl: void 0,
                        $imageWrapEl: void 0,
                        maxRatio: 3
                    },
                    image: {
                        isTouched: void 0,
                        isMoved: void 0,
                        currentX: void 0,
                        currentY: void 0,
                        minX: void 0,
                        minY: void 0,
                        maxX: void 0,
                        maxY: void 0,
                        width: void 0,
                        height: void 0,
                        startX: void 0,
                        startY: void 0,
                        touchesStart: {},
                        touchesCurrent: {}
                    },
                    velocity: {
                        x: void 0,
                        y: void 0,
                        prevPositionX: void 0,
                        prevPositionY: void 0,
                        prevTime: void 0
                    }
                }, ae)
            });
            var a = 1;
            Object.defineProperty(e.zoom, "scale", {
                get: function() {
                    return a
                },
                set: function(t) {
                    if (a !== t) {
                        var i = e.zoom.gesture.$imageEl ? e.zoom.gesture.$imageEl[0] : void 0
                          , s = e.zoom.gesture.$slideEl ? e.zoom.gesture.$slideEl[0] : void 0;
                        e.emit("zoomChange", t, i, s)
                    }
                    a = t
                }
            })
        },
        on: {
            init: function(e) {
                e.params.zoom.enabled && e.zoom.enable()
            },
            destroy: function(e) {
                e.zoom.disable()
            },
            touchStart: function(e, t) {
                e.zoom.enabled && e.zoom.onTouchStart(t)
            },
            touchEnd: function(e, t) {
                e.zoom.enabled && e.zoom.onTouchEnd(t)
            },
            doubleTap: function(e, t) {
                !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && e.zoom.toggle(t)
            },
            transitionEnd: function(e) {
                e.zoom.enabled && e.params.zoom.enabled && e.zoom.onTransitionEnd()
            },
            slideChange: function(e) {
                e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && e.zoom.onTransitionEnd()
            }
        }
    }, {
        name: "lazy",
        params: {
            lazy: {
                checkInView: !1,
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                scrollingElement: "",
                elementClass: "swiper-lazy",
                loadingClass: "swiper-lazy-loading",
                loadedClass: "swiper-lazy-loaded",
                preloaderClass: "swiper-lazy-preloader"
            }
        },
        create: function() {
            M(this, {
                lazy: t({
                    initialImageLoaded: !1
                }, ie)
            })
        },
        on: {
            beforeInit: function(e) {
                e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1)
            },
            init: function(e) {
                e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && (e.params.lazy.checkInView ? e.lazy.checkInViewOnLoad() : e.lazy.load())
            },
            scroll: function(e) {
                e.params.freeMode && !e.params.freeModeSticky && e.lazy.load()
            },
            "scrollbarDragMove resize _freeModeNoMomentumRelease": function(e) {
                e.params.lazy.enabled && e.lazy.load()
            },
            transitionStart: function(e) {
                e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load()
            },
            transitionEnd: function(e) {
                e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load()
            },
            slideChange: function(e) {
                e.params.lazy.enabled && e.params.cssMode && e.lazy.load()
            }
        }
    }, {
        name: "controller",
        params: {
            controller: {
                control: void 0,
                inverse: !1,
                by: "slide"
            }
        },
        create: function() {
            M(this, {
                controller: t({
                    control: this.params.controller.control
                }, se)
            })
        },
        on: {
            update: function(e) {
                e.controller.control && e.controller.spline && (e.controller.spline = void 0,
                delete e.controller.spline)
            },
            resize: function(e) {
                e.controller.control && e.controller.spline && (e.controller.spline = void 0,
                delete e.controller.spline)
            },
            observerUpdate: function(e) {
                e.controller.control && e.controller.spline && (e.controller.spline = void 0,
                delete e.controller.spline)
            },
            setTranslate: function(e, t, a) {
                e.controller.control && e.controller.setTranslate(t, a)
            },
            setTransition: function(e, t, a) {
                e.controller.control && e.controller.setTransition(t, a)
            }
        }
    }, {
        name: "a11y",
        params: {
            a11y: {
                enabled: !0,
                notificationClass: "swiper-notification",
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                slideLabelMessage: "{{index}} / {{slidesLength}}",
                containerMessage: null,
                containerRoleDescriptionMessage: null,
                itemRoleDescriptionMessage: null,
                slideRole: "group"
            }
        },
        create: function() {
            M(this, {
                a11y: t({}, re, {
                    liveRegion: m('<span class="' + this.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
                })
            })
        },
        on: {
            afterInit: function(e) {
                e.params.a11y.enabled && (e.a11y.init(),
                e.a11y.updateNavigation())
            },
            toEdge: function(e) {
                e.params.a11y.enabled && e.a11y.updateNavigation()
            },
            fromEdge: function(e) {
                e.params.a11y.enabled && e.a11y.updateNavigation()
            },
            paginationUpdate: function(e) {
                e.params.a11y.enabled && e.a11y.updatePagination()
            },
            destroy: function(e) {
                e.params.a11y.enabled && e.a11y.destroy()
            }
        }
    }, {
        name: "history",
        params: {
            history: {
                enabled: !1,
                root: "",
                replaceState: !1,
                key: "slides"
            }
        },
        create: function() {
            M(this, {
                history: t({}, ne)
            })
        },
        on: {
            init: function(e) {
                e.params.history.enabled && e.history.init()
            },
            destroy: function(e) {
                e.params.history.enabled && e.history.destroy()
            },
            "transitionEnd _freeModeNoMomentumRelease": function(e) {
                e.history.initialized && e.history.setHistory(e.params.history.key, e.activeIndex)
            },
            slideChange: function(e) {
                e.history.initialized && e.params.cssMode && e.history.setHistory(e.params.history.key, e.activeIndex)
            }
        }
    }, {
        name: "hash-navigation",
        params: {
            hashNavigation: {
                enabled: !1,
                replaceState: !1,
                watchState: !1
            }
        },
        create: function() {
            M(this, {
                hashNavigation: t({
                    initialized: !1
                }, le)
            })
        },
        on: {
            init: function(e) {
                e.params.hashNavigation.enabled && e.hashNavigation.init()
            },
            destroy: function(e) {
                e.params.hashNavigation.enabled && e.hashNavigation.destroy()
            },
            "transitionEnd _freeModeNoMomentumRelease": function(e) {
                e.hashNavigation.initialized && e.hashNavigation.setHash()
            },
            slideChange: function(e) {
                e.hashNavigation.initialized && e.params.cssMode && e.hashNavigation.setHash()
            }
        }
    }, {
        name: "autoplay",
        params: {
            autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
                pauseOnMouseEnter: !1
            }
        },
        create: function() {
            M(this, {
                autoplay: t({}, oe, {
                    running: !1,
                    paused: !1
                })
            })
        },
        on: {
            init: function(e) {
                e.params.autoplay.enabled && (e.autoplay.start(),
                r().addEventListener("visibilitychange", e.autoplay.onVisibilityChange),
                e.autoplay.attachMouseEvents())
            },
            beforeTransitionStart: function(e, t, a) {
                e.autoplay.running && (a || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(t) : e.autoplay.stop())
            },
            sliderFirstMove: function(e) {
                e.autoplay.running && (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause())
            },
            touchEnd: function(e) {
                e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && e.autoplay.run()
            },
            destroy: function(e) {
                e.autoplay.detachMouseEvents(),
                e.autoplay.running && e.autoplay.stop(),
                r().removeEventListener("visibilitychange", e.autoplay.onVisibilityChange)
            }
        }
    }, {
        name: "effect-fade",
        params: {
            fadeEffect: {
                crossFade: !1
            }
        },
        create: function() {
            M(this, {
                fadeEffect: t({}, de)
            })
        },
        on: {
            beforeInit: function(e) {
                if ("fade" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "fade");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    S(e.params, t),
                    S(e.originalParams, t)
                }
            },
            setTranslate: function(e) {
                "fade" === e.params.effect && e.fadeEffect.setTranslate()
            },
            setTransition: function(e, t) {
                "fade" === e.params.effect && e.fadeEffect.setTransition(t)
            }
        }
    }, {
        name: "effect-cube",
        params: {
            cubeEffect: {
                slideShadows: !0,
                shadow: !0,
                shadowOffset: 20,
                shadowScale: .94
            }
        },
        create: function() {
            M(this, {
                cubeEffect: t({}, pe)
            })
        },
        on: {
            beforeInit: function(e) {
                if ("cube" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "cube"),
                    e.classNames.push(e.params.containerModifierClass + "3d");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        resistanceRatio: 0,
                        spaceBetween: 0,
                        centeredSlides: !1,
                        virtualTranslate: !0
                    };
                    S(e.params, t),
                    S(e.originalParams, t)
                }
            },
            setTranslate: function(e) {
                "cube" === e.params.effect && e.cubeEffect.setTranslate()
            },
            setTransition: function(e, t) {
                "cube" === e.params.effect && e.cubeEffect.setTransition(t)
            }
        }
    }, {
        name: "effect-flip",
        params: {
            flipEffect: {
                slideShadows: !0,
                limitRotation: !0
            }
        },
        create: function() {
            M(this, {
                flipEffect: t({}, ue)
            })
        },
        on: {
            beforeInit: function(e) {
                if ("flip" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "flip"),
                    e.classNames.push(e.params.containerModifierClass + "3d");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    S(e.params, t),
                    S(e.originalParams, t)
                }
            },
            setTranslate: function(e) {
                "flip" === e.params.effect && e.flipEffect.setTranslate()
            },
            setTransition: function(e, t) {
                "flip" === e.params.effect && e.flipEffect.setTransition(t)
            }
        }
    }, {
        name: "effect-coverflow",
        params: {
            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                scale: 1,
                modifier: 1,
                slideShadows: !0
            }
        },
        create: function() {
            M(this, {
                coverflowEffect: t({}, ce)
            })
        },
        on: {
            beforeInit: function(e) {
                "coverflow" === e.params.effect && (e.classNames.push(e.params.containerModifierClass + "coverflow"),
                e.classNames.push(e.params.containerModifierClass + "3d"),
                e.params.watchSlidesProgress = !0,
                e.originalParams.watchSlidesProgress = !0)
            },
            setTranslate: function(e) {
                "coverflow" === e.params.effect && e.coverflowEffect.setTranslate()
            },
            setTransition: function(e, t) {
                "coverflow" === e.params.effect && e.coverflowEffect.setTransition(t)
            }
        }
    }, {
        name: "thumbs",
        params: {
            thumbs: {
                swiper: null,
                multipleActiveThumbs: !0,
                autoScrollOffset: 0,
                slideThumbActiveClass: "swiper-slide-thumb-active",
                thumbsContainerClass: "swiper-container-thumbs"
            }
        },
        create: function() {
            M(this, {
                thumbs: t({
                    swiper: null,
                    initialized: !1
                }, he)
            })
        },
        on: {
            beforeInit: function(e) {
                var t = e.params.thumbs;
                t && t.swiper && (e.thumbs.init(),
                e.thumbs.update(!0))
            },
            slideChange: function(e) {
                e.thumbs.swiper && e.thumbs.update()
            },
            update: function(e) {
                e.thumbs.swiper && e.thumbs.update()
            },
            resize: function(e) {
                e.thumbs.swiper && e.thumbs.update()
            },
            observerUpdate: function(e) {
                e.thumbs.swiper && e.thumbs.update()
            },
            setTransition: function(e, t) {
                var a = e.thumbs.swiper;
                a && a.setTransition(t)
            },
            beforeDestroy: function(e) {
                var t = e.thumbs.swiper;
                t && e.thumbs.swiperCreated && t && t.destroy()
            }
        }
    }];
    return _.use(ve),
    _
}
));
//# sourceMappingURL=swiper-bundle.min.js.map
!function(i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
}(function(i) {
    "use strict";
    var e = window.Slick || {};
    (e = function() {
        var e = 0;
        return function(t, o) {
            var s, n = this;
            n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(e, t) {
                    return i('<button type="button" />').text(t + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            },
            n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            },
            i.extend(n, n.initials),
            n.activeBreakpoint = null,
            n.animType = null,
            n.animProp = null,
            n.breakpoints = [],
            n.breakpointSettings = [],
            n.cssTransitions = !1,
            n.focussed = !1,
            n.interrupted = !1,
            n.hidden = "hidden",
            n.paused = !0,
            n.positionProp = null,
            n.respondTo = null,
            n.rowCount = 1,
            n.shouldClick = !0,
            n.$slider = i(t),
            n.$slidesCache = null,
            n.transformType = null,
            n.transitionType = null,
            n.visibilityChange = "visibilitychange",
            n.windowWidth = 0,
            n.windowTimer = null,
            s = i(t).data("slick") || {},
            n.options = i.extend({}, n.defaults, o, s),
            n.currentSlide = n.options.initialSlide,
            n.originalSettings = n.options,
            void 0 !== document.mozHidden ? (n.hidden = "mozHidden",
            n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden",
            n.visibilityChange = "webkitvisibilitychange"),
            n.autoPlay = i.proxy(n.autoPlay, n),
            n.autoPlayClear = i.proxy(n.autoPlayClear, n),
            n.autoPlayIterator = i.proxy(n.autoPlayIterator, n),
            n.changeSlide = i.proxy(n.changeSlide, n),
            n.clickHandler = i.proxy(n.clickHandler, n),
            n.selectHandler = i.proxy(n.selectHandler, n),
            n.setPosition = i.proxy(n.setPosition, n),
            n.swipeHandler = i.proxy(n.swipeHandler, n),
            n.dragHandler = i.proxy(n.dragHandler, n),
            n.keyHandler = i.proxy(n.keyHandler, n),
            n.instanceUid = e++,
            n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
            n.registerBreakpoints(),
            n.init(!0)
        }
    }()).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }
    ,
    e.prototype.addSlide = e.prototype.slickAdd = function(e, t, o) {
        var s = this;
        if ("boolean" == typeof t)
            o = t,
            t = null;
        else if (t < 0 || t >= s.slideCount)
            return !1;
        s.unload(),
        "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack),
        s.$slides = s.$slideTrack.children(this.options.slide),
        s.$slideTrack.children(this.options.slide).detach(),
        s.$slideTrack.append(s.$slides),
        s.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e)
        }),
        s.$slidesCache = s.$slides,
        s.reinit()
    }
    ,
    e.prototype.animateHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.animate({
                height: e
            }, i.options.speed)
        }
    }
    ,
    e.prototype.animateSlide = function(e, t) {
        var o = {}
          , s = this;
        s.animateHeight(),
        !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
        !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
            left: e
        }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
            top: e
        }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
        i({
            animStart: s.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: s.options.speed,
            easing: s.options.easing,
            step: function(i) {
                i = Math.ceil(i),
                !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)",
                s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)",
                s.$slideTrack.css(o))
            },
            complete: function() {
                t && t.call()
            }
        })) : (s.applyTransition(),
        e = Math.ceil(e),
        !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)",
        s.$slideTrack.css(o),
        t && setTimeout(function() {
            s.disableTransition(),
            t.call()
        }, s.options.speed))
    }
    ,
    e.prototype.getNavTarget = function() {
        var e = this
          , t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)),
        t
    }
    ,
    e.prototype.asNavFor = function(e) {
        var t = this.getNavTarget();
        null !== t && "object" == typeof t && t.each(function() {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }
    ,
    e.prototype.applyTransition = function(i) {
        var e = this
          , t = {};
        !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase,
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }
    ,
    e.prototype.autoPlay = function() {
        var i = this;
        i.autoPlayClear(),
        i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
    }
    ,
    e.prototype.autoPlayClear = function() {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer)
    }
    ,
    e.prototype.autoPlayIterator = function() {
        var i = this
          , e = i.currentSlide + i.options.slidesToScroll;
        i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll,
        i.currentSlide - 1 == 0 && (i.direction = 1))),
        i.slideHandler(e))
    }
    ,
    e.prototype.buildArrows = function() {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"),
        e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"),
        e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
        !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }
    ,
    e.prototype.buildDots = function() {
        var e, t, o = this;
        if (!0 === o.options.dots) {
            for (o.$slider.addClass("slick-dotted"),
            t = i("<ul />").addClass(o.options.dotsClass),
            e = 0; e <= o.getDotCount(); e += 1)
                t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
            o.$dots = t.appendTo(o.options.appendDots),
            o.$dots.find("li").first().addClass("slick-active")
        }
    }
    ,
    e.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
        }),
        e.$slider.addClass("slick-slider"),
        e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(),
        e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(),
        e.$slideTrack.css("opacity", 0),
        !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1),
        i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
        !0 === e.options.draggable && e.$list.addClass("draggable")
    }
    ,
    e.prototype.buildRows = function() {
        var i, e, t, o, s, n, r, l = this;
        if (o = document.createDocumentFragment(),
        n = l.$slider.children(),
        l.options.rows > 1) {
            for (r = l.options.slidesPerRow * l.options.rows,
            s = Math.ceil(n.length / r),
            i = 0; i < s; i++) {
                var d = document.createElement("div");
                for (e = 0; e < l.options.rows; e++) {
                    var a = document.createElement("div");
                    for (t = 0; t < l.options.slidesPerRow; t++) {
                        var c = i * r + (e * l.options.slidesPerRow + t);
                        n.get(c) && a.appendChild(n.get(c))
                    }
                    d.appendChild(a)
                }
                o.appendChild(d)
            }
            l.$slider.empty().append(o),
            l.$slider.children().children().children().css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }
    ,
    e.prototype.checkResponsive = function(e, t) {
        var o, s, n, r = this, l = !1, d = r.$slider.width(), a = window.innerWidth || i(window).width();
        if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)),
        r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            s = null;
            for (o in r.breakpoints)
                r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
            null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s,
            "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e)),
            l = s) : (r.activeBreakpoint = s,
            "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e)),
            l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null,
            r.options = r.originalSettings,
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e),
            l = s),
            e || !1 === l || r.$slider.trigger("breakpoint", [r, l])
        }
    }
    ,
    e.prototype.changeSlide = function(e, t) {
        var o, s, n, r = this, l = i(e.currentTarget);
        switch (l.is("a") && e.preventDefault(),
        l.is("li") || (l = l.closest("li")),
        n = r.slideCount % r.options.slidesToScroll != 0,
        o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll,
        e.data.message) {
        case "previous":
            s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o,
            r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
            break;
        case "next":
            s = 0 === o ? r.options.slidesToScroll : o,
            r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
            break;
        case "index":
            var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
            r.slideHandler(r.checkNavigable(d), !1, t),
            l.children().trigger("focus");
            break;
        default:
            return
        }
    }
    ,
    e.prototype.checkNavigable = function(i) {
        var e, t;
        if (e = this.getNavigableIndexes(),
        t = 0,
        i > e[e.length - 1])
            i = e[e.length - 1];
        else
            for (var o in e) {
                if (i < e[o]) {
                    i = t;
                    break
                }
                t = e[o]
            }
        return i
    }
    ,
    e.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
        !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)),
        e.$slider.off("focus.slick blur.slick"),
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
        e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
        !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
        e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
        e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
        e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
        e.$list.off("click.slick", e.clickHandler),
        i(document).off(e.visibilityChange, e.visibility),
        e.cleanUpSlideEvents(),
        !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler),
        i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
        i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
        i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
        i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }
    ,
    e.prototype.cleanUpSlideEvents = function() {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }
    ,
    e.prototype.cleanUpRows = function() {
        var i, e = this;
        e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"),
        e.$slider.empty().append(i))
    }
    ,
    e.prototype.clickHandler = function(i) {
        !1 === this.shouldClick && (i.stopImmediatePropagation(),
        i.stopPropagation(),
        i.preventDefault())
    }
    ,
    e.prototype.destroy = function(e) {
        var t = this;
        t.autoPlayClear(),
        t.touchObject = {},
        t.cleanUpEvents(),
        i(".slick-cloned", t.$slider).detach(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
        t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
        t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            i(this).attr("style", i(this).data("originalStyling"))
        }),
        t.$slideTrack.children(this.options.slide).detach(),
        t.$slideTrack.detach(),
        t.$list.detach(),
        t.$slider.append(t.$slides)),
        t.cleanUpRows(),
        t.$slider.removeClass("slick-slider"),
        t.$slider.removeClass("slick-initialized"),
        t.$slider.removeClass("slick-dotted"),
        t.unslicked = !0,
        e || t.$slider.trigger("destroy", [t])
    }
    ,
    e.prototype.disableTransition = function(i) {
        var e = this
          , t = {};
        t[e.transitionType] = "",
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }
    ,
    e.prototype.fadeSlide = function(i, e) {
        var t = this;
        !1 === t.cssTransitions ? (t.$slides.eq(i).css({
            zIndex: t.options.zIndex
        }),
        t.$slides.eq(i).animate({
            opacity: 1
        }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i),
        t.$slides.eq(i).css({
            opacity: 1,
            zIndex: t.options.zIndex
        }),
        e && setTimeout(function() {
            t.disableTransition(i),
            e.call()
        }, t.options.speed))
    }
    ,
    e.prototype.fadeSlideOut = function(i) {
        var e = this;
        !1 === e.cssTransitions ? e.$slides.eq(i).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(i),
        e.$slides.eq(i).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }
    ,
    e.prototype.filterSlides = e.prototype.slickFilter = function(i) {
        var e = this;
        null !== i && (e.$slidesCache = e.$slides,
        e.unload(),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slidesCache.filter(i).appendTo(e.$slideTrack),
        e.reinit())
    }
    ,
    e.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(t) {
            t.stopImmediatePropagation();
            var o = i(this);
            setTimeout(function() {
                e.options.pauseOnFocus && (e.focussed = o.is(":focus"),
                e.autoPlay())
            }, 0)
        })
    }
    ,
    e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }
    ,
    e.prototype.getDotCount = function() {
        var i = this
          , e = 0
          , t = 0
          , o = 0;
        if (!0 === i.options.infinite)
            if (i.slideCount <= i.options.slidesToShow)
                ++o;
            else
                for (; e < i.slideCount; )
                    ++o,
                    e = t + i.options.slidesToScroll,
                    t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else if (!0 === i.options.centerMode)
            o = i.slideCount;
        else if (i.options.asNavFor)
            for (; e < i.slideCount; )
                ++o,
                e = t + i.options.slidesToScroll,
                t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else
            o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
        return o - 1
    }
    ,
    e.prototype.getLeft = function(i) {
        var e, t, o, s, n = this, r = 0;
        return n.slideOffset = 0,
        t = n.$slides.first().outerHeight(!0),
        !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1,
        s = -1,
        !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)),
        r = t * n.options.slidesToShow * s),
        n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1,
        r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1,
        r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth,
        r = (i + n.options.slidesToShow - n.slideCount) * t),
        n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0,
        r = 0),
        !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0,
        n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)),
        e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r,
        !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow),
        e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0,
        !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1),
        e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0,
        e += (n.$list.width() - o.outerWidth()) / 2)),
        e
    }
    ,
    e.prototype.getOption = e.prototype.slickGetOption = function(i) {
        return this.options[i]
    }
    ,
    e.prototype.getNavigableIndexes = function() {
        var i, e = this, t = 0, o = 0, s = [];
        for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll,
        o = -1 * e.options.slidesToScroll,
        i = 2 * e.slideCount); t < i; )
            s.push(t),
            t = o + e.options.slidesToScroll,
            o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return s
    }
    ,
    e.prototype.getSlick = function() {
        return this
    }
    ,
    e.prototype.getSlideCount = function() {
        var e, t, o = this;
        return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0,
        !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(s, n) {
            if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft)
                return e = n,
                !1
        }),
        Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }
    ,
    e.prototype.goTo = e.prototype.slickGoTo = function(i, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(i)
            }
        }, e)
    }
    ,
    e.prototype.init = function(e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"),
        t.buildRows(),
        t.buildOut(),
        t.setProps(),
        t.startLoad(),
        t.loadSlider(),
        t.initializeEvents(),
        t.updateArrows(),
        t.updateDots(),
        t.checkResponsive(!0),
        t.focusHandler()),
        e && t.$slider.trigger("init", [t]),
        !0 === t.options.accessibility && t.initADA(),
        t.options.autoplay && (t.paused = !1,
        t.autoPlay())
    }
    ,
    e.prototype.initADA = function() {
        var e = this
          , t = Math.ceil(e.slideCount / e.options.slidesToShow)
          , o = e.getNavigableIndexes().filter(function(i) {
            return i >= 0 && i < e.slideCount
        });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }),
        null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t) {
            var s = o.indexOf(t);
            i(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + t,
                tabindex: -1
            }),
            -1 !== s && i(this).attr({
                "aria-describedby": "slick-slide-control" + e.instanceUid + s
            })
        }),
        e.$dots.attr("role", "tablist").find("li").each(function(s) {
            var n = o[s];
            i(this).attr({
                role: "presentation"
            }),
            i(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + s,
                "aria-controls": "slick-slide" + e.instanceUid + n,
                "aria-label": s + 1 + " of " + t,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)
            e.$slides.eq(s).attr("tabindex", 0);
        e.activateADA()
    }
    ,
    e.prototype.initArrowEvents = function() {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, i.changeSlide),
        i.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, i.changeSlide),
        !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler),
        i.$nextArrow.on("keydown.slick", i.keyHandler)))
    }
    ,
    e.prototype.initDotEvents = function() {
        var e = this;
        !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide),
        !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)),
        !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }
    ,
    e.prototype.initSlideEvents = function() {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
    }
    ,
    e.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(),
        e.initDotEvents(),
        e.initSlideEvents(),
        e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler),
        e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler),
        e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("click.slick", e.clickHandler),
        i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
        !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)),
        i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)),
        i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
        i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(e.setPosition)
    }
    ,
    e.prototype.initUI = function() {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(),
        i.$nextArrow.show()),
        !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
    }
    ,
    e.prototype.keyHandler = function(i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "next" : "previous"
            }
        }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "previous" : "next"
            }
        }))
    }
    ,
    e.prototype.lazyLoad = function() {
        function e(e) {
            i("img[data-lazy]", e).each(function() {
                var e = i(this)
                  , t = i(this).attr("data-lazy")
                  , o = i(this).attr("data-srcset")
                  , s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes")
                  , r = document.createElement("img");
                r.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        o && (e.attr("srcset", o),
                        s && e.attr("sizes", s)),
                        e.attr("src", t).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }),
                        n.$slider.trigger("lazyLoaded", [n, e, t])
                    })
                }
                ,
                r.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                    n.$slider.trigger("lazyLoadError", [n, e, t])
                }
                ,
                r.src = t
            })
        }
        var t, o, s, n = this;
        if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)),
        s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide,
        s = Math.ceil(o + n.options.slidesToShow),
        !0 === n.options.fade && (o > 0 && o--,
        s <= n.slideCount && s++)),
        t = n.$slider.find(".slick-slide").slice(o, s),
        "anticipated" === n.options.lazyLoad)
            for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++)
                r < 0 && (r = n.slideCount - 1),
                t = (t = t.add(d.eq(r))).add(d.eq(l)),
                r--,
                l++;
        e(t),
        n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
    }
    ,
    e.prototype.loadSlider = function() {
        var i = this;
        i.setPosition(),
        i.$slideTrack.css({
            opacity: 1
        }),
        i.$slider.removeClass("slick-loading"),
        i.initUI(),
        "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
    }
    ,
    e.prototype.next = e.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    e.prototype.orientationChange = function() {
        var i = this;
        i.checkResponsive(),
        i.setPosition()
    }
    ,
    e.prototype.pause = e.prototype.slickPause = function() {
        var i = this;
        i.autoPlayClear(),
        i.paused = !0
    }
    ,
    e.prototype.play = e.prototype.slickPlay = function() {
        var i = this;
        i.autoPlay(),
        i.options.autoplay = !0,
        i.paused = !1,
        i.focussed = !1,
        i.interrupted = !1
    }
    ,
    e.prototype.postSlide = function(e) {
        var t = this;
        t.unslicked || (t.$slider.trigger("afterChange", [t, e]),
        t.animating = !1,
        t.slideCount > t.options.slidesToShow && t.setPosition(),
        t.swipeLeft = null,
        t.options.autoplay && t.autoPlay(),
        !0 === t.options.accessibility && (t.initADA(),
        t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()))
    }
    ,
    e.prototype.prev = e.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }
    ,
    e.prototype.preventDefault = function(i) {
        i.preventDefault()
    }
    ,
    e.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var t, o, s, n, r, l = this, d = i("img[data-lazy]", l.$slider);
        d.length ? (t = d.first(),
        o = t.attr("data-lazy"),
        s = t.attr("data-srcset"),
        n = t.attr("data-sizes") || l.$slider.attr("data-sizes"),
        (r = document.createElement("img")).onload = function() {
            s && (t.attr("srcset", s),
            n && t.attr("sizes", n)),
            t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
            !0 === l.options.adaptiveHeight && l.setPosition(),
            l.$slider.trigger("lazyLoaded", [l, t, o]),
            l.progressiveLazyLoad()
        }
        ,
        r.onerror = function() {
            e < 3 ? setTimeout(function() {
                l.progressiveLazyLoad(e + 1)
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
            l.$slider.trigger("lazyLoadError", [l, t, o]),
            l.progressiveLazyLoad())
        }
        ,
        r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
    }
    ,
    e.prototype.refresh = function(e) {
        var t, o, s = this;
        o = s.slideCount - s.options.slidesToShow,
        !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
        s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
        t = s.currentSlide,
        s.destroy(!0),
        i.extend(s, s.initials, {
            currentSlide: t
        }),
        s.init(),
        e || s.changeSlide({
            data: {
                message: "index",
                index: t
            }
        }, !1)
    }
    ,
    e.prototype.registerBreakpoints = function() {
        var e, t, o, s = this, n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
            s.respondTo = s.options.respondTo || "window";
            for (e in n)
                if (o = s.breakpoints.length - 1,
                n.hasOwnProperty(e)) {
                    for (t = n[e].breakpoint; o >= 0; )
                        s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1),
                        o--;
                    s.breakpoints.push(t),
                    s.breakpointSettings[t] = n[e].settings
                }
            s.breakpoints.sort(function(i, e) {
                return s.options.mobileFirst ? i - e : e - i
            })
        }
    }
    ,
    e.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.registerBreakpoints(),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.cleanUpSlideEvents(),
        e.initSlideEvents(),
        e.checkResponsive(!1, !0),
        !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
        e.setPosition(),
        e.focusHandler(),
        e.paused = !e.options.autoplay,
        e.autoPlay(),
        e.$slider.trigger("reInit", [e])
    }
    ,
    e.prototype.resize = function() {
        var e = this;
        i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay),
        e.windowDelay = window.setTimeout(function() {
            e.windowWidth = i(window).width(),
            e.checkResponsive(),
            e.unslicked || e.setPosition()
        }, 50))
    }
    ,
    e.prototype.removeSlide = e.prototype.slickRemove = function(i, e, t) {
        var o = this;
        if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i,
        o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
            return !1;
        o.unload(),
        !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
        o.$slides = o.$slideTrack.children(this.options.slide),
        o.$slideTrack.children(this.options.slide).detach(),
        o.$slideTrack.append(o.$slides),
        o.$slidesCache = o.$slides,
        o.reinit()
    }
    ,
    e.prototype.setCSS = function(i) {
        var e, t, o = this, s = {};
        !0 === o.options.rtl && (i = -i),
        e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px",
        t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px",
        s[o.positionProp] = i,
        !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {},
        !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")",
        o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)",
        o.$slideTrack.css(s)))
    }
    ,
    e.prototype.setDimensions = function() {
        var i = this;
        !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
            padding: "0px " + i.options.centerPadding
        }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow),
        !0 === i.options.centerMode && i.$list.css({
            padding: i.options.centerPadding + " 0px"
        })),
        i.listWidth = i.$list.width(),
        i.listHeight = i.$list.height(),
        !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow),
        i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth),
        i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
    }
    ,
    e.prototype.setFade = function() {
        var e, t = this;
        t.$slides.each(function(o, s) {
            e = t.slideWidth * o * -1,
            !0 === t.options.rtl ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            }) : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            })
        }),
        t.$slides.eq(t.currentSlide).css({
            zIndex: t.options.zIndex - 1,
            opacity: 1
        })
    }
    ,
    e.prototype.setHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.css("height", e)
        }
    }
    ,
    e.prototype.setOption = e.prototype.slickSetOption = function() {
        var e, t, o, s, n, r = this, l = !1;
        if ("object" === i.type(arguments[0]) ? (o = arguments[0],
        l = arguments[1],
        n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0],
        s = arguments[1],
        l = arguments[2],
        "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")),
        "single" === n)
            r.options[o] = s;
        else if ("multiple" === n)
            i.each(o, function(i, e) {
                r.options[i] = e
            });
        else if ("responsive" === n)
            for (t in s)
                if ("array" !== i.type(r.options.responsive))
                    r.options.responsive = [s[t]];
                else {
                    for (e = r.options.responsive.length - 1; e >= 0; )
                        r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1),
                        e--;
                    r.options.responsive.push(s[t])
                }
        l && (r.unload(),
        r.reinit())
    }
    ,
    e.prototype.setPosition = function() {
        var i = this;
        i.setDimensions(),
        i.setHeight(),
        !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(),
        i.$slider.trigger("setPosition", [i])
    }
    ,
    e.prototype.setProps = function() {
        var i = this
          , e = document.body.style;
        i.positionProp = !0 === i.options.vertical ? "top" : "left",
        "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"),
        void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0),
        i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex),
        void 0 !== e.OTransform && (i.animType = "OTransform",
        i.transformType = "-o-transform",
        i.transitionType = "OTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.MozTransform && (i.animType = "MozTransform",
        i.transformType = "-moz-transform",
        i.transitionType = "MozTransition",
        void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
        void 0 !== e.webkitTransform && (i.animType = "webkitTransform",
        i.transformType = "-webkit-transform",
        i.transitionType = "webkitTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.msTransform && (i.animType = "msTransform",
        i.transformType = "-ms-transform",
        i.transitionType = "msTransition",
        void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform",
        i.transformType = "transform",
        i.transitionType = "transition"),
        i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
    }
    ,
    e.prototype.setSlideClasses = function(i) {
        var e, t, o, s, n = this;
        if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
        n.$slides.eq(i).addClass("slick-current"),
        !0 === n.options.centerMode) {
            var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
            e = Math.floor(n.options.slidesToShow / 2),
            !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i,
            t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")),
            0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")),
            n.$slides.eq(i).addClass("slick-center")
        } else
            i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow,
            o = !0 === n.options.infinite ? n.options.slidesToShow + i : i,
            n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
    }
    ,
    e.prototype.setupInfinite = function() {
        var e, t, o, s = this;
        if (!0 === s.options.fade && (s.options.centerMode = !1),
        !0 === s.options.infinite && !1 === s.options.fade && (t = null,
        s.slideCount > s.options.slidesToShow)) {
            for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow,
            e = s.slideCount; e > s.slideCount - o; e -= 1)
                t = e - 1,
                i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < o + s.slideCount; e += 1)
                t = e,
                i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                i(this).attr("id", "")
            })
        }
    }
    ,
    e.prototype.interrupt = function(i) {
        var e = this;
        i || e.autoPlay(),
        e.interrupted = i
    }
    ,
    e.prototype.selectHandler = function(e) {
        var t = this
          , o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide")
          , s = parseInt(o.attr("data-slick-index"));
        s || (s = 0),
        t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s)
    }
    ,
    e.prototype.slideHandler = function(i, e, t) {
        var o, s, n, r, l, d = null, a = this;
        if (e = e || !1,
        !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i))
            if (!1 === e && a.asNavFor(i),
            o = i,
            d = a.getLeft(o),
            r = a.getLeft(a.currentSlide),
            a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft,
            !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
                !1 === a.options.fade && (o = a.currentSlide,
                !0 !== t ? a.animateSlide(r, function() {
                    a.postSlide(o)
                }) : a.postSlide(o));
            else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll))
                !1 === a.options.fade && (o = a.currentSlide,
                !0 !== t ? a.animateSlide(r, function() {
                    a.postSlide(o)
                }) : a.postSlide(o));
            else {
                if (a.options.autoplay && clearInterval(a.autoPlayTimer),
                s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o,
                a.animating = !0,
                a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
                n = a.currentSlide,
                a.currentSlide = s,
                a.setSlideClasses(a.currentSlide),
                a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide),
                a.updateDots(),
                a.updateArrows(),
                !0 === a.options.fade)
                    return !0 !== t ? (a.fadeSlideOut(n),
                    a.fadeSlide(s, function() {
                        a.postSlide(s)
                    })) : a.postSlide(s),
                    void a.animateHeight();
                !0 !== t ? a.animateSlide(d, function() {
                    a.postSlide(s)
                }) : a.postSlide(s)
            }
    }
    ,
    e.prototype.startLoad = function() {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(),
        i.$nextArrow.hide()),
        !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
        i.$slider.addClass("slick-loading")
    }
    ,
    e.prototype.swipeDirection = function() {
        var i, e, t, o, s = this;
        return i = s.touchObject.startX - s.touchObject.curX,
        e = s.touchObject.startY - s.touchObject.curY,
        t = Math.atan2(e, i),
        (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
        o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
    }
    ,
    e.prototype.swipeEnd = function(i) {
        var e, t, o = this;
        if (o.dragging = !1,
        o.swiping = !1,
        o.scrolling)
            return o.scrolling = !1,
            !1;
        if (o.interrupted = !1,
        o.shouldClick = !(o.touchObject.swipeLength > 10),
        void 0 === o.touchObject.curX)
            return !1;
        if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (t = o.swipeDirection()) {
            case "left":
            case "down":
                e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(),
                o.currentDirection = 0;
                break;
            case "right":
            case "up":
                e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(),
                o.currentDirection = 1
            }
            "vertical" != t && (o.slideHandler(e),
            o.touchObject = {},
            o.$slider.trigger("swipe", [o, t]))
        } else
            o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide),
            o.touchObject = {})
    }
    ,
    e.prototype.swipeHandler = function(i) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend"in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse")))
            switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1,
            e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold,
            !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
            i.data.action) {
            case "start":
                e.swipeStart(i);
                break;
            case "move":
                e.swipeMove(i);
                break;
            case "end":
                e.swipeEnd(i)
            }
    }
    ,
    e.prototype.swipeMove = function(i) {
        var e, t, o, s, n, r, l = this;
        return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null,
        !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide),
        l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX,
        l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY,
        l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))),
        r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))),
        !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0,
        !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r),
        t = l.swipeDirection(),
        void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0,
        i.preventDefault()),
        s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1),
        !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
        o = l.touchObject.swipeLength,
        l.touchObject.edgeHit = !1,
        !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction,
        l.touchObject.edgeHit = !0),
        !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s,
        !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
        !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null,
        !1) : void l.setCSS(l.swipeLeft))))
    }
    ,
    e.prototype.swipeStart = function(i) {
        var e, t = this;
        if (t.interrupted = !0,
        1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow)
            return t.touchObject = {},
            !1;
        void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
        t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX,
        t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY,
        t.dragging = !0
    }
    ,
    e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
        var i = this;
        null !== i.$slidesCache && (i.unload(),
        i.$slideTrack.children(this.options.slide).detach(),
        i.$slidesCache.appendTo(i.$slideTrack),
        i.reinit())
    }
    ,
    e.prototype.unload = function() {
        var e = this;
        i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
        e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
        e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }
    ,
    e.prototype.unslick = function(i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]),
        e.destroy()
    }
    ,
    e.prototype.updateArrows = function() {
        var i = this;
        Math.floor(i.options.slidesToShow / 2),
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }
    ,
    e.prototype.updateDots = function() {
        var i = this;
        null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(),
        i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
    }
    ,
    e.prototype.visibility = function() {
        var i = this;
        i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
    }
    ,
    i.fn.slick = function() {
        var i, t, o = this, s = arguments[0], n = Array.prototype.slice.call(arguments, 1), r = o.length;
        for (i = 0; i < r; i++)
            if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i],s) : t = o[i].slick[s].apply(o[i].slick, n),
            void 0 !== t)
                return t;
        return o
    }
});

// ==================================================
// fancyBox v3.5.7
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2019 fancyApps
//
// ==================================================
/*
!function(t, e, n, o) {
    "use strict";
    function i(t, e) {
        var o, i, a, s = [], r = 0;
        t && t.isDefaultPrevented() || (t.preventDefault(),
        e = e || {},
        t && t.data && (e = h(t.data.options, e)),
        o = e.$target || n(t.currentTarget).trigger("blur"),
        (a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o) || (e.selector ? s = n(e.selector) : (i = o.attr("data-fancybox") || "",
        i ? (s = t.data ? t.data.items : [],
        s = s.length ? s.filter('[data-fancybox="' + i + '"]') : n('[data-fancybox="' + i + '"]')) : s = [o]),
        r = n(s).index(o),
        r < 0 && (r = 0),
        a = n.fancybox.open(s, e, r),
        a.$trigger = o))
    }
    if (t.console = t.console || {
        info: function(t) {}
    },
    n) {
        if (n.fn.fancybox)
            return void console.info("fancyBox already initialized");
        var a = {
            closeExisting: !1,
            loop: !1,
            gutter: 50,
            keyboard: !0,
            preventCaptionOverlap: !0,
            arrows: !0,
            infobar: !0,
            smallBtn: "auto",
            toolbar: "auto",
            buttons: ["zoom", "slideShow", "thumbs", "close"],
            idleTime: 3,
            protect: !1,
            modal: !1,
            image: {
                preload: !1
            },
            ajax: {
                settings: {
                    data: {
                        fancybox: !0
                    }
                }
            },
            iframe: {
                tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
                preload: !0,
                css: {},
                attr: {
                    scrolling: "auto"
                }
            },
            video: {
                tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
                format: "",
                autoStart: !0
            },
            defaultType: "image",
            animationEffect: "zoom",
            animationDuration: 366,
            zoomOpacity: "auto",
            transitionEffect: "fade",
            transitionDuration: 366,
            slideClass: "",
            baseClass: "",
            baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
            spinnerTpl: '<div class="fancybox-loading"></div>',
            errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
            btnTpl: {
                download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
                zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
                close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
                arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
                arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
                smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'
            },
            parentEl: "body",
            hideScrollbar: !0,
            autoFocus: !0,
            backFocus: !0,
            trapFocus: !0,
            fullScreen: {
                autoStart: !1
            },
            touch: {
                vertical: !0,
                momentum: !0
            },
            hash: null,
            media: {},
            slideShow: {
                autoStart: !1,
                speed: 3e3
            },
            thumbs: {
                autoStart: !1,
                hideOnClose: !0,
                parentEl: ".fancybox-container",
                axis: "y"
            },
            wheel: "auto",
            onInit: n.noop,
            beforeLoad: n.noop,
            afterLoad: n.noop,
            beforeShow: n.noop,
            afterShow: n.noop,
            beforeClose: n.noop,
            afterClose: n.noop,
            onActivate: n.noop,
            onDeactivate: n.noop,
            clickContent: function(t, e) {
                return "image" === t.type && "zoom"
            },
            clickSlide: "close",
            clickOutside: "close",
            dblclickContent: !1,
            dblclickSlide: !1,
            dblclickOutside: !1,
            mobile: {
                preventCaptionOverlap: !1,
                idleTime: !1,
                clickContent: function(t, e) {
                    return "image" === t.type && "toggleControls"
                },
                clickSlide: function(t, e) {
                    return "image" === t.type ? "toggleControls" : "close"
                },
                dblclickContent: function(t, e) {
                    return "image" === t.type && "zoom"
                },
                dblclickSlide: function(t, e) {
                    return "image" === t.type && "zoom"
                }
            },
            lang: "en",
            i18n: {
                en: {
                    CLOSE: "Close",
                    NEXT: "Next",
                    PREV: "Previous",
                    ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                    PLAY_START: "Start slideshow",
                    PLAY_STOP: "Pause slideshow",
                    FULL_SCREEN: "Full screen",
                    THUMBS: "Thumbnails",
                    DOWNLOAD: "Download",
                    SHARE: "Share",
                    ZOOM: "Zoom"
                },
                de: {
                    CLOSE: "Schlie&szlig;en",
                    NEXT: "Weiter",
                    PREV: "Zur&uuml;ck",
                    ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                    PLAY_START: "Diaschau starten",
                    PLAY_STOP: "Diaschau beenden",
                    FULL_SCREEN: "Vollbild",
                    THUMBS: "Vorschaubilder",
                    DOWNLOAD: "Herunterladen",
                    SHARE: "Teilen",
                    ZOOM: "Vergr&ouml;&szlig;ern"
                }
            }
        }
          , s = n(t)
          , r = n(e)
          , c = 0
          , l = function(t) {
            return t && t.hasOwnProperty && t instanceof n
        }
          , d = function() {
            return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
                return t.setTimeout(e, 1e3 / 60)
            }
        }()
          , u = function() {
            return t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function(e) {
                t.clearTimeout(e)
            }
        }()
          , f = function() {
            var t, n = e.createElement("fakeelement"), o = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
            };
            for (t in o)
                if (void 0 !== n.style[t])
                    return o[t];
            return "transitionend"
        }()
          , p = function(t) {
            return t && t.length && t[0].offsetHeight
        }
          , h = function(t, e) {
            var o = n.extend(!0, {}, t, e);
            return n.each(e, function(t, e) {
                n.isArray(e) && (o[t] = e)
            }),
            o
        }
          , g = function(t) {
            var o, i;
            return !(!t || t.ownerDocument !== e) && (n(".fancybox-container").css("pointer-events", "none"),
            o = {
                x: t.getBoundingClientRect().left + t.offsetWidth / 2,
                y: t.getBoundingClientRect().top + t.offsetHeight / 2
            },
            i = e.elementFromPoint(o.x, o.y) === t,
            n(".fancybox-container").css("pointer-events", ""),
            i)
        }
          , b = function(t, e, o) {
            var i = this;
            i.opts = h({
                index: o
            }, n.fancybox.defaults),
            n.isPlainObject(e) && (i.opts = h(i.opts, e)),
            n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)),
            i.id = i.opts.id || ++c,
            i.currIndex = parseInt(i.opts.index, 10) || 0,
            i.prevIndex = null,
            i.prevPos = null,
            i.currPos = 0,
            i.firstRun = !0,
            i.group = [],
            i.slides = {},
            i.addContent(t),
            i.group.length && i.init()
        };
        n.extend(b.prototype, {
            init: function() {
                var o, i, a = this, s = a.group[a.currIndex], r = s.opts;
                r.closeExisting && n.fancybox.close(!0),
                n("body").addClass("fancybox-active"),
                !n.fancybox.getInstance() && !1 !== r.hideScrollbar && !n.fancybox.isMobile && e.body.scrollHeight > t.innerHeight && (n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (t.innerWidth - e.documentElement.clientWidth) + "px;}</style>"),
                n("body").addClass("compensate-for-scrollbar")),
                i = "",
                n.each(r.buttons, function(t, e) {
                    i += r.btnTpl[e] || ""
                }),
                o = n(a.translate(a, r.baseTpl.replace("{{buttons}}", i).replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight))).attr("id", "fancybox-container-" + a.id).addClass(r.baseClass).data("FancyBox", a).appendTo(r.parentEl),
                a.$refs = {
                    container: o
                },
                ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function(t) {
                    a.$refs[t] = o.find(".fancybox-" + t)
                }),
                a.trigger("onInit"),
                a.activate(),
                a.jumpTo(a.currIndex)
            },
            translate: function(t, e) {
                var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
                return e.replace(/\{\{(\w+)\}\}/g, function(t, e) {
                    return void 0 === n[e] ? t : n[e]
                })
            },
            addContent: function(t) {
                var e, o = this, i = n.makeArray(t);
                n.each(i, function(t, e) {
                    var i, a, s, r, c, l = {}, d = {};
                    n.isPlainObject(e) ? (l = e,
                    d = e.opts || e) : "object" === n.type(e) && n(e).length ? (i = n(e),
                    d = i.data() || {},
                    d = n.extend(!0, {}, d, d.options),
                    d.$orig = i,
                    l.src = o.opts.src || d.src || i.attr("href"),
                    l.type || l.src || (l.type = "inline",
                    l.src = e)) : l = {
                        type: "html",
                        src: e + ""
                    },
                    l.opts = n.extend(!0, {}, o.opts, d),
                    n.isArray(d.buttons) && (l.opts.buttons = d.buttons),
                    n.fancybox.isMobile && l.opts.mobile && (l.opts = h(l.opts, l.opts.mobile)),
                    a = l.type || l.opts.type,
                    r = l.src || "",
                    !a && r && ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (a = "video",
                    l.opts.video.format || (l.opts.video.format = "video/" + ("ogv" === s[1] ? "ogg" : s[1]))) : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? a = "image" : r.match(/\.(pdf)((\?|#).*)?$/i) ? (a = "iframe",
                    l = n.extend(!0, l, {
                        contentType: "pdf",
                        opts: {
                            iframe: {
                                preload: !1
                            }
                        }
                    })) : "#" === r.charAt(0) && (a = "inline")),
                    a ? l.type = a : o.trigger("objectNeedsType", l),
                    l.contentType || (l.contentType = n.inArray(l.type, ["html", "inline", "ajax"]) > -1 ? "html" : l.type),
                    l.index = o.group.length,
                    "auto" == l.opts.smallBtn && (l.opts.smallBtn = n.inArray(l.type, ["html", "inline", "ajax"]) > -1),
                    "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn),
                    l.$thumb = l.opts.$thumb || null,
                    l.opts.$trigger && l.index === o.opts.index && (l.$thumb = l.opts.$trigger.find("img:first"),
                    l.$thumb.length && (l.opts.$orig = l.opts.$trigger)),
                    l.$thumb && l.$thumb.length || !l.opts.$orig || (l.$thumb = l.opts.$orig.find("img:first")),
                    l.$thumb && !l.$thumb.length && (l.$thumb = null),
                    l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null),
                    "function" === n.type(l.opts.caption) && (l.opts.caption = l.opts.caption.apply(e, [o, l])),
                    "function" === n.type(o.opts.caption) && (l.opts.caption = o.opts.caption.apply(e, [o, l])),
                    l.opts.caption instanceof n || (l.opts.caption = void 0 === l.opts.caption ? "" : l.opts.caption + ""),
                    "ajax" === l.type && (c = r.split(/\s+/, 2),
                    c.length > 1 && (l.src = c.shift(),
                    l.opts.filter = c.shift())),
                    l.opts.modal && (l.opts = n.extend(!0, l.opts, {
                        trapFocus: !0,
                        infobar: 0,
                        toolbar: 0,
                        smallBtn: 0,
                        keyboard: 0,
                        slideShow: 0,
                        fullScreen: 0,
                        thumbs: 0,
                        touch: 0,
                        clickContent: !1,
                        clickSlide: !1,
                        clickOutside: !1,
                        dblclickContent: !1,
                        dblclickSlide: !1,
                        dblclickOutside: !1
                    })),
                    o.group.push(l)
                }),
                Object.keys(o.slides).length && (o.updateControls(),
                (e = o.Thumbs) && e.isActive && (e.create(),
                e.focus()))
            },
            addEvents: function() {
                var e = this;
                e.removeEvents(),
                e.$refs.container.on("click.fb-close", "[data-fancybox-close]", function(t) {
                    t.stopPropagation(),
                    t.preventDefault(),
                    e.close(t)
                }).on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function(t) {
                    t.stopPropagation(),
                    t.preventDefault(),
                    e.previous()
                }).on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function(t) {
                    t.stopPropagation(),
                    t.preventDefault(),
                    e.next()
                }).on("click.fb", "[data-fancybox-zoom]", function(t) {
                    e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]()
                }),
                s.on("orientationchange.fb resize.fb", function(t) {
                    t && t.originalEvent && "resize" === t.originalEvent.type ? (e.requestId && u(e.requestId),
                    e.requestId = d(function() {
                        e.update(t)
                    })) : (e.current && "iframe" === e.current.type && e.$refs.stage.hide(),
                    setTimeout(function() {
                        e.$refs.stage.show(),
                        e.update(t)
                    }, n.fancybox.isMobile ? 600 : 250))
                }),
                r.on("keydown.fb", function(t) {
                    var o = n.fancybox ? n.fancybox.getInstance() : null
                      , i = o.current
                      , a = t.keyCode || t.which;
                    if (9 == a)
                        return void (i.opts.trapFocus && e.focus(t));
                    if (!(!i.opts.keyboard || t.ctrlKey || t.altKey || t.shiftKey || n(t.target).is("input,textarea,video,audio,select")))
                        return 8 === a || 27 === a ? (t.preventDefault(),
                        void e.close(t)) : 37 === a || 38 === a ? (t.preventDefault(),
                        void e.previous()) : 39 === a || 40 === a ? (t.preventDefault(),
                        void e.next()) : void e.trigger("afterKeydown", t, a)
                }),
                e.group[e.currIndex].opts.idleTime && (e.idleSecondsCounter = 0,
                r.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function(t) {
                    e.idleSecondsCounter = 0,
                    e.isIdle && e.showControls(),
                    e.isIdle = !1
                }),
                e.idleInterval = t.setInterval(function() {
                    ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime && !e.isDragging && (e.isIdle = !0,
                    e.idleSecondsCounter = 0,
                    e.hideControls())
                }, 1e3))
            },
            removeEvents: function() {
                var e = this;
                s.off("orientationchange.fb resize.fb"),
                r.off("keydown.fb .fb-idle"),
                this.$refs.container.off(".fb-close .fb-prev .fb-next"),
                e.idleInterval && (t.clearInterval(e.idleInterval),
                e.idleInterval = null)
            },
            previous: function(t) {
                return this.jumpTo(this.currPos - 1, t)
            },
            next: function(t) {
                return this.jumpTo(this.currPos + 1, t)
            },
            jumpTo: function(t, e) {
                var o, i, a, s, r, c, l, d, u, f = this, h = f.group.length;
                if (!(f.isDragging || f.isClosing || f.isAnimating && f.firstRun)) {
                    if (t = parseInt(t, 10),
                    !(a = f.current ? f.current.opts.loop : f.opts.loop) && (t < 0 || t >= h))
                        return !1;
                    if (o = f.firstRun = !Object.keys(f.slides).length,
                    r = f.current,
                    f.prevIndex = f.currIndex,
                    f.prevPos = f.currPos,
                    s = f.createSlide(t),
                    h > 1 && ((a || s.index < h - 1) && f.createSlide(t + 1),
                    (a || s.index > 0) && f.createSlide(t - 1)),
                    f.current = s,
                    f.currIndex = s.index,
                    f.currPos = s.pos,
                    f.trigger("beforeShow", o),
                    f.updateControls(),
                    s.forcedDuration = void 0,
                    n.isNumeric(e) ? s.forcedDuration = e : e = s.opts[o ? "animationDuration" : "transitionDuration"],
                    e = parseInt(e, 10),
                    i = f.isMoved(s),
                    s.$slide.addClass("fancybox-slide--current"),
                    o)
                        return s.opts.animationEffect && e && f.$refs.container.css("transition-duration", e + "ms"),
                        f.$refs.container.addClass("fancybox-is-open").trigger("focus"),
                        f.loadSlide(s),
                        void f.preload("image");
                    c = n.fancybox.getTranslate(r.$slide),
                    l = n.fancybox.getTranslate(f.$refs.stage),
                    n.each(f.slides, function(t, e) {
                        n.fancybox.stop(e.$slide, !0)
                    }),
                    r.pos !== s.pos && (r.isComplete = !1),
                    r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),
                    i ? (u = c.left - (r.pos * c.width + r.pos * r.opts.gutter),
                    n.each(f.slides, function(t, o) {
                        o.$slide.removeClass("fancybox-animated").removeClass(function(t, e) {
                            return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ")
                        });
                        var i = o.pos * c.width + o.pos * o.opts.gutter;
                        n.fancybox.setTranslate(o.$slide, {
                            top: 0,
                            left: i - l.left + u
                        }),
                        o.pos !== s.pos && o.$slide.addClass("fancybox-slide--" + (o.pos > s.pos ? "next" : "previous")),
                        p(o.$slide),
                        n.fancybox.animate(o.$slide, {
                            top: 0,
                            left: (o.pos - s.pos) * c.width + (o.pos - s.pos) * o.opts.gutter
                        }, e, function() {
                            o.$slide.css({
                                transform: "",
                                opacity: ""
                            }).removeClass("fancybox-slide--next fancybox-slide--previous"),
                            o.pos === f.currPos && f.complete()
                        })
                    })) : e && s.opts.transitionEffect && (d = "fancybox-animated fancybox-fx-" + s.opts.transitionEffect,
                    r.$slide.addClass("fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")),
                    n.fancybox.animate(r.$slide, d, e, function() {
                        r.$slide.removeClass(d).removeClass("fancybox-slide--next fancybox-slide--previous")
                    }, !1)),
                    s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
                    f.preload("image")
                }
            },
            createSlide: function(t) {
                var e, o, i = this;
                return o = t % i.group.length,
                o = o < 0 ? i.group.length + o : o,
                !i.slides[t] && i.group[o] && (e = n('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage),
                i.slides[t] = n.extend(!0, {}, i.group[o], {
                    pos: t,
                    $slide: e,
                    isLoaded: !1
                }),
                i.updateSlide(i.slides[t])),
                i.slides[t]
            },
            scaleToActual: function(t, e, o) {
                var i, a, s, r, c, l = this, d = l.current, u = d.$content, f = n.fancybox.getTranslate(d.$slide).width, p = n.fancybox.getTranslate(d.$slide).height, h = d.width, g = d.height;
                l.isAnimating || l.isMoved() || !u || "image" != d.type || !d.isLoaded || d.hasError || (l.isAnimating = !0,
                n.fancybox.stop(u),
                t = void 0 === t ? .5 * f : t,
                e = void 0 === e ? .5 * p : e,
                i = n.fancybox.getTranslate(u),
                i.top -= n.fancybox.getTranslate(d.$slide).top,
                i.left -= n.fancybox.getTranslate(d.$slide).left,
                r = h / i.width,
                c = g / i.height,
                a = .5 * f - .5 * h,
                s = .5 * p - .5 * g,
                h > f && (a = i.left * r - (t * r - t),
                a > 0 && (a = 0),
                a < f - h && (a = f - h)),
                g > p && (s = i.top * c - (e * c - e),
                s > 0 && (s = 0),
                s < p - g && (s = p - g)),
                l.updateCursor(h, g),
                n.fancybox.animate(u, {
                    top: s,
                    left: a,
                    scaleX: r,
                    scaleY: c
                }, o || 366, function() {
                    l.isAnimating = !1
                }),
                l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop())
            },
            scaleToFit: function(t) {
                var e, o = this, i = o.current, a = i.$content;
                o.isAnimating || o.isMoved() || !a || "image" != i.type || !i.isLoaded || i.hasError || (o.isAnimating = !0,
                n.fancybox.stop(a),
                e = o.getFitPos(i),
                o.updateCursor(e.width, e.height),
                n.fancybox.animate(a, {
                    top: e.top,
                    left: e.left,
                    scaleX: e.width / a.width(),
                    scaleY: e.height / a.height()
                }, t || 366, function() {
                    o.isAnimating = !1
                }))
            },
            getFitPos: function(t) {
                var e, o, i, a, s = this, r = t.$content, c = t.$slide, l = t.width || t.opts.width, d = t.height || t.opts.height, u = {};
                return !!(t.isLoaded && r && r.length) && (e = n.fancybox.getTranslate(s.$refs.stage).width,
                o = n.fancybox.getTranslate(s.$refs.stage).height,
                e -= parseFloat(c.css("paddingLeft")) + parseFloat(c.css("paddingRight")) + parseFloat(r.css("marginLeft")) + parseFloat(r.css("marginRight")),
                o -= parseFloat(c.css("paddingTop")) + parseFloat(c.css("paddingBottom")) + parseFloat(r.css("marginTop")) + parseFloat(r.css("marginBottom")),
                l && d || (l = e,
                d = o),
                i = Math.min(1, e / l, o / d),
                l *= i,
                d *= i,
                l > e - .5 && (l = e),
                d > o - .5 && (d = o),
                "image" === t.type ? (u.top = Math.floor(.5 * (o - d)) + parseFloat(c.css("paddingTop")),
                u.left = Math.floor(.5 * (e - l)) + parseFloat(c.css("paddingLeft"))) : "video" === t.contentType && (a = t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9,
                d > l / a ? d = l / a : l > d * a && (l = d * a)),
                u.width = l,
                u.height = d,
                u)
            },
            update: function(t) {
                var e = this;
                n.each(e.slides, function(n, o) {
                    e.updateSlide(o, t)
                })
            },
            updateSlide: function(t, e) {
                var o = this
                  , i = t && t.$content
                  , a = t.width || t.opts.width
                  , s = t.height || t.opts.height
                  , r = t.$slide;
                o.adjustCaption(t),
                i && (a || s || "video" === t.contentType) && !t.hasError && (n.fancybox.stop(i),
                n.fancybox.setTranslate(i, o.getFitPos(t)),
                t.pos === o.currPos && (o.isAnimating = !1,
                o.updateCursor())),
                o.adjustLayout(t),
                r.length && (r.trigger("refresh"),
                t.pos === o.currPos && o.$refs.toolbar.add(o.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", r.get(0).scrollHeight > r.get(0).clientHeight)),
                o.trigger("onUpdate", t, e)
            },
            centerSlide: function(t) {
                var e = this
                  , o = e.current
                  , i = o.$slide;
                !e.isClosing && o && (i.siblings().css({
                    transform: "",
                    opacity: ""
                }),
                i.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),
                n.fancybox.animate(i, {
                    top: 0,
                    left: 0,
                    opacity: 1
                }, void 0 === t ? 0 : t, function() {
                    i.css({
                        transform: "",
                        opacity: ""
                    }),
                    o.isComplete || e.complete()
                }, !1))
            },
            isMoved: function(t) {
                var e, o, i = t || this.current;
                return !!i && (o = n.fancybox.getTranslate(this.$refs.stage),
                e = n.fancybox.getTranslate(i.$slide),
                !i.$slide.hasClass("fancybox-animated") && (Math.abs(e.top - o.top) > .5 || Math.abs(e.left - o.left) > .5))
            },
            updateCursor: function(t, e) {
                var o, i, a = this, s = a.current, r = a.$refs.container;
                s && !a.isClosing && a.Guestures && (r.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"),
                o = a.canPan(t, e),
                i = !!o || a.isZoomable(),
                r.toggleClass("fancybox-is-zoomable", i),
                n("[data-fancybox-zoom]").prop("disabled", !i),
                o ? r.addClass("fancybox-can-pan") : i && ("zoom" === s.opts.clickContent || n.isFunction(s.opts.clickContent) && "zoom" == s.opts.clickContent(s)) ? r.addClass("fancybox-can-zoomIn") : s.opts.touch && (s.opts.touch.vertical || a.group.length > 1) && "video" !== s.contentType && r.addClass("fancybox-can-swipe"))
            },
            isZoomable: function() {
                var t, e = this, n = e.current;
                if (n && !e.isClosing && "image" === n.type && !n.hasError) {
                    if (!n.isLoaded)
                        return !0;
                    if ((t = e.getFitPos(n)) && (n.width > t.width || n.height > t.height))
                        return !0
                }
                return !1
            },
            isScaledDown: function(t, e) {
                var o = this
                  , i = !1
                  , a = o.current
                  , s = a.$content;
                return void 0 !== t && void 0 !== e ? i = t < a.width && e < a.height : s && (i = n.fancybox.getTranslate(s),
                i = i.width < a.width && i.height < a.height),
                i
            },
            canPan: function(t, e) {
                var o = this
                  , i = o.current
                  , a = null
                  , s = !1;
                return "image" === i.type && (i.isComplete || t && e) && !i.hasError && (s = o.getFitPos(i),
                void 0 !== t && void 0 !== e ? a = {
                    width: t,
                    height: e
                } : i.isComplete && (a = n.fancybox.getTranslate(i.$content)),
                a && s && (s = Math.abs(a.width - s.width) > 1.5 || Math.abs(a.height - s.height) > 1.5)),
                s
            },
            loadSlide: function(t) {
                var e, o, i, a = this;
                if (!t.isLoading && !t.isLoaded) {
                    if (t.isLoading = !0,
                    !1 === a.trigger("beforeLoad", t))
                        return t.isLoading = !1,
                        !1;
                    switch (e = t.type,
                    o = t.$slide,
                    o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),
                    e) {
                    case "image":
                        a.setImage(t);
                        break;
                    case "iframe":
                        a.setIframe(t);
                        break;
                    case "html":
                        a.setContent(t, t.src || t.content);
                        break;
                    case "video":
                        a.setContent(t, t.opts.video.tpl.replace(/\{\{src\}\}/gi, t.src).replace("{{format}}", t.opts.videoFormat || t.opts.video.format || "").replace("{{poster}}", t.thumb || ""));
                        break;
                    case "inline":
                        n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
                        break;
                    case "ajax":
                        a.showLoading(t),
                        i = n.ajax(n.extend({}, t.opts.ajax.settings, {
                            url: t.src,
                            success: function(e, n) {
                                "success" === n && a.setContent(t, e)
                            },
                            error: function(e, n) {
                                e && "abort" !== n && a.setError(t)
                            }
                        })),
                        o.one("onReset", function() {
                            i.abort()
                        });
                        break;
                    default:
                        a.setError(t)
                    }
                    return !0
                }
            },
            setImage: function(t) {
                var o, i = this;
                setTimeout(function() {
                    var e = t.$image;
                    i.isClosing || !t.isLoading || e && e.length && e[0].complete || t.hasError || i.showLoading(t)
                }, 50),
                i.checkSrcset(t),
                t.$content = n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image")),
                !1 !== t.opts.preload && t.opts.width && t.opts.height && t.thumb && (t.width = t.opts.width,
                t.height = t.opts.height,
                o = e.createElement("img"),
                o.onerror = function() {
                    n(this).remove(),
                    t.$ghost = null
                }
                ,
                o.onload = function() {
                    i.afterLoad(t)
                }
                ,
                t.$ghost = n(o).addClass("fancybox-image").appendTo(t.$content).attr("src", t.thumb)),
                i.setBigImage(t)
            },
            checkSrcset: function(e) {
                var n, o, i, a, s = e.opts.srcset || e.opts.image.srcset;
                if (s) {
                    i = t.devicePixelRatio || 1,
                    a = t.innerWidth * i,
                    o = s.split(",").map(function(t) {
                        var e = {};
                        return t.trim().split(/\s+/).forEach(function(t, n) {
                            var o = parseInt(t.substring(0, t.length - 1), 10);
                            if (0 === n)
                                return e.url = t;
                            o && (e.value = o,
                            e.postfix = t[t.length - 1])
                        }),
                        e
                    }),
                    o.sort(function(t, e) {
                        return t.value - e.value
                    });
                    for (var r = 0; r < o.length; r++) {
                        var c = o[r];
                        if ("w" === c.postfix && c.value >= a || "x" === c.postfix && c.value >= i) {
                            n = c;
                            break
                        }
                    }
                    !n && o.length && (n = o[o.length - 1]),
                    n && (e.src = n.url,
                    e.width && e.height && "w" == n.postfix && (e.height = e.width / e.height * n.value,
                    e.width = n.value),
                    e.opts.srcset = s)
                }
            },
            setBigImage: function(t) {
                var o = this
                  , i = e.createElement("img")
                  , a = n(i);
                t.$image = a.one("error", function() {
                    o.setError(t)
                }).one("load", function() {
                    var e;
                    t.$ghost || (o.resolveImageSlideSize(t, this.naturalWidth, this.naturalHeight),
                    o.afterLoad(t)),
                    o.isClosing || (t.opts.srcset && (e = t.opts.sizes,
                    e && "auto" !== e || (e = (t.width / t.height > 1 && s.width() / s.height() > 1 ? "100" : Math.round(t.width / t.height * 100)) + "vw"),
                    a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                    t.$ghost && setTimeout(function() {
                        t.$ghost && !o.isClosing && t.$ghost.hide()
                    }, Math.min(300, Math.max(1e3, t.height / 1600))),
                    o.hideLoading(t))
                }).addClass("fancybox-image").attr("src", t.src).appendTo(t.$content),
                (i.complete || "complete" == i.readyState) && a.naturalWidth && a.naturalHeight ? a.trigger("load") : i.error && a.trigger("error")
            },
            resolveImageSlideSize: function(t, e, n) {
                var o = parseInt(t.opts.width, 10)
                  , i = parseInt(t.opts.height, 10);
                t.width = e,
                t.height = n,
                o > 0 && (t.width = o,
                t.height = Math.floor(o * n / e)),
                i > 0 && (t.width = Math.floor(i * e / n),
                t.height = i)
            },
            setIframe: function(t) {
                var e, o = this, i = t.opts.iframe, a = t.$slide;
                t.$content = n('<div class="fancybox-content' + (i.preload ? " fancybox-is-hidden" : "") + '"></div>').css(i.css).appendTo(a),
                a.addClass("fancybox-slide--" + t.contentType),
                t.$iframe = e = n(i.tpl.replace(/\{rnd\}/g, (new Date).getTime())).attr(i.attr).appendTo(t.$content),
                i.preload ? (o.showLoading(t),
                e.on("load.fb error.fb", function(e) {
                    this.isReady = 1,
                    t.$slide.trigger("refresh"),
                    o.afterLoad(t)
                }),
                a.on("refresh.fb", function() {
                    var n, o, s = t.$content, r = i.css.width, c = i.css.height;
                    if (1 === e[0].isReady) {
                        try {
                            n = e.contents(),
                            o = n.find("body")
                        } catch (t) {}
                        o && o.length && o.children().length && (a.css("overflow", "visible"),
                        s.css({
                            width: "100%",
                            "max-width": "100%",
                            height: "9999px"
                        }),
                        void 0 === r && (r = Math.ceil(Math.max(o[0].clientWidth, o.outerWidth(!0)))),
                        s.css("width", r || "").css("max-width", ""),
                        void 0 === c && (c = Math.ceil(Math.max(o[0].clientHeight, o.outerHeight(!0)))),
                        s.css("height", c || ""),
                        a.css("overflow", "auto")),
                        s.removeClass("fancybox-is-hidden")
                    }
                })) : o.afterLoad(t),
                e.attr("src", t.src),
                a.one("onReset", function() {
                    try {
                        n(this).find("iframe").hide().unbind().attr("src", "//about:blank")
                    } catch (t) {}
                    n(this).off("refresh.fb").empty(),
                    t.isLoaded = !1,
                    t.isRevealed = !1
                })
            },
            setContent: function(t, e) {
                var o = this;
                o.isClosing || (o.hideLoading(t),
                t.$content && n.fancybox.stop(t.$content),
                t.$slide.empty(),
                l(e) && e.parent().length ? ((e.hasClass("fancybox-content") || e.parent().hasClass("fancybox-content")) && e.parents(".fancybox-slide").trigger("onReset"),
                t.$placeholder = n("<div>").hide().insertAfter(e),
                e.css("display", "inline-block")) : t.hasError || ("string" === n.type(e) && (e = n("<div>").append(n.trim(e)).contents()),
                t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
                t.$slide.one("onReset", function() {
                    n(this).find("video,audio").trigger("pause"),
                    t.$placeholder && (t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(),
                    t.$placeholder = null),
                    t.$smallBtn && (t.$smallBtn.remove(),
                    t.$smallBtn = null),
                    t.hasError || (n(this).empty(),
                    t.isLoaded = !1,
                    t.isRevealed = !1)
                }),
                n(e).appendTo(t.$slide),
                n(e).is("video,audio") && (n(e).addClass("fancybox-video"),
                n(e).wrap("<div></div>"),
                t.contentType = "video",
                t.opts.width = t.opts.width || n(e).attr("width"),
                t.opts.height = t.opts.height || n(e).attr("height")),
                t.$content = t.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first(),
                t.$content.siblings().hide(),
                t.$content.length || (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
                t.$content.addClass("fancybox-content"),
                t.$slide.addClass("fancybox-slide--" + t.contentType),
                o.afterLoad(t))
            },
            setError: function(t) {
                t.hasError = !0,
                t.$slide.trigger("onReset").removeClass("fancybox-slide--" + t.contentType).addClass("fancybox-slide--error"),
                t.contentType = "html",
                this.setContent(t, this.translate(t, t.opts.errorTpl)),
                t.pos === this.currPos && (this.isAnimating = !1)
            },
            showLoading: function(t) {
                var e = this;
                (t = t || e.current) && !t.$spinner && (t.$spinner = n(e.translate(e, e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"))
            },
            hideLoading: function(t) {
                var e = this;
                (t = t || e.current) && t.$spinner && (t.$spinner.stop().remove(),
                delete t.$spinner)
            },
            afterLoad: function(t) {
                var e = this;
                e.isClosing || (t.isLoading = !1,
                t.isLoaded = !0,
                e.trigger("afterLoad", t),
                e.hideLoading(t),
                !t.opts.smallBtn || t.$smallBtn && t.$smallBtn.length || (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content)),
                t.opts.protect && t.$content && !t.hasError && (t.$content.on("contextmenu.fb", function(t) {
                    return 2 == t.button && t.preventDefault(),
                    !0
                }),
                "image" === t.type && n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
                e.adjustCaption(t),
                e.adjustLayout(t),
                t.pos === e.currPos && e.updateCursor(),
                e.revealContent(t))
            },
            adjustCaption: function(t) {
                var e, n = this, o = t || n.current, i = o.opts.caption, a = o.opts.preventCaptionOverlap, s = n.$refs.caption, r = !1;
                s.toggleClass("fancybox-caption--separate", a),
                a && i && i.length && (o.pos !== n.currPos ? (e = s.clone().appendTo(s.parent()),
                e.children().eq(0).empty().html(i),
                r = e.outerHeight(!0),
                e.empty().remove()) : n.$caption && (r = n.$caption.outerHeight(!0)),
                o.$slide.css("padding-bottom", r || ""))
            },
            adjustLayout: function(t) {
                var e, n, o, i, a = this, s = t || a.current;
                s.isLoaded && !0 !== s.opts.disableLayoutFix && (s.$content.css("margin-bottom", ""),
                s.$content.outerHeight() > s.$slide.height() + .5 && (o = s.$slide[0].style["padding-bottom"],
                i = s.$slide.css("padding-bottom"),
                parseFloat(i) > 0 && (e = s.$slide[0].scrollHeight,
                s.$slide.css("padding-bottom", 0),
                Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i),
                s.$slide.css("padding-bottom", o))),
                s.$content.css("margin-bottom", n))
            },
            revealContent: function(t) {
                var e, o, i, a, s = this, r = t.$slide, c = !1, l = !1, d = s.isMoved(t), u = t.isRevealed;
                return t.isRevealed = !0,
                e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"],
                i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"],
                i = parseInt(void 0 === t.forcedDuration ? i : t.forcedDuration, 10),
                !d && t.pos === s.currPos && i || (e = !1),
                "zoom" === e && (t.pos === s.currPos && i && "image" === t.type && !t.hasError && (l = s.getThumbPos(t)) ? c = s.getFitPos(t) : e = "fade"),
                "zoom" === e ? (s.isAnimating = !0,
                c.scaleX = c.width / l.width,
                c.scaleY = c.height / l.height,
                a = t.opts.zoomOpacity,
                "auto" == a && (a = Math.abs(t.width / t.height - l.width / l.height) > .1),
                a && (l.opacity = .1,
                c.opacity = 1),
                n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), l),
                p(t.$content),
                void n.fancybox.animate(t.$content, c, i, function() {
                    s.isAnimating = !1,
                    s.complete()
                })) : (s.updateSlide(t),
                e ? (n.fancybox.stop(r),
                o = "fancybox-slide--" + (t.pos >= s.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + e,
                r.addClass(o).removeClass("fancybox-slide--current"),
                t.$content.removeClass("fancybox-is-hidden"),
                p(r),
                "image" !== t.type && t.$content.hide().show(0),
                void n.fancybox.animate(r, "fancybox-slide--current", i, function() {
                    r.removeClass(o).css({
                        transform: "",
                        opacity: ""
                    }),
                    t.pos === s.currPos && s.complete()
                }, !0)) : (t.$content.removeClass("fancybox-is-hidden"),
                u || !d || "image" !== t.type || t.hasError || t.$content.hide().fadeIn("fast"),
                void (t.pos === s.currPos && s.complete())))
            },
            getThumbPos: function(t) {
                var e, o, i, a, s, r = !1, c = t.$thumb;
                return !(!c || !g(c[0])) && (e = n.fancybox.getTranslate(c),
                o = parseFloat(c.css("border-top-width") || 0),
                i = parseFloat(c.css("border-right-width") || 0),
                a = parseFloat(c.css("border-bottom-width") || 0),
                s = parseFloat(c.css("border-left-width") || 0),
                r = {
                    top: e.top + o,
                    left: e.left + s,
                    width: e.width - i - s,
                    height: e.height - o - a,
                    scaleX: 1,
                    scaleY: 1
                },
                e.width > 0 && e.height > 0 && r)
            },
            complete: function() {
                var t, e = this, o = e.current, i = {};
                !e.isMoved() && o.isLoaded && (o.isComplete || (o.isComplete = !0,
                o.$slide.siblings().trigger("onReset"),
                e.preload("inline"),
                p(o.$slide),
                o.$slide.addClass("fancybox-slide--complete"),
                n.each(e.slides, function(t, o) {
                    o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1 ? i[o.pos] = o : o && (n.fancybox.stop(o.$slide),
                    o.$slide.off().remove())
                }),
                e.slides = i),
                e.isAnimating = !1,
                e.updateCursor(),
                e.trigger("afterShow"),
                o.opts.video.autoStart && o.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended", function() {
                    Document.exitFullscreen ? Document.exitFullscreen() : this.webkitExitFullscreen && this.webkitExitFullscreen(),
                    e.next()
                }),
                o.opts.autoFocus && "html" === o.contentType && (t = o.$content.find("input[autofocus]:enabled:visible:first"),
                t.length ? t.trigger("focus") : e.focus(null, !0)),
                o.$slide.scrollTop(0).scrollLeft(0))
            },
            preload: function(t) {
                var e, n, o = this;
                o.group.length < 2 || (n = o.slides[o.currPos + 1],
                e = o.slides[o.currPos - 1],
                e && e.type === t && o.loadSlide(e),
                n && n.type === t && o.loadSlide(n))
            },
            focus: function(t, o) {
                var i, a, s = this, r = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "video", "audio", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'].join(",");
                s.isClosing || (i = !t && s.current && s.current.isComplete ? s.current.$slide.find("*:visible" + (o ? ":not(.fancybox-close-small)" : "")) : s.$refs.container.find("*:visible"),
                i = i.filter(r).filter(function() {
                    return "hidden" !== n(this).css("visibility") && !n(this).hasClass("disabled")
                }),
                i.length ? (a = i.index(e.activeElement),
                t && t.shiftKey ? (a < 0 || 0 == a) && (t.preventDefault(),
                i.eq(i.length - 1).trigger("focus")) : (a < 0 || a == i.length - 1) && (t && t.preventDefault(),
                i.eq(0).trigger("focus"))) : s.$refs.container.trigger("focus"))
            },
            activate: function() {
                var t = this;
                n(".fancybox-container").each(function() {
                    var e = n(this).data("FancyBox");
                    e && e.id !== t.id && !e.isClosing && (e.trigger("onDeactivate"),
                    e.removeEvents(),
                    e.isVisible = !1)
                }),
                t.isVisible = !0,
                (t.current || t.isIdle) && (t.update(),
                t.updateControls()),
                t.trigger("onActivate"),
                t.addEvents()
            },
            close: function(t, e) {
                var o, i, a, s, r, c, l, u = this, f = u.current, h = function() {
                    u.cleanUp(t)
                };
                return !u.isClosing && (u.isClosing = !0,
                !1 === u.trigger("beforeClose", t) ? (u.isClosing = !1,
                d(function() {
                    u.update()
                }),
                !1) : (u.removeEvents(),
                a = f.$content,
                o = f.opts.animationEffect,
                i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0,
                f.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),
                !0 !== t ? n.fancybox.stop(f.$slide) : o = !1,
                f.$slide.siblings().trigger("onReset").remove(),
                i && u.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration", i + "ms"),
                u.hideLoading(f),
                u.hideControls(!0),
                u.updateCursor(),
                "zoom" !== o || a && i && "image" === f.type && !u.isMoved() && !f.hasError && (l = u.getThumbPos(f)) || (o = "fade"),
                "zoom" === o ? (n.fancybox.stop(a),
                s = n.fancybox.getTranslate(a),
                c = {
                    top: s.top,
                    left: s.left,
                    scaleX: s.width / l.width,
                    scaleY: s.height / l.height,
                    width: l.width,
                    height: l.height
                },
                r = f.opts.zoomOpacity,
                "auto" == r && (r = Math.abs(f.width / f.height - l.width / l.height) > .1),
                r && (l.opacity = 0),
                n.fancybox.setTranslate(a, c),
                p(a),
                n.fancybox.animate(a, l, i, h),
                !0) : (o && i ? n.fancybox.animate(f.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + o, i, h) : !0 === t ? setTimeout(h, i) : h(),
                !0)))
            },
            cleanUp: function(e) {
                var o, i, a, s = this, r = s.current.opts.$orig;
                s.current.$slide.trigger("onReset"),
                s.$refs.container.empty().remove(),
                s.trigger("afterClose", e),
                s.current.opts.backFocus && (r && r.length && r.is(":visible") || (r = s.$trigger),
                r && r.length && (i = t.scrollX,
                a = t.scrollY,
                r.trigger("focus"),
                n("html, body").scrollTop(a).scrollLeft(i))),
                s.current = null,
                o = n.fancybox.getInstance(),
                o ? o.activate() : (n("body").removeClass("fancybox-active compensate-for-scrollbar"),
                n("#fancybox-style-noscroll").remove())
            },
            trigger: function(t, e) {
                var o, i = Array.prototype.slice.call(arguments, 1), a = this, s = e && e.opts ? e : a.current;
                if (s ? i.unshift(s) : s = a,
                i.unshift(a),
                n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)),
                !1 === o)
                    return o;
                "afterClose" !== t && a.$refs ? a.$refs.container.trigger(t + ".fb", i) : r.trigger(t + ".fb", i)
            },
            updateControls: function() {
                var t = this
                  , o = t.current
                  , i = o.index
                  , a = t.$refs.container
                  , s = t.$refs.caption
                  , r = o.opts.caption;
                o.$slide.trigger("refresh"),
                r && r.length ? (t.$caption = s,
                s.children().eq(0).html(r)) : t.$caption = null,
                t.hasHiddenControls || t.isIdle || t.showControls(),
                a.find("[data-fancybox-count]").html(t.group.length),
                a.find("[data-fancybox-index]").html(i + 1),
                a.find("[data-fancybox-prev]").prop("disabled", !o.opts.loop && i <= 0),
                a.find("[data-fancybox-next]").prop("disabled", !o.opts.loop && i >= t.group.length - 1),
                "image" === o.type ? a.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href", o.opts.image.src || o.src).show() : o.opts.toolbar && a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
                n(e.activeElement).is(":hidden,[disabled]") && t.$refs.container.trigger("focus")
            },
            hideControls: function(t) {
                var e = this
                  , n = ["infobar", "toolbar", "nav"];
                !t && e.current.opts.preventCaptionOverlap || n.push("caption"),
                this.$refs.container.removeClass(n.map(function(t) {
                    return "fancybox-show-" + t
                }).join(" ")),
                this.hasHiddenControls = !0
            },
            showControls: function() {
                var t = this
                  , e = t.current ? t.current.opts : t.opts
                  , n = t.$refs.container;
                t.hasHiddenControls = !1,
                t.idleSecondsCounter = 0,
                n.toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons)).toggleClass("fancybox-show-infobar", !!(e.infobar && t.group.length > 1)).toggleClass("fancybox-show-caption", !!t.$caption).toggleClass("fancybox-show-nav", !!(e.arrows && t.group.length > 1)).toggleClass("fancybox-is-modal", !!e.modal)
            },
            toggleControls: function() {
                this.hasHiddenControls ? this.showControls() : this.hideControls()
            }
        }),
        n.fancybox = {
            version: "3.5.7",
            defaults: a,
            getInstance: function(t) {
                var e = n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox")
                  , o = Array.prototype.slice.call(arguments, 1);
                return e instanceof b && ("string" === n.type(t) ? e[t].apply(e, o) : "function" === n.type(t) && t.apply(e, o),
                e)
            },
            open: function(t, e, n) {
                return new b(t,e,n)
            },
            close: function(t) {
                var e = this.getInstance();
                e && (e.close(),
                !0 === t && this.close(t))
            },
            destroy: function() {
                this.close(!0),
                r.add("body").off("click.fb-start", "**")
            },
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            use3d: function() {
                var n = e.createElement("div");
                return t.getComputedStyle && t.getComputedStyle(n) && t.getComputedStyle(n).getPropertyValue("transform") && !(e.documentMode && e.documentMode < 11)
            }(),
            getTranslate: function(t) {
                var e;
                return !(!t || !t.length) && (e = t[0].getBoundingClientRect(),
                {
                    top: e.top || 0,
                    left: e.left || 0,
                    width: e.width,
                    height: e.height,
                    opacity: parseFloat(t.css("opacity"))
                })
            },
            setTranslate: function(t, e) {
                var n = ""
                  , o = {};
                if (t && e)
                    return void 0 === e.left && void 0 === e.top || (n = (void 0 === e.left ? t.position().left : e.left) + "px, " + (void 0 === e.top ? t.position().top : e.top) + "px",
                    n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")"),
                    void 0 !== e.scaleX && void 0 !== e.scaleY ? n += " scale(" + e.scaleX + ", " + e.scaleY + ")" : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
                    n.length && (o.transform = n),
                    void 0 !== e.opacity && (o.opacity = e.opacity),
                    void 0 !== e.width && (o.width = e.width),
                    void 0 !== e.height && (o.height = e.height),
                    t.css(o)
            },
            animate: function(t, e, o, i, a) {
                var s, r = this;
                n.isFunction(o) && (i = o,
                o = null),
                r.stop(t),
                s = r.getTranslate(t),
                t.on(f, function(c) {
                    (!c || !c.originalEvent || t.is(c.originalEvent.target) && "z-index" != c.originalEvent.propertyName) && (r.stop(t),
                    n.isNumeric(o) && t.css("transition-duration", ""),
                    n.isPlainObject(e) ? void 0 !== e.scaleX && void 0 !== e.scaleY && r.setTranslate(t, {
                        top: e.top,
                        left: e.left,
                        width: s.width * e.scaleX,
                        height: s.height * e.scaleY,
                        scaleX: 1,
                        scaleY: 1
                    }) : !0 !== a && t.removeClass(e),
                    n.isFunction(i) && i(c))
                }),
                n.isNumeric(o) && t.css("transition-duration", o + "ms"),
                n.isPlainObject(e) ? (void 0 !== e.scaleX && void 0 !== e.scaleY && (delete e.width,
                delete e.height,
                t.parent().hasClass("fancybox-slide--image") && t.parent().addClass("fancybox-is-scaling")),
                n.fancybox.setTranslate(t, e)) : t.addClass(e),
                t.data("timer", setTimeout(function() {
                    t.trigger(f)
                }, o + 33))
            },
            stop: function(t, e) {
                t && t.length && (clearTimeout(t.data("timer")),
                e && t.trigger(f),
                t.off(f).css("transition-duration", ""),
                t.parent().removeClass("fancybox-is-scaling"))
            }
        },
        n.fn.fancybox = function(t) {
            var e;
            return t = t || {},
            e = t.selector || !1,
            e ? n("body").off("click.fb-start", e).on("click.fb-start", e, {
                options: t
            }, i) : this.off("click.fb-start").on("click.fb-start", {
                items: this,
                options: t
            }, i),
            this
        }
        ,
        r.on("click.fb-start", "[data-fancybox]", i),
        r.on("click.fb-start", "[data-fancybox-trigger]", function(t) {
            n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]').eq(n(this).attr("data-fancybox-index") || 0).trigger("click.fb-start", {
                $trigger: n(this)
            })
        }),
        function() {
            var t = null;
            r.on("mousedown mouseup focus blur", ".fancybox-button", function(e) {
                switch (e.type) {
                case "mousedown":
                    t = n(this);
                    break;
                case "mouseup":
                    t = null;
                    break;
                case "focusin":
                    n(".fancybox-button").removeClass("fancybox-focus"),
                    n(this).is(t) || n(this).is("[disabled]") || n(this).addClass("fancybox-focus");
                    break;
                case "focusout":
                    n(".fancybox-button").removeClass("fancybox-focus")
                }
            })
        }()
    }
}(window, document, jQuery),
function(t) {
    "use strict";
    var e = {
        youtube: {
            matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
            params: {
                autoplay: 1,
                autohide: 1,
                fs: 1,
                rel: 0,
                hd: 1,
                wmode: "transparent",
                enablejsapi: 1,
                html5: 1
            },
            paramPlace: 8,
            type: "iframe",
            url: "https://www.youtube-nocookie.com/embed/$4",
            thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg"
        },
        vimeo: {
            matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
            params: {
                autoplay: 1,
                hd: 1,
                show_title: 1,
                show_byline: 1,
                show_portrait: 0,
                fullscreen: 1
            },
            paramPlace: 3,
            type: "iframe",
            url: "//player.vimeo.com/video/$2"
        },
        instagram: {
            matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
            type: "image",
            url: "//$1/p/$2/media/?size=l"
        },
        gmap_place: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
            type: "iframe",
            url: function(t) {
                return "//maps.google." + t[2] + "/?ll=" + (t[9] ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "") : t[12] + "").replace(/\?/, "&") + "&output=" + (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            }
        },
        gmap_search: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
            type: "iframe",
            url: function(t) {
                return "//maps.google." + t[2] + "/maps?q=" + t[5].replace("query=", "q=").replace("api=1", "") + "&output=embed"
            }
        }
    }
      , n = function(e, n, o) {
        if (e)
            return o = o || "",
            "object" === t.type(o) && (o = t.param(o, !0)),
            t.each(n, function(t, n) {
                e = e.replace("$" + t, n || "")
            }),
            o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
            e
    };
    t(document).on("objectNeedsType.fb", function(o, i, a) {
        var s, r, c, l, d, u, f, p = a.src || "", h = !1;
        s = t.extend(!0, {}, e, a.opts.media),
        t.each(s, function(e, o) {
            if (c = p.match(o.matcher)) {
                if (h = o.type,
                f = e,
                u = {},
                o.paramPlace && c[o.paramPlace]) {
                    d = c[o.paramPlace],
                    "?" == d[0] && (d = d.substring(1)),
                    d = d.split("&");
                    for (var i = 0; i < d.length; ++i) {
                        var s = d[i].split("=", 2);
                        2 == s.length && (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")))
                    }
                }
                return l = t.extend(!0, {}, o.params, a.opts[e], u),
                p = "function" === t.type(o.url) ? o.url.call(this, c, l, a) : n(o.url, c, l),
                r = "function" === t.type(o.thumb) ? o.thumb.call(this, c, l, a) : n(o.thumb, c),
                "youtube" === e ? p = p.replace(/&t=((\d+)m)?(\d+)s/, function(t, e, n, o) {
                    return "&start=" + ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10))
                }) : "vimeo" === e && (p = p.replace("&%23", "#")),
                !1
            }
        }),
        h ? (a.opts.thumb || a.opts.$thumb && a.opts.$thumb.length || (a.opts.thumb = r),
        "iframe" === h && (a.opts = t.extend(!0, a.opts, {
            iframe: {
                preload: !1,
                attr: {
                    scrolling: "no"
                }
            }
        })),
        t.extend(a, {
            type: h,
            src: p,
            origSrc: a.src,
            contentSource: f,
            contentType: "image" === h ? "image" : "gmap_place" == f || "gmap_search" == f ? "map" : "video"
        })) : p && (a.type = a.opts.defaultType)
    });
    var o = {
        youtube: {
            src: "https://www.youtube.com/iframe_api",
            class: "YT",
            loading: !1,
            loaded: !1
        },
        vimeo: {
            src: "https://player.vimeo.com/api/player.js",
            class: "Vimeo",
            loading: !1,
            loaded: !1
        },
        load: function(t) {
            var e, n = this;
            if (this[t].loaded)
                return void setTimeout(function() {
                    n.done(t)
                });
            this[t].loading || (this[t].loading = !0,
            e = document.createElement("script"),
            e.type = "text/javascript",
            e.src = this[t].src,
            "youtube" === t ? window.onYouTubeIframeAPIReady = function() {
                n[t].loaded = !0,
                n.done(t)
            }
            : e.onload = function() {
                n[t].loaded = !0,
                n.done(t)
            }
            ,
            document.body.appendChild(e))
        },
        done: function(e) {
            var n, o, i;
            "youtube" === e && delete window.onYouTubeIframeAPIReady,
            (n = t.fancybox.getInstance()) && (o = n.current.$content.find("iframe"),
            "youtube" === e && void 0 !== YT && YT ? i = new YT.Player(o.attr("id"),{
                events: {
                    onStateChange: function(t) {
                        0 == t.data && n.next()
                    }
                }
            }) : "vimeo" === e && void 0 !== Vimeo && Vimeo && (i = new Vimeo.Player(o),
            i.on("ended", function() {
                n.next()
            })))
        }
    };
    t(document).on({
        "afterShow.fb": function(t, e, n) {
            e.group.length > 1 && ("youtube" === n.contentSource || "vimeo" === n.contentSource) && o.load(n.contentSource)
        }
    })
}(jQuery),
function(t, e, n) {
    "use strict";
    var o = function() {
        return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
            return t.setTimeout(e, 1e3 / 60)
        }
    }()
      , i = function() {
        return t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function(e) {
            t.clearTimeout(e)
        }
    }()
      , a = function(e) {
        var n = [];
        e = e.originalEvent || e || t.e,
        e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e];
        for (var o in e)
            e[o].pageX ? n.push({
                x: e[o].pageX,
                y: e[o].pageY
            }) : e[o].clientX && n.push({
                x: e[o].clientX,
                y: e[o].clientY
            });
        return n
    }
      , s = function(t, e, n) {
        return e && t ? "x" === n ? t.x - e.x : "y" === n ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)) : 0
    }
      , r = function(t) {
        if (t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || n.isFunction(t.get(0).onclick) || t.data("selectable"))
            return !0;
        for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++)
            if ("data-fancybox-" === o[e].nodeName.substr(0, 14))
                return !0;
        return !1
    }
      , c = function(e) {
        var n = t.getComputedStyle(e)["overflow-y"]
          , o = t.getComputedStyle(e)["overflow-x"]
          , i = ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight
          , a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
        return i || a
    }
      , l = function(t) {
        for (var e = !1; ; ) {
            if (e = c(t.get(0)))
                break;
            if (t = t.parent(),
            !t.length || t.hasClass("fancybox-stage") || t.is("body"))
                break
        }
        return e
    }
      , d = function(t) {
        var e = this;
        e.instance = t,
        e.$bg = t.$refs.bg,
        e.$stage = t.$refs.stage,
        e.$container = t.$refs.container,
        e.destroy(),
        e.$container.on("touchstart.fb.touch mousedown.fb.touch", n.proxy(e, "ontouchstart"))
    };
    d.prototype.destroy = function() {
        var t = this;
        t.$container.off(".fb.touch"),
        n(e).off(".fb.touch"),
        t.requestId && (i(t.requestId),
        t.requestId = null),
        t.tapped && (clearTimeout(t.tapped),
        t.tapped = null)
    }
    ,
    d.prototype.ontouchstart = function(o) {
        var i = this
          , c = n(o.target)
          , d = i.instance
          , u = d.current
          , f = u.$slide
          , p = u.$content
          , h = "touchstart" == o.type;
        if (h && i.$container.off("mousedown.fb.touch"),
        (!o.originalEvent || 2 != o.originalEvent.button) && f.length && c.length && !r(c) && !r(c.parent()) && (c.is("img") || !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left))) {
            if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated"))
                return o.stopPropagation(),
                void o.preventDefault();
            i.realPoints = i.startPoints = a(o),
            i.startPoints.length && (u.touch && o.stopPropagation(),
            i.startEvent = o,
            i.canTap = !0,
            i.$target = c,
            i.$content = p,
            i.opts = u.opts.touch,
            i.isPanning = !1,
            i.isSwiping = !1,
            i.isZooming = !1,
            i.isScrolling = !1,
            i.canPan = d.canPan(),
            i.startTime = (new Date).getTime(),
            i.distanceX = i.distanceY = i.distance = 0,
            i.canvasWidth = Math.round(f[0].clientWidth),
            i.canvasHeight = Math.round(f[0].clientHeight),
            i.contentLastPos = null,
            i.contentStartPos = n.fancybox.getTranslate(i.$content) || {
                top: 0,
                left: 0
            },
            i.sliderStartPos = n.fancybox.getTranslate(f),
            i.stagePos = n.fancybox.getTranslate(d.$refs.stage),
            i.sliderStartPos.top -= i.stagePos.top,
            i.sliderStartPos.left -= i.stagePos.left,
            i.contentStartPos.top -= i.stagePos.top,
            i.contentStartPos.left -= i.stagePos.left,
            n(e).off(".fb.touch").on(h ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", n.proxy(i, "ontouchend")).on(h ? "touchmove.fb.touch" : "mousemove.fb.touch", n.proxy(i, "ontouchmove")),
            n.fancybox.isMobile && e.addEventListener("scroll", i.onscroll, !0),
            ((i.opts || i.canPan) && (c.is(i.$stage) || i.$stage.find(c).length) || (c.is(".fancybox-image") && o.preventDefault(),
            n.fancybox.isMobile && c.parents(".fancybox-caption").length)) && (i.isScrollable = l(c) || l(c.parent()),
            n.fancybox.isMobile && i.isScrollable || o.preventDefault(),
            (1 === i.startPoints.length || u.hasError) && (i.canPan ? (n.fancybox.stop(i.$content),
            i.isPanning = !0) : i.isSwiping = !0,
            i.$container.addClass("fancybox-is-grabbing")),
            2 === i.startPoints.length && "image" === u.type && (u.isLoaded || u.$ghost) && (i.canTap = !1,
            i.isSwiping = !1,
            i.isPanning = !1,
            i.isZooming = !0,
            n.fancybox.stop(i.$content),
            i.centerPointStartX = .5 * (i.startPoints[0].x + i.startPoints[1].x) - n(t).scrollLeft(),
            i.centerPointStartY = .5 * (i.startPoints[0].y + i.startPoints[1].y) - n(t).scrollTop(),
            i.percentageOfImageAtPinchPointX = (i.centerPointStartX - i.contentStartPos.left) / i.contentStartPos.width,
            i.percentageOfImageAtPinchPointY = (i.centerPointStartY - i.contentStartPos.top) / i.contentStartPos.height,
            i.startDistanceBetweenFingers = s(i.startPoints[0], i.startPoints[1]))))
        }
    }
    ,
    d.prototype.onscroll = function(t) {
        var n = this;
        n.isScrolling = !0,
        e.removeEventListener("scroll", n.onscroll, !0)
    }
    ,
    d.prototype.ontouchmove = function(t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons && 0 === t.originalEvent.buttons ? void e.ontouchend(t) : e.isScrolling ? void (e.canTap = !1) : (e.newPoints = a(t),
        void ((e.opts || e.canPan) && e.newPoints.length && e.newPoints.length && (e.isSwiping && !0 === e.isSwiping || t.preventDefault(),
        e.distanceX = s(e.newPoints[0], e.startPoints[0], "x"),
        e.distanceY = s(e.newPoints[0], e.startPoints[0], "y"),
        e.distance = s(e.newPoints[0], e.startPoints[0]),
        e.distance > 0 && (e.isSwiping ? e.onSwipe(t) : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()))))
    }
    ,
    d.prototype.onSwipe = function(e) {
        var a, s = this, r = s.instance, c = s.isSwiping, l = s.sliderStartPos.left || 0;
        if (!0 !== c)
            "x" == c && (s.distanceX > 0 && (s.instance.group.length < 2 || 0 === s.instance.current.index && !s.instance.current.opts.loop) ? l += Math.pow(s.distanceX, .8) : s.distanceX < 0 && (s.instance.group.length < 2 || s.instance.current.index === s.instance.group.length - 1 && !s.instance.current.opts.loop) ? l -= Math.pow(-s.distanceX, .8) : l += s.distanceX),
            s.sliderLastPos = {
                top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY,
                left: l
            },
            s.requestId && (i(s.requestId),
            s.requestId = null),
            s.requestId = o(function() {
                s.sliderLastPos && (n.each(s.instance.slides, function(t, e) {
                    var o = e.pos - s.instance.currPos;
                    n.fancybox.setTranslate(e.$slide, {
                        top: s.sliderLastPos.top,
                        left: s.sliderLastPos.left + o * s.canvasWidth + o * e.opts.gutter
                    })
                }),
                s.$container.addClass("fancybox-is-sliding"))
            });
        else if (Math.abs(s.distance) > 10) {
            if (s.canTap = !1,
            r.group.length < 2 && s.opts.vertical ? s.isSwiping = "y" : r.isDragging || !1 === s.opts.vertical || "auto" === s.opts.vertical && n(t).width() > 800 ? s.isSwiping = "x" : (a = Math.abs(180 * Math.atan2(s.distanceY, s.distanceX) / Math.PI),
            s.isSwiping = a > 45 && a < 135 ? "y" : "x"),
            "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
                return void (s.isScrolling = !0);
            r.isDragging = s.isSwiping,
            s.startPoints = s.newPoints,
            n.each(r.slides, function(t, e) {
                var o, i;
                n.fancybox.stop(e.$slide),
                o = n.fancybox.getTranslate(e.$slide),
                i = n.fancybox.getTranslate(r.$refs.stage),
                e.$slide.css({
                    transform: "",
                    opacity: "",
                    "transition-duration": ""
                }).removeClass("fancybox-animated").removeClass(function(t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ")
                }),
                e.pos === r.current.pos && (s.sliderStartPos.top = o.top - i.top,
                s.sliderStartPos.left = o.left - i.left),
                n.fancybox.setTranslate(e.$slide, {
                    top: o.top - i.top,
                    left: o.left - i.left
                })
            }),
            r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop()
        }
    }
    ,
    d.prototype.onPan = function() {
        var t = this;
        if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5))
            return void (t.startPoints = t.newPoints);
        t.canTap = !1,
        t.contentLastPos = t.limitMovement(),
        t.requestId && i(t.requestId),
        t.requestId = o(function() {
            n.fancybox.setTranslate(t.$content, t.contentLastPos)
        })
    }
    ,
    d.prototype.limitMovement = function() {
        var t, e, n, o, i, a, s = this, r = s.canvasWidth, c = s.canvasHeight, l = s.distanceX, d = s.distanceY, u = s.contentStartPos, f = u.left, p = u.top, h = u.width, g = u.height;
        return i = h > r ? f + l : f,
        a = p + d,
        t = Math.max(0, .5 * r - .5 * h),
        e = Math.max(0, .5 * c - .5 * g),
        n = Math.min(r - h, .5 * r - .5 * h),
        o = Math.min(c - g, .5 * c - .5 * g),
        l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, .8) || 0),
        l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, .8) || 0),
        d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, .8) || 0),
        d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, .8) || 0),
        {
            top: a,
            left: i
        }
    }
    ,
    d.prototype.limitPosition = function(t, e, n, o) {
        var i = this
          , a = i.canvasWidth
          , s = i.canvasHeight;
        return n > a ? (t = t > 0 ? 0 : t,
        t = t < a - n ? a - n : t) : t = Math.max(0, a / 2 - n / 2),
        o > s ? (e = e > 0 ? 0 : e,
        e = e < s - o ? s - o : e) : e = Math.max(0, s / 2 - o / 2),
        {
            top: e,
            left: t
        }
    }
    ,
    d.prototype.onZoom = function() {
        var e = this
          , a = e.contentStartPos
          , r = a.width
          , c = a.height
          , l = a.left
          , d = a.top
          , u = s(e.newPoints[0], e.newPoints[1])
          , f = u / e.startDistanceBetweenFingers
          , p = Math.floor(r * f)
          , h = Math.floor(c * f)
          , g = (r - p) * e.percentageOfImageAtPinchPointX
          , b = (c - h) * e.percentageOfImageAtPinchPointY
          , m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft()
          , v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop()
          , y = m - e.centerPointStartX
          , x = v - e.centerPointStartY
          , w = l + (g + y)
          , $ = d + (b + x)
          , S = {
            top: $,
            left: w,
            scaleX: f,
            scaleY: f
        };
        e.canTap = !1,
        e.newWidth = p,
        e.newHeight = h,
        e.contentLastPos = S,
        e.requestId && i(e.requestId),
        e.requestId = o(function() {
            n.fancybox.setTranslate(e.$content, e.contentLastPos)
        })
    }
    ,
    d.prototype.ontouchend = function(t) {
        var o = this
          , s = o.isSwiping
          , r = o.isPanning
          , c = o.isZooming
          , l = o.isScrolling;
        if (o.endPoints = a(t),
        o.dMs = Math.max((new Date).getTime() - o.startTime, 1),
        o.$container.removeClass("fancybox-is-grabbing"),
        n(e).off(".fb.touch"),
        e.removeEventListener("scroll", o.onscroll, !0),
        o.requestId && (i(o.requestId),
        o.requestId = null),
        o.isSwiping = !1,
        o.isPanning = !1,
        o.isZooming = !1,
        o.isScrolling = !1,
        o.instance.isDragging = !1,
        o.canTap)
            return o.onTap(t);
        o.speed = 100,
        o.velocityX = o.distanceX / o.dMs * .5,
        o.velocityY = o.distanceY / o.dMs * .5,
        r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l)
    }
    ,
    d.prototype.endSwiping = function(t, e) {
        var o = this
          , i = !1
          , a = o.instance.group.length
          , s = Math.abs(o.distanceX)
          , r = "x" == t && a > 1 && (o.dMs > 130 && s > 10 || s > 50);
        o.sliderLastPos = null,
        "y" == t && !e && Math.abs(o.distanceY) > 50 ? (n.fancybox.animate(o.instance.current.$slide, {
            top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY,
            opacity: 0
        }, 200),
        i = o.instance.close(!0, 250)) : r && o.distanceX > 0 ? i = o.instance.previous(300) : r && o.distanceX < 0 && (i = o.instance.next(300)),
        !1 !== i || "x" != t && "y" != t || o.instance.centerSlide(200),
        o.$container.removeClass("fancybox-is-sliding")
    }
    ,
    d.prototype.endPanning = function() {
        var t, e, o, i = this;
        i.contentLastPos && (!1 === i.opts.momentum || i.dMs > 350 ? (t = i.contentLastPos.left,
        e = i.contentLastPos.top) : (t = i.contentLastPos.left + 500 * i.velocityX,
        e = i.contentLastPos.top + 500 * i.velocityY),
        o = i.limitPosition(t, e, i.contentStartPos.width, i.contentStartPos.height),
        o.width = i.contentStartPos.width,
        o.height = i.contentStartPos.height,
        n.fancybox.animate(i.$content, o, 366))
    }
    ,
    d.prototype.endZooming = function() {
        var t, e, o, i, a = this, s = a.instance.current, r = a.newWidth, c = a.newHeight;
        a.contentLastPos && (t = a.contentLastPos.left,
        e = a.contentLastPos.top,
        i = {
            top: e,
            left: t,
            width: r,
            height: c,
            scaleX: 1,
            scaleY: 1
        },
        n.fancybox.setTranslate(a.$content, i),
        r < a.canvasWidth && c < a.canvasHeight ? a.instance.scaleToFit(150) : r > s.width || c > s.height ? a.instance.scaleToActual(a.centerPointStartX, a.centerPointStartY, 150) : (o = a.limitPosition(t, e, r, c),
        n.fancybox.animate(a.$content, o, 150)))
    }
    ,
    d.prototype.onTap = function(e) {
        var o, i = this, s = n(e.target), r = i.instance, c = r.current, l = e && a(e) || i.startPoints, d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0, u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0, f = function(t) {
            var o = c.opts[t];
            if (n.isFunction(o) && (o = o.apply(r, [c, e])),
            o)
                switch (o) {
                case "close":
                    r.close(i.startEvent);
                    break;
                case "toggleControls":
                    r.toggleControls();
                    break;
                case "next":
                    r.next();
                    break;
                case "nextOrClose":
                    r.group.length > 1 ? r.next() : r.close(i.startEvent);
                    break;
                case "zoom":
                    "image" == c.type && (c.isLoaded || c.$ghost) && (r.canPan() ? r.scaleToFit() : r.isScaledDown() ? r.scaleToActual(d, u) : r.group.length < 2 && r.close(i.startEvent))
                }
        };
        if ((!e.originalEvent || 2 != e.originalEvent.button) && (s.is("img") || !(d > s[0].clientWidth + s.offset().left))) {
            if (s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"))
                o = "Outside";
            else if (s.is(".fancybox-slide"))
                o = "Slide";
            else {
                if (!r.current.$content || !r.current.$content.find(s).addBack().filter(s).length)
                    return;
                o = "Content"
            }
            if (i.tapped) {
                if (clearTimeout(i.tapped),
                i.tapped = null,
                Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50)
                    return this;
                f("dblclick" + o)
            } else
                i.tapX = d,
                i.tapY = u,
                c.opts["dblclick" + o] && c.opts["dblclick" + o] !== c.opts["click" + o] ? i.tapped = setTimeout(function() {
                    i.tapped = null,
                    r.isAnimating || f("click" + o)
                }, 500) : f("click" + o);
            return this
        }
    }
    ,
    n(e).on("onActivate.fb", function(t, e) {
        e && !e.Guestures && (e.Guestures = new d(e))
    }).on("beforeClose.fb", function(t, e) {
        e && e.Guestures && e.Guestures.destroy()
    })
}(window, document, jQuery),
function(t, e) {
    "use strict";
    e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
            slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'
        },
        slideShow: {
            autoStart: !1,
            speed: 3e3,
            progress: !0
        }
    });
    var n = function(t) {
        this.instance = t,
        this.init()
    };
    e.extend(n.prototype, {
        timer: null,
        isActive: !1,
        $button: null,
        init: function() {
            var t = this
              , n = t.instance
              , o = n.group[n.currIndex].opts.slideShow;
            t.$button = n.$refs.toolbar.find("[data-fancybox-play]").on("click", function() {
                t.toggle()
            }),
            n.group.length < 2 || !o ? t.$button.hide() : o.progress && (t.$progress = e('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner))
        },
        set: function(t) {
            var n = this
              , o = n.instance
              , i = o.current;
            i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1) ? n.isActive && "video" !== i.contentType && (n.$progress && e.fancybox.animate(n.$progress.show(), {
                scaleX: 1
            }, i.opts.slideShow.speed),
            n.timer = setTimeout(function() {
                o.current.opts.loop || o.current.index != o.group.length - 1 ? o.next() : o.jumpTo(0)
            }, i.opts.slideShow.speed)) : (n.stop(),
            o.idleSecondsCounter = 0,
            o.showControls())
        },
        clear: function() {
            var t = this;
            clearTimeout(t.timer),
            t.timer = null,
            t.$progress && t.$progress.removeAttr("style").hide()
        },
        start: function() {
            var t = this
              , e = t.instance.current;
            e && (t.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"),
            t.isActive = !0,
            e.isComplete && t.set(!0),
            t.instance.trigger("onSlideShowChange", !0))
        },
        stop: function() {
            var t = this
              , e = t.instance.current;
            t.clear(),
            t.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"),
            t.isActive = !1,
            t.instance.trigger("onSlideShowChange", !1),
            t.$progress && t.$progress.removeAttr("style").hide()
        },
        toggle: function() {
            var t = this;
            t.isActive ? t.stop() : t.start()
        }
    }),
    e(t).on({
        "onInit.fb": function(t, e) {
            e && !e.SlideShow && (e.SlideShow = new n(e))
        },
        "beforeShow.fb": function(t, e, n, o) {
            var i = e && e.SlideShow;
            o ? i && n.opts.slideShow.autoStart && i.start() : i && i.isActive && i.clear()
        },
        "afterShow.fb": function(t, e, n) {
            var o = e && e.SlideShow;
            o && o.isActive && o.set()
        },
        "afterKeydown.fb": function(n, o, i, a, s) {
            var r = o && o.SlideShow;
            !r || !i.opts.slideShow || 80 !== s && 32 !== s || e(t.activeElement).is("button,a,input") || (a.preventDefault(),
            r.toggle())
        },
        "beforeClose.fb onDeactivate.fb": function(t, e) {
            var n = e && e.SlideShow;
            n && n.stop()
        }
    }),
    e(t).on("visibilitychange", function() {
        var n = e.fancybox.getInstance()
          , o = n && n.SlideShow;
        o && o.isActive && (t.hidden ? o.clear() : o.set())
    })
}(document, jQuery),
function(t, e) {
    "use strict";
    var n = function() {
        for (var e = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]], n = {}, o = 0; o < e.length; o++) {
            var i = e[o];
            if (i && i[1]in t) {
                for (var a = 0; a < i.length; a++)
                    n[e[0][a]] = i[a];
                return n
            }
        }
        return !1
    }();
    if (n) {
        var o = {
            request: function(e) {
                e = e || t.documentElement,
                e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT)
            },
            exit: function() {
                t[n.exitFullscreen]()
            },
            toggle: function(e) {
                e = e || t.documentElement,
                this.isFullscreen() ? this.exit() : this.request(e)
            },
            isFullscreen: function() {
                return Boolean(t[n.fullscreenElement])
            },
            enabled: function() {
                return Boolean(t[n.fullscreenEnabled])
            }
        };
        e.extend(!0, e.fancybox.defaults, {
            btnTpl: {
                fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'
            },
            fullScreen: {
                autoStart: !1
            }
        }),
        e(t).on(n.fullscreenchange, function() {
            var t = o.isFullscreen()
              , n = e.fancybox.getInstance();
            n && (n.current && "image" === n.current.type && n.isAnimating && (n.isAnimating = !1,
            n.update(!0, !0, 0),
            n.isComplete || n.complete()),
            n.trigger("onFullscreenChange", t),
            n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
            n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !t).toggleClass("fancybox-button--fsexit", t))
        })
    }
    e(t).on({
        "onInit.fb": function(t, e) {
            var i;
            if (!n)
                return void e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
            e && e.group[e.currIndex].opts.fullScreen ? (i = e.$refs.container,
            i.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function(t) {
                t.stopPropagation(),
                t.preventDefault(),
                o.toggle()
            }),
            e.opts.fullScreen && !0 === e.opts.fullScreen.autoStart && o.request(),
            e.FullScreen = o) : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide()
        },
        "afterKeydown.fb": function(t, e, n, o, i) {
            e && e.FullScreen && 70 === i && (o.preventDefault(),
            e.FullScreen.toggle())
        },
        "beforeClose.fb": function(t, e) {
            e && e.FullScreen && e.$refs.container.hasClass("fancybox-is-fullscreen") && o.exit()
        }
    })
}(document, jQuery),
function(t, e) {
    "use strict";
    var n = "fancybox-thumbs";
    e.fancybox.defaults = e.extend(!0, {
        btnTpl: {
            thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'
        },
        thumbs: {
            autoStart: !1,
            hideOnClose: !0,
            parentEl: ".fancybox-container",
            axis: "y"
        }
    }, e.fancybox.defaults);
    var o = function(t) {
        this.init(t)
    };
    e.extend(o.prototype, {
        $button: null,
        $grid: null,
        $list: null,
        isVisible: !1,
        isActive: !1,
        init: function(t) {
            var e = this
              , n = t.group
              , o = 0;
            e.instance = t,
            e.opts = n[t.currIndex].opts.thumbs,
            t.Thumbs = e,
            e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]");
            for (var i = 0, a = n.length; i < a && (n[i].thumb && o++,
            !(o > 1)); i++)
                ;
            o > 1 && e.opts ? (e.$button.removeAttr("style").on("click", function() {
                e.toggle()
            }),
            e.isActive = !0) : e.$button.hide()
        },
        create: function() {
            var t, o = this, i = o.instance, a = o.opts.parentEl, s = [];
            o.$grid || (o.$grid = e('<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>').appendTo(i.$refs.container.find(a).addBack().filter(a)),
            o.$grid.on("click", "a", function() {
                i.jumpTo(e(this).attr("data-index"))
            })),
            o.$list || (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)),
            e.each(i.group, function(e, n) {
                t = n.thumb,
                t || "image" !== n.type || (t = n.src),
                s.push('<a href="javascript:;" tabindex="0" data-index="' + e + '"' + (t && t.length ? ' style="background-image:url(' + t + ')"' : 'class="fancybox-thumbs-missing"') + "></a>")
            }),
            o.$list[0].innerHTML = s.join(""),
            "x" === o.opts.axis && o.$list.width(parseInt(o.$grid.css("padding-right"), 10) + i.group.length * o.$list.children().eq(0).outerWidth(!0))
        },
        focus: function(t) {
            var e, n, o = this, i = o.$list, a = o.$grid;
            o.instance.current && (e = i.children().removeClass("fancybox-thumbs-active").filter('[data-index="' + o.instance.current.index + '"]').addClass("fancybox-thumbs-active"),
            n = e.position(),
            "y" === o.opts.axis && (n.top < 0 || n.top > i.height() - e.outerHeight()) ? i.stop().animate({
                scrollTop: i.scrollTop() + n.top
            }, t) : "x" === o.opts.axis && (n.left < a.scrollLeft() || n.left > a.scrollLeft() + (a.width() - e.outerWidth())) && i.parent().stop().animate({
                scrollLeft: n.left
            }, t))
        },
        update: function() {
            var t = this;
            t.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible),
            t.isVisible ? (t.$grid || t.create(),
            t.instance.trigger("onThumbsShow"),
            t.focus(0)) : t.$grid && t.instance.trigger("onThumbsHide"),
            t.instance.update()
        },
        hide: function() {
            this.isVisible = !1,
            this.update()
        },
        show: function() {
            this.isVisible = !0,
            this.update()
        },
        toggle: function() {
            this.isVisible = !this.isVisible,
            this.update()
        }
    }),
    e(t).on({
        "onInit.fb": function(t, e) {
            var n;
            e && !e.Thumbs && (n = new o(e),
            n.isActive && !0 === n.opts.autoStart && n.show())
        },
        "beforeShow.fb": function(t, e, n, o) {
            var i = e && e.Thumbs;
            i && i.isVisible && i.focus(o ? 0 : 250)
        },
        "afterKeydown.fb": function(t, e, n, o, i) {
            var a = e && e.Thumbs;
            a && a.isActive && 71 === i && (o.preventDefault(),
            a.toggle())
        },
        "beforeClose.fb": function(t, e) {
            var n = e && e.Thumbs;
            n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide()
        }
    })
}(document, jQuery),
function(t, e) {
    "use strict";
    function n(t) {
        var e = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
            "`": "&#x60;",
            "=": "&#x3D;"
        };
        return String(t).replace(/[&<>"'`=\/]/g, function(t) {
            return e[t]
        })
    }
    e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
            share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'
        },
        share: {
            url: function(t, e) {
                return !t.currentHash && "inline" !== e.type && "html" !== e.type && (e.origSrc || e.src) || window.location
            },
            tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'
        }
    }),
    e(t).on("click", "[data-fancybox-share]", function() {
        var t, o, i = e.fancybox.getInstance(), a = i.current || null;
        a && ("function" === e.type(a.opts.share.url) && (t = a.opts.share.url.apply(a, [i, a])),
        o = a.opts.share.tpl.replace(/\{\{media\}\}/g, "image" === a.type ? encodeURIComponent(a.src) : "").replace(/\{\{url\}\}/g, encodeURIComponent(t)).replace(/\{\{url_raw\}\}/g, n(t)).replace(/\{\{descr\}\}/g, i.$caption ? encodeURIComponent(i.$caption.text()) : ""),
        e.fancybox.open({
            src: i.translate(i, o),
            type: "html",
            opts: {
                touch: !1,
                animationEffect: !1,
                afterLoad: function(t, e) {
                    i.$refs.container.one("beforeClose.fb", function() {
                        t.close(null, 0)
                    }),
                    e.$content.find(".fancybox-share__button").click(function() {
                        return window.open(this.href, "Share", "width=550, height=450"),
                        !1
                    })
                },
                mobile: {
                    autoFocus: !1
                }
            }
        }))
    })
}(document, jQuery),
function(t, e, n) {
    "use strict";
    function o() {
        var e = t.location.hash.substr(1)
          , n = e.split("-")
          , o = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) ? parseInt(n.pop(-1), 10) || 1 : 1
          , i = n.join("-");
        return {
            hash: e,
            index: o < 1 ? 1 : o,
            gallery: i
        }
    }
    function i(t) {
        "" !== t.gallery && n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']").eq(t.index - 1).focus().trigger("click.fb-start")
    }
    function a(t) {
        var e, n;
        return !!t && (e = t.current ? t.current.opts : t.opts,
        "" !== (n = e.hash || (e.$orig ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger") : "")) && n)
    }
    n.escapeSelector || (n.escapeSelector = function(t) {
        return (t + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(t, e) {
            return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
        })
    }
    ),
    n(function() {
        !1 !== n.fancybox.defaults.hash && (n(e).on({
            "onInit.fb": function(t, e) {
                var n, i;
                !1 !== e.group[e.currIndex].opts.hash && (n = o(),
                (i = a(e)) && n.gallery && i == n.gallery && (e.currIndex = n.index - 1))
            },
            "beforeShow.fb": function(n, o, i, s) {
                var r;
                i && !1 !== i.opts.hash && (r = a(o)) && (o.currentHash = r + (o.group.length > 1 ? "-" + (i.index + 1) : ""),
                t.location.hash !== "#" + o.currentHash && (s && !o.origHash && (o.origHash = t.location.hash),
                o.hashTimer && clearTimeout(o.hashTimer),
                o.hashTimer = setTimeout(function() {
                    "replaceState"in t.history ? (t.history[s ? "pushState" : "replaceState"]({}, e.title, t.location.pathname + t.location.search + "#" + o.currentHash),
                    s && (o.hasCreatedHistory = !0)) : t.location.hash = o.currentHash,
                    o.hashTimer = null
                }, 300)))
            },
            "beforeClose.fb": function(n, o, i) {
                i && !1 !== i.opts.hash && (clearTimeout(o.hashTimer),
                o.currentHash && o.hasCreatedHistory ? t.history.back() : o.currentHash && ("replaceState"in t.history ? t.history.replaceState({}, e.title, t.location.pathname + t.location.search + (o.origHash || "")) : t.location.hash = o.origHash),
                o.currentHash = null)
            }
        }),
        n(t).on("hashchange.fb", function() {
            var t = o()
              , e = null;
            n.each(n(".fancybox-container").get().reverse(), function(t, o) {
                var i = n(o).data("FancyBox");
                if (i && i.currentHash)
                    return e = i,
                    !1
            }),
            e ? e.currentHash === t.gallery + "-" + t.index || 1 === t.index && e.currentHash == t.gallery || (e.currentHash = null,
            e.close()) : "" !== t.gallery && i(t)
        }),
        setTimeout(function() {
            n.fancybox.getInstance() || i(o())
        }, 50))
    })
}(window, document, jQuery),
function(t, e) {
    "use strict";
    var n = (new Date).getTime();
    e(t).on({
        "onInit.fb": function(t, e, o) {
            e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function(t) {
                var o = e.current
                  , i = (new Date).getTime();
                e.group.length < 2 || !1 === o.opts.wheel || "auto" === o.opts.wheel && "image" !== o.type || (t.preventDefault(),
                t.stopPropagation(),
                o.$slide.hasClass("fancybox-animated") || (t = t.originalEvent || t,
                i - n < 250 || (n = i,
                e[(-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0 ? "next" : "previous"]())))
            })
        }
    })
}(document, jQuery);
*/

"object" == typeof navigator && function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Plyr", t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).Plyr = t()
}(this, (function() {
    "use strict";
    function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        )(t)
    }
    function t(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function n(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1,
            i.configurable = !0,
            "value"in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i)
        }
    }
    function i(e, t, i) {
        return t && n(e.prototype, t),
        i && n(e, i),
        e
    }
    function a(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function r(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            t && (i = i.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, i)
        }
        return n
    }
    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? r(Object(n), !0).forEach((function(t) {
                a(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function s(e, t) {
        if (null == e)
            return {};
        var n, i, a = function(e, t) {
            if (null == e)
                return {};
            var n, i, a = {}, r = Object.keys(e);
            for (i = 0; i < r.length; i++)
                n = r[i],
                t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            for (i = 0; i < r.length; i++)
                n = r[i],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (a[n] = e[n])
        }
        return a
    }
    function l(e, t) {
        return function(e) {
            if (Array.isArray(e))
                return e
        }(e) || function(e, t) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e)))
                return;
            var n = []
              , i = !0
              , a = !1
              , r = void 0;
            try {
                for (var o, s = e[Symbol.iterator](); !(i = (o = s.next()).done) && (n.push(o.value),
                !t || n.length !== t); i = !0)
                    ;
            } catch (e) {
                a = !0,
                r = e
            } finally {
                try {
                    i || null == s.return || s.return()
                } finally {
                    if (a)
                        throw r
                }
            }
            return n
        }(e, t) || u(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function c(e) {
        return function(e) {
            if (Array.isArray(e))
                return d(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
                return Array.from(e)
        }(e) || u(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function u(e, t) {
        if (e) {
            if ("string" == typeof e)
                return d(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name),
            "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e, t) : void 0
        }
    }
    function d(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++)
            i[n] = e[n];
        return i
    }
    function h(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1,
            i.configurable = !0,
            "value"in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i)
        }
    }
    function m(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function p(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            t && (i = i.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, i)
        }
        return n
    }
    function f(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? p(Object(n), !0).forEach((function(t) {
                m(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    var g = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    function y(e, t) {
        return function() {
            return Array.from(document.querySelectorAll(t)).includes(this)
        }
        .call(e, t)
    }
    var b = function(e) {
        return null != e ? e.constructor : null
    }
      , v = function(e, t) {
        return !!(e && t && e instanceof t)
    }
      , w = function(e) {
        return null == e
    }
      , k = function(e) {
        return b(e) === Object
    }
      , T = function(e) {
        return b(e) === String
    }
      , C = function(e) {
        return Array.isArray(e)
    }
      , A = function(e) {
        return v(e, NodeList)
    }
      , S = T
      , P = C
      , E = A
      , N = function(e) {
        return v(e, Element)
    }
      , M = function(e) {
        return v(e, Event)
    }
      , x = function(e) {
        return w(e) || (T(e) || C(e) || A(e)) && !e.length || k(e) && !Object.keys(e).length
    };
    function I(e, t) {
        if (1 > t) {
            var n = function(e) {
                var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0
            }(t);
            return parseFloat(e.toFixed(n))
        }
        return Math.round(e / t) * t
    }
    var L, O, _, j = function() {
        function e(t, n) {
            (function(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            )(this, e),
            N(t) ? this.element = t : S(t) && (this.element = document.querySelector(t)),
            N(this.element) && x(this.element.rangeTouch) && (this.config = f({}, g, {}, n),
            this.init())
        }
        return function(e, t, n) {
            t && h(e.prototype, t),
            n && h(e, n)
        }(e, [{
            key: "init",
            value: function() {
                e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none",
                this.element.style.webKitUserSelect = "none",
                this.element.style.touchAction = "manipulation"),
                this.listeners(!0),
                this.element.rangeTouch = this)
            }
        }, {
            key: "destroy",
            value: function() {
                e.enabled && (this.config.addCSS && (this.element.style.userSelect = "",
                this.element.style.webKitUserSelect = "",
                this.element.style.touchAction = ""),
                this.listeners(!1),
                this.element.rangeTouch = null)
            }
        }, {
            key: "listeners",
            value: function(e) {
                var t = this
                  , n = e ? "addEventListener" : "removeEventListener";
                ["touchstart", "touchmove", "touchend"].forEach((function(e) {
                    t.element[n](e, (function(e) {
                        return t.set(e)
                    }
                    ), !1)
                }
                ))
            }
        }, {
            key: "get",
            value: function(t) {
                if (!e.enabled || !M(t))
                    return null;
                var n, i = t.target, a = t.changedTouches[0], r = parseFloat(i.getAttribute("min")) || 0, o = parseFloat(i.getAttribute("max")) || 100, s = parseFloat(i.getAttribute("step")) || 1, l = i.getBoundingClientRect(), c = 100 / l.width * (this.config.thumbWidth / 2) / 100;
                return 0 > (n = 100 / l.width * (a.clientX - l.left)) ? n = 0 : 100 < n && (n = 100),
                50 > n ? n -= (100 - 2 * n) * c : 50 < n && (n += 2 * (n - 50) * c),
                r + I(n / 100 * (o - r), s)
            }
        }, {
            key: "set",
            value: function(t) {
                e.enabled && M(t) && !t.target.disabled && (t.preventDefault(),
                t.target.value = this.get(t),
                function(e, t) {
                    if (e && t) {
                        var n = new Event(t,{
                            bubbles: !0
                        });
                        e.dispatchEvent(n)
                    }
                }(t.target, "touchend" === t.type ? "change" : "input"))
            }
        }], [{
            key: "setup",
            value: function(t) {
                var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}
                  , i = null;
                if (x(t) || S(t) ? i = Array.from(document.querySelectorAll(S(t) ? t : 'input[type="range"]')) : N(t) ? i = [t] : E(t) ? i = Array.from(t) : P(t) && (i = t.filter(N)),
                x(i))
                    return null;
                var a = f({}, g, {}, n);
                if (S(t) && a.watch) {
                    var r = new MutationObserver((function(n) {
                        Array.from(n).forEach((function(n) {
                            Array.from(n.addedNodes).forEach((function(n) {
                                N(n) && y(n, t) && new e(n,a)
                            }
                            ))
                        }
                        ))
                    }
                    ));
                    r.observe(document.body, {
                        childList: !0,
                        subtree: !0
                    })
                }
                return i.map((function(t) {
                    return new e(t,n)
                }
                ))
            }
        }, {
            key: "enabled",
            get: function() {
                return "ontouchstart"in document.documentElement
            }
        }]),
        e
    }(), D = function(e) {
        return null != e ? e.constructor : null
    }, q = function(e, t) {
        return Boolean(e && t && e instanceof t)
    }, H = function(e) {
        return null == e
    }, F = function(e) {
        return D(e) === Object
    }, R = function(e) {
        return D(e) === String
    }, V = function(e) {
        return D(e) === Function
    }, B = function(e) {
        return Array.isArray(e)
    }, U = function(e) {
        return q(e, NodeList)
    }, W = function(e) {
        return H(e) || (R(e) || B(e) || U(e)) && !e.length || F(e) && !Object.keys(e).length
    }, z = H, K = F, Y = function(e) {
        return D(e) === Number && !Number.isNaN(e)
    }, Q = R, X = function(e) {
        return D(e) === Boolean
    }, $ = V, J = B, G = U, Z = function(t) {
        return null !== t && "object" === e(t) && 1 === t.nodeType && "object" === e(t.style) && "object" === e(t.ownerDocument)
    }, ee = function(e) {
        return q(e, Event)
    }, te = function(e) {
        return q(e, KeyboardEvent)
    }, ne = function(e) {
        return q(e, TextTrack) || !H(e) && R(e.kind)
    }, ie = function(e) {
        return q(e, Promise) && V(e.then)
    }, ae = function(e) {
        if (q(e, window.URL))
            return !0;
        if (!R(e))
            return !1;
        var t = e;
        e.startsWith("http://") && e.startsWith("https://") || (t = "http://".concat(e));
        try {
            return !W(new URL(t).hostname)
        } catch (e) {
            return !1
        }
    }, re = W, oe = (L = document.createElement("span"),
    O = {
        WebkitTransition: "webkitTransitionEnd",
        MozTransition: "transitionend",
        OTransition: "oTransitionEnd otransitionend",
        transition: "transitionend"
    },
    _ = Object.keys(O).find((function(e) {
        return void 0 !== L.style[e]
    }
    )),
    !!Q(_) && O[_]);
    function se(e, t) {
        setTimeout((function() {
            try {
                e.hidden = !0,
                e.offsetHeight,
                e.hidden = !1
            } catch (e) {}
        }
        ), t)
    }
    var le = {
        isIE: /* @cc_on!@ */
        !!document.documentMode,
        isEdge: window.navigator.userAgent.includes("Edge"),
        isWebkit: "WebkitAppearance"in document.documentElement.style && !/Edge/.test(navigator.userAgent),
        isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
        isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform)
    };
    function ce(e, t) {
        return t.split(".").reduce((function(e, t) {
            return e && e[t]
        }
        ), e)
    }
    function ue() {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
            n[i - 1] = arguments[i];
        if (!n.length)
            return e;
        var r = n.shift();
        return K(r) ? (Object.keys(r).forEach((function(t) {
            K(r[t]) ? (Object.keys(e).includes(t) || Object.assign(e, a({}, t, {})),
            ue(e[t], r[t])) : Object.assign(e, a({}, t, r[t]))
        }
        )),
        ue.apply(void 0, [e].concat(n))) : e
    }
    function de(e, t) {
        var n = e.length ? e : [e];
        Array.from(n).reverse().forEach((function(e, n) {
            var i = n > 0 ? t.cloneNode(!0) : t
              , a = e.parentNode
              , r = e.nextSibling;
            i.appendChild(e),
            r ? a.insertBefore(i, r) : a.appendChild(i)
        }
        ))
    }
    function he(e, t) {
        Z(e) && !re(t) && Object.entries(t).filter((function(e) {
            var t = l(e, 2)[1];
            return !z(t)
        }
        )).forEach((function(t) {
            var n = l(t, 2)
              , i = n[0]
              , a = n[1];
            return e.setAttribute(i, a)
        }
        ))
    }
    function me(e, t, n) {
        var i = document.createElement(e);
        return K(t) && he(i, t),
        Q(n) && (i.innerText = n),
        i
    }
    function pe(e, t, n, i) {
        Z(t) && t.appendChild(me(e, n, i))
    }
    function fe(e) {
        G(e) || J(e) ? Array.from(e).forEach(fe) : Z(e) && Z(e.parentNode) && e.parentNode.removeChild(e)
    }
    function ge(e) {
        if (Z(e))
            for (var t = e.childNodes.length; t > 0; )
                e.removeChild(e.lastChild),
                t -= 1
    }
    function ye(e, t) {
        return Z(t) && Z(t.parentNode) && Z(e) ? (t.parentNode.replaceChild(e, t),
        e) : null
    }
    function be(e, t) {
        if (!Q(e) || re(e))
            return {};
        var n = {}
          , i = ue({}, t);
        return e.split(",").forEach((function(e) {
            var t = e.trim()
              , a = t.replace(".", "")
              , r = t.replace(/[[\]]/g, "").split("=")
              , o = l(r, 1)[0]
              , s = r.length > 1 ? r[1].replace(/["']/g, "") : "";
            switch (t.charAt(0)) {
            case ".":
                Q(i.class) ? n.class = "".concat(i.class, " ").concat(a) : n.class = a;
                break;
            case "#":
                n.id = t.replace("#", "");
                break;
            case "[":
                n[o] = s
            }
        }
        )),
        ue(i, n)
    }
    function ve(e, t) {
        if (Z(e)) {
            var n = t;
            X(n) || (n = !e.hidden),
            e.hidden = n
        }
    }
    function we(e, t, n) {
        if (G(e))
            return Array.from(e).map((function(e) {
                return we(e, t, n)
            }
            ));
        if (Z(e)) {
            var i = "toggle";
            return void 0 !== n && (i = n ? "add" : "remove"),
            e.classList[i](t),
            e.classList.contains(t)
        }
        return !1
    }
    function ke(e, t) {
        return Z(e) && e.classList.contains(t)
    }
    function Te(e, t) {
        var n = Element.prototype;
        return (n.matches || n.webkitMatchesSelector || n.mozMatchesSelector || n.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t)).includes(this)
        }
        ).call(e, t)
    }
    function Ce(e) {
        return this.elements.container.querySelectorAll(e)
    }
    function Ae(e) {
        return this.elements.container.querySelector(e)
    }
    function Se() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null
          , t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        Z(e) && (e.focus({
            preventScroll: !0
        }),
        t && we(e, this.config.classNames.tabFocus))
    }
    var Pe, Ee = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    }, Ne = {
        audio: "canPlayType"in document.createElement("audio"),
        video: "canPlayType"in document.createElement("video"),
        check: function(e, t, n) {
            var i = le.isIPhone && n && Ne.playsinline
              , a = Ne[e] || "html5" !== t;
            return {
                api: a,
                ui: a && Ne.rangeInput && ("video" !== e || !le.isIPhone || i)
            }
        },
        pip: !(le.isIPhone || !$(me("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || me("video").disablePictureInPicture)),
        airplay: $(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline"in document.createElement("video"),
        mime: function(e) {
            if (re(e))
                return !1;
            var t = l(e.split("/"), 1)[0]
              , n = e;
            if (!this.isHTML5 || t !== this.type)
                return !1;
            Object.keys(Ee).includes(n) && (n += '; codecs="'.concat(Ee[e], '"'));
            try {
                return Boolean(n && this.media.canPlayType(n).replace(/no/, ""))
            } catch (e) {
                return !1
            }
        },
        textTracks: "textTracks"in document.createElement("video"),
        rangeInput: (Pe = document.createElement("input"),
        Pe.type = "range",
        "range" === Pe.type),
        touch: "ontouchstart"in document.documentElement,
        transitions: !1 !== oe,
        reducedMotion: "matchMedia"in window && window.matchMedia("(prefers-reduced-motion)").matches
    }, Me = function() {
        var e = !1;
        try {
            var t = Object.defineProperty({}, "passive", {
                get: function() {
                    return e = !0,
                    null
                }
            });
            window.addEventListener("test", null, t),
            window.removeEventListener("test", null, t)
        } catch (e) {}
        return e
    }();
    function xe(e, t, n) {
        var i = this
          , a = arguments.length > 3 && void 0 !== arguments[3] && arguments[3]
          , r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4]
          , o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
        if (e && "addEventListener"in e && !re(t) && $(n)) {
            var s = t.split(" ")
              , l = o;
            Me && (l = {
                passive: r,
                capture: o
            }),
            s.forEach((function(t) {
                i && i.eventListeners && a && i.eventListeners.push({
                    element: e,
                    type: t,
                    callback: n,
                    options: l
                }),
                e[a ? "addEventListener" : "removeEventListener"](t, n, l)
            }
            ))
        }
    }
    function Ie(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
          , n = arguments.length > 2 ? arguments[2] : void 0
          , i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]
          , a = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        xe.call(this, e, t, n, !0, i, a)
    }
    function Le(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
          , n = arguments.length > 2 ? arguments[2] : void 0
          , i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]
          , a = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        xe.call(this, e, t, n, !1, i, a)
    }
    function Oe(e) {
        var t = this
          , n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
          , i = arguments.length > 2 ? arguments[2] : void 0
          , a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]
          , r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4]
          , o = function o() {
            Le(e, n, o, a, r);
            for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
                l[c] = arguments[c];
            i.apply(t, l)
        };
        xe.call(this, e, n, o, !0, a, r)
    }
    function _e(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
          , n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
          , i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        if (Z(e) && !re(t)) {
            var a = new CustomEvent(t,{
                bubbles: n,
                detail: o(o({}, i), {}, {
                    plyr: this
                })
            });
            e.dispatchEvent(a)
        }
    }
    function je() {
        this && this.eventListeners && (this.eventListeners.forEach((function(e) {
            var t = e.element
              , n = e.type
              , i = e.callback
              , a = e.options;
            t.removeEventListener(n, i, a)
        }
        )),
        this.eventListeners = [])
    }
    function De() {
        var e = this;
        return new Promise((function(t) {
            return e.ready ? setTimeout(t, 0) : Ie.call(e, e.elements.container, "ready", t)
        }
        )).then((function() {}
        ))
    }
    function qe(e) {
        ie(e) && e.then(null, (function() {}
        ))
    }
    function He(e) {
        return !!(J(e) || Q(e) && e.includes(":")) && (J(e) ? e : e.split(":")).map(Number).every(Y)
    }
    function Fe(e) {
        if (!J(e) || !e.every(Y))
            return null;
        var t = l(e, 2)
          , n = t[0]
          , i = t[1]
          , a = function e(t, n) {
            return 0 === n ? t : e(n, t % n)
        }(n, i);
        return [n / a, i / a]
    }
    function Re(e) {
        var t = function(e) {
            return He(e) ? e.split(":").map(Number) : null
        }
          , n = t(e);
        if (null === n && (n = t(this.config.ratio)),
        null === n && !re(this.embed) && J(this.embed.ratio) && (n = this.embed.ratio),
        null === n && this.isHTML5) {
            var i = this.media;
            n = Fe([i.videoWidth, i.videoHeight])
        }
        return n
    }
    function Ve(e) {
        if (!this.isVideo)
            return {};
        var t = this.elements.wrapper
          , n = Re.call(this, e)
          , i = l(J(n) ? n : [0, 0], 2)
          , a = 100 / i[0] * i[1];
        if (t.style.paddingBottom = "".concat(a, "%"),
        this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            var r = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10)
              , o = (r - a) / (r / 50);
            this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = "translateY(-".concat(o, "%)")
        } else
            this.isHTML5 && t.classList.toggle(this.config.classNames.videoFixedRatio, null !== n);
        return {
            padding: a,
            ratio: n
        }
    }
    var Be = {
        getSources: function() {
            var e = this;
            return this.isHTML5 ? Array.from(this.media.querySelectorAll("source")).filter((function(t) {
                var n = t.getAttribute("type");
                return !!re(n) || Ne.mime.call(e, n)
            }
            )) : []
        },
        getQualityOptions: function() {
            return this.config.quality.forced ? this.config.quality.options : Be.getSources.call(this).map((function(e) {
                return Number(e.getAttribute("size"))
            }
            )).filter(Boolean)
        },
        setup: function() {
            if (this.isHTML5) {
                var e = this;
                e.options.speed = e.config.speed.options,
                re(this.config.ratio) || Ve.call(e),
                Object.defineProperty(e.media, "quality", {
                    get: function() {
                        var t = Be.getSources.call(e).find((function(t) {
                            return t.getAttribute("src") === e.source
                        }
                        ));
                        return t && Number(t.getAttribute("size"))
                    },
                    set: function(t) {
                        if (e.quality !== t) {
                            if (e.config.quality.forced && $(e.config.quality.onChange))
                                e.config.quality.onChange(t);
                            else {
                                var n = Be.getSources.call(e).find((function(e) {
                                    return Number(e.getAttribute("size")) === t
                                }
                                ));
                                if (!n)
                                    return;
                                var i = e.media
                                  , a = i.currentTime
                                  , r = i.paused
                                  , o = i.preload
                                  , s = i.readyState
                                  , l = i.playbackRate;
                                e.media.src = n.getAttribute("src"),
                                ("none" !== o || s) && (e.once("loadedmetadata", (function() {
                                    e.speed = l,
                                    e.currentTime = a,
                                    r || qe(e.play())
                                }
                                )),
                                e.media.load())
                            }
                            _e.call(e, e.media, "qualitychange", !1, {
                                quality: t
                            })
                        }
                    }
                })
            }
        },
        cancelRequests: function() {
            this.isHTML5 && (fe(Be.getSources.call(this)),
            this.media.setAttribute("src", this.config.blankVideo),
            this.media.load(),
            this.debug.log("Cancelled network requests"))
        }
    };
    function Ue(e) {
        return J(e) ? e.filter((function(t, n) {
            return e.indexOf(t) === n
        }
        )) : e
    }
    function We(e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
            n[i - 1] = arguments[i];
        return re(e) ? e : e.toString().replace(/{(\d+)}/g, (function(e, t) {
            return n[t].toString()
        }
        ))
    }
    var ze = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
          , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
          , n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
        return e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"),"g"), n.toString())
    }
      , Ke = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return e.toString().replace(/\w\S*/g, (function(e) {
            return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase()
        }
        ))
    };
    function Ye() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
          , t = e.toString();
        return t = ze(t, "-", " "),
        t = ze(t, "_", " "),
        t = Ke(t),
        ze(t, " ", "")
    }
    function Qe(e) {
        var t = document.createElement("div");
        return t.appendChild(e),
        t.innerHTML
    }
    var Xe = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    }
      , $e = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
          , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (re(e) || re(t))
            return "";
        var n = ce(t.i18n, e);
        if (re(n))
            return Object.keys(Xe).includes(e) ? Xe[e] : "";
        var i = {
            "{seektime}": t.seekTime,
            "{title}": t.title
        };
        return Object.entries(i).forEach((function(e) {
            var t = l(e, 2)
              , i = t[0]
              , a = t[1];
            n = ze(n, i, a)
        }
        )),
        n
    }
      , Je = function() {
        function e(n) {
            var i = this;
            t(this, e),
            a(this, "get", (function(t) {
                if (!e.supported || !i.enabled)
                    return null;
                var n = window.localStorage.getItem(i.key);
                if (re(n))
                    return null;
                var a = JSON.parse(n);
                return Q(t) && t.length ? a[t] : a
            }
            )),
            a(this, "set", (function(t) {
                if (e.supported && i.enabled && K(t)) {
                    var n = i.get();
                    re(n) && (n = {}),
                    ue(n, t),
                    window.localStorage.setItem(i.key, JSON.stringify(n))
                }
            }
            )),
            this.enabled = n.config.storage.enabled,
            this.key = n.config.storage.key
        }
        return i(e, null, [{
            key: "supported",
            get: function() {
                try {
                    if (!("localStorage"in window))
                        return !1;
                    var e = "___test";
                    return window.localStorage.setItem(e, e),
                    window.localStorage.removeItem(e),
                    !0
                } catch (e) {
                    return !1
                }
            }
        }]),
        e
    }();
    function Ge(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "text";
        return new Promise((function(n, i) {
            try {
                var a = new XMLHttpRequest;
                if (!("withCredentials"in a))
                    return;
                a.addEventListener("load", (function() {
                    if ("text" === t)
                        try {
                            n(JSON.parse(a.responseText))
                        } catch (e) {
                            n(a.responseText)
                        }
                    else
                        n(a.response)
                }
                )),
                a.addEventListener("error", (function() {
                    throw new Error(a.status)
                }
                )),
                a.open("GET", e, !0),
                a.responseType = t,
                a.send()
            } catch (e) {
                i(e)
            }
        }
        ))
    }
    function Ze(e, t) {
        if (Q(e)) {
            var n = "cache"
              , i = Q(t)
              , a = function() {
                return null !== document.getElementById(t)
            }
              , r = function(e, t) {
                e.innerHTML = t,
                i && a() || document.body.insertAdjacentElement("afterbegin", e)
            };
            if (!i || !a()) {
                var o = Je.supported
                  , s = document.createElement("div");
                if (s.setAttribute("hidden", ""),
                i && s.setAttribute("id", t),
                o) {
                    var l = window.localStorage.getItem("".concat(n, "-").concat(t));
                    if (null !== l) {
                        var c = JSON.parse(l);
                        r(s, c.content)
                    }
                }
                Ge(e).then((function(e) {
                    re(e) || (o && window.localStorage.setItem("".concat(n, "-").concat(t), JSON.stringify({
                        content: e
                    })),
                    r(s, e))
                }
                )).catch((function() {}
                ))
            }
        }
    }
    var et = function(e) {
        return Math.trunc(e / 60 / 60 % 60, 10)
    }
      , tt = function(e) {
        return Math.trunc(e / 60 % 60, 10)
    }
      , nt = function(e) {
        return Math.trunc(e % 60, 10)
    };
    function it() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0
          , t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
          , n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!Y(e))
            return it(void 0, t, n);
        var i = function(e) {
            return "0".concat(e).slice(-2)
        }
          , a = et(e)
          , r = tt(e)
          , o = nt(e);
        return a = t || a > 0 ? "".concat(a, ":") : "",
        "".concat(n && e > 0 ? "-" : "").concat(a).concat(i(r), ":").concat(i(o))
    }
    var at = {
        getIconUrl: function() {
            var e = new URL(this.config.iconUrl,window.location).host !== window.location.host || le.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: e
            }
        },
        findElements: function() {
            try {
                return this.elements.controls = Ae.call(this, this.config.selectors.controls.wrapper),
                this.elements.buttons = {
                    play: Ce.call(this, this.config.selectors.buttons.play),
                    pause: Ae.call(this, this.config.selectors.buttons.pause),
                    restart: Ae.call(this, this.config.selectors.buttons.restart),
                    rewind: Ae.call(this, this.config.selectors.buttons.rewind),
                    fastForward: Ae.call(this, this.config.selectors.buttons.fastForward),
                    mute: Ae.call(this, this.config.selectors.buttons.mute),
                    pip: Ae.call(this, this.config.selectors.buttons.pip),
                    airplay: Ae.call(this, this.config.selectors.buttons.airplay),
                    settings: Ae.call(this, this.config.selectors.buttons.settings),
                    captions: Ae.call(this, this.config.selectors.buttons.captions),
                    fullscreen: Ae.call(this, this.config.selectors.buttons.fullscreen)
                },
                this.elements.progress = Ae.call(this, this.config.selectors.progress),
                this.elements.inputs = {
                    seek: Ae.call(this, this.config.selectors.inputs.seek),
                    volume: Ae.call(this, this.config.selectors.inputs.volume)
                },
                this.elements.display = {
                    buffer: Ae.call(this, this.config.selectors.display.buffer),
                    currentTime: Ae.call(this, this.config.selectors.display.currentTime),
                    duration: Ae.call(this, this.config.selectors.display.duration)
                },
                Z(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(".".concat(this.config.classNames.tooltip))),
                !0
            } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e),
                this.toggleNativeControls(!0),
                !1
            }
        },
        createIcon: function(e, t) {
            var n = "http://www.w3.org/2000/svg"
              , i = at.getIconUrl.call(this)
              , a = "".concat(i.cors ? "" : i.url, "#").concat(this.config.iconPrefix)
              , r = document.createElementNS(n, "svg");
            he(r, ue(t, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            var o = document.createElementNS(n, "use")
              , s = "".concat(a, "-").concat(e);
            return "href"in o && o.setAttributeNS("http://www.w3.org/1999/xlink", "href", s),
            o.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", s),
            r.appendChild(o),
            r
        },
        createLabel: function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
              , n = $e(e, this.config)
              , i = o(o({}, t), {}, {
                class: [t.class, this.config.classNames.hidden].filter(Boolean).join(" ")
            });
            return me("span", i, n)
        },
        createBadge: function(e) {
            if (re(e))
                return null;
            var t = me("span", {
                class: this.config.classNames.menu.value
            });
            return t.appendChild(me("span", {
                class: this.config.classNames.menu.badge
            }, e)),
            t
        },
        createButton: function(e, t) {
            var n = this
              , i = ue({}, t)
              , a = function() {
                var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toString();
                return (e = Ye(e)).charAt(0).toLowerCase() + e.slice(1)
            }(e)
              , r = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            switch (["element", "icon", "label"].forEach((function(e) {
                Object.keys(i).includes(e) && (r[e] = i[e],
                delete i[e])
            }
            )),
            "button" !== r.element || Object.keys(i).includes("type") || (i.type = "button"),
            Object.keys(i).includes("class") ? i.class.split(" ").some((function(e) {
                return e === n.config.classNames.control
            }
            )) || ue(i, {
                class: "".concat(i.class, " ").concat(this.config.classNames.control)
            }) : i.class = this.config.classNames.control,
            e) {
            case "play":
                r.toggle = !0,
                r.label = "play",
                r.labelPressed = "pause",
                r.icon = "play",
                r.iconPressed = "pause";
                break;
            case "mute":
                r.toggle = !0,
                r.label = "mute",
                r.labelPressed = "unmute",
                r.icon = "volume",
                r.iconPressed = "muted";
                break;
            case "captions":
                r.toggle = !0,
                r.label = "enableCaptions",
                r.labelPressed = "disableCaptions",
                r.icon = "captions-off",
                r.iconPressed = "captions-on";
                break;
            case "fullscreen":
                r.toggle = !0,
                r.label = "enterFullscreen",
                r.labelPressed = "exitFullscreen",
                r.icon = "enter-fullscreen",
                r.iconPressed = "exit-fullscreen";
                break;
            case "play-large":
                i.class += " ".concat(this.config.classNames.control, "--overlaid"),
                a = "play",
                r.label = "play",
                r.icon = "play";
                break;
            default:
                re(r.label) && (r.label = a),
                re(r.icon) && (r.icon = e)
            }
            var o = me(r.element);
            return r.toggle ? (o.appendChild(at.createIcon.call(this, r.iconPressed, {
                class: "icon--pressed"
            })),
            o.appendChild(at.createIcon.call(this, r.icon, {
                class: "icon--not-pressed"
            })),
            o.appendChild(at.createLabel.call(this, r.labelPressed, {
                class: "label--pressed"
            })),
            o.appendChild(at.createLabel.call(this, r.label, {
                class: "label--not-pressed"
            }))) : (o.appendChild(at.createIcon.call(this, r.icon)),
            o.appendChild(at.createLabel.call(this, r.label))),
            ue(i, be(this.config.selectors.buttons[a], i)),
            he(o, i),
            "play" === a ? (J(this.elements.buttons[a]) || (this.elements.buttons[a] = []),
            this.elements.buttons[a].push(o)) : this.elements.buttons[a] = o,
            o
        },
        createRange: function(e, t) {
            var n = me("input", ue(be(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": $e(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, t));
            return this.elements.inputs[e] = n,
            at.updateRangeFill.call(this, n),
            j.setup(n),
            n
        },
        createProgress: function(e, t) {
            var n = me("progress", ue(be(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
            }, t));
            if ("volume" !== e) {
                n.appendChild(me("span", null, "0"));
                var i = {
                    played: "played",
                    buffer: "buffered"
                }[e]
                  , a = i ? $e(i, this.config) : "";
                n.innerText = "% ".concat(a.toLowerCase())
            }
            return this.elements.display[e] = n,
            n
        },
        createTime: function(e, t) {
            var n = be(this.config.selectors.display[e], t)
              , i = me("div", ue(n, {
                class: "".concat(n.class ? n.class : "", " ").concat(this.config.classNames.display.time, " ").trim(),
                "aria-label": $e(e, this.config)
            }), "00:00");
            return this.elements.display[e] = i,
            i
        },
        bindMenuItemShortcuts: function(e, t) {
            var n = this;
            Ie.call(this, e, "keydown keyup", (function(i) {
                if ([32, 38, 39, 40].includes(i.which) && (i.preventDefault(),
                i.stopPropagation(),
                "keydown" !== i.type)) {
                    var a, r = Te(e, '[role="menuitemradio"]');
                    if (!r && [32, 39].includes(i.which))
                        at.showMenuPanel.call(n, t, !0);
                    else
                        32 !== i.which && (40 === i.which || r && 39 === i.which ? (a = e.nextElementSibling,
                        Z(a) || (a = e.parentNode.firstElementChild)) : (a = e.previousElementSibling,
                        Z(a) || (a = e.parentNode.lastElementChild)),
                        Se.call(n, a, !0))
                }
            }
            ), !1),
            Ie.call(this, e, "keyup", (function(e) {
                13 === e.which && at.focusFirstMenuItem.call(n, null, !0)
            }
            ))
        },
        createMenuItem: function(e) {
            var t = this
              , n = e.value
              , i = e.list
              , a = e.type
              , r = e.title
              , o = e.badge
              , s = void 0 === o ? null : o
              , l = e.checked
              , c = void 0 !== l && l
              , u = be(this.config.selectors.inputs[a])
              , d = me("button", ue(u, {
                type: "button",
                role: "menuitemradio",
                class: "".concat(this.config.classNames.control, " ").concat(u.class ? u.class : "").trim(),
                "aria-checked": c,
                value: n
            }))
              , h = me("span");
            h.innerHTML = r,
            Z(s) && h.appendChild(s),
            d.appendChild(h),
            Object.defineProperty(d, "checked", {
                enumerable: !0,
                get: function() {
                    return "true" === d.getAttribute("aria-checked")
                },
                set: function(e) {
                    e && Array.from(d.parentNode.children).filter((function(e) {
                        return Te(e, '[role="menuitemradio"]')
                    }
                    )).forEach((function(e) {
                        return e.setAttribute("aria-checked", "false")
                    }
                    )),
                    d.setAttribute("aria-checked", e ? "true" : "false")
                }
            }),
            this.listeners.bind(d, "click keyup", (function(e) {
                if (!te(e) || 32 === e.which) {
                    switch (e.preventDefault(),
                    e.stopPropagation(),
                    d.checked = !0,
                    a) {
                    case "language":
                        t.currentTrack = Number(n);
                        break;
                    case "quality":
                        t.quality = n;
                        break;
                    case "speed":
                        t.speed = parseFloat(n)
                    }
                    at.showMenuPanel.call(t, "home", te(e))
                }
            }
            ), a, !1),
            at.bindMenuItemShortcuts.call(this, d, a),
            i.appendChild(d)
        },
        formatTime: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0
              , t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            if (!Y(e))
                return e;
            var n = et(this.duration) > 0;
            return it(e, n, t)
        },
        updateTimeDisplay: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null
              , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0
              , n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            Z(e) && Y(t) && (e.innerText = at.formatTime(t, n))
        },
        updateVolume: function() {
            this.supported.ui && (Z(this.elements.inputs.volume) && at.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume),
            Z(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume))
        },
        setRange: function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            Z(e) && (e.value = t,
            at.updateRangeFill.call(this, e))
        },
        updateProgress: function(e) {
            var t = this;
            if (this.supported.ui && ee(e)) {
                var n, i, a = 0;
                if (e)
                    switch (e.type) {
                    case "timeupdate":
                    case "seeking":
                    case "seeked":
                        n = this.currentTime,
                        i = this.duration,
                        a = 0 === n || 0 === i || Number.isNaN(n) || Number.isNaN(i) ? 0 : (n / i * 100).toFixed(2),
                        "timeupdate" === e.type && at.setRange.call(this, this.elements.inputs.seek, a);
                        break;
                    case "playing":
                    case "progress":
                        !function(e, n) {
                            var i = Y(n) ? n : 0
                              , a = Z(e) ? e : t.elements.display.buffer;
                            if (Z(a)) {
                                a.value = i;
                                var r = a.getElementsByTagName("span")[0];
                                Z(r) && (r.childNodes[0].nodeValue = i)
                            }
                        }(this.elements.display.buffer, 100 * this.buffered)
                    }
            }
        },
        updateRangeFill: function(e) {
            var t = ee(e) ? e.target : e;
            if (Z(t) && "range" === t.getAttribute("type")) {
                if (Te(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    var n = at.formatTime(this.currentTime)
                      , i = at.formatTime(this.duration)
                      , a = $e("seekLabel", this.config);
                    t.setAttribute("aria-valuetext", a.replace("{currentTime}", n).replace("{duration}", i))
                } else if (Te(t, this.config.selectors.inputs.volume)) {
                    var r = 100 * t.value;
                    t.setAttribute("aria-valuenow", r),
                    t.setAttribute("aria-valuetext", "".concat(r.toFixed(1), "%"))
                } else
                    t.setAttribute("aria-valuenow", t.value);
                le.isWebkit && t.style.setProperty("--value", "".concat(t.value / t.max * 100, "%"))
            }
        },
        updateSeekTooltip: function(e) {
            var t = this;
            if (this.config.tooltips.seek && Z(this.elements.inputs.seek) && Z(this.elements.display.seekTooltip) && 0 !== this.duration) {
                var n = "".concat(this.config.classNames.tooltip, "--visible")
                  , i = function(e) {
                    return we(t.elements.display.seekTooltip, n, e)
                };
                if (this.touch)
                    i(!1);
                else {
                    var a = 0
                      , r = this.elements.progress.getBoundingClientRect();
                    if (ee(e))
                        a = 100 / r.width * (e.pageX - r.left);
                    else {
                        if (!ke(this.elements.display.seekTooltip, n))
                            return;
                        a = parseFloat(this.elements.display.seekTooltip.style.left, 10)
                    }
                    a < 0 ? a = 0 : a > 100 && (a = 100),
                    at.updateTimeDisplay.call(this, this.elements.display.seekTooltip, this.duration / 100 * a),
                    this.elements.display.seekTooltip.style.left = "".concat(a, "%"),
                    ee(e) && ["mouseenter", "mouseleave"].includes(e.type) && i("mouseenter" === e.type)
                }
            }
        },
        timeUpdate: function(e) {
            var t = !Z(this.elements.display.duration) && this.config.invertTime;
            at.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t),
            e && "timeupdate" === e.type && this.media.seeking || at.updateProgress.call(this, e)
        },
        durationUpdate: function() {
            if (this.supported.ui && (this.config.invertTime || !this.currentTime)) {
                if (this.duration >= Math.pow(2, 32))
                    return ve(this.elements.display.currentTime, !0),
                    void ve(this.elements.progress, !0);
                Z(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
                var e = Z(this.elements.display.duration);
                !e && this.config.displayDuration && this.paused && at.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration),
                e && at.updateTimeDisplay.call(this, this.elements.display.duration, this.duration),
                at.updateSeekTooltip.call(this)
            }
        },
        toggleMenuButton: function(e, t) {
            ve(this.elements.settings.buttons[e], !t)
        },
        updateSetting: function(e, t, n) {
            var i = this.elements.settings.panels[e]
              , a = null
              , r = t;
            if ("captions" === e)
                a = this.currentTrack;
            else {
                if (a = re(n) ? this[e] : n,
                re(a) && (a = this.config[e].default),
                !re(this.options[e]) && !this.options[e].includes(a))
                    return void this.debug.warn("Unsupported value of '".concat(a, "' for ").concat(e));
                if (!this.config[e].options.includes(a))
                    return void this.debug.warn("Disabled value of '".concat(a, "' for ").concat(e))
            }
            if (Z(r) || (r = i && i.querySelector('[role="menu"]')),
            Z(r)) {
                this.elements.settings.buttons[e].querySelector(".".concat(this.config.classNames.menu.value)).innerHTML = at.getLabel.call(this, e, a);
                var o = r && r.querySelector('[value="'.concat(a, '"]'));
                Z(o) && (o.checked = !0)
            }
        },
        getLabel: function(e, t) {
            switch (e) {
            case "speed":
                return 1 === t ? $e("normal", this.config) : "".concat(t, "&times;");
            case "quality":
                if (Y(t)) {
                    var n = $e("qualityLabel.".concat(t), this.config);
                    return n.length ? n : "".concat(t, "p")
                }
                return Ke(t);
            case "captions":
                return st.getLabel.call(this);
            default:
                return null
            }
        },
        setQualityMenu: function(e) {
            var t = this;
            if (Z(this.elements.settings.panels.quality)) {
                var n = "quality"
                  , i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
                J(e) && (this.options.quality = Ue(e).filter((function(e) {
                    return t.config.quality.options.includes(e)
                }
                )));
                var a = !re(this.options.quality) && this.options.quality.length > 1;
                if (at.toggleMenuButton.call(this, n, a),
                ge(i),
                at.checkMenu.call(this),
                a) {
                    var r = function(e) {
                        var n = $e("qualityBadge.".concat(e), t.config);
                        return n.length ? at.createBadge.call(t, n) : null
                    };
                    this.options.quality.sort((function(e, n) {
                        var i = t.config.quality.options;
                        return i.indexOf(e) > i.indexOf(n) ? 1 : -1
                    }
                    )).forEach((function(e) {
                        at.createMenuItem.call(t, {
                            value: e,
                            list: i,
                            type: n,
                            title: at.getLabel.call(t, "quality", e),
                            badge: r(e)
                        })
                    }
                    )),
                    at.updateSetting.call(this, n, i)
                }
            }
        },
        setCaptionsMenu: function() {
            var e = this;
            if (Z(this.elements.settings.panels.captions)) {
                var t = "captions"
                  , n = this.elements.settings.panels.captions.querySelector('[role="menu"]')
                  , i = st.getTracks.call(this)
                  , a = Boolean(i.length);
                if (at.toggleMenuButton.call(this, t, a),
                ge(n),
                at.checkMenu.call(this),
                a) {
                    var r = i.map((function(t, i) {
                        return {
                            value: i,
                            checked: e.captions.toggled && e.currentTrack === i,
                            title: st.getLabel.call(e, t),
                            badge: t.language && at.createBadge.call(e, t.language.toUpperCase()),
                            list: n,
                            type: "language"
                        }
                    }
                    ));
                    r.unshift({
                        value: -1,
                        checked: !this.captions.toggled,
                        title: $e("disabled", this.config),
                        list: n,
                        type: "language"
                    }),
                    r.forEach(at.createMenuItem.bind(this)),
                    at.updateSetting.call(this, t, n)
                }
            }
        },
        setSpeedMenu: function() {
            var e = this;
            if (Z(this.elements.settings.panels.speed)) {
                var t = "speed"
                  , n = this.elements.settings.panels.speed.querySelector('[role="menu"]');
                this.options.speed = this.options.speed.filter((function(t) {
                    return t >= e.minimumSpeed && t <= e.maximumSpeed
                }
                ));
                var i = !re(this.options.speed) && this.options.speed.length > 1;
                at.toggleMenuButton.call(this, t, i),
                ge(n),
                at.checkMenu.call(this),
                i && (this.options.speed.forEach((function(i) {
                    at.createMenuItem.call(e, {
                        value: i,
                        list: n,
                        type: t,
                        title: at.getLabel.call(e, "speed", i)
                    })
                }
                )),
                at.updateSetting.call(this, t, n))
            }
        },
        checkMenu: function() {
            var e = this.elements.settings.buttons
              , t = !re(e) && Object.values(e).some((function(e) {
                return !e.hidden
            }
            ));
            ve(this.elements.settings.menu, !t)
        },
        focusFirstMenuItem: function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            if (!this.elements.settings.popup.hidden) {
                var n = e;
                Z(n) || (n = Object.values(this.elements.settings.panels).find((function(e) {
                    return !e.hidden
                }
                )));
                var i = n.querySelector('[role^="menuitem"]');
                Se.call(this, i, t)
            }
        },
        toggleMenu: function(e) {
            var t = this.elements.settings.popup
              , n = this.elements.buttons.settings;
            if (Z(t) && Z(n)) {
                var i = t.hidden
                  , a = i;
                if (X(e))
                    a = e;
                else if (te(e) && 27 === e.which)
                    a = !1;
                else if (ee(e)) {
                    var r = $(e.composedPath) ? e.composedPath()[0] : e.target
                      , o = t.contains(r);
                    if (o || !o && e.target !== n && a)
                        return
                }
                n.setAttribute("aria-expanded", a),
                ve(t, !a),
                we(this.elements.container, this.config.classNames.menu.open, a),
                a && te(e) ? at.focusFirstMenuItem.call(this, null, !0) : a || i || Se.call(this, n, te(e))
            }
        },
        getMenuSize: function(e) {
            var t = e.cloneNode(!0);
            t.style.position = "absolute",
            t.style.opacity = 0,
            t.removeAttribute("hidden"),
            e.parentNode.appendChild(t);
            var n = t.scrollWidth
              , i = t.scrollHeight;
            return fe(t),
            {
                width: n,
                height: i
            }
        },
        showMenuPanel: function() {
            var e = this
              , t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
              , n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
              , i = this.elements.container.querySelector("#plyr-settings-".concat(this.id, "-").concat(t));
            if (Z(i)) {
                var a = i.parentNode
                  , r = Array.from(a.children).find((function(e) {
                    return !e.hidden
                }
                ));
                if (Ne.transitions && !Ne.reducedMotion) {
                    a.style.width = "".concat(r.scrollWidth, "px"),
                    a.style.height = "".concat(r.scrollHeight, "px");
                    var o = at.getMenuSize.call(this, i)
                      , s = function t(n) {
                        n.target === a && ["width", "height"].includes(n.propertyName) && (a.style.width = "",
                        a.style.height = "",
                        Le.call(e, a, oe, t))
                    };
                    Ie.call(this, a, oe, s),
                    a.style.width = "".concat(o.width, "px"),
                    a.style.height = "".concat(o.height, "px")
                }
                ve(r, !0),
                ve(i, !1),
                at.focusFirstMenuItem.call(this, i, n)
            }
        },
        setDownloadUrl: function() {
            var e = this.elements.buttons.download;
            Z(e) && e.setAttribute("href", this.download)
        },
        create: function(e) {
            var t = this
              , n = at.bindMenuItemShortcuts
              , i = at.createButton
              , a = at.createProgress
              , r = at.createRange
              , o = at.createTime
              , s = at.setQualityMenu
              , l = at.setSpeedMenu
              , c = at.showMenuPanel;
            this.elements.controls = null,
            J(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
            var u = me("div", be(this.config.selectors.controls.wrapper));
            this.elements.controls = u;
            var d = {
                class: "plyr__controls__item"
            };
            return Ue(J(this.config.controls) ? this.config.controls : []).forEach((function(s) {
                if ("restart" === s && u.appendChild(i.call(t, "restart", d)),
                "rewind" === s && u.appendChild(i.call(t, "rewind", d)),
                "play" === s && u.appendChild(i.call(t, "play", d)),
                "fast-forward" === s && u.appendChild(i.call(t, "fast-forward", d)),
                "progress" === s) {
                    var l = me("div", {
                        class: "".concat(d.class, " plyr__progress__container")
                    })
                      , h = me("div", be(t.config.selectors.progress));
                    if (h.appendChild(r.call(t, "seek", {
                        id: "plyr-seek-".concat(e.id)
                    })),
                    h.appendChild(a.call(t, "buffer")),
                    t.config.tooltips.seek) {
                        var m = me("span", {
                            class: t.config.classNames.tooltip
                        }, "00:00");
                        h.appendChild(m),
                        t.elements.display.seekTooltip = m
                    }
                    t.elements.progress = h,
                    l.appendChild(t.elements.progress),
                    u.appendChild(l)
                }
                if ("current-time" === s && u.appendChild(o.call(t, "currentTime", d)),
                "duration" === s && u.appendChild(o.call(t, "duration", d)),
                "mute" === s || "volume" === s) {
                    var p = t.elements.volume;
                    if (Z(p) && u.contains(p) || (p = me("div", ue({}, d, {
                        class: "".concat(d.class, " plyr__volume").trim()
                    })),
                    t.elements.volume = p,
                    u.appendChild(p)),
                    "mute" === s && p.appendChild(i.call(t, "mute")),
                    "volume" === s && !le.isIos) {
                        var f = {
                            max: 1,
                            step: .05,
                            value: t.config.volume
                        };
                        p.appendChild(r.call(t, "volume", ue(f, {
                            id: "plyr-volume-".concat(e.id)
                        })))
                    }
                }
                if ("captions" === s && u.appendChild(i.call(t, "captions", d)),
                "settings" === s && !re(t.config.settings)) {
                    var g = me("div", ue({}, d, {
                        class: "".concat(d.class, " plyr__menu").trim(),
                        hidden: ""
                    }));
                    g.appendChild(i.call(t, "settings", {
                        "aria-haspopup": !0,
                        "aria-controls": "plyr-settings-".concat(e.id),
                        "aria-expanded": !1
                    }));
                    var y = me("div", {
                        class: "plyr__menu__container",
                        id: "plyr-settings-".concat(e.id),
                        hidden: ""
                    })
                      , b = me("div")
                      , v = me("div", {
                        id: "plyr-settings-".concat(e.id, "-home")
                    })
                      , w = me("div", {
                        role: "menu"
                    });
                    v.appendChild(w),
                    b.appendChild(v),
                    t.elements.settings.panels.home = v,
                    t.config.settings.forEach((function(i) {
                        var a = me("button", ue(be(t.config.selectors.buttons.settings), {
                            type: "button",
                            class: "".concat(t.config.classNames.control, " ").concat(t.config.classNames.control, "--forward"),
                            role: "menuitem",
                            "aria-haspopup": !0,
                            hidden: ""
                        }));
                        n.call(t, a, i),
                        Ie.call(t, a, "click", (function() {
                            c.call(t, i, !1)
                        }
                        ));
                        var r = me("span", null, $e(i, t.config))
                          , o = me("span", {
                            class: t.config.classNames.menu.value
                        });
                        o.innerHTML = e[i],
                        r.appendChild(o),
                        a.appendChild(r),
                        w.appendChild(a);
                        var s = me("div", {
                            id: "plyr-settings-".concat(e.id, "-").concat(i),
                            hidden: ""
                        })
                          , l = me("button", {
                            type: "button",
                            class: "".concat(t.config.classNames.control, " ").concat(t.config.classNames.control, "--back")
                        });
                        l.appendChild(me("span", {
                            "aria-hidden": !0
                        }, $e(i, t.config))),
                        l.appendChild(me("span", {
                            class: t.config.classNames.hidden
                        }, $e("menuBack", t.config))),
                        Ie.call(t, s, "keydown", (function(e) {
                            37 === e.which && (e.preventDefault(),
                            e.stopPropagation(),
                            c.call(t, "home", !0))
                        }
                        ), !1),
                        Ie.call(t, l, "click", (function() {
                            c.call(t, "home", !1)
                        }
                        )),
                        s.appendChild(l),
                        s.appendChild(me("div", {
                            role: "menu"
                        })),
                        b.appendChild(s),
                        t.elements.settings.buttons[i] = a,
                        t.elements.settings.panels[i] = s
                    }
                    )),
                    y.appendChild(b),
                    g.appendChild(y),
                    u.appendChild(g),
                    t.elements.settings.popup = y,
                    t.elements.settings.menu = g
                }
                if ("pip" === s && Ne.pip && u.appendChild(i.call(t, "pip", d)),
                "airplay" === s && Ne.airplay && u.appendChild(i.call(t, "airplay", d)),
                "download" === s) {
                    var k = ue({}, d, {
                        element: "a",
                        href: t.download,
                        target: "_blank"
                    });
                    t.isHTML5 && (k.download = "");
                    var T = t.config.urls.download;
                    !ae(T) && t.isEmbed && ue(k, {
                        icon: "logo-".concat(t.provider),
                        label: t.provider
                    }),
                    u.appendChild(i.call(t, "download", k))
                }
                "fullscreen" === s && u.appendChild(i.call(t, "fullscreen", d))
            }
            )),
            this.isHTML5 && s.call(this, Be.getQualityOptions.call(this)),
            l.call(this),
            u
        },
        inject: function() {
            var e = this;
            if (this.config.loadSprite) {
                var t = at.getIconUrl.call(this);
                t.cors && Ze(t.url, "sprite-plyr")
            }
            this.id = Math.floor(1e4 * Math.random());
            var n = null;
            this.elements.controls = null;
            var i = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            }
              , a = !0;
            $(this.config.controls) && (this.config.controls = this.config.controls.call(this, i)),
            this.config.controls || (this.config.controls = []),
            Z(this.config.controls) || Q(this.config.controls) ? n = this.config.controls : (n = at.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: st.getLabel.call(this)
            }),
            a = !1);
            var r, o;
            if (a && Q(this.config.controls) && (r = n,
            Object.entries(i).forEach((function(e) {
                var t = l(e, 2)
                  , n = t[0]
                  , i = t[1];
                r = ze(r, "{".concat(n, "}"), i)
            }
            )),
            n = r),
            Q(this.config.selectors.controls.container) && (o = document.querySelector(this.config.selectors.controls.container)),
            Z(o) || (o = this.elements.container),
            o[Z(n) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", n),
            Z(this.elements.controls) || at.findElements.call(this),
            !re(this.elements.buttons)) {
                var s = function(t) {
                    var n = e.config.classNames.controlPressed;
                    Object.defineProperty(t, "pressed", {
                        enumerable: !0,
                        get: function() {
                            return ke(t, n)
                        },
                        set: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                            we(t, n, e)
                        }
                    })
                };
                Object.values(this.elements.buttons).filter(Boolean).forEach((function(e) {
                    J(e) || G(e) ? Array.from(e).filter(Boolean).forEach(s) : s(e)
                }
                ))
            }
            if (le.isEdge && se(o),
            this.config.tooltips.controls) {
                var c = this.config
                  , u = c.classNames
                  , d = c.selectors
                  , h = "".concat(d.controls.wrapper, " ").concat(d.labels, " .").concat(u.hidden)
                  , m = Ce.call(this, h);
                Array.from(m).forEach((function(t) {
                    we(t, e.config.classNames.hidden, !1),
                    we(t, e.config.classNames.tooltip, !0)
                }
                ))
            }
        }
    };
    function rt(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]
          , n = e;
        if (t) {
            var i = document.createElement("a");
            i.href = n,
            n = i.href
        }
        try {
            return new URL(n)
        } catch (e) {
            return null
        }
    }
    function ot(e) {
        var t = new URLSearchParams;
        return K(e) && Object.entries(e).forEach((function(e) {
            var n = l(e, 2)
              , i = n[0]
              , a = n[1];
            t.set(i, a)
        }
        )),
        t
    }
    var st = {
        setup: function() {
            if (this.supported.ui)
                if (!this.isVideo || this.isYouTube || this.isHTML5 && !Ne.textTracks)
                    J(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && at.setCaptionsMenu.call(this);
                else {
                    if (Z(this.elements.captions) || (this.elements.captions = me("div", be(this.config.selectors.captions)),
                    function(e, t) {
                        Z(e) && Z(t) && t.parentNode.insertBefore(e, t.nextSibling)
                    }(this.elements.captions, this.elements.wrapper)),
                    le.isIE && window.URL) {
                        var e = this.media.querySelectorAll("track");
                        Array.from(e).forEach((function(e) {
                            var t = e.getAttribute("src")
                              , n = rt(t);
                            null !== n && n.hostname !== window.location.href.hostname && ["http:", "https:"].includes(n.protocol) && Ge(t, "blob").then((function(t) {
                                e.setAttribute("src", window.URL.createObjectURL(t))
                            }
                            )).catch((function() {
                                fe(e)
                            }
                            ))
                        }
                        ))
                    }
                    var t = Ue((navigator.languages || [navigator.language || navigator.userLanguage || "en"]).map((function(e) {
                        return e.split("-")[0]
                    }
                    )))
                      , n = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
                    if ("auto" === n)
                        n = l(t, 1)[0];
                    var i = this.storage.get("captions");
                    if (X(i) || (i = this.config.captions.active),
                    Object.assign(this.captions, {
                        toggled: !1,
                        active: i,
                        language: n,
                        languages: t
                    }),
                    this.isHTML5) {
                        var a = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                        Ie.call(this, this.media.textTracks, a, st.update.bind(this))
                    }
                    setTimeout(st.update.bind(this), 0)
                }
        },
        update: function() {
            var e = this
              , t = st.getTracks.call(this, !0)
              , n = this.captions
              , i = n.active
              , a = n.language
              , r = n.meta
              , o = n.currentTrackNode
              , s = Boolean(t.find((function(e) {
                return e.language === a
            }
            )));
            this.isHTML5 && this.isVideo && t.filter((function(e) {
                return !r.get(e)
            }
            )).forEach((function(t) {
                e.debug.log("Track added", t),
                r.set(t, {
                    default: "showing" === t.mode
                }),
                "showing" === t.mode && (t.mode = "hidden"),
                Ie.call(e, t, "cuechange", (function() {
                    return st.updateCues.call(e)
                }
                ))
            }
            )),
            (s && this.language !== a || !t.includes(o)) && (st.setLanguage.call(this, a),
            st.toggle.call(this, i && s)),
            we(this.elements.container, this.config.classNames.captions.enabled, !re(t)),
            J(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && at.setCaptionsMenu.call(this)
        },
        toggle: function(e) {
            var t = this
              , n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            if (this.supported.ui) {
                var i = this.captions.toggled
                  , a = this.config.classNames.captions.active
                  , r = z(e) ? !i : e;
                if (r !== i) {
                    if (n || (this.captions.active = r,
                    this.storage.set({
                        captions: r
                    })),
                    !this.language && r && !n) {
                        var o = st.getTracks.call(this)
                          , s = st.findTrack.call(this, [this.captions.language].concat(c(this.captions.languages)), !0);
                        return this.captions.language = s.language,
                        void st.set.call(this, o.indexOf(s))
                    }
                    this.elements.buttons.captions && (this.elements.buttons.captions.pressed = r),
                    we(this.elements.container, a, r),
                    this.captions.toggled = r,
                    at.updateSetting.call(this, "captions"),
                    _e.call(this, this.media, r ? "captionsenabled" : "captionsdisabled")
                }
                setTimeout((function() {
                    r && t.captions.toggled && (t.captions.currentTrackNode.mode = "hidden")
                }
                ))
            }
        },
        set: function(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]
              , n = st.getTracks.call(this);
            if (-1 !== e)
                if (Y(e))
                    if (e in n) {
                        if (this.captions.currentTrack !== e) {
                            this.captions.currentTrack = e;
                            var i = n[e]
                              , a = i || {}
                              , r = a.language;
                            this.captions.currentTrackNode = i,
                            at.updateSetting.call(this, "captions"),
                            t || (this.captions.language = r,
                            this.storage.set({
                                language: r
                            })),
                            this.isVimeo && this.embed.enableTextTrack(r),
                            _e.call(this, this.media, "languagechange")
                        }
                        st.toggle.call(this, !0, t),
                        this.isHTML5 && this.isVideo && st.updateCues.call(this)
                    } else
                        this.debug.warn("Track not found", e);
                else
                    this.debug.warn("Invalid caption argument", e);
            else
                st.toggle.call(this, !1, t)
        },
        setLanguage: function(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            if (Q(e)) {
                var n = e.toLowerCase();
                this.captions.language = n;
                var i = st.getTracks.call(this)
                  , a = st.findTrack.call(this, [n]);
                st.set.call(this, i.indexOf(a), t)
            } else
                this.debug.warn("Invalid language argument", e)
        },
        getTracks: function() {
            var e = this
              , t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
              , n = Array.from((this.media || {}).textTracks || []);
            return n.filter((function(n) {
                return !e.isHTML5 || t || e.captions.meta.has(n)
            }
            )).filter((function(e) {
                return ["captions", "subtitles"].includes(e.kind)
            }
            ))
        },
        findTrack: function(e) {
            var t, n = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = st.getTracks.call(this), r = function(e) {
                return Number((n.captions.meta.get(e) || {}).default)
            }, o = Array.from(a).sort((function(e, t) {
                return r(t) - r(e)
            }
            ));
            return e.every((function(e) {
                return !(t = o.find((function(t) {
                    return t.language === e
                }
                )))
            }
            )),
            t || (i ? o[0] : void 0)
        },
        getCurrentTrack: function() {
            return st.getTracks.call(this)[this.currentTrack]
        },
        getLabel: function(e) {
            var t = e;
            return !ne(t) && Ne.textTracks && this.captions.toggled && (t = st.getCurrentTrack.call(this)),
            ne(t) ? re(t.label) ? re(t.language) ? $e("enabled", this.config) : e.language.toUpperCase() : t.label : $e("disabled", this.config)
        },
        updateCues: function(e) {
            if (this.supported.ui)
                if (Z(this.elements.captions))
                    if (z(e) || Array.isArray(e)) {
                        var t = e;
                        if (!t) {
                            var n = st.getCurrentTrack.call(this);
                            t = Array.from((n || {}).activeCues || []).map((function(e) {
                                return e.getCueAsHTML()
                            }
                            )).map(Qe)
                        }
                        var i = t.map((function(e) {
                            return e.trim()
                        }
                        )).join("\n");
                        if (i !== this.elements.captions.innerHTML) {
                            ge(this.elements.captions);
                            var a = me("span", be(this.config.selectors.caption));
                            a.innerHTML = i,
                            this.elements.captions.appendChild(a),
                            _e.call(this, this.media, "cuechange")
                        }
                    } else
                        this.debug.warn("updateCues: Invalid input", e);
                else
                    this.debug.warn("No captions element to render to")
        }
    }
      , lt = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.6.4/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
            default: 576,
            options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240],
            forced: !1,
            onChange: null
        },
        loop: {
            active: !1
        },
        speed: {
            selected: 1,
            options: [.5, .75, 1, 1.25, 1.5, 1.75, 2, 4]
        },
        keyboard: {
            focused: !0,
            global: !1
        },
        tooltips: {
            controls: !1,
            seek: !0
        },
        captions: {
            active: !1,
            language: "auto",
            update: !1
        },
        fullscreen: {
            enabled: !0,
            fallback: !0,
            iosNative: !1
        },
        storage: {
            enabled: !0,
            key: "plyr"
        },
        controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"],
        settings: ["captions", "quality", "speed"],
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        events: ["ended", "progress", "stalled", "playing", "waiting", "canplay", "canplaythrough", "loadstart", "loadeddata", "loadedmetadata", "timeupdate", "volumechange", "play", "pause", "error", "seeking", "seeked", "emptied", "ratechange", "cuechange", "download", "enterfullscreen", "exitfullscreen", "captionsenabled", "captionsdisabled", "languagechange", "controlshidden", "controlsshown", "ready", "statechange", "qualitychange", "adsloaded", "adscontentpause", "adscontentresume", "adstarted", "adsmidpoint", "adscomplete", "adsallcomplete", "adsimpression", "adsclick"],
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isIos: "plyr--is-ios",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            tabFocus: "plyr__tab-focus",
            previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id"
            }
        },
        ads: {
            enabled: !1,
            publisherId: "",
            tagUrl: ""
        },
        previewThumbnails: {
            enabled: !1,
            src: ""
        },
        vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
            customControls: !0,
            referrerPolicy: null,
            premium: !1
        },
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            customControls: !0,
            noCookie: !1
        }
    }
      , ct = "picture-in-picture"
      , ut = "inline"
      , dt = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    }
      , ht = "audio"
      , mt = "video";
    var pt = function() {}
      , ft = function() {
        function e() {
            var n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            t(this, e),
            this.enabled = window.console && n,
            this.enabled && this.log("Debugging enabled")
        }
        return i(e, [{
            key: "log",
            get: function() {
                return this.enabled ? Function.prototype.bind.call(console.log, console) : pt
            }
        }, {
            key: "warn",
            get: function() {
                return this.enabled ? Function.prototype.bind.call(console.warn, console) : pt
            }
        }, {
            key: "error",
            get: function() {
                return this.enabled ? Function.prototype.bind.call(console.error, console) : pt
            }
        }]),
        e
    }()
      , gt = function() {
        function e(n) {
            var i = this;
            t(this, e),
            a(this, "onChange", (function() {
                if (i.enabled) {
                    var e = i.player.elements.buttons.fullscreen;
                    Z(e) && (e.pressed = i.active);
                    var t = i.target === i.player.media ? i.target : i.player.elements.container;
                    _e.call(i.player, t, i.active ? "enterfullscreen" : "exitfullscreen", !0)
                }
            }
            )),
            a(this, "toggleFallback", (function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (e ? i.scrollPosition = {
                    x: window.scrollX || 0,
                    y: window.scrollY || 0
                } : window.scrollTo(i.scrollPosition.x, i.scrollPosition.y),
                document.body.style.overflow = e ? "hidden" : "",
                we(i.target, i.player.config.classNames.fullscreen.fallback, e),
                le.isIos) {
                    var t = document.head.querySelector('meta[name="viewport"]')
                      , n = "viewport-fit=cover";
                    t || (t = document.createElement("meta")).setAttribute("name", "viewport");
                    var a = Q(t.content) && t.content.includes(n);
                    e ? (i.cleanupViewport = !a,
                    a || (t.content += ",".concat(n))) : i.cleanupViewport && (t.content = t.content.split(",").filter((function(e) {
                        return e.trim() !== n
                    }
                    )).join(","))
                }
                i.onChange()
            }
            )),
            a(this, "trapFocus", (function(e) {
                if (!le.isIos && i.active && "Tab" === e.key && 9 === e.keyCode) {
                    var t = document.activeElement
                      , n = Ce.call(i.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]")
                      , a = l(n, 1)[0]
                      , r = n[n.length - 1];
                    t !== r || e.shiftKey ? t === a && e.shiftKey && (r.focus(),
                    e.preventDefault()) : (a.focus(),
                    e.preventDefault())
                }
            }
            )),
            a(this, "update", (function() {
                var t;
                i.enabled ? (t = i.forceFallback ? "Fallback (forced)" : e.native ? "Native" : "Fallback",
                i.player.debug.log("".concat(t, " fullscreen enabled"))) : i.player.debug.log("Fullscreen not supported and fallback disabled");
                we(i.player.elements.container, i.player.config.classNames.fullscreen.enabled, i.enabled)
            }
            )),
            a(this, "enter", (function() {
                i.enabled && (le.isIos && i.player.config.fullscreen.iosNative ? i.player.isVimeo ? i.player.embed.requestFullscreen() : i.target.webkitEnterFullscreen() : !e.native || i.forceFallback ? i.toggleFallback(!0) : i.prefix ? re(i.prefix) || i.target["".concat(i.prefix, "Request").concat(i.property)]() : i.target.requestFullscreen({
                    navigationUI: "hide"
                }))
            }
            )),
            a(this, "exit", (function() {
                if (i.enabled)
                    if (le.isIos && i.player.config.fullscreen.iosNative)
                        i.target.webkitExitFullscreen(),
                        qe(i.player.play());
                    else if (!e.native || i.forceFallback)
                        i.toggleFallback(!1);
                    else if (i.prefix) {
                        if (!re(i.prefix)) {
                            var t = "moz" === i.prefix ? "Cancel" : "Exit";
                            document["".concat(i.prefix).concat(t).concat(i.property)]()
                        }
                    } else
                        (document.cancelFullScreen || document.exitFullscreen).call(document)
            }
            )),
            a(this, "toggle", (function() {
                i.active ? i.exit() : i.enter()
            }
            )),
            this.player = n,
            this.prefix = e.prefix,
            this.property = e.property,
            this.scrollPosition = {
                x: 0,
                y: 0
            },
            this.forceFallback = "force" === n.config.fullscreen.fallback,
            this.player.elements.fullscreen = n.config.fullscreen.container && function(e, t) {
                return (Element.prototype.closest || function() {
                    var e = this;
                    do {
                        if (Te.matches(e, t))
                            return e;
                        e = e.parentElement || e.parentNode
                    } while (null !== e && 1 === e.nodeType);
                    return null
                }
                ).call(e, t)
            }(this.player.elements.container, n.config.fullscreen.container),
            Ie.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : "".concat(this.prefix, "fullscreenchange"), (function() {
                i.onChange()
            }
            )),
            Ie.call(this.player, this.player.elements.container, "dblclick", (function(e) {
                Z(i.player.elements.controls) && i.player.elements.controls.contains(e.target) || i.player.listeners.proxy(e, i.toggle, "fullscreen")
            }
            )),
            Ie.call(this, this.player.elements.container, "keydown", (function(e) {
                return i.trapFocus(e)
            }
            )),
            this.update()
        }
        return i(e, [{
            key: "usingNative",
            get: function() {
                return e.native && !this.forceFallback
            }
        }, {
            key: "enabled",
            get: function() {
                return (e.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo
            }
        }, {
            key: "active",
            get: function() {
                if (!this.enabled)
                    return !1;
                if (!e.native || this.forceFallback)
                    return ke(this.target, this.player.config.classNames.fullscreen.fallback);
                var t = this.prefix ? document["".concat(this.prefix).concat(this.property, "Element")] : document.fullscreenElement;
                return t && t.shadowRoot ? t === this.target.getRootNode().host : t === this.target
            }
        }, {
            key: "target",
            get: function() {
                return le.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container
            }
        }], [{
            key: "native",
            get: function() {
                return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled)
            }
        }, {
            key: "prefix",
            get: function() {
                if ($(document.exitFullscreen))
                    return "";
                var e = "";
                return ["webkit", "moz", "ms"].some((function(t) {
                    return !(!$(document["".concat(t, "ExitFullscreen")]) && !$(document["".concat(t, "CancelFullScreen")])) && (e = t,
                    !0)
                }
                )),
                e
            }
        }, {
            key: "property",
            get: function() {
                return "moz" === this.prefix ? "FullScreen" : "Fullscreen"
            }
        }]),
        e
    }();
    function yt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        return new Promise((function(n, i) {
            var a = new Image
              , r = function() {
                delete a.onload,
                delete a.onerror,
                (a.naturalWidth >= t ? n : i)(a)
            };
            Object.assign(a, {
                onload: r,
                onerror: r,
                src: e
            })
        }
        ))
    }
    var bt = {
        addStyleHook: function() {
            we(this.elements.container, this.config.selectors.container.replace(".", ""), !0),
            we(this.elements.container, this.config.classNames.uiSupported, this.supported.ui)
        },
        toggleNativeControls: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls")
        },
        build: function() {
            var e = this;
            if (this.listeners.media(),
            !this.supported.ui)
                return this.debug.warn("Basic support only for ".concat(this.provider, " ").concat(this.type)),
                void bt.toggleNativeControls.call(this, !0);
            Z(this.elements.controls) || (at.inject.call(this),
            this.listeners.controls()),
            bt.toggleNativeControls.call(this),
            this.isHTML5 && st.setup.call(this),
            this.volume = null,
            this.muted = null,
            this.loop = null,
            this.quality = null,
            this.speed = null,
            at.updateVolume.call(this),
            at.timeUpdate.call(this),
            bt.checkPlaying.call(this),
            we(this.elements.container, this.config.classNames.pip.supported, Ne.pip && this.isHTML5 && this.isVideo),
            we(this.elements.container, this.config.classNames.airplay.supported, Ne.airplay && this.isHTML5),
            we(this.elements.container, this.config.classNames.isIos, le.isIos),
            we(this.elements.container, this.config.classNames.isTouch, this.touch),
            this.ready = !0,
            setTimeout((function() {
                _e.call(e, e.media, "ready")
            }
            ), 0),
            bt.setTitle.call(this),
            this.poster && bt.setPoster.call(this, this.poster, !1).catch((function() {}
            )),
            this.config.duration && at.durationUpdate.call(this)
        },
        setTitle: function() {
            var e = $e("play", this.config);
            if (Q(this.config.title) && !re(this.config.title) && (e += ", ".concat(this.config.title)),
            Array.from(this.elements.buttons.play || []).forEach((function(t) {
                t.setAttribute("aria-label", e)
            }
            )),
            this.isEmbed) {
                var t = Ae.call(this, "iframe");
                if (!Z(t))
                    return;
                var n = re(this.config.title) ? "video" : this.config.title
                  , i = $e("frameTitle", this.config);
                t.setAttribute("title", i.replace("{title}", n))
            }
        },
        togglePoster: function(e) {
            we(this.elements.container, this.config.classNames.posterEnabled, e)
        },
        setPoster: function(e) {
            var t = this
              , n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            return n && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e),
            this.elements.poster.removeAttribute("hidden"),
            De.call(this).then((function() {
                return yt(e)
            }
            )).catch((function(n) {
                throw e === t.poster && bt.togglePoster.call(t, !1),
                n
            }
            )).then((function() {
                if (e !== t.poster)
                    throw new Error("setPoster cancelled by later call to setPoster")
            }
            )).then((function() {
                return Object.assign(t.elements.poster.style, {
                    backgroundImage: "url('".concat(e, "')"),
                    backgroundSize: ""
                }),
                bt.togglePoster.call(t, !0),
                e
            }
            )))
        },
        checkPlaying: function(e) {
            var t = this;
            we(this.elements.container, this.config.classNames.playing, this.playing),
            we(this.elements.container, this.config.classNames.paused, this.paused),
            we(this.elements.container, this.config.classNames.stopped, this.stopped),
            Array.from(this.elements.buttons.play || []).forEach((function(e) {
                Object.assign(e, {
                    pressed: t.playing
                }),
                e.setAttribute("aria-label", $e(t.playing ? "pause" : "play", t.config))
            }
            )),
            ee(e) && "timeupdate" === e.type || bt.toggleControls.call(this)
        },
        checkLoading: function(e) {
            var t = this;
            this.loading = ["stalled", "waiting"].includes(e.type),
            clearTimeout(this.timers.loading),
            this.timers.loading = setTimeout((function() {
                we(t.elements.container, t.config.classNames.loading, t.loading),
                bt.toggleControls.call(t)
            }
            ), this.loading ? 250 : 0)
        },
        toggleControls: function(e) {
            var t = this.elements.controls;
            if (t && this.config.hideControls) {
                var n = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || n))
            }
        },
        migrateStyles: function() {
            var e = this;
            Object.values(o({}, this.media.style)).filter((function(e) {
                return !re(e) && Q(e) && e.startsWith("--plyr")
            }
            )).forEach((function(t) {
                e.elements.container.style.setProperty(t, e.media.style.getPropertyValue(t)),
                e.media.style.removeProperty(t)
            }
            )),
            re(this.media.style) && this.media.removeAttribute("style")
        }
    }
      , vt = function() {
        function e(n) {
            var i = this;
            t(this, e),
            a(this, "firstTouch", (function() {
                var e = i.player
                  , t = e.elements;
                e.touch = !0,
                we(t.container, e.config.classNames.isTouch, !0)
            }
            )),
            a(this, "setTabFocus", (function(e) {
                var t = i.player
                  , n = t.elements;
                if (clearTimeout(i.focusTimer),
                "keydown" !== e.type || 9 === e.which) {
                    "keydown" === e.type && (i.lastKeyDown = e.timeStamp);
                    var a, r = e.timeStamp - i.lastKeyDown <= 20;
                    if ("focus" !== e.type || r)
                        a = t.config.classNames.tabFocus,
                        we(Ce.call(t, ".".concat(a)), a, !1),
                        "focusout" !== e.type && (i.focusTimer = setTimeout((function() {
                            var e = document.activeElement;
                            n.container.contains(e) && we(document.activeElement, t.config.classNames.tabFocus, !0)
                        }
                        ), 10))
                }
            }
            )),
            a(this, "global", (function() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]
                  , t = i.player;
                t.config.keyboard.global && xe.call(t, window, "keydown keyup", i.handleKey, e, !1),
                xe.call(t, document.body, "click", i.toggleMenu, e),
                Oe.call(t, document.body, "touchstart", i.firstTouch),
                xe.call(t, document.body, "keydown focus blur focusout", i.setTabFocus, e, !1, !0)
            }
            )),
            a(this, "container", (function() {
                var e = i.player
                  , t = e.config
                  , n = e.elements
                  , a = e.timers;
                !t.keyboard.global && t.keyboard.focused && Ie.call(e, n.container, "keydown keyup", i.handleKey, !1),
                Ie.call(e, n.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (function(t) {
                    var i = n.controls;
                    i && "enterfullscreen" === t.type && (i.pressed = !1,
                    i.hover = !1);
                    var r = 0;
                    ["touchstart", "touchmove", "mousemove"].includes(t.type) && (bt.toggleControls.call(e, !0),
                    r = e.touch ? 3e3 : 2e3),
                    clearTimeout(a.controls),
                    a.controls = setTimeout((function() {
                        return bt.toggleControls.call(e, !1)
                    }
                    ), r)
                }
                ));
                var r = function(t) {
                    if (!t)
                        return Ve.call(e);
                    var i = n.container.getBoundingClientRect()
                      , a = i.width
                      , r = i.height;
                    return Ve.call(e, "".concat(a, ":").concat(r))
                }
                  , o = function() {
                    clearTimeout(a.resized),
                    a.resized = setTimeout(r, 50)
                };
                Ie.call(e, n.container, "enterfullscreen exitfullscreen", (function(t) {
                    var i = e.fullscreen
                      , a = i.target
                      , s = i.usingNative;
                    if (a === n.container && (e.isEmbed || !re(e.config.ratio))) {
                        var c = "enterfullscreen" === t.type
                          , u = r(c);
                        u.padding;
                        !function(t, n, i) {
                            if (e.isVimeo && !e.config.vimeo.premium) {
                                var a = e.elements.wrapper.firstChild
                                  , r = l(t, 2)[1]
                                  , o = l(Re.call(e), 2)
                                  , s = o[0]
                                  , c = o[1];
                                a.style.maxWidth = i ? "".concat(r / c * s, "px") : null,
                                a.style.margin = i ? "0 auto" : null
                            }
                        }(u.ratio, 0, c),
                        c && setTimeout((function() {
                            return se(n.container)
                        }
                        ), 100),
                        s || (c ? Ie.call(e, window, "resize", o) : Le.call(e, window, "resize", o))
                    }
                }
                ))
            }
            )),
            a(this, "media", (function() {
                var e = i.player
                  , t = e.elements;
                if (Ie.call(e, e.media, "timeupdate seeking seeked", (function(t) {
                    return at.timeUpdate.call(e, t)
                }
                )),
                Ie.call(e, e.media, "durationchange loadeddata loadedmetadata", (function(t) {
                    return at.durationUpdate.call(e, t)
                }
                )),
                Ie.call(e, e.media, "ended", (function() {
                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(),
                    e.pause())
                }
                )),
                Ie.call(e, e.media, "progress playing seeking seeked", (function(t) {
                    return at.updateProgress.call(e, t)
                }
                )),
                Ie.call(e, e.media, "volumechange", (function(t) {
                    return at.updateVolume.call(e, t)
                }
                )),
                Ie.call(e, e.media, "playing play pause ended emptied timeupdate", (function(t) {
                    return bt.checkPlaying.call(e, t)
                }
                )),
                Ie.call(e, e.media, "waiting canplay seeked playing", (function(t) {
                    return bt.checkLoading.call(e, t)
                }
                )),
                e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                    var n = Ae.call(e, ".".concat(e.config.classNames.video));
                    if (!Z(n))
                        return;
                    Ie.call(e, t.container, "click", (function(a) {
                        ([t.container, n].includes(a.target) || n.contains(a.target)) && (e.touch && e.config.hideControls || (e.ended ? (i.proxy(a, e.restart, "restart"),
                        i.proxy(a, (function() {
                            qe(e.play())
                        }
                        ), "play")) : i.proxy(a, (function() {
                            qe(e.togglePlay())
                        }
                        ), "play")))
                    }
                    ))
                }
                e.supported.ui && e.config.disableContextMenu && Ie.call(e, t.wrapper, "contextmenu", (function(e) {
                    e.preventDefault()
                }
                ), !1),
                Ie.call(e, e.media, "volumechange", (function() {
                    e.storage.set({
                        volume: e.volume,
                        muted: e.muted
                    })
                }
                )),
                Ie.call(e, e.media, "ratechange", (function() {
                    at.updateSetting.call(e, "speed"),
                    e.storage.set({
                        speed: e.speed
                    })
                }
                )),
                Ie.call(e, e.media, "qualitychange", (function(t) {
                    at.updateSetting.call(e, "quality", null, t.detail.quality)
                }
                )),
                Ie.call(e, e.media, "ready qualitychange", (function() {
                    at.setDownloadUrl.call(e)
                }
                ));
                var a = e.config.events.concat(["keyup", "keydown"]).join(" ");
                Ie.call(e, e.media, a, (function(n) {
                    var i = n.detail
                      , a = void 0 === i ? {} : i;
                    "error" === n.type && (a = e.media.error),
                    _e.call(e, t.container, n.type, !0, a)
                }
                ))
            }
            )),
            a(this, "proxy", (function(e, t, n) {
                var a = i.player
                  , r = a.config.listeners[n]
                  , o = !0;
                $(r) && (o = r.call(a, e)),
                !1 !== o && $(t) && t.call(a, e)
            }
            )),
            a(this, "bind", (function(e, t, n, a) {
                var r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4]
                  , o = i.player
                  , s = o.config.listeners[a]
                  , l = $(s);
                Ie.call(o, e, t, (function(e) {
                    return i.proxy(e, n, a)
                }
                ), r && !l)
            }
            )),
            a(this, "controls", (function() {
                var e = i.player
                  , t = e.elements
                  , n = le.isIE ? "change" : "input";
                if (t.buttons.play && Array.from(t.buttons.play).forEach((function(t) {
                    i.bind(t, "click", (function() {
                        qe(e.togglePlay())
                    }
                    ), "play")
                }
                )),
                i.bind(t.buttons.restart, "click", e.restart, "restart"),
                i.bind(t.buttons.rewind, "click", (function() {
                    e.lastSeekTime = Date.now(),
                    e.rewind()
                }
                ), "rewind"),
                i.bind(t.buttons.fastForward, "click", (function() {
                    e.lastSeekTime = Date.now(),
                    e.forward()
                }
                ), "fastForward"),
                i.bind(t.buttons.mute, "click", (function() {
                    e.muted = !e.muted
                }
                ), "mute"),
                i.bind(t.buttons.captions, "click", (function() {
                    return e.toggleCaptions()
                }
                )),
                i.bind(t.buttons.download, "click", (function() {
                    _e.call(e, e.media, "download")
                }
                ), "download"),
                i.bind(t.buttons.fullscreen, "click", (function() {
                    e.fullscreen.toggle()
                }
                ), "fullscreen"),
                i.bind(t.buttons.pip, "click", (function() {
                    e.pip = "toggle"
                }
                ), "pip"),
                i.bind(t.buttons.airplay, "click", e.airplay, "airplay"),
                i.bind(t.buttons.settings, "click", (function(t) {
                    t.stopPropagation(),
                    t.preventDefault(),
                    at.toggleMenu.call(e, t)
                }
                ), null, !1),
                i.bind(t.buttons.settings, "keyup", (function(t) {
                    var n = t.which;
                    [13, 32].includes(n) && (13 !== n ? (t.preventDefault(),
                    t.stopPropagation(),
                    at.toggleMenu.call(e, t)) : at.focusFirstMenuItem.call(e, null, !0))
                }
                ), null, !1),
                i.bind(t.settings.menu, "keydown", (function(t) {
                    27 === t.which && at.toggleMenu.call(e, t)
                }
                )),
                i.bind(t.inputs.seek, "mousedown mousemove", (function(e) {
                    var n = t.progress.getBoundingClientRect()
                      , i = 100 / n.width * (e.pageX - n.left);
                    e.currentTarget.setAttribute("seek-value", i)
                }
                )),
                i.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (function(t) {
                    var n = t.currentTarget
                      , i = t.keyCode ? t.keyCode : t.which
                      , a = "play-on-seeked";
                    if (!te(t) || 39 === i || 37 === i) {
                        e.lastSeekTime = Date.now();
                        var r = n.hasAttribute(a)
                          , o = ["mouseup", "touchend", "keyup"].includes(t.type);
                        r && o ? (n.removeAttribute(a),
                        qe(e.play())) : !o && e.playing && (n.setAttribute(a, ""),
                        e.pause())
                    }
                }
                )),
                le.isIos) {
                    var a = Ce.call(e, 'input[type="range"]');
                    Array.from(a).forEach((function(e) {
                        return i.bind(e, n, (function(e) {
                            return se(e.target)
                        }
                        ))
                    }
                    ))
                }
                i.bind(t.inputs.seek, n, (function(t) {
                    var n = t.currentTarget
                      , i = n.getAttribute("seek-value");
                    re(i) && (i = n.value),
                    n.removeAttribute("seek-value"),
                    e.currentTime = i / n.max * e.duration
                }
                ), "seek"),
                i.bind(t.progress, "mouseenter mouseleave mousemove", (function(t) {
                    return at.updateSeekTooltip.call(e, t)
                }
                )),
                i.bind(t.progress, "mousemove touchmove", (function(t) {
                    var n = e.previewThumbnails;
                    n && n.loaded && n.startMove(t)
                }
                )),
                i.bind(t.progress, "mouseleave touchend click", (function() {
                    var t = e.previewThumbnails;
                    t && t.loaded && t.endMove(!1, !0)
                }
                )),
                i.bind(t.progress, "mousedown touchstart", (function(t) {
                    var n = e.previewThumbnails;
                    n && n.loaded && n.startScrubbing(t)
                }
                )),
                i.bind(t.progress, "mouseup touchend", (function(t) {
                    var n = e.previewThumbnails;
                    n && n.loaded && n.endScrubbing(t)
                }
                )),
                le.isWebkit && Array.from(Ce.call(e, 'input[type="range"]')).forEach((function(t) {
                    i.bind(t, "input", (function(t) {
                        return at.updateRangeFill.call(e, t.target)
                    }
                    ))
                }
                )),
                e.config.toggleInvert && !Z(t.display.duration) && i.bind(t.display.currentTime, "click", (function() {
                    0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime,
                    at.timeUpdate.call(e))
                }
                )),
                i.bind(t.inputs.volume, n, (function(t) {
                    e.volume = t.target.value
                }
                ), "volume"),
                i.bind(t.controls, "mouseenter mouseleave", (function(n) {
                    t.controls.hover = !e.touch && "mouseenter" === n.type
                }
                )),
                t.fullscreen && Array.from(t.fullscreen.children).filter((function(e) {
                    return !e.contains(t.container)
                }
                )).forEach((function(n) {
                    i.bind(n, "mouseenter mouseleave", (function(n) {
                        t.controls.hover = !e.touch && "mouseenter" === n.type
                    }
                    ))
                }
                )),
                i.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (function(e) {
                    t.controls.pressed = ["mousedown", "touchstart"].includes(e.type)
                }
                )),
                i.bind(t.controls, "focusin", (function() {
                    var n = e.config
                      , a = e.timers;
                    we(t.controls, n.classNames.noTransition, !0),
                    bt.toggleControls.call(e, !0),
                    setTimeout((function() {
                        we(t.controls, n.classNames.noTransition, !1)
                    }
                    ), 0);
                    var r = i.touch ? 3e3 : 4e3;
                    clearTimeout(a.controls),
                    a.controls = setTimeout((function() {
                        return bt.toggleControls.call(e, !1)
                    }
                    ), r)
                }
                )),
                i.bind(t.inputs.volume, "wheel", (function(t) {
                    var n = t.webkitDirectionInvertedFromDevice
                      , i = l([t.deltaX, -t.deltaY].map((function(e) {
                        return n ? -e : e
                    }
                    )), 2)
                      , a = i[0]
                      , r = i[1]
                      , o = Math.sign(Math.abs(a) > Math.abs(r) ? a : r);
                    e.increaseVolume(o / 50);
                    var s = e.media.volume;
                    (1 === o && s < 1 || -1 === o && s > 0) && t.preventDefault()
                }
                ), "volume", !1)
            }
            )),
            this.player = n,
            this.lastKey = null,
            this.focusTimer = null,
            this.lastKeyDown = null,
            this.handleKey = this.handleKey.bind(this),
            this.toggleMenu = this.toggleMenu.bind(this),
            this.setTabFocus = this.setTabFocus.bind(this),
            this.firstTouch = this.firstTouch.bind(this)
        }
        return i(e, [{
            key: "handleKey",
            value: function(e) {
                var t = this.player
                  , n = t.elements
                  , i = e.keyCode ? e.keyCode : e.which
                  , a = "keydown" === e.type
                  , r = a && i === this.lastKey;
                if (!(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) && Y(i)) {
                    if (a) {
                        var o = document.activeElement;
                        if (Z(o)) {
                            var s = t.config.selectors.editable;
                            if (o !== n.inputs.seek && Te(o, s))
                                return;
                            if (32 === e.which && Te(o, 'button, [role^="menuitem"]'))
                                return
                        }
                        switch ([32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 56, 57, 67, 70, 73, 75, 76, 77, 79].includes(i) && (e.preventDefault(),
                        e.stopPropagation()),
                        i) {
                        case 48:
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            r || (t.currentTime = t.duration / 10 * (i - 48));
                            break;
                        case 32:
                        case 75:
                            r || qe(t.togglePlay());
                            break;
                        case 38:
                            t.increaseVolume(.1);
                            break;
                        case 40:
                            t.decreaseVolume(.1);
                            break;
                        case 77:
                            r || (t.muted = !t.muted);
                            break;
                        case 39:
                            t.forward();
                            break;
                        case 37:
                            t.rewind();
                            break;
                        case 70:
                            t.fullscreen.toggle();
                            break;
                        case 67:
                            r || t.toggleCaptions();
                            break;
                        case 76:
                            t.loop = !t.loop
                        }
                        27 === i && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(),
                        this.lastKey = i
                    } else
                        this.lastKey = null
                }
            }
        }, {
            key: "toggleMenu",
            value: function(e) {
                at.toggleMenu.call(this.player, e)
            }
        }]),
        e
    }();
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
    var wt = function(e, t) {
        return e(t = {
            exports: {}
        }, t.exports),
        t.exports
    }((function(e, t) {
        e.exports = function() {
            var e = function() {}
              , t = {}
              , n = {}
              , i = {};
            function a(e, t) {
                e = e.push ? e : [e];
                var a, r, o, s = [], l = e.length, c = l;
                for (a = function(e, n) {
                    n.length && s.push(e),
                    --c || t(s)
                }
                ; l--; )
                    r = e[l],
                    (o = n[r]) ? a(r, o) : (i[r] = i[r] || []).push(a)
            }
            function r(e, t) {
                if (e) {
                    var a = i[e];
                    if (n[e] = t,
                    a)
                        for (; a.length; )
                            a[0](e, t),
                            a.splice(0, 1)
                }
            }
            function o(t, n) {
                t.call && (t = {
                    success: t
                }),
                n.length ? (t.error || e)(n) : (t.success || e)(t)
            }
            function s(t, n, i, a) {
                var r, o, l = document, c = i.async, u = (i.numRetries || 0) + 1, d = i.before || e, h = t.replace(/[\?|#].*$/, ""), m = t.replace(/^(css|img)!/, "");
                a = a || 0,
                /(^css!|\.css$)/.test(h) ? ((o = l.createElement("link")).rel = "stylesheet",
                o.href = m,
                (r = "hideFocus"in o) && o.relList && (r = 0,
                o.rel = "preload",
                o.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(h) ? (o = l.createElement("img")).src = m : ((o = l.createElement("script")).src = t,
                o.async = void 0 === c || c),
                o.onload = o.onerror = o.onbeforeload = function(e) {
                    var l = e.type[0];
                    if (r)
                        try {
                            o.sheet.cssText.length || (l = "e")
                        } catch (e) {
                            18 != e.code && (l = "e")
                        }
                    if ("e" == l) {
                        if ((a += 1) < u)
                            return s(t, n, i, a)
                    } else if ("preload" == o.rel && "style" == o.as)
                        return o.rel = "stylesheet";
                    n(t, l, e.defaultPrevented)
                }
                ,
                !1 !== d(t, o) && l.head.appendChild(o)
            }
            function l(e, t, n) {
                var i, a, r = (e = e.push ? e : [e]).length, o = r, l = [];
                for (i = function(e, n, i) {
                    if ("e" == n && l.push(e),
                    "b" == n) {
                        if (!i)
                            return;
                        l.push(e)
                    }
                    --r || t(l)
                }
                ,
                a = 0; a < o; a++)
                    s(e[a], i, n)
            }
            function c(e, n, i) {
                var a, s;
                if (n && n.trim && (a = n),
                s = (a ? i : n) || {},
                a) {
                    if (a in t)
                        throw "LoadJS";
                    t[a] = !0
                }
                function c(t, n) {
                    l(e, (function(e) {
                        o(s, e),
                        t && o({
                            success: t,
                            error: n
                        }, e),
                        r(a, e)
                    }
                    ), s)
                }
                if (s.returnPromise)
                    return new Promise(c);
                c()
            }
            return c.ready = function(e, t) {
                return a(e, (function(e) {
                    o(t, e)
                }
                )),
                c
            }
            ,
            c.done = function(e) {
                r(e, [])
            }
            ,
            c.reset = function() {
                t = {},
                n = {},
                i = {}
            }
            ,
            c.isDefined = function(e) {
                return e in t
            }
            ,
            c
        }()
    }
    ));
    function kt(e) {
        return new Promise((function(t, n) {
            wt(e, {
                success: t,
                error: n
            })
        }
        ))
    }
    function Tt(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
        this.media.paused === e && (this.media.paused = !e,
        _e.call(this, this.media, e ? "play" : "pause"))
    }
    var Ct = {
        setup: function() {
            var e = this;
            we(e.elements.wrapper, e.config.classNames.embed, !0),
            e.options.speed = e.config.speed.options,
            Ve.call(e),
            K(window.Vimeo) ? Ct.ready.call(e) : kt(e.config.urls.vimeo.sdk).then((function() {
                Ct.ready.call(e)
            }
            )).catch((function(t) {
                e.debug.warn("Vimeo SDK (player.js) failed to load", t)
            }
            ))
        },
        ready: function() {
            var e = this
              , t = this
              , n = t.config.vimeo
              , i = n.premium
              , a = n.referrerPolicy
              , r = s(n, ["premium", "referrerPolicy"]);
            i && Object.assign(r, {
                controls: !1,
                sidedock: !1
            });
            var c = ot(o({
                loop: t.config.loop.active,
                autoplay: t.autoplay,
                muted: t.muted,
                gesture: "media",
                playsinline: !this.config.fullscreen.iosNative
            }, r))
              , u = t.media.getAttribute("src");
            re(u) && (u = t.media.getAttribute(t.config.attributes.embed.id));
            var d, h = re(d = u) ? null : Y(Number(d)) ? d : d.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : d, m = me("iframe"), p = We(t.config.urls.vimeo.iframe, h, c);
            if (m.setAttribute("src", p),
            m.setAttribute("allowfullscreen", ""),
            m.setAttribute("allow", ["autoplay", "fullscreen", "picture-in-picture"].join("; ")),
            re(a) || m.setAttribute("referrerPolicy", a),
            i || !n.customControls)
                m.setAttribute("data-poster", t.poster),
                t.media = ye(m, t.media);
            else {
                var f = me("div", {
                    class: t.config.classNames.embedContainer,
                    "data-poster": t.poster
                });
                f.appendChild(m),
                t.media = ye(f, t.media)
            }
            n.customControls || Ge(We(t.config.urls.vimeo.api, p)).then((function(e) {
                !re(e) && e.thumbnail_url && bt.setPoster.call(t, e.thumbnail_url).catch((function() {}
                ))
            }
            )),
            t.embed = new window.Vimeo.Player(m,{
                autopause: t.config.autopause,
                muted: t.muted
            }),
            t.media.paused = !0,
            t.media.currentTime = 0,
            t.supported.ui && t.embed.disableTextTrack(),
            t.media.play = function() {
                return Tt.call(t, !0),
                t.embed.play()
            }
            ,
            t.media.pause = function() {
                return Tt.call(t, !1),
                t.embed.pause()
            }
            ,
            t.media.stop = function() {
                t.pause(),
                t.currentTime = 0
            }
            ;
            var g = t.media.currentTime;
            Object.defineProperty(t.media, "currentTime", {
                get: function() {
                    return g
                },
                set: function(e) {
                    var n = t.embed
                      , i = t.media
                      , a = t.paused
                      , r = t.volume
                      , o = a && !n.hasPlayed;
                    i.seeking = !0,
                    _e.call(t, i, "seeking"),
                    Promise.resolve(o && n.setVolume(0)).then((function() {
                        return n.setCurrentTime(e)
                    }
                    )).then((function() {
                        return o && n.pause()
                    }
                    )).then((function() {
                        return o && n.setVolume(r)
                    }
                    )).catch((function() {}
                    ))
                }
            });
            var y = t.config.speed.selected;
            Object.defineProperty(t.media, "playbackRate", {
                get: function() {
                    return y
                },
                set: function(e) {
                    t.embed.setPlaybackRate(e).then((function() {
                        y = e,
                        _e.call(t, t.media, "ratechange")
                    }
                    )).catch((function() {
                        t.options.speed = [1]
                    }
                    ))
                }
            });
            var b = t.config.volume;
            Object.defineProperty(t.media, "volume", {
                get: function() {
                    return b
                },
                set: function(e) {
                    t.embed.setVolume(e).then((function() {
                        b = e,
                        _e.call(t, t.media, "volumechange")
                    }
                    ))
                }
            });
            var v = t.config.muted;
            Object.defineProperty(t.media, "muted", {
                get: function() {
                    return v
                },
                set: function(e) {
                    var n = !!X(e) && e;
                    t.embed.setVolume(n ? 0 : t.config.volume).then((function() {
                        v = n,
                        _e.call(t, t.media, "volumechange")
                    }
                    ))
                }
            });
            var w, k = t.config.loop;
            Object.defineProperty(t.media, "loop", {
                get: function() {
                    return k
                },
                set: function(e) {
                    var n = X(e) ? e : t.config.loop.active;
                    t.embed.setLoop(n).then((function() {
                        k = n
                    }
                    ))
                }
            }),
            t.embed.getVideoUrl().then((function(e) {
                w = e,
                at.setDownloadUrl.call(t)
            }
            )).catch((function(t) {
                e.debug.warn(t)
            }
            )),
            Object.defineProperty(t.media, "currentSrc", {
                get: function() {
                    return w
                }
            }),
            Object.defineProperty(t.media, "ended", {
                get: function() {
                    return t.currentTime === t.duration
                }
            }),
            Promise.all([t.embed.getVideoWidth(), t.embed.getVideoHeight()]).then((function(n) {
                var i = l(n, 2)
                  , a = i[0]
                  , r = i[1];
                t.embed.ratio = [a, r],
                Ve.call(e)
            }
            )),
            t.embed.setAutopause(t.config.autopause).then((function(e) {
                t.config.autopause = e
            }
            )),
            t.embed.getVideoTitle().then((function(n) {
                t.config.title = n,
                bt.setTitle.call(e)
            }
            )),
            t.embed.getCurrentTime().then((function(e) {
                g = e,
                _e.call(t, t.media, "timeupdate")
            }
            )),
            t.embed.getDuration().then((function(e) {
                t.media.duration = e,
                _e.call(t, t.media, "durationchange")
            }
            )),
            t.embed.getTextTracks().then((function(e) {
                t.media.textTracks = e,
                st.setup.call(t)
            }
            )),
            t.embed.on("cuechange", (function(e) {
                var n = e.cues
                  , i = (void 0 === n ? [] : n).map((function(e) {
                    return function(e) {
                        var t = document.createDocumentFragment()
                          , n = document.createElement("div");
                        return t.appendChild(n),
                        n.innerHTML = e,
                        t.firstChild.innerText
                    }(e.text)
                }
                ));
                st.updateCues.call(t, i)
            }
            )),
            t.embed.on("loaded", (function() {
                (t.embed.getPaused().then((function(e) {
                    Tt.call(t, !e),
                    e || _e.call(t, t.media, "playing")
                }
                )),
                Z(t.embed.element) && t.supported.ui) && t.embed.element.setAttribute("tabindex", -1)
            }
            )),
            t.embed.on("bufferstart", (function() {
                _e.call(t, t.media, "waiting")
            }
            )),
            t.embed.on("bufferend", (function() {
                _e.call(t, t.media, "playing")
            }
            )),
            t.embed.on("play", (function() {
                Tt.call(t, !0),
                _e.call(t, t.media, "playing")
            }
            )),
            t.embed.on("pause", (function() {
                Tt.call(t, !1)
            }
            )),
            t.embed.on("timeupdate", (function(e) {
                t.media.seeking = !1,
                g = e.seconds,
                _e.call(t, t.media, "timeupdate")
            }
            )),
            t.embed.on("progress", (function(e) {
                t.media.buffered = e.percent,
                _e.call(t, t.media, "progress"),
                1 === parseInt(e.percent, 10) && _e.call(t, t.media, "canplaythrough"),
                t.embed.getDuration().then((function(e) {
                    e !== t.media.duration && (t.media.duration = e,
                    _e.call(t, t.media, "durationchange"))
                }
                ))
            }
            )),
            t.embed.on("seeked", (function() {
                t.media.seeking = !1,
                _e.call(t, t.media, "seeked")
            }
            )),
            t.embed.on("ended", (function() {
                t.media.paused = !0,
                _e.call(t, t.media, "ended")
            }
            )),
            t.embed.on("error", (function(e) {
                t.media.error = e,
                _e.call(t, t.media, "error")
            }
            )),
            n.customControls && setTimeout((function() {
                return bt.build.call(t)
            }
            ), 0)
        }
    };
    function At(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
        this.media.paused === e && (this.media.paused = !e,
        _e.call(this, this.media, e ? "play" : "pause"))
    }
    function St(e) {
        return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0
    }
    var Pt = {
        setup: function() {
            var e = this;
            if (we(this.elements.wrapper, this.config.classNames.embed, !0),
            K(window.YT) && $(window.YT.Player))
                Pt.ready.call(this);
            else {
                var t = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = function() {
                    $(t) && t(),
                    Pt.ready.call(e)
                }
                ,
                kt(this.config.urls.youtube.sdk).catch((function(t) {
                    e.debug.warn("YouTube API failed to load", t)
                }
                ))
            }
        },
        getTitle: function(e) {
            var t = this;
            Ge(We(this.config.urls.youtube.api, e)).then((function(e) {
                if (K(e)) {
                    var n = e.title
                      , i = e.height
                      , a = e.width;
                    t.config.title = n,
                    bt.setTitle.call(t),
                    t.embed.ratio = [a, i]
                }
                Ve.call(t)
            }
            )).catch((function() {
                Ve.call(t)
            }
            ))
        },
        ready: function() {
            var e = this
              , t = e.config.youtube
              , n = e.media && e.media.getAttribute("id");
            if (re(n) || !n.startsWith("youtube-")) {
                var i = e.media.getAttribute("src");
                re(i) && (i = e.media.getAttribute(this.config.attributes.embed.id));
                var a, r, o = re(a = i) ? null : a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a, s = me("div", {
                    id: (r = e.provider,
                    "".concat(r, "-").concat(Math.floor(1e4 * Math.random()))),
                    "data-poster": t.customControls ? e.poster : void 0
                });
                if (e.media = ye(s, e.media),
                t.customControls) {
                    var l = function(e) {
                        return "https://i.ytimg.com/vi/".concat(o, "/").concat(e, "default.jpg")
                    };
                    yt(l("maxres"), 121).catch((function() {
                        return yt(l("sd"), 121)
                    }
                    )).catch((function() {
                        return yt(l("hq"))
                    }
                    )).then((function(t) {
                        return bt.setPoster.call(e, t.src)
                    }
                    )).then((function(t) {
                        t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover")
                    }
                    )).catch((function() {}
                    ))
                }
                e.embed = new window.YT.Player(e.media,{
                    videoId: o,
                    host: St(t),
                    playerVars: ue({}, {
                        autoplay: e.config.autoplay ? 1 : 0,
                        hl: e.config.hl,
                        controls: e.supported.ui && t.customControls ? 0 : 1,
                        disablekb: 1,
                        playsinline: e.config.fullscreen.iosNative ? 0 : 1,
                        cc_load_policy: e.captions.active ? 1 : 0,
                        cc_lang_pref: e.config.captions.language,
                        widget_referrer: window ? window.location.href : null
                    }, t),
                    events: {
                        onError: function(t) {
                            if (!e.media.error) {
                                var n = t.data
                                  , i = {
                                    2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                    5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                    100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                    101: "The owner of the requested video does not allow it to be played in embedded players.",
                                    150: "The owner of the requested video does not allow it to be played in embedded players."
                                }[n] || "An unknown error occured";
                                e.media.error = {
                                    code: n,
                                    message: i
                                },
                                _e.call(e, e.media, "error")
                            }
                        },
                        onPlaybackRateChange: function(t) {
                            var n = t.target;
                            e.media.playbackRate = n.getPlaybackRate(),
                            _e.call(e, e.media, "ratechange")
                        },
                        onReady: function(n) {
                            if (!$(e.media.play)) {
                                var i = n.target;
                                Pt.getTitle.call(e, o),
                                e.media.play = function() {
                                    At.call(e, !0),
                                    i.playVideo()
                                }
                                ,
                                e.media.pause = function() {
                                    At.call(e, !1),
                                    i.pauseVideo()
                                }
                                ,
                                e.media.stop = function() {
                                    i.stopVideo()
                                }
                                ,
                                e.media.duration = i.getDuration(),
                                e.media.paused = !0,
                                e.media.currentTime = 0,
                                Object.defineProperty(e.media, "currentTime", {
                                    get: function() {
                                        return Number(i.getCurrentTime())
                                    },
                                    set: function(t) {
                                        e.paused && !e.embed.hasPlayed && e.embed.mute(),
                                        e.media.seeking = !0,
                                        _e.call(e, e.media, "seeking"),
                                        i.seekTo(t)
                                    }
                                }),
                                Object.defineProperty(e.media, "playbackRate", {
                                    get: function() {
                                        return i.getPlaybackRate()
                                    },
                                    set: function(e) {
                                        i.setPlaybackRate(e)
                                    }
                                });
                                var a = e.config.volume;
                                Object.defineProperty(e.media, "volume", {
                                    get: function() {
                                        return a
                                    },
                                    set: function(t) {
                                        a = t,
                                        i.setVolume(100 * a),
                                        _e.call(e, e.media, "volumechange")
                                    }
                                });
                                var r = e.config.muted;
                                Object.defineProperty(e.media, "muted", {
                                    get: function() {
                                        return r
                                    },
                                    set: function(t) {
                                        var n = X(t) ? t : r;
                                        r = n,
                                        i[n ? "mute" : "unMute"](),
                                        i.setVolume(100 * a),
                                        _e.call(e, e.media, "volumechange")
                                    }
                                }),
                                Object.defineProperty(e.media, "currentSrc", {
                                    get: function() {
                                        return i.getVideoUrl()
                                    }
                                }),
                                Object.defineProperty(e.media, "ended", {
                                    get: function() {
                                        return e.currentTime === e.duration
                                    }
                                });
                                var s = i.getAvailablePlaybackRates();
                                e.options.speed = s.filter((function(t) {
                                    return e.config.speed.options.includes(t)
                                }
                                )),
                                e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1),
                                _e.call(e, e.media, "timeupdate"),
                                _e.call(e, e.media, "durationchange"),
                                clearInterval(e.timers.buffering),
                                e.timers.buffering = setInterval((function() {
                                    e.media.buffered = i.getVideoLoadedFraction(),
                                    (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && _e.call(e, e.media, "progress"),
                                    e.media.lastBuffered = e.media.buffered,
                                    1 === e.media.buffered && (clearInterval(e.timers.buffering),
                                    _e.call(e, e.media, "canplaythrough"))
                                }
                                ), 200),
                                t.customControls && setTimeout((function() {
                                    return bt.build.call(e)
                                }
                                ), 50)
                            }
                        },
                        onStateChange: function(n) {
                            var i = n.target;
                            switch (clearInterval(e.timers.playing),
                            e.media.seeking && [1, 2].includes(n.data) && (e.media.seeking = !1,
                            _e.call(e, e.media, "seeked")),
                            n.data) {
                            case -1:
                                _e.call(e, e.media, "timeupdate"),
                                e.media.buffered = i.getVideoLoadedFraction(),
                                _e.call(e, e.media, "progress");
                                break;
                            case 0:
                                At.call(e, !1),
                                e.media.loop ? (i.stopVideo(),
                                i.playVideo()) : _e.call(e, e.media, "ended");
                                break;
                            case 1:
                                t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (At.call(e, !0),
                                _e.call(e, e.media, "playing"),
                                e.timers.playing = setInterval((function() {
                                    _e.call(e, e.media, "timeupdate")
                                }
                                ), 50),
                                e.media.duration !== i.getDuration() && (e.media.duration = i.getDuration(),
                                _e.call(e, e.media, "durationchange")));
                                break;
                            case 2:
                                e.muted || e.embed.unMute(),
                                At.call(e, !1);
                                break;
                            case 3:
                                _e.call(e, e.media, "waiting")
                            }
                            _e.call(e, e.elements.container, "statechange", !1, {
                                code: n.data
                            })
                        }
                    }
                })
            }
        }
    }
      , Et = {
        setup: function() {
            this.media ? (we(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0),
            we(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0),
            this.isEmbed && we(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0),
            this.isVideo && (this.elements.wrapper = me("div", {
                class: this.config.classNames.video
            }),
            de(this.media, this.elements.wrapper),
            this.elements.poster = me("div", {
                class: this.config.classNames.poster,
                hidden: ""
            }),
            this.elements.wrapper.appendChild(this.elements.poster)),
            this.isHTML5 ? Be.setup.call(this) : this.isYouTube ? Pt.setup.call(this) : this.isVimeo && Ct.setup.call(this)) : this.debug.warn("No media element found!")
        }
    }
      , Nt = function() {
        function e(n) {
            var i = this;
            t(this, e),
            a(this, "load", (function() {
                i.enabled && (K(window.google) && K(window.google.ima) ? i.ready() : kt(i.player.config.urls.googleIMA.sdk).then((function() {
                    i.ready()
                }
                )).catch((function() {
                    i.trigger("error", new Error("Google IMA SDK failed to load"))
                }
                )))
            }
            )),
            a(this, "ready", (function() {
                var e;
                i.enabled || ((e = i).manager && e.manager.destroy(),
                e.elements.displayContainer && e.elements.displayContainer.destroy(),
                e.elements.container.remove()),
                i.startSafetyTimer(12e3, "ready()"),
                i.managerPromise.then((function() {
                    i.clearSafetyTimer("onAdsManagerLoaded()")
                }
                )),
                i.listeners(),
                i.setupIMA()
            }
            )),
            a(this, "setupIMA", (function() {
                i.elements.container = me("div", {
                    class: i.player.config.classNames.ads
                }),
                i.player.elements.container.appendChild(i.elements.container),
                google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED),
                google.ima.settings.setLocale(i.player.config.ads.language),
                google.ima.settings.setDisableCustomPlaybackForIOS10Plus(i.player.config.playsinline),
                i.elements.displayContainer = new google.ima.AdDisplayContainer(i.elements.container,i.player.media),
                i.loader = new google.ima.AdsLoader(i.elements.displayContainer),
                i.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (function(e) {
                    return i.onAdsManagerLoaded(e)
                }
                ), !1),
                i.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (function(e) {
                    return i.onAdError(e)
                }
                ), !1),
                i.requestAds()
            }
            )),
            a(this, "requestAds", (function() {
                var e = i.player.elements.container;
                try {
                    var t = new google.ima.AdsRequest;
                    t.adTagUrl = i.tagUrl,
                    t.linearAdSlotWidth = e.offsetWidth,
                    t.linearAdSlotHeight = e.offsetHeight,
                    t.nonLinearAdSlotWidth = e.offsetWidth,
                    t.nonLinearAdSlotHeight = e.offsetHeight,
                    t.forceNonLinearFullSlot = !1,
                    t.setAdWillPlayMuted(!i.player.muted),
                    i.loader.requestAds(t)
                } catch (e) {
                    i.onAdError(e)
                }
            }
            )),
            a(this, "pollCountdown", (function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (!e)
                    return clearInterval(i.countdownTimer),
                    void i.elements.container.removeAttribute("data-badge-text");
                var t = function() {
                    var e = it(Math.max(i.manager.getRemainingTime(), 0))
                      , t = "".concat($e("advertisement", i.player.config), " - ").concat(e);
                    i.elements.container.setAttribute("data-badge-text", t)
                };
                i.countdownTimer = setInterval(t, 100)
            }
            )),
            a(this, "onAdsManagerLoaded", (function(e) {
                if (i.enabled) {
                    var t = new google.ima.AdsRenderingSettings;
                    t.restoreCustomPlaybackStateOnAdBreakComplete = !0,
                    t.enablePreloading = !0,
                    i.manager = e.getAdsManager(i.player, t),
                    i.cuePoints = i.manager.getCuePoints(),
                    i.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (function(e) {
                        return i.onAdError(e)
                    }
                    )),
                    Object.keys(google.ima.AdEvent.Type).forEach((function(e) {
                        i.manager.addEventListener(google.ima.AdEvent.Type[e], (function(e) {
                            return i.onAdEvent(e)
                        }
                        ))
                    }
                    )),
                    i.trigger("loaded")
                }
            }
            )),
            a(this, "addCuePoints", (function() {
                re(i.cuePoints) || i.cuePoints.forEach((function(e) {
                    if (0 !== e && -1 !== e && e < i.player.duration) {
                        var t = i.player.elements.progress;
                        if (Z(t)) {
                            var n = 100 / i.player.duration * e
                              , a = me("span", {
                                class: i.player.config.classNames.cues
                            });
                            a.style.left = "".concat(n.toString(), "%"),
                            t.appendChild(a)
                        }
                    }
                }
                ))
            }
            )),
            a(this, "onAdEvent", (function(e) {
                var t = i.player.elements.container
                  , n = e.getAd()
                  , a = e.getAdData();
                switch (function(e) {
                    _e.call(i.player, i.player.media, "ads".concat(e.replace(/_/g, "").toLowerCase()))
                }(e.type),
                e.type) {
                case google.ima.AdEvent.Type.LOADED:
                    i.trigger("loaded"),
                    i.pollCountdown(!0),
                    n.isLinear() || (n.width = t.offsetWidth,
                    n.height = t.offsetHeight);
                    break;
                case google.ima.AdEvent.Type.STARTED:
                    i.manager.setVolume(i.player.volume);
                    break;
                case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                    i.player.ended ? i.loadAds() : i.loader.contentComplete();
                    break;
                case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                    i.pauseContent();
                    break;
                case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                    i.pollCountdown(),
                    i.resumeContent();
                    break;
                case google.ima.AdEvent.Type.LOG:
                    a.adError && i.player.debug.warn("Non-fatal ad error: ".concat(a.adError.getMessage()))
                }
            }
            )),
            a(this, "onAdError", (function(e) {
                i.cancel(),
                i.player.debug.warn("Ads error", e)
            }
            )),
            a(this, "listeners", (function() {
                var e, t = i.player.elements.container;
                i.player.on("canplay", (function() {
                    i.addCuePoints()
                }
                )),
                i.player.on("ended", (function() {
                    i.loader.contentComplete()
                }
                )),
                i.player.on("timeupdate", (function() {
                    e = i.player.currentTime
                }
                )),
                i.player.on("seeked", (function() {
                    var t = i.player.currentTime;
                    re(i.cuePoints) || i.cuePoints.forEach((function(n, a) {
                        e < n && n < t && (i.manager.discardAdBreak(),
                        i.cuePoints.splice(a, 1))
                    }
                    ))
                }
                )),
                window.addEventListener("resize", (function() {
                    i.manager && i.manager.resize(t.offsetWidth, t.offsetHeight, google.ima.ViewMode.NORMAL)
                }
                ))
            }
            )),
            a(this, "play", (function() {
                var e = i.player.elements.container;
                i.managerPromise || i.resumeContent(),
                i.managerPromise.then((function() {
                    i.manager.setVolume(i.player.volume),
                    i.elements.displayContainer.initialize();
                    try {
                        i.initialized || (i.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL),
                        i.manager.start()),
                        i.initialized = !0
                    } catch (e) {
                        i.onAdError(e)
                    }
                }
                )).catch((function() {}
                ))
            }
            )),
            a(this, "resumeContent", (function() {
                i.elements.container.style.zIndex = "",
                i.playing = !1,
                qe(i.player.media.play())
            }
            )),
            a(this, "pauseContent", (function() {
                i.elements.container.style.zIndex = 3,
                i.playing = !0,
                i.player.media.pause()
            }
            )),
            a(this, "cancel", (function() {
                i.initialized && i.resumeContent(),
                i.trigger("error"),
                i.loadAds()
            }
            )),
            a(this, "loadAds", (function() {
                i.managerPromise.then((function() {
                    i.manager && i.manager.destroy(),
                    i.managerPromise = new Promise((function(e) {
                        i.on("loaded", e),
                        i.player.debug.log(i.manager)
                    }
                    )),
                    i.initialized = !1,
                    i.requestAds()
                }
                )).catch((function() {}
                ))
            }
            )),
            a(this, "trigger", (function(e) {
                for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
                    n[a - 1] = arguments[a];
                var r = i.events[e];
                J(r) && r.forEach((function(e) {
                    $(e) && e.apply(i, n)
                }
                ))
            }
            )),
            a(this, "on", (function(e, t) {
                return J(i.events[e]) || (i.events[e] = []),
                i.events[e].push(t),
                i
            }
            )),
            a(this, "startSafetyTimer", (function(e, t) {
                i.player.debug.log("Safety timer invoked from: ".concat(t)),
                i.safetyTimer = setTimeout((function() {
                    i.cancel(),
                    i.clearSafetyTimer("startSafetyTimer()")
                }
                ), e)
            }
            )),
            a(this, "clearSafetyTimer", (function(e) {
                z(i.safetyTimer) || (i.player.debug.log("Safety timer cleared from: ".concat(e)),
                clearTimeout(i.safetyTimer),
                i.safetyTimer = null)
            }
            )),
            this.player = n,
            this.config = n.config.ads,
            this.playing = !1,
            this.initialized = !1,
            this.elements = {
                container: null,
                displayContainer: null
            },
            this.manager = null,
            this.loader = null,
            this.cuePoints = null,
            this.events = {},
            this.safetyTimer = null,
            this.countdownTimer = null,
            this.managerPromise = new Promise((function(e, t) {
                i.on("loaded", e),
                i.on("error", t)
            }
            )),
            this.load()
        }
        return i(e, [{
            key: "enabled",
            get: function() {
                var e = this.config;
                return this.player.isHTML5 && this.player.isVideo && e.enabled && (!re(e.publisherId) || ae(e.tagUrl))
            }
        }, {
            key: "tagUrl",
            get: function() {
                var e = this.config;
                if (ae(e.tagUrl))
                    return e.tagUrl;
                var t = {
                    AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                    AV_CHANNELID: "5a0458dc28a06145e4519d21",
                    AV_URL: window.location.hostname,
                    cb: Date.now(),
                    AV_WIDTH: 640,
                    AV_HEIGHT: 480,
                    AV_CDIM2: e.publisherId
                };
                return "".concat("https://go.aniview.com/api/adserver6/vast/", "?").concat(ot(t))
            }
        }]),
        e
    }()
      , Mt = function(e, t) {
        var n = {};
        return e > t.width / t.height ? (n.width = t.width,
        n.height = 1 / e * t.width) : (n.height = t.height,
        n.width = e * t.height),
        n
    }
      , xt = function() {
        function e(n) {
            var i = this;
            t(this, e),
            a(this, "load", (function() {
                i.player.elements.display.seekTooltip && (i.player.elements.display.seekTooltip.hidden = i.enabled),
                i.enabled && i.getThumbnails().then((function() {
                    i.enabled && (i.render(),
                    i.determineContainerAutoSizing(),
                    i.loaded = !0)
                }
                ))
            }
            )),
            a(this, "getThumbnails", (function() {
                return new Promise((function(e) {
                    var t = i.player.config.previewThumbnails.src;
                    if (re(t))
                        throw new Error("Missing previewThumbnails.src config attribute");
                    var n = function() {
                        i.thumbnails.sort((function(e, t) {
                            return e.height - t.height
                        }
                        )),
                        i.player.debug.log("Preview thumbnails", i.thumbnails),
                        e()
                    };
                    if ($(t))
                        t((function(e) {
                            i.thumbnails = e,
                            n()
                        }
                        ));
                    else {
                        var a = (Q(t) ? [t] : t).map((function(e) {
                            return i.getThumbnail(e)
                        }
                        ));
                        Promise.all(a).then(n)
                    }
                }
                ))
            }
            )),
            a(this, "getThumbnail", (function(e) {
                return new Promise((function(t) {
                    Ge(e).then((function(n) {
                        var a, r, o = {
                            frames: (a = n,
                            r = [],
                            a.split(/\r\n\r\n|\n\n|\r\r/).forEach((function(e) {
                                var t = {};
                                e.split(/\r\n|\n|\r/).forEach((function(e) {
                                    if (Y(t.startTime)) {
                                        if (!re(e.trim()) && re(t.text)) {
                                            var n = e.trim().split("#xywh=")
                                              , i = l(n, 1);
                                            if (t.text = i[0],
                                            n[1]) {
                                                var a = l(n[1].split(","), 4);
                                                t.x = a[0],
                                                t.y = a[1],
                                                t.w = a[2],
                                                t.h = a[3]
                                            }
                                        }
                                    } else {
                                        var r = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                                        r && (t.startTime = 60 * Number(r[1] || 0) * 60 + 60 * Number(r[2]) + Number(r[3]) + Number("0.".concat(r[4])),
                                        t.endTime = 60 * Number(r[6] || 0) * 60 + 60 * Number(r[7]) + Number(r[8]) + Number("0.".concat(r[9])))
                                    }
                                }
                                )),
                                t.text && r.push(t)
                            }
                            )),
                            r),
                            height: null,
                            urlPrefix: ""
                        };
                        o.frames[0].text.startsWith("/") || o.frames[0].text.startsWith("http://") || o.frames[0].text.startsWith("https://") || (o.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                        var s = new Image;
                        s.onload = function() {
                            o.height = s.naturalHeight,
                            o.width = s.naturalWidth,
                            i.thumbnails.push(o),
                            t()
                        }
                        ,
                        s.src = o.urlPrefix + o.frames[0].text
                    }
                    ))
                }
                ))
            }
            )),
            a(this, "startMove", (function(e) {
                if (i.loaded && ee(e) && ["touchmove", "mousemove"].includes(e.type) && i.player.media.duration) {
                    if ("touchmove" === e.type)
                        i.seekTime = i.player.media.duration * (i.player.elements.inputs.seek.value / 100);
                    else {
                        var t = i.player.elements.progress.getBoundingClientRect()
                          , n = 100 / t.width * (e.pageX - t.left);
                        i.seekTime = i.player.media.duration * (n / 100),
                        i.seekTime < 0 && (i.seekTime = 0),
                        i.seekTime > i.player.media.duration - 1 && (i.seekTime = i.player.media.duration - 1),
                        i.mousePosX = e.pageX,
                        i.elements.thumb.time.innerText = it(i.seekTime)
                    }
                    i.showImageAtCurrentTime()
                }
            }
            )),
            a(this, "endMove", (function() {
                i.toggleThumbContainer(!1, !0)
            }
            )),
            a(this, "startScrubbing", (function(e) {
                (z(e.button) || !1 === e.button || 0 === e.button) && (i.mouseDown = !0,
                i.player.media.duration && (i.toggleScrubbingContainer(!0),
                i.toggleThumbContainer(!1, !0),
                i.showImageAtCurrentTime()))
            }
            )),
            a(this, "endScrubbing", (function() {
                i.mouseDown = !1,
                Math.ceil(i.lastTime) === Math.ceil(i.player.media.currentTime) ? i.toggleScrubbingContainer(!1) : Oe.call(i.player, i.player.media, "timeupdate", (function() {
                    i.mouseDown || i.toggleScrubbingContainer(!1)
                }
                ))
            }
            )),
            a(this, "listeners", (function() {
                i.player.on("play", (function() {
                    i.toggleThumbContainer(!1, !0)
                }
                )),
                i.player.on("seeked", (function() {
                    i.toggleThumbContainer(!1)
                }
                )),
                i.player.on("timeupdate", (function() {
                    i.lastTime = i.player.media.currentTime
                }
                ))
            }
            )),
            a(this, "render", (function() {
                i.elements.thumb.container = me("div", {
                    class: i.player.config.classNames.previewThumbnails.thumbContainer
                }),
                i.elements.thumb.imageContainer = me("div", {
                    class: i.player.config.classNames.previewThumbnails.imageContainer
                }),
                i.elements.thumb.container.appendChild(i.elements.thumb.imageContainer);
                var e = me("div", {
                    class: i.player.config.classNames.previewThumbnails.timeContainer
                });
                i.elements.thumb.time = me("span", {}, "00:00"),
                e.appendChild(i.elements.thumb.time),
                i.elements.thumb.container.appendChild(e),
                Z(i.player.elements.progress) && i.player.elements.progress.appendChild(i.elements.thumb.container),
                i.elements.scrubbing.container = me("div", {
                    class: i.player.config.classNames.previewThumbnails.scrubbingContainer
                }),
                i.player.elements.wrapper.appendChild(i.elements.scrubbing.container)
            }
            )),
            a(this, "destroy", (function() {
                i.elements.thumb.container && i.elements.thumb.container.remove(),
                i.elements.scrubbing.container && i.elements.scrubbing.container.remove()
            }
            )),
            a(this, "showImageAtCurrentTime", (function() {
                i.mouseDown ? i.setScrubbingContainerSize() : i.setThumbContainerSizeAndPos();
                var e = i.thumbnails[0].frames.findIndex((function(e) {
                    return i.seekTime >= e.startTime && i.seekTime <= e.endTime
                }
                ))
                  , t = e >= 0
                  , n = 0;
                i.mouseDown || i.toggleThumbContainer(t),
                t && (i.thumbnails.forEach((function(t, a) {
                    i.loadedImages.includes(t.frames[e].text) && (n = a)
                }
                )),
                e !== i.showingThumb && (i.showingThumb = e,
                i.loadImage(n)))
            }
            )),
            a(this, "loadImage", (function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0
                  , t = i.showingThumb
                  , n = i.thumbnails[e]
                  , a = n.urlPrefix
                  , r = n.frames[t]
                  , o = n.frames[t].text
                  , s = a + o;
                if (i.currentImageElement && i.currentImageElement.dataset.filename === o)
                    i.showImage(i.currentImageElement, r, e, t, o, !1),
                    i.currentImageElement.dataset.index = t,
                    i.removeOldImages(i.currentImageElement);
                else {
                    i.loadingImage && i.usingSprites && (i.loadingImage.onload = null);
                    var l = new Image;
                    l.src = s,
                    l.dataset.index = t,
                    l.dataset.filename = o,
                    i.showingThumbFilename = o,
                    i.player.debug.log("Loading image: ".concat(s)),
                    l.onload = function() {
                        return i.showImage(l, r, e, t, o, !0)
                    }
                    ,
                    i.loadingImage = l,
                    i.removeOldImages(l)
                }
            }
            )),
            a(this, "showImage", (function(e, t, n, a, r) {
                var o = !(arguments.length > 5 && void 0 !== arguments[5]) || arguments[5];
                i.player.debug.log("Showing thumb: ".concat(r, ". num: ").concat(a, ". qual: ").concat(n, ". newimg: ").concat(o)),
                i.setImageSizeAndOffset(e, t),
                o && (i.currentImageContainer.appendChild(e),
                i.currentImageElement = e,
                i.loadedImages.includes(r) || i.loadedImages.push(r)),
                i.preloadNearby(a, !0).then(i.preloadNearby(a, !1)).then(i.getHigherQuality(n, e, t, r))
            }
            )),
            a(this, "removeOldImages", (function(e) {
                Array.from(i.currentImageContainer.children).forEach((function(t) {
                    if ("img" === t.tagName.toLowerCase()) {
                        var n = i.usingSprites ? 500 : 1e3;
                        if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                            t.dataset.deleting = !0;
                            var a = i.currentImageContainer;
                            setTimeout((function() {
                                a.removeChild(t),
                                i.player.debug.log("Removing thumb: ".concat(t.dataset.filename))
                            }
                            ), n)
                        }
                    }
                }
                ))
            }
            )),
            a(this, "preloadNearby", (function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return new Promise((function(n) {
                    setTimeout((function() {
                        var a = i.thumbnails[0].frames[e].text;
                        if (i.showingThumbFilename === a) {
                            var r;
                            r = t ? i.thumbnails[0].frames.slice(e) : i.thumbnails[0].frames.slice(0, e).reverse();
                            var o = !1;
                            r.forEach((function(e) {
                                var t = e.text;
                                if (t !== a && !i.loadedImages.includes(t)) {
                                    o = !0,
                                    i.player.debug.log("Preloading thumb filename: ".concat(t));
                                    var r = i.thumbnails[0].urlPrefix + t
                                      , s = new Image;
                                    s.src = r,
                                    s.onload = function() {
                                        i.player.debug.log("Preloaded thumb filename: ".concat(t)),
                                        i.loadedImages.includes(t) || i.loadedImages.push(t),
                                        n()
                                    }
                                }
                            }
                            )),
                            o || n()
                        }
                    }
                    ), 300)
                }
                ))
            }
            )),
            a(this, "getHigherQuality", (function(e, t, n, a) {
                if (e < i.thumbnails.length - 1) {
                    var r = t.naturalHeight;
                    i.usingSprites && (r = n.h),
                    r < i.thumbContainerHeight && setTimeout((function() {
                        i.showingThumbFilename === a && (i.player.debug.log("Showing higher quality thumb for: ".concat(a)),
                        i.loadImage(e + 1))
                    }
                    ), 300)
                }
            }
            )),
            a(this, "toggleThumbContainer", (function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                  , t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                  , n = i.player.config.classNames.previewThumbnails.thumbContainerShown;
                i.elements.thumb.container.classList.toggle(n, e),
                !e && t && (i.showingThumb = null,
                i.showingThumbFilename = null)
            }
            )),
            a(this, "toggleScrubbingContainer", (function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                  , t = i.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                i.elements.scrubbing.container.classList.toggle(t, e),
                e || (i.showingThumb = null,
                i.showingThumbFilename = null)
            }
            )),
            a(this, "determineContainerAutoSizing", (function() {
                (i.elements.thumb.imageContainer.clientHeight > 20 || i.elements.thumb.imageContainer.clientWidth > 20) && (i.sizeSpecifiedInCSS = !0)
            }
            )),
            a(this, "setThumbContainerSizeAndPos", (function() {
                if (i.sizeSpecifiedInCSS) {
                    if (i.elements.thumb.imageContainer.clientHeight > 20 && i.elements.thumb.imageContainer.clientWidth < 20) {
                        var e = Math.floor(i.elements.thumb.imageContainer.clientHeight * i.thumbAspectRatio);
                        i.elements.thumb.imageContainer.style.width = "".concat(e, "px")
                    } else if (i.elements.thumb.imageContainer.clientHeight < 20 && i.elements.thumb.imageContainer.clientWidth > 20) {
                        var t = Math.floor(i.elements.thumb.imageContainer.clientWidth / i.thumbAspectRatio);
                        i.elements.thumb.imageContainer.style.height = "".concat(t, "px")
                    }
                } else {
                    var n = Math.floor(i.thumbContainerHeight * i.thumbAspectRatio);
                    i.elements.thumb.imageContainer.style.height = "".concat(i.thumbContainerHeight, "px"),
                    i.elements.thumb.imageContainer.style.width = "".concat(n, "px")
                }
                i.setThumbContainerPos()
            }
            )),
            a(this, "setThumbContainerPos", (function() {
                var e = i.player.elements.progress.getBoundingClientRect()
                  , t = i.player.elements.container.getBoundingClientRect()
                  , n = i.elements.thumb.container
                  , a = t.left - e.left + 10
                  , r = t.right - e.left - n.clientWidth - 10
                  , o = i.mousePosX - e.left - n.clientWidth / 2;
                o < a && (o = a),
                o > r && (o = r),
                n.style.left = "".concat(o, "px")
            }
            )),
            a(this, "setScrubbingContainerSize", (function() {
                var e = Mt(i.thumbAspectRatio, {
                    width: i.player.media.clientWidth,
                    height: i.player.media.clientHeight
                })
                  , t = e.width
                  , n = e.height;
                i.elements.scrubbing.container.style.width = "".concat(t, "px"),
                i.elements.scrubbing.container.style.height = "".concat(n, "px")
            }
            )),
            a(this, "setImageSizeAndOffset", (function(e, t) {
                if (i.usingSprites) {
                    var n = i.thumbContainerHeight / t.h;
                    e.style.height = "".concat(e.naturalHeight * n, "px"),
                    e.style.width = "".concat(e.naturalWidth * n, "px"),
                    e.style.left = "-".concat(t.x * n, "px"),
                    e.style.top = "-".concat(t.y * n, "px")
                }
            }
            )),
            this.player = n,
            this.thumbnails = [],
            this.loaded = !1,
            this.lastMouseMoveTime = Date.now(),
            this.mouseDown = !1,
            this.loadedImages = [],
            this.elements = {
                thumb: {},
                scrubbing: {}
            },
            this.load()
        }
        return i(e, [{
            key: "enabled",
            get: function() {
                return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled
            }
        }, {
            key: "currentImageContainer",
            get: function() {
                return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer
            }
        }, {
            key: "usingSprites",
            get: function() {
                return Object.keys(this.thumbnails[0].frames[0]).includes("w")
            }
        }, {
            key: "thumbAspectRatio",
            get: function() {
                return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height
            }
        }, {
            key: "thumbContainerHeight",
            get: function() {
                return this.mouseDown ? Mt(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                }).height : this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4)
            }
        }, {
            key: "currentImageElement",
            get: function() {
                return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement
            },
            set: function(e) {
                this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e
            }
        }]),
        e
    }()
      , It = {
        insertElements: function(e, t) {
            var n = this;
            Q(t) ? pe(e, this.media, {
                src: t
            }) : J(t) && t.forEach((function(t) {
                pe(e, n.media, t)
            }
            ))
        },
        change: function(e) {
            var t = this;
            ce(e, "sources.length") ? (Be.cancelRequests.call(this),
            this.destroy.call(this, (function() {
                t.options.quality = [],
                fe(t.media),
                t.media = null,
                Z(t.elements.container) && t.elements.container.removeAttribute("class");
                var n = e.sources
                  , i = e.type
                  , a = l(n, 1)[0]
                  , r = a.provider
                  , o = void 0 === r ? dt.html5 : r
                  , s = a.src
                  , c = "html5" === o ? i : "div"
                  , u = "html5" === o ? {} : {
                    src: s
                };
                Object.assign(t, {
                    provider: o,
                    type: i,
                    supported: Ne.check(i, o, t.config.playsinline),
                    media: me(c, u)
                }),
                t.elements.container.appendChild(t.media),
                X(e.autoplay) && (t.config.autoplay = e.autoplay),
                t.isHTML5 && (t.config.crossorigin && t.media.setAttribute("crossorigin", ""),
                t.config.autoplay && t.media.setAttribute("autoplay", ""),
                re(e.poster) || (t.poster = e.poster),
                t.config.loop.active && t.media.setAttribute("loop", ""),
                t.config.muted && t.media.setAttribute("muted", ""),
                t.config.playsinline && t.media.setAttribute("playsinline", "")),
                bt.addStyleHook.call(t),
                t.isHTML5 && It.insertElements.call(t, "source", n),
                t.config.title = e.title,
                Et.setup.call(t),
                t.isHTML5 && Object.keys(e).includes("tracks") && It.insertElements.call(t, "track", e.tracks),
                (t.isHTML5 || t.isEmbed && !t.supported.ui) && bt.build.call(t),
                t.isHTML5 && t.media.load(),
                re(e.previewThumbnails) || (Object.assign(t.config.previewThumbnails, e.previewThumbnails),
                t.previewThumbnails && t.previewThumbnails.loaded && (t.previewThumbnails.destroy(),
                t.previewThumbnails = null),
                t.config.previewThumbnails.enabled && (t.previewThumbnails = new xt(t))),
                t.fullscreen.update()
            }
            ), !0)) : this.debug.warn("Invalid source format")
        }
    };
    var Lt, Ot = function() {
        function e(n, i) {
            var r = this;
            if (t(this, e),
            a(this, "play", (function() {
                return $(r.media.play) ? (r.ads && r.ads.enabled && r.ads.managerPromise.then((function() {
                    return r.ads.play()
                }
                )).catch((function() {
                    return qe(r.media.play())
                }
                )),
                r.media.play()) : null
            }
            )),
            a(this, "pause", (function() {
                return r.playing && $(r.media.pause) ? r.media.pause() : null
            }
            )),
            a(this, "togglePlay", (function(e) {
                return (X(e) ? e : !r.playing) ? r.play() : r.pause()
            }
            )),
            a(this, "stop", (function() {
                r.isHTML5 ? (r.pause(),
                r.restart()) : $(r.media.stop) && r.media.stop()
            }
            )),
            a(this, "restart", (function() {
                r.currentTime = 0
            }
            )),
            a(this, "rewind", (function(e) {
                r.currentTime -= Y(e) ? e : r.config.seekTime
            }
            )),
            a(this, "forward", (function(e) {
                r.currentTime += Y(e) ? e : r.config.seekTime
            }
            )),
            a(this, "increaseVolume", (function(e) {
                var t = r.media.muted ? 0 : r.volume;
                r.volume = t + (Y(e) ? e : 0)
            }
            )),
            a(this, "decreaseVolume", (function(e) {
                r.increaseVolume(-e)
            }
            )),
            a(this, "airplay", (function() {
                Ne.airplay && r.media.webkitShowPlaybackTargetPicker()
            }
            )),
            a(this, "toggleControls", (function(e) {
                if (r.supported.ui && !r.isAudio) {
                    var t = ke(r.elements.container, r.config.classNames.hideControls)
                      , n = void 0 === e ? void 0 : !e
                      , i = we(r.elements.container, r.config.classNames.hideControls, n);
                    if (i && J(r.config.controls) && r.config.controls.includes("settings") && !re(r.config.settings) && at.toggleMenu.call(r, !1),
                    i !== t) {
                        var a = i ? "controlshidden" : "controlsshown";
                        _e.call(r, r.media, a)
                    }
                    return !i
                }
                return !1
            }
            )),
            a(this, "on", (function(e, t) {
                Ie.call(r, r.elements.container, e, t)
            }
            )),
            a(this, "once", (function(e, t) {
                Oe.call(r, r.elements.container, e, t)
            }
            )),
            a(this, "off", (function(e, t) {
                Le(r.elements.container, e, t)
            }
            )),
            a(this, "destroy", (function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (r.ready) {
                    var n = function() {
                        document.body.style.overflow = "",
                        r.embed = null,
                        t ? (Object.keys(r.elements).length && (fe(r.elements.buttons.play),
                        fe(r.elements.captions),
                        fe(r.elements.controls),
                        fe(r.elements.wrapper),
                        r.elements.buttons.play = null,
                        r.elements.captions = null,
                        r.elements.controls = null,
                        r.elements.wrapper = null),
                        $(e) && e()) : (je.call(r),
                        Be.cancelRequests.call(r),
                        ye(r.elements.original, r.elements.container),
                        _e.call(r, r.elements.original, "destroyed", !0),
                        $(e) && e.call(r.elements.original),
                        r.ready = !1,
                        setTimeout((function() {
                            r.elements = null,
                            r.media = null
                        }
                        ), 200))
                    };
                    r.stop(),
                    clearTimeout(r.timers.loading),
                    clearTimeout(r.timers.controls),
                    clearTimeout(r.timers.resized),
                    r.isHTML5 ? (bt.toggleNativeControls.call(r, !0),
                    n()) : r.isYouTube ? (clearInterval(r.timers.buffering),
                    clearInterval(r.timers.playing),
                    null !== r.embed && $(r.embed.destroy) && r.embed.destroy(),
                    n()) : r.isVimeo && (null !== r.embed && r.embed.unload().then(n),
                    setTimeout(n, 200))
                }
            }
            )),
            a(this, "supports", (function(e) {
                return Ne.mime.call(r, e)
            }
            )),
            this.timers = {},
            this.ready = !1,
            this.loading = !1,
            this.failed = !1,
            this.touch = Ne.touch,
            this.media = n,
            Q(this.media) && (this.media = document.querySelectorAll(this.media)),
            (window.jQuery && this.media instanceof jQuery || G(this.media) || J(this.media)) && (this.media = this.media[0]),
            this.config = ue({}, lt, e.defaults, i || {}, function() {
                try {
                    return JSON.parse(r.media.getAttribute("data-plyr-config"))
                } catch (e) {
                    return {}
                }
            }()),
            this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            },
            this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap
            },
            this.fullscreen = {
                active: !1
            },
            this.options = {
                speed: [],
                quality: []
            },
            this.debug = new ft(this.config.debug),
            this.debug.log("Config", this.config),
            this.debug.log("Support", Ne),
            !z(this.media) && Z(this.media))
                if (this.media.plyr)
                    this.debug.warn("Target already setup");
                else if (this.config.enabled)
                    if (Ne.check().api) {
                        var o = this.media.cloneNode(!0);
                        o.autoplay = !1,
                        this.elements.original = o;
                        var s = this.media.tagName.toLowerCase()
                          , l = null
                          , c = null;
                        switch (s) {
                        case "div":
                            if (l = this.media.querySelector("iframe"),
                            Z(l)) {
                                if (c = rt(l.getAttribute("src")),
                                this.provider = function(e) {
                                    return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? dt.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? dt.vimeo : null
                                }(c.toString()),
                                this.elements.container = this.media,
                                this.media = l,
                                this.elements.container.className = "",
                                c.search.length) {
                                    var u = ["1", "true"];
                                    u.includes(c.searchParams.get("autoplay")) && (this.config.autoplay = !0),
                                    u.includes(c.searchParams.get("loop")) && (this.config.loop.active = !0),
                                    this.isYouTube ? (this.config.playsinline = u.includes(c.searchParams.get("playsinline")),
                                    this.config.youtube.hl = c.searchParams.get("hl")) : this.config.playsinline = !0
                                }
                            } else
                                this.provider = this.media.getAttribute(this.config.attributes.embed.provider),
                                this.media.removeAttribute(this.config.attributes.embed.provider);
                            if (re(this.provider) || !Object.values(dt).includes(this.provider))
                                return void this.debug.error("Setup failed: Invalid provider");
                            this.type = mt;
                            break;
                        case "video":
                        case "audio":
                            this.type = s,
                            this.provider = dt.html5,
                            this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0),
                            this.media.hasAttribute("autoplay") && (this.config.autoplay = !0),
                            (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0),
                            this.media.hasAttribute("muted") && (this.config.muted = !0),
                            this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                            break;
                        default:
                            return void this.debug.error("Setup failed: unsupported type")
                        }
                        this.supported = Ne.check(this.type, this.provider, this.config.playsinline),
                        this.supported.api ? (this.eventListeners = [],
                        this.listeners = new vt(this),
                        this.storage = new Je(this),
                        this.media.plyr = this,
                        Z(this.elements.container) || (this.elements.container = me("div", {
                            tabindex: 0
                        }),
                        de(this.media, this.elements.container)),
                        bt.migrateStyles.call(this),
                        bt.addStyleHook.call(this),
                        Et.setup.call(this),
                        this.config.debug && Ie.call(this, this.elements.container, this.config.events.join(" "), (function(e) {
                            r.debug.log("event: ".concat(e.type))
                        }
                        )),
                        this.fullscreen = new gt(this),
                        (this.isHTML5 || this.isEmbed && !this.supported.ui) && bt.build.call(this),
                        this.listeners.container(),
                        this.listeners.global(),
                        this.config.ads.enabled && (this.ads = new Nt(this)),
                        this.isHTML5 && this.config.autoplay && this.once("canplay", (function() {
                            return qe(r.play())
                        }
                        )),
                        this.lastSeekTime = 0,
                        this.config.previewThumbnails.enabled && (this.previewThumbnails = new xt(this))) : this.debug.error("Setup failed: no support")
                    } else
                        this.debug.error("Setup failed: no support");
                else
                    this.debug.error("Setup failed: disabled by config");
            else
                this.debug.error("Setup failed: no suitable element passed")
        }
        return i(e, [{
            key: "toggleCaptions",
            value: function(e) {
                st.toggle.call(this, e, !1)
            }
        }, {
            key: "isHTML5",
            get: function() {
                return this.provider === dt.html5
            }
        }, {
            key: "isEmbed",
            get: function() {
                return this.isYouTube || this.isVimeo
            }
        }, {
            key: "isYouTube",
            get: function() {
                return this.provider === dt.youtube
            }
        }, {
            key: "isVimeo",
            get: function() {
                return this.provider === dt.vimeo
            }
        }, {
            key: "isVideo",
            get: function() {
                return this.type === mt
            }
        }, {
            key: "isAudio",
            get: function() {
                return this.type === ht
            }
        }, {
            key: "playing",
            get: function() {
                return Boolean(this.ready && !this.paused && !this.ended)
            }
        }, {
            key: "paused",
            get: function() {
                return Boolean(this.media.paused)
            }
        }, {
            key: "stopped",
            get: function() {
                return Boolean(this.paused && 0 === this.currentTime)
            }
        }, {
            key: "ended",
            get: function() {
                return Boolean(this.media.ended)
            }
        }, {
            key: "currentTime",
            set: function(e) {
                if (this.duration) {
                    var t = Y(e) && e > 0;
                    this.media.currentTime = t ? Math.min(e, this.duration) : 0,
                    this.debug.log("Seeking to ".concat(this.currentTime, " seconds"))
                }
            },
            get: function() {
                return Number(this.media.currentTime)
            }
        }, {
            key: "buffered",
            get: function() {
                var e = this.media.buffered;
                return Y(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0
            }
        }, {
            key: "seeking",
            get: function() {
                return Boolean(this.media.seeking)
            }
        }, {
            key: "duration",
            get: function() {
                var e = parseFloat(this.config.duration)
                  , t = (this.media || {}).duration
                  , n = Y(t) && t !== 1 / 0 ? t : 0;
                return e || n
            }
        }, {
            key: "volume",
            set: function(e) {
                var t = e;
                Q(t) && (t = Number(t)),
                Y(t) || (t = this.storage.get("volume")),
                Y(t) || (t = this.config.volume),
                t > 1 && (t = 1),
                t < 0 && (t = 0),
                this.config.volume = t,
                this.media.volume = t,
                !re(e) && this.muted && t > 0 && (this.muted = !1)
            },
            get: function() {
                return Number(this.media.volume)
            }
        }, {
            key: "muted",
            set: function(e) {
                var t = e;
                X(t) || (t = this.storage.get("muted")),
                X(t) || (t = this.config.muted),
                this.config.muted = t,
                this.media.muted = t
            },
            get: function() {
                return Boolean(this.media.muted)
            }
        }, {
            key: "hasAudio",
            get: function() {
                return !this.isHTML5 || (!!this.isAudio || (Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length)))
            }
        }, {
            key: "speed",
            set: function(e) {
                var t = this
                  , n = null;
                Y(e) && (n = e),
                Y(n) || (n = this.storage.get("speed")),
                Y(n) || (n = this.config.speed.selected);
                var i = this.minimumSpeed
                  , a = this.maximumSpeed;
                n = function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0
                      , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0
                      , n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 255;
                    return Math.min(Math.max(e, t), n)
                }(n, i, a),
                this.config.speed.selected = n,
                setTimeout((function() {
                    t.media.playbackRate = n
                }
                ), 0)
            },
            get: function() {
                return Number(this.media.playbackRate)
            }
        }, {
            key: "minimumSpeed",
            get: function() {
                return this.isYouTube ? Math.min.apply(Math, c(this.options.speed)) : this.isVimeo ? .5 : .0625
            }
        }, {
            key: "maximumSpeed",
            get: function() {
                return this.isYouTube ? Math.max.apply(Math, c(this.options.speed)) : this.isVimeo ? 2 : 16
            }
        }, {
            key: "quality",
            set: function(e) {
                var t = this.config.quality
                  , n = this.options.quality;
                if (n.length) {
                    var i = [!re(e) && Number(e), this.storage.get("quality"), t.selected, t.default].find(Y)
                      , a = !0;
                    if (!n.includes(i)) {
                        var r = function(e, t) {
                            return J(e) && e.length ? e.reduce((function(e, n) {
                                return Math.abs(n - t) < Math.abs(e - t) ? n : e
                            }
                            )) : null
                        }(n, i);
                        this.debug.warn("Unsupported quality option: ".concat(i, ", using ").concat(r, " instead")),
                        i = r,
                        a = !1
                    }
                    t.selected = i,
                    this.media.quality = i,
                    a && this.storage.set({
                        quality: i
                    })
                }
            },
            get: function() {
                return this.media.quality
            }
        }, {
            key: "loop",
            set: function(e) {
                var t = X(e) ? e : this.config.loop.active;
                this.config.loop.active = t,
                this.media.loop = t
            },
            get: function() {
                return Boolean(this.media.loop)
            }
        }, {
            key: "source",
            set: function(e) {
                It.change.call(this, e)
            },
            get: function() {
                return this.media.currentSrc
            }
        }, {
            key: "download",
            get: function() {
                var e = this.config.urls.download;
                return ae(e) ? e : this.source
            },
            set: function(e) {
                ae(e) && (this.config.urls.download = e,
                at.setDownloadUrl.call(this))
            }
        }, {
            key: "poster",
            set: function(e) {
                this.isVideo ? bt.setPoster.call(this, e, !1).catch((function() {}
                )) : this.debug.warn("Poster can only be set for video")
            },
            get: function() {
                return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null
            }
        }, {
            key: "ratio",
            get: function() {
                if (!this.isVideo)
                    return null;
                var e = Fe(Re.call(this));
                return J(e) ? e.join(":") : e
            },
            set: function(e) {
                this.isVideo ? Q(e) && He(e) ? (this.config.ratio = e,
                Ve.call(this)) : this.debug.error("Invalid aspect ratio specified (".concat(e, ")")) : this.debug.warn("Aspect ratio can only be set for video")
            }
        }, {
            key: "autoplay",
            set: function(e) {
                var t = X(e) ? e : this.config.autoplay;
                this.config.autoplay = t
            },
            get: function() {
                return Boolean(this.config.autoplay)
            }
        }, {
            key: "currentTrack",
            set: function(e) {
                st.set.call(this, e, !1)
            },
            get: function() {
                var e = this.captions
                  , t = e.toggled
                  , n = e.currentTrack;
                return t ? n : -1
            }
        }, {
            key: "language",
            set: function(e) {
                st.setLanguage.call(this, e, !1)
            },
            get: function() {
                return (st.getCurrentTrack.call(this) || {}).language
            }
        }, {
            key: "pip",
            set: function(e) {
                if (Ne.pip) {
                    var t = X(e) ? e : !this.pip;
                    $(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? ct : ut),
                    $(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture())
                }
            },
            get: function() {
                return Ne.pip ? re(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === ct : null
            }
        }], [{
            key: "supported",
            value: function(e, t, n) {
                return Ne.check(e, t, n)
            }
        }, {
            key: "loadSprite",
            value: function(e, t) {
                return Ze(e, t)
            }
        }, {
            key: "setup",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
                  , i = null;
                return Q(t) ? i = Array.from(document.querySelectorAll(t)) : G(t) ? i = Array.from(t) : J(t) && (i = t.filter(Z)),
                re(i) ? null : i.map((function(t) {
                    return new e(t,n)
                }
                ))
            }
        }]),
        e
    }();
    return Ot.defaults = (Lt = lt,
    JSON.parse(JSON.stringify(Lt))),
    Ot
}
));

/*
 * jQuery Open/Close plugin
 */
;(function($) {
    function OpenClose(options) {
        this.options = $.extend({
            addClassBeforeAnimation: true,
            hideOnClickOutside: false,
            activeClass: 'active',
            opener: '.opener',
            slider: '.slide',
            animSpeed: 400,
            effect: 'fade',
            event: 'click'
        }, options);
        this.init();
    }
    OpenClose.prototype = {
        init: function() {
            if (this.options.holder) {
                this.findElements();
                this.attachEvents();
                this.makeCallback('onInit', this);
            }
        },
        findElements: function() {
            this.holder = $(this.options.holder);
            this.opener = this.holder.find(this.options.opener);
            this.slider = this.holder.find(this.options.slider);
        },
        attachEvents: function() {
            // add handler
            var self = this;
            this.eventHandler = function(e) {
                e.preventDefault();
                if (self.slider.hasClass(slideHiddenClass)) {
                    self.showSlide();
                } else {
                    self.hideSlide();
                }
            }
            ;
            self.opener.on(self.options.event, this.eventHandler);

            // hover mode handler
            if (self.options.event === 'hover') {
                self.opener.on('mouseenter', function() {
                    if (!self.holder.hasClass(self.options.activeClass)) {
                        self.showSlide();
                    }
                });
                self.holder.on('mouseleave', function() {
                    self.hideSlide();
                });
            }

            // outside click handler
            self.outsideClickHandler = function(e) {
                if (self.options.hideOnClickOutside) {
                    var target = $(e.target);
                    if (!target.is(self.holder) && !target.closest(self.holder).length) {
                        self.hideSlide();
                    }
                }
            }
            ;

            // set initial styles
            if (this.holder.hasClass(this.options.activeClass)) {
                $(document).on('click touchstart', self.outsideClickHandler);
            } else {
                this.slider.addClass(slideHiddenClass);
            }
        },
        showSlide: function() {
            var self = this;
            if (self.options.addClassBeforeAnimation) {
                self.holder.addClass(self.options.activeClass);
            }
            self.slider.removeClass(slideHiddenClass);
            $(document).on('click touchstart', self.outsideClickHandler);

            self.makeCallback('animStart', true);
            toggleEffects[self.options.effect].show({
                box: self.slider,
                speed: self.options.animSpeed,
                complete: function() {
                    if (!self.options.addClassBeforeAnimation) {
                        self.holder.addClass(self.options.activeClass);
                    }
                    self.makeCallback('animEnd', true);
                }
            });
        },
        hideSlide: function() {
            var self = this;
            if (self.options.addClassBeforeAnimation) {
                self.holder.removeClass(self.options.activeClass);
            }
            $(document).off('click touchstart', self.outsideClickHandler);

            self.makeCallback('animStart', false);
            toggleEffects[self.options.effect].hide({
                box: self.slider,
                speed: self.options.animSpeed,
                complete: function() {
                    if (!self.options.addClassBeforeAnimation) {
                        self.holder.removeClass(self.options.activeClass);
                    }
                    self.slider.addClass(slideHiddenClass);
                    self.makeCallback('animEnd', false);
                }
            });
        },
        destroy: function() {
            this.slider.removeClass(slideHiddenClass).css({
                display: ''
            });
            this.opener.off(this.options.event, this.eventHandler);
            this.holder.removeClass(this.options.activeClass).removeData('OpenClose');
            $(document).off('click touchstart', this.outsideClickHandler);
        },
        makeCallback: function(name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        }
    };

    // add stylesheet for slide on DOMReady
    var slideHiddenClass = 'js-slide-hidden';
    (function() {
        var tabStyleSheet = $('<style type="text/css">')[0];
        var tabStyleRule = '.' + slideHiddenClass;
        tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}';
        if (tabStyleSheet.styleSheet) {
            tabStyleSheet.styleSheet.cssText = tabStyleRule;
        } else {
            tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
        }
        $('head').append(tabStyleSheet);
    }());

    // animation effects
    var toggleEffects = {
        slide: {
            show: function(o) {
                o.box.stop(true).hide().slideDown(o.speed, o.complete);
            },
            hide: function(o) {
                o.box.stop(true).slideUp(o.speed, o.complete);
            }
        },
        fade: {
            show: function(o) {
                o.box.stop(true).hide().fadeIn(o.speed, o.complete);
            },
            hide: function(o) {
                o.box.stop(true).fadeOut(o.speed, o.complete);
            }
        },
        none: {
            show: function(o) {
                o.box.hide().show(0, o.complete);
            },
            hide: function(o) {
                o.box.hide(0, o.complete);
            }
        }
    };

    // jQuery plugin interface
    $.fn.openClose = function(opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function() {
            var $holder = jQuery(this);
            var instance = $holder.data('OpenClose');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $holder.data('OpenClose', new OpenClose($.extend({
                    holder: this
                }, opt)));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    }
    ;
}(jQuery));

/*
 * Add Class on focusthis.blurHandler
 */
;(function($) {
    function AddFocusClass(options) {
        this.options = $.extend({
            container: null,
            element: ':input',
            focusClass: 'focus',
            stayFocusOnFilled: false
        }, options);
        this.initStructure();
        this.attachEvents();
    }

    AddFocusClass.prototype = {
        initStructure: function() {
            this.container = $(this.options.container);
            this.element = this.container.find(this.options.element);
        },
        attachEvents: function() {
            var self = this;
            this.focusHandler = function() {
                self.container.addClass(self.options.focusClass);
            }
            ;
            this.blurHandler = function() {
                setTimeout(function() {
                    if (self.options.stayFocusOnFilled) {
                        if (self.element.prop('tagName') !== 'SELECT') {
                            self.container.toggleClass(self.options.focusClass, !!self.element.val().trim().length);
                        }
                    } else {
                        self.container.removeClass(self.options.focusClass);
                    }
                }, 0);
            }
            ;
            this.blurHandler();
            this.element.on({
                focus: this.focusHandler,
                blur: this.blurHandler
            });
        },
        destroy: function() {
            this.container.removeClass(this.options.focusClass);
            this.element.off({
                focus: this.focusHandler,
                blur: this.blurHandler
            });
        }
    };

    $.fn.addFocusClass = function(options) {
        return this.each(function() {
            var params = $.extend({}, options, {
                container: this
            })
              , instance = new AddFocusClass(params);
            $.data(this, 'AddFocusClass', instance);
        });
    }
    ;
}(jQuery));

/*
 * jQuery form validation plugin
 */
;(function($) {
    'use strict';

    var FormValidation = (function() {
        var Validator = function($field, $fields) {
            this.$field = $field;
            this.$fields = $fields;
        };

        Validator.prototype = {
            reg: {
                email: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
                number: '^[0-9]+$'
            },

            checkField: function() {
                return {
                    state: this.run(),
                    $fields: this.$field.add(this.additionalFields)
                }
            },

            run: function() {
                var fieldType;

                switch (this.$field.get(0).tagName.toUpperCase()) {
                case 'SELECT':
                    fieldType = 'select';
                    break;

                case 'TEXTAREA':
                    fieldType = 'text';
                    break;

                default:
                    fieldType = this.$field.data('type') || this.$field.attr('type');
                }

                var functionName = 'check_' + fieldType.replace(/-/g, '_');
                var state = true;

                if ($.isFunction(this[functionName])) {
                    state = this[functionName]();

                    if (state && this.$field.data('confirm')) {
                        state = this.check_confirm();
                    }
                }

                return state;
            },

            check_email: function() {
                var value = this.getValue();
                var required = this.$field.data('required');
                var requiredOrValue = required || value.length;

                if ((requiredOrValue && !this.check_regexp(value, this.reg.email))) {
                    return false;
                }

                return requiredOrValue ? true : null;
            },

            check_number: function() {
                var value = this.getValue();
                var required = this.$field.data('required');
                var isNumber = this.check_regexp(value, this.reg.number);
                var requiredOrValue = required || value.length;

                if (requiredOrValue && !isNumber) {
                    return false;
                }

                var min = this.$field.data('min');
                var max = this.$field.data('max');
                value = +value;

                if ((min && (value < min || !isNumber)) || (max && (value > max || !isNumber))) {
                    return false;
                }

                return (requiredOrValue || min || max) ? true : null;
            },

            check_password: function() {
                return this.check_text();
            },

            check_text: function() {
                var value = this.getValue();
                var required = this.$field.data('required');

                if (this.$field.data('required') && !value.length) {
                    return false;
                }

                var min = +this.$field.data('min');
                var max = +this.$field.data('max');

                if ((min && value.length < min) || (max && value.length > max)) {
                    return false;
                }

                var regExp = this.$field.data('regexp');

                if (regExp && !this.check_regexp(value, regExp)) {
                    return false;
                }

                return (required || min || max || regExp) ? true : null;
            },

            check_confirm: function() {
                var value = this.getValue();
                var $confirmFields = this.$fields.filter('[data-confirm="' + this.$field.data('confirm') + '"]');
                var confirmState = true;

                for (var i = $confirmFields.length - 1; i >= 0; i--) {
                    if ($confirmFields.eq(i).val() !== value || !value.length) {
                        confirmState = false;
                        break;
                    }
                }

                this.additionalFields = $confirmFields;

                return confirmState;
            },

            check_select: function() {
                var required = this.$field.data('required');

                if (required && this.$field.get(0).selectedIndex === 0) {
                    return false;
                }

                return required ? true : null;
            },

            check_radio: function() {
                var $fields = this.$fields.filter('[name="' + this.$field.attr('name') + '"]');
                var required = this.$field.data('required');

                if (required && !$fields.filter(':checked').length) {
                    return false;
                }

                this.additionalFields = $fields;

                return required ? true : null;
            },

            check_checkbox: function() {
                var required = this.$field.data('required');

                if (required && !this.$field.prop('checked')) {
                    return false;
                }

                return required ? true : null;
            },

            check_at_least_one: function() {
                var $fields = this.$fields.filter('[data-name="' + this.$field.data('name') + '"]');

                if (!$fields.filter(':checked').length) {
                    return false;
                }

                this.additionalFields = $fields;

                return true;
            },

            check_regexp: function(val, exp) {
                return new RegExp(exp).test(val);
            },

            getValue: function() {
                if (this.$field.data('trim')) {
                    this.$field.val($.trim(this.$field.val()));
                }

                return this.$field.val();
            }
        };

        var publicClass = function(form, options) {
            this.$form = $(form).attr('novalidate', 'novalidate');
            this.options = options;
        };

        publicClass.prototype = {
            buildSelector: function(input) {
                return input + ':not(' + this.options.skipDefaultFields + (this.options.skipFields ? ',' + this.options.skipFields : '') + ')';
            },

            init: function() {
                this.fieldsSelector = this.buildSelector(':input');

                this.$form.on('submit', this.submitHandler.bind(this)).on('keyup blur', this.fieldsSelector, this.changeHandler.bind(this)).on('change', this.buildSelector('select'), this.changeHandler.bind(this)).on('focus', this.fieldsSelector, this.focusHandler.bind(this));
            },

            submitHandler: function(e) {
                var self = this;
                var $fields = this.getFormFields();

                this.getClassTarget($fields).removeClass(this.options.errorClass + ' ' + this.options.successClass);

                this.setFormState(true);

                $fields.each(function(i, input) {
                    var $field = $(input);
                    var $classTarget = self.getClassTarget($field);

                    // continue iteration if $field has error class already
                    if ($classTarget.hasClass(self.options.errorClass)) {
                        return;
                    }

                    self.setState(new Validator($field,$fields).checkField());
                });

                return this.checkSuccess($fields, e);
            },

            checkSuccess: function($fields, e) {
                var self = this;
                var success = this.getClassTarget($fields || this.getFormFields()).filter('.' + this.options.errorClass).length === 0;

                if (e && success && this.options.successSendClass) {
                    e.preventDefault();

                    $.ajax({
                        url: this.$form.removeClass(this.options.successSendClass).attr('action') || '/',
                        type: this.$form.attr('method') || 'POST',
                        data: this.$form.serialize(),
                        success: function() {
                            self.$form.addClass(self.options.successSendClass);
                        }
                    });
                }

                this.setFormState(success);

                return success;
            },

            changeHandler: function(e) {
                var $field = $(e.target);

                if ($field.data('interactive')) {
                    this.setState(new Validator($field,this.getFormFields()).checkField());
                }

                this.checkSuccess();
            },

            focusHandler: function(e) {
                var $field = $(e.target);

                this.getClassTarget($field).removeClass(this.options.errorClass + ' ' + this.options.successClass);

                this.checkSuccess();
            },

            setState: function(result) {
                this.getClassTarget(result.$fields).toggleClass(this.options.errorClass, result.state !== null && !result.state).toggleClass(this.options.successClass, result.state !== null && this.options.successClass && !!result.state);
            },

            setFormState: function(state) {
                if (this.options.errorFormClass) {
                    this.$form.toggleClass(this.options.errorFormClass, !state);
                }
            },

            getClassTarget: function($input) {
                return (this.options.addClassToParent ? $input.closest(this.options.addClassToParent) : $input);
            },

            getFormFields: function() {
                return this.$form.find(this.fieldsSelector);
            }
        };

        return publicClass;
    }());

    $.fn.formValidation = function(options) {
        options = $.extend({}, {
            errorClass: 'input-error',
            successClass: '',
            errorFormClass: '',
            addClassToParent: '',
            skipDefaultFields: ':button, :submit, :image, :hidden, :reset',
            skipFields: '',
            successSendClass: ''
        }, options);

        return this.each(function() {
            new FormValidation(this,options).init();
        });
    }
    ;
}(jQuery));

(function($) {
    $.fn.extend({
        passwordValidation: function(_options, _callback, _confirmcallback) {
            //var _unicodeSpecialSet = "^\\x00-\\x1F\\x7F\\x80-\\x9F0-9A-Za-z"; //All chars other than above (and C0/C1)
            var CHARSETS = {
                upperCaseSet: "A-Z",
                //All UpperCase (Acii/Unicode)
                lowerCaseSet: "a-z",
                //All LowerCase (Acii/Unicode)
                digitSet: "0-9",
                //All digits (Acii/Unicode)
                specialSet: "\\x20-\\x2F\\x3A-\\x40\\x5B-\\x60\\x7B-\\x7E\\x80-\\xFF",
                //All Other printable Ascii
            }
            var _defaults = {
                minLength: 8,
                //Minimum Length of password
                minUpperCase: 1,
                //Minimum number of Upper Case Letters characters in password
                minLowerCase: 1,
                //Minimum number of Lower Case Letters characters in password
                minDigits: 1,
                //Minimum number of digits characters in password
                minSpecial: false,
                //Minimum number of special characters in password
                maxRepeats: 5,
                //Maximum number of repeated alphanumeric characters in password dhgurAAAfjewd <- 3 A's
                maxConsecutive: 3,
                //Maximum number of alphanumeric characters from one set back to back
                noUpper: false,
                //Disallow Upper Case Lettera
                noLower: false,
                //Disallow Lower Case Letters
                noDigit: false,
                //Disallow Digits
                noSpecial: false,
                //Disallow Special Characters
                //NOT IMPLEMENTED YET allowUnicode: false,  //Switches Ascii Special Set out for Unicode Special Set
                failRepeats: true,
                //Disallow user to have x number of repeated alphanumeric characters ex.. ..A..a..A.. <- fails if maxRepeats <= 3 CASE INSENSITIVE
                failConsecutive: true,
                //Disallow user to have x number of consecutive alphanumeric characters from any set ex.. abc <- fails if maxConsecutive <= 3
                confirmField: undefined
            };

            //Ensure parameters are correctly defined
            if ($.isFunction(_options)) {
                if ($.isFunction(_callback)) {
                    if ($.isFunction(_confirmcallback)) {
                        console.log("Warning in passValidate: 3 or more callbacks were defined... First two will be used.");
                    }
                    _confirmcallback = _callback;
                }
                _callback = _options;
                _options = {};
            }

            //concatenate user options with _defaults
            _options = $.extend(_defaults, _options);
            if (_options.maxRepeats < 2)
                _options.maxRepeats = 2;

            function charsetToString() {
                return CHARSETS.upperCaseSet + CHARSETS.lowerCaseSet + CHARSETS.digitSet + CHARSETS.specialSet;
            }

            //GENERATE ALL REGEXs FOR EVERY CASE
            function buildPasswordRegex() {
                var cases = [];

                //if(_options.allowUnicode) CHARSETS.specialSet = _unicodeSpecialSet;
                if (_options.noUpper)
                    cases.push({
                        "regex": "(?=" + CHARSETS.upperCaseSet + ")",
                        "message": "Password can't contain an Upper Case Letter"
                    });
                else
                    cases.push({
                        "regex": "(?=" + ("[" + CHARSETS.upperCaseSet + "][^" + CHARSETS.upperCaseSet + "]*").repeat(_options.minUpperCase) + ")",
                        "message": "Password must contain at least " + _options.minUpperCase + " Cap letter"
                    });
                if (_options.noLower)
                    cases.push({
                        "regex": "(?=" + CHARSETS.lowerCaseSet + ")",
                        "message": "Password can't contain a Lower Case Letter"
                    });
                else
                    cases.push({
                        "regex": "(?=" + ("[" + CHARSETS.lowerCaseSet + "][^" + CHARSETS.lowerCaseSet + "]*").repeat(_options.minLowerCase) + ")",
                        "message": "Password must contain at least " + _options.minLowerCase + " lower-case letter"
                    });
                if (_options.noDigit)
                    cases.push({
                        "regex": "(?=" + CHARSETS.digitSet + ")",
                        "message": "Password can't contain a Number"
                    });
                else
                    cases.push({
                        "regex": "(?=" + ("[" + CHARSETS.digitSet + "][^" + CHARSETS.digitSet + "]*").repeat(_options.minDigits) + ")",
                        "message": "Password must contain at least " + _options.minDigits + " number"
                    });
                if (_options.noSpecial)
                    cases.push({
                        "regex": "(?=" + CHARSETS.specialSet + ")",
                        "message": "Password can't contain a Special Character"
                    });
                else
                    cases.push({
                        "regex": "(?=" + ("[" + CHARSETS.specialSet + "][^" + CHARSETS.specialSet + "]*").repeat(_options.minSpecial) + ")",
                        "message": "Password must contain at least " + _options.minSpecial + " Special Characters."
                    });

                cases.push({
                    "regex": "[" + charsetToString() + "]{" + _options.minLength + ",}",
                    "message": "Password must contain at least " + _options.minLength + " characters."
                });

                return cases;
            }
            var _cases = buildPasswordRegex();

            var _element = this;
            var $confirmField = (_options.confirmField != undefined) ? $(_options.confirmField) : undefined;

            //Field validation on every captured event
            function validateField() {
                var failedCases = [];

                //Evaluate all verbose cases
                $.each(_cases, function(i, _case) {
                    if ($(_element).val().search(new RegExp(_case.regex,"g")) == -1) {
                        failedCases.push(_case.message);
                    }
                });
                if (_options.failRepeats && $(_element).val().search(new RegExp("(.)" + (".*\\1").repeat(_options.maxRepeats - 1),"gi")) != -1) {
                    failedCases.push("Password can not contain " + _options.maxRepeats + " of the same character case insensitive.");
                }
                if (_options.failConsecutive && $(_element).val().search(new RegExp("(?=(.)" + ("\\1").repeat(_options.maxConsecutive) + ")","g")) != -1) {
                    failedCases.push("Password can't contain the same character more than " + _options.maxConsecutive + " times in a row.");
                }

                //Determine if valid
                var validPassword = (failedCases.length == 0) && ($(_element).val().length >= _options.minLength);
                var fieldsMatch = true;
                if ($confirmField != undefined) {
                    fieldsMatch = ($confirmField.val() == $(_element).val());
                }

                _callback(_element, validPassword, validPassword && fieldsMatch, failedCases);
            }

            //Add custom classes to fields
            this.each(function() {
                //Validate field if it is already filled
                if ($(this).val()) {
                    validateField().apply(this);
                }

                $(this).toggleClass("jqPassField", true);
                if ($confirmField != undefined) {
                    $confirmField.toggleClass("jqPassConfirmField", true);
                }
            });

            //Add event bindings to the password fields
            return this.each(function() {
                $(this).bind('keyup focus input proprtychange mouseup', validateField);
                if ($confirmField != undefined) {
                    $confirmField.bind('keyup focus input proprtychange mouseup', validateField);
                }
            });
        }
    });
}
)(jQuery);

/*!
 * JavaScript Custom Forms
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
;(function(root, factory) {

    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.jcf = factory(jQuery);
    }
}(this, function($) {

    'use strict';

    // define version
    var version = '1.1.3';

    // private variables
    var customInstances = [];

    // default global options
    var commonOptions = {
        optionsKey: 'jcf',
        dataKey: 'jcf-instance',
        rtlClass: 'jcf-rtl',
        focusClass: 'jcf-focus',
        pressedClass: 'jcf-pressed',
        disabledClass: 'jcf-disabled',
        hiddenClass: 'jcf-hidden',
        resetAppearanceClass: 'jcf-reset-appearance',
        unselectableClass: 'jcf-unselectable'
    };

    // detect device type
    var isTouchDevice = ('ontouchstart'in window) || window.DocumentTouch && document instanceof window.DocumentTouch
      , isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent);
    commonOptions.isMobileDevice = !!(isTouchDevice || isWinPhoneDevice);

    var isIOS = /(iPad|iPhone).*OS ([0-9_]*) .*/.exec(navigator.userAgent);
    if (isIOS)
        isIOS = parseFloat(isIOS[2].replace(/_/g, '.'));
    commonOptions.ios = isIOS;

    // create global stylesheet if custom forms are used
    var createStyleSheet = function() {
        var styleTag = $('<style>').appendTo('head')
          , styleSheet = styleTag.prop('sheet') || styleTag.prop('styleSheet');

        // crossbrowser style handling
        var addCSSRule = function(selector, rules, index) {
            if (styleSheet.insertRule) {
                styleSheet.insertRule(selector + '{' + rules + '}', index);
            } else {
                styleSheet.addRule(selector, rules, index);
            }
        };

        // add special rules
        addCSSRule('.' + commonOptions.hiddenClass, 'position:absolute !important;left:-9999px !important;height:1px !important;width:1px !important;margin:0 !important;border-width:0 !important;-webkit-appearance:none;-moz-appearance:none;appearance:none');
        addCSSRule('.' + commonOptions.rtlClass + ' .' + commonOptions.hiddenClass, 'right:-9999px !important; left: auto !important');
        addCSSRule('.' + commonOptions.unselectableClass, '-webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-tap-highlight-color: rgba(0,0,0,0);');
        addCSSRule('.' + commonOptions.resetAppearanceClass, 'background: none; border: none; -webkit-appearance: none; appearance: none; opacity: 0; filter: alpha(opacity=0);');

        // detect rtl pages
        var html = $('html')
          , body = $('body');
        if (html.css('direction') === 'rtl' || body.css('direction') === 'rtl') {
            html.addClass(commonOptions.rtlClass);
        }

        // handle form reset event
        html.on('reset', function() {
            setTimeout(function() {
                api.refreshAll();
            }, 0);
        });

        // mark stylesheet as created
        commonOptions.styleSheetCreated = true;
    };

    // simplified pointer events handler
    (function() {
        var pointerEventsSupported = navigator.pointerEnabled || navigator.msPointerEnabled, touchEventsSupported = ('ontouchstart'in window) || window.DocumentTouch && document instanceof window.DocumentTouch, eventList, eventMap = {}, eventPrefix = 'jcf-';

        // detect events to attach
        if (pointerEventsSupported) {
            eventList = {
                pointerover: navigator.pointerEnabled ? 'pointerover' : 'MSPointerOver',
                pointerdown: navigator.pointerEnabled ? 'pointerdown' : 'MSPointerDown',
                pointermove: navigator.pointerEnabled ? 'pointermove' : 'MSPointerMove',
                pointerup: navigator.pointerEnabled ? 'pointerup' : 'MSPointerUp'
            };
        } else {
            eventList = {
                pointerover: 'mouseover',
                pointerdown: 'mousedown' + (touchEventsSupported ? ' touchstart' : ''),
                pointermove: 'mousemove' + (touchEventsSupported ? ' touchmove' : ''),
                pointerup: 'mouseup' + (touchEventsSupported ? ' touchend' : '')
            };
        }

        // create event map
        $.each(eventList, function(targetEventName, fakeEventList) {
            $.each(fakeEventList.split(' '), function(index, fakeEventName) {
                eventMap[fakeEventName] = targetEventName;
            });
        });

        // jQuery event hooks
        $.each(eventList, function(eventName, eventHandlers) {
            eventHandlers = eventHandlers.split(' ');
            $.event.special[eventPrefix + eventName] = {
                setup: function() {
                    var self = this;
                    $.each(eventHandlers, function(index, fallbackEvent) {
                        if (self.addEventListener)
                            self.addEventListener(fallbackEvent, fixEvent, false);
                        else
                            self['on' + fallbackEvent] = fixEvent;
                    });
                },
                teardown: function() {
                    var self = this;
                    $.each(eventHandlers, function(index, fallbackEvent) {
                        if (self.addEventListener)
                            self.removeEventListener(fallbackEvent, fixEvent, false);
                        else
                            self['on' + fallbackEvent] = null;
                    });
                }
            };
        });

        // check that mouse event are not simulated by mobile browsers
        var lastTouch = null;
        var mouseEventSimulated = function(e) {
            var dx = Math.abs(e.pageX - lastTouch.x)
              , dy = Math.abs(e.pageY - lastTouch.y)
              , rangeDistance = 25;

            if (dx <= rangeDistance && dy <= rangeDistance) {
                return true;
            }
        };

        // normalize event
        var fixEvent = function(e) {
            var origEvent = e || window.event
              , touchEventData = null
              , targetEventName = eventMap[origEvent.type];

            e = $.event.fix(origEvent);
            e.type = eventPrefix + targetEventName;

            if (origEvent.pointerType) {
                switch (origEvent.pointerType) {
                case 2:
                    e.pointerType = 'touch';
                    break;
                case 3:
                    e.pointerType = 'pen';
                    break;
                case 4:
                    e.pointerType = 'mouse';
                    break;
                default:
                    e.pointerType = origEvent.pointerType;
                }
            } else {
                e.pointerType = origEvent.type.substr(0, 5);
                // "mouse" or "touch" word length
            }

            if (!e.pageX && !e.pageY) {
                touchEventData = origEvent.changedTouches ? origEvent.changedTouches[0] : origEvent;
                e.pageX = touchEventData.pageX;
                e.pageY = touchEventData.pageY;
            }

            if (origEvent.type === 'touchend') {
                lastTouch = {
                    x: e.pageX,
                    y: e.pageY
                };
            }
            if (e.pointerType === 'mouse' && lastTouch && mouseEventSimulated(e)) {
                return;
            } else {
                return ($.event.dispatch || $.event.handle).call(this, e);
            }
        };
    }());

    // custom mousewheel/trackpad handler
    (function() {
        var wheelEvents = ('onwheel'in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll').split(' ')
          , shimEventName = 'jcf-mousewheel';

        $.event.special[shimEventName] = {
            setup: function() {
                var self = this;
                $.each(wheelEvents, function(index, fallbackEvent) {
                    if (self.addEventListener)
                        self.addEventListener(fallbackEvent, fixEvent, false);
                    else
                        self['on' + fallbackEvent] = fixEvent;
                });
            },
            teardown: function() {
                var self = this;
                $.each(wheelEvents, function(index, fallbackEvent) {
                    if (self.addEventListener)
                        self.removeEventListener(fallbackEvent, fixEvent, false);
                    else
                        self['on' + fallbackEvent] = null;
                });
            }
        };

        var fixEvent = function(e) {
            var origEvent = e || window.event;
            e = $.event.fix(origEvent);
            e.type = shimEventName;

            // old wheel events handler
            if ('detail'in origEvent) {
                e.deltaY = -origEvent.detail;
            }
            if ('wheelDelta'in origEvent) {
                e.deltaY = -origEvent.wheelDelta;
            }
            if ('wheelDeltaY'in origEvent) {
                e.deltaY = -origEvent.wheelDeltaY;
            }
            if ('wheelDeltaX'in origEvent) {
                e.deltaX = -origEvent.wheelDeltaX;
            }

            // modern wheel event handler
            if ('deltaY'in origEvent) {
                e.deltaY = origEvent.deltaY;
            }
            if ('deltaX'in origEvent) {
                e.deltaX = origEvent.deltaX;
            }

            // handle deltaMode for mouse wheel
            e.delta = e.deltaY || e.deltaX;
            if (origEvent.deltaMode === 1) {
                var lineHeight = 16;
                e.delta *= lineHeight;
                e.deltaY *= lineHeight;
                e.deltaX *= lineHeight;
            }

            return ($.event.dispatch || $.event.handle).call(this, e);
        };
    }());

    // extra module methods
    var moduleMixin = {
        // provide function for firing native events
        fireNativeEvent: function(elements, eventName) {
            $(elements).each(function() {
                var element = this, eventObject;
                if (element.dispatchEvent) {
                    eventObject = document.createEvent('HTMLEvents');
                    eventObject.initEvent(eventName, true, true);
                    element.dispatchEvent(eventObject);
                } else if (document.createEventObject) {
                    eventObject = document.createEventObject();
                    eventObject.target = element;
                    element.fireEvent('on' + eventName, eventObject);
                }
            });
        },
        // bind event handlers for module instance (functions beggining with "on")
        bindHandlers: function() {
            var self = this;
            $.each(self, function(propName, propValue) {
                if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
                    // dont use $.proxy here because it doesn't create unique handler
                    self[propName] = function() {
                        return propValue.apply(self, arguments);
                    }
                    ;
                }
            });
        }
    };

    // public API
    var api = {
        version: version,
        modules: {},
        getOptions: function() {
            return $.extend({}, commonOptions);
        },
        setOptions: function(moduleName, moduleOptions) {
            if (arguments.length > 1) {
                // set module options
                if (this.modules[moduleName]) {
                    $.extend(this.modules[moduleName].prototype.options, moduleOptions);
                }
            } else {
                // set common options
                $.extend(commonOptions, moduleName);
            }
        },
        addModule: function(proto) {
            // add module to list
            var Module = function(options) {
                // save instance to collection
                if (!options.element.data(commonOptions.dataKey)) {
                    options.element.data(commonOptions.dataKey, this);
                }
                customInstances.push(this);

                // save options
                this.options = $.extend({}, commonOptions, this.options, getInlineOptions(options.element), options);

                // bind event handlers to instance
                this.bindHandlers();

                // call constructor
                this.init.apply(this, arguments);
            };

            // parse options from HTML attribute
            var getInlineOptions = function(element) {
                var dataOptions = element.data(commonOptions.optionsKey)
                  , attrOptions = element.attr(commonOptions.optionsKey);

                if (dataOptions) {
                    return dataOptions;
                } else if (attrOptions) {
                    try {
                        return $.parseJSON(attrOptions);
                    } catch (e) {// ignore invalid attributes
                    }
                }
            };

            // set proto as prototype for new module
            Module.prototype = proto;

            // add mixin methods to module proto
            $.extend(proto, moduleMixin);
            if (proto.plugins) {
                $.each(proto.plugins, function(pluginName, plugin) {
                    $.extend(plugin.prototype, moduleMixin);
                });
            }

            // override destroy method
            var originalDestroy = Module.prototype.destroy;
            Module.prototype.destroy = function() {
                this.options.element.removeData(this.options.dataKey);

                for (var i = customInstances.length - 1; i >= 0; i--) {
                    if (customInstances[i] === this) {
                        customInstances.splice(i, 1);
                        break;
                    }
                }

                if (originalDestroy) {
                    originalDestroy.apply(this, arguments);
                }
            }
            ;

            // save module to list
            this.modules[proto.name] = Module;
        },
        getInstance: function(element) {
            return $(element).data(commonOptions.dataKey);
        },
        replace: function(elements, moduleName, customOptions) {
            var self = this, instance;

            if (!commonOptions.styleSheetCreated) {
                createStyleSheet();
            }

            $(elements).each(function() {
                var moduleOptions, element = $(this);

                instance = element.data(commonOptions.dataKey);
                if (instance) {
                    instance.refresh();
                } else {
                    if (!moduleName) {
                        $.each(self.modules, function(currentModuleName, module) {
                            if (module.prototype.matchElement.call(module.prototype, element)) {
                                moduleName = currentModuleName;
                                return false;
                            }
                        });
                    }
                    if (moduleName) {
                        moduleOptions = $.extend({
                            element: element
                        }, customOptions);
                        instance = new self.modules[moduleName](moduleOptions);
                    }
                }
            });
            return instance;
        },
        refresh: function(elements) {
            $(elements).each(function() {
                var instance = $(this).data(commonOptions.dataKey);
                if (instance) {
                    instance.refresh();
                }
            });
        },
        destroy: function(elements) {
            $(elements).each(function() {
                var instance = $(this).data(commonOptions.dataKey);
                if (instance) {
                    instance.destroy();
                }
            });
        },
        replaceAll: function(context) {
            var self = this;
            $.each(this.modules, function(moduleName, module) {
                $(module.prototype.selector, context).each(function() {
                    if (this.className.indexOf('jcf-ignore') < 0) {
                        self.replace(this, moduleName);
                    }
                });
            });
        },
        refreshAll: function(context) {
            if (context) {
                $.each(this.modules, function(moduleName, module) {
                    $(module.prototype.selector, context).each(function() {
                        var instance = $(this).data(commonOptions.dataKey);
                        if (instance) {
                            instance.refresh();
                        }
                    });
                });
            } else {
                for (var i = customInstances.length - 1; i >= 0; i--) {
                    customInstances[i].refresh();
                }
            }
        },
        destroyAll: function(context) {
            if (context) {
                $.each(this.modules, function(moduleName, module) {
                    $(module.prototype.selector, context).each(function(index, element) {
                        var instance = $(element).data(commonOptions.dataKey);
                        if (instance) {
                            instance.destroy();
                        }
                    });
                });
            } else {
                while (customInstances.length) {
                    customInstances[0].destroy();
                }
            }
        }
    };

    // always export API to the global window object
    window.jcf = api;

    return api;
}));

/*!
* JavaScript Custom Forms : Select Module
*
* Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
* Released under the MIT license (LICENSE.txt)
*
* Version: 1.1.3
*/
;(function($, window) {

    'use strict';

    jcf.addModule({
        name: 'Select',
        selector: 'select',
        options: {
            element: null,
            multipleCompactStyle: false
        },
        plugins: {
            ListBox: ListBox,
            ComboBox: ComboBox,
            SelectList: SelectList
        },
        matchElement: function(element) {
            return element.is('select');
        },
        init: function() {
            this.element = $(this.options.element);
            this.createInstance();
        },
        isListBox: function() {
            return this.element.is('[size]:not([jcf-size]), [multiple]');
        },
        createInstance: function() {
            if (this.instance) {
                this.instance.destroy();
            }
            if (this.isListBox() && !this.options.multipleCompactStyle) {
                this.instance = new ListBox(this.options);
            } else {
                this.instance = new ComboBox(this.options);
            }
        },
        refresh: function() {
            var typeMismatch = (this.isListBox() && this.instance instanceof ComboBox) || (!this.isListBox() && this.instance instanceof ListBox);

            if (typeMismatch) {
                this.createInstance();
            } else {
                this.instance.refresh();
            }
        },
        destroy: function() {
            this.instance.destroy();
        }
    });

    // combobox module
    function ComboBox(options) {
        this.options = $.extend({
            wrapNative: true,
            wrapNativeOnMobile: true,
            fakeDropInBody: true,
            useCustomScroll: true,
            flipDropToFit: true,
            maxVisibleItems: 10,
            fakeAreaStructure: '<span class="jcf-select"><span class="jcf-select-text"></span><span class="jcf-select-opener"></span></span>',
            fakeDropStructure: '<div class="jcf-select-drop"><div class="jcf-select-drop-content"></div></div>',
            optionClassPrefix: 'jcf-option-',
            selectClassPrefix: 'jcf-select-',
            dropContentSelector: '.jcf-select-drop-content',
            selectTextSelector: '.jcf-select-text',
            dropActiveClass: 'jcf-drop-active',
            flipDropClass: 'jcf-drop-flipped'
        }, options);
        this.init();
    }
    $.extend(ComboBox.prototype, {
        init: function() {
            this.initStructure();
            this.bindHandlers();
            this.attachEvents();
            this.refresh();
        },
        initStructure: function() {
            // prepare structure
            this.win = $(window);
            this.doc = $(document);
            this.realElement = $(this.options.element);
            this.fakeElement = $(this.options.fakeAreaStructure).insertAfter(this.realElement);
            this.selectTextContainer = this.fakeElement.find(this.options.selectTextSelector);
            this.selectText = $('<span></span>').appendTo(this.selectTextContainer);
            makeUnselectable(this.fakeElement);

            // copy classes from original select
            this.fakeElement.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));

            // handle compact multiple style
            if (this.realElement.prop('multiple')) {
                this.fakeElement.addClass('jcf-compact-multiple');
            }

            // detect device type and dropdown behavior
            if (this.options.isMobileDevice && this.options.wrapNativeOnMobile && !this.options.wrapNative) {
                this.options.wrapNative = true;
            }

            if (this.options.wrapNative) {
                // wrap native select inside fake block
                this.realElement.prependTo(this.fakeElement).css({
                    position: 'absolute',
                    height: '100%',
                    width: '100%'
                }).addClass(this.options.resetAppearanceClass);
            } else {
                // just hide native select
                this.realElement.addClass(this.options.hiddenClass);
                this.fakeElement.attr('title', this.realElement.attr('title'));
                this.fakeDropTarget = this.options.fakeDropInBody ? $('body') : this.fakeElement;
            }
        },
        attachEvents: function() {
            // delayed refresh handler
            var self = this;
            this.delayedRefresh = function() {
                setTimeout(function() {
                    self.refresh();
                    if (self.list) {
                        self.list.refresh();
                        self.list.scrollToActiveOption();
                    }
                }, 1);
            }
            ;

            // native dropdown event handlers
            if (this.options.wrapNative) {
                this.realElement.on({
                    focus: this.onFocus,
                    change: this.onChange,
                    click: this.onChange,
                    keydown: this.onChange
                });
            } else {
                // custom dropdown event handlers
                this.realElement.on({
                    focus: this.onFocus,
                    change: this.onChange,
                    keydown: this.onKeyDown
                });
                this.fakeElement.on({
                    'jcf-pointerdown': this.onSelectAreaPress
                });
            }
        },
        onKeyDown: function(e) {
            if (e.which === 13) {
                this.toggleDropdown();
            } else if (this.dropActive) {
                this.delayedRefresh();
            }
        },
        onChange: function() {
            this.refresh();
        },
        onFocus: function() {
            if (!this.pressedFlag || !this.focusedFlag) {
                this.fakeElement.addClass(this.options.focusClass);
                this.realElement.on('blur', this.onBlur);
                this.toggleListMode(true);
                this.focusedFlag = true;
            }
        },
        onBlur: function() {
            if (!this.pressedFlag) {
                this.fakeElement.removeClass(this.options.focusClass);
                this.realElement.off('blur', this.onBlur);
                this.toggleListMode(false);
                this.focusedFlag = false;
            }
        },
        onResize: function() {
            if (this.dropActive) {
                this.hideDropdown();
            }
        },
        onSelectDropPress: function() {
            this.pressedFlag = true;
        },
        onSelectDropRelease: function(e, pointerEvent) {
            this.pressedFlag = false;
            if (pointerEvent.pointerType === 'mouse') {
                this.realElement.focus();
            }
        },
        onSelectAreaPress: function(e) {
            // skip click if drop inside fake element or real select is disabled
            var dropClickedInsideFakeElement = !this.options.fakeDropInBody && $(e.target).closest(this.dropdown).length;
            if (dropClickedInsideFakeElement || e.button > 1 || this.realElement.is(':disabled')) {
                return;
            }

            // toggle dropdown visibility
            this.selectOpenedByEvent = e.pointerType;
            this.toggleDropdown();

            // misc handlers
            if (!this.focusedFlag) {
                if (e.pointerType === 'mouse') {
                    this.realElement.focus();
                } else {
                    this.onFocus(e);
                }
            }
            this.pressedFlag = true;
            this.fakeElement.addClass(this.options.pressedClass);
            this.doc.on('jcf-pointerup', this.onSelectAreaRelease);
        },
        onSelectAreaRelease: function(e) {
            if (this.focusedFlag && e.pointerType === 'mouse') {
                this.realElement.focus();
            }
            this.pressedFlag = false;
            this.fakeElement.removeClass(this.options.pressedClass);
            this.doc.off('jcf-pointerup', this.onSelectAreaRelease);
        },
        onOutsideClick: function(e) {
            var target = $(e.target)
              , clickedInsideSelect = target.closest(this.fakeElement).length || target.closest(this.dropdown).length;

            if (!clickedInsideSelect) {
                this.hideDropdown();
            }
        },
        onSelect: function() {
            this.refresh();

            if (this.realElement.prop('multiple')) {
                this.repositionDropdown();
            } else {
                this.hideDropdown();
            }

            this.fireNativeEvent(this.realElement, 'change');
        },
        toggleListMode: function(state) {
            if (!this.options.wrapNative) {
                if (state) {
                    // temporary change select to list to avoid appearing of native dropdown
                    this.realElement.attr({
                        size: 4,
                        'jcf-size': ''
                    });
                } else {
                    // restore select from list mode to dropdown select
                    if (!this.options.wrapNative) {
                        this.realElement.removeAttr('size jcf-size');
                    }
                }
            }
        },
        createDropdown: function() {
            // destroy previous dropdown if needed
            if (this.dropdown) {
                this.list.destroy();
                this.dropdown.remove();
            }

            // create new drop container
            this.dropdown = $(this.options.fakeDropStructure).appendTo(this.fakeDropTarget);
            this.dropdown.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));
            makeUnselectable(this.dropdown);

            // handle compact multiple style
            if (this.realElement.prop('multiple')) {
                this.dropdown.addClass('jcf-compact-multiple');
            }

            // set initial styles for dropdown in body
            if (this.options.fakeDropInBody) {
                this.dropdown.css({
                    position: 'absolute',
                    top: -9999
                });
            }

            // create new select list instance
            this.list = new SelectList({
                useHoverClass: true,
                handleResize: false,
                alwaysPreventMouseWheel: true,
                maxVisibleItems: this.options.maxVisibleItems,
                useCustomScroll: this.options.useCustomScroll,
                holder: this.dropdown.find(this.options.dropContentSelector),
                multipleSelectWithoutKey: this.realElement.prop('multiple'),
                element: this.realElement
            });
            $(this.list).on({
                select: this.onSelect,
                press: this.onSelectDropPress,
                release: this.onSelectDropRelease
            });
        },
        repositionDropdown: function() {
            var selectOffset = this.fakeElement.offset(), selectWidth = this.fakeElement.outerWidth(), selectHeight = this.fakeElement.outerHeight(), dropHeight = this.dropdown.css('width', selectWidth).outerHeight(), winScrollTop = this.win.scrollTop(), winHeight = this.win.height(), calcTop, calcLeft, bodyOffset, needFlipDrop = false;

            // check flip drop position
            if (selectOffset.top + selectHeight + dropHeight > winScrollTop + winHeight && selectOffset.top - dropHeight > winScrollTop) {
                needFlipDrop = true;
            }

            if (this.options.fakeDropInBody) {
                bodyOffset = this.fakeDropTarget.css('position') !== 'static' ? this.fakeDropTarget.offset().top : 0;
                if (this.options.flipDropToFit && needFlipDrop) {
                    // calculate flipped dropdown position
                    calcLeft = selectOffset.left;
                    calcTop = selectOffset.top - dropHeight - bodyOffset;
                } else {
                    // calculate default drop position
                    calcLeft = selectOffset.left;
                    calcTop = selectOffset.top + selectHeight - bodyOffset;
                }

                // update drop styles
                this.dropdown.css({
                    width: selectWidth,
                    left: calcLeft,
                    top: calcTop
                });
            }

            // refresh flipped class
            this.dropdown.add(this.fakeElement).toggleClass(this.options.flipDropClass, this.options.flipDropToFit && needFlipDrop);
        },
        showDropdown: function() {
            // do not show empty custom dropdown
            if (!this.realElement.prop('options').length) {
                return;
            }

            // create options list if not created
            if (!this.dropdown) {
                this.createDropdown();
            }

            // show dropdown
            this.dropActive = true;
            this.dropdown.appendTo(this.fakeDropTarget);
            this.fakeElement.addClass(this.options.dropActiveClass);
            this.refreshSelectedText();
            this.repositionDropdown();
            this.list.setScrollTop(this.savedScrollTop);
            this.list.refresh();

            // add temporary event handlers
            this.win.on('resize', this.onResize);
            this.doc.on('jcf-pointerdown', this.onOutsideClick);
        },
        hideDropdown: function() {
            if (this.dropdown) {
                this.savedScrollTop = this.list.getScrollTop();
                this.fakeElement.removeClass(this.options.dropActiveClass + ' ' + this.options.flipDropClass);
                this.dropdown.removeClass(this.options.flipDropClass).detach();
                this.doc.off('jcf-pointerdown', this.onOutsideClick);
                this.win.off('resize', this.onResize);
                this.dropActive = false;
                if (this.selectOpenedByEvent === 'touch') {
                    this.onBlur();
                }
            }
        },
        toggleDropdown: function() {
            if (this.dropActive) {
                this.hideDropdown();
            } else {
                this.showDropdown();
            }
        },
        refreshSelectedText: function() {
            // redraw selected area
            var selectedIndex = this.realElement.prop('selectedIndex'), selectedOption = this.realElement.prop('options')[selectedIndex], selectedOptionImage = selectedOption ? selectedOption.getAttribute('data-image') : null, selectedOptionText = '', selectedOptionClasses, self = this;

            if (this.realElement.prop('multiple')) {
                $.each(this.realElement.prop('options'), function(index, option) {
                    if (option.selected) {
                        selectedOptionText += (selectedOptionText ? ', ' : '') + option.innerHTML;
                    }
                });
                if (!selectedOptionText) {
                    selectedOptionText = self.realElement.attr('placeholder') || '';
                }
                this.selectText.removeAttr('class').html(selectedOptionText);
            } else if (!selectedOption) {
                if (this.selectImage) {
                    this.selectImage.hide();
                }
                this.selectText.removeAttr('class').empty();
            } else if (this.currentSelectedText !== selectedOption.innerHTML || this.currentSelectedImage !== selectedOptionImage) {
                selectedOptionClasses = getPrefixedClasses(selectedOption.className, this.options.optionClassPrefix);
                this.selectText.attr('class', selectedOptionClasses).html(selectedOption.innerHTML);

                if (selectedOptionImage) {
                    if (!this.selectImage) {
                        this.selectImage = $('<img>').prependTo(this.selectTextContainer).hide();
                    }
                    this.selectImage.attr('src', selectedOptionImage).show();
                } else if (this.selectImage) {
                    this.selectImage.hide();
                }

                this.currentSelectedText = selectedOption.innerHTML;
                this.currentSelectedImage = selectedOptionImage;
            }
        },
        refresh: function() {
            // refresh fake select visibility
            if (this.realElement.prop('style').display === 'none') {
                this.fakeElement.hide();
            } else {
                this.fakeElement.show();
            }

            // refresh selected text
            this.refreshSelectedText();

            // handle disabled state
            this.fakeElement.toggleClass(this.options.disabledClass, this.realElement.is(':disabled'));
        },
        destroy: function() {
            // restore structure
            if (this.options.wrapNative) {
                this.realElement.insertBefore(this.fakeElement).css({
                    position: '',
                    height: '',
                    width: ''
                }).removeClass(this.options.resetAppearanceClass);
            } else {
                this.realElement.removeClass(this.options.hiddenClass);
                if (this.realElement.is('[jcf-size]')) {
                    this.realElement.removeAttr('size jcf-size');
                }
            }

            // removing element will also remove its event handlers
            this.fakeElement.remove();

            // remove other event handlers
            this.doc.off('jcf-pointerup', this.onSelectAreaRelease);
            this.realElement.off({
                focus: this.onFocus
            });
        }
    });

    // listbox module
    function ListBox(options) {
        this.options = $.extend({
            wrapNative: true,
            useCustomScroll: true,
            fakeStructure: '<span class="jcf-list-box"><span class="jcf-list-wrapper"></span></span>',
            selectClassPrefix: 'jcf-select-',
            listHolder: '.jcf-list-wrapper'
        }, options);
        this.init();
    }
    $.extend(ListBox.prototype, {
        init: function() {
            this.bindHandlers();
            this.initStructure();
            this.attachEvents();
        },
        initStructure: function() {
            this.realElement = $(this.options.element);
            this.fakeElement = $(this.options.fakeStructure).insertAfter(this.realElement);
            this.listHolder = this.fakeElement.find(this.options.listHolder);
            makeUnselectable(this.fakeElement);

            // copy classes from original select
            this.fakeElement.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));
            this.realElement.addClass(this.options.hiddenClass);

            this.list = new SelectList({
                useCustomScroll: this.options.useCustomScroll,
                holder: this.listHolder,
                selectOnClick: false,
                element: this.realElement
            });
        },
        attachEvents: function() {
            // delayed refresh handler
            var self = this;
            this.delayedRefresh = function(e) {
                if (e && e.which === 16) {
                    // ignore SHIFT key
                    return;
                } else {
                    clearTimeout(self.refreshTimer);
                    self.refreshTimer = setTimeout(function() {
                        self.refresh();
                        self.list.scrollToActiveOption();
                    }, 1);
                }
            }
            ;

            // other event handlers
            this.realElement.on({
                focus: this.onFocus,
                click: this.delayedRefresh,
                keydown: this.delayedRefresh
            });

            // select list event handlers
            $(this.list).on({
                select: this.onSelect,
                press: this.onFakeOptionsPress,
                release: this.onFakeOptionsRelease
            });
        },
        onFakeOptionsPress: function(e, pointerEvent) {
            this.pressedFlag = true;
            if (pointerEvent.pointerType === 'mouse') {
                this.realElement.focus();
            }
        },
        onFakeOptionsRelease: function(e, pointerEvent) {
            this.pressedFlag = false;
            if (pointerEvent.pointerType === 'mouse') {
                this.realElement.focus();
            }
        },
        onSelect: function() {
            this.fireNativeEvent(this.realElement, 'change');
            this.fireNativeEvent(this.realElement, 'click');
        },
        onFocus: function() {
            if (!this.pressedFlag || !this.focusedFlag) {
                this.fakeElement.addClass(this.options.focusClass);
                this.realElement.on('blur', this.onBlur);
                this.focusedFlag = true;
            }
        },
        onBlur: function() {
            if (!this.pressedFlag) {
                this.fakeElement.removeClass(this.options.focusClass);
                this.realElement.off('blur', this.onBlur);
                this.focusedFlag = false;
            }
        },
        refresh: function() {
            this.fakeElement.toggleClass(this.options.disabledClass, this.realElement.is(':disabled'));
            this.list.refresh();
        },
        destroy: function() {
            this.list.destroy();
            this.realElement.insertBefore(this.fakeElement).removeClass(this.options.hiddenClass);
            this.fakeElement.remove();
        }
    });

    // options list module
    function SelectList(options) {
        this.options = $.extend({
            holder: null,
            maxVisibleItems: 10,
            selectOnClick: true,
            useHoverClass: false,
            useCustomScroll: false,
            handleResize: true,
            multipleSelectWithoutKey: false,
            alwaysPreventMouseWheel: false,
            indexAttribute: 'data-index',
            cloneClassPrefix: 'jcf-option-',
            containerStructure: '<span class="jcf-list"><span class="jcf-list-content"></span></span>',
            containerSelector: '.jcf-list-content',
            captionClass: 'jcf-optgroup-caption',
            disabledClass: 'jcf-disabled',
            optionClass: 'jcf-option',
            groupClass: 'jcf-optgroup',
            hoverClass: 'jcf-hover',
            selectedClass: 'jcf-selected',
            scrollClass: 'jcf-scroll-active'
        }, options);
        this.init();
    }
    $.extend(SelectList.prototype, {
        init: function() {
            this.initStructure();
            this.refreshSelectedClass();
            this.attachEvents();
        },
        initStructure: function() {
            this.element = $(this.options.element);
            this.indexSelector = '[' + this.options.indexAttribute + ']';
            this.container = $(this.options.containerStructure).appendTo(this.options.holder);
            this.listHolder = this.container.find(this.options.containerSelector);
            this.lastClickedIndex = this.element.prop('selectedIndex');
            this.rebuildList();
        },
        attachEvents: function() {
            this.bindHandlers();
            this.listHolder.on('jcf-pointerdown', this.indexSelector, this.onItemPress);
            this.listHolder.on('jcf-pointerdown', this.onPress);

            if (this.options.useHoverClass) {
                this.listHolder.on('jcf-pointerover', this.indexSelector, this.onHoverItem);
            }
        },
        onPress: function(e) {
            $(this).trigger('press', e);
            this.listHolder.on('jcf-pointerup', this.onRelease);
        },
        onRelease: function(e) {
            $(this).trigger('release', e);
            this.listHolder.off('jcf-pointerup', this.onRelease);
        },
        onHoverItem: function(e) {
            var hoverIndex = parseFloat(e.currentTarget.getAttribute(this.options.indexAttribute));
            this.fakeOptions.removeClass(this.options.hoverClass).eq(hoverIndex).addClass(this.options.hoverClass);
        },
        onItemPress: function(e) {
            if (e.pointerType === 'touch' || this.options.selectOnClick) {
                // select option after "click"
                this.tmpListOffsetTop = this.list.offset().top;
                this.listHolder.on('jcf-pointerup', this.indexSelector, this.onItemRelease);
            } else {
                // select option immediately
                this.onSelectItem(e);
            }
        },
        onItemRelease: function(e) {
            // remove event handlers and temporary data
            this.listHolder.off('jcf-pointerup', this.indexSelector, this.onItemRelease);

            // simulate item selection
            if (this.tmpListOffsetTop === this.list.offset().top) {
                this.listHolder.on('click', this.indexSelector, {
                    savedPointerType: e.pointerType
                }, this.onSelectItem);
            }
            delete this.tmpListOffsetTop;
        },
        onSelectItem: function(e) {
            var clickedIndex = parseFloat(e.currentTarget.getAttribute(this.options.indexAttribute)), pointerType = e.data && e.data.savedPointerType || e.pointerType || 'mouse', range;

            // remove click event handler
            this.listHolder.off('click', this.indexSelector, this.onSelectItem);

            // ignore clicks on disabled options
            if (e.button > 1 || this.realOptions[clickedIndex].disabled) {
                return;
            }

            if (this.element.prop('multiple')) {
                if (e.metaKey || e.ctrlKey || pointerType === 'touch' || this.options.multipleSelectWithoutKey) {
                    // if CTRL/CMD pressed or touch devices - toggle selected option
                    this.realOptions[clickedIndex].selected = !this.realOptions[clickedIndex].selected;
                } else if (e.shiftKey) {
                    // if SHIFT pressed - update selection
                    range = [this.lastClickedIndex, clickedIndex].sort(function(a, b) {
                        return a - b;
                    });
                    this.realOptions.each(function(index, option) {
                        option.selected = (index >= range[0] && index <= range[1]);
                    });
                } else {
                    // set single selected index
                    this.element.prop('selectedIndex', clickedIndex);
                }
            } else {
                this.element.prop('selectedIndex', clickedIndex);
            }

            // save last clicked option
            if (!e.shiftKey) {
                this.lastClickedIndex = clickedIndex;
            }

            // refresh classes
            this.refreshSelectedClass();

            // scroll to active item in desktop browsers
            if (pointerType === 'mouse') {
                this.scrollToActiveOption();
            }

            // make callback when item selected
            $(this).trigger('select');
        },
        rebuildList: function() {
            // rebuild options
            var self = this
              , rootElement = this.element[0];

            // recursively create fake options
            this.storedSelectHTML = rootElement.innerHTML;
            this.optionIndex = 0;
            this.list = $(this.createOptionsList(rootElement));
            this.listHolder.empty().append(this.list);
            this.realOptions = this.element.find('option');
            this.fakeOptions = this.list.find(this.indexSelector);
            this.fakeListItems = this.list.find('.' + this.options.captionClass + ',' + this.indexSelector);
            delete this.optionIndex;

            // detect max visible items
            var maxCount = this.options.maxVisibleItems
              , sizeValue = this.element.prop('size');
            if (sizeValue > 1 && !this.element.is('[jcf-size]')) {
                maxCount = sizeValue;
            }

            // handle scrollbar
            var needScrollBar = this.fakeOptions.length > maxCount;
            this.container.toggleClass(this.options.scrollClass, needScrollBar);
            if (needScrollBar) {
                // change max-height
                this.listHolder.css({
                    maxHeight: this.getOverflowHeight(maxCount),
                    overflow: 'auto'
                });

                if (this.options.useCustomScroll && jcf.modules.Scrollable) {
                    // add custom scrollbar if specified in options
                    jcf.replace(this.listHolder, 'Scrollable', {
                        handleResize: this.options.handleResize,
                        alwaysPreventMouseWheel: this.options.alwaysPreventMouseWheel
                    });
                    return;
                }
            }

            // disable edge wheel scrolling
            if (this.options.alwaysPreventMouseWheel) {
                this.preventWheelHandler = function(e) {
                    var currentScrollTop = self.listHolder.scrollTop()
                      , maxScrollTop = self.listHolder.prop('scrollHeight') - self.listHolder.innerHeight();

                    // check edge cases
                    if ((currentScrollTop <= 0 && e.deltaY < 0) || (currentScrollTop >= maxScrollTop && e.deltaY > 0)) {
                        e.preventDefault();
                    }
                }
                ;
                this.listHolder.on('jcf-mousewheel', this.preventWheelHandler);
            }
        },
        refreshSelectedClass: function() {
            var self = this, selectedItem, isMultiple = this.element.prop('multiple'), selectedIndex = this.element.prop('selectedIndex');

            if (isMultiple) {
                this.realOptions.each(function(index, option) {
                    self.fakeOptions.eq(index).toggleClass(self.options.selectedClass, !!option.selected);
                });
            } else {
                this.fakeOptions.removeClass(this.options.selectedClass + ' ' + this.options.hoverClass);
                selectedItem = this.fakeOptions.eq(selectedIndex).addClass(this.options.selectedClass);
                if (this.options.useHoverClass) {
                    selectedItem.addClass(this.options.hoverClass);
                }
            }
        },
        scrollToActiveOption: function() {
            // scroll to target option
            var targetOffset = this.getActiveOptionOffset();
            if (typeof targetOffset === 'number') {
                this.listHolder.prop('scrollTop', targetOffset);
            }
        },
        getSelectedIndexRange: function() {
            var firstSelected = -1
              , lastSelected = -1;
            this.realOptions.each(function(index, option) {
                if (option.selected) {
                    if (firstSelected < 0) {
                        firstSelected = index;
                    }
                    lastSelected = index;
                }
            });
            return [firstSelected, lastSelected];
        },
        getChangedSelectedIndex: function() {
            var selectedIndex = this.element.prop('selectedIndex'), targetIndex;

            if (this.element.prop('multiple')) {
                // multiple selects handling
                if (!this.previousRange) {
                    this.previousRange = [selectedIndex, selectedIndex];
                }
                this.currentRange = this.getSelectedIndexRange();
                targetIndex = this.currentRange[this.currentRange[0] !== this.previousRange[0] ? 0 : 1];
                this.previousRange = this.currentRange;
                return targetIndex;
            } else {
                // single choice selects handling
                return selectedIndex;
            }
        },
        getActiveOptionOffset: function() {
            // calc values
            var dropHeight = this.listHolder.height()
              , dropScrollTop = this.listHolder.prop('scrollTop')
              , currentIndex = this.getChangedSelectedIndex()
              , fakeOption = this.fakeOptions.eq(currentIndex)
              , fakeOptionOffset = fakeOption.offset().top - this.list.offset().top
              , fakeOptionHeight = fakeOption.innerHeight();

            // scroll list
            if (fakeOptionOffset + fakeOptionHeight >= dropScrollTop + dropHeight) {
                // scroll down (always scroll to option)
                return fakeOptionOffset - dropHeight + fakeOptionHeight;
            } else if (fakeOptionOffset < dropScrollTop) {
                // scroll up to option
                return fakeOptionOffset;
            }
        },
        getOverflowHeight: function(sizeValue) {
            var item = this.fakeListItems.eq(sizeValue - 1)
              , listOffset = this.list.offset().top
              , itemOffset = item.offset().top
              , itemHeight = item.innerHeight();

            return itemOffset + itemHeight - listOffset;
        },
        getScrollTop: function() {
            return this.listHolder.scrollTop();
        },
        setScrollTop: function(value) {
            this.listHolder.scrollTop(value);
        },
        createOption: function(option) {
            var newOption = document.createElement('span');
            newOption.className = this.options.optionClass;
            newOption.innerHTML = option.innerHTML;
            newOption.setAttribute(this.options.indexAttribute, this.optionIndex++);

            var optionImage, optionImageSrc = option.getAttribute('data-image');
            if (optionImageSrc) {
                optionImage = document.createElement('img');
                optionImage.src = optionImageSrc;
                newOption.insertBefore(optionImage, newOption.childNodes[0]);
            }
            if (option.disabled) {
                newOption.className += ' ' + this.options.disabledClass;
            }
            if (option.className) {
                newOption.className += ' ' + getPrefixedClasses(option.className, this.options.cloneClassPrefix);
            }
            return newOption;
        },
        createOptGroup: function(optgroup) {
            var optGroupContainer = document.createElement('span'), optGroupName = optgroup.getAttribute('label'), optGroupCaption, optGroupList;

            // create caption
            optGroupCaption = document.createElement('span');
            optGroupCaption.className = this.options.captionClass;
            optGroupCaption.innerHTML = optGroupName;
            optGroupContainer.appendChild(optGroupCaption);

            // create list of options
            if (optgroup.children.length) {
                optGroupList = this.createOptionsList(optgroup);
                optGroupContainer.appendChild(optGroupList);
            }

            optGroupContainer.className = this.options.groupClass;
            return optGroupContainer;
        },
        createOptionContainer: function() {
            var optionContainer = document.createElement('li');
            return optionContainer;
        },
        createOptionsList: function(container) {
            var self = this
              , list = document.createElement('ul');

            $.each(container.children, function(index, currentNode) {
                var item = self.createOptionContainer(currentNode), newNode;

                switch (currentNode.tagName.toLowerCase()) {
                case 'option':
                    newNode = self.createOption(currentNode);
                    break;
                case 'optgroup':
                    newNode = self.createOptGroup(currentNode);
                    break;
                }
                list.appendChild(item).appendChild(newNode);
            });
            return list;
        },
        refresh: function() {
            // check for select innerHTML changes
            if (this.storedSelectHTML !== this.element.prop('innerHTML')) {
                this.rebuildList();
            }

            // refresh custom scrollbar
            var scrollInstance = jcf.getInstance(this.listHolder);
            if (scrollInstance) {
                scrollInstance.refresh();
            }

            // refresh selectes classes
            this.refreshSelectedClass();
        },
        destroy: function() {
            this.listHolder.off('jcf-mousewheel', this.preventWheelHandler);
            this.listHolder.off('jcf-pointerdown', this.indexSelector, this.onSelectItem);
            this.listHolder.off('jcf-pointerover', this.indexSelector, this.onHoverItem);
            this.listHolder.off('jcf-pointerdown', this.onPress);
        }
    });

    // helper functions
    var getPrefixedClasses = function(className, prefixToAdd) {
        return className ? className.replace(/[\s]*([\S]+)+[\s]*/gi, prefixToAdd + '$1 ') : '';
    };
    var makeUnselectable = (function() {
        var unselectableClass = jcf.getOptions().unselectableClass;
        function preventHandler(e) {
            e.preventDefault();
        }
        return function(node) {
            node.addClass(unselectableClass).on('selectstart', preventHandler);
        }
        ;
    }());

}(jQuery, this));

/*!
* JavaScript Custom Forms : Number Module
*
* Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
* Released under the MIT license (LICENSE.txt)
*
* Version: 1.1.3
*/
;(function($) {

    'use strict';

    jcf.addModule({
        name: 'Number',
        selector: 'input[type="number"]',
        options: {
            realElementClass: 'jcf-real-element',
            fakeStructure: '<span class="jcf-number"><span class="jcf-btn-inc"></span><span class="jcf-btn-dec"></span></span>',
            btnIncSelector: '.jcf-btn-inc',
            btnDecSelector: '.jcf-btn-dec',
            pressInterval: 150
        },
        matchElement: function(element) {
            return element.is(this.selector);
        },
        init: function() {
            this.initStructure();
            this.attachEvents();
            this.refresh();
        },
        initStructure: function() {
            this.page = $('html');
            this.realElement = $(this.options.element).addClass(this.options.realElementClass);
            this.fakeElement = $(this.options.fakeStructure).insertBefore(this.realElement).prepend(this.realElement);
            this.btnDec = this.fakeElement.find(this.options.btnDecSelector);
            this.btnInc = this.fakeElement.find(this.options.btnIncSelector);
        

            // set initial values
            this.initialValue = parseFloat(this.realElement.val()) || 0;
            this.minValue = parseFloat(this.realElement.attr('min'));
            this.maxValue = parseFloat(this.realElement.attr('max'));
            this.stepValue = parseFloat(this.realElement.attr('step')) || 1;

            console.log('Current value1:  --->', this.maxValue);

            // check attribute values
            this.minValue = isNaN(this.minValue) ? -Infinity : this.minValue;
            this.maxValue = isNaN(this.maxValue) ? Infinity : this.maxValue;

            // handle range
            if (isFinite(this.maxValue)) {
                this.maxValue -= (this.maxValue - this.minValue) % this.stepValue;
            }
        },
        attachEvents: function() {
            this.realElement.on({
                focus: this.onFocus
            });
            this.btnDec.add(this.btnInc).on('jcf-pointerdown', this.onBtnPress);
        },
        onBtnPress: function(e) {
            var self = this, increment;
            if (!this.realElement.is(':disabled')) {
                increment = this.btnInc.is(e.currentTarget);

                console.log('btn pressed', { increment, el: this.realElement }, e)
                self.step(increment);
                clearInterval(this.stepTimer);
                this.stepTimer = setInterval(function() {
                    self.step(increment);
                }, this.options.pressInterval);

                this.page.on('jcf-pointerup', this.onBtnRelease);


            }
        },
        onBtnRelease: async function() {
            clearInterval(this.stepTimer);
            this.page.off('jcf-pointerup', this.onBtnRelease);
            
            if (window['handleProductQtyMinMax']) {
                try {
                    const qtyInput = this.realElement[0]
                    const productHandle = qtyInput.dataset.productHandle
                    const variantId = qtyInput.dataset.variantId
                    await handleProductQtyMinMax(productHandle, variantId, qtyInput)
                } catch (ex) {
                    
                }
            }

            // $(this.realElement).trigger('input');
            const inputEvent = new Event('input', { bubbles: true });
            this.realElement[0].dispatchEvent(inputEvent);

            // 🔥 Fire custom event with details
            const qtyChangeEvent = new CustomEvent('qtyChange', {
                bubbles: true,
                detail: {
                    qty: this.realElement.val(),
                    variantId: this.realElement.data('variant-id')
                }
            });
            this.realElement[0].dispatchEvent(qtyChangeEvent);

            // console.log('Qty on release:', this.realElement.val(), 'Variant ID:', this.realElement.data('variant-id'));
        },
        onFocus: function() {
            this.fakeElement.addClass(this.options.focusClass);
            this.realElement.on({
                blur: this.onBlur,
                keydown: this.onKeyPress
            });
        },
        onBlur: function() {
            this.fakeElement.removeClass(this.options.focusClass);
            this.realElement.off({
                blur: this.onBlur,
                keydown: this.onKeyPress
            });
        },
        onKeyPress: function(e) {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
                this.step(e.which === 38);
            }
        },
        step: function(increment) {
            var originalValue = parseFloat(this.realElement.val())
              , newValue = originalValue || 0
              , addValue = this.stepValue * (increment ? 1 : -1)
              , edgeNumber = isFinite(this.minValue) ? this.minValue : this.initialValue - Math.abs(newValue * this.stepValue)
              , diff = Math.abs(edgeNumber - newValue) % this.stepValue;

            // handle step diff
            if (diff) {
                if (increment) {
                    newValue += addValue - diff;
                } else {
                    newValue -= diff;
                }
            } else {
                newValue += addValue;
            }

            // handle min/max limits
            if (newValue < this.minValue) {
                newValue = this.minValue;
            } else if (newValue > this.maxValue) {
                newValue = this.maxValue;
            }

            // update value in real input if its changed
            if (newValue !== originalValue) {
                this.realElement.val(newValue).trigger('change');
                this.refresh();
            }

            if (window['handleProductQtyMinMax']) {
                try {
                    const qtyInput = this.realElement[0]
                    const productHandle = qtyInput.dataset.productHandle
                    const variantId = qtyInput.dataset.variantId
                    handleProductQtyMinMax(productHandle, variantId, qtyInput)
                } catch (ex) {
                    
                }
            }
        },
        refresh: function() {
            var isDisabled = this.realElement.is(':disabled')
              , currentValue = parseFloat(this.realElement.val());

            // handle disabled state
            this.fakeElement.toggleClass(this.options.disabledClass, isDisabled);

            // refresh button classes
            this.btnDec.toggleClass(this.options.disabledClass, currentValue === this.minValue);
            this.btnInc.toggleClass(this.options.disabledClass, currentValue === this.maxValue);
        },
        destroy: function() {
            // restore original structure
            this.realElement.removeClass(this.options.realElementClass).insertBefore(this.fakeElement);
            this.fakeElement.remove();
            clearInterval(this.stepTimer);

            // remove event handlers
            this.page.off('jcf-pointerup', this.onBtnRelease);
            this.realElement.off({
                keydown: this.onKeyPress,
                focus: this.onFocus,
                blur: this.onBlur
            });
        }
    });

}(jQuery));

/*
 * jQuery sticky box plugin
 */
;(function($, $win) {

    'use strict';

    function StickyScrollBlock($stickyBox, options) {
        this.options = options;
        this.$stickyBox = $stickyBox;
        this.init();
    }

    var StickyScrollBlockPrototype = {
        init: function() {
            this.findElements();
            this.attachEvents();
            this.makeCallback('onInit');
        },

        findElements: function() {
            // find parent container in which will be box move
            this.$container = this.$stickyBox.closest(this.options.container);
            // define box wrap flag
            this.isWrap = this.options.positionType === 'fixed' && this.options.setBoxHeight;
            // define box move flag
            this.moveInContainer = !!this.$container.length;
            // wrapping box to set place in content
            if (this.isWrap) {
                this.$stickyBoxWrap = this.$stickyBox.wrap('<div class="' + this.getWrapClass() + '"/>').parent();
            }
            //define block to add active class
            this.parentForActive = this.getParentForActive();
            this.isInit = true;
        },

        attachEvents: function() {
            var self = this;

            // bind events
            this.onResize = function() {
                if (!self.isInit)
                    return;
                self.resetState();
                self.recalculateOffsets();
                self.checkStickyPermission();
                self.scrollHandler();
            }
            ;

            this.onScroll = function() {
                self.scrollHandler();
            }
            ;

            // initial handler call
            this.onResize();

            // handle events
            $win.on('load resize orientationchange', this.onResize).on('scroll', this.onScroll);
        },

        defineExtraTop: function() {
            // define box's extra top dimension
            var extraTop;

            if (typeof this.options.extraTop === 'number') {
                extraTop = this.options.extraTop;
            } else if (typeof this.options.extraTop === 'function') {
                extraTop = this.options.extraTop();
            }

            this.extraTop = this.options.positionType === 'absolute' ? extraTop : Math.min(this.winParams.height - this.data.boxFullHeight, extraTop);
        },

        checkStickyPermission: function() {
            // check the permission to set sticky
            this.isStickyEnabled = this.moveInContainer ? this.data.containerOffsetTop + this.data.containerHeight > this.data.boxFullHeight + this.data.boxOffsetTop + this.options.extraBottom : true;
        },

        getParentForActive: function() {
            if (this.isWrap) {
                return this.$stickyBoxWrap;
            }

            if (this.$container.length) {
                return this.$container;
            }

            return this.$stickyBox;
        },

        getWrapClass: function() {
            // get set of container classes
            try {
                return this.$stickyBox.attr('class').split(' ').map(function(name) {
                    return 'sticky-wrap-' + name;
                }).join(' ');
            } catch (err) {
                return 'sticky-wrap';
            }
        },

        resetState: function() {
            // reset dimensions and state
            this.stickyFlag = false;
            this.$stickyBox.css({
                '-webkit-transition': '',
                '-webkit-transform': '',
                transition: '',
                transform: '',
                position: '',
                width: '',
                left: '',
                top: ''
            }).removeClass(this.options.activeClass);

            if (this.isWrap) {
                this.$stickyBoxWrap.removeClass(this.options.activeClass).removeAttr('style');
            }

            if (this.moveInContainer) {
                this.$container.removeClass(this.options.activeClass);
            }
        },

        recalculateOffsets: function() {
            // define box and container dimensions
            this.winParams = this.getWindowParams();

            this.data = $.extend(this.getBoxOffsets(), this.getContainerOffsets());

            this.defineExtraTop();
        },

        getBoxOffsets: function() {
            function offetTop(obj) {
                obj.top = 0;
                return obj
            }
            var boxOffset = this.$stickyBox.css('position') === 'fixed' ? offetTop(this.$stickyBox.offset()) : this.$stickyBox.offset();
            var boxPosition = this.$stickyBox.position();

            return {
                // sticky box offsets
                boxOffsetLeft: boxOffset.left,
                boxOffsetTop: boxOffset.top,
                // sticky box positions
                boxTopPosition: boxPosition.top,
                boxLeftPosition: boxPosition.left,
                // sticky box width/height
                boxFullHeight: this.$stickyBox.outerHeight(true),
                boxHeight: this.$stickyBox.outerHeight(),
                boxWidth: this.$stickyBox.outerWidth()
            };
        },

        getContainerOffsets: function() {
            var containerOffset = this.moveInContainer ? this.$container.offset() : null;

            return containerOffset ? {
                // container offsets
                containerOffsetLeft: containerOffset.left,
                containerOffsetTop: containerOffset.top,
                // container height
                containerHeight: this.$container.outerHeight()
            } : {};
        },

        getWindowParams: function() {
            return {
                height: window.innerHeight || document.documentElement.clientHeight
            };
        },

        makeCallback: function(name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        },

        destroy: function() {
            this.isInit = false;
            // remove event handlers and styles
            $win.off('load resize orientationchange', this.onResize).off('scroll', this.onScroll);
            this.resetState();
            this.$stickyBox.removeData('StickyScrollBlock');
            if (this.isWrap) {
                this.$stickyBox.unwrap();
            }
            this.makeCallback('onDestroy');
        }
    };

    var stickyMethods = {
        fixed: {
            scrollHandler: function() {
                this.winScrollTop = $win.scrollTop();
                var isActiveSticky = this.winScrollTop - (this.options.showAfterScrolled ? this.extraTop : 0) - (this.options.showAfterScrolled ? this.data.boxHeight + this.extraTop : 0) > this.data.boxOffsetTop - this.extraTop;

                if (isActiveSticky) {
                    this.isStickyEnabled && this.stickyOn();
                } else {
                    this.stickyOff();
                }
            },

            stickyOn: function() {
                if (!this.stickyFlag) {
                    this.stickyFlag = true;
                    this.parentForActive.addClass(this.options.activeClass);
                    this.$stickyBox.css({
                        width: this.data.boxWidth,
                        position: this.options.positionType
                    });
                    if (this.isWrap) {
                        this.$stickyBoxWrap.css({
                            height: this.data.boxFullHeight
                        });
                    }
                    this.makeCallback('fixedOn');
                }
                this.setDynamicPosition();
            },

            stickyOff: function() {
                if (this.stickyFlag) {
                    this.stickyFlag = false;
                    this.resetState();
                    this.makeCallback('fixedOff');
                }
            },

            setDynamicPosition: function() {
                this.$stickyBox.css({
                    top: this.getTopPosition(),
                    left: this.data.boxOffsetLeft - $win.scrollLeft()
                });
            },

            getTopPosition: function() {
                if (this.moveInContainer) {
                    var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;

                    return Math.min(this.extraTop, (this.data.containerHeight + this.data.containerOffsetTop) - currScrollTop);
                } else {
                    return this.extraTop;
                }
            }
        },
        absolute: {
            scrollHandler: function() {
                this.winScrollTop = $win.scrollTop();
                var isActiveSticky = this.winScrollTop > this.data.boxOffsetTop - this.extraTop;

                if (isActiveSticky) {
                    this.isStickyEnabled && this.stickyOn();
                } else {
                    this.stickyOff();
                }
            },

            stickyOn: function() {
                if (!this.stickyFlag) {
                    this.stickyFlag = true;
                    this.parentForActive.addClass(this.options.activeClass);
                    this.$stickyBox.css({
                        width: this.data.boxWidth,
                        transition: 'transform ' + this.options.animSpeed + 's ease',
                        '-webkit-transition': 'transform ' + this.options.animSpeed + 's ease',
                    });

                    if (this.isWrap) {
                        this.$stickyBoxWrap.css({
                            height: this.data.boxFullHeight
                        });
                    }

                    this.makeCallback('fixedOn');
                }

                this.clearTimer();
                this.timer = setTimeout(function() {
                    this.setDynamicPosition();
                }
                .bind(this), this.options.animDelay * 1000);
            },

            stickyOff: function() {
                if (this.stickyFlag) {
                    this.clearTimer();
                    this.stickyFlag = false;

                    this.timer = setTimeout(function() {
                        this.setDynamicPosition();
                        setTimeout(function() {
                            this.resetState();
                        }
                        .bind(this), this.options.animSpeed * 1000);
                    }
                    .bind(this), this.options.animDelay * 1000);
                    this.makeCallback('fixedOff');
                }
            },

            clearTimer: function() {
                clearTimeout(this.timer);
            },

            setDynamicPosition: function() {
                var topPosition = Math.max(0, this.getTopPosition());

                this.$stickyBox.css({
                    transform: 'translateY(' + topPosition + 'px)',
                    '-webkit-transform': 'translateY(' + topPosition + 'px)'
                });
            },

            getTopPosition: function() {
                var currTopPosition = this.winScrollTop - this.data.boxOffsetTop + this.extraTop;

                if (this.moveInContainer) {
                    var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
                    var diffOffset = Math.abs(Math.min(0, (this.data.containerHeight + this.data.containerOffsetTop) - currScrollTop - this.extraTop));

                    return currTopPosition - diffOffset;
                } else {
                    return currTopPosition;
                }
            }
        }
    };

    // jQuery plugin interface
    $.fn.stickyScrollBlock = function(opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        var options = $.extend({
            container: null,
            positionType: 'fixed',
            // 'fixed' or 'absolute'
            activeClass: 'fixed-position',
            setBoxHeight: true,
            showAfterScrolled: false,
            extraTop: 0,
            extraBottom: 0,
            animDelay: 0.1,
            animSpeed: 0.2
        }, opt);

        return this.each(function() {
            var $stickyBox = jQuery(this);
            var instance = $stickyBox.data('StickyScrollBlock');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                StickyScrollBlock.prototype = $.extend(stickyMethods[options.positionType], StickyScrollBlockPrototype);
                $stickyBox.data('StickyScrollBlock', new StickyScrollBlock($stickyBox,options));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    }
    ;

    // module exports
    window.StickyScrollBlock = StickyScrollBlock;
}(jQuery, jQuery(window)));

/*!
 * SmoothScroll module
 */
;(function($, exports) {
    // private variables
    var page, win = $(window), activeBlock, activeWheelHandler, wheelEvents = ('onwheel'in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll');

    // animation handlers
    function scrollTo(offset, options, callback) {
        // initialize variables
        var scrollBlock;
        if (document.body) {
            if (typeof options === 'number') {
                options = {
                    duration: options
                };
            } else {
                options = options || {};
            }
            page = page || $('html, body');
            scrollBlock = options.container || page;
        } else {
            return;
        }

        // treat single number as scrollTop
        if (typeof offset === 'number') {
            offset = {
                top: offset
            };
        }

        // handle mousewheel/trackpad while animation is active
        if (activeBlock && activeWheelHandler) {
            activeBlock.off(wheelEvents, activeWheelHandler);
        }
        if (options.wheelBehavior && options.wheelBehavior !== 'none') {
            activeWheelHandler = function(e) {
                if (options.wheelBehavior === 'stop') {
                    scrollBlock.off(wheelEvents, activeWheelHandler);
                    scrollBlock.stop();
                } else if (options.wheelBehavior === 'ignore') {
                    e.preventDefault();
                }
            }
            ;
            activeBlock = scrollBlock.on(wheelEvents, activeWheelHandler);
        }

        // start scrolling animation
        scrollBlock.stop().animate({
            scrollLeft: offset.left,
            scrollTop: offset.top
        }, options.duration, function() {
            if (activeWheelHandler) {
                scrollBlock.off(wheelEvents, activeWheelHandler);
            }
            if ($.isFunction(callback)) {
                callback();
            }
        });
    }

    // smooth scroll contstructor
    function SmoothScroll(options) {
        this.options = $.extend({
            anchorLinks: 'a[href^="#"]',
            // selector or jQuery object
            container: null,
            // specify container for scrolling (default - whole page)
            extraOffset: null,
            // function or fixed number
            activeClasses: null,
            // null, "link", "parent"
            easing: 'swing',
            // easing of scrolling
            animMode: 'duration',
            // or "speed" mode
            animDuration: 800,
            // total duration for scroll (any distance)
            animSpeed: 1500,
            // pixels per second
            anchorActiveClass: 'anchor-active',
            sectionActiveClass: 'section-active',
            wheelBehavior: 'stop',
            // "stop", "ignore" or "none"
            useNativeAnchorScrolling: false // do not handle click in devices with native smooth scrolling
        }, options);
        this.init();
    }
    SmoothScroll.prototype = {
        init: function() {
            this.initStructure();
            this.attachEvents();
            this.isInit = true;
        },
        initStructure: function() {
            var self = this;

            this.container = this.options.container ? $(this.options.container) : $('html,body');
            this.scrollContainer = this.options.container ? this.container : win;
            this.anchorLinks = jQuery(this.options.anchorLinks).filter(function() {
                return jQuery(self.getAnchorTarget(jQuery(this))).length;
            });
        },
        getId: function(str) {
            try {
                return '#' + str.replace(/^.*?(#|$)/, '');
            } catch (err) {
                return null;
            }
        },
        getAnchorTarget: function(link) {
            // get target block from link href
            var targetId = this.getId($(link).attr('href'));
            return $(targetId.length > 1 ? targetId : 'html');
        },
        getTargetOffset: function(block) {
            // get target offset
            var blockOffset = block.offset().top;
            if (this.options.container) {
                blockOffset -= this.container.offset().top - this.container.prop('scrollTop');
            }

            // handle extra offset
            if (typeof this.options.extraOffset === 'number') {
                blockOffset -= this.options.extraOffset;
            } else if (typeof this.options.extraOffset === 'function') {
                blockOffset -= this.options.extraOffset(block);
            }
            return {
                top: blockOffset
            };
        },
        attachEvents: function() {
            var self = this;

            // handle active classes
            if (this.options.activeClasses && this.anchorLinks.length) {
                // cache structure
                this.anchorData = [];

                for (var i = 0; i < this.anchorLinks.length; i++) {
                    var link = jQuery(this.anchorLinks[i])
                      , targetBlock = self.getAnchorTarget(link)
                      , anchorDataItem = null;

                    $.each(self.anchorData, function(index, item) {
                        if (item.block[0] === targetBlock[0]) {
                            anchorDataItem = item;
                        }
                    });

                    if (anchorDataItem) {
                        anchorDataItem.link = anchorDataItem.link.add(link);
                    } else {
                        self.anchorData.push({
                            link: link,
                            block: targetBlock
                        });
                    }
                }
                ;
                // add additional event handlers
                this.resizeHandler = function() {
                    if (!self.isInit)
                        return;
                    self.recalculateOffsets();
                }
                ;
                this.scrollHandler = function() {
                    self.refreshActiveClass();
                }
                ;

                this.recalculateOffsets();
                this.scrollContainer.on('scroll', this.scrollHandler);
                win.on('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
            }

            // handle click event
            this.clickHandler = function(e) {
                self.onClick(e);
            }
            ;
            if (!this.options.useNativeAnchorScrolling) {
                this.anchorLinks.on('click', this.clickHandler);
            }
        },
        recalculateOffsets: function() {
            var self = this;
            $.each(this.anchorData, function(index, data) {
                data.offset = self.getTargetOffset(data.block);
                data.height = data.block.outerHeight();
            });
            this.refreshActiveClass();
        },
        toggleActiveClass: function(anchor, block, state) {
            anchor.toggleClass(this.options.anchorActiveClass, state);
            block.toggleClass(this.options.sectionActiveClass, state);
        },
        refreshActiveClass: function() {
            var self = this
              , foundFlag = false
              , containerHeight = this.container.prop('scrollHeight')
              , viewPortHeight = this.scrollContainer.height()
              , scrollTop = this.options.container ? this.container.prop('scrollTop') : win.scrollTop();

            // user function instead of default handler
            if (this.options.customScrollHandler) {
                this.options.customScrollHandler.call(this, scrollTop, this.anchorData);
                return;
            }

            // sort anchor data by offsets
            this.anchorData.sort(function(a, b) {
                return a.offset.top - b.offset.top;
            });

            // default active class handler
            $.each(this.anchorData, function(index) {
                var reverseIndex = self.anchorData.length - index - 1
                  , data = self.anchorData[reverseIndex]
                  , anchorElement = (self.options.activeClasses === 'parent' ? data.link.parent() : data.link);

                if (scrollTop >= containerHeight - viewPortHeight) {
                    // handle last section
                    if (reverseIndex === self.anchorData.length - 1) {
                        self.toggleActiveClass(anchorElement, data.block, true);
                    } else {
                        self.toggleActiveClass(anchorElement, data.block, false);
                    }
                } else {
                    // handle other sections
                    if (!foundFlag && (scrollTop >= data.offset.top - 1 || reverseIndex === 0)) {
                        foundFlag = true;
                        self.toggleActiveClass(anchorElement, data.block, true);
                    } else {
                        self.toggleActiveClass(anchorElement, data.block, false);
                    }
                }
            });
        },
        calculateScrollDuration: function(offset) {
            var distance;
            if (this.options.animMode === 'speed') {
                distance = Math.abs(this.scrollContainer.scrollTop() - offset.top);
                return (distance / this.options.animSpeed) * 1000;
            } else {
                return this.options.animDuration;
            }
        },
        onClick: function(e) {
            var targetBlock = this.getAnchorTarget(e.currentTarget)
              , targetOffset = this.getTargetOffset(targetBlock);

            e.preventDefault();
            scrollTo(targetOffset, {
                container: this.container,
                wheelBehavior: this.options.wheelBehavior,
                duration: this.calculateScrollDuration(targetOffset)
            });
            this.makeCallback('onBeforeScroll', e.currentTarget);
        },
        makeCallback: function(name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        },
        destroy: function() {
            var self = this;

            this.isInit = false;
            if (this.options.activeClasses) {
                win.off('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
                this.scrollContainer.off('scroll', this.scrollHandler);
                $.each(this.anchorData, function(index) {
                    var reverseIndex = self.anchorData.length - index - 1
                      , data = self.anchorData[reverseIndex]
                      , anchorElement = (self.options.activeClasses === 'parent' ? data.link.parent() : data.link);

                    self.toggleActiveClass(anchorElement, data.block, false);
                });
            }
            this.anchorLinks.off('click', this.clickHandler);
        }
    };

    // public API
    $.extend(SmoothScroll, {
        scrollTo: function(blockOrOffset, durationOrOptions, callback) {
            scrollTo(blockOrOffset, durationOrOptions, callback);
        }
    });

    // export module
    exports.SmoothScroll = SmoothScroll;
}(jQuery, this));

/*!
 * SmoothScroll module
 */
;(function($, exports) {
    // private variables
    var page, win = $(window), activeBlock, activeWheelHandler, wheelEvents = ('onwheel'in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll');

    // animation handlers
    function scrollTo(offset, options, callback) {
        // initialize variables
        var scrollBlock;
        if (document.body) {
            if (typeof options === 'number') {
                options = {
                    duration: options
                };
            } else {
                options = options || {};
            }
            page = page || $('html, body');
            scrollBlock = options.container || page;
        } else {
            return;
        }

        // treat single number as scrollTop
        if (typeof offset === 'number') {
            offset = {
                top: offset
            };
        }

        // handle mousewheel/trackpad while animation is active
        if (activeBlock && activeWheelHandler) {
            activeBlock.off(wheelEvents, activeWheelHandler);
        }
        if (options.wheelBehavior && options.wheelBehavior !== 'none') {
            activeWheelHandler = function(e) {
                if (options.wheelBehavior === 'stop') {
                    scrollBlock.off(wheelEvents, activeWheelHandler);
                    scrollBlock.stop();
                } else if (options.wheelBehavior === 'ignore') {
                    e.preventDefault();
                }
            }
            ;
            activeBlock = scrollBlock.on(wheelEvents, activeWheelHandler);
        }

        // start scrolling animation
        scrollBlock.stop().animate({
            scrollLeft: offset.left,
            scrollTop: offset.top
        }, options.duration, function() {
            if (activeWheelHandler) {
                scrollBlock.off(wheelEvents, activeWheelHandler);
            }
            if ($.isFunction(callback)) {
                callback();
            }
        });
    }

    // smooth scroll contstructor
    function SmoothScroll(options) {
        this.options = $.extend({
            anchorLinks: 'a[href^="#"]',
            // selector or jQuery object
            container: null,
            // specify container for scrolling (default - whole page)
            extraOffset: null,
            // function or fixed number
            activeClasses: null,
            // null, "link", "parent"
            easing: 'swing',
            // easing of scrolling
            animMode: 'duration',
            // or "speed" mode
            animDuration: 800,
            // total duration for scroll (any distance)
            animSpeed: 1500,
            // pixels per second
            anchorActiveClass: 'anchor-active',
            sectionActiveClass: 'section-active',
            wheelBehavior: 'stop',
            // "stop", "ignore" or "none"
            useNativeAnchorScrolling: false // do not handle click in devices with native smooth scrolling
        }, options);
        this.init();
    }
    SmoothScroll.prototype = {
        init: function() {
            this.initStructure();
            this.attachEvents();
            this.isInit = true;
        },
        initStructure: function() {
            var self = this;

            this.container = this.options.container ? $(this.options.container) : $('html,body');
            this.scrollContainer = this.options.container ? this.container : win;
            this.anchorLinks = jQuery(this.options.anchorLinks).filter(function() {
                return jQuery(self.getAnchorTarget(jQuery(this))).length;
            });
        },
        getId: function(str) {
            try {
                return '#' + str.replace(/^.*?(#|$)/, '');
            } catch (err) {
                return null;
            }
        },
        getAnchorTarget: function(link) {
            // get target block from link href
            var targetId = this.getId($(link).attr('href'));
            return $(targetId.length > 1 ? targetId : 'html');
        },
        getTargetOffset: function(block) {
            // get target offset
            var blockOffset = block.offset().top;
            if (this.options.container) {
                blockOffset -= this.container.offset().top - this.container.prop('scrollTop');
            }

            // handle extra offset
            if (typeof this.options.extraOffset === 'number') {
                blockOffset -= this.options.extraOffset;
            } else if (typeof this.options.extraOffset === 'function') {
                blockOffset -= this.options.extraOffset(block);
            }
            return {
                top: blockOffset
            };
        },
        attachEvents: function() {
            var self = this;

            // handle active classes
            if (this.options.activeClasses && this.anchorLinks.length) {
                // cache structure
                this.anchorData = [];

                for (var i = 0; i < this.anchorLinks.length; i++) {
                    var link = jQuery(this.anchorLinks[i])
                      , targetBlock = self.getAnchorTarget(link)
                      , anchorDataItem = null;

                    $.each(self.anchorData, function(index, item) {
                        if (item.block[0] === targetBlock[0]) {
                            anchorDataItem = item;
                        }
                    });

                    if (anchorDataItem) {
                        anchorDataItem.link = anchorDataItem.link.add(link);
                    } else {
                        self.anchorData.push({
                            link: link,
                            block: targetBlock
                        });
                    }
                }
                ;
                // add additional event handlers
                this.resizeHandler = function() {
                    if (!self.isInit)
                        return;
                    self.recalculateOffsets();
                }
                ;
                this.scrollHandler = function() {
                    self.refreshActiveClass();
                }
                ;

                this.recalculateOffsets();
                this.scrollContainer.on('scroll', this.scrollHandler);
                win.on('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
            }

            // handle click event
            this.clickHandler = function(e) {
                self.onClick(e);
            }
            ;
            if (!this.options.useNativeAnchorScrolling) {
                this.anchorLinks.on('click', this.clickHandler);
            }
        },
        recalculateOffsets: function() {
            var self = this;
            $.each(this.anchorData, function(index, data) {
                data.offset = self.getTargetOffset(data.block);
                data.height = data.block.outerHeight();
            });
            this.refreshActiveClass();
        },
        toggleActiveClass: function(anchor, block, state) {
            anchor.toggleClass(this.options.anchorActiveClass, state);
            block.toggleClass(this.options.sectionActiveClass, state);
        },
        refreshActiveClass: function() {
            var self = this
              , foundFlag = false
              , containerHeight = this.container.prop('scrollHeight')
              , viewPortHeight = this.scrollContainer.height()
              , scrollTop = this.options.container ? this.container.prop('scrollTop') : win.scrollTop();

            // user function instead of default handler
            if (this.options.customScrollHandler) {
                this.options.customScrollHandler.call(this, scrollTop, this.anchorData);
                return;
            }

            // sort anchor data by offsets
            this.anchorData.sort(function(a, b) {
                return a.offset.top - b.offset.top;
            });

            // default active class handler
            $.each(this.anchorData, function(index) {
                var reverseIndex = self.anchorData.length - index - 1
                  , data = self.anchorData[reverseIndex]
                  , anchorElement = (self.options.activeClasses === 'parent' ? data.link.parent() : data.link);

                if (scrollTop >= containerHeight - viewPortHeight) {
                    // handle last section
                    if (reverseIndex === self.anchorData.length - 1) {
                        self.toggleActiveClass(anchorElement, data.block, true);
                    } else {
                        self.toggleActiveClass(anchorElement, data.block, false);
                    }
                } else {
                    // handle other sections
                    if (!foundFlag && (scrollTop >= data.offset.top - 1 || reverseIndex === 0)) {
                        foundFlag = true;
                        self.toggleActiveClass(anchorElement, data.block, true);
                    } else {
                        self.toggleActiveClass(anchorElement, data.block, false);
                    }
                }
            });
        },
        calculateScrollDuration: function(offset) {
            var distance;
            if (this.options.animMode === 'speed') {
                distance = Math.abs(this.scrollContainer.scrollTop() - offset.top);
                return (distance / this.options.animSpeed) * 1000;
            } else {
                return this.options.animDuration;
            }
        },
        onClick: function(e) {
            var targetBlock = this.getAnchorTarget(e.currentTarget)
              , targetOffset = this.getTargetOffset(targetBlock);

            e.preventDefault();
            scrollTo(targetOffset, {
                container: this.container,
                wheelBehavior: this.options.wheelBehavior,
                duration: this.calculateScrollDuration(targetOffset)
            });
            this.makeCallback('onBeforeScroll', e.currentTarget);
            setTimeout(()=>{
                var targetBlock = this.getAnchorTarget(e.currentTarget)
                  , targetOffset = this.getTargetOffset(targetBlock);

                e.preventDefault();
                scrollTo(targetOffset, {
                    container: this.container,
                    wheelBehavior: this.options.wheelBehavior,
                    duration: this.calculateScrollDuration(targetOffset)
                });
                this.makeCallback('onBeforeScroll', e.currentTarget);
            }
            , 850)
        },
        makeCallback: function(name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        },
        destroy: function() {
            var self = this;

            this.isInit = false;
            if (this.options.activeClasses) {
                win.off('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
                this.scrollContainer.off('scroll', this.scrollHandler);
                $.each(this.anchorData, function(index) {
                    var reverseIndex = self.anchorData.length - index - 1
                      , data = self.anchorData[reverseIndex]
                      , anchorElement = (self.options.activeClasses === 'parent' ? data.link.parent() : data.link);

                    self.toggleActiveClass(anchorElement, data.block, false);
                });
            }
            this.anchorLinks.off('click', this.clickHandler);
        }
    };

    // public API
    $.extend(SmoothScroll, {
        scrollTo: function(blockOrOffset, durationOrOptions, callback) {
            scrollTo(blockOrOffset, durationOrOptions, callback);
        }
    });

    // export module
    exports.SmoothScrollPdp = SmoothScroll;
}(jQuery, this));

/*
 * Simple Mobile Navigation
 */
;(function($) {
    function MobileNav(options) {
        this.options = $.extend({
            container: null,
            hideOnClickOutside: false,
            menuActiveClass: 'nav-active',
            menuOpener: '.nav-opener',
            menuDrop: '.nav-drop',
            toggleEvent: 'click',
            outsideClickEvent: 'click touchstart pointerdown MSPointerDown'
        }, options);
        this.initStructure();
        this.attachEvents();
    }
    MobileNav.prototype = {
        initStructure: function() {
            this.page = $('html');
            this.container = $(this.options.container);
            this.opener = this.container.find(this.options.menuOpener);
            this.drop = this.container.find(this.options.menuDrop);
        },
        attachEvents: function() {
            var self = this;

            if (activateResizeHandler) {
                activateResizeHandler();
                activateResizeHandler = null;
            }

            this.outsideClickHandler = function(e) {
                if (self.isOpened()) {
                    var target = $(e.target);
                    if (!target.closest(self.opener).length && !target.closest(self.drop).length) {
                        self.hide();
                    }
                }
            }
            ;

            this.openerClickHandler = function(e) {
                e.preventDefault();
                self.toggle();
            }
            ;

            this.opener.on(this.options.toggleEvent, this.openerClickHandler);
        },
        isOpened: function() {
            return this.container.hasClass(this.options.menuActiveClass);
        },
        show: function() {
            this.container.addClass(this.options.menuActiveClass);
            if (this.options.hideOnClickOutside) {
                this.page.on(this.options.outsideClickEvent, this.outsideClickHandler);
            }
        },
        hide: function() {
            this.container.removeClass(this.options.menuActiveClass);
            if (this.options.hideOnClickOutside) {
                this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
            }
        },
        toggle: function() {
            if (this.isOpened()) {
                this.hide();
            } else {
                this.show();
            }
        },
        destroy: function() {
            this.container.removeClass(this.options.menuActiveClass);
            this.opener.off(this.options.toggleEvent, this.clickHandler);
            this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
        }
    };

    var activateResizeHandler = function() {
        var win = $(window), doc = $('html'), resizeClass = 'resize-active', flag, timer;
        var removeClassHandler = function() {
            flag = false;
            doc.removeClass(resizeClass);
        };
        var resizeHandler = function() {
            if (!flag) {
                flag = true;
                doc.addClass(resizeClass);
            }
            clearTimeout(timer);
            timer = setTimeout(removeClassHandler, 500);
        };
        win.on('resize orientationchange', resizeHandler);
    };

    $.fn.mobileNav = function(opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function() {
            var $container = jQuery(this);
            var instance = $container.data('MobileNav');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $container.data('MobileNav', new MobileNav($.extend({
                    container: this
                }, opt)));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    }
    ;
}(jQuery));

/*
 * jQuery Accordion plugin
 */
;(function(root, factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.SlideAccordion = factory(jQuery);
    }
}(this, function($) {
    'use strict';
    var accHiddenClass = 'js-acc-hidden';

    function SlideAccordion(options) {
        this.options = $.extend(true, {
            allowClickWhenExpanded: false,
            activeClass: 'active',
            opener: '.opener',
            slider: '.slide',
            animSpeed: 300,
            collapsible: true,
            event: 'click',
            scrollToActiveItem: {
                enable: false,
                breakpoint: 767,
                // max-width
                animSpeed: 600,
                extraOffset: null
            }
        }, options);
        this.init();
    }

    SlideAccordion.prototype = {
        init: function() {
            if (this.options.holder) {
                this.findElements();
                this.setStateOnInit();
                this.attachEvents();
                this.makeCallback('onInit');
            }
        },

        findElements: function() {
            this.$holder = $(this.options.holder).data('SlideAccordion', this);
            this.$items = this.$holder.find(':has(' + this.options.slider + ')');
        },

        setStateOnInit: function() {
            var self = this;

            this.$items.each(function() {
                if (!$(this).hasClass(self.options.activeClass)) {
                    $(this).find(self.options.slider).addClass(accHiddenClass);
                }
            });
        },

        attachEvents: function() {
            var self = this;

            this.accordionToggle = function(e) {
                var $item = jQuery(this).closest(self.$items);
                var $actiItem = self.getActiveItem($item);

                if (!self.options.allowClickWhenExpanded || !$item.hasClass(self.options.activeClass)) {
                    e.preventDefault();
                    self.toggle($item, $actiItem);
                }
            }
            ;

            this.$items.on(this.options.event, this.options.opener, this.accordionToggle);
        },

        toggle: function($item, $prevItem) {
            if (!$item.hasClass(this.options.activeClass)) {
                this.show($item);
            } else if (this.options.collapsible) {
                this.hide($item);
            }

            if (!$item.is($prevItem) && $prevItem.length) {
                this.hide($prevItem);
            }

            this.makeCallback('beforeToggle');
        },

        show: function($item) {
            var $slider = $item.find(this.options.slider);

            $item.addClass(this.options.activeClass);
            $slider.stop().hide().removeClass(accHiddenClass).slideDown({
                duration: this.options.animSpeed,
                complete: function() {
                    $slider.removeAttr('style');
                    if (this.options.scrollToActiveItem.enable && window.innerWidth <= this.options.scrollToActiveItem.breakpoint) {
                        this.goToItem($item);
                    }
                    this.makeCallback('onShow', $item);
                }
                .bind(this)
            });

            this.makeCallback('beforeShow', $item);
        },

        hide: function($item) {
            var $slider = $item.find(this.options.slider);

            $item.removeClass(this.options.activeClass);
            $slider.stop().show().slideUp({
                duration: this.options.animSpeed,
                complete: function() {
                    $slider.addClass(accHiddenClass);
                    $slider.removeAttr('style');
                    this.makeCallback('onHide', $item);
                }
                .bind(this)
            });

            this.makeCallback('beforeHide', $item);
        },

        goToItem: function($item) {
            var itemOffset = $item.offset().top;

            if (itemOffset < $(window).scrollTop()) {
                // handle extra offset
                if (typeof this.options.scrollToActiveItem.extraOffset === 'number') {
                    itemOffset -= this.options.scrollToActiveItem.extraOffset;
                } else if (typeof this.options.scrollToActiveItem.extraOffset === 'function') {
                    itemOffset -= this.options.scrollToActiveItem.extraOffset();
                }

                $('body, html').animate({
                    scrollTop: itemOffset
                }, this.options.scrollToActiveItem.animSpeed);
            }
        },

        getActiveItem: function($item) {
            return $item.siblings().filter('.' + this.options.activeClass);
        },

        makeCallback: function(name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        },

        destroy: function() {
            this.$holder.removeData('SlideAccordion');
            this.$items.off(this.options.event, this.options.opener, this.accordionToggle);
            this.$items.removeClass(this.options.activeClass).each(function(i, item) {
                $(item).find(this.options.slider).removeAttr('style').removeClass(accHiddenClass);
            }
            .bind(this));
            this.makeCallback('onDestroy');
        }
    };

    $.fn.slideAccordion = function(opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function() {
            var $holder = jQuery(this);
            var instance = $holder.data('SlideAccordion');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                new SlideAccordion($.extend(true, {
                    holder: this
                }, opt));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    }
    ;

    (function() {
        var tabStyleSheet = $('<style type="text/css">')[0];
        var tabStyleRule = '.' + accHiddenClass;
        tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important; width: 100% !important;}';
        if (tabStyleSheet.styleSheet) {
            tabStyleSheet.styleSheet.cssText = tabStyleRule;
        } else {
            tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
        }
        $('head').append(tabStyleSheet);
    }());

    return SlideAccordion;
}));

// Cart.js
// version: 1.0.2
// author: Gavin Ballard
// license: MIT
(function() {
    function a(a, c, d, e) {
        return new b(a,c,d,e)
    }
    function b(a, b, d, e) {
        this.options = e || {},
        this.options.adapters = this.options.adapters || {},
        this.obj = a,
        this.keypath = b,
        this.callback = d,
        this.objectPath = [],
        this.update = this.update.bind(this),
        this.parse(),
        c(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback)
    }
    function c(a) {
        return "object" == typeof a && null !== a
    }
    function d(a) {
        throw new Error("[sightglass] " + a)
    }
    a.adapters = {},
    b.tokenize = function(a, b, c) {
        var d, e, f = [], g = {
            i: c,
            path: ""
        };
        for (d = 0; d < a.length; d++)
            e = a.charAt(d),
            ~b.indexOf(e) ? (f.push(g),
            g = {
                i: e,
                path: ""
            }) : g.path += e;
        return f.push(g),
        f
    }
    ,
    b.prototype.parse = function() {
        var c, e, f = this.interfaces();
        f.length || d("Must define at least one adapter interface."),
        ~f.indexOf(this.keypath[0]) ? (c = this.keypath[0],
        e = this.keypath.substr(1)) : ("undefined" == typeof (c = this.options.root || a.root) && d("Must define a default root adapter."),
        e = this.keypath),
        this.tokens = b.tokenize(e, f, c),
        this.key = this.tokens.pop()
    }
    ,
    b.prototype.realize = function() {
        var a, b = this.obj, d = !1;
        return this.tokens.forEach(function(e, f) {
            c(b) ? ("undefined" != typeof this.objectPath[f] ? b !== (a = this.objectPath[f]) && (this.set(!1, e, a, this.update),
            this.set(!0, e, b, this.update),
            this.objectPath[f] = b) : (this.set(!0, e, b, this.update),
            this.objectPath[f] = b),
            b = this.get(e, b)) : (d === !1 && (d = f),
            (a = this.objectPath[f]) && this.set(!1, e, a, this.update))
        }, this),
        d !== !1 && this.objectPath.splice(d),
        b
    }
    ,
    b.prototype.update = function() {
        var a, b;
        (a = this.realize()) !== this.target && (c(this.target) && this.set(!1, this.key, this.target, this.callback),
        c(a) && this.set(!0, this.key, a, this.callback),
        b = this.value(),
        this.target = a,
        (this.value()instanceof Function || this.value() !== b) && this.callback())
    }
    ,
    b.prototype.value = function() {
        return c(this.target) ? this.get(this.key, this.target) : void 0
    }
    ,
    b.prototype.setValue = function(a) {
        c(this.target) && this.adapter(this.key).set(this.target, this.key.path, a)
    }
    ,
    b.prototype.get = function(a, b) {
        return this.adapter(a).get(b, a.path)
    }
    ,
    b.prototype.set = function(a, b, c, d) {
        var e = a ? "observe" : "unobserve";
        this.adapter(b)[e](c, b.path, d)
    }
    ,
    b.prototype.interfaces = function() {
        var b = Object.keys(this.options.adapters);
        return Object.keys(a.adapters).forEach(function(a) {
            ~b.indexOf(a) || b.push(a)
        }),
        b
    }
    ,
    b.prototype.adapter = function(b) {
        return this.options.adapters[b.i] || a.adapters[b.i]
    }
    ,
    b.prototype.unobserve = function() {
        var a;
        this.tokens.forEach(function(b, c) {
            (a = this.objectPath[c]) && this.set(!1, b, a, this.update)
        }, this),
        c(this.target) && this.set(!1, this.key, this.target, this.callback)
    }
    ,
    "undefined" != typeof module && module.exports ? module.exports = a : "function" == typeof define && define.amd ? define([], function() {
        return this.sightglass = a
    }) : this.sightglass = a
}
).call(this),
function() {
    var a, b, c, d, e = function(a, b) {
        return function() {
            return a.apply(b, arguments)
        }
    }, f = [].slice, g = {}.hasOwnProperty, h = function(a, b) {
        function c() {
            this.constructor = a
        }
        for (var d in b)
            g.call(b, d) && (a[d] = b[d]);
        return c.prototype = b.prototype,
        a.prototype = new c,
        a.__super__ = b.prototype,
        a
    }, i = [].indexOf || function(a) {
        for (var b = 0, c = this.length; c > b; b++)
            if (b in this && this[b] === a)
                return b;
        return -1
    }
    ;
    a = {
        options: ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"],
        extensions: ["binders", "formatters", "components", "adapters"],
        "public": {
            binders: {},
            components: {},
            formatters: {},
            adapters: {},
            prefix: "data-rv",
            templateDelimiters: ["{", "}"],
            rootInterface: ".",
            preloadData: !0,
            handler: function(a, b, c) {
                return this.call(a, b, c.view.models)
            },
            configure: function(b) {
                var c, d, e, f;
                null == b && (b = {});
                for (e in b)
                    if (f = b[e],
                    "binders" === e || "components" === e || "formatters" === e || "adapters" === e)
                        for (d in f)
                            c = f[d],
                            a[e][d] = c;
                    else
                        a["public"][e] = f
            },
            bind: function(b, c, d) {
                var e;
                return null == c && (c = {}),
                null == d && (d = {}),
                e = new a.View(b,c,d),
                e.bind(),
                e
            },
            init: function(b, c, d) {
                var e, f;
                return null == d && (d = {}),
                null == c && (c = document.createElement("div")),
                b = a["public"].components[b],
                c.innerHTML = b.template.call(this, c),
                e = b.initialize.call(this, c, d),
                f = new a.View(c,e),
                f.bind(),
                f
            }
        }
    },
    window.jQuery || window.$ ? (d = "on"in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"],
    b = d[0],
    c = d[1],
    a.Util = {
        bindEvent: function(a, c, d) {
            return jQuery(a)[b](c, d)
        },
        unbindEvent: function(a, b, d) {
            return jQuery(a)[c](b, d)
        },
        getInputValue: function(a) {
            var b;
            return b = jQuery(a),
            "checkbox" === b.attr("type") ? b.is(":checked") : b.val()
        }
    }) : a.Util = {
        bindEvent: function() {
            return "addEventListener"in window ? function(a, b, c) {
                return a.addEventListener(b, c, !1)
            }
            : function(a, b, c) {
                return a.attachEvent("on" + b, c)
            }
        }(),
        unbindEvent: function() {
            return "removeEventListener"in window ? function(a, b, c) {
                return a.removeEventListener(b, c, !1)
            }
            : function(a, b, c) {
                return a.detachEvent("on" + b, c)
            }
        }(),
        getInputValue: function(a) {
            var b, c, d, e;
            if ("checkbox" === a.type)
                return a.checked;
            if ("select-multiple" === a.type) {
                for (e = [],
                c = 0,
                d = a.length; d > c; c++)
                    b = a[c],
                    b.selected && e.push(b.value);
                return e
            }
            return a.value
        }
    },
    a.TypeParser = function() {
        function a() {}
        return a.types = {
            primitive: 0,
            keypath: 1
        },
        a.parse = function(a) {
            return /^'.*'$|^".*"$/.test(a) ? {
                type: this.types.primitive,
                value: a.slice(1, -1)
            } : "true" === a ? {
                type: this.types.primitive,
                value: !0
            } : "false" === a ? {
                type: this.types.primitive,
                value: !1
            } : "null" === a ? {
                type: this.types.primitive,
                value: null
            } : "undefined" === a ? {
                type: this.types.primitive,
                value: void 0
            } : isNaN(Number(a)) === !1 ? {
                type: this.types.primitive,
                value: Number(a)
            } : {
                type: this.types.keypath,
                value: a
            }
        }
        ,
        a
    }(),
    a.TextTemplateParser = function() {
        function a() {}
        return a.types = {
            text: 0,
            binding: 1
        },
        a.parse = function(a, b) {
            var c, d, e, f, g, h, i;
            for (h = [],
            f = a.length,
            c = 0,
            d = 0; f > d; ) {
                if (c = a.indexOf(b[0], d),
                0 > c) {
                    h.push({
                        type: this.types.text,
                        value: a.slice(d)
                    });
                    break
                }
                if (c > 0 && c > d && h.push({
                    type: this.types.text,
                    value: a.slice(d, c)
                }),
                d = c + b[0].length,
                c = a.indexOf(b[1], d),
                0 > c) {
                    g = a.slice(d - b[1].length),
                    e = h[h.length - 1],
                    (null != e ? e.type : void 0) === this.types.text ? e.value += g : h.push({
                        type: this.types.text,
                        value: g
                    });
                    break
                }
                i = a.slice(d, c).trim(),
                h.push({
                    type: this.types.binding,
                    value: i
                }),
                d = c + b[1].length
            }
            return h
        }
        ,
        a
    }(),
    a.View = function() {
        function b(b, c, d) {
            var f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (this.els = b,
            this.models = c,
            null == d && (d = {}),
            this.update = e(this.update, this),
            this.publish = e(this.publish, this),
            this.sync = e(this.sync, this),
            this.unbind = e(this.unbind, this),
            this.bind = e(this.bind, this),
            this.select = e(this.select, this),
            this.traverse = e(this.traverse, this),
            this.build = e(this.build, this),
            this.buildBinding = e(this.buildBinding, this),
            this.bindingRegExp = e(this.bindingRegExp, this),
            this.options = e(this.options, this),
            this.els.jquery || this.els instanceof Array || (this.els = [this.els]),
            n = a.extensions,
            j = 0,
            l = n.length; l > j; j++) {
                if (g = n[j],
                this[g] = {},
                d[g]) {
                    o = d[g];
                    for (f in o)
                        h = o[f],
                        this[g][f] = h
                }
                p = a["public"][g];
                for (f in p)
                    h = p[f],
                    null == (i = this[g])[f] && (i[f] = h)
            }
            for (q = a.options,
            k = 0,
            m = q.length; m > k; k++)
                g = q[k],
                this[g] = null != (r = d[g]) ? r : a["public"][g];
            this.build()
        }
        return b.prototype.options = function() {
            var b, c, d, e, f;
            for (c = {},
            f = a.extensions.concat(a.options),
            d = 0,
            e = f.length; e > d; d++)
                b = f[d],
                c[b] = this[b];
            return c
        }
        ,
        b.prototype.bindingRegExp = function() {
            return new RegExp("^" + this.prefix + "-")
        }
        ,
        b.prototype.buildBinding = function(b, c, d, e) {
            var f, g, h, i, j, k, l;
            return j = {},
            l = function() {
                var a, b, c, d;
                for (c = e.split("|"),
                d = [],
                a = 0,
                b = c.length; b > a; a++)
                    k = c[a],
                    d.push(k.trim());
                return d
            }(),
            f = function() {
                var a, b, c, d;
                for (c = l.shift().split("<"),
                d = [],
                a = 0,
                b = c.length; b > a; a++)
                    g = c[a],
                    d.push(g.trim());
                return d
            }(),
            i = f.shift(),
            j.formatters = l,
            (h = f.shift()) && (j.dependencies = h.split(/\s+/)),
            this.bindings.push(new a[b](this,c,d,i,j))
        }
        ,
        b.prototype.build = function() {
            var b, c, d, e, f;
            for (this.bindings = [],
            c = function(b) {
                return function(d) {
                    var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                    if (3 === d.nodeType) {
                        if (i = a.TextTemplateParser,
                        (g = b.templateDelimiters) && (l = i.parse(d.data, g)).length && (1 !== l.length || l[0].type !== i.types.text)) {
                            for (m = 0,
                            o = l.length; o > m; m++)
                                k = l[m],
                                j = document.createTextNode(k.value),
                                d.parentNode.insertBefore(j, d),
                                1 === k.type && b.buildBinding("TextBinding", j, null, k.value);
                            d.parentNode.removeChild(d)
                        }
                    } else
                        1 === d.nodeType && (e = b.traverse(d));
                    if (!e) {
                        for (q = function() {
                            var a, b, c, e;
                            for (c = d.childNodes,
                            e = [],
                            a = 0,
                            b = c.length; b > a; a++)
                                h = c[a],
                                e.push(h);
                            return e
                        }(),
                        r = [],
                        n = 0,
                        p = q.length; p > n; n++)
                            f = q[n],
                            r.push(c(f));
                        return r
                    }
                }
            }(this),
            f = this.els,
            d = 0,
            e = f.length; e > d; d++)
                b = f[d],
                c(b);
            this.bindings.sort(function(a, b) {
                var c, d;
                return ((null != (c = b.binder) ? c.priority : void 0) || 0) - ((null != (d = a.binder) ? d.priority : void 0) || 0)
            })
        }
        ,
        b.prototype.traverse = function(b) {
            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (f = this.bindingRegExp(),
            g = "SCRIPT" === b.nodeName || "STYLE" === b.nodeName,
            p = b.attributes,
            l = 0,
            n = p.length; n > l; l++)
                if (c = p[l],
                f.test(c.name)) {
                    if (j = c.name.replace(f, ""),
                    !(e = this.binders[j])) {
                        q = this.binders;
                        for (h in q)
                            k = q[h],
                            "*" !== h && -1 !== h.indexOf("*") && (i = new RegExp("^" + h.replace(/\*/g, ".+") + "$"),
                            i.test(j) && (e = k))
                    }
                    e || (e = this.binders["*"]),
                    e.block && (g = !0,
                    d = [c])
                }
            for (r = d || b.attributes,
            m = 0,
            o = r.length; o > m; m++)
                c = r[m],
                f.test(c.name) && (j = c.name.replace(f, ""),
                this.buildBinding("Binding", b, j, c.value));
            return g || (j = b.nodeName.toLowerCase(),
            this.components[j] && !b._bound && (this.bindings.push(new a.ComponentBinding(this,b,j)),
            g = !0)),
            g
        }
        ,
        b.prototype.select = function(a) {
            var b, c, d, e, f;
            for (e = this.bindings,
            f = [],
            c = 0,
            d = e.length; d > c; c++)
                b = e[c],
                a(b) && f.push(b);
            return f
        }
        ,
        b.prototype.bind = function() {
            var a, b, c, d, e;
            for (d = this.bindings,
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push(a.bind());
            return e
        }
        ,
        b.prototype.unbind = function() {
            var a, b, c, d, e;
            for (d = this.bindings,
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push(a.unbind());
            return e
        }
        ,
        b.prototype.sync = function() {
            var a, b, c, d, e;
            for (d = this.bindings,
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push("function" == typeof a.sync ? a.sync() : void 0);
            return e
        }
        ,
        b.prototype.publish = function() {
            var a, b, c, d, e;
            for (d = this.select(function(a) {
                var b;
                return null != (b = a.binder) ? b.publishes : void 0
            }),
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push(a.publish());
            return e
        }
        ,
        b.prototype.update = function(a) {
            var b, c, d, e, f, g, h;
            null == a && (a = {});
            for (c in a)
                d = a[c],
                this.models[c] = d;
            for (g = this.bindings,
            h = [],
            e = 0,
            f = g.length; f > e; e++)
                b = g[e],
                h.push("function" == typeof b.update ? b.update(a) : void 0);
            return h
        }
        ,
        b
    }(),
    a.Binding = function() {
        function b(a, b, c, d, f) {
            this.view = a,
            this.el = b,
            this.type = c,
            this.keypath = d,
            this.options = null != f ? f : {},
            this.getValue = e(this.getValue, this),
            this.update = e(this.update, this),
            this.unbind = e(this.unbind, this),
            this.bind = e(this.bind, this),
            this.publish = e(this.publish, this),
            this.sync = e(this.sync, this),
            this.set = e(this.set, this),
            this.eventHandler = e(this.eventHandler, this),
            this.formattedValue = e(this.formattedValue, this),
            this.parseTarget = e(this.parseTarget, this),
            this.observe = e(this.observe, this),
            this.setBinder = e(this.setBinder, this),
            this.formatters = this.options.formatters || [],
            this.dependencies = [],
            this.formatterObservers = {},
            this.model = void 0,
            this.setBinder()
        }
        return b.prototype.setBinder = function() {
            var a, b, c, d;
            if (!(this.binder = this.view.binders[this.type])) {
                d = this.view.binders;
                for (a in d)
                    c = d[a],
                    "*" !== a && -1 !== a.indexOf("*") && (b = new RegExp("^" + a.replace(/\*/g, ".+") + "$"),
                    b.test(this.type) && (this.binder = c,
                    this.args = new RegExp("^" + a.replace(/\*/g, "(.+)") + "$").exec(this.type),
                    this.args.shift()))
            }
            return this.binder || (this.binder = this.view.binders["*"]),
            this.binder instanceof Function ? this.binder = {
                routine: this.binder
            } : void 0
        }
        ,
        b.prototype.observe = function(b, c, d) {
            return a.sightglass(b, c, d, {
                root: this.view.rootInterface,
                adapters: this.view.adapters
            })
        }
        ,
        b.prototype.parseTarget = function() {
            var b;
            return b = a.TypeParser.parse(this.keypath),
            0 === b.type ? this.value = b.value : (this.observer = this.observe(this.view.models, this.keypath, this.sync),
            this.model = this.observer.target)
        }
        ,
        b.prototype.formattedValue = function(b) {
            var c, d, e, g, h, i, j, k, l, m, n, o, p, q;
            for (q = this.formatters,
            g = m = 0,
            o = q.length; o > m; g = ++m) {
                for (h = q[g],
                e = h.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g),
                i = e.shift(),
                h = this.view.formatters[i],
                e = function() {
                    var b, c, f;
                    for (f = [],
                    b = 0,
                    c = e.length; c > b; b++)
                        d = e[b],
                        f.push(a.TypeParser.parse(d));
                    return f
                }(),
                k = [],
                c = n = 0,
                p = e.length; p > n; c = ++n)
                    d = e[c],
                    k.push(0 === d.type ? d.value : ((l = this.formatterObservers)[g] || (l[g] = {}),
                    (j = this.formatterObservers[g][c]) ? void 0 : (j = this.observe(this.view.models, d.value, this.sync),
                    this.formatterObservers[g][c] = j),
                    j.value()));
                (null != h ? h.read : void 0)instanceof Function ? b = h.read.apply(h, [b].concat(f.call(k))) : h instanceof Function && (b = h.apply(null, [b].concat(f.call(k))))
            }
            return b
        }
        ,
        b.prototype.eventHandler = function(a) {
            var b, c;
            return c = (b = this).view.handler,
            function(d) {
                return c.call(a, this, d, b)
            }
        }
        ,
        b.prototype.set = function(a) {
            var b;
            return a = this.formattedValue(a instanceof Function && !this.binder["function"] ? a.call(this.model) : a),
            null != (b = this.binder.routine) ? b.call(this, this.el, a) : void 0
        }
        ,
        b.prototype.sync = function() {
            var a, b;
            return this.set(function() {
                var c, d, e, f, g, h, i;
                if (this.observer) {
                    if (this.model !== this.observer.target) {
                        for (g = this.dependencies,
                        c = 0,
                        e = g.length; e > c; c++)
                            b = g[c],
                            b.unobserve();
                        if (this.dependencies = [],
                        null != (this.model = this.observer.target) && (null != (h = this.options.dependencies) ? h.length : void 0))
                            for (i = this.options.dependencies,
                            d = 0,
                            f = i.length; f > d; d++)
                                a = i[d],
                                b = this.observe(this.model, a, this.sync),
                                this.dependencies.push(b)
                    }
                    return this.observer.value()
                }
                return this.value
            }
            .call(this))
        }
        ,
        b.prototype.publish = function() {
            var a, b, c, d, e, g, h, i, j;
            if (this.observer) {
                for (d = this.getValue(this.el),
                h = this.formatters.slice(0).reverse(),
                e = 0,
                g = h.length; g > e; e++)
                    b = h[e],
                    a = b.split(/\s+/),
                    c = a.shift(),
                    (null != (i = this.view.formatters[c]) ? i.publish : void 0) && (d = (j = this.view.formatters[c]).publish.apply(j, [d].concat(f.call(a))));
                return this.observer.setValue(d)
            }
        }
        ,
        b.prototype.bind = function() {
            var a, b, c, d, e, f, g;
            if (this.parseTarget(),
            null != (e = this.binder.bind) && e.call(this, this.el),
            null != this.model && (null != (f = this.options.dependencies) ? f.length : void 0))
                for (g = this.options.dependencies,
                c = 0,
                d = g.length; d > c; c++)
                    a = g[c],
                    b = this.observe(this.model, a, this.sync),
                    this.dependencies.push(b);
            return this.view.preloadData ? this.sync() : void 0
        }
        ,
        b.prototype.unbind = function() {
            var a, b, c, d, e, f, g, h, i, j;
            for (null != (g = this.binder.unbind) && g.call(this, this.el),
            null != (h = this.observer) && h.unobserve(),
            i = this.dependencies,
            e = 0,
            f = i.length; f > e; e++)
                d = i[e],
                d.unobserve();
            this.dependencies = [],
            j = this.formatterObservers;
            for (c in j) {
                b = j[c];
                for (a in b)
                    d = b[a],
                    d.unobserve()
            }
            return this.formatterObservers = {}
        }
        ,
        b.prototype.update = function(a) {
            var b, c;
            return null == a && (a = {}),
            this.model = null != (b = this.observer) ? b.target : void 0,
            null != (c = this.binder.update) ? c.call(this, a) : void 0
        }
        ,
        b.prototype.getValue = function(b) {
            return this.binder && null != this.binder.getValue ? this.binder.getValue.call(this, b) : a.Util.getInputValue(b)
        }
        ,
        b
    }(),
    a.ComponentBinding = function(b) {
        function c(a, b, c) {
            var d, f, g, h, j, k, l;
            for (this.view = a,
            this.el = b,
            this.type = c,
            this.unbind = e(this.unbind, this),
            this.bind = e(this.bind, this),
            this.locals = e(this.locals, this),
            this.component = this.view.components[this.type],
            this["static"] = {},
            this.observers = {},
            this.upstreamObservers = {},
            f = a.bindingRegExp(),
            k = this.el.attributes || [],
            h = 0,
            j = k.length; j > h; h++)
                d = k[h],
                f.test(d.name) || (g = this.camelCase(d.name),
                i.call(null != (l = this.component["static"]) ? l : [], g) >= 0 ? this["static"][g] = d.value : this.observers[g] = d.value)
        }
        return h(c, b),
        c.prototype.sync = function() {}
        ,
        c.prototype.update = function() {}
        ,
        c.prototype.publish = function() {}
        ,
        c.prototype.locals = function() {
            var a, b, c, d, e, f;
            c = {},
            e = this["static"];
            for (a in e)
                d = e[a],
                c[a] = d;
            f = this.observers;
            for (a in f)
                b = f[a],
                c[a] = b.value();
            return c
        }
        ,
        c.prototype.camelCase = function(a) {
            return a.replace(/-([a-z])/g, function(a) {
                return a[1].toUpperCase()
            })
        }
        ,
        c.prototype.bind = function() {
            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
            if (!this.bound) {
                o = this.observers;
                for (c in o)
                    d = o[c],
                    this.observers[c] = this.observe(this.view.models, d, function(a) {
                        return function(b) {
                            return function() {
                                return a.componentView.models[b] = a.observers[b].value()
                            }
                        }
                    }(this).call(this, c));
                this.bound = !0
            }
            if (null != this.componentView)
                return this.componentView.bind();
            for (this.el.innerHTML = this.component.template.call(this),
            h = this.component.initialize.call(this, this.el, this.locals()),
            this.el._bound = !0,
            g = {},
            p = a.extensions,
            k = 0,
            m = p.length; m > k; k++) {
                if (f = p[k],
                g[f] = {},
                this.component[f]) {
                    q = this.component[f];
                    for (b in q)
                        i = q[b],
                        g[f][b] = i
                }
                r = this.view[f];
                for (b in r)
                    i = r[b],
                    null == (j = g[f])[b] && (j[b] = i)
            }
            for (s = a.options,
            l = 0,
            n = s.length; n > l; l++)
                f = s[l],
                g[f] = null != (t = this.component[f]) ? t : this.view[f];
            this.componentView = new a.View(this.el,h,g),
            this.componentView.bind(),
            u = this.observers,
            v = [];
            for (c in u)
                e = u[c],
                v.push(this.upstreamObservers[c] = this.observe(this.componentView.models, c, function(a) {
                    return function(b, c) {
                        return function() {
                            return c.setValue(a.componentView.models[b])
                        }
                    }
                }(this).call(this, c, e)));
            return v
        }
        ,
        c.prototype.unbind = function() {
            var a, b, c, d, e;
            c = this.upstreamObservers;
            for (a in c)
                b = c[a],
                b.unobserve();
            d = this.observers;
            for (a in d)
                b = d[a],
                b.unobserve();
            return null != (e = this.componentView) ? e.unbind.call(this) : void 0
        }
        ,
        c
    }(a.Binding),
    a.TextBinding = function(a) {
        function b(a, b, c, d, f) {
            this.view = a,
            this.el = b,
            this.type = c,
            this.keypath = d,
            this.options = null != f ? f : {},
            this.sync = e(this.sync, this),
            this.formatters = this.options.formatters || [],
            this.dependencies = [],
            this.formatterObservers = {}
        }
        return h(b, a),
        b.prototype.binder = {
            routine: function(a, b) {
                return a.data = null != b ? b : ""
            }
        },
        b.prototype.sync = function() {
            return b.__super__.sync.apply(this, arguments)
        }
        ,
        b
    }(a.Binding),
    a["public"].binders.text = function(a, b) {
        return null != a.textContent ? a.textContent = null != b ? b : "" : a.innerText = null != b ? b : ""
    }
    ,
    a["public"].binders.html = function(a, b) {
        return a.innerHTML = null != b ? b : ""
    }
    ,
    a["public"].binders.show = function(a, b) {
        return a.style.display = b ? "" : "none"
    }
    ,
    a["public"].binders.hide = function(a, b) {
        return a.style.display = b ? "none" : ""
    }
    ,
    a["public"].binders.enabled = function(a, b) {
        return a.disabled = !b
    }
    ,
    a["public"].binders.disabled = function(a, b) {
        return a.disabled = !!b
    }
    ,
    a["public"].binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish)
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish)
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) === (null != b ? b.toString() : void 0) : !!b
        }
    },
    a["public"].binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish)
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish)
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) !== (null != b ? b.toString() : void 0) : !b
        }
    },
    a["public"].binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? (this.event = "SELECT" === b.tagName ? "change" : "input",
            a.Util.bindEvent(b, this.event, this.publish)) : void 0
        },
        unbind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? a.Util.unbindEvent(b, this.event, this.publish) : void 0
        },
        routine: function(a, b) {
            var c, d, e, f, g, h, j;
            if ("INPUT" === a.tagName && "radio" === a.type)
                return a.setAttribute("value", b);
            if (null != window.jQuery) {
                if (a = jQuery(a),
                (null != b ? b.toString() : void 0) !== (null != (f = a.val()) ? f.toString() : void 0))
                    return a.val(null != b ? b : "")
            } else if ("select-multiple" === a.type) {
                if (null != b) {
                    for (j = [],
                    d = 0,
                    e = a.length; e > d; d++)
                        c = a[d],
                        j.push(c.selected = (g = c.value,
                        i.call(b, g) >= 0));
                    return j
                }
            } else if ((null != b ? b.toString() : void 0) !== (null != (h = a.value) ? h.toString() : void 0))
                return a.value = null != b ? b : ""
        }
    },
    a["public"].binders["if"] = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c;
            return null == this.marker ? (b = [this.view.prefix, this.type].join("-").replace("--", "-"),
            c = a.getAttribute(b),
            this.marker = document.createComment(" rivets: " + this.type + " " + c + " "),
            this.bound = !1,
            a.removeAttribute(b),
            a.parentNode.insertBefore(this.marker, a),
            a.parentNode.removeChild(a)) : void 0
        },
        unbind: function() {
            var a;
            return null != (a = this.nested) ? a.unbind() : void 0
        },
        routine: function(b, c) {
            var d, e, f, g;
            if (!!c == !this.bound) {
                if (c) {
                    f = {},
                    g = this.view.models;
                    for (d in g)
                        e = g[d],
                        f[d] = e;
                    return (this.nested || (this.nested = new a.View(b,f,this.view.options()))).bind(),
                    this.marker.parentNode.insertBefore(b, this.marker.nextSibling),
                    this.bound = !0
                }
                return b.parentNode.removeChild(b),
                this.nested.unbind(),
                this.bound = !1
            }
        },
        update: function(a) {
            var b;
            return null != (b = this.nested) ? b.update(a) : void 0
        }
    },
    a["public"].binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function(b) {
            return a["public"].binders["if"].bind.call(this, b)
        },
        unbind: function() {
            return a["public"].binders["if"].unbind.call(this)
        },
        routine: function(b, c) {
            return a["public"].binders["if"].routine.call(this, b, !c)
        },
        update: function(b) {
            return a["public"].binders["if"].update.call(this, b)
        }
    },
    a["public"].binders["on-*"] = {
        "function": !0,
        priority: 1e3,
        unbind: function(b) {
            return this.handler ? a.Util.unbindEvent(b, this.args[0], this.handler) : void 0
        },
        routine: function(b, c) {
            return this.handler && a.Util.unbindEvent(b, this.args[0], this.handler),
            a.Util.bindEvent(b, this.args[0], this.handler = this.eventHandler(c))
        }
    },
    a["public"].binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c, d, e, f;
            if (null == this.marker)
                b = [this.view.prefix, this.type].join("-").replace("--", "-"),
                this.marker = document.createComment(" rivets: " + this.type + " "),
                this.iterated = [],
                a.removeAttribute(b),
                a.parentNode.insertBefore(this.marker, a),
                a.parentNode.removeChild(a);
            else
                for (f = this.iterated,
                d = 0,
                e = f.length; e > d; d++)
                    c = f[d],
                    c.bind()
        },
        unbind: function() {
            var a, b, c, d, e;
            if (null != this.iterated) {
                for (d = this.iterated,
                e = [],
                b = 0,
                c = d.length; c > b; b++)
                    a = d[b],
                    e.push(a.unbind());
                return e
            }
        },
        routine: function(b, c) {
            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x;
            if (j = this.args[0],
            c = c || [],
            this.iterated.length > c.length)
                for (u = Array(this.iterated.length - c.length),
                o = 0,
                r = u.length; r > o; o++)
                    f = u[o],
                    n = this.iterated.pop(),
                    n.unbind(),
                    this.marker.parentNode.removeChild(n.els[0]);
            for (g = p = 0,
            s = c.length; s > p; g = ++p)
                if (i = c[g],
                e = {
                    index: g
                },
                e[j] = i,
                null == this.iterated[g]) {
                    v = this.view.models;
                    for (h in v)
                        i = v[h],
                        null == e[h] && (e[h] = i);
                    l = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker,
                    k = this.view.options(),
                    k.preloadData = !0,
                    m = b.cloneNode(!0),
                    n = new a.View(m,e,k),
                    n.bind(),
                    this.iterated.push(n),
                    this.marker.parentNode.insertBefore(m, l.nextSibling)
                } else
                    this.iterated[g].models[j] !== i && this.iterated[g].update(e);
            if ("OPTION" === b.nodeName) {
                for (w = this.view.bindings,
                x = [],
                q = 0,
                t = w.length; t > q; q++)
                    d = w[q],
                    x.push(d.el === this.marker.parentNode && "value" === d.type ? d.sync() : void 0);
                return x
            }
        },
        update: function(a) {
            var b, c, d, e, f, g, h, i;
            b = {};
            for (c in a)
                d = a[c],
                c !== this.args[0] && (b[c] = d);
            for (h = this.iterated,
            i = [],
            f = 0,
            g = h.length; g > f; f++)
                e = h[f],
                i.push(e.update(b));
            return i
        }
    },
    a["public"].binders["class-*"] = function(a, b) {
        var c;
        return c = " " + a.className + " ",
        !b == (-1 !== c.indexOf(" " + this.args[0] + " ")) ? a.className = b ? "" + a.className + " " + this.args[0] : c.replace(" " + this.args[0] + " ", " ").trim() : void 0
    }
    ,
    a["public"].binders["*"] = function(a, b) {
        return null != b ? a.setAttribute(this.type, b) : a.removeAttribute(this.type)
    }
    ,
    a["public"].adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function(a) {
            var b, c, d;
            return a.hasOwnProperty(this.id) || (b = this.counter++,
            Object.defineProperty(a, this.id, {
                value: b
            })),
            (c = this.weakmap)[d = a[this.id]] || (c[d] = {
                callbacks: {}
            })
        },
        cleanupWeakReference: function(a, b) {
            return Object.keys(a.callbacks).length || a.pointers && Object.keys(a.pointers).length ? void 0 : delete this.weakmap[b]
        },
        stubFunction: function(a, b) {
            var c, d, e;
            return d = a[b],
            c = this.weakReference(a),
            e = this.weakmap,
            a[b] = function() {
                var b, f, g, h, i, j, k, l, m, n;
                h = d.apply(a, arguments),
                k = c.pointers;
                for (g in k)
                    for (f = k[g],
                    n = null != (l = null != (m = e[g]) ? m.callbacks[f] : void 0) ? l : [],
                    i = 0,
                    j = n.length; j > i; i++)
                        (b = n[i])();
                return h
            }
        },
        observeMutations: function(a, b, c) {
            var d, e, f, g, h, j;
            if (Array.isArray(a)) {
                if (f = this.weakReference(a),
                null == f.pointers)
                    for (f.pointers = {},
                    e = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"],
                    h = 0,
                    j = e.length; j > h; h++)
                        d = e[h],
                        this.stubFunction(a, d);
                if (null == (g = f.pointers)[b] && (g[b] = []),
                i.call(f.pointers[b], c) < 0)
                    return f.pointers[b].push(c)
            }
        },
        unobserveMutations: function(a, b, c) {
            var d, e, f;
            return Array.isArray(a) && null != a[this.id] && (e = this.weakmap[a[this.id]]) && (f = e.pointers[b]) ? ((d = f.indexOf(c)) >= 0 && f.splice(d, 1),
            f.length || delete e.pointers[b],
            this.cleanupWeakReference(e, a[this.id])) : void 0
        },
        observe: function(a, b, c) {
            var d, e, f;
            return d = this.weakReference(a).callbacks,
            null == d[b] && (d[b] = [],
            e = Object.getOwnPropertyDescriptor(a, b),
            (null != e ? e.get : void 0) || (null != e ? e.set : void 0) || (f = a[b],
            Object.defineProperty(a, b, {
                enumerable: !0,
                get: function() {
                    return f
                },
                set: function(e) {
                    return function(g) {
                        var h, j, k, l;
                        if (g !== f && (e.unobserveMutations(f, a[e.id], b),
                        f = g,
                        h = e.weakmap[a[e.id]])) {
                            if (d = h.callbacks,
                            d[b])
                                for (l = d[b].slice(),
                                j = 0,
                                k = l.length; k > j; j++)
                                    c = l[j],
                                    i.call(d[b], c) >= 0 && c();
                            return e.observeMutations(g, a[e.id], b)
                        }
                    }
                }(this)
            }))),
            i.call(d[b], c) < 0 && d[b].push(c),
            this.observeMutations(a[b], a[this.id], b)
        },
        unobserve: function(a, b, c) {
            var d, e, f;
            return (f = this.weakmap[a[this.id]]) && (d = f.callbacks[b]) ? ((e = d.indexOf(c)) >= 0 && (d.splice(e, 1),
            d.length || delete f.callbacks[b]),
            this.unobserveMutations(a[b], a[this.id], b),
            this.cleanupWeakReference(f, a[this.id])) : void 0
        },
        get: function(a, b) {
            return a[b]
        },
        set: function(a, b, c) {
            return a[b] = c
        }
    },
    a.factory = function(b) {
        return a.sightglass = b,
        a["public"]._ = a,
        a["public"]
    }
    ,
    "object" == typeof ("undefined" != typeof module && null !== module ? module.exports : void 0) ? module.exports = a.factory(require("sightglass")) : "function" == typeof define && define.amd ? define(["sightglass"], function(b) {
        return this.rivets = a.factory(b)
    }) : this.rivets = a.factory(sightglass)
}
.call(this),
/* 
// this function has duplicate + updated function right after it.
// thats why it is commented.
(function() {
    var a, b, c, d, e, f, g, h = function(a, b) {
        return function() {
            return a.apply(b, arguments)
        }
    };
    b = function() {
        function a() {
            this.update = h(this.update, this)
        }
        return a.prototype.update = function(a) {
            var b, c, d;
            for (c in a)
                d = a[c],
                "items" !== c && (this[c] = d);
            return this.items = function() {
                var c, d, f, g;
                for (f = a.items,
                g = [],
                c = 0,
                d = f.length; d > c; c++)
                    b = f[c],
                    g.push(new e(b));
                return g
            }()
        }
        ,
        a
    }(),
    e = function() {
        function a(a) {
            this.propertyArray = h(this.propertyArray, this),
            this.update = h(this.update, this),
            this.update(a)
        }
        return a.prototype.update = function(a) {
            var b, d;
            for (b in a)
                d = a[b],
                "properties" !== b && (this[b] = d);
            return this.properties = c.Utils.extend({}, a.properties)
        }
        ,
        a.prototype.propertyArray = function() {
            var a, b, c, d;
            c = this.properties,
            d = [];
            for (a in c)
                b = c[a],
                d.push({
                    name: a,
                    value: b
                });
            return d
        }
        ,
        a
    }(),
    c = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0
        },
        cart: new b
    },
    c.init = function(a, b) {
        return null == b && (b = {}),
        c.configure(b),
        c.Utils.log("Initialising CartJS."),
        c.cart.update(a),
        c.settings.dataAPI && (c.Utils.log('"dataAPI" setting is true, initialising Data API.'),
        c.Data.init()),
        c.settings.requestBodyClass && (c.Utils.log('"requestBodyClass" set, adding event listeners.'),
        jQuery(document).on("cart.requestStarted", function() {
            return jQuery("body").addClass(c.settings.requestBodyClass)
        }),
        jQuery(document).on("cart.requestComplete", function() {
            return jQuery("body").removeClass(c.settings.requestBodyClass)
        })),
        c.Rivets.init(),
        jQuery(document).trigger("cart.ready", [c.cart])
    }
    ,
    c.configure = function(a) {
        return null == a && (a = {}),
        c.Utils.extend(c.settings, a)
    }
    ,
    null == window.console && (window.console = {},
    window.console.log = function() {}
    ),
    d = 'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.',
    c.Utils = {
        log: function() {
            return c.Utils.console(console.log, arguments)
        },
        warn: function() {
            return c.Utils.console(console.warn, arguments)
        },
        error: function() {
            return c.Utils.console(console.error, arguments)
        },
        console: function(a, b) {
            return c.settings.debug && "undefined" != typeof console && null !== console ? (b = Array.prototype.slice.call(b),
            b.unshift("[CartJS]:"),
            a.apply(console, b)) : void 0
        },
        wrapKeys: function(a, b, c) {
            var d, e, f;
            null == b && (b = "properties"),
            f = {};
            for (d in a)
                e = a[d],
                f["" + b + "[" + d + "]"] = null != c ? c : e;
            return f
        },
        unwrapKeys: function(a, b, c) {
            var d, e, f, g;
            null == b && (b = "properties"),
            e = {};
            for (d in a)
                g = a[d],
                f = d.replace("" + b + "[", "").replace("]", ""),
                e[f] = null != c ? c : g;
            return e
        },
        extend: function(a, b) {
            var c, d;
            for (c in b)
                d = b[c],
                a[c] = d;
            return a
        },
        clone: function(a) {
            var b, c;
            if (null == a || "object" != typeof a)
                return a;
            c = new a.constructor;
            for (b in a)
                c[b] = clone(a[b]);
            return c
        },
        isArray: Array.isArray || function(a) {
            return "[object Array]" === {}.toString.call(a)
        }
        ,
        ensureArray: function(a) {
            return c.Utils.isArray(a) ? a : null != a ? [a] : []
        },
        formatMoney: function(a, b, e, f) {
            var g, h;
            return null == f && (f = ""),
            f || (f = c.settings.currency),
            null != window.Currency && f !== c.settings.currency && (a = Currency.convert(a, c.settings.currency, f),
            null != (null != (g = window.Currency) ? g.moneyFormats : void 0) && f in window.Currency.moneyFormats && (b = window.Currency.moneyFormats[f][e])),
            null != (null != (h = window.Shopify) ? h.formatMoney : void 0) ? Shopify.formatMoney(a, b) : (c.Utils.warn(d),
            a)
        },
        getSizedImageUrl: function(a, b) {
            var c, d;
            return null != (null != (c = window.Shopify) && null != (d = c.Image) ? d.getSizedImageUrl : void 0) ? a ? Shopify.Image.getSizedImageUrl(a, b) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", b).replace("-_", "-") : a ? a : "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
    },
    g = [],
    f = !1,
    c.Queue = {
        add: function(a, b, d) {
            var e;
            return null == d && (d = {}),
            e = {
                url: a,
                data: b,
                type: d.type || "POST",
                dataType: d.dataType || "json",
                success: c.Utils.ensureArray(d.success),
                error: c.Utils.ensureArray(d.error),
                complete: c.Utils.ensureArray(d.complete)
            },
            d.updateCart && e.success.push(c.cart.update),
            g.push(e),
            f ? void 0 : (jQuery(document).trigger("cart.requestStarted", [c.cart]),
            c.Queue.process())
        },
        process: function() {
            var a;
            return g.length ? (f = !0,
            a = g.shift(),
            a.complete = c.Queue.process,
            jQuery.ajax(a)) : (f = !1,
            void jQuery(document).trigger("cart.requestComplete", [c.cart]))
        }
    },
    c.Core = {
        getCart: function(a) {
            return null == a && (a = {}),
            a.type = "GET",
            a.updateCart = !0,
            c.Queue.add("/cart.js", {
                v: (new Date).getTime()
            }, a)
        },
        addItem: async function(a, b, d, e) {

            if (window['verifyProductAddToCart']) {
                const possibleAmount = await verifyProductAddToCart(+a, +b)
                b = possibleAmount
            }
            var f;
            return null == b && (b = 1),
            null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.id = a,
            f.quantity = b,
            c.Queue.add("/cart/add.js", f, e),
            c.Core.getCart()
        },
        addItems: async function(a, b) {
         
            if (window['verifyProductAddToCart']) {
                const possibleAmount = await verifyProductAddToCart(+a, +b)
                b = possibleAmount
            }
            var d;
            return null == b && (b = {}),
            d = {
                items: a
            },
            c.Queue.add("/cart/add.js", d, b),
            c.Core.getCart()
        },
        updateItem: function(a, b, d, e) {
            var f;
            return null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.line = a,
            null != b && (f.quantity = b),
            e.updateCart = !0,
            c.Queue.add("/cart/change.js", f, e)
        },
        removeItem: function(a, b) {
            return null == b && (b = {}),
            c.Core.updateItem(a, 0, {}, b)
        },
        updateItemById: function(a, b, d, e) {
            var f;
            return null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.id = a,
            null != b && (f.quantity = b),
            e.updateCart = !0,
            c.Queue.add("/cart/change.js", f, e)
        },
        updateItemQuantitiesById: function(a, b) {
            return null == a && (a = {}),
            null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", {
                updates: a
            }, b)
        },
        removeItemById: function(a, b) {
            var d;
            return null == b && (b = {}),
            d = {
                id: a,
                quantity: 0
            },
            b.updateCart = !0,
            c.Queue.add("/cart/change.js", d, b)
        },
        clear: function(a) {
            return null == a && (a = {}),
            a.updateCart = !0,
            c.Queue.add("/cart/clear.js", {}, a)
        },
        getAttribute: function(a, b) {
            return a in c.cart.attributes ? c.cart.attributes[a] : b
        },
        setAttribute: function(a, b, d) {
            var e;
            return null == d && (d = {}),
            e = {},
            e[a] = b,
            c.Core.setAttributes(e, d)
        },
        getAttributes: function() {
            return c.cart.attributes
        },
        setAttributes: function(a, b) {
            return null == a && (a = {}),
            null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b)
        },
        clearAttributes: function(a) {
            return null == a && (a = {}),
            a.updateCart = !0,
            c.Queue.add("/cart/update.js", c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""), a)
        },
        getNote: function() {
            return c.cart.note
        },
        setNote: function(a, b) {
            return null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", {
                note: a
            }, b)
        }
    },
    a = null,
    c.Data = {
        init: function() {
            return a = jQuery(document),
            c.Data.setEventListeners("on"),
            c.Data.render(null, c.cart)
        },
        destroy: function() {
            return c.Data.setEventListeners("off")
        },
        setEventListeners: function(b) {
            return a[b]("click", "[data-cart-add]", c.Data.add),
            a[b]("click", "[data-cart-remove]", c.Data.remove),
            a[b]("click", "[data-cart-remove-id]", c.Data.removeById),
            a[b]("click", "[data-cart-update]", c.Data.update),
            a[b]("click", "[data-cart-update-id]", c.Data.updateById),
            a[b]("click", "[data-cart-clear]", c.Data.clear),
            a[b]("change", "[data-cart-toggle]", c.Data.toggle),
            a[b]("change", "[data-cart-toggle-attribute]", c.Data.toggleAttribute),
            a[b]("submit", "[data-cart-submit]", c.Data.submit),
            a[b]("cart.requestComplete", c.Data.render)
        },
        add: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.addItem(b.attr("data-cart-add"), b.attr("data-cart-quantity"))
        },
        remove: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.removeItem(b.attr("data-cart-remove"))
        },
        removeById: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.removeItemById(b.attr("data-cart-remove-id"))
        },
        update: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.updateItem(b.attr("data-cart-update"), b.attr("data-cart-quantity"))
        },
        updateById: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.updateItemById(b.attr("data-cart-update-id"), b.attr("data-cart-quantity"))
        },
        clear: function(a) {
            return a.preventDefault(),
            c.Core.clear()
        },
        toggle: function() {
            var a, b;
            return a = jQuery(this),
            b = a.attr("data-cart-toggle"),
            a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b)
        },
        toggleAttribute: function() {
            var a, b;
            return a = jQuery(this),
            b = a.attr("data-cart-toggle-attribute"),
            c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "")
        },
        submit: function(a) {
            var b, d, e, f;
            return a.preventDefault(),
            b = jQuery(this).serializeArray(),
            d = void 0,
            f = void 0,
            e = {},
            jQuery.each(b, function(a, b) {
                return "id" === b.name ? d = b.value : "quantity" === b.name ? f = b.value : b.name.match(/^properties\[[\w ]+\]$/) ? e[b.name] = b.value : void 0
            }),
            c.Core.addItem(d, f, c.Utils.unwrapKeys(e))
        },
        render: function(a, b) {
            var d;
            return d = {
                item_count: b.item_count,
                total_price: b.total_price,
                total_price_money: c.Utils.formatMoney(b.total_price, c.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: c.Utils.formatMoney(b.total_price, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            },
            jQuery("[data-cart-render]").each(function() {
                var a;
                return a = jQuery(this),
                a.html(d[a.attr("data-cart-render")])
            })
        }
    },
    rivets ? (c.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return c.Rivets.bindViews()
        },
        destroy: function() {
            return c.Rivets.unbindViews()
        },
        bindViews: function() {
            return c.Utils.log("Rivets.js is present, binding views."),
            c.Rivets.unbindViews(),
            c.Rivets.model = c.Utils.extend({
                cart: c.cart
            }, c.settings.rivetsModels),
            null != window.Currency && (c.Rivets.model.Currency = window.Currency),
            jQuery("[data-cart-view]").each(function() {
                var a;
                return a = rivets.bind(jQuery(this), c.Rivets.model),
                c.Rivets.boundViews.push(a)
            })
        },
        unbindViews: function() {
            var a, b, d, e;
            for (e = c.Rivets.boundViews,
            b = 0,
            d = e.length; d > b; b++)
                a = e[b],
                a.unbind();
            return c.Rivets.boundViews = []
        }
    },
    rivets.formatters.eq = function(a, b) {
        return a === b
    }
    ,
    rivets.formatters.includes = function(a, b) {
        return a.indexOf(b) >= 0
    }
    ,
    rivets.formatters.match = function(a, b, c) {
        return a.match(new RegExp(b,c))
    }
    ,
    rivets.formatters.lt = function(a, b) {
        return b > a
    }
    ,
    rivets.formatters.gt = function(a, b) {
        return a > b
    }
    ,
    rivets.formatters.not = function(a) {
        return !a
    }
    ,
    rivets.formatters.empty = function(a) {
        return !a.length
    }
    ,
    rivets.formatters.plus = function(a, b) {
        return parseInt(a) + parseInt(b)
    }
    ,
    rivets.formatters.minus = function(a, b) {
        return parseInt(a) - parseInt(b)
    }
    ,
    rivets.formatters.times = function(a, b) {
        return a * b
    }
    ,
    rivets.formatters.divided_by = function(a, b) {
        return a / b
    }
    ,
    rivets.formatters.modulo = function(a, b) {
        return a % b
    }
    ,
    rivets.formatters.prepend = function(a, b) {
        return b + a
    }
    ,
    rivets.formatters.append = function(a, b) {
        return a + b
    }
    ,
    rivets.formatters.slice = function(a, b, c) {
        return a.slice(b, c)
    }
    ,
    rivets.formatters.pluralize = function(a, b, d) {
        return null == d && (d = b + "s"),
        c.Utils.isArray(a) && (a = a.length),
        1 === a ? b : d
    }
    ,
    rivets.formatters.array_element = function(a, b) {
        return a[b]
    }
    ,
    rivets.formatters.array_first = function(a) {
        return a[0]
    }
    ,
    rivets.formatters.array_last = function(a) {
        return a[a.length - 1]
    }
    ,
    rivets.formatters.money = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyFormat, "money_format", b)
    }
    ,
    rivets.formatters.money_with_currency = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", b)
    }
    ,
    rivets.formatters.weight = function(a) {
        switch (c.settings.weightUnit) {
        case "kg":
            return (a / 1e3).toFixed(c.settings.weightPrecision);
        case "oz":
            return (.035274 * a).toFixed(c.settings.weightPrecision);
        case "lb":
            return (.00220462 * a).toFixed(c.settings.weightPrecision);
        default:
            return a.toFixed(c.settings.weightPrecision)
        }
    }
    ,
    rivets.formatters.weight_with_unit = function(a) {
        return rivets.formatters.weight(a) + c.settings.weightUnit
    }
    ,
    rivets.formatters.product_image_size = function(a, b) {
        return c.Utils.getSizedImageUrl(a, b)
    }
    ,
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency,
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit,
    rivets.formatters.productImageSize = rivets.formatters.product_image_size) : c.Rivets = {
        init: function() {},
        destroy: function() {}
    },
    c.factory = function(a) {
        return a.init = c.init,
        a.configure = c.configure,
        a.cart = c.cart,
        a.settings = c.settings,
        a.getCart = c.Core.getCart,
        a.addItem = c.Core.addItem,
        a.addItems = c.Core.addItems,
        a.updateItem = c.Core.updateItem,
        a.updateItemById = c.Core.updateItemById,
        a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById,
        a.removeItem = c.Core.removeItem,
        a.removeItemById = c.Core.removeItemById,
        a.clear = c.Core.clear,
        a.getAttribute = c.Core.getAttribute,
        a.setAttribute = c.Core.setAttribute,
        a.getAttributes = c.Core.getAttributes,
        a.setAttributes = c.Core.setAttributes,
        a.clearAttributes = c.Core.clearAttributes,
        a.getNote = c.Core.getNote,
        a.setNote = c.Core.setNote,
        a.render = c.Data.render
    }
    ,
    "object" == typeof exports ? c.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(a) {
        return c.factory(this.CartJS = a),
        a
    }) : c.factory(this.CartJS = {})
}).call(this);
*/

// Cart.js
// version: 1.0.2
// author: Gavin Ballard
// license: MIT
(function() {
    var a, b, c, d, e, f, g, h = function(a, b) {
        return function() {
            return a.apply(b, arguments)
        }
    };
    b = function() {
        function a() {
            this.update = h(this.update, this)
        }
        return a.prototype.update = function(a) {
            var b, c, d;
            for (c in a)
                d = a[c],
                "items" !== c && (this[c] = d);
            return this.items = function() {
                var c, d, f, g;
                for (f = a.items,
                g = [],
                c = 0,
                d = f.length; d > c; c++)
                    b = f[c],
                    g.push(new e(b));
                return g
            }()
        }
        ,
        a
    }(),
    e = function() {
        function a(a) {
            this.propertyArray = h(this.propertyArray, this),
            this.update = h(this.update, this),
            this.update(a)
        }
        return a.prototype.update = function(a) {
            var b, d;
            for (b in a)
                d = a[b],
                "properties" !== b && (this[b] = d);
            return this.properties = c.Utils.extend({}, a.properties)
        }
        ,
        a.prototype.propertyArray = function() {
            var a, b, c, d;
            c = this.properties,
            d = [];
            for (a in c)
                b = c[a],
                d.push({
                    name: a,
                    value: b
                });
            return d
        }
        ,
        a
    }(),
    c = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0
        },
        cart: new b
    },
    c.init = function(a, b) {
        return null == b && (b = {}),
        c.configure(b),
        c.Utils.log("Initialising CartJS."),
        c.cart.update(a),
        c.settings.dataAPI && (c.Utils.log('"dataAPI" setting is true, initialising Data API.'),
        c.Data.init()),
        c.settings.requestBodyClass && (c.Utils.log('"requestBodyClass" set, adding event listeners.'),
        jQuery(document).on("cart.requestStarted", function() {
            return jQuery("body").addClass(c.settings.requestBodyClass)
        }),
        jQuery(document).on("cart.requestComplete", function() {
            return jQuery("body").removeClass(c.settings.requestBodyClass)
        })),
        c.Rivets.init(),
        jQuery(document).trigger("cart.ready", [c.cart]),
          
        jQuery(document).on("quizKitAddToCartSuccess", function (e) {    
          jQuery.getJSON("/cart.js", function (cart) {
            c.cart.update(cart);
            jQuery(document).trigger("cart.requestComplete", [c.cart]);
          });
        });
    }
    ,
    c.configure = function(a) {
        return null == a && (a = {}),
        c.Utils.extend(c.settings, a)
    }
    ,
    null == window.console && (window.console = {},
    window.console.log = function() {}
    ),
    d = 'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.',
    c.Utils = {
        log: function() {
            return c.Utils.console(console.log, arguments)
        },
        warn: function() {
            return c.Utils.console(console.warn, arguments)
        },
        error: function() {
            return c.Utils.console(console.error, arguments)
        },
        console: function(a, b) {
            return c.settings.debug && "undefined" != typeof console && null !== console ? (b = Array.prototype.slice.call(b),
            b.unshift("[CartJS]:"),
            a.apply(console, b)) : void 0
        },
        wrapKeys: function(a, b, c) {
            var d, e, f;
            null == b && (b = "properties"),
            f = {};
            for (d in a)
                e = a[d],
                f["" + b + "[" + d + "]"] = null != c ? c : e;
            return f
        },
        unwrapKeys: function(a, b, c) {
            var d, e, f, g;
            null == b && (b = "properties"),
            e = {};
            for (d in a)
                g = a[d],
                f = d.replace("" + b + "[", "").replace("]", ""),
                e[f] = null != c ? c : g;
            return e
        },
        extend: function(a, b) {
            var c, d;
            for (c in b)
                d = b[c],
                a[c] = d;
            return a
        },
        clone: function(a) {
            var b, c;
            if (null == a || "object" != typeof a)
                return a;
            c = new a.constructor;
            for (b in a)
                c[b] = clone(a[b]);
            return c
        },
        isArray: Array.isArray || function(a) {
            return "[object Array]" === {}.toString.call(a)
        }
        ,
        ensureArray: function(a) {
            return c.Utils.isArray(a) ? a : null != a ? [a] : []
        },
        formatMoney: function(a, b, e, f) {
            var g, h;
            return null == f && (f = ""),
            f || (f = c.settings.currency),
            null != window.Currency && f !== c.settings.currency && (a = Currency.convert(a, c.settings.currency, f),
            null != (null != (g = window.Currency) ? g.moneyFormats : void 0) && f in window.Currency.moneyFormats && (b = window.Currency.moneyFormats[f][e])),
            null != (null != (h = window.Shopify) ? h.formatMoney : void 0) ? Shopify.formatMoney(a, b) : (c.Utils.warn(d),
            a)
        },
        getSizedImageUrl: function(a, b) {
            var c, d;
            return null != (null != (c = window.Shopify) && null != (d = c.Image) ? d.getSizedImageUrl : void 0) ? a ? Shopify.Image.getSizedImageUrl(a, b) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", b).replace("-_", "-") : a ? a : "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
    },
    g = [],
    f = !1,
    c.Queue = {
        add: function(a, b, d) {
            var e;
            return null == d && (d = {}),
            e = {
                url: a,
                data: b,
                type: d.type || "POST",
                dataType: d.dataType || "json",
                success: c.Utils.ensureArray(d.success),
                error: c.Utils.ensureArray(d.error),
                complete: c.Utils.ensureArray(d.complete)
            },
            d.updateCart && e.success.push(c.cart.update),
            g.push(e),
            f ? void 0 : (jQuery(document).trigger("cart.requestStarted", [c.cart]),
            c.Queue.process())
        },
        process: function() {
            var a;
            return g.length ? (f = !0,
            a = g.shift(),
            a.complete = c.Queue.process,
            jQuery.ajax(a)) : (f = !1,
            void jQuery(document).trigger("cart.requestComplete", [c.cart]))
        }
    },
    c.Core = {
        getCart: function(a) {
            return null == a && (a = {}),
            a.type = "GET",
            a.updateCart = !0,
            c.Queue.add("/cart.js", {
                v: (new Date).getTime()
            }, a)
        },
      addItem: async function(a, b, d, e) {

          const res = await fetch("/cart.js");
          if (!res.ok) throw new Error("Something went wrong");
          const cartData = await res.json();
          window.cartData = cartData;
          
          let lineItem = undefined; // Default value if no match is found
          let isNew = 1;
          let lineItemIndex = undefined;
          
          if (window['verifyProductAddToCart']) {
                const line = +a, qty = +b, properties = d
                // console.log("line ----->", line, d, e, cartData.items);
                if (window?.cartData?.items) {
                    for (let itemIndex = 0; itemIndex < window.cartData.items.length; itemIndex++) {
                        if (window.cartData.items[itemIndex].id === line) {
                          lineItem = window.cartData.items.find(item => 
                            item.properties["Monogram Text"] === properties["Monogram Text"] &&
                            item.properties["Select Font"] === properties["Select Font"] &&
                            item.id === line
                          );
                          console.log("lineItem ====>", lineItem);

                          const index = window.cartData.items.findIndex(item => 
                              item.properties["Monogram Text"] === properties["Monogram Text"] &&
                              item.properties["Select Font"] === properties["Select Font"] &&
                              item.id === line
                          );
                            if (index == -1) {
                              isNew = 1;
                            } else {
                              lineItemIndex = index+1;
                              isNew = 0;
                              b = parseInt(lineItem.quantity) + parseInt(b);
                            }
                            break; // Exit the loop once the item is found
                        }
                    }
                }
                console.log("lineItemIndex ====---->", lineItemIndex);
                if (isNew == 0) {
                   // c.Core.updateItemById(lineItem.id, b);
                  d = {
                      line: lineItemIndex,
                      quantity: b
                  },
                  c.Queue.add("/cart/change.js", d, b)
                } else {
                  const possibleAmount = await verifyProductAddToCart(+a, +b);
                  b = possibleAmount;
                  isNew = 1;
                }
            }
            let selling_plan = '';
			let selling_plan_frequency = '';
            if($('input[name="selling_plan"]').val()){
              selling_plan = $('input[name="selling_plan"]').val();
              selling_plan_frequency = {'Frequency' :  $('input[name="subscription_frequency"]').val() };
            }
                    var f;
 
            // waiting for customily's properties to render inside form
            await new Promise((resolve) => { setTimeout(()=>{ resolve('') }, 500) })

            return null == b && (b = 1),
            null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.id = a,
            f.quantity = b,
            f.selling_plan = selling_plan,
            f.properties = selling_plan_frequency,
            isNew == 1 ? c.Queue.add("/cart/add.js", f, e) : null,
            c.Core.getCart()
         
        },
   //      addItem: async function(a, b, d, e) {
   //        let lineItem = undefined; // Default value if no match is found
   //          console.log("-----------addCart-------------",a,b,d);
   //        console.log("-----------cartData-------------",window?.cartData?.items);
   //          if (window['verifyProductAddToCart']) {
   //              const line = +a, qty = +b
   //              if (window?.cartData?.items) {
   //                  for (let itemIndex = 0; itemIndex < window.cartData.items.length; itemIndex++) {
   //                    console.log("-----------line-------------",line);
   //                      if (window.cartData.items[itemIndex].id === line) {
   //                          lineItem = window.cartData.items[itemIndex];
   //                          break; // Exit the loop once the item is found
   //                      }
   //                  }
   //              }
   //              console.log("-----------lineItem-------------",lineItem);
   //              if (lineItem) {
   //                 c.Core.updateItemQuantitiesById(+a, +b);
   //              }
   //            else{
   //              const possibleAmount = await verifyProductAddToCart(+a, +b);
   //             console.log("-----------possibleAmount-------------",possibleAmount);
   //              b = possibleAmount;
   //            }
   //          }
   //          let selling_plan = '';
			// let selling_plan_frequency = '';
   //          if($('input[name="selling_plan"]').val()){
   //            selling_plan = $('input[name="selling_plan"]').val();
   //            selling_plan_frequency = {'Frequency' :  $('input[name="subscription_frequency"]').val() };
   //          }
   //                  var f;
 
   //          // waiting for customily's properties to render inside form
   //          await new Promise((resolve) => { setTimeout(()=>{ resolve('') }, 500) })

   //          return null == b && (b = 1),
   //          null == d && (d = {}),
   //          null == e && (e = {}),
   //          f = c.Utils.wrapKeys(d),
   //          f.id = a,
   //          f.quantity = b,
   //          f.selling_plan = selling_plan,
   //          f.properties = selling_plan_frequency,
   //          c.Queue.add("/cart/add.js", f, e),
   //          c.Core.getCart()
   //      },
        addItems: async function(a, b) {
            if (window['verifyProductAddToCart']) {
                const possibleAmount = await verifyProductAddToCart(+a, +b)
                b = possibleAmount
            }
            var d;
            return null == b && (b = {}),
            d = {
                items: a
            },
            c.Queue.add("/cart/add.js", d, b),
            c.Core.getCart()
        },
        updateItem: async function(a, b, d, e) {
            var f;
            if (window['verifyProductAddToCart']) {
                const line = +a, qty = +b
                const lineItem = window?.cartData?.items?.find((item, itemIndex) => (itemIndex + 1) === line)
                if (lineItem) {
                    const { variant_id } = lineItem
                    const possibleAmount = await verifyProductAddToCart(+variant_id, +qty)
                    b = possibleAmount
                }
            }
            return null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.line = a,
            null != b && (f.quantity = b),
            e.updateCart = !0,
            c.Queue.add("/cart/change.js", f, e)
        },
        removeItem: function(a, b) {
            return null == b && (b = {}),
            c.Core.updateItem(a, 0, {}, b)
        },
        updateItemById: function(a, b, d, e) {
            var f;
            return null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.id = a,
            null != b && (f.quantity = b),
            e.updateCart = !0,
            c.Queue.add("/cart/change.js", f, e)
        },
        updateItemQuantitiesById: function(a, b) {
            return null == a && (a = {}),
            null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", {
                updates: a
            }, b)
        },
        removeItemById: function(a, b) {
            var d;
            return null == b && (b = {}),
            d = {
                id: a,
                quantity: 0
            },
            b.updateCart = !0,
            c.Queue.add("/cart/change.js", d, b)
        },
        clear: function(a) {
            return null == a && (a = {}),
            a.updateCart = !0,
            c.Queue.add("/cart/clear.js", {}, a)
        },
        getAttribute: function(a, b) {
            return a in c.cart.attributes ? c.cart.attributes[a] : b
        },
        setAttribute: function(a, b, d) {
            var e;
            return null == d && (d = {}),
            e = {},
            e[a] = b,
            c.Core.setAttributes(e, d)
        },
        getAttributes: function() {
            return c.cart.attributes
        },
        setAttributes: function(a, b) {
            return null == a && (a = {}),
            null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b)
        },
        clearAttributes: function(a) {
            return null == a && (a = {}),
            a.updateCart = !0,
            c.Queue.add("/cart/update.js", c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""), a)
        },
        getNote: function() {
            return c.cart.note
        },
        setNote: function(a, b) {
            return null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", {
                note: a
            }, b)
        }
    },
    a = null,
    c.Data = {
        init: function() {
            return a = jQuery(document),
            c.Data.setEventListeners("on"),
            c.Data.render(null, c.cart)
        },
        destroy: function() {
            return c.Data.setEventListeners("off")
        },
        setEventListeners: function(b) {
            return a[b]("click", "[data-cart-add]", c.Data.add),
            a[b]("click", "[data-cart-remove]", c.Data.remove),
            a[b]("click", "[data-cart-remove-id]", c.Data.removeById),
            a[b]("click", "[data-cart-update]", c.Data.update),
            a[b]("click", "[data-cart-update-id]", c.Data.updateById),
            a[b]("click", "[data-cart-clear]", c.Data.clear),
            a[b]("change", "[data-cart-toggle]", c.Data.toggle),
            a[b]("change", "[data-cart-toggle-attribute]", c.Data.toggleAttribute),
            a[b]("submit", "[data-cart-submit]", c.Data.submit),
            a[b]("cart.requestComplete", c.Data.render)
        },
        add: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.addItem(b.attr("data-cart-add"), b.attr("data-cart-quantity"))
        },
        remove: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.removeItem(b.attr("data-cart-remove"))
        },
        removeById: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.removeItemById(b.attr("data-cart-remove-id"))
        },
        update: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.updateItem(b.attr("data-cart-update"), b.attr("data-cart-quantity"))
        },
        updateById: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.updateItemById(b.attr("data-cart-update-id"), b.attr("data-cart-quantity"))
        },
        clear: function(a) {
            return a.preventDefault(),
            c.Core.clear()
        },
        toggle: function() {
            var a, b;
            return a = jQuery(this),
            b = a.attr("data-cart-toggle"),
            a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b)
        },
        toggleAttribute: function() {
            var a, b;
            return a = jQuery(this),
            b = a.attr("data-cart-toggle-attribute"),
            c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "")
        },
        submit: function(a) {
            var b, d, e, f;
            return a.preventDefault(),
            b = jQuery(this).serializeArray(),
            b = c.Data.updateProperties(b),
            d = void 0,
            f = void 0,
            e = {},
            jQuery.each(b, function(a, b) {
                return "id" === b.name ? d = b.value : "quantity" === b.name ? f = b.value : b.name.match(/^properties\[[\w ]+\]$/) ? e[b.name] = b.value : void 0
            }),
            c.Core.addItem(d, f, c.Utils.unwrapKeys(e))
        },
        render: function(a, b) {
            var d;
            return d = {
                item_count: b.item_count,
                total_price: b.total_price,
                total_price_money: c.Utils.formatMoney(b.total_price, c.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: c.Utils.formatMoney(b.total_price, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            },
            jQuery("[data-cart-render]").each(function() {
                var a;
                return a = jQuery(this),
                a.html(d[a.attr("data-cart-render")])
            })
        },
        updateProperties: function (b) {
            var q = [...b];
            var p = q.find(s => s.name === "properties[_quiz_kit_id]");
            if (p) {
                let variantId = q.find(s => s.name === "id").value;
                variantId = parseInt(variantId);
                let price = window.product_data.variants.find(variant => variant.id == variantId).price;
                let data = {
                    price,
                    variantId,
                    source: 'quiz_result' 
                };
                let url = "https://api.quizkitapp.com/api/v1/quizzes/B7Nn6S-TQ/add-to-cart";
                fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                })
                .then(res => res.text())
                .then(t => console.log(t));
            }
            return q;
        }
    },
    rivets ? (c.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return c.Rivets.bindViews()
        },
        destroy: function() {
            return c.Rivets.unbindViews()
        },
        bindViews: function() {
            return c.Utils.log("Rivets.js is present, binding views."),
            c.Rivets.unbindViews(),
            c.Rivets.model = c.Utils.extend({
                cart: c.cart
            }, c.settings.rivetsModels),
            null != window.Currency && (c.Rivets.model.Currency = window.Currency),
            jQuery("[data-cart-view]").each(function() {
                var a;
                return a = rivets.bind(jQuery(this), c.Rivets.model),
                c.Rivets.boundViews.push(a)
            })
        },
        unbindViews: function() {
            var a, b, d, e;
            for (e = c.Rivets.boundViews,
            b = 0,
            d = e.length; d > b; b++)
                a = e[b],
                a.unbind();
            return c.Rivets.boundViews = []
        }
    },
    rivets.formatters.eq = function(a, b) {
        return a === b
    }
    ,
    rivets.formatters.includes = function(a, b) {
        return a.indexOf(b) >= 0
    }
    ,
    rivets.formatters.match = function(a, b, c) {
        return a.match(new RegExp(b,c))
    }
    ,
    rivets.formatters.lt = function(a, b) {
        return b > a
    }
    ,
    rivets.formatters.gt = function(a, b) {
        return a > b
    }
    ,
    rivets.formatters.not = function(a) {
        return !a
    }
    ,
    rivets.formatters.empty = function(a) {
        return !a.length
    }
    ,
    rivets.formatters.plus = function(a, b) {
        return parseInt(a) + parseInt(b)
    }
    ,
    rivets.formatters.minus = function(a, b) {
        return parseInt(a) - parseInt(b)
    }
    ,
    rivets.formatters.times = function(a, b) {
        return a * b
    }
    ,
    rivets.formatters.divided_by = function(a, b) {
        return a / b
    }
    ,
    rivets.formatters.modulo = function(a, b) {
        return a % b
    }
    ,
    rivets.formatters.prepend = function(a, b) {
        return b + a
    }
    ,
    rivets.formatters.append = function(a, b) {
        return a + b
    }
    ,
    rivets.formatters.slice = function(a, b, c) {
        return a.slice(b, c)
    }
    ,
    rivets.formatters.pluralize = function(a, b, d) {
        return null == d && (d = b + "s"),
        c.Utils.isArray(a) && (a = a.length),
        1 === a ? b : d
    }
    ,
    rivets.formatters.array_element = function(a, b) {
        return a[b]
    }
    ,
    rivets.formatters.array_first = function(a) {
        return a[0]
    }
    ,
    rivets.formatters.array_last = function(a) {
        return a[a.length - 1]
    }
    ,
    rivets.formatters.money = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyFormat, "money_format", b)
    }
    ,
    rivets.formatters.money_with_currency = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", b)
    }
    ,
    rivets.formatters.weight = function(a) {
        switch (c.settings.weightUnit) {
        case "kg":
            return (a / 1e3).toFixed(c.settings.weightPrecision);
        case "oz":
            return (.035274 * a).toFixed(c.settings.weightPrecision);
        case "lb":
            return (.00220462 * a).toFixed(c.settings.weightPrecision);
        default:
            return a.toFixed(c.settings.weightPrecision)
        }
    }
    ,
    rivets.formatters.weight_with_unit = function(a) {
        return rivets.formatters.weight(a) + c.settings.weightUnit
    }
    ,
    rivets.formatters.product_image_size = function(a, b) {
        return c.Utils.getSizedImageUrl(a, b)
    }
    ,
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency,
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit,
    rivets.formatters.productImageSize = rivets.formatters.product_image_size) : c.Rivets = {
        init: function() {},
        destroy: function() {}
    },
    c.factory = function(a) {
        return a.init = c.init,
        a.configure = c.configure,
        a.cart = c.cart,
        a.settings = c.settings,
        a.getCart = c.Core.getCart,
        a.addItem = c.Core.addItem,
        a.addItems = c.Core.addItems,
        a.updateItem = c.Core.updateItem,
        a.updateItemById = c.Core.updateItemById,
        a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById,
        a.removeItem = c.Core.removeItem,
        a.removeItemById = c.Core.removeItemById,
        a.clear = c.Core.clear,
        a.getAttribute = c.Core.getAttribute,
        a.setAttribute = c.Core.setAttribute,
        a.getAttributes = c.Core.getAttributes,
        a.setAttributes = c.Core.setAttributes,
        a.clearAttributes = c.Core.clearAttributes,
        a.getNote = c.Core.getNote,
        a.setNote = c.Core.setNote,
        a.render = c.Data.render
    }
    ,
    "object" == typeof exports ? c.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(a) {
        return c.factory(this.CartJS = a),
        a
    }) : c.factory(this.CartJS = {})
}
).call(this);

/*!
 * Masonry PACKAGED v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

!function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, function(t, e) {
    "use strict";
    function i(i, r, a) {
        function h(t, e, n) {
            var o, r = "$()." + i + '("' + e + '")';
            return t.each(function(t, h) {
                var u = a.data(h, i);
                if (!u)
                    return void s(i + " not initialized. Cannot call methods, i.e. " + r);
                var d = u[e];
                if (!d || "_" == e.charAt(0))
                    return void s(r + " is not a valid method");
                var l = d.apply(u, n);
                o = void 0 === o ? l : o
            }),
            void 0 !== o ? o : t
        }
        function u(t, e) {
            t.each(function(t, n) {
                var o = a.data(n, i);
                o ? (o.option(e),
                o._init()) : (o = new r(n,e),
                a.data(n, i, o))
            })
        }
        a = a || e || t.jQuery,
        a && (r.prototype.option || (r.prototype.option = function(t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
        }
        ),
        a.fn[i] = function(t) {
            if ("string" == typeof t) {
                var e = o.call(arguments, 1);
                return h(this, t, e)
            }
            return u(this, t),
            this
        }
        ,
        n(a))
    }
    function n(t) {
        !t || t && t.bridget || (t.bridget = i)
    }
    var o = Array.prototype.slice
      , r = t.console
      , s = "undefined" == typeof r ? function() {}
    : function(t) {
        r.error(t)
    }
    ;
    return n(e || t.jQuery),
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {}
              , n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e),
            this
        }
    }
    ,
    e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {}
              , n = i[t] = i[t] || {};
            return n[e] = !0,
            this
        }
    }
    ,
    e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1),
            this
        }
    }
    ,
    e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0),
            e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                var r = i[o]
                  , s = n && n[r];
                s && (this.off(t, r),
                delete n[r]),
                r.apply(this, e)
            }
            return this
        }
    }
    ,
    e.allOff = function() {
        delete this._events,
        delete this._onceEvents
    }
    ,
    t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";
    function t(t) {
        var e = parseFloat(t)
          , i = -1 == t.indexOf("%") && !isNaN(e);
        return i && e
    }
    function e() {}
    function i() {
        for (var t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        }, e = 0; u > e; e++) {
            var i = h[e];
            t[i] = 0
        }
        return t
    }
    function n(t) {
        var e = getComputedStyle(t);
        return e || a("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),
        e
    }
    function o() {
        if (!d) {
            d = !0;
            var e = document.createElement("div");
            e.style.width = "200px",
            e.style.padding = "1px 2px 3px 4px",
            e.style.borderStyle = "solid",
            e.style.borderWidth = "1px 2px 3px 4px",
            e.style.boxSizing = "border-box";
            var i = document.body || document.documentElement;
            i.appendChild(e);
            var o = n(e);
            s = 200 == Math.round(t(o.width)),
            r.isBoxSizeOuter = s,
            i.removeChild(e)
        }
    }
    function r(e) {
        if (o(),
        "string" == typeof e && (e = document.querySelector(e)),
        e && "object" == typeof e && e.nodeType) {
            var r = n(e);
            if ("none" == r.display)
                return i();
            var a = {};
            a.width = e.offsetWidth,
            a.height = e.offsetHeight;
            for (var d = a.isBorderBox = "border-box" == r.boxSizing, l = 0; u > l; l++) {
                var c = h[l]
                  , f = r[c]
                  , m = parseFloat(f);
                a[c] = isNaN(m) ? 0 : m
            }
            var p = a.paddingLeft + a.paddingRight
              , g = a.paddingTop + a.paddingBottom
              , y = a.marginLeft + a.marginRight
              , v = a.marginTop + a.marginBottom
              , _ = a.borderLeftWidth + a.borderRightWidth
              , z = a.borderTopWidth + a.borderBottomWidth
              , E = d && s
              , b = t(r.width);
            b !== !1 && (a.width = b + (E ? 0 : p + _));
            var x = t(r.height);
            return x !== !1 && (a.height = x + (E ? 0 : g + z)),
            a.innerWidth = a.width - (p + _),
            a.innerHeight = a.height - (g + z),
            a.outerWidth = a.width + y,
            a.outerHeight = a.height + v,
            a
        }
    }
    var s, a = "undefined" == typeof console ? e : function(t) {
        console.error(t)
    }
    , h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], u = h.length, d = !1;
    return r
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches)
            return "matches";
        if (t.matchesSelector)
            return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i]
              , o = n + "MatchesSelector";
            if (t[o])
                return o
        }
    }();
    return function(e, i) {
        return e[t](i)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, function(t, e) {
    var i = {};
    i.extend = function(t, e) {
        for (var i in e)
            t[i] = e[i];
        return t
    }
    ,
    i.modulo = function(t, e) {
        return (t % e + e) % e
    }
    ;
    var n = Array.prototype.slice;
    i.makeArray = function(t) {
        if (Array.isArray(t))
            return t;
        if (null === t || void 0 === t)
            return [];
        var e = "object" == typeof t && "number" == typeof t.length;
        return e ? n.call(t) : [t]
    }
    ,
    i.removeFrom = function(t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1)
    }
    ,
    i.getParent = function(t, i) {
        for (; t.parentNode && t != document.body; )
            if (t = t.parentNode,
            e(t, i))
                return t
    }
    ,
    i.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }
    ,
    i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    i.filterFindElements = function(t, n) {
        t = i.makeArray(t);
        var o = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement) {
                if (!n)
                    return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++)
                    o.push(i[r])
            }
        }),
        o
    }
    ,
    i.debounceMethod = function(t, e, i) {
        i = i || 100;
        var n = t.prototype[e]
          , o = e + "Timeout";
        t.prototype[e] = function() {
            var t = this[o];
            clearTimeout(t);
            var e = arguments
              , r = this;
            this[o] = setTimeout(function() {
                n.apply(r, e),
                delete r[o]
            }, i)
        }
    }
    ,
    i.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }
    ,
    i.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    }
    ;
    var o = t.console;
    return i.htmlInit = function(e, n) {
        i.docReady(function() {
            var r = i.toDashed(n)
              , s = "data-" + r
              , a = document.querySelectorAll("[" + s + "]")
              , h = document.querySelectorAll(".js-" + r)
              , u = i.makeArray(a).concat(i.makeArray(h))
              , d = s + "-options"
              , l = t.jQuery;
            u.forEach(function(t) {
                var i, r = t.getAttribute(s) || t.getAttribute(d);
                try {
                    i = r && JSON.parse(r)
                } catch (a) {
                    return void (o && o.error("Error parsing " + s + " on " + t.className + ": " + a))
                }
                var h = new e(t,i);
                l && l.data(t, n, h)
            })
        })
    }
    ,
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {},
    t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function(t, e) {
    "use strict";
    function i(t) {
        for (var e in t)
            return !1;
        return e = null,
        !0
    }
    function n(t, e) {
        t && (this.element = t,
        this.layout = e,
        this.position = {
            x: 0,
            y: 0
        },
        this._create())
    }
    function o(t) {
        return t.replace(/([A-Z])/g, function(t) {
            return "-" + t.toLowerCase()
        })
    }
    var r = document.documentElement.style
      , s = "string" == typeof r.transition ? "transition" : "WebkitTransition"
      , a = "string" == typeof r.transform ? "transform" : "WebkitTransform"
      , h = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend"
    }[s]
      , u = {
        transform: a,
        transition: s,
        transitionDuration: s + "Duration",
        transitionProperty: s + "Property",
        transitionDelay: s + "Delay"
    }
      , d = n.prototype = Object.create(t.prototype);
    d.constructor = n,
    d._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        },
        this.css({
            position: "absolute"
        })
    }
    ,
    d.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    d.getSize = function() {
        this.size = e(this.element)
    }
    ,
    d.css = function(t) {
        var e = this.element.style;
        for (var i in t) {
            var n = u[i] || i;
            e[n] = t[i]
        }
    }
    ,
    d.getPosition = function() {
        var t = getComputedStyle(this.element)
          , e = this.layout._getOption("originLeft")
          , i = this.layout._getOption("originTop")
          , n = t[e ? "left" : "right"]
          , o = t[i ? "top" : "bottom"]
          , r = parseFloat(n)
          , s = parseFloat(o)
          , a = this.layout.size;
        -1 != n.indexOf("%") && (r = r / 100 * a.width),
        -1 != o.indexOf("%") && (s = s / 100 * a.height),
        r = isNaN(r) ? 0 : r,
        s = isNaN(s) ? 0 : s,
        r -= e ? a.paddingLeft : a.paddingRight,
        s -= i ? a.paddingTop : a.paddingBottom,
        this.position.x = r,
        this.position.y = s
    }
    ,
    d.layoutPosition = function() {
        var t = this.layout.size
          , e = {}
          , i = this.layout._getOption("originLeft")
          , n = this.layout._getOption("originTop")
          , o = i ? "paddingLeft" : "paddingRight"
          , r = i ? "left" : "right"
          , s = i ? "right" : "left"
          , a = this.position.x + t[o];
        e[r] = this.getXValue(a),
        e[s] = "";
        var h = n ? "paddingTop" : "paddingBottom"
          , u = n ? "top" : "bottom"
          , d = n ? "bottom" : "top"
          , l = this.position.y + t[h];
        e[u] = this.getYValue(l),
        e[d] = "",
        this.css(e),
        this.emitEvent("layout", [this])
    }
    ,
    d.getXValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }
    ,
    d.getYValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }
    ,
    d._transitionTo = function(t, e) {
        this.getPosition();
        var i = this.position.x
          , n = this.position.y
          , o = t == this.position.x && e == this.position.y;
        if (this.setPosition(t, e),
        o && !this.isTransitioning)
            return void this.layoutPosition();
        var r = t - i
          , s = e - n
          , a = {};
        a.transform = this.getTranslate(r, s),
        this.transition({
            to: a,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: !0
        })
    }
    ,
    d.getTranslate = function(t, e) {
        var i = this.layout._getOption("originLeft")
          , n = this.layout._getOption("originTop");
        return t = i ? t : -t,
        e = n ? e : -e,
        "translate3d(" + t + "px, " + e + "px, 0)"
    }
    ,
    d.goTo = function(t, e) {
        this.setPosition(t, e),
        this.layoutPosition()
    }
    ,
    d.moveTo = d._transitionTo,
    d.setPosition = function(t, e) {
        this.position.x = parseFloat(t),
        this.position.y = parseFloat(e)
    }
    ,
    d._nonTransition = function(t) {
        this.css(t.to),
        t.isCleaning && this._removeStyles(t.to);
        for (var e in t.onTransitionEnd)
            t.onTransitionEnd[e].call(this)
    }
    ,
    d.transition = function(t) {
        if (!parseFloat(this.layout.options.transitionDuration))
            return void this._nonTransition(t);
        var e = this._transn;
        for (var i in t.onTransitionEnd)
            e.onEnd[i] = t.onTransitionEnd[i];
        for (i in t.to)
            e.ingProperties[i] = !0,
            t.isCleaning && (e.clean[i] = !0);
        if (t.from) {
            this.css(t.from);
            var n = this.element.offsetHeight;
            n = null
        }
        this.enableTransition(t.to),
        this.css(t.to),
        this.isTransitioning = !0
    }
    ;
    var l = "opacity," + o(a);
    d.enableTransition = function() {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t,
            this.css({
                transitionProperty: l,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }),
            this.element.addEventListener(h, this, !1)
        }
    }
    ,
    d.onwebkitTransitionEnd = function(t) {
        this.ontransitionend(t)
    }
    ,
    d.onotransitionend = function(t) {
        this.ontransitionend(t)
    }
    ;
    var c = {
        "-webkit-transform": "transform"
    };
    d.ontransitionend = function(t) {
        if (t.target === this.element) {
            var e = this._transn
              , n = c[t.propertyName] || t.propertyName;
            if (delete e.ingProperties[n],
            i(e.ingProperties) && this.disableTransition(),
            n in e.clean && (this.element.style[t.propertyName] = "",
            delete e.clean[n]),
            n in e.onEnd) {
                var o = e.onEnd[n];
                o.call(this),
                delete e.onEnd[n]
            }
            this.emitEvent("transitionEnd", [this])
        }
    }
    ,
    d.disableTransition = function() {
        this.removeTransitionStyles(),
        this.element.removeEventListener(h, this, !1),
        this.isTransitioning = !1
    }
    ,
    d._removeStyles = function(t) {
        var e = {};
        for (var i in t)
            e[i] = "";
        this.css(e)
    }
    ;
    var f = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return d.removeTransitionStyles = function() {
        this.css(f)
    }
    ,
    d.stagger = function(t) {
        t = isNaN(t) ? 0 : t,
        this.staggerDelay = t + "ms"
    }
    ,
    d.removeElem = function() {
        this.element.parentNode.removeChild(this.element),
        this.css({
            display: ""
        }),
        this.emitEvent("remove", [this])
    }
    ,
    d.remove = function() {
        return s && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem()
        }),
        void this.hide()) : void this.removeElem()
    }
    ,
    d.reveal = function() {
        delete this.isHidden,
        this.css({
            display: ""
        });
        var t = this.layout.options
          , e = {}
          , i = this.getHideRevealTransitionEndProperty("visibleStyle");
        e[i] = this.onRevealTransitionEnd,
        this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }
    ,
    d.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal")
    }
    ,
    d.getHideRevealTransitionEndProperty = function(t) {
        var e = this.layout.options[t];
        if (e.opacity)
            return "opacity";
        for (var i in e)
            return i
    }
    ,
    d.hide = function() {
        this.isHidden = !0,
        this.css({
            display: ""
        });
        var t = this.layout.options
          , e = {}
          , i = this.getHideRevealTransitionEndProperty("hiddenStyle");
        e[i] = this.onHideTransitionEnd,
        this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }
    ,
    d.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }),
        this.emitEvent("hide"))
    }
    ,
    d.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        })
    }
    ,
    n
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(i, n, o, r) {
        return e(t, i, n, o, r)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item)
}(window, function(t, e, i, n, o) {
    "use strict";
    function r(t, e) {
        var i = n.getQueryElement(t);
        if (!i)
            return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
        this.element = i,
        u && (this.$element = u(this.element)),
        this.options = n.extend({}, this.constructor.defaults),
        this.option(e);
        var o = ++l;
        this.element.outlayerGUID = o,
        c[o] = this,
        this._create();
        var r = this._getOption("initLayout");
        r && this.layout()
    }
    function s(t) {
        function e() {
            t.apply(this, arguments)
        }
        return e.prototype = Object.create(t.prototype),
        e.prototype.constructor = e,
        e
    }
    function a(t) {
        if ("number" == typeof t)
            return t;
        var e = t.match(/(^\d*\.?\d*)(\w*)/)
          , i = e && e[1]
          , n = e && e[2];
        if (!i.length)
            return 0;
        i = parseFloat(i);
        var o = m[n] || 1;
        return i * o
    }
    var h = t.console
      , u = t.jQuery
      , d = function() {}
      , l = 0
      , c = {};
    r.namespace = "outlayer",
    r.Item = o,
    r.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var f = r.prototype;
    n.extend(f, e.prototype),
    f.option = function(t) {
        n.extend(this.options, t)
    }
    ,
    f._getOption = function(t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }
    ,
    r.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    },
    f._create = function() {
        this.reloadItems(),
        this.stamps = [],
        this.stamp(this.options.stamp),
        n.extend(this.element.style, this.options.containerStyle);
        var t = this._getOption("resize");
        t && this.bindResize()
    }
    ,
    f.reloadItems = function() {
        this.items = this._itemize(this.element.children)
    }
    ,
    f._itemize = function(t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var r = e[o]
              , s = new i(r,this);
            n.push(s)
        }
        return n
    }
    ,
    f._filterFindItemElements = function(t) {
        return n.filterFindElements(t, this.options.itemSelector)
    }
    ,
    f.getItemElements = function() {
        return this.items.map(function(t) {
            return t.element
        })
    }
    ,
    f.layout = function() {
        this._resetLayout(),
        this._manageStamps();
        var t = this._getOption("layoutInstant")
          , e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e),
        this._isLayoutInited = !0
    }
    ,
    f._init = f.layout,
    f._resetLayout = function() {
        this.getSize()
    }
    ,
    f.getSize = function() {
        this.size = i(this.element)
    }
    ,
    f._getMeasurement = function(t, e) {
        var n, o = this.options[t];
        o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o),
        this[t] = n ? i(n)[e] : o) : this[t] = 0
    }
    ,
    f.layoutItems = function(t, e) {
        t = this._getItemsForLayout(t),
        this._layoutItems(t, e),
        this._postLayout()
    }
    ,
    f._getItemsForLayout = function(t) {
        return t.filter(function(t) {
            return !t.isIgnored
        })
    }
    ,
    f._layoutItems = function(t, e) {
        if (this._emitCompleteOnItems("layout", t),
        t && t.length) {
            var i = [];
            t.forEach(function(t) {
                var n = this._getItemLayoutPosition(t);
                n.item = t,
                n.isInstant = e || t.isLayoutInstant,
                i.push(n)
            }, this),
            this._processLayoutQueue(i)
        }
    }
    ,
    f._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        }
    }
    ,
    f._processLayoutQueue = function(t) {
        this.updateStagger(),
        t.forEach(function(t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }
    ,
    f.updateStagger = function() {
        var t = this.options.stagger;
        return null === t || void 0 === t ? void (this.stagger = 0) : (this.stagger = a(t),
        this.stagger)
    }
    ,
    f._positionItem = function(t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger),
        t.moveTo(e, i))
    }
    ,
    f._postLayout = function() {
        this.resizeContainer()
    }
    ,
    f.resizeContainer = function() {
        var t = this._getOption("resizeContainer");
        if (t) {
            var e = this._getContainerSize();
            e && (this._setContainerMeasure(e.width, !0),
            this._setContainerMeasure(e.height, !1))
        }
    }
    ,
    f._getContainerSize = d,
    f._setContainerMeasure = function(t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth),
            t = Math.max(t, 0),
            this.element.style[e ? "width" : "height"] = t + "px"
        }
    }
    ,
    f._emitCompleteOnItems = function(t, e) {
        function i() {
            o.dispatchEvent(t + "Complete", null, [e])
        }
        function n() {
            s++,
            s == r && i()
        }
        var o = this
          , r = e.length;
        if (!e || !r)
            return void i();
        var s = 0;
        e.forEach(function(e) {
            e.once(t, n)
        })
    }
    ,
    f.dispatchEvent = function(t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n),
        u)
            if (this.$element = this.$element || u(this.element),
            e) {
                var o = u.Event(e);
                o.type = t,
                this.$element.trigger(o, i)
            } else
                this.$element.trigger(t, i)
    }
    ,
    f.ignore = function(t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0)
    }
    ,
    f.unignore = function(t) {
        var e = this.getItem(t);
        e && delete e.isIgnored
    }
    ,
    f.stamp = function(t) {
        t = this._find(t),
        t && (this.stamps = this.stamps.concat(t),
        t.forEach(this.ignore, this))
    }
    ,
    f.unstamp = function(t) {
        t = this._find(t),
        t && t.forEach(function(t) {
            n.removeFrom(this.stamps, t),
            this.unignore(t)
        }, this)
    }
    ,
    f._find = function(t) {
        return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)),
        t = n.makeArray(t)) : void 0
    }
    ,
    f._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(),
        this.stamps.forEach(this._manageStamp, this))
    }
    ,
    f._getBoundingRect = function() {
        var t = this.element.getBoundingClientRect()
          , e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }
    ,
    f._manageStamp = d,
    f._getElementOffset = function(t) {
        var e = t.getBoundingClientRect()
          , n = this._boundingRect
          , o = i(t)
          , r = {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom
        };
        return r
    }
    ,
    f.handleEvent = n.handleEvent,
    f.bindResize = function() {
        t.addEventListener("resize", this),
        this.isResizeBound = !0
    }
    ,
    f.unbindResize = function() {
        t.removeEventListener("resize", this),
        this.isResizeBound = !1
    }
    ,
    f.onresize = function() {
        this.resize()
    }
    ,
    n.debounceMethod(r, "onresize", 100),
    f.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }
    ,
    f.needsResizeLayout = function() {
        var t = i(this.element)
          , e = this.size && t;
        return e && t.innerWidth !== this.size.innerWidth
    }
    ,
    f.addItems = function(t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)),
        e
    }
    ,
    f.appended = function(t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0),
        this.reveal(e))
    }
    ,
    f.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(i)
        }
    }
    ,
    f.reveal = function(t) {
        if (this._emitCompleteOnItems("reveal", t),
        t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e),
                t.reveal()
            })
        }
    }
    ,
    f.hide = function(t) {
        if (this._emitCompleteOnItems("hide", t),
        t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e),
                t.hide()
            })
        }
    }
    ,
    f.revealItemElements = function(t) {
        var e = this.getItems(t);
        this.reveal(e)
    }
    ,
    f.hideItemElements = function(t) {
        var e = this.getItems(t);
        this.hide(e)
    }
    ,
    f.getItem = function(t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t)
                return i
        }
    }
    ,
    f.getItems = function(t) {
        t = n.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            var i = this.getItem(t);
            i && e.push(i)
        }, this),
        e
    }
    ,
    f.remove = function(t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e),
        e && e.length && e.forEach(function(t) {
            t.remove(),
            n.removeFrom(this.items, t)
        }, this)
    }
    ,
    f.destroy = function() {
        var t = this.element.style;
        t.height = "",
        t.position = "",
        t.width = "",
        this.items.forEach(function(t) {
            t.destroy()
        }),
        this.unbindResize();
        var e = this.element.outlayerGUID;
        delete c[e],
        delete this.element.outlayerGUID,
        u && u.removeData(this.element, this.constructor.namespace)
    }
    ,
    r.data = function(t) {
        t = n.getQueryElement(t);
        var e = t && t.outlayerGUID;
        return e && c[e]
    }
    ,
    r.create = function(t, e) {
        var i = s(r);
        return i.defaults = n.extend({}, r.defaults),
        n.extend(i.defaults, e),
        i.compatOptions = n.extend({}, r.compatOptions),
        i.namespace = t,
        i.data = r.data,
        i.Item = s(o),
        n.htmlInit(i, t),
        u && u.bridget && u.bridget(t, i),
        i
    }
    ;
    var m = {
        ms: 1,
        s: 1e3
    };
    return r.Item = o,
    r
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function(t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var n = i.prototype;
    return n._resetLayout = function() {
        this.getSize(),
        this._getMeasurement("columnWidth", "outerWidth"),
        this._getMeasurement("gutter", "outerWidth"),
        this.measureColumns(),
        this.colYs = [];
        for (var t = 0; t < this.cols; t++)
            this.colYs.push(0);
        this.maxY = 0,
        this.horizontalColIndex = 0
    }
    ,
    n.measureColumns = function() {
        if (this.getContainerWidth(),
        !this.columnWidth) {
            var t = this.items[0]
              , i = t && t.element;
            this.columnWidth = i && e(i).outerWidth || this.containerWidth
        }
        var n = this.columnWidth += this.gutter
          , o = this.containerWidth + this.gutter
          , r = o / n
          , s = n - o % n
          , a = s && 1 > s ? "round" : "floor";
        r = Math[a](r),
        this.cols = Math.max(r, 1)
    }
    ,
    n.getContainerWidth = function() {
        var t = this._getOption("fitWidth")
          , i = t ? this.element.parentNode : this.element
          , n = e(i);
        this.containerWidth = n && n.innerWidth
    }
    ,
    n._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth
          , i = e && 1 > e ? "round" : "ceil"
          , n = Math[i](t.size.outerWidth / this.columnWidth);
        n = Math.min(n, this.cols);
        for (var o = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", r = this[o](n, t), s = {
            x: this.columnWidth * r.col,
            y: r.y
        }, a = r.y + t.size.outerHeight, h = n + r.col, u = r.col; h > u; u++)
            this.colYs[u] = a;
        return s
    }
    ,
    n._getTopColPosition = function(t) {
        var e = this._getTopColGroup(t)
          , i = Math.min.apply(Math, e);
        return {
            col: e.indexOf(i),
            y: i
        }
    }
    ,
    n._getTopColGroup = function(t) {
        if (2 > t)
            return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++)
            e[n] = this._getColGroupY(n, t);
        return e
    }
    ,
    n._getColGroupY = function(t, e) {
        if (2 > e)
            return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i)
    }
    ,
    n._getHorizontalColPosition = function(t, e) {
        var i = this.horizontalColIndex % this.cols
          , n = t > 1 && i + t > this.cols;
        i = n ? 0 : i;
        var o = e.size.outerWidth && e.size.outerHeight;
        return this.horizontalColIndex = o ? i + t : this.horizontalColIndex,
        {
            col: i,
            y: this._getColGroupY(i, t)
        }
    }
    ,
    n._manageStamp = function(t) {
        var i = e(t)
          , n = this._getElementOffset(t)
          , o = this._getOption("originLeft")
          , r = o ? n.left : n.right
          , s = r + i.outerWidth
          , a = Math.floor(r / this.columnWidth);
        a = Math.max(0, a);
        var h = Math.floor(s / this.columnWidth);
        h -= s % this.columnWidth ? 0 : 1,
        h = Math.min(this.cols - 1, h);
        for (var u = this._getOption("originTop"), d = (u ? n.top : n.bottom) + i.outerHeight, l = a; h >= l; l++)
            this.colYs[l] = Math.max(d, this.colYs[l])
    }
    ,
    n._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()),
        t
    }
    ,
    n._getContainerFitWidth = function() {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; )
            t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }
    ,
    n.needsResizeLayout = function() {
        var t = this.containerWidth;
        return this.getContainerWidth(),
        t != this.containerWidth
    }
    ,
    i
});
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o) {
    var t = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    o.zoom = function(t, n, e, i) {
        var u, c, a, r, m, l, s, f = o(t), h = f.css("position"), d = o(n);
        return t.style.position = /(absolute|fixed)/.test(h) ? h : "relative",
        t.style.overflow = "hidden",
        e.style.width = e.style.height = "",
        o(e).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: e.width * i,
            height: e.height * i,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(t),
        {
            init: function() {
                c = f.outerWidth(),
                u = f.outerHeight(),
                n === t ? (r = c,
                a = u) : (r = d.outerWidth(),
                a = d.outerHeight()),
                m = (e.width - c) / r,
                l = (e.height - u) / a,
                s = d.offset()
            },
            move: function(o) {
                var t = o.pageX - s.left
                  , n = o.pageY - s.top;
                n = Math.max(Math.min(n, a), 0),
                t = Math.max(Math.min(t, r), 0),
                e.style.left = t * -m + "px",
                e.style.top = n * -l + "px"
            }
        }
    }
    ,
    o.fn.zoom = function(n) {
        return this.each(function() {
            var e = o.extend({}, t, n || {})
              , i = e.target && o(e.target)[0] || this
              , u = this
              , c = o(u)
              , a = document.createElement("img")
              , r = o(a)
              , m = "mousemove.zoom"
              , l = !1
              , s = !1;
            if (!e.url) {
                var f = u.querySelector("img");
                if (f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src),
                !e.url)
                    return
            }
            c.one("zoom.destroy", function(o, t) {
                c.off(".zoom"),
                i.style.position = o,
                i.style.overflow = t,
                a.onload = null,
                r.remove()
            }
            .bind(this, i.style.position, i.style.overflow)),
            a.onload = function() {
                function t(t) {
                    f.init(),
                    f.move(t),
                    r.stop().fadeTo(o.support.opacity ? e.duration : 0, 1, o.isFunction(e.onZoomIn) ? e.onZoomIn.call(a) : !1)
                }
                function n() {
                    r.stop().fadeTo(e.duration, 0, o.isFunction(e.onZoomOut) ? e.onZoomOut.call(a) : !1)
                }
                var f = o.zoom(i, u, a, e.magnify);
                "grab" === e.on ? c.on("mousedown.zoom", function(e) {
                    1 === e.which && (o(document).one("mouseup.zoom", function() {
                        n(),
                        o(document).off(m, f.move)
                    }),
                    t(e),
                    o(document).on(m, f.move),
                    e.preventDefault())
                }) : "click" === e.on ? c.on("click.zoom", function(e) {
                    return l ? void 0 : (l = !0,
                    t(e),
                    o(document).on(m, f.move),
                    o(document).one("click.zoom", function() {
                        n(),
                        l = !1,
                        o(document).off(m, f.move)
                    }),
                    !1)
                }) : "toggle" === e.on ? c.on("click.zoom", function(o) {
                    l ? n() : t(o),
                    l = !l
                }) : "mouseover" === e.on && (f.init(),
                c.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(m, f.move)),
                e.touch && c.on("touchstart.zoom", function(o) {
                    o.preventDefault(),
                    s ? (s = !1,
                    n()) : (s = !0,
                    t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]))
                }).on("touchmove.zoom", function(o) {
                    o.preventDefault(),
                    f.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0])
                }).on("touchend.zoom", function(o) {
                    o.preventDefault(),
                    s && (s = !1,
                    n())
                }),
                o.isFunction(e.callback) && e.callback.call(a)
            }
            ,
            a.setAttribute("role", "presentation"),
            a.alt = "",
            a.src = e.url
        })
    }
    ,
    o.fn.zoom.defaults = t
}
)(window.jQuery);

// Attempts to preserve comments that likely contain licensing information,
// even if the comment does not have directives such as `@license` or `/*!`.
//
// Implemented via the [`uglify-save-license`](https://github.com/shinnn/uglify-save-license)
// module, this option preserves a comment if one of the following is true:
//
// 1. The comment is in the *first* line of a file
// 2. A regular expression matches the string of the comment.
//    For example: `MIT`, `@license`, or `Copyright`.
// 3. There is a comment at the *previous* line, and it matches 1, 2, or 3.
